export const USstates = {
  AL: "Alabama",
  AK: "Alaska",
  AS: "American Samoa",
  AZ: "Arizona",
  AR: "Arkansas",
  CA: "California",
  CO: "Colorado",
  CT: "Connecticut",
  DE: "Delaware",
  DC: "District Of Columbia",
  FM: "Federated States Of Micronesia",
  FL: "Florida",
  GA: "Georgia",
  GU: "Guam",
  HI: "Hawaii",
  ID: "Idaho",
  IL: "Illinois",
  IN: "Indiana",
  IA: "Iowa",
  KS: "Kansas",
  KY: "Kentucky",
  LA: "Louisiana",
  ME: "Maine",
  MH: "Marshall Islands",
  MD: "Maryland",
  MA: "Massachusetts",
  MI: "Michigan",
  MN: "Minnesota",
  MS: "Mississippi",
  MO: "Missouri",
  MT: "Montana",
  NE: "Nebraska",
  NV: "Nevada",
  NH: "New Hampshire",
  NJ: "New Jersey",
  NM: "New Mexico",
  NY: "New York",
  NC: "North Carolina",
  ND: "North Dakota",
  MP: "Northern Mariana Islands",
  OH: "Ohio",
  OK: "Oklahoma",
  OR: "Oregon",
  PW: "Palau",
  PA: "Pennsylvania",
  PR: "Puerto Rico",
  RI: "Rhode Island",
  SC: "South Carolina",
  SD: "South Dakota",
  TN: "Tennessee",
  TX: "Texas",
  UT: "Utah",
  VT: "Vermont",
  VI: "Virgin Islands",
  VA: "Virginia",
  WA: "Washington",
  WV: "West Virginia",
  WI: "Wisconsin",
  WY: "Wyoming",
};

const UScities = {
  AK: [
    "Anchorage",
    "Jber",
    "Fort Richardson",
    "Ft Richardson",
    "Elmendorf AFB",
    "Indian",
    "Bird Creek",
    "Adak",
    "Atka",
    "Chignik Lake",
    "Chignik",
    "Port Heiden",
    "King Salmon",
    "Port Lions",
    "Akiachak",
    "Akiak",
    "Akutan",
    "Alakanuk",
    "Aleknagik",
    "Anchor Point",
    "Nikolaevsk",
    "Aniak",
    "Chuathbaluk",
    "Stony River",
    "Anvik",
    "Bethel",
    "Atmautluak",
    "Napaskiak",
    "Newtok",
    "Chefornak",
    "Chevak",
    "Chignik Lagoon",
    "Chignik Lagn",
    "Chitina",
    "Chugiak",
    "Clam Gulch",
    "Clarks Point",
    "Cold Bay",
    "Nelson Lagoon",
    "Cooper Landing",
    "Cooper Lndg",
    "Copper Center",
    "Cordova",
    "Chenega Bay",
    "Crooked Creek",
    "Dillingham",
    "Koliganek",
    "Twin Hills",
    "Eagle River",
    "Eek",
    "Egegik",
    "Ekwok",
    "Emmonak",
    "False Pass",
    "Marshall",
    "Gakona",
    "Miers Lake",
    "Slana",
    "Girdwood",
    "Glennallen",
    "Goodnews Bay",
    "Grayling",
    "Saint George Island",
    "Saint Paul Island",
    "St George Is",
    "St Paul Isle",
    "Holy Cross",
    "Homer",
    "English Bay",
    "Fritz Creek",
    "Halibut Cove",
    "Kachemak",
    "Nanwalek",
    "Port Graham",
    "Hooper Bay",
    "Hope",
    "Iliamna",
    "Kokhanok",
    "Kalskag",
    "Karluk",
    "Kasigluk",
    "Kasilof",
    "Kenai",
    "Nikiski",
    "King Cove",
    "Igiugig",
    "Kipnuk",
    "Kodiak",
    "Akhiok",
    "Chiniak",
    "Kotlik",
    "Kwethluk",
    "Kwigillingok",
    "Wasilla",
    "Big Lake",
    "Houston",
    "Meadow Lake",
    "Larsen Bay",
    "Levelock",
    "Lower Kalskag",
    "McGrath",
    "Manokotak",
    "Mekoryuk",
    "Moose Pass",
    "Mountain Village",
    "Mountain Vlg",
    "Naknek",
    "Napakiak",
    "New Stuyahok",
    "Toksook Bay",
    "Nikolski",
    "Ninilchik",
    "Nondalton",
    "Nunapitchuk",
    "Old Harbor",
    "Ouzinkie",
    "Palmer",
    "Pedro Bay",
    "Perryville",
    "Pilot Point",
    "Pilot Station",
    "Platinum",
    "Port Alsworth",
    "Quinhagak",
    "Red Devil",
    "Russian Mission",
    "Russian Msn",
    "Saint Marys",
    "Saint Michael",
    "Saint Paul",
    "St Paul",
    "Sand Point",
    "Scammon Bay",
    "Seldovia",
    "Seward",
    "Shageluk",
    "Nunam Iqua",
    "Skwentna",
    "Sleetmute",
    "Soldotna",
    "South Naknek",
    "Stebbins",
    "Sterling",
    "Sutton",
    "Chickaloon",
    "Takotna",
    "Mc Grath",
    "Talkeetna",
    "Tatitlek",
    "Togiak",
    "Tuluksak",
    "Tuntutuliak",
    "Tununak",
    "Tyonek",
    "Trapper Creek",
    "Willow",
    "Unalakleet",
    "Unalaska",
    "Valdez",
    "Yakutat",
    "Nightmute",
    "Nikolai",
    "Dutch Harbor",
    "Whittier",
    "Fairbanks",
    "Eielson Afb",
    "Fort Wainwright",
    "Ft Wainwright",
    "Clear",
    "Nenana",
    "North Pole",
    "Salcha",
    "Allakaket",
    "Anaktuvuk Pass",
    "Anaktuvuk",
    "Arctic Village",
    "Arctic Vlg",
    "Barrow",
    "Beaver",
    "Ester",
    "Bettles Field",
    "Buckland",
    "Cantwell",
    "Central",
    "Chicken",
    "Circle",
    "Prudhoe Bay",
    "Deering",
    "Delta Junction",
    "Delta Jct",
    "Eagle",
    "Elim",
    "Fort Yukon",
    "Galena",
    "Gambell",
    "Healy",
    "Anderson",
    "Hughes",
    "Huslia",
    "Kaktovik",
    "Kaltag",
    "Kiana",
    "Kivalina",
    "Kobuk",
    "Kotzebue",
    "Koyuk",
    "Koyukuk",
    "Denali National Park",
    "Denali Park",
    "Manley Hot Springs",
    "Manley Spgs",
    "Lake Minchumina",
    "Lk Minchumina",
    "Minto",
    "Point Lay",
    "Noatak",
    "Nome",
    "Diomede",
    "Golovin",
    "Little Diomede",
    "Ltl Diomede",
    "Noorvik",
    "Northway",
    "Nulato",
    "Point Hope",
    "Rampart",
    "Ruby",
    "Savoonga",
    "Selawik",
    "Shaktoolik",
    "Shishmaref",
    "Shungnak",
    "Stevens Village",
    "Stevens Vlg",
    "Tanacross",
    "Tok",
    "Tanana",
    "Teller",
    "Mentasta Lake",
    "Venetie",
    "Wainwright",
    "Wales",
    "White Mountain",
    "White Mtn",
    "Brevig Mission",
    "Brevig Msn",
    "Ambler",
    "Chalkyitsik",
    "Nuiqsut",
    "Atqasuk",
    "Juneau",
    "Angoon",
    "Douglas",
    "Elfin Cove",
    "Gustavus",
    "Haines",
    "Hoonah",
    "Kake",
    "Pelican",
    "Petersburg",
    "Kupreanof",
    "Sitka",
    "Port Alexander",
    "Prt Alexander",
    "Skagway",
    "Tenakee Springs",
    "Tenakee Spgs",
    "Ketchikan",
    "Edna Bay",
    "Kasaan",
    "Naukati Bay",
    "Saxman",
    "Meyers Chuck",
    "Coffman Cove",
    "Thorne Bay",
    "Craig",
    "Hydaburg",
    "Hyder",
    "Klawock",
    "Metlakatla",
    "Point Baker",
    "Wrangell",
  ],
  AL: [
    "Moody",
    "Acmar",
    "Adamsville",
    "Adger",
    "Alabaster",
    "Alexander City",
    "Alex City",
    "Allgood",
    "Alpine",
    "Arab",
    "Baileyton",
    "Bessemer",
    "Brighton",
    "Helena",
    "Hoover",
    "Hueytown",
    "Blountsville",
    "Bon Air",
    "Bremen",
    "Brent",
    "Brierfield",
    "Brookside",
    "Cardiff",
    "Calera",
    "Centreville",
    "Chelsea",
    "Childersburg",
    "Coosa Pines",
    "Clanton",
    "Cleveland",
    "Nectar",
    "Columbiana",
    "Cook Springs",
    "Crane Hill",
    "Cropwell",
    "Cullman",
    "Dodge City",
    "Good Hope",
    "Docena",
    "Dolomite",
    "Dora",
    "Empire",
    "Fairfield",
    "Fultondale",
    "Coalburg",
    "Garden City",
    "Gardendale",
    "Goodwater",
    "Graysville",
    "Green Pond",
    "Hanceville",
    "Harpersville",
    "Hayden",
    "Hollins",
    "Sylacauga",
    "Holly Pond",
    "Jemison",
    "Joppa",
    "Kellyton",
    "Kimberly",
    "Leeds",
    "Lincoln",
    "Locust Fork",
    "Logan",
    "McCalla",
    "Lake View",
    "Margaret",
    "Maylene",
    "Montevallo",
    "Morris",
    "Mount Olive",
    "Mulga",
    "Sylvan Spgs",
    "Sylvan Springs",
    "New Castle",
    "Odenville",
    "Branchville",
    "Oneonta",
    "Highland Lake",
    "Rosa",
    "Pelham",
    "Indian Spgs",
    "Indian Springs",
    "Indian Springs Village",
    "Indn Spgs Vlg",
    "Pell City",
    "Pinson",
    "Dixiana",
    "Pleasant Grove",
    "Pleasant Grv",
    "Quinton",
    "W Jefferson",
    "West Jefferson",
    "Ragland",
    "Remlap",
    "Riverside",
    "Rockford",
    "Shelby",
    "Springville",
    "Sterrett",
    "Westover",
    "Sumiton",
    "Sycamore",
    "Oak Grove",
    "Taladga Spgs",
    "Talladega Springs",
    "Talladega",
    "Waldo",
    "Thorsby",
    "Trafford",
    "County Line",
    "Trussville",
    "Union Grove",
    "Cherokee Rdg",
    "Cherokee Ridge",
    "Vandiver",
    "Vincent",
    "Vinemont",
    "S Vinemont",
    "South Vinemont",
    "West Point",
    "Warrior",
    "Watson",
    "Weogufka",
    "West Blocton",
    "Wilsonville",
    "Woodstock",
    "Birmingham",
    "Homewood",
    "Mountain Brk",
    "Irondale",
    "Crestline Heights",
    "Crestline Hts",
    "Forestdale",
    "Center Point",
    "Vestavia",
    "Vestavia Hills",
    "Vestavia Hls",
    "Tarrant",
    "Ensley",
    "Mountain Brook",
    "Bluff Park",
    "Midfield",
    "Meadowbrook",
    "Shoal Creek",
    "Cahaba Heights",
    "Cahaba Hts",
    "Tuscaloosa",
    "Akron",
    "Stewart",
    "Aliceville",
    "Mcmullen",
    "Old Memphis",
    "Boligee",
    "Brookwood",
    "Buhl",
    "Carrollton",
    "Pickensville",
    "Coker",
    "Cottondale",
    "Coaling",
    "Duncanville",
    "Echola",
    "Elrod",
    "Emelle",
    "Epes",
    "Ethelsville",
    "Eutaw",
    "Union",
    "Fosters",
    "Gainesville",
    "Gordo",
    "Knoxville",
    "Livingston",
    "Coatopa",
    "Northport",
    "Moundville",
    "Cypress",
    "Havana",
    "Panola",
    "Ralph",
    "Reform",
    "Vance",
    "West Greene",
    "Jasper",
    "Addison",
    "Arley",
    "Bankston",
    "Bear Creek",
    "Beaverton",
    "Belk",
    "Berry",
    "Brilliant",
    "Carbon Hill",
    "Cordova",
    "Detroit",
    "Double Springs",
    "Double Spgs",
    "Eldridge",
    "Fayette",
    "Glen Allen",
    "Guin",
    "Gu Win",
    "Hackleburg",
    "Haleyville",
    "Hamilton",
    "Hodges",
    "Houston",
    "Kansas",
    "Kennedy",
    "Lynn",
    "Millport",
    "Natural Bridge",
    "Natural Brg",
    "Nauvoo",
    "Oakman",
    "Parrish",
    "Phil Campbell",
    "Red Bay",
    "Sipsey",
    "Spruce Pine",
    "Sulligent",
    "Townley",
    "Vernon",
    "Vina",
    "Winfield",
    "Decatur",
    "Anderson",
    "Athens",
    "Belle Mina",
    "Cherokee",
    "Courtland",
    "N Courtland",
    "North Courtland",
    "Danville",
    "Elkmont",
    "Eva",
    "Falkville",
    "Florence",
    "Saint Florian",
    "Hartselle",
    "Hillsboro",
    "Killen",
    "Leighton",
    "Lester",
    "Lexington",
    "Mooresville",
    "Moulton",
    "Mount Hope",
    "Rogersville",
    "Russellville",
    "Littleville",
    "Sheffield",
    "Muscle Shoals",
    "Somerville",
    "Tanner",
    "Town Creek",
    "Trinity",
    "Tuscumbia",
    "Waterloo",
    "Ardmore",
    "Bridgeport",
    "Brownsboro",
    "Dutton",
    "Estillfork",
    "Fackler",
    "Grant",
    "Gurley",
    "Harvest",
    "Hazel Green",
    "Hollytree",
    "Hollywood",
    "Laceys Spring",
    "Langston",
    "Madison",
    "Triana",
    "Meridianville",
    "New Hope",
    "New Market",
    "Owens Cross Roads",
    "Big Cove",
    "Hampton Cove",
    "Owens X Rds",
    "Paint Rock",
    "Pisgah",
    "Princeton",
    "Scottsboro",
    "Hytop",
    "Section",
    "Stevenson",
    "Toney",
    "Trenton",
    "Valhermoso Springs",
    "Valhermoso Sp",
    "Valhermoso Spg",
    "Vlhrmoso Spgs",
    "Woodville",
    "Huntsville",
    "Gadsden",
    "East Gadsden",
    "Hokes Bluff",
    "Glencoe",
    "Rainbow City",
    "Southside",
    "Albertville",
    "Altoona",
    "Snead",
    "Susan Moore",
    "Ashville",
    "Attalla",
    "Boaz",
    "Sardis City",
    "Bryant",
    "Cedar Bluff",
    "Centre",
    "Collinsville",
    "Crossville",
    "Dawson",
    "Flat Rock",
    "Fort Payne",
    "Pine Ridge",
    "Fyffe",
    "Lakeview",
    "Gallant",
    "Gaylesville",
    "Geraldine",
    "Groveoak",
    "Guntersville",
    "Henagar",
    "Higdon",
    "Horton",
    "Ider",
    "Leesburg",
    "Sand Rock",
    "Sandrock",
    "Mentone",
    "Rainsville",
    "Powell",
    "Shiloh",
    "Steele",
    "Sylvania",
    "Valley Head",
    "Hammondville",
    "Walnut Grove",
    "Autaugaville",
    "Banks",
    "Billingsley",
    "Booth",
    "Brantley",
    "Brundidge",
    "Cecil",
    "Clayton",
    "Clio",
    "Coosada",
    "Deatsville",
    "Eclectic",
    "Elmore",
    "Equality",
    "Eufaula",
    "Bakerhill",
    "Dozier",
    "Fitzpatrick",
    "Forest Home",
    "Fort Davis",
    "Fort Deposit",
    "Georgiana",
    "Glenwood",
    "Goshen",
    "Grady",
    "Greenville",
    "Gantt",
    "Hardaway",
    "Hayneville",
    "Gordonville",
    "White Hall",
    "Highland Home",
    "Honoraville",
    "Hope Hull",
    "Lapine",
    "Letohatchee",
    "Louisville",
    "Luverne",
    "Marbury",
    "Mathews",
    "Midway",
    "Millbrook",
    "Mount Meigs",
    "Pike Road",
    "Prattville",
    "Ramer",
    "Rutledge",
    "Shorter",
    "Tallassee",
    "Troy",
    "Titus",
    "Tuskegee",
    "Tuskegee Institute",
    "Tuskegee Inst",
    "Union Springs",
    "Verbena",
    "Wetumpka",
    "Montgomery",
    "Maxwell AFB",
    "Mafb Gun Annx",
    "Maxwell AFB Gunter Annex",
    "Anniston",
    "Hobson City",
    "Oxford",
    "Fort Mc Clellan",
    "Ft Mcclellan",
    "Alexandria",
    "Ashland",
    "Cragford",
    "Daviston",
    "New Site",
    "Delta",
    "Eastaboga",
    "Fruithurst",
    "Graham",
    "Heflin",
    "Jacksonville",
    "Lineville",
    "Millerville",
    "Munford",
    "Muscadine",
    "Ohatchee",
    "Piedmont",
    "Borden Springs",
    "Brdn Sprngs",
    "Ranburne",
    "Roanoke",
    "Wadley",
    "Weaver",
    "Wedowee",
    "Wellington",
    "Woodland",
    "Newell",
    "Dothan",
    "Rehobeth",
    "Taylor",
    "Kinsey",
    "Abbeville",
    "Ariton",
    "Ashford",
    "Avon",
    "Bellwood",
    "Black",
    "Chancellor",
    "Clopton",
    "Coffee Springs",
    "Coffee Spgs",
    "Columbia",
    "Cottonwood",
    "Cowarts",
    "Daleville",
    "Level Plains",
    "Elba",
    "Enterprise",
    "Geneva",
    "Gordon",
    "Hartford",
    "Headland",
    "Jack",
    "Midland City",
    "New Brockton",
    "Newton",
    "Newville",
    "Ozark",
    "Fort Novosel",
    "Pansey",
    "Pinckard",
    "Shorterville",
    "Skipperville",
    "Slocomb",
    "Webb",
    "Evergreen",
    "Andalusia",
    "Babbie",
    "Carolina",
    "Heath",
    "Sanford",
    "Beatrice",
    "Brewton",
    "East Brewton",
    "Castleberry",
    "Coy",
    "Dickinson",
    "Excel",
    "Flomaton",
    "Florala",
    "Franklin",
    "Frisco City",
    "Fulton",
    "Grove Hill",
    "Allen",
    "Kinston",
    "Lenox",
    "Lockhart",
    "McKenzie",
    "Mckenzie",
    "Monroeville",
    "Opp",
    "Horn Hill",
    "Onycha",
    "Perdue Hill",
    "Peterman",
    "Range",
    "Red Level",
    "Repton",
    "River Falls",
    "Samson",
    "Uriah",
    "Vredenburgh",
    "Whatley",
    "Wing",
    "Atmore",
    "Mc Cullough",
    "Mccullough",
    "Axis",
    "Bay Minette",
    "Bayou La Batre",
    "Bayou Labatre",
    "Bon Secour",
    "Bucks",
    "Calvert",
    "Chatom",
    "Chunchula",
    "Citronelle",
    "Coden",
    "Coffeeville",
    "Creola",
    "Daphne",
    "Spanish Fort",
    "Dauphin Island",
    "Dauphin Isl",
    "Deer Park",
    "Elberta",
    "Perdido Beach",
    "Fairhope",
    "Foley",
    "Frankville",
    "Fruitdale",
    "Gainestown",
    "Grand Bay",
    "Gulf Shores",
    "Huxford",
    "Irvington",
    "Jackson",
    "Salipta",
    "Walker Spgs",
    "Walker Springs",
    "Leroy",
    "Lillian",
    "Little River",
    "Loxley",
    "McIntosh",
    "Magnolia Springs",
    "Magnolia Spgs",
    "Malcolm",
    "Millry",
    "Bigbee",
    "Montrose",
    "Mount Vernon",
    "Orange Beach",
    "Perdido",
    "Point Clear",
    "Robertsdale",
    "Saint Elmo",
    "Saint Stephens",
    "St Stephens",
    "Saraland",
    "Satsuma",
    "Seminole",
    "Semmes",
    "Silverhill",
    "Stapleton",
    "Stockton",
    "Summerdale",
    "Sunflower",
    "Theodore",
    "Saltaire",
    "Tibbie",
    "Vinegar Bend",
    "Wagarville",
    "Wilmer",
    "Mobile",
    "Magazine",
    "Prichard",
    "Chickasaw",
    "Whistler",
    "Eight Mile",
    "Brookley Field",
    "Brookley Fld",
    "Selma",
    "Valley Grande",
    "Alberta",
    "Arlington",
    "Boykin",
    "Camden",
    "Campbell",
    "Catherine",
    "Prairie",
    "Demopolis",
    "Dixons Mills",
    "Faunsdale",
    "Dayton",
    "Forkland",
    "Furman",
    "Gallion",
    "Providence",
    "Greensboro",
    "Linden",
    "Jones",
    "Maplesville",
    "Lower Peach Tree",
    "Low Peach Tre",
    "Lwr Pch Tree",
    "Lowndesboro",
    "Burkville",
    "McWilliams",
    "Magnolia",
    "Marion",
    "Sprott",
    "Plantersville",
    "Marion Junction",
    "Marion Jct",
    "Minter",
    "Myrtlewood",
    "Nanafalia",
    "Newbern",
    "Oak Hill",
    "Orrville",
    "Pine Apple",
    "Snow Hill",
    "Pine Hill",
    "Yellow Bluff",
    "Safford",
    "Sardis",
    "Sawyerville",
    "Sweet Water",
    "Thomaston",
    "Thomasville",
    "Tyler",
    "Benton",
    "Uniontown",
    "Stanton",
    "Randolph",
    "Lawley",
    "Opelika",
    "Auburn",
    "Auburn University",
    "Auburn Univ",
    "Camp Hill",
    "Cottonton",
    "Cusseta",
    "Dadeville",
    "Valley",
    "Five Points",
    "Fort Mitchell",
    "Hatchechubbee",
    "Hurtsboro",
    "Jacksons Gap",
    "Lafayette",
    "Lanett",
    "Loachapoka",
    "Notasulga",
    "Phenix City",
    "Pittsview",
    "Salem",
    "Seale",
    "Smiths Station",
    "Smiths",
    "Smiths Sta",
    "Waverly",
    "Bellamy",
    "Butler",
    "Lavaca",
    "Cuba",
    "Gilbertown",
    "Jachin",
    "Lisman",
    "Melvin",
    "Needham",
    "Pennington",
    "Silas",
    "Bolinger",
    "Toxey",
    "Ward",
    "York",
  ],
  AR: [
    "Pine Bluff",
    "White Hall",
    "Arkansas City",
    "Banks",
    "Crossett",
    "Dermott",
    "Collins",
    "Dumas",
    "Eudora",
    "Fountain Hill",
    "Gould",
    "Grady",
    "Hamburg",
    "Hermitage",
    "Jersey",
    "Kingsland",
    "Lake Village",
    "Jennie",
    "McGehee",
    "Mcgehee",
    "Monticello",
    "Montrose",
    "Moscow",
    "New Edinburg",
    "Parkdale",
    "Pickens",
    "Portland",
    "Rison",
    "Rohwer",
    "Mc Gehee",
    "Star City",
    "Tillar",
    "Warren",
    "Watson",
    "Wilmar",
    "Wilmot",
    "Winchester",
    "Yorktown",
    "Camden",
    "East Camden",
    "Bearden",
    "Beirne",
    "Bluff City",
    "Calion",
    "Carthage",
    "Chidester",
    "Reader",
    "Curtis",
    "El Dorado",
    "Emerson",
    "Fordyce",
    "Gurdon",
    "Hampton",
    "Harrell",
    "Huttig",
    "Ivan",
    "Junction City",
    "Louann",
    "McNeil",
    "Magnolia",
    "Village",
    "Mount Holly",
    "Norphlet",
    "Smackover",
    "Sparkman",
    "Manning",
    "Stephens",
    "Strong",
    "Thornton",
    "Waldo",
    "Whelen Springs",
    "Whelen Spgs",
    "Hope",
    "Alleene",
    "Ashdown",
    "Ben Lomond",
    "Blevins",
    "Bradley",
    "Buckner",
    "Columbus",
    "De Queen",
    "Dierks",
    "Doddridge",
    "Emmet",
    "Foreman",
    "Fouke",
    "Fulton",
    "Garland City",
    "Gillham",
    "Horatio",
    "Lewisville",
    "Lockesburg",
    "McCaskill",
    "Mineral Springs",
    "Mineral Spgs",
    "Nashville",
    "Ogden",
    "Texarkana",
    "Ozan",
    "Prescott",
    "Laneburg",
    "Rosston",
    "Saratoga",
    "Stamps",
    "Taylor",
    "Washington",
    "Willisville",
    "Wilton",
    "Winthrop",
    "Hot Springs National Park",
    "Fountain Lake",
    "Hot Springs",
    "Hot Springs Village",
    "Lake Hamilton",
    "Amity",
    "Alpine",
    "Antoine",
    "Arkadelphia",
    "Caddo Valley",
    "Bismarck",
    "Bonnerdale",
    "Caddo Gap",
    "Cove",
    "Hatton",
    "Delight",
    "Donaldson",
    "Friendship",
    "Glenwood",
    "Grannis",
    "Hatfield",
    "Jessieville",
    "Buckville",
    "Kirby",
    "Langley",
    "Mena",
    "Mountain Pine",
    "Mount Ida",
    "Murfreesboro",
    "Newhope",
    "Norman",
    "Oden",
    "Pine Ridge",
    "Okolona",
    "Pearcy",
    "Pencil Bluff",
    "Royal",
    "Sims",
    "Story",
    "Umpire",
    "Vandervoort",
    "Wickes",
    "Adona",
    "Alexander",
    "Almyra",
    "Altheimer",
    "Amagon",
    "Balch",
    "Augusta",
    "Austin",
    "Bald Knob",
    "Bauxite",
    "Beebe",
    "Bee Branch",
    "Beedeville",
    "Benton",
    "Bryant",
    "Haskell",
    "Tull",
    "Bigelow",
    "Biscoe",
    "Bradford",
    "Brinkley",
    "Cabot",
    "Carlisle",
    "Casa",
    "Casscoe",
    "Center Ridge",
    "Choctaw",
    "Clarendon",
    "Cleveland",
    "Clinton",
    "Conway",
    "Cotton Plant",
    "Crocketts Bluff",
    "Crocketts Blf",
    "Damascus",
    "Twin Groves",
    "Des Arc",
    "De Valls Bluff",
    "De Valls Blf",
    "Devalls Bluff",
    "De Witt",
    "Dewitt",
    "Edgemont",
    "El Paso",
    "England",
    "Enola",
    "Ethel",
    "Fox",
    "Garner",
    "College Station",
    "College Sta",
    "Gillett",
    "Grapevine",
    "Greenbrier",
    "Gregory",
    "Griffithville",
    "Guy",
    "Hattieville",
    "Hazen",
    "Hensley",
    "Hickory Plains",
    "Hickory Plns",
    "Higden",
    "Greers Ferry",
    "Higginson",
    "Holly Grove",
    "Houston",
    "Humnoke",
    "Humphrey",
    "Hunter",
    "Jacksonport",
    "Jacksonville",
    "Gravel Ridge",
    "Little Rock AFB",
    "Lr AFB",
    "Lrafb",
    "Jefferson",
    "Jerusalem",
    "Judsonia",
    "Steprock",
    "Kensett",
    "Keo",
    "Leola",
    "Letona",
    "Lonoke",
    "Lonsdale",
    "Fairfield Bay",
    "Shirley",
    "Little Rock Air Force Base",
    "McCrory",
    "Fair Oaks",
    "Howell",
    "Mccrory",
    "McRae",
    "Mabelvale",
    "Shannon Hills",
    "Malvern",
    "Rockport",
    "Mayflower",
    "Menifee",
    "Monroe",
    "Morrilton",
    "Oppelo",
    "Mount Vernon",
    "Newport",
    "Maumelle",
    "N Little Rock",
    "North Little Rock",
    "Sherwood",
    "Pangburn",
    "Paron",
    "Patterson",
    "Perry",
    "Perryville",
    "Plumerville",
    "Poyen",
    "Prattsville",
    "Prim",
    "Quitman",
    "Redfield",
    "Reydell",
    "Roe",
    "Roland",
    "Romance",
    "Rose Bud",
    "Russell",
    "Saint Charles",
    "Scotland",
    "Scott",
    "Searcy",
    "Georgetown",
    "Sheridan",
    "Sherrill",
    "Solgohachia",
    "Springfield",
    "Stuttgart",
    "Thida",
    "Tichnor",
    "Traskwood",
    "Tucker",
    "Tupelo",
    "Ulm",
    "Vilonia",
    "Holland",
    "Wabbaseka",
    "Ward",
    "West Point",
    "Wilburn",
    "Woodson",
    "Wooster",
    "Wright",
    "Wrightsville",
    "Nlr",
    "No Little Rock",
    "Little Rock",
    "Cammack Village",
    "Cammack Vlg",
    "West Memphis",
    "Aubrey",
    "Bassett",
    "Blytheville",
    "Gosnell",
    "Brickeys",
    "Caldwell",
    "Cherry Valley",
    "Birdeye",
    "Clarkedale",
    "Colt",
    "Crawfordsville",
    "Crawfordsvlle",
    "Crumrod",
    "Driver",
    "Dyess",
    "Earle",
    "Twist",
    "Edmondson",
    "Elaine",
    "Forrest City",
    "Frenchmans Bayou",
    "Frenchman Byu",
    "Gilmore",
    "Goodwin",
    "Haynes",
    "Helena",
    "Heth",
    "Hickory Ridge",
    "Hughes",
    "Horseshoe Lake",
    "Horseshoe Lk",
    "Joiner",
    "Keiser",
    "La Grange",
    "Lambrook",
    "Lepanto",
    "Lexa",
    "Luxora",
    "Madison",
    "Marianna",
    "Marion",
    "Marked Tree",
    "Marvell",
    "Mellwood",
    "Moro",
    "Oneida",
    "Osceola",
    "Palestine",
    "Parkin",
    "Poplar Grove",
    "Proctor",
    "Rivervale",
    "Snow Lake",
    "Turner",
    "Turrell",
    "Tyronza",
    "Vanndale",
    "Wabash",
    "West Helena",
    "West Ridge",
    "Wheatley",
    "Widener",
    "Round Pond",
    "Wilson",
    "Wynne",
    "Jonesboro",
    "Alicia",
    "Bay",
    "Beech Grove",
    "Biggers",
    "Black Oak",
    "Black Rock",
    "Bono",
    "Brookland",
    "Caraway",
    "Cash",
    "Corning",
    "Datto",
    "Delaplaine",
    "Dell",
    "Egypt",
    "Etowah",
    "Fisher",
    "Greenway",
    "Grubbs",
    "Harrisburg",
    "Hoxie",
    "Imboden",
    "Knobel",
    "Peach Orchard",
    "Lafe",
    "Marmaduke",
    "Lake City",
    "Leachville",
    "Lynn",
    "McDougal",
    "Manila",
    "Maynard",
    "Minturn",
    "Monette",
    "O'Kean",
    "Paragould",
    "Piggott",
    "Pocahontas",
    "Pollard",
    "Portia",
    "Powhatan",
    "Ravenden",
    "Ravenden Springs",
    "Ravenden Spgs",
    "Rector",
    "Reyno",
    "Saint Francis",
    "Smithville",
    "State University",
    "State Univ",
    "Strawberry",
    "Calamine",
    "Success",
    "Swifton",
    "Trumann",
    "Tuckerman",
    "Walnut Ridge",
    "Williams Baptist College",
    "Wms College",
    "Warm Springs",
    "Weiner",
    "Williford",
    "Batesville",
    "Southside",
    "Horseshoe Bend",
    "Franklin",
    "Horseshoe Bnd",
    "Ash Flat",
    "Bexar",
    "Brockwell",
    "Calico Rock",
    "Jordan",
    "Camp",
    "Cave City",
    "Charlotte",
    "Concord",
    "Cord",
    "Cushman",
    "Desha",
    "Dolph",
    "Cherokee Village",
    "Cherokee Vlg",
    "Hardy",
    "Drasco",
    "Elizabeth",
    "Evening Shade",
    "Fifty Six",
    "Mountain View",
    "Floral",
    "Gamaliel",
    "Gepp",
    "Glencoe",
    "Guion",
    "Highland",
    "Heber Springs",
    "Henderson",
    "Ida",
    "Locust Grove",
    "Magness",
    "Mammoth Spring",
    "Mammoth Spg",
    "Marcella",
    "Melbourne",
    "Boswell",
    "Zion",
    "Hanover",
    "Mount Pleasant",
    "Mt Pleasant",
    "Newark",
    "Oil Trough",
    "Oxford",
    "Pineville",
    "Pleasant Grove",
    "Pleasant Grv",
    "Pleasant Plains",
    "Pleasant Plns",
    "Poughkeepsie",
    "Rosie",
    "Saffell",
    "Sage",
    "Salem",
    "Moko",
    "Sidney",
    "Sturkie",
    "Sulphur Rock",
    "Tumbling Shoals",
    "Tumbling Shls",
    "Viola",
    "Violet Hill",
    "Wideman",
    "Wiseman",
    "Harrison",
    "Alpena",
    "Bergman",
    "Berryville",
    "Big Flat",
    "Harriet",
    "Bull Shoals",
    "Clarkridge",
    "Compton",
    "Cotter",
    "Deer",
    "Dennard",
    "Diamond City",
    "Eureka Springs",
    "Busch",
    "Eureka Spgs",
    "Holiday Island",
    "Holiday Isle",
    "Everton",
    "Flippin",
    "Gassville",
    "Gilbert",
    "Green Forest",
    "Cozahome",
    "Hasty",
    "Jasper",
    "Lakeview",
    "Lead Hill",
    "Leslie",
    "Marble Falls",
    "Marshall",
    "Midway",
    "Mountain Home",
    "Salesville",
    "Mount Judea",
    "Bass",
    "Norfork",
    "Old Joe",
    "Oak Grove",
    "Oakland",
    "Price Place",
    "Omaha",
    "Onia",
    "Parthenon",
    "Peel",
    "Pindall",
    "Ponca",
    "Pyatt",
    "Saint Joe",
    "Summit",
    "Tilly",
    "Timbo",
    "Alco",
    "Valley Springs",
    "Bruno",
    "Valley Spgs",
    "Vendor",
    "Western Grove",
    "Witts Springs",
    "Yellville",
    "Fayetteville",
    "Tontitown",
    "Wheeler",
    "Bentonville",
    "Bella Vista",
    "Canehill",
    "Cave Springs",
    "Centerton",
    "Combs",
    "Decatur",
    "Elkins",
    "Evansville",
    "Farmington",
    "Garfield",
    "Gentry",
    "Springtown",
    "Gravette",
    "Hindsville",
    "Hiwasse",
    "Huntsville",
    "Kingston",
    "Lincoln",
    "Lowell",
    "Maysville",
    "Morrow",
    "Pea Ridge",
    "Pettigrew",
    "Prairie Grove",
    "Rogers",
    "Little Flock",
    "Saint Paul",
    "Siloam Springs",
    "Siloam Spgs",
    "Springdale",
    "Bethel Heights",
    "Bethel Hts",
    "Sulphur Springs",
    "Sulphur Spgs",
    "Summers",
    "Wesley",
    "West Fork",
    "Witter",
    "Russellville",
    "Altus",
    "Wiederkehr Vg",
    "Wiederkehr Village",
    "Atkins",
    "Appleton",
    "Blackwell",
    "Belleville",
    "Blue Mountain",
    "Bluffton",
    "Briggsville",
    "Centerville",
    "Clarksville",
    "Coal Hill",
    "Danville",
    "Dardanelle",
    "Delaware",
    "Dover",
    "Gravelly",
    "Hagarville",
    "Hartman",
    "Hunt",
    "Harvey",
    "Havana",
    "Waveland",
    "Hector",
    "Knoxville",
    "Lamar",
    "London",
    "New Blaine",
    "Oark",
    "Ola",
    "Ozone",
    "Paris",
    "Pelsor",
    "Plainview",
    "Pottsville",
    "Rover",
    "Scranton",
    "Subiaco",
    "Fort Smith",
    "Fort Chaffee",
    "Bonanza",
    "Alma",
    "Barling",
    "Boles",
    "Booneville",
    "Branch",
    "Cecil",
    "Cedarville",
    "Charleston",
    "Chester",
    "Dyer",
    "Greenwood",
    "Hackett",
    "Hartford",
    "Huntington",
    "Lavaca",
    "Central City",
    "Magazine",
    "Mansfield",
    "Midland",
    "Mountainburg",
    "Mulberry",
    "Natural Dam",
    "Ozark",
    "Parks",
    "Ratcliff",
    "Rudy",
    "Uniontown",
    "Van Buren",
    "Waldron",
    "Bates",
    "Winslow",
  ],
  AS: ["Pago Pago"],
  AZ: [
    "Phoenix",
    "Anthem",
    "Desert Hills",
    "New River",
    "Gold Canyon",
    "Apache Jct",
    "Apache Junction",
    "Queen Valley",
    "Superstition Mountain",
    "Superstition Mtn",
    "Suprstitn Mtn",
    "Tortilla Flat",
    "Bapchule",
    "Casa Grande",
    "Eleven Mile",
    "Eleven Mile Corner",
    "Arizona City",
    "Coolidge",
    "Eloy",
    "Toltec",
    "Florence",
    "Hayden",
    "Kearny",
    "Maricopa",
    "Mobile",
    "San Tan Valley",
    "Queen Creek",
    "San Tan Vly",
    "Picacho",
    "Chandler Heights",
    "Chandler Hts",
    "Red Rock",
    "Sacaton",
    "Stanfield",
    "Superior",
    "Valley Farms",
    "Winkelman",
    "Dudleyville",
    "Mesa",
    "Chandler",
    "Gilbert",
    "Higley",
    "Sun Lakes",
    "Scottsdale",
    "Paradise Valley",
    "Paradise Vly",
    "Rio Verde",
    "Fort Mcdowell",
    "Fountain Hills",
    "Fountain Hls",
    "Tempe",
    "Guadalupe",
    "Glendale",
    "Luke AFB",
    "Luke Air Force Base",
    "Gbafaf",
    "Aguila",
    "Ajo",
    "Arlington",
    "Avondale",
    "Black Canyon City",
    "Black Cyn Cty",
    "Rock Springs",
    "Bouse",
    "Buckeye",
    "Cibola",
    "Cashion",
    "Cave Creek",
    "Congress",
    "Dateland",
    "Ehrenberg",
    "El Mirage",
    "San Luis",
    "Gadsden",
    "Gila Bend",
    "Goodyear",
    "Laveen",
    "Litchfield Park",
    "Litchfield Pk",
    "Lukeville",
    "Morristown",
    "Palo Verde",
    "Parker",
    "Peoria",
    "Quartzsite",
    "Roll",
    "Salome",
    "Somerton",
    "Sun City",
    "Tacna",
    "Tolleson",
    "Tonopah",
    "Waddell",
    "Wellton",
    "Wenden",
    "Wikieup",
    "Wittmann",
    "Yarnell",
    "Youngtown",
    "Yuma",
    "Martinez Lake",
    "Ypg",
    "Yuma Proving Ground",
    "Poston",
    "Surprise",
    "Sun City West",
    "Carefree",
    "Wickenburg",
    "Globe",
    "Bylas",
    "Central",
    "Claypool",
    "Clifton",
    "Duncan",
    "Eden",
    "Fort Thomas",
    "Miami",
    "Morenci",
    "Payson",
    "Star Valley",
    "Peridot",
    "Pima",
    "Pine",
    "Strawberry",
    "Roosevelt",
    "Safford",
    "San Carlos",
    "Solomon",
    "Thatcher",
    "Tonto Basin",
    "Young",
    "Arivaca",
    "Benson",
    "Mescal",
    "Redington",
    "Bisbee",
    "Bowie",
    "Cochise",
    "Douglas",
    "Dragoon",
    "Elfrida",
    "Elgin",
    "Fort Huachuca",
    "Sierra Vista",
    "Green Valley",
    "Madera Canyon",
    "Hereford",
    "Huachuca City",
    "McNeal",
    "Mammoth",
    "Mount Lemmon",
    "Naco",
    "Nogales",
    "Oracle",
    "Patagonia",
    "Pearce",
    "Sunsites",
    "Pirtleville",
    "Pomerene",
    "Sahuarita",
    "Saint David",
    "San Manuel",
    "San Simon",
    "Portal",
    "Sasabe",
    "Sells",
    "Pisinemo",
    "Sonoita",
    "Tombstone",
    "Topawa",
    "Tumacacori",
    "Vail",
    "Corona",
    "Corona De Tuc",
    "Corona De Tucson",
    "Santa Rita",
    "Santa Rita Foothills",
    "Willcox",
    "Ft Grant",
    "Amado",
    "Tubac",
    "Rio Rico",
    "Marana",
    "Rillito",
    "Tucson",
    "Oro Valley",
    "Davis Monthan AFB",
    "Dm AFB",
    "South Tucson",
    "Catalina",
    "Saddlebrooke",
    "Show Low",
    "Cibecue",
    "White Mountain Lake",
    "White Mtn Lk",
    "Alpine",
    "Blue",
    "Clay Springs",
    "Concho",
    "Eagar",
    "Fort Apache",
    "Greer",
    "Heber",
    "Lakeside",
    "Mcnary",
    "Forest Lakes",
    "Nutrioso",
    "Overgaard",
    "Pinedale",
    "Pinetop",
    "Pinetop Lake",
    "Pinetop Lakeside",
    "Saint Johns",
    "Snowflake",
    "Springerville",
    "Taylor",
    "Vernon",
    "Whiteriver",
    "Woodruff",
    "Flagstaff",
    "Bellemont",
    "Gray Mountain",
    "Cameron",
    "Munds Park",
    "Parks",
    "Parks Comm Po",
    "Colorado City",
    "Fredonia",
    "Cane Beds",
    "Grand Canyon",
    "Happy Jack",
    "Holbrook",
    "Petrified Forest Natl Pk",
    "Petrified For",
    "Sun Valley",
    "Hotevilla",
    "Indian Wells",
    "Joseph City",
    "Kayenta",
    "Keams Canyon",
    "Leupp",
    "Marble Canyon",
    "Mormon Lake",
    "Kykotsmovi Village",
    "Kykotsmovi",
    "Page",
    "Greenehaven",
    "Polacca",
    "Second Mesa",
    "Tonalea",
    "Tuba City",
    "Williams",
    "Winslow",
    "North Rim",
    "Kaibeto",
    "Shonto",
    "Prescott",
    "Groom Creek",
    "Iron Springs",
    "Prescott Valley",
    "Prescott Vly",
    "Ash Fork",
    "Bagdad",
    "Camp Verde",
    "Chino Valley",
    "Clarkdale",
    "Cornville",
    "Cottonwood",
    "Dewey",
    "Dewey Humblt",
    "Dewey Humboldt",
    "Humboldt",
    "Jerome",
    "Kirkland",
    "Peeples Valley",
    "Peeples Vly",
    "Mayer",
    "Bensch Ranch",
    "Cordes Lakes",
    "Spring Valley",
    "Paulden",
    "Rimrock",
    "Sedona",
    "Seligman",
    "Skull Valley",
    "Crown King",
    "Kingman",
    "Lake Havasu City",
    "Lk Havasu Cty",
    "Hualapai",
    "Hackberry",
    "Golden Valley",
    "Fort Mohave",
    "Bullhead City",
    "Chloride",
    "Littlefield",
    "Beaver Dam",
    "Scenic",
    "Oatman",
    "Peach Springs",
    "Supai",
    "Topock",
    "Valentine",
    "Yucca",
    "Mohave Valley",
    "Dolan Springs",
    "Temple Bar Marina",
    "Templ Bar Mar",
    "Meadview",
    "Willow Beach",
    "White Hills",
    "Chambers",
    "Chinle",
    "Fort Defiance",
    "Ganado",
    "Houck",
    "Lukachukai",
    "Lupton",
    "Pinon",
    "Saint Michaels",
    "St Michaels",
    "Sanders",
    "Teec Nos Pos",
    "Window Rock",
    "Blue Gap",
    "Dennehotso",
    "Many Farms",
    "Nazlini",
    "Red Valley",
    "Rock Point",
    "Round Rock",
    "Tsaile",
  ],
  CA: [
    "Los Angeles",
    "Firestone Park",
    "Firestone Pk",
    "Watts",
    "Oakwood",
    "Sanford",
    "Dockweiler",
    "Baldwin Hills",
    "Leimert Park",
    "View Park",
    "Commerce",
    "E Los Angeles",
    "East Los Angeles",
    "W Los Angeles",
    "West Los Angeles",
    "Hollywood",
    "Lincoln Heights",
    "Lincoln Hts",
    "W Hollywood",
    "West Hollywood",
    "Cty Of Cmmrce",
    "Eagle Rock",
    "Highland Park",
    "Windsor Hills",
    "Westchester",
    "Vernon",
    "Hazard",
    "Rancho Park",
    "Glassell",
    "Glassell Park",
    "Century City",
    "Veterans Adm",
    "Veterans Admin",
    "Veterans Administration",
    "Veterans Admn",
    "Playa Vista",
    "Bell Gardens",
    "Bell",
    "Cudahy",
    "Beverly Hills",
    "Compton",
    "Crystal City",
    "Rancho Dominguez",
    "Rncho Domingz",
    "E Rncho Dmngz",
    "East Rancho Dominguez",
    "Rosewood",
    "Culver City",
    "Downey",
    "El Segundo",
    "Gardena",
    "Hawthorne",
    "Holly Park",
    "Hollyglen",
    "Hermosa Beach",
    "Huntington Park",
    "Huntington Pk",
    "Walnut Park",
    "Lawndale",
    "Lynwood",
    "Malibu",
    "Manhattan Beach",
    "Manhattan Bch",
    "Maywood",
    "Pacific Palisades",
    "Pacific Plsds",
    "Palos Verdes Peninsula",
    "Palos Verdes Estates",
    "Pls Vrds Est",
    "Pls Vrds Pnsl",
    "Rllng Hls Est",
    "Rolling Hills",
    "Rolling Hills Estates",
    "Rancho Palos Verdes",
    "Rch Palos Vrd",
    "Redondo Beach",
    "South Gate",
    "Topanga",
    "Venice",
    "Playa Del Rey",
    "Marina Del Rey",
    "Marina Dl Rey",
    "Inglewood",
    "Santa Monica",
    "Torrance",
    "Whittier",
    "City Industry",
    "City Of Industry",
    "Pico Rivera",
    "Los Nietos",
    "Buena Park",
    "La Palma",
    "Cypress",
    "La Habra",
    "La Habra Heights",
    "La Habra Hgts",
    "La Mirada",
    "Lamirada",
    "Mirada",
    "Montebello",
    "Norwalk",
    "Santa Fe Springs",
    "Santa Fe Spgs",
    "Stanton",
    "Artesia",
    "Cerritos",
    "Avalon",
    "Bellflower",
    "Harbor City",
    "Lakewood",
    "Hawaiian Gardens",
    "Hawaiian Gdns",
    "Lomita",
    "Los Alamitos",
    "Rossmoor",
    "Paramount",
    "San Pedro",
    "Seal Beach",
    "Sunset Beach",
    "Surfside",
    "Wilmington",
    "Carson",
    "Long Beach",
    "Signal Hill",
    "Altadena",
    "Arcadia",
    "Duarte",
    "Bradbury",
    "La Canada Flintridge",
    "Flintridge",
    "La Canada",
    "La Canada Flt",
    "Pasadena",
    "Monrovia",
    "Montrose",
    "Sierra Madre",
    "South Pasadena",
    "S Pasadena",
    "Sunland",
    "Shadow Hills",
    "Tujunga",
    "Verdugo City",
    "San Marino",
    "Glendale",
    "La Crescenta",
    "Agoura Hills",
    "Agoura",
    "Calabasas",
    "Calabasas Hills",
    "Calabasas Hls",
    "Cornell",
    "Malibu Lake",
    "Oak Park",
    "Saratoga Hills",
    "Saratoga Hls",
    "Hidden Hills",
    "Monte Nido",
    "Woodland Hills",
    "Woodland Hls",
    "Canoga Park",
    "Box Canyon",
    "West Hills",
    "Winnetka",
    "Bell Canyon",
    "Chatsworth",
    "Encino",
    "Van Nuys",
    "Newbury Park",
    "Thousand Oaks",
    "Newhall",
    "Santa Clarita",
    "Northridge",
    "Sherwood Forest",
    "Sherwood Frst",
    "Porter Ranch",
    "Pacoima",
    "Arleta",
    "Hansen Hills",
    "Reseda",
    "Tarzana",
    "San Fernando",
    "Sylmar",
    "Kagel Canyon",
    "Lake View Ter",
    "Lake View Terrace",
    "Rancho Cascades",
    "Rnch Cascades",
    "North Hills",
    "Sepulveda",
    "Granada Hills",
    "Mission Hills",
    "Agua Dulce",
    "Saugus",
    "Canyon Country",
    "Canyon Cntry",
    "Sun Valley",
    "Valencia",
    "Westlake Village",
    "Hidden Valley",
    "Lake Sherwood",
    "Westlake Vlg",
    "Stevenson Ranch",
    "Stevenson Rnh",
    "Castaic",
    "Val Verde",
    "Green Valley",
    "Sherman Oaks",
    "Valley Glen",
    "Panorama City",
    "Lake Balboa",
    "Burbank",
    "North Hollywood",
    "N Hollywood",
    "Toluca Ter",
    "Toluca Terrace",
    "Valley Village",
    "Valley Vlg",
    "Studio City",
    "Toluca Lake",
    "W Toluca Lake",
    "West Toluca Lake",
    "Sherman Village",
    "Sherman Vlg",
    "Universal City",
    "Universal Cty",
    "Rancho Cucamonga",
    "Alta Loma",
    "Rch Cucamonga",
    "Azusa",
    "Irwindale",
    "Baldwin Park",
    "Chino",
    "Chino Hills",
    "Montclair",
    "Ontario",
    "Claremont",
    "Covina",
    "El Monte",
    "South El Monte",
    "S El Monte",
    "Etiwanda",
    "Glendora",
    "La Puente",
    "Hacienda Heights",
    "Hacienda Hts",
    "Bassett",
    "Rowland Heights",
    "Rowland Hghts",
    "Rowland Hgts",
    "La Verne",
    "Mira Loma",
    "Eastvale",
    "Jurupa Valley",
    "Monterey Park",
    "Mt Baldy",
    "Diamond Bar",
    "Pomona",
    "Phillips Ranch",
    "Phillips Rnch",
    "Rosemead",
    "San Dimas",
    "San Gabriel",
    "Temple City",
    "Upland",
    "Walnut",
    "West Covina",
    "Alhambra",
    "Alpine",
    "Bonita",
    "Boulevard",
    "Campo",
    "Chula Vista",
    "Descanso",
    "Dulzura",
    "Guatay",
    "Imperial Beach",
    "Imperial Bch",
    "Jacumba",
    "Jamul",
    "La Mesa",
    "Lemon Grove",
    "Mount Laguna",
    "National City",
    "Lincoln Acres",
    "Pine Valley",
    "Potrero",
    "Spring Valley",
    "Tecate",
    "Bonsall",
    "Borrego Springs",
    "Borrego Spgs",
    "Cardiff By The Sea",
    "Cardiff",
    "Carlsbad",
    "La Costa",
    "Del Mar",
    "El Cajon",
    "Encinitas",
    "Escondido",
    "Fallbrook",
    "Elfin Forest",
    "Julian",
    "La Jolla",
    "Lakeside",
    "Oceanside",
    "Camp Pendleton",
    "Cmp Pendleton",
    "Pala",
    "Palomar Mountain",
    "Palomar Mtn",
    "Pauma Valley",
    "Poway",
    "Ramona",
    "Ranchita",
    "Warner Spgs",
    "Warner Springs",
    "Rancho Santa Fe",
    "Rcho Santa Fe",
    "San Marcos",
    "Santa Ysabel",
    "Santee",
    "Solana Beach",
    "Vista",
    "Valley Center",
    "San Diego",
    "Coronado",
    "Nas N Island",
    "Nas North Island",
    "San Ysidro",
    "Indio",
    "Chiriaco Smt",
    "Chiriaco Summit",
    "Bermuda Dunes",
    "Indian Wells",
    "Palm Desert",
    "Banning",
    "Bard",
    "Beaumont",
    "Cherry Valley",
    "Blythe",
    "Ripley",
    "Brawley",
    "Cabazon",
    "Calexico",
    "Calipatria",
    "Cathedral City",
    "Cathedral Cty",
    "Coachella",
    "Desert Center",
    "Eagle Mountain",
    "Eagle Mtn",
    "Desert Hot Springs",
    "Dsrt Hot Spgs",
    "Earp",
    "Big River",
    "El Centro",
    "Heber",
    "Holtville",
    "Imperial",
    "Joshua Tree",
    "La Quinta",
    "Mecca",
    "Morongo Valley",
    "Morongo Vly",
    "Niland",
    "North Palm Springs",
    "N Palm Spgs",
    "N Palm Springs",
    "No Palm Springs",
    "Ocotillo",
    "Palm Springs",
    "Palo Verde",
    "Parker Dam",
    "Pioneertown",
    "Rancho Mirage",
    "Seeley",
    "Thermal",
    "Salton City",
    "Thousand Palms",
    "Thousand Plms",
    "Twentynine Palms",
    "29 Palms",
    "Twentynin Plm",
    "Twentynine Palms Mcb",
    "Vidal",
    "Westmorland",
    "Whitewater",
    "Winterhaven",
    "Felicity",
    "Yucca Valley",
    "Landers",
    "Johnson Valley",
    "Johnson Vly",
    "Adelanto",
    "El Mirage",
    "Amboy",
    "Cadiz",
    "Angelus Oaks",
    "Apple Valley",
    "Jess Ranch",
    "Baker",
    "Kelso",
    "Fort Irwin",
    "Barstow",
    "Grand Terrace",
    "Big Bear City",
    "Big Bear Lake",
    "Bloomington",
    "Blue Jay",
    "Calimesa",
    "Cedar Glen",
    "Cedarpines Park",
    "Cedarpines Pk",
    "Colton",
    "Crestline",
    "Daggett",
    "Death Valley",
    "Essex",
    "Fawnskin",
    "Fontana",
    "Ludlow",
    "Newberry Spgs",
    "Newberry Springs",
    "Forest Falls",
    "Green Valley Lake",
    "Green Vly Lk",
    "Helendale",
    "Hesperia",
    "Oak Hills",
    "Highland",
    "Hinkley",
    "Loma Linda",
    "Lake Arrowhead",
    "Lk Arrowhead",
    "Lucerne Valley",
    "Lucerne Vly",
    "Lytle Creek",
    "Mentone",
    "Needles",
    "Havasu Lake",
    "Nipton",
    "Oro Grande",
    "Patton",
    "Phelan",
    "Pinon Hills",
    "Redlands",
    "Rialto",
    "Rimforest",
    "Running Springs",
    "Arrowbear Lake",
    "Arrowbear Lk",
    "Running Spgs",
    "Shoshone",
    "Skyforest",
    "Sugarloaf",
    "Tecopa",
    "Twin Peaks",
    "Victorville",
    "George AFB",
    "Spg Valley Lk",
    "Spring Valley Lake",
    "Wrightwood",
    "Yermo",
    "Yucaipa",
    "Oak Glen",
    "San Bernardino",
    "Sn Bernrdno",
    "Arrowhead Farms",
    "Arrowhed Farm",
    "Devore Heights",
    "Devore Hghts",
    "Muscoy",
    "Verdemont",
    "Riverside",
    "March Air Reserve Base",
    "March Arb",
    "Lake Elsinore",
    "Aguanga",
    "Anza",
    "Hemet",
    "Sage",
    "Homeland",
    "Idyllwild",
    "Moreno Valley",
    "Rancho Belago",
    "Mountain Center",
    "Mountain Ctr",
    "Murrieta",
    "Nuevo",
    "Lakeview",
    "Perris",
    "Lake Mathews",
    "San Jacinto",
    "Gilman Hot Springs",
    "Glmn Hot Spgs",
    "Menifee",
    "Quail Valley",
    "Romoland",
    "Sun City",
    "Canyon Lake",
    "Temecula",
    "Wildomar",
    "Winchester",
    "Irvine",
    "Foothill Ranch",
    "El Toro",
    "Foothill Rnch",
    "Lake Forest",
    "Capistrano Beach",
    "Capo Beach",
    "Dana Point",
    "Corona Del Mar",
    "Corona Dl Mar",
    "Costa Mesa",
    "Monarch Bay",
    "Monarch Beach",
    "Laguna Woods",
    "Laguna Hills",
    "Huntington Beach",
    "Huntingtn Bch",
    "Laguna Beach",
    "Aliso Viejo",
    "Midway City",
    "Newport Coast",
    "Newport Beach",
    "Balboa",
    "Balboa Island",
    "San Clemente",
    "San Juan Capistrano",
    "Mission Viejo",
    "San Juan Capo",
    "Silverado",
    "Laguna Niguel",
    "Trabuco Canyon",
    "Trabuco Cyn",
    "Coto De Caza",
    "Dove Canyon",
    "Portola Hills",
    "Robinson Ranch",
    "Robinson Rnch",
    "Trabuco",
    "Westminster",
    "Rancho Santa Margarita",
    "Rancho Sta Marg",
    "Rcho Sta Marg",
    "Rsm",
    "Ladera Ranch",
    "Ran Msn Viejo",
    "Rancho Mission Viejo",
    "Rmv",
    "Santa Ana",
    "Cowan Heights",
    "North Tustin",
    "Fountain Valley",
    "Fountain Vly",
    "Tustin",
    "Anaheim",
    "Brea",
    "Fullerton",
    "Garden Grove",
    "Norco",
    "Villa Park",
    "Orange",
    "Placentia",
    "Corona",
    "Temescal Valley",
    "Temescal Vly",
    "Yorba Linda",
    "Ventura",
    "Camarillo",
    "Santa Rosa Va",
    "Santa Rosa Valley",
    "Carpinteria",
    "Fillmore",
    "Moorpark",
    "Oak View",
    "Ojai",
    "Oxnard",
    "Piru",
    "Port Hueneme",
    "Point Mugu Nawc",
    "Pt Mugu Nawc",
    "Port Hueneme Cbc Base",
    "Prt Hueneme",
    "Santa Paula",
    "Simi Valley",
    "Santa Susana",
    "Brandeis",
    "Somis",
    "Summerland",
    "Santa Barbara",
    "Montecito",
    "Goleta",
    "Gaviota",
    "Isla Vista",
    "Alpaugh",
    "Armona",
    "Arvin",
    "Di Giorgio",
    "Tejon Ranch",
    "Avenal",
    "Bodfish",
    "Buttonwillow",
    "California Hot Springs",
    "Calif Hot Spg",
    "Camp Nelson",
    "Springville",
    "Coalinga",
    "Corcoran",
    "Delano",
    "Ducor",
    "Earlimart",
    "Edison",
    "Exeter",
    "Pine Mountain Club",
    "Frazier Park",
    "Pine Mtn Clb",
    "Farmersville",
    "Fellows",
    "Glennville",
    "Goshen",
    "Hanford",
    "Huron",
    "Ivanhoe",
    "Kaweah",
    "Kernville",
    "Kettleman City",
    "Kettleman Cty",
    "Lake Isabella",
    "Mountain Mesa",
    "Lamont",
    "Laton",
    "Lebec",
    "Gorman",
    "Lemon Cove",
    "Lemoore",
    "Lemoore Nas",
    "Lemoore Naval Air Station",
    "Lindsay",
    "Lost Hills",
    "McFarland",
    "McKittrick",
    "Maricopa",
    "New Cuyama",
    "Cuyama",
    "Onyx",
    "Pixley",
    "Porterville",
    "Poplar",
    "Woodville",
    "Posey",
    "Richgrove",
    "Sequoia National Park",
    "Seq Natl Pk",
    "Shafter",
    "Stratford",
    "Strathmore",
    "Taft",
    "Terra Bella",
    "Three Rivers",
    "Tipton",
    "Tulare",
    "Tupman",
    "Visalia",
    "Wasco",
    "Weldon",
    "Wofford Heights",
    "Wofford Hts",
    "Woodlake",
    "Woody",
    "Bakersfield",
    "Pumpkin Center",
    "Pumpkin Ctr",
    "San Luis Obispo",
    "Sn Luis Obisp",
    "Los Osos",
    "Arroyo Grande",
    "Atascadero",
    "Avila Beach",
    "Bradley",
    "Buellton",
    "Cambria",
    "Casmalia",
    "Cayucos",
    "Creston",
    "Grover Beach",
    "Guadalupe",
    "Lompoc",
    "Vandenberg AFB",
    "Vandenbrg AFB",
    "Los Alamos",
    "Los Olivos",
    "Morro Bay",
    "Nipomo",
    "Oceano",
    "Paso Robles",
    "Adelaide",
    "Heritage Ranch",
    "Heritage Rnch",
    "Pismo Beach",
    "Shell Beach",
    "San Ardo",
    "San Miguel",
    "Parkfield",
    "San Simeon",
    "Ragged Point",
    "Santa Margarita",
    "Santa Margar",
    "Santa Maria",
    "Rancho Suey",
    "Orcutt",
    "Santa Ynez",
    "Shandon",
    "Solvang",
    "Ballard",
    "Templeton",
    "Mojave",
    "Tehachapi",
    "California City",
    "Calif City",
    "Acton",
    "Benton",
    "Bishop",
    "Big Pine",
    "Chalfant",
    "Chalfant Valley",
    "Chalfant Vly",
    "Hammil Valley",
    "Swall Meadows",
    "Boron",
    "Bridgeport",
    "Caliente",
    "Havilah",
    "Cantil",
    "Darwin",
    "Edwards",
    "Aerial Acres",
    "North Edwards",
    "Edwards AFB",
    "Independence",
    "Inyokern",
    "Pearsonville",
    "Johannesburg",
    "June Lake",
    "Keeler",
    "Keene",
    "Lake Hughes",
    "Elizabeth Lake",
    "Elizabeth Lk",
    "Lancaster",
    "Hi Vista",
    "Lake La",
    "Lake Los Angeles",
    "Del Sur",
    "Quartz Hill",
    "Lee Vining",
    "Littlerock",
    "Juniper Hills",
    "Sun Village",
    "Llano",
    "Crystalaire",
    "Lone Pine",
    "Mammoth Lakes",
    "Crowley Lake",
    "Toms Place",
    "Olancha",
    "Cartago",
    "Palmdale",
    "City Ranch",
    "Leona Valley",
    "Pearblossom",
    "Randsburg",
    "Ridgecrest",
    "Red Mountain",
    "Rosamond",
    "Willow Spgs",
    "Willow Springs",
    "Bear Valley Springs",
    "Bear Vly Spgs",
    "Golden Hills",
    "Monolith",
    "Stallion Spgs",
    "Stallion Springs",
    "Trona",
    "Argus",
    "Valyermo",
    "Ahwahnee",
    "Auberry",
    "Badger",
    "Miramonte",
    "Bass Lake",
    "Big Creek",
    "Biola",
    "Cantua Creek",
    "Caruthers",
    "Chowchilla",
    "Clovis",
    "Coarsegold",
    "Cutler",
    "Del Rey",
    "Dinuba",
    "Dos Palos",
    "Dunlap",
    "Firebaugh",
    "Fish Camp",
    "Five Points",
    "Fowler",
    "Friant",
    "Helm",
    "Hume",
    "Kerman",
    "Kingsburg",
    "Kings Canyon National Pk",
    "Kcnp",
    "Kings Canyon",
    "Lakeshore",
    "Shaver Lake",
    "Los Banos",
    "Madera",
    "Berenda",
    "Mendota",
    "North Fork",
    "Oakhurst",
    "O'Neals",
    "Orange Cove",
    "Squaw Valley",
    "Orosi",
    "Parlier",
    "Fresno",
    "Pinedale",
    "Prather",
    "Raisin City",
    "Raymond",
    "Reedley",
    "Riverdale",
    "Sanger",
    "San Joaquin",
    "Selma",
    "South Dos Palos",
    "S Dos Palos",
    "Sultana",
    "Tollhouse",
    "Tranquillity",
    "Wishon",
    "Yettem",
    "Traver",
    "Salinas",
    "Prunedale",
    "Corral De Tie",
    "Corral De Tierra",
    "Big Sur",
    "Carmel By The Sea",
    "Carmel",
    "Carmel By The",
    "Carmel Valley",
    "Chualar",
    "Gonzales",
    "Greenfield",
    "Jolon",
    "Fort Hunter Liggett",
    "Ft H Liggett",
    "King City",
    "Lockwood",
    "Marina",
    "East Garrison",
    "Monterey",
    "Del Rey Oaks",
    "Presidio Mtry",
    "Presidio Of Monterey",
    "Pacific Grove",
    "Pebble Beach",
    "San Lucas",
    "Seaside",
    "Sand City",
    "Soledad",
    "Spreckels",
    "Belmont",
    "Brisbane",
    "Burlingame",
    "Hillsborough",
    "Daly City",
    "Colma",
    "Broadmoor Vlg",
    "El Granada",
    "Half Moon Bay",
    "La Honda",
    "Loma Mar",
    "Los Altos",
    "Los Altos Hills",
    "Los Altos Hls",
    "Menlo Park",
    "W Menlo Park",
    "West Menlo Park",
    "Atherton",
    "Portola Valley",
    "Portola Vally",
    "Millbrae",
    "Montara",
    "Moss Beach",
    "Mountain View",
    "Pacifica",
    "Pescadero",
    "Redwood City",
    "Woodside",
    "Emerald Hills",
    "Palomar Park",
    "San Bruno",
    "San Carlos",
    "San Gregorio",
    "South San Francisco",
    "S San Fran",
    "Sunnyvale",
    "San Francisco",
    "Palo Alto",
    "E Palo Alto",
    "East Palo Alto",
    "Stanford",
    "San Mateo",
    "Foster City",
    "Alameda",
    "American Canyon",
    "American Cyn",
    "Vallejo",
    "Discovery Bay",
    "Byron",
    "Danville",
    "Blackhawk",
    "Alamo",
    "Angwin",
    "Antioch",
    "Benicia",
    "Bethel Island",
    "Birds Landing",
    "Brentwood",
    "Calistoga",
    "Canyon",
    "Clayton",
    "Concord",
    "Pleasant Hill",
    "Crockett",
    "Diablo",
    "El Cerrito",
    "Fairfield",
    "Suisun City",
    "Travis Afb",
    "Fremont",
    "Hayward",
    "Castro Valley",
    "Hercules",
    "Rodeo",
    "Knightsen",
    "Lafayette",
    "Livermore",
    "Martinez",
    "Briones",
    "Pacheco",
    "Moraga",
    "Napa",
    "Spanish Flat",
    "Newark",
    "Oakley",
    "Oakville",
    "Orinda",
    "Pinole",
    "Pittsburg",
    "Bay Point",
    "Pleasanton",
    "Pope Valley",
    "Dublin",
    "Port Costa",
    "Rio Vista",
    "Rutherford",
    "Saint Helena",
    "Deer Park",
    "San Leandro",
    "San Lorenzo",
    "San Ramon",
    "Birds Lndg",
    "Sunol",
    "Union City",
    "Walnut Creek",
    "Yountville",
    "Oakland",
    "Piedmont",
    "Emeryville",
    "Berkeley",
    "Albany",
    "Kensington",
    "Richmond",
    "N Richmond",
    "North Richmond",
    "Point Richmond",
    "Pt Richmond",
    "El Sobrante",
    "San Pablo",
    "Hilltop Mall",
    "San Rafael",
    "San Anselmo",
    "Greenbrae",
    "Kentfield",
    "Belvedere Tiburon",
    "Bel Tiburon",
    "Belvedere",
    "Tiburon",
    "Bodega",
    "Bodega Bay",
    "Bolinas",
    "Corte Madera",
    "Rohnert Park",
    "Cotati",
    "Dillon Beach",
    "Fairfax",
    "Forest Knolls",
    "Inverness",
    "Lagunitas",
    "Larkspur",
    "Marshall",
    "Mill Valley",
    "Novato",
    "Nicasio",
    "Olema",
    "Penngrove",
    "Petaluma",
    "Point Reyes Station",
    "Pt Reyes Sta",
    "Ross",
    "San Geronimo",
    "San Quentin",
    "Sausalito",
    "Muir Beach",
    "Stinson Beach",
    "Tomales",
    "Valley Ford",
    "Woodacre",
    "Alviso",
    "San Jose",
    "Aptos",
    "Aromas",
    "Ben Lomond",
    "Boulder Creek",
    "Brookdale",
    "Campbell",
    "Capitola",
    "Castroville",
    "Coyote",
    "Cupertino",
    "Monte Vista",
    "Permanente",
    "Davenport",
    "Felton",
    "Freedom",
    "Gilroy",
    "Hollister",
    "Los Gatos",
    "Monte Sereno",
    "Milpitas",
    "Morgan Hill",
    "Moss Landing",
    "Mount Hermon",
    "Paicines",
    "San Juan Bautista",
    "Sn Jun Batsta",
    "San Martin",
    "Santa Clara",
    "Santa Cruz",
    "Bonny Doon",
    "Scotts Valley",
    "Saratoga",
    "Soquel",
    "Tres Pinos",
    "Watsonville",
    "Corralitos",
    "La Selva Bch",
    "La Selva Beach",
    "Mt Madonna",
    "Pajaro",
    "Royal Oaks",
    "Mount Hamilton",
    "Mt Hamilton",
    "Stockton",
    "Morada",
    "Acampo",
    "Altaville",
    "Angels Camp",
    "Arnold",
    "Bear Valley",
    "Camp Connell",
    "Avery",
    "Burson",
    "Campo Seco",
    "Valley Spgs",
    "Valley Springs",
    "Clements",
    "Copperopolis",
    "Farmington",
    "French Camp",
    "Glencoe",
    "Hathaway Pines",
    "Hathaway Pnes",
    "Linden",
    "Lockeford",
    "Lodi",
    "Mokelumne Hill",
    "Mokelumne Hl",
    "Mountain Ranch",
    "Mtn Ranch",
    "Sheep Ranch",
    "Murphys",
    "Rail Road Flat",
    "Rail Rd Flat",
    "San Andreas",
    "Vallecito",
    "Victor",
    "Wallace",
    "West Point",
    "Wilseyville",
    "Woodbridge",
    "Atwater",
    "Ballico",
    "Tracy",
    "Banta",
    "Big Oak Flat",
    "Catheys Valley",
    "Catheys Vly",
    "Ceres",
    "Chinese Camp",
    "Columbia",
    "Coulterville",
    "Cressey",
    "Crows Landing",
    "Delhi",
    "Denair",
    "El Nido",
    "El Portal",
    "Empire",
    "Escalon",
    "Groveland",
    "Gustine",
    "Santa Nella",
    "Hickman",
    "Hilmar",
    "Hornitos",
    "Hughson",
    "Jamestown",
    "Keyes",
    "La Grange",
    "Lathrop",
    "Le Grand",
    "Livingston",
    "Long Barn",
    "Cold Springs",
    "Manteca",
    "Mariposa",
    "Merced",
    "Midpines",
    "Mi Wuk Village",
    "Mi Wuk Vlg",
    "Modesto",
    "Newman",
    "Oakdale",
    "Knights Ferry",
    "Valley Home",
    "Patterson",
    "Diablo Grande",
    "Pinecrest",
    "Dardanelle",
    "Planada",
    "Ripon",
    "Riverbank",
    "Salida",
    "Snelling",
    "Sonora",
    "Soulsbyville",
    "Stevinson",
    "Strawberry",
    "Tuolumne",
    "Turlock",
    "Twain Harte",
    "Vernalis",
    "Waterford",
    "Westley",
    "Winton",
    "Yosemite National Park",
    "Tuolumne Mdws",
    "Tuolumne Meadows",
    "Wawona",
    "Yosemite Ntpk",
    "Mountain House",
    "Mtn House",
    "Santa Rosa",
    "Larkfield",
    "Kenwood",
    "Albion",
    "Annapolis",
    "Boonville",
    "Branscomb",
    "Laytonville",
    "Camp Meeker",
    "Caspar",
    "Cazadero",
    "Clearlake",
    "Clearlake Oaks",
    "Clearlake Oks",
    "Cloverdale",
    "Cobb",
    "Comptche",
    "Covelo",
    "Dos Rios",
    "Duncans Mills",
    "Eldridge",
    "Elk",
    "Finley",
    "Forestville",
    "Fort Bragg",
    "Fulton",
    "Geyserville",
    "Glen Ellen",
    "Glenhaven",
    "Graton",
    "Gualala",
    "Guerneville",
    "Healdsburg",
    "Hopland",
    "Jenner",
    "Kelseyville",
    "Lakeport",
    "Little River",
    "Littleriver",
    "Lower Lake",
    "Lucerne",
    "Manchester",
    "Mendocino",
    "Middletown",
    "Loch Lomond",
    "Monte Rio",
    "Russian River",
    "Russian River Mdws",
    "Navarro",
    "Nice",
    "Occidental",
    "Philo",
    "Hidden Valley Lake",
    "Hidden Vl Lk",
    "Point Arena",
    "Potter Valley",
    "Redwood Valley",
    "Redwood Vly",
    "Rio Nido",
    "Sebastopol",
    "Freestone",
    "Sonoma",
    "Stewarts Point",
    "Stewarts Pt",
    "Ukiah",
    "Upper Lake",
    "Villa Grande",
    "Westport",
    "Willits",
    "Windsor",
    "Witter Springs",
    "Witter Spgs",
    "Yorkville",
    "The Sea Ranch",
    "Eureka",
    "Alderpoint",
    "Blocksburg",
    "Mckinleyville",
    "Arcata",
    "Mc Kinleyville",
    "Bayside",
    "Blue Lake",
    "Bridgeville",
    "Mad River",
    "Ruth",
    "Burnt Ranch",
    "Carlotta",
    "Crescent City",
    "Ferndale",
    "Fields Landing",
    "Fields Ldg",
    "Fort Dick",
    "Fortuna",
    "Garberville",
    "Gasquet",
    "Honeydew",
    "Hoopa",
    "Hydesville",
    "Klamath",
    "Kneeland",
    "Korbel",
    "Loleta",
    "Miranda",
    "Myers Flat",
    "Orick",
    "Orleans",
    "Petrolia",
    "Phillipsville",
    "Redway",
    "Rio Dell",
    "Salyer",
    "Samoa",
    "Scotia",
    "Smith River",
    "Somes Bar",
    "Redcrest",
    "Trinidad",
    "Weott",
    "Willow Creek",
    "Leggett",
    "Piercy",
    "Whitethorn",
    "Zenia",
    "Amador City",
    "Auburn",
    "Bowman",
    "West Sacramento",
    "Broderick",
    "Bryte",
    "W Sacramento",
    "Brooks",
    "Capay",
    "Esparto",
    "Carmichael",
    "Citrus Heights",
    "Citrus Hts",
    "Clarksburg",
    "Coloma",
    "Cool",
    "Courtland",
    "Davis",
    "El Macero",
    "Diamond Springs",
    "Diamond Spgs",
    "Dixon",
    "Liberty Farms",
    "El Dorado",
    "Elk Grove",
    "Elmira",
    "Elverta",
    "Fair Oaks",
    "Fiddletown",
    "Folsom",
    "Foresthill",
    "Galt",
    "Garden Valley",
    "Georgetown",
    "Greenwood",
    "Grizzly Flats",
    "Guinda",
    "Herald",
    "Hood",
    "Ione",
    "Isleton",
    "Jackson",
    "Knights Landing",
    "Knights Lndg",
    "Kirkwood",
    "Pioneer",
    "Lincoln",
    "Loomis",
    "Lotus",
    "Mcclellan",
    "Madison",
    "Mather",
    "Rancho Cordova",
    "Rncho Cordova",
    "Newcastle",
    "Nicolaus",
    "East Nicolaus",
    "Trowbridge",
    "North Highlands",
    "N Highlands",
    "Roseville",
    "Granite Bay",
    "Orangevale",
    "Penryn",
    "Pilot Hill",
    "Pine Grove",
    "Placerville",
    "Kelsey",
    "Pleasant Grove",
    "Pleasant Grv",
    "Plymouth",
    "Gold River",
    "Represa",
    "Rescue",
    "Rio Linda",
    "Rio Oso",
    "River Pines",
    "Mount Aukum",
    "Robbins",
    "Rocklin",
    "Rumsey",
    "Ryde",
    "Sheridan",
    "Shingle Springs",
    "Cameron Park",
    "Latrobe",
    "Shingle Spgs",
    "Sloughhouse",
    "Rancho Murieta",
    "Rncho Murieta",
    "Somerset",
    "Fair Play",
    "Sutter Creek",
    "Thornton",
    "Vacaville",
    "Volcano",
    "Walnut Grove",
    "Wheatland",
    "Wilton",
    "Winters",
    "Woodland",
    "Yolo",
    "Zamora",
    "Drytown",
    "Alta",
    "Applegate",
    "Camino",
    "Colfax",
    "Eden Valley",
    "Iowa Hill",
    "Dutch Flat",
    "Emigrant Gap",
    "Gold Run",
    "Kyburz",
    "Echo Lake",
    "Twin Bridges",
    "Meadow Vista",
    "Pollock Pines",
    "Pacific House",
    "Soda Springs",
    "Weimar",
    "El Dorado Hills",
    "El Dorado Hls",
    "Sacramento",
    "Antelope",
    "Marysville",
    "Linda",
    "Loma Rica",
    "Beale Afb",
    "Alleghany",
    "Arbuckle",
    "College City",
    "Artois",
    "Bangor",
    "Belden",
    "Oroville",
    "Berry Creek",
    "Biggs",
    "Browns Valley",
    "Brownsville",
    "Butte City",
    "Camptonville",
    "Canyon Dam",
    "Canyondam",
    "Challenge",
    "Chico",
    "Clipper Mills",
    "La Porte",
    "Colusa",
    "Crescent Mills",
    "Crescent Mls",
    "Dobbins",
    "Downieville",
    "Dunnigan",
    "Durham",
    "Elk Creek",
    "Forbestown",
    "Forest Ranch",
    "Butte Meadows",
    "Glenn",
    "Goodyears Bar",
    "Grass Valley",
    "Penn Valley",
    "Greenville",
    "Gridley",
    "Grimes",
    "Hamilton City",
    "Live Oak",
    "Magalia",
    "Maxwell",
    "Meadow Valley",
    "Meridian",
    "Nelson",
    "Nevada City",
    "North San Juan",
    "N San Juan",
    "Olivehurst",
    "Arboga",
    "Plumas Lake",
    "West Linda",
    "Oregon House",
    "Orland",
    "Butte Valley",
    "Pulga",
    "Yankee Hill",
    "Palermo",
    "Paradise",
    "Princeton",
    "Quincy",
    "Spring Garden",
    "Rackerby",
    "Cohasset",
    "Richvale",
    "Rough And Ready",
    "Rough Ready",
    "Smartsville",
    "Big Oak Valley",
    "Big Oak Vly",
    "Stirling City",
    "Stonyford",
    "Strawberry Valley",
    "Strawbrry Vly",
    "Sutter",
    "Taylorsville",
    "Twain",
    "Washington",
    "Williams",
    "Willows",
    "Yuba City",
    "Redding",
    "Adin",
    "Anderson",
    "Bella Vista",
    "Bieber",
    "Big Bar",
    "Big Bend",
    "Burney",
    "Callahan",
    "Canby",
    "Cassel",
    "Castella",
    "Shasta Lake",
    "Central Valley",
    "Central Vly",
    "Chester",
    "Corning",
    "Cottonwood",
    "Dorris",
    "Douglas City",
    "Dunsmuir",
    "Etna",
    "Sawyers Bar",
    "Fall River Mills",
    "Fl River Mls",
    "Flournoy",
    "Forks Of Salmon",
    "Frk Of Salmon",
    "Fort Jones",
    "French Gulch",
    "Gazelle",
    "Gerber",
    "Greenview",
    "Grenada",
    "Happy Camp",
    "Hat Creek",
    "Hayfork",
    "Hornbrook",
    "Hyampom",
    "Igo",
    "Ono",
    "Junction City",
    "Helena",
    "Klamath River",
    "Horse Creek",
    "Lakehead",
    "Lewiston",
    "Lookout",
    "Los Molinos",
    "Mcarthur",
    "Little Valley",
    "Mccloud",
    "Macdoel",
    "Manton",
    "Mill Creek",
    "Millville",
    "Mineral",
    "Montague",
    "Montgomery Creek",
    "Montgomry Crk",
    "Mount Shasta",
    "Nubieber",
    "Oak Run",
    "Old Station",
    "Palo Cedro",
    "Paskenta",
    "Paynes Creek",
    "Platina",
    "Wildwood",
    "Proberta",
    "Red Bluff",
    "Round Mountain",
    "Round Mtn",
    "Scott Bar",
    "Seiad Valley",
    "Shasta",
    "Shingletown",
    "Tehama",
    "Trinity Center",
    "Trinity Ctr",
    "Vina",
    "Weaverville",
    "Weed",
    "Edgewood",
    "Hammond Ranch",
    "Whitmore",
    "Yreka",
    "Alturas",
    "Blairsden Graeagle",
    "Blairsden",
    "Blrsdn Greagl",
    "Cromberg",
    "Graeagle",
    "Cedarville",
    "Chilcoot",
    "Clio",
    "Coleville",
    "Davis Creek",
    "Doyle",
    "Eagleville",
    "Floriston",
    "Fort Bidwell",
    "Herlong",
    "Janesville",
    "Lake City",
    "Likely",
    "Litchfield",
    "Loyalton",
    "Madeline",
    "Markleeville",
    "Hope Valley",
    "Milford",
    "Portola",
    "Ravendale",
    "Calpine",
    "Sattley",
    "Sierra City",
    "Sierraville",
    "Standish",
    "Beckwourth",
    "Susanville",
    "Termo",
    "Topaz",
    "Tulelake",
    "Newell",
    "Tionesta",
    "Vinton",
    "Wendel",
    "Westwood",
    "Lake Almanor",
    "Carnelian Bay",
    "Homewood",
    "Tahoma",
    "Kings Beach",
    "Tahoe City",
    "Alpine Mdws",
    "Alpine Meadows",
    "Olympic Valley",
    "Olympic Vly",
    "Tahoe Vista",
    "South Lake Tahoe",
    "S Lake Tahoe",
    "Truckee",
    "Northstar",
  ],
  CO: [
    "Arvada",
    "Westminster",
    "Aurora",
    "Buckley AFB",
    "Buckley Air Force Base",
    "Denver",
    "Centennial",
    "Foxfield",
    "Broomfield",
    "Commerce City",
    "Thornton",
    "Dupont",
    "Eldorado Springs",
    "Eldorado Sprg",
    "Lafayette",
    "Louisville",
    "Superior",
    "Wheat Ridge",
    "Agate",
    "Bennett",
    "Byers",
    "Castle Rock",
    "Deer Trail",
    "Elbert",
    "Elizabeth",
    "Castle Pines",
    "Englewood",
    "Cherry Hills",
    "Cherry Hills Village",
    "Cherry Hl Vlg",
    "Greenwood Village",
    "Greenwood Vlg",
    "Sheridan",
    "Franktown",
    "Kiowa",
    "Larkspur",
    "Littleton",
    "Bow Mar",
    "Columbine Valley",
    "Columbine Vly",
    "Lakewood",
    "Lone Tree",
    "Roxborough",
    "Hghlnds Ranch",
    "Highlands Ranch",
    "Louviers",
    "Monument",
    "Palmer Lake",
    "Parker",
    "Sedalia",
    "Deckers",
    "Strasburg",
    "Watkins",
    "Edgewater",
    "Federal Heights",
    "Federal Hgts",
    "Lowry",
    "Montclair",
    "Northglenn",
    "North Glenn",
    "Montbello",
    "Glendale",
    "Boulder",
    "Golden",
    "Evergreen",
    "Alma",
    "Bailey",
    "Black Hawk",
    "Bond",
    "Breckenridge",
    "Blue River",
    "Buffalo Creek",
    "Burns",
    "Central City",
    "Clark",
    "Coalmont",
    "Walden",
    "Como",
    "Fairplay",
    "Conifer",
    "Foxton",
    "Cowdrey",
    "Dillon",
    "Keystone",
    "Montezuma",
    "Dumont",
    "Empire",
    "Fraser",
    "Frisco",
    "Georgetown",
    "Granby",
    "Grand Lake",
    "Grant",
    "Hartsel",
    "Hot Sulphur Springs",
    "Hot Slphr Spr",
    "Idaho Springs",
    "Idledale",
    "Indian Hills",
    "Jamestown",
    "Jefferson",
    "Kittredge",
    "Kremmling",
    "Leadville",
    "McCoy",
    "Morrison",
    "Nederland",
    "Oak Creek",
    "Parshall",
    "Phippsburg",
    "Pine",
    "Pinecliffe",
    "Rand",
    "Rollinsville",
    "Shawnee",
    "Silver Plume",
    "Tabernash",
    "Toponas",
    "Ward",
    "Winter Park",
    "Yampa",
    "Steamboat Springs",
    "Steamboat Spr",
    "Silverthorne",
    "Heeney",
    "Longmont",
    "Niwot",
    "Firestone",
    "Frederick",
    "Mead",
    "Allenspark",
    "Bellvue",
    "Berthoud",
    "Dacono",
    "Erie",
    "Drake",
    "Estes Park",
    "Fort Collins",
    "Severance",
    "Timnath",
    "Windsor",
    "Glen Haven",
    "Johnstown",
    "Loveland",
    "Laporte",
    "Livermore",
    "Virginia Dale",
    "Lyons",
    "Milliken",
    "Red Feather Lakes",
    "Red Fe Lks",
    "Wellington",
    "Brighton",
    "Lochbuie",
    "Ault",
    "Briggsdale",
    "Carr",
    "Eaton",
    "Evans",
    "Fort Lupton",
    "Wattenburg",
    "Galeton",
    "Gilcrest",
    "Gill",
    "Greeley",
    "Garden City",
    "Henderson",
    "Hudson",
    "Keenesburg",
    "Kersey",
    "La Salle",
    "Lucerne",
    "Nunn",
    "Orchard",
    "Pierce",
    "Platteville",
    "Roggen",
    "Weldona",
    "Wiggins",
    "Hoyt",
    "Fort Morgan",
    "Log Lane Village",
    "Log Lane Vlg",
    "Akron",
    "Amherst",
    "Atwood",
    "Brush",
    "Crook",
    "Eckley",
    "Fleming",
    "Grover",
    "Haxtun",
    "Hereford",
    "Hillrose",
    "Holyoke",
    "Idalia",
    "Hale",
    "Iliff",
    "Julesburg",
    "Lindon",
    "Merino",
    "Willard",
    "New Raymer",
    "Otis",
    "Ovid",
    "Padroni",
    "Paoli",
    "Peetz",
    "Sedgwick",
    "Snyder",
    "Sterling",
    "Stoneham",
    "Vernon",
    "Woodrow",
    "Last Chance",
    "Wray",
    "Laird",
    "Yuma",
    "Anton",
    "Arapahoe",
    "Arriba",
    "Bethune",
    "Burlington",
    "Calhan",
    "Cascade",
    "Cheyenne Wells",
    "Cheyenne Wls",
    "Cope",
    "Cripple Creek",
    "Divide",
    "Flagler",
    "Florissant",
    "Fountain",
    "Genoa",
    "Green Mountain Falls",
    "Green Mtn Fls",
    "Guffey",
    "Hugo",
    "Boyero",
    "Joes",
    "Karval",
    "Kirk",
    "Kit Carson",
    "Limon",
    "Lake George",
    "Manitou Springs",
    "Manitou Spgs",
    "Matheson",
    "Peyton",
    "Falcon",
    "Ramah",
    "Rush",
    "Seibert",
    "Simla",
    "Stratton",
    "Usaf Academy",
    "United States Air Force Acad",
    "Us Air Force",
    "Victor",
    "Vona",
    "Wild Horse",
    "Woodland Park",
    "Yoder",
    "Colorado Springs",
    "Colo Spgs",
    "Colorado Spgs",
    "Fort Carson",
    "Ft Carson",
    "Chey Mtn AFB",
    "Cheyenne Mountain AFB",
    "Peterson AFB",
    "Co Spgs",
    "Pueblo",
    "Pueblo Dep Ac",
    "Pueblo Depot Activity",
    "Pueblo West",
    "Colorado City",
    "Colo City",
    "Aguilar",
    "Arlington",
    "Avondale",
    "N Avondale",
    "North Avondale",
    "Beulah",
    "Boncarbo",
    "Boone",
    "Branson",
    "Campo",
    "Cheraw",
    "Crowley",
    "Eads",
    "Chivington",
    "Fowler",
    "Gardner",
    "Granada",
    "Hartman",
    "Hasty",
    "Caddoa",
    "Haswell",
    "Hoehne",
    "Holly",
    "Bristol",
    "Kim",
    "Villegreen",
    "La Junta",
    "Timpas",
    "Lamar",
    "Las Animas",
    "Deora",
    "Fort Lyon",
    "Ninaview",
    "La Veta",
    "McClave",
    "Manzanola",
    "Model",
    "Delhi",
    "Thatcher",
    "Tyrone",
    "Olney Springs",
    "Ordway",
    "Pritchett",
    "Utleyville",
    "Rocky Ford",
    "Rye",
    "Sheridan Lake",
    "Brandon",
    "Towner",
    "Springfield",
    "Sugar City",
    "Swink",
    "Trinchera",
    "Trinidad",
    "Cokedale",
    "Jansen",
    "Sopris",
    "Starkville",
    "Two Buttes",
    "Lycan",
    "Vilas",
    "Walsenburg",
    "Farista",
    "Walsh",
    "Stonington",
    "Weston",
    "Wiley",
    "Alamosa",
    "Great Sand Dunes National Mo",
    "Sand Dunes Mo",
    "Antonito",
    "Arboles",
    "Bayfield",
    "Chimney Rock",
    "Blanca",
    "Capulin",
    "Center",
    "Chama",
    "Chromo",
    "Conejos",
    "Creede",
    "Crestone",
    "Del Norte",
    "Fort Garland",
    "Sangre De Cri",
    "Sangre De Cristo Ranches",
    "Hooper",
    "Ignacio",
    "S Ute Indian",
    "Southern Ute Indian Reservat",
    "Jaroso",
    "La Jara",
    "Manassa",
    "Moffat",
    "Monte Vista",
    "Mosca",
    "Pagosa Springs",
    "Pagosa Spgs",
    "Romeo",
    "Saguache",
    "Sanford",
    "San Acacio",
    "San Luis",
    "Garcia",
    "Mesita",
    "San Pablo",
    "South Fork",
    "Villa Grove",
    "Salida",
    "Poncha Spgs",
    "Poncha Springs",
    "Almont",
    "Buena Vista",
    "Canon City",
    "Brookside",
    "Cimarron",
    "Coal Creek",
    "Coaldale",
    "Cotopaxi",
    "Crested Butte",
    "Florence",
    "Monarch",
    "Granite",
    "Twin Lakes",
    "Gunnison",
    "Hillside",
    "Howard",
    "Lake City",
    "Nathrop",
    "Ohio City",
    "Parlin",
    "Penrose",
    "Pitkin",
    "Powderhorn",
    "Rockvale",
    "Sargents",
    "Westcliffe",
    "Silver Cliff",
    "Wetmore",
    "Durango",
    "Cahone",
    "Cortez",
    "Dolores",
    "Dove Creek",
    "Egnar",
    "Slick Rock",
    "Hesperus",
    "Lewis",
    "Mancos",
    "Mesa Verde National Park",
    "Mesa Verde",
    "Pleasant View",
    "Rico",
    "Towaoc",
    "Yellow Jacket",
    "Montrose",
    "Austin",
    "Orchard City",
    "Bedrock",
    "Cedaredge",
    "Crawford",
    "Maher",
    "Delta",
    "Eckert",
    "Hotchkiss",
    "Naturita",
    "Norwood",
    "Nucla",
    "Olathe",
    "Ophir",
    "Ouray",
    "Paonia",
    "Paradox",
    "Placerville",
    "Redvale",
    "Ridgway",
    "Silverton",
    "Somerset",
    "Telluride",
    "Mountain Village",
    "Mountain Vlg",
    "Grand Junction",
    "Grand Jct",
    "Fruitvale",
    "Clifton",
    "Fruita",
    "Gateway",
    "Glade Park",
    "Loma",
    "Mack",
    "Palisade",
    "Whitewater",
    "Glenwood Springs",
    "Glenwood Spgs",
    "Dinosaur",
    "Aspen",
    "Snowmass Village",
    "Snowmass Vlg",
    "Avon",
    "Beaver Creek",
    "Basalt",
    "Carbondale",
    "El Jebel",
    "Marble",
    "Redstone",
    "Collbran",
    "Craig",
    "De Beque",
    "Eagle",
    "Edwards",
    "Cordillera",
    "Elk Springs",
    "Parachute",
    "Battlement Mesa",
    "Btlmt Mesa",
    "Gypsum",
    "Hamilton",
    "Hayden",
    "Maybell",
    "Meeker",
    "Meredith",
    "Mesa",
    "Minturn",
    "Gilman",
    "Molina",
    "New Castle",
    "Rangely",
    "Red Cliff",
    "Rifle",
    "Silt",
    "Slater",
    "Snowmass",
    "Wolcott",
    "Woody Creek",
    "Vail",
  ],
  CT: [
    "Avon",
    "Bloomfield",
    "Bristol",
    "Burlington",
    "Unionville",
    "Broad Brook",
    "Melrose",
    "Windsorville",
    "Canaan",
    "Canton",
    "Collinsville",
    "Canton Center",
    "Colebrook",
    "East Berlin",
    "East Canaan",
    "East Granby",
    "East Hartland",
    "Ellington",
    "Falls Village",
    "Farmington",
    "Glastonbury",
    "Granby",
    "Berlin",
    "Kensington",
    "Lakeville",
    "Manchester",
    "Bolton",
    "New Britain",
    "New Hartford",
    "Norfolk",
    "North Canton",
    "North Granby",
    "Pine Meadow",
    "Plainville",
    "Barkhamsted",
    "Pleasant Valley",
    "Pleasant Vly",
    "Winsted",
    "Riverton",
    "Vernon Rockville",
    "Vernon",
    "Vernon Rockvl",
    "Rocky Hill",
    "Salisbury",
    "Sharon",
    "Simsbury",
    "Somers",
    "Somersville",
    "South Glastonbury",
    "S Glastonbury",
    "South Windsor",
    "Stafford Springs",
    "Stafford Spgs",
    "Union",
    "Suffield",
    "Taconic",
    "Tariffville",
    "Enfield",
    "Tolland",
    "East Windsor",
    "Weatogue",
    "West Granby",
    "West Hartland",
    "West Simsbury",
    "West Suffield",
    "Windsor",
    "Windsor Locks",
    "Winchester Center",
    "Winchestr Ctr",
    "Hartford",
    "West Hartford",
    "West Hartfrd",
    "East Hartford",
    "Wethersfield",
    "Newington",
    "Willimantic",
    "Amston",
    "Andover",
    "Brooklyn",
    "Chaplin",
    "Mansfield Center",
    "Mansfield Ctr",
    "North Windham",
    "Columbia",
    "Coventry",
    "Danielson",
    "Killingly",
    "Dayville",
    "Eastford",
    "East Killingly",
    "E Killingly",
    "Hampton",
    "Scotland",
    "Hebron",
    "Lebanon",
    "North Franklin",
    "N Franklin",
    "North Grosvenordale",
    "N Grosvenordl",
    "Pomfret",
    "Pomfret Center",
    "Pomfret Ctr",
    "Putnam",
    "Quinebaug",
    "Rogers",
    "South Windham",
    "Storrs Mansfield",
    "Storrs",
    "Storrs Manfld",
    "Thompson",
    "Ashford",
    "Warrenville",
    "Willington",
    "Windham",
    "Woodstock",
    "Woodstock Valley",
    "Woodstock Vly",
    "New London",
    "Baltic",
    "Canterbury",
    "Central Village",
    "Central Vlg",
    "East Lyme",
    "Bozrah",
    "Gales Ferry",
    "Gilman",
    "Mashantucket",
    "Ledyard",
    "Groton",
    "Hanover",
    "Jewett City",
    "Griswold",
    "Lisbon",
    "Montville",
    "Moosup",
    "Mystic",
    "Niantic",
    "North Stonington",
    "N Stonington",
    "Norwich",
    "Preston",
    "Oakdale",
    "Old Lyme",
    "Lyme",
    "Oneco",
    "Plainfield",
    "Quaker Hill",
    "South Lyme",
    "Sterling",
    "Stonington",
    "Pawcatuck",
    "Taftville",
    "Uncasville",
    "Voluntown",
    "Glasgo",
    "Waterford",
    "Wauregan",
    "Yantic",
    "Ansonia",
    "Beacon Falls",
    "Branford",
    "Centerbrook",
    "Cheshire",
    "Chester",
    "Clinton",
    "Cobalt",
    "Colchester",
    "Cromwell",
    "Deep River",
    "Derby",
    "Killingworth",
    "Salem",
    "Durham",
    "East Haddam",
    "East Hampton",
    "Haddam Neck",
    "Essex",
    "Guilford",
    "Haddam",
    "Hadlyme",
    "Higganum",
    "Ivoryton",
    "Madison",
    "Marion",
    "Marlborough",
    "Meriden",
    "Middlefield",
    "Middle Haddam",
    "Middletown",
    "Milford",
    "Milldale",
    "Monroe",
    "Moodus",
    "Newtown",
    "North Branford",
    "N Branford",
    "Northford",
    "North Haven",
    "Old Saybrook",
    "Orange",
    "Oxford",
    "Seymour",
    "Plantsville",
    "Portland",
    "Rockfall",
    "Sandy Hook",
    "Shelton",
    "Huntington",
    "Southbury",
    "Southington",
    "Wallingford",
    "Yalesville",
    "Westbrook",
    "New Haven",
    "Hamden",
    "East Haven",
    "West Haven",
    "W Haven",
    "Whitneyville",
    "Bethany",
    "Woodbridge",
    "Bridgeport",
    "Trumbull",
    "Easton",
    "Stratford",
    "Waterbury",
    "Wolcott",
    "Prospect",
    "Bantam",
    "Bethlehem",
    "Bridgewater",
    "Cornwall",
    "Cornwall Bridge",
    "Cornwall Brg",
    "Warren",
    "Gaylordsville",
    "Goshen",
    "Kent",
    "Lakeside",
    "Litchfield",
    "Middlebury",
    "Morris",
    "Naugatuck",
    "New Milford",
    "New Preston Marble Dale",
    "New Preston",
    "Washington Depot",
    "Washington Dt",
    "Northfield",
    "Thomaston",
    "Oakville",
    "Watertown",
    "Plymouth",
    "Roxbury",
    "Sherman",
    "South Kent",
    "Terryville",
    "Torrington",
    "Harwinton",
    "Washington",
    "West Cornwall",
    "Woodbury",
    "Bethel",
    "Brookfield",
    "Brookfld Ctr",
    "Cos Cob",
    "Danbury",
    "New Fairfield",
    "Darien",
    "Fairfield",
    "Greenwich",
    "New Canaan",
    "Norwalk",
    "Old Greenwich",
    "Ridgefield",
    "Riverside",
    "Westport",
    "Weston",
    "Southport",
    "Redding",
    "West Redding",
    "Wilton",
    "Stamford",
    "Ridgeway",
  ],
  DC: [
    "Washington",
    "Chevy Chase",
    "Fort Lesley J Mcnair",
    "Fort Mcnair",
    "Ft L J Mcnair",
    "Bolling AFB",
    "Naval Anacost Annex",
    "Anacostia",
    "Anacostia Anx",
    "Jbab",
    "Joint Base Anacostia Bolling",
    "Washington Navy Yard",
    "Washington Na",
    "Marine Barrks",
    "Us Marine Corps Barracks",
  ],
  DE: [
    "Bear",
    "Newark",
    "Christiana",
    "Claymont",
    "Delaware City",
    "Hockessin",
    "Middletown",
    "Montchanin",
    "New Castle",
    "Historic New Castle",
    "Hst Newcastle",
    "Manor",
    "Odessa",
    "Port Penn",
    "Rockland",
    "Saint Georges",
    "Townsend",
    "Winterthur",
    "Yorklyn",
    "Wilmington",
    "Talleyville",
    "Newport",
    "Stanton",
    "Elsmere",
    "Greenville",
    "Marshallton",
    "Bellefonte",
    "Edgemoor",
    "Dover",
    "Leipsic",
    "Dover Afb",
    "Dover Air Force Base",
    "Bethany Beach",
    "S Bethany",
    "South Bethany",
    "Bethel",
    "Bridgeville",
    "Camden Wyoming",
    "Camden",
    "Camden Wyo",
    "Wyoming",
    "Cheswold",
    "Clayton",
    "Dagsboro",
    "Delmar",
    "Ellendale",
    "Felton",
    "Fenwick Island",
    "Fenwick Isle",
    "Selbyville",
    "Frankford",
    "Frederica",
    "Georgetown",
    "Greenwood",
    "Farmington",
    "Harbeson",
    "Harrington",
    "Hartly",
    "Houston",
    "Kenton",
    "Laurel",
    "Lewes",
    "Lincoln",
    "Magnolia",
    "Milford",
    "Marydel",
    "Millsboro",
    "Long Neck",
    "Millville",
    "Ocean View",
    "Milton",
    "Clarksville",
    "Rehoboth Beach",
    "Dewey Beach",
    "Rehoboth Bch",
    "Seaford",
    "Blades",
    "Smyrna",
    "Viola",
    "Woodside",
  ],
  FL: [
    "Fleming Island",
    "Fleming Isle",
    "Orange Park",
    "Branford",
    "Bryceville",
    "Callahan",
    "Day",
    "Lake City",
    "Elkton",
    "Fernandina Beach",
    "Amelia Island",
    "Fern Bch",
    "Fernandina",
    "Fernandina Bch",
    "Fort White",
    "Glen Saint Mary",
    "Glen St Mary",
    "Green Cove Springs",
    "Green Cv Spgs",
    "Hampton",
    "Hilliard",
    "Jasper",
    "Jennings",
    "Lake Butler",
    "Lawtey",
    "Lee",
    "Live Oak",
    "Dowling Park",
    "Lulu",
    "McAlpin",
    "Macclenny",
    "Boys Ranch",
    "Mayo",
    "Middleburg",
    "O'Brien",
    "Penney Farms",
    "Saint Augustine",
    "Anastasia Is",
    "Anastasia Island",
    "Saint Augustine Beach",
    "St Aug Beach",
    "St Augustine",
    "St Augustine Beach",
    "Ponte Vedra",
    "Ponte Vedra Beach",
    "Tn Of Nocatee",
    "Town Of Nocatee",
    "Raiford",
    "Sanderson",
    "Starke",
    "Kingsley Lake",
    "Kngsly Lk",
    "Wellborn",
    "White Springs",
    "Yulee",
    "Wildlight",
    "Astor",
    "Bunnell",
    "Crescent City",
    "Welaka",
    "Citra",
    "Daytona Beach",
    "Holly Hill",
    "Dayt Bch Sh",
    "Daytona Beach Shores",
    "S Daytona",
    "S Daytona Bch",
    "South Daytona",
    "Port Orange",
    "Ponce Inlet",
    "Pt Orange",
    "Wilbur By Sea",
    "Wilbur By The Sea",
    "De Leon Springs",
    "De Leon Spgs",
    "East Palatka",
    "Edgewater",
    "Eastlake Weir",
    "Fort McCoy",
    "Palatka",
    "Salt Springs",
    "Flagler Beach",
    "Beverly Beach",
    "Palm Coast",
    "Georgetown",
    "Florahome",
    "Hastings",
    "Hollister",
    "Interlachen",
    "Lake Como",
    "Lady Lake",
    "The Villages",
    "New Smyrna Beach",
    "New Smyrna",
    "Ormond Beach",
    "Ocklawaha",
    "Pierson",
    "Pomona Park",
    "Orange Springs",
    "Orange Spgs",
    "San Mateo",
    "Satsuma",
    "Seville",
    "Sparr",
    "Weirsdale",
    "Jacksonville",
    "Jacksonville Nas",
    "Jax Naval Air",
    "Dinsmore",
    "Mayport Naval Station",
    "Mayport Navy",
    "Atlantic Beach",
    "Atlantic Bch",
    "Mayport",
    "Baldwin",
    "Maxville",
    "Jacksonville Beach",
    "Jax Bch",
    "Saint Johns",
    "Fruit Cove",
    "Julington Creek",
    "Julington Crk",
    "St Johns",
    "Switzerland",
    "Neptune Beach",
    "Tallahassee",
    "Miccosukee",
    "Apalachicola",
    "Bristol",
    "Carrabelle",
    "Lanark Village",
    "Lanark Vlg",
    "Chattahoochee",
    "Crawfordville",
    "Wakulla Spgs",
    "Wakulla Springs",
    "Eastpoint",
    "Saint George Island",
    "St George Isl",
    "Greensboro",
    "Greenville",
    "Gretna",
    "Havana",
    "Hosford",
    "Lamont",
    "Lloyd",
    "Madison",
    "Midway",
    "Monticello",
    "Panacea",
    "Alligator Point",
    "Alligator Pt",
    "Ochlockonee",
    "Ochlockonee Bay",
    "Perry",
    "Pinetta",
    "Quincy",
    "Mount Pleasant",
    "Mt Pleasant",
    "Saint Marks",
    "Salem",
    "Sopchoppy",
    "Saint Teresa",
    "St Teresa",
    "Steinhatchee",
    "Telogia",
    "Wacissa",
    "Panama City",
    "P C Beach",
    "Panama City Beach",
    "Tyndall AFB",
    "Callaway",
    "Parker",
    "Southport",
    "Mexico Beach",
    "Alys Beach",
    "Grande Pointe",
    "Inlet Beach",
    "Rosemary Bch",
    "Seacrest",
    "Watersound",
    "Alford",
    "Altha",
    "Bascom",
    "Blountstown",
    "Bonifay",
    "Caryville",
    "Esto",
    "Campbellton",
    "Chipley",
    "Sunny Hills",
    "Clarksville",
    "Cottondale",
    "Jacob",
    "Cypress",
    "Defuniak Springs",
    "Defuniak Spgs",
    "Ebro",
    "Fountain",
    "Freeport",
    "Graceville",
    "Grand Ridge",
    "Greenwood",
    "Lynn Haven",
    "Malone",
    "Marianna",
    "Wewahitchka",
    "Kinard",
    "Ponce De Leon",
    "Bruce",
    "Red Bay",
    "Port Saint Joe",
    "Cape San Blas",
    "Overstreet",
    "Port St Joe",
    "Santa Rosa Beach",
    "Point Washington",
    "Pt Washington",
    "Santa Rsa Bch",
    "Sneads",
    "Rosemary Beach",
    "Vernon",
    "Wausau",
    "Westville",
    "Youngstown",
    "Pensacola",
    "Bellview",
    "Bagdad",
    "Baker",
    "Cantonment",
    "Century",
    "Crestview",
    "Destin",
    "Eglin Afb",
    "Dfafs",
    "Duke Field Afs",
    "Eglin",
    "Hurlburt Field",
    "Hurlburt Fld",
    "Fort Walton Beach",
    "Ft Walton Bch",
    "Okaloosa Is",
    "Okaloosa Island",
    "Miramar Beach",
    "Sandestin",
    "Gulf Breeze",
    "Pensacola Bch",
    "Pensacola Beach",
    "Holt",
    "Jay",
    "Navarre",
    "Laurel Hill",
    "McDavid",
    "Walnut Hill",
    "Mary Esther",
    "Milton",
    "Pace",
    "Molino",
    "Niceville",
    "Choctaw Beach",
    "Shalimar",
    "Valparaiso",
    "Gainesville",
    "Alachua",
    "Santa Fe",
    "Anthony",
    "Archer",
    "Bell",
    "Bronson",
    "Brooker",
    "Cedar Key",
    "Chiefland",
    "Cross City",
    "Earleton",
    "Fairfield",
    "Gulf Hammock",
    "Hawthorne",
    "Cross Creek",
    "High Springs",
    "Horseshoe Beach",
    "Horseshoe Bch",
    "Keystone Heights",
    "Keystone Hgts",
    "La Crosse",
    "McIntosh",
    "Melrose",
    "Micanopy",
    "Morriston",
    "Newberry",
    "Jonesville",
    "Tioga",
    "Old Town",
    "Orange Lake",
    "Otter Creek",
    "Reddick",
    "Suwannee",
    "Trenton",
    "Fanning Spgs",
    "Fanning Springs",
    "Waldo",
    "Williston",
    "Worthington Springs",
    "Worthngtn Spg",
    "Altamonte Springs",
    "Altamonte Spg",
    "Altoona",
    "Apopka",
    "Forest City",
    "Casselberry",
    "Winter Springs",
    "Winter Spgs",
    "Christmas",
    "Debary",
    "Deland",
    "Deltona",
    "Enterprise",
    "Eustis",
    "Fern Park",
    "Geneva",
    "Grand Island",
    "Lake Helen",
    "Lake Mary",
    "Heathrow",
    "Longwood",
    "Maitland",
    "Eatonville",
    "Mims",
    "Mount Dora",
    "Oak Hill",
    "Orange City",
    "Osteen",
    "Oviedo",
    "Chuluota",
    "Paisley",
    "Plymouth",
    "Sanford",
    "Scottsmoor",
    "Sorrento",
    "Mount Plymouth",
    "Mt Plymouth",
    "Tavares",
    "Deer Island",
    "Wekiva Spg",
    "Wekiva Springs",
    "Titusville",
    "Umatilla",
    "Dona Vista",
    "Winter Park",
    "Aloma",
    "Zellwood",
    "Orlando",
    "Azalea Park",
    "Pine Hills",
    "Belle Isle",
    "Edgewood",
    "Pine Castle",
    "Lockhart",
    "Orlo Vista",
    "Alafaya",
    "Union Park",
    "Hiawassee",
    "Sand Lake",
    "Bay Lake",
    "Lake Buena Vista",
    "Lk Buena Vis",
    "Golden Oak",
    "Kennedy Sp Ct",
    "Kennedy Space Center",
    "Melbourne",
    "Indialantic",
    "Melbourne Village",
    "Melbourne Vlg",
    "W Melbourne",
    "West Melbourne",
    "Palm Bay",
    "Grant Valkaria",
    "Grant Vlkria",
    "Cape Canaveral",
    "Cpe Canaveral",
    "Port Canaveral",
    "Pt Canaveral",
    "Cocoa",
    "Patrick Afb",
    "Canaveral Air Station",
    "Canaveral As",
    "Patrick Air Force Base",
    "Port Saint John",
    "Port St John",
    "Cocoa Beach",
    "Eau Gallie",
    "Satellite Beach",
    "Ind Hbr Bch",
    "Indian Harbour Beach",
    "Indn Hbr Bch",
    "Satellite Bch",
    "Palm Shores",
    "Viera",
    "Fellsmere",
    "Grant",
    "Malabar",
    "Melbourne Beach",
    "Melbourne Bch",
    "Merritt Island",
    "Merritt Is",
    "Rockledge",
    "Sebastian",
    "Sharpes",
    "Vero Beach",
    "Indian River Shores",
    "Indn Riv Shrs",
    "Orchid",
    "Citrus Ridge",
    "Wabasso",
    "Barefoot Bay",
    "Micco",
    "Long Key",
    "Dania",
    "Dania Beach",
    "Hallandale",
    "Hallandale Beach",
    "Hallandle Bch",
    "Halndle Bch",
    "Hialeah",
    "Miami Gardens",
    "Miami Lakes",
    "Hialeah Gardens",
    "Hialeah Gdns",
    "Hollywood",
    "Pembroke Park",
    "Miramar",
    "Pembroke Pines",
    "Pembroke Pnes",
    "W Hollywood",
    "West Hollywood",
    "West Park",
    "Homestead",
    "Redland",
    "Naranja",
    "Princeton",
    "Flamingo Ldge",
    "Flamingo Lodge",
    "Florida City",
    "Islamorada",
    "Key Largo",
    "Homestead AFB",
    "Key West",
    "E Rockland Key",
    "E Rockland Ky",
    "East Rockland Key",
    "Key West Nas",
    "Key West Naval Air Station",
    "Stock Island",
    "Summerland Key",
    "Big Torch Key",
    "Cudjoe Key",
    "Little Torch Key",
    "Lower Sugarloaf Key",
    "Ltl Torch Key",
    "Lwr Sugarloaf",
    "Mid Torch Key",
    "Middle Torch Key",
    "Ramrod Key",
    "Sugarlf Shrs",
    "Sugarloaf",
    "Sugarloaf Key",
    "Sugarloaf Shrs",
    "Summrlnd Key",
    "Upper Sugarloaf Key",
    "Upr Sugarloaf",
    "Big Pine Key",
    "Marathon",
    "Conch Key",
    "Duck Key",
    "Grassy Key",
    "Marathon Shores",
    "Marathon Shrs",
    "Key Colony Beach",
    "Key Col Bch",
    "Opa Locka",
    "Carol City",
    "Pompano Beach",
    "Hillsboro Bch",
    "Hillsboro Beach",
    "Coconut Creek",
    "Margate",
    "Deerfield Bch",
    "Deerfield Beach",
    "Lighthouse Point",
    "Lighthouse Pt",
    "Coral Springs",
    "Parkland",
    "N Lauderdale",
    "North Lauderdale",
    "Tavernier",
    "Miami",
    "Miami Beach",
    "Doral",
    "Coconut Grove",
    "Coral Gables",
    "El Portal",
    "Miami Shores",
    "North Bay Village",
    "North Bay Vlg",
    "South Miami",
    "West Miami",
    "Key Biscayne",
    "Bal Harbour",
    "Bay Harbor Is",
    "Bay Harbor Islands",
    "Ind Crk Vlg",
    "Indian Creek Village",
    "Surfside",
    "Kendall",
    "Pinecrest",
    "Cutler Bay",
    "Cutler Ridge",
    "Palmetto Bay",
    "Perrine",
    "Village Of Palmetto Bay",
    "North Miami Beach",
    "Aventura",
    "Golden Beach",
    "N Miami Beach",
    "Sunny Isl Bch",
    "Sunny Isles Beach",
    "Biscayne Park",
    "North Miami",
    "Uleta",
    "Olympia Heights",
    "Olympia Hgts",
    "Medley",
    "Miami Springs",
    "Virginia Gardens",
    "Virginia Gdns",
    "Goulds",
    "Quail Heights",
    "Sweetwater",
    "Fort Lauderdale",
    "Ft Lauderdale",
    "Oakland Park",
    "Lazy Lake",
    "Wilton Manors",
    "Laud By Sea",
    "Lauderdale By The Sea",
    "Sea Ranch Lakes",
    "Sea Ranch Lks",
    "Laud Lakes",
    "Lauderdale Lakes",
    "Tamarac",
    "Lauderhill",
    "Plantation",
    "Davie",
    "City Of Sunrise",
    "Sunrise",
    "Weston",
    "Cooper City",
    "Southwest Ranches",
    "Sw Ranches",
    "West Palm Beach",
    "West Palm Bch",
    "Lake Park",
    "N Palm Beach",
    "North Palm Beach",
    "Palm Bch Gdns",
    "Palm Beach Gardens",
    "Riviera Beach",
    "W Plm Bch",
    "Palm Bch Shrs",
    "Palm Beach Shores",
    "Singer Island",
    "Cloud Lake",
    "Glen Ridge",
    "Lake Clarke",
    "Lake Clarke Shores",
    "Palm Springs",
    "Mangonia Park",
    "Juno Beach",
    "Haverhill",
    "Royal Palm Beach",
    "Royal Plm Bch",
    "Wellington",
    "Green Acres",
    "Greenacres",
    "Village Of Wellington",
    "Vlg Wellingtn",
    "Boynton Beach",
    "Boca Raton",
    "Belle Glade",
    "Briny Breezes",
    "Ocean Ridge",
    "Golf",
    "Village Of Golf",
    "Vlg Of Golf",
    "Canal Point",
    "Bryant",
    "Clewiston",
    "Delray Beach",
    "W Delray Bch",
    "West Delray Beach",
    "Lake Worth",
    "Hobe Sound",
    "Jupiter Island",
    "Jupiter Isle",
    "Jupiter",
    "Lake Worth Beach",
    "Lk Worth Bch",
    "Village Of Palm Springs",
    "Atlantis",
    "Hypoluxo",
    "Lantana",
    "Manalapan",
    "Jupiter Inlet",
    "Jupiter Inlet Colony",
    "Tequesta",
    "Loxahatchee",
    "City Of Westlake",
    "Lox",
    "Loxahatchee Groves",
    "Lxhtchee Grvs",
    "Westlake",
    "Moore Haven",
    "Pahokee",
    "Palm Beach",
    "S Palm Bch",
    "South Palm Beach",
    "Gulf Stream",
    "Highland Bch",
    "Highland Beach",
    "South Bay",
    "Balm",
    "Brandon",
    "Bushnell",
    "Center Hill",
    "Coleman",
    "Dade City",
    "Ridge Manor",
    "Richland",
    "Dover",
    "Durant",
    "Gibsonton",
    "Lake Panasoffkee",
    "Lk Panasoffke",
    "Zephyrhills",
    "Wesley Chapel",
    "Lithia",
    "Lutz",
    "Mango",
    "Odessa",
    "Plant City",
    "Riverview",
    "Ruskin",
    "Apollo Beach",
    "Sun City Center",
    "Sun City Ctr",
    "Saint Leo",
    "San Antonio",
    "Seffner",
    "Sumterville",
    "Thonotosassa",
    "Valrico",
    "Webster",
    "Rdg Mnr Est",
    "Ridge Manor Estates",
    "Wimauma",
    "Tampa",
    "Ybor City",
    "Univ Of Tampa",
    "University Of Tampa",
    "Rocky Point",
    "Twn N Cntry",
    "Temple Ter",
    "Temple Terr",
    "Temple Terrace",
    "Carrollwood",
    "Clair Mel",
    "Clair Mel City",
    "Northdale",
    "Westchase",
    "Palma Ceia",
    "Tampa Palms",
    "Saint Petersburg",
    "St Petersburg",
    "Lealman",
    "Pass A Grille",
    "Pass A Grille Beach",
    "Saint Pete Beach",
    "St Pete Bch",
    "St Pete Beach",
    "St Petersburg Beach",
    "Treasure Is",
    "Treasure Island",
    "Gulfport",
    "S Pasadena",
    "South Pasadena",
    "Madeira Beach",
    "N Redngtn Bch",
    "North Redington Beach",
    "Redingtn Shor",
    "Redington Bch",
    "Redington Beach",
    "Redington Shores",
    "Kenneth City",
    "Tierra Verde",
    "Bay Pines",
    "Clearwater",
    "Belleair",
    "Clearwater Beach",
    "Clearwatr Bch",
    "Largo",
    "Belleair Blf",
    "Belleair Bluffs",
    "Seminole",
    "Pinellas Park",
    "Indian Rocks Beach",
    "Belleair Bch",
    "Belleair Beach",
    "Indian Rk Bch",
    "Indian Rks Beach",
    "Indian Shores",
    "Belleair Shores",
    "Belleair Shrs",
    "Lakeland",
    "Auburndale",
    "Avon Park",
    "Babson Park",
    "Hillcrest Heights",
    "Hillcrest Hts",
    "Bartow",
    "Bowling Green",
    "Bradley",
    "Davenport",
    "Dundee",
    "Eagle Lake",
    "Eaton Park",
    "Fort Meade",
    "Frostproof",
    "Haines City",
    "Homeland",
    "Intercession City",
    "Intrcsion Cty",
    "Kathleen",
    "Lake Alfred",
    "Lake Hamilton",
    "Lake Placid",
    "Lake Wales",
    "Lakeshore",
    "Indian Lake Estates",
    "Indian Lk Est",
    "Nalcrest",
    "Lorida",
    "Loughman",
    "Mulberry",
    "Ona",
    "River Ranch",
    "Polk City",
    "Sebring",
    "Wauchula",
    "Waverly",
    "Winter Haven",
    "Eloise",
    "Jpv",
    "Wahneta",
    "Cypress Gardens",
    "Cypress Gdns",
    "Zolfo Springs",
    "Champions Gate",
    "Champions Gt",
    "Highland Park",
    "Fort Myers",
    "North Fort Myers",
    "N Fort Myers",
    "N Ft Myers",
    "No Fort Myers",
    "No Ft Myers",
    "Cape Coral",
    "Buckingham",
    "Tice",
    "Miromar Lakes",
    "North Ft Myers",
    "Alva",
    "Babcock Ranch",
    "Boca Grande",
    "Bokeelia",
    "Captiva",
    "Estero",
    "Felda",
    "Fort Myers Beach",
    "Bonita Spgs",
    "Bonita Springs",
    "Ft Myers Bch",
    "Labelle",
    "Fort Denaud",
    "Ft Denaud",
    "Lehigh Acres",
    "Palmdale",
    "Placida",
    "Cape Haze",
    "Rotonda West",
    "Port Charlotte",
    "Pt Charlotte",
    "Punta Gorda",
    "Saint James City",
    "St James City",
    "Sanibel",
    "Venus",
    "Matlacha Isle",
    "Matlacha Isles",
    "Matlacha",
    "Naples",
    "Coco River",
    "Barefoot Bch",
    "Barefoot Beach",
    "Copeland",
    "Chokoloskee",
    "Everglades City",
    "Everglades",
    "Goodland",
    "Ochopee",
    "Jerome",
    "Immokalee",
    "Ave Maria",
    "Marco Island",
    "Bradenton",
    "Braden River",
    "University Park",
    "University Pk",
    "Lakewood Ranch",
    "Lakewood Rch",
    "Palma Sola",
    "Cortez",
    "Anna Maria",
    "Bradenton Beach",
    "Bradenton Bch",
    "Holmes Beach",
    "Parrish",
    "Duette",
    "Palmetto",
    "Rubonia",
    "Ellenton",
    "Englewood",
    "West Villages",
    "Grove City",
    "Longboat Key",
    "Osprey",
    "Sarasota",
    "Siesta Key",
    "Terra Ceia",
    "Terra Ceia Is",
    "Terra Ceia Island",
    "Myakka City",
    "Arcadia",
    "Lake Suzy",
    "Sidell",
    "Fort Ogden",
    "Nocatee",
    "Nokomis",
    "North Venice",
    "Venice",
    "North Port",
    "Belleview",
    "Crystal River",
    "Dunnellon",
    "Citrus Spgs",
    "Citrus Springs",
    "Floral City",
    "Hernando",
    "Citrus Hills",
    "Holder",
    "Homosassa",
    "Homosassa Spg",
    "Homosassa Springs",
    "Inglis",
    "Inverness",
    "Lecanto",
    "Beverly Hills",
    "Pine Ridge",
    "Ocala",
    "Oxford",
    "Silver Springs",
    "Silver Spgs",
    "Summerfield",
    "Yankeetown",
    "Brooksville",
    "Spring Hill",
    "Weeki Wachee",
    "Hernando Bch",
    "Hernando Beach",
    "Shady Hills",
    "Land O'Lakes",
    "New Port Richey",
    "New Prt Rchy",
    "New Pt Richey",
    "Nw Prt Rchy",
    "Trinity",
    "Nobleton",
    "Hudson",
    "Bayonet Point",
    "Port Richey",
    "Oldsmar",
    "Aripeka",
    "Crystal Beach",
    "Palm Harbor",
    "Tarpon Springs",
    "Tarpon Spgs",
    "Tarpon Spngs",
    "Holiday",
    "Safety Harbor",
    "Dunedin",
    "Astatula",
    "Clermont",
    "Minneola",
    "Ferndale",
    "Montverde",
    "Fruitland Park",
    "Fruitland Pk",
    "Gotha",
    "Groveland",
    "Howey In The Hills",
    "Howey In Hls",
    "Kenansville",
    "Kissimmee",
    "Buena Ventura Lakes",
    "Bvl",
    "Kindred",
    "Celebration",
    "Reunion",
    "Leesburg",
    "Mascotte",
    "Bella Collina",
    "Poinciana",
    "Oakland",
    "Ocoee",
    "Saint Cloud",
    "Magnolia Sq",
    "Magnolia Square",
    "Harmony",
    "Wildwood",
    "Windermere",
    "Winter Garden",
    "Haines Creek",
    "Yalaha",
    "Fort Pierce",
    "St Lucie Village",
    "St Lucie Vllg",
    "Hutchinson Is",
    "Hutchinson Island",
    "Port Saint Lucie",
    "Port St Lucie",
    "Saint Lucie West",
    "St Lucie West",
    "Indiantown",
    "Jensen Beach",
    "Ocean Breeze",
    "Ocean Breeze Park",
    "Ocean Brz Pk",
    "Okeechobee",
    "Basinger",
    "Yeehaw",
    "Yeehaw Junction",
    "Palm City",
    "Stuart",
    "Sewalls Point",
  ],
  GA: [
    "Avondale Estates",
    "Avondale Est",
    "Alpharetta",
    "Milton",
    "Johns Creek",
    "Marietta",
    "Auburn",
    "Carl",
    "Conyers",
    "Covington",
    "Porterdale",
    "Grayson",
    "Jersey",
    "Dacula",
    "Clarkston",
    "Suwanee",
    "Social Circle",
    "Cumming",
    "Decatur",
    "Lithonia",
    "Stonecrest",
    "Snellville",
    "Lawrenceville",
    "Lilburn",
    "Loganville",
    "Walnut Grove",
    "Oxford",
    "Mansfield",
    "Newborn",
    "Norcross",
    "Berkeley Lake",
    "Peachtree Cor",
    "Peachtree Corners",
    "Pine Lake",
    "Roswell",
    "Mountain Park",
    "Scottdale",
    "Smyrna",
    "Stone Mountain",
    "Stone Mtn",
    "Tucker",
    "Smoke Rise",
    "Duluth",
    "Acworth",
    "Adairsville",
    "Aragon",
    "Armuchee",
    "Austell",
    "Ball Ground",
    "Bowdon",
    "Bremen",
    "Clarkdale",
    "Buchanan",
    "Canton",
    "Holly Springs",
    "Carrollton",
    "Cartersville",
    "Euharlee",
    "Emerson",
    "Lithia Springs",
    "Lithia Spgs",
    "Cave Spring",
    "Cedartown",
    "Mableton",
    "Powder Springs",
    "Powder Spgs",
    "Dallas",
    "Douglasville",
    "Fairmount",
    "Hiram",
    "Jasper",
    "Big Canoe",
    "Kennesaw",
    "Kingston",
    "Lindale",
    "Marble Hill",
    "Mount Berry",
    "Rome",
    "Rockmart",
    "Braswell",
    "Roopville",
    "Rydal",
    "Silver Creek",
    "Talking Rock",
    "Tallapoosa",
    "Tate",
    "Taylorsville",
    "Temple",
    "Villa Rica",
    "Waco",
    "Waleska",
    "White",
    "Whitesburg",
    "Winston",
    "Woodstock",
    "Barnesville",
    "Aldora",
    "Brooks",
    "Concord",
    "Fairburn",
    "Fayetteville",
    "Woolsey",
    "Flovilla",
    "Franklin",
    "Centralhatchee",
    "Ctrlhatchee",
    "Gay",
    "Grantville",
    "Lone Oak",
    "Greenville",
    "Stovall",
    "Griffin",
    "Hampton",
    "Haralson",
    "Hogansville",
    "Jackson",
    "Jenkinsburg",
    "Jonesboro",
    "Lake Spivey",
    "Lagrange",
    "Locust Grove",
    "Lovejoy",
    "Luthersville",
    "Mcdonough",
    "Meansville",
    "Milner",
    "Molena",
    "Moreland",
    "Morrow",
    "Lake City",
    "Newnan",
    "Raymond",
    "Palmetto",
    "Chatt Hills",
    "Chattahoochee Hills",
    "Peachtree City",
    "Peachtree Cty",
    "Red Oak",
    "Rex",
    "Riverdale",
    "Sargent",
    "Senoia",
    "Sharpsburg",
    "Stockbridge",
    "Sunny Side",
    "The Rock",
    "Thomaston",
    "Conley",
    "Turin",
    "Tyrone",
    "Union City",
    "Williamson",
    "Woodbury",
    "Ellenwood",
    "Zebulon",
    "Forest Park",
    "Fort Gillem",
    "Gillem Enclave",
    "Gillem Enclv",
    "Atlanta",
    "South Fulton",
    "Brookhaven",
    "Sandy Spgs",
    "Sandy Springs",
    "College Park",
    "Dunwoody",
    "Vinings",
    "Doraville",
    "Chamblee",
    "East Point",
    "Hapeville",
    "Swainsboro",
    "Covena",
    "Summertown",
    "Ailey",
    "Alamo",
    "Alston",
    "Bartow",
    "Bellville",
    "Brooklet",
    "Claxton",
    "Cobbtown",
    "Collins",
    "Daisy",
    "Garfield",
    "Girard",
    "Glennville",
    "Glenwood",
    "Hagan",
    "Louisville",
    "Lyons",
    "Oak Park",
    "Metter",
    "Midville",
    "Millen",
    "Perkins",
    "Mount Vernon",
    "Newington",
    "Nunez",
    "Oliver",
    "Portal",
    "Pulaski",
    "Register",
    "Reidsville",
    "Rockledge",
    "Rocky Ford",
    "Sardis",
    "Soperton",
    "Statesboro",
    "Stillmore",
    "Sylvania",
    "Hiltonia",
    "Tarrytown",
    "Twin City",
    "Uvalda",
    "Vidalia",
    "Wadley",
    "Gainesville",
    "Alto",
    "Baldwin",
    "Blairsville",
    "Blue Ridge",
    "Bowersville",
    "Braselton",
    "Buford",
    "Rest Haven",
    "Sugar Hill",
    "Canon",
    "Carnesville",
    "Cherry Log",
    "Clarkesville",
    "Clayton",
    "Clermont",
    "Cleveland",
    "Commerce",
    "Cornelia",
    "Dahlonega",
    "Dawsonville",
    "Demorest",
    "Ellijay",
    "Dillard",
    "Sky Valley",
    "Eastanollee",
    "East Ellijay",
    "Epworth",
    "Flowery Branch",
    "Flowery Br",
    "Gillsville",
    "Helen",
    "Hiawassee",
    "Homer",
    "Hoschton",
    "Jefferson",
    "Arcade",
    "Lakemont",
    "Lavonia",
    "Lula",
    "McCaysville",
    "Martin",
    "Avalon",
    "Maysville",
    "Mineral Bluff",
    "Morganton",
    "Mountain City",
    "Mount Airy",
    "Murrayville",
    "Nicholson",
    "Oakwood",
    "Pendergrass",
    "Rabun Gap",
    "Sautee Nacoochee",
    "Saute Nacoche",
    "Sautee",
    "Suches",
    "Tallulah Falls",
    "Tallulah Fls",
    "Talmo",
    "Tiger",
    "Toccoa",
    "Wiley",
    "Young Harris",
    "Toccoa Falls",
    "Athens",
    "Arnoldsville",
    "Bethlehem",
    "Bishop",
    "N High Shoals",
    "North High Shoals",
    "Bogart",
    "Bostwick",
    "Bowman",
    "Buckhead",
    "Carlton",
    "Colbert",
    "Comer",
    "Crawford",
    "Crawfordville",
    "Danielsville",
    "Dewy Rose",
    "Elberton",
    "Franklin Springs",
    "Franklin Spgs",
    "Good Hope",
    "Greensboro",
    "Hartwell",
    "Hull",
    "Lexington",
    "Madison",
    "Monroe",
    "Between",
    "Rayle",
    "Philomath",
    "Royston",
    "Rutledge",
    "Sharon",
    "Siloam",
    "Statham",
    "Stephens",
    "Maxeys",
    "Tignall",
    "Danburg",
    "Union Point",
    "Woodville",
    "Washington",
    "Watkinsville",
    "White Plains",
    "Winder",
    "Winterville",
    "Calhoun",
    "Chatsworth",
    "Chickamauga",
    "Cisco",
    "Cohutta",
    "Crandall",
    "Dalton",
    "Eton",
    "Flintstone",
    "Graysville",
    "La Fayette",
    "Lyerly",
    "Menlo",
    "Cloudland",
    "Plainville",
    "Ranger",
    "Resaca",
    "Ringgold",
    "Rising Fawn",
    "Rock Spring",
    "Rocky Face",
    "Rossville",
    "Fort Oglethorpe",
    "Ft Oglethorpe",
    "Sugar Valley",
    "Summerville",
    "Lookout Mountain",
    "Lookout Mtn",
    "Tennga",
    "Trenton",
    "Trion",
    "Tunnel Hill",
    "Varnell",
    "Wildwood",
    "Appling",
    "Avera",
    "Blythe",
    "Camak",
    "Dearing",
    "Evans",
    "Gibson",
    "Edge Hill",
    "Gracewood",
    "Grovetown",
    "Harlem",
    "Hephzibah",
    "Keysville",
    "Lincolnton",
    "Matthews",
    "Wrens",
    "Mitchell",
    "Norwood",
    "Stapleton",
    "Thomson",
    "Warrenton",
    "Waynesboro",
    "Augusta",
    "Fort Gordon",
    "Martinez",
    "Abbeville",
    "Adrian",
    "Allentown",
    "Bolingbroke",
    "Bonaire",
    "Butler",
    "Byromville",
    "Byron",
    "Powersville",
    "Cadwell",
    "Chauncey",
    "Chester",
    "Cochran",
    "Empire",
    "Cordele",
    "Culloden",
    "Danville",
    "Davisboro",
    "Riddleville",
    "Dexter",
    "Dry Branch",
    "Dublin",
    "Dudley",
    "Eastman",
    "Plainfield",
    "Eatonton",
    "Elko",
    "East Dublin",
    "E Dublin",
    "Centerville",
    "Forsyth",
    "Fort Valley",
    "Gordon",
    "Ivey",
    "Gray",
    "Haddock",
    "Hardwick",
    "Harrison",
    "Hawkinsville",
    "McRae Helena",
    "Helena",
    "Hillsboro",
    "Round Oak",
    "Howard",
    "Ideal",
    "Irwinton",
    "Jeffersonville",
    "Jeffersonvlle",
    "Jewell",
    "Juliette",
    "Kathleen",
    "Kite",
    "Knoxville",
    "Lilly",
    "Lizella",
    "McIntyre",
    "Mc Rae",
    "Marshallville",
    "Mauk",
    "Milan",
    "Milledgeville",
    "Montezuma",
    "Dooling",
    "Monticello",
    "Montrose",
    "Musella",
    "Oconee",
    "Oglethorpe",
    "Perry",
    "Pinehurst",
    "Pineview",
    "Pitts",
    "Rentz",
    "Reynolds",
    "Rhine",
    "Roberta",
    "Rochelle",
    "Rupert",
    "Sandersville",
    "Deepstep",
    "Scotland",
    "Seville",
    "Shady Dale",
    "Sparta",
    "Mayfield",
    "Warner Robins",
    "Tennille",
    "Toomsboro",
    "Unadilla",
    "Vienna",
    "Warthen",
    "Wrightsville",
    "Yatesville",
    "Robins A F B",
    "Robins AFB",
    "South Base",
    "Macon",
    "Huber",
    "Payne",
    "Payne City",
    "Allenhurst",
    "Bloomingdale",
    "Clyo",
    "Darien",
    "Eden",
    "Ellabell",
    "Black Creek",
    "Fleming",
    "Guyton",
    "Hinesville",
    "Flemington",
    "Fort Stewart",
    "Ludowici",
    "Meldrim",
    "Midway",
    "Pembroke",
    "Nevils",
    "Pooler",
    "Riceboro",
    "Richmond Hill",
    "Rincon",
    "Sapelo Island",
    "Tybee Island",
    "Springfield",
    "Stillwell",
    "Townsend",
    "Shellman Blf",
    "Shellman Bluff",
    "Walthourville",
    "Savannah",
    "Thunderbolt",
    "Garden City",
    "Garden Cty",
    "Vernonburg",
    "Port Wentworth",
    "Port Wentwrth",
    "Prt Wentworth",
    "Hunter Aaf",
    "Wilmington Is",
    "Wilmington Island",
    "Waycross",
    "Okefenokee",
    "Alma",
    "Ambrose",
    "Baxley",
    "Blackshear",
    "Bristol",
    "Broxton",
    "Brunswick",
    "Saint Simons Island",
    "Saint Simons Is",
    "St Simons Is",
    "St Simons Island",
    "Jekyll Island",
    "Denton",
    "Douglas",
    "Folkston",
    "Homeland",
    "Hazlehurst",
    "Hoboken",
    "Hortense",
    "Jacksonville",
    "Jesup",
    "Kings Bay",
    "Kingsland",
    "Lumber City",
    "Manor",
    "Mershon",
    "Millwood",
    "Nahunta",
    "Nicholls",
    "Odum",
    "Offerman",
    "Patterson",
    "Saint Marys",
    "Screven",
    "Sea Island",
    "Saint George",
    "Surrency",
    "Waresboro",
    "Waverly",
    "Waynesville",
    "West Green",
    "White Oak",
    "Woodbine",
    "Valdosta",
    "Adel",
    "Alapaha",
    "Argyle",
    "Axson",
    "Barney",
    "Boston",
    "Cecil",
    "Dixie",
    "Du Pont",
    "Fargo",
    "Hahira",
    "Homerville",
    "Cogdell",
    "Lakeland",
    "Lake Park",
    "Lenox",
    "Morven",
    "Nashville",
    "Naylor",
    "Pearson",
    "Quitman",
    "Ray City",
    "Sparks",
    "Statenville",
    "Stockton",
    "Willacoochee",
    "Moody Afb",
    "Albany",
    "Bridgeboro",
    "Americus",
    "Andersonville",
    "Arabi",
    "Ashburn",
    "Baconton",
    "Barwick",
    "Berlin",
    "Brookfield",
    "Camilla",
    "Chula",
    "Cobb",
    "Coolidge",
    "De Soto",
    "Doerun",
    "Ellenton",
    "Enigma",
    "Fitzgerald",
    "Funston",
    "Hartsfield",
    "Thomasville",
    "Leesburg",
    "Leslie",
    "Meigs",
    "Moultrie",
    "Riverside",
    "Norman Park",
    "Oakfield",
    "Ochlocknee",
    "Ocilla",
    "Omega",
    "Pavo",
    "Pelham",
    "Plains",
    "Poulan",
    "Rebecca",
    "Sale City",
    "Smithville",
    "Sumner",
    "Sycamore",
    "Sylvester",
    "Metcalf",
    "Tifton",
    "Abac",
    "Abraham Baldwin College",
    "Ty Ty",
    "Warwick",
    "Wray",
    "Box Springs",
    "Juniper",
    "Buena Vista",
    "Tazewell",
    "Cataula",
    "Cusseta",
    "Ellaville",
    "Ellerslie",
    "Fortson",
    "Geneva",
    "Hamilton",
    "Junction City",
    "Louvale",
    "Lumpkin",
    "Manchester",
    "Midland",
    "Omaha",
    "Pine Mountain",
    "Pine Mountain Valley",
    "Pine Mtn Vly",
    "Preston",
    "Richland",
    "Shiloh",
    "Talbotton",
    "Upatoi",
    "Columbus",
    "Warm Springs",
    "Waverly Hall",
    "Weston",
    "West Point",
    "Woodland",
    "Fort Moore",
    "Arlington",
    "Attapulgus",
    "Bainbridge",
    "Blakely",
    "Bluffton",
    "Brinson",
    "Bronwood",
    "Cairo",
    "Cedar Springs",
    "Climax",
    "Coleman",
    "Colquitt",
    "Cuthbert",
    "Damascus",
    "Dawson",
    "Donalsonville",
    "Edison",
    "Fort Gaines",
    "Georgetown",
    "Iron City",
    "Jakin",
    "Leary",
    "Morgan",
    "Morris",
    "Newton",
    "Parrott",
    "Sasser",
    "Shellman",
    "Whigham",
  ],
  GU: [
    "Hagatna",
    "Agana Heights",
    "Asan",
    "Chalan Pago",
    "Maite",
    "Mongmong",
    "Ordot",
    "Sinajana",
    "Toto",
    "Barrigada",
    "Mangilao",
    "Tamuning",
    "Santa Rita",
    "Inarajan",
    "Merizo",
    "New Inarajan",
    "Piti",
    "Talofofo",
    "Umatac",
    "Yona",
    "Agat",
    "Yigo",
    "Dededo",
  ],
  HI: [
    "Aiea",
    "Anahola",
    "Captain Cook",
    "Ocean View",
    "Eleele",
    "Ewa Beach",
    "Kapolei",
    "Haiku",
    "Hakalau",
    "Haleiwa",
    "Hana",
    "Hanalei",
    "Hanapepe",
    "Hauula",
    "Hawi",
    "Hilo",
    "Princeville",
    "Holualoa",
    "Honaunau",
    "Honokaa",
    "Paauhau",
    "Honomu",
    "Hoolehua",
    "Kaaawa",
    "Kahuku",
    "Kahului",
    "Kailua",
    "Waikoloa",
    "Kailua Kona",
    "Kalaheo",
    "Kalaupapa",
    "Kamuela",
    "Kaneohe",
    "Kapaa",
    "Kaumakani",
    "Kaunakakai",
    "Keaau",
    "Kealakekua",
    "Kealia",
    "Kekaha",
    "Kihei",
    "Wailea",
    "Kilauea",
    "Kapaau",
    "Koloa",
    "Kualapuu",
    "Kunia",
    "Kurtistown",
    "Lahaina",
    "Laie",
    "Lanai City",
    "Laupahoehoe",
    "Lawai",
    "Lihue",
    "Makawao",
    "Makaweli",
    "Maunaloa",
    "Mountain View",
    "Naalehu",
    "Ninole",
    "Ookala",
    "Paauilo",
    "Pahala",
    "Pahoa",
    "Paia",
    "Papaaloa",
    "Papaikou",
    "Pearl City",
    "Pepeekeo",
    "Volcano",
    "Wahiawa",
    "Mililani",
    "Kula",
    "Waialua",
    "Waianae",
    "Wailuku",
    "Waimanalo",
    "Waimea",
    "Waipahu",
    "Honolulu",
    "Jbphh",
    "Hickam AFB",
    "Jb Pearl Harbor Hickam",
    "Joint Base Pearl Hbr Hickam",
    "Schofield Barracks",
    "Schofield",
    "Fort Shafter",
    "Tripler Army Medical Center",
    "Tripler Amc",
    "Pearl Harbor",
    "Mcbh Kaneohe Bay",
    "Mcbh K Bay",
  ],
  IA: [
    "Ackworth",
    "Adair",
    "Adel",
    "Albion",
    "Alden",
    "Buckeye",
    "Alleman",
    "Allerton",
    "Altoona",
    "Ames",
    "Anita",
    "Ankeny",
    "Atlantic",
    "Audubon",
    "Bagley",
    "Barnes City",
    "Baxter",
    "Bayard",
    "Beaver",
    "Berwick",
    "Bevington",
    "Blairsburg",
    "Bondurant",
    "Boone",
    "Booneville",
    "Bouton",
    "Boxholm",
    "Bradford",
    "Brayton",
    "Bussey",
    "Cambridge",
    "Carlisle",
    "Casey",
    "Chariton",
    "Churdan",
    "Clemons",
    "Clio",
    "Colfax",
    "Collins",
    "Colo",
    "Columbia",
    "Coon Rapids",
    "Corydon",
    "Sewal",
    "Cumming",
    "W Des Moines",
    "Wdm",
    "West Des Moines",
    "Melcher Dallas",
    "Dallas",
    "Melcher Dal",
    "Dallas Center",
    "Dana",
    "Davis City",
    "Pleasanton",
    "Dawson",
    "Decatur",
    "Derby",
    "De Soto",
    "Dexter",
    "Dows",
    "Earlham",
    "Elkhart",
    "Ellston",
    "Beaconsfield",
    "Ellsworth",
    "Exira",
    "Ferguson",
    "Galt",
    "Garden City",
    "Garden Grove",
    "Gibson",
    "Gilbert",
    "Gilman",
    "Grand Junction",
    "Grand Jct",
    "Grand River",
    "Granger",
    "Gray",
    "Grimes",
    "Grinnell",
    "Oakland Acres",
    "Guthrie Center",
    "Guthrie Ctr",
    "Hamilton",
    "Hamlin",
    "Hartford",
    "Harvey",
    "Haverhill",
    "Hubbard",
    "Humeston",
    "Huxley",
    "Indianola",
    "Spring Hill",
    "Iowa Falls",
    "Ira",
    "Jamaica",
    "Jefferson",
    "Jewell",
    "Johnston",
    "Urbandale",
    "Kamrar",
    "Kellerton",
    "Kelley",
    "Kellogg",
    "Keswick",
    "Killduff",
    "Knoxville",
    "Pershing",
    "Lacona",
    "Lamoni",
    "Laurel",
    "Le Grand",
    "Leighton",
    "Leon",
    "Liberty Center",
    "Liberty Ctr",
    "Linden",
    "Lineville",
    "Liscomb",
    "Lorimor",
    "Lovilia",
    "Lucas",
    "Luther",
    "Lynnville",
    "McCallsburg",
    "Macksburg",
    "Madrid",
    "Malcom",
    "Marshalltown",
    "Martensdale",
    "Maxwell",
    "Melbourne",
    "Melcher",
    "Menlo",
    "Millerton",
    "Milo",
    "Minburn",
    "Mingo",
    "Mitchellville",
    "Monroe",
    "Montezuma",
    "Montour",
    "Murray",
    "Nevada",
    "New Providence",
    "New Providnce",
    "New Sharon",
    "Taintor",
    "Newton",
    "New Virginia",
    "Norwalk",
    "Churchville",
    "Ogden",
    "Osceola",
    "Otley",
    "Panora",
    "Paton",
    "Patterson",
    "Pella",
    "Perry",
    "Peru",
    "East Peru",
    "Pilot Mound",
    "Pleasantville",
    "Polk City",
    "Popejoy",
    "Prairie City",
    "Prole",
    "Radcliffe",
    "Randall",
    "Reasnor",
    "Redfield",
    "Rhodes",
    "Harvester",
    "Rippey",
    "Roland",
    "Runnells",
    "Russell",
    "Saint Anthony",
    "Saint Charles",
    "Saint Marys",
    "Searsboro",
    "Sheldahl",
    "Slater",
    "Stanhope",
    "State Center",
    "Story City",
    "Stratford",
    "Stuart",
    "Sully",
    "Swan",
    "Thayer",
    "Thornburg",
    "Tracy",
    "Truro",
    "Union",
    "Van Meter",
    "Van Wert",
    "Waukee",
    "Weldon",
    "What Cheer",
    "Whitten",
    "Williams",
    "Williamson",
    "Winterset",
    "Wiota",
    "Woodburn",
    "Woodward",
    "Yale",
    "Zearing",
    "Des Moines",
    "Beaverdale",
    "Pleasant Hill",
    "Windsor Heights",
    "Clive",
    "Windsor Hts",
    "Mason City",
    "Alexander",
    "Belmond",
    "Britt",
    "Buffalo Center",
    "Buffalo Ctr",
    "Carpenter",
    "Chapin",
    "Clear Lake",
    "Corwith",
    "Coulter",
    "Crystal Lake",
    "Dougherty",
    "Fertile",
    "Floyd",
    "Forest City",
    "Garner",
    "Goodell",
    "Grafton",
    "Hampton",
    "Hansell",
    "Hanlontown",
    "Joice",
    "Kanawha",
    "Kensett",
    "Klemme",
    "Lake Mills",
    "Lakota",
    "Latimer",
    "Leland",
    "Little Cedar",
    "McIntire",
    "Manly",
    "Meservey",
    "Nora Springs",
    "Northwood",
    "Orchard",
    "Osage",
    "Mitchell",
    "Plymouth",
    "Rake",
    "Riceville",
    "Rock Falls",
    "Rockford",
    "Rockwell",
    "Rowan",
    "Rudd",
    "Saint Ansgar",
    "Scarville",
    "Sheffield",
    "Stacyville",
    "Swaledale",
    "Thompson",
    "Thornton",
    "Titonka",
    "Ventura",
    "Wesley",
    "Woden",
    "Fort Dodge",
    "Albert City",
    "Algona",
    "Armstrong",
    "Ayrshire",
    "Badger",
    "Bancroft",
    "Barnum",
    "Bode",
    "Bradgate",
    "Burnside",
    "Burt",
    "Callender",
    "Clare",
    "Clarion",
    "Curlew",
    "Cylinder",
    "Dakota City",
    "Dayton",
    "Dolliver",
    "Duncombe",
    "Eagle Grove",
    "Early",
    "Emmetsburg",
    "Farnhamville",
    "Rinard",
    "Fenton",
    "Fonda",
    "Gilmore City",
    "Goldfield",
    "Gowrie",
    "Harcourt",
    "Hardy",
    "Havelock",
    "Humboldt",
    "Jolley",
    "Knierim",
    "Laurens",
    "Ledyard",
    "Lehigh",
    "Livermore",
    "Lone Rock",
    "Lu Verne",
    "Lytton",
    "Mallard",
    "Manson",
    "Marathon",
    "Moorland",
    "Nemaha",
    "Newell",
    "Otho",
    "Ottosen",
    "Palmer",
    "Plover",
    "Pocahontas",
    "Pomeroy",
    "Knoke",
    "Rembrandt",
    "Renwick",
    "Ringsted",
    "Rockwell City",
    "Rolfe",
    "Rutland",
    "Sac City",
    "Sioux Rapids",
    "Somers",
    "Storm Lake",
    "Lakeside",
    "Swea City",
    "Thor",
    "Truesdale",
    "Varina",
    "Vincent",
    "Webster City",
    "West Bend",
    "Whittemore",
    "Woolstock",
    "Ackley",
    "Allison",
    "Alta Vista",
    "Aplington",
    "Aredale",
    "Arlington",
    "Aurora",
    "Austinville",
    "Beaman",
    "Bristow",
    "Buckingham",
    "Cedar Falls",
    "Charles City",
    "Clarksville",
    "Colwell",
    "Conrad",
    "Denver",
    "Dewar",
    "Dike",
    "Dumont",
    "Dunkerton",
    "Eldora",
    "Elma",
    "Fairbank",
    "Fredericksburg",
    "Fredericksbrg",
    "Frederika",
    "Garwin",
    "Green Mountain",
    "Green Mtn",
    "Geneva",
    "Gilbertville",
    "Gladbrook",
    "Greene",
    "Grundy Center",
    "Hazleton",
    "Holland",
    "Hudson",
    "Voorhies",
    "Independence",
    "Ionia",
    "Janesville",
    "Jesup",
    "Kesley",
    "Lamont",
    "La Porte City",
    "Lincoln",
    "Marble Rock",
    "Masonville",
    "Maynard",
    "Morrison",
    "Nashua",
    "New Hampton",
    "N Washington",
    "North Washington",
    "New Hartford",
    "Oelwein",
    "Oran",
    "Parkersburg",
    "Plainfield",
    "Raymond",
    "Readlyn",
    "Reinbeck",
    "Shell Rock",
    "Stanley",
    "Steamboat Rock",
    "Steamboat Rk",
    "Stout",
    "Sumner",
    "Traer",
    "Tripoli",
    "Waverly",
    "Bremer",
    "Wellsburg",
    "Westgate",
    "Winthrop",
    "Waterloo",
    "Washburn",
    "Evansdale",
    "Elk Run Heights",
    "Elk Run Hgts",
    "Creston",
    "Afton",
    "Arispe",
    "Bedford",
    "Benton",
    "Blockton",
    "Maloy",
    "Bridgewater",
    "Carbon",
    "Clearfield",
    "Corning",
    "Cromwell",
    "Cumberland",
    "Diagonal",
    "Fontanelle",
    "Grant",
    "Gravity",
    "Greenfield",
    "Lenox",
    "Kent",
    "Massena",
    "Mount Ayr",
    "Nodaway",
    "Orient",
    "Prescott",
    "Redding",
    "Delphos",
    "Shannon City",
    "Sharpsburg",
    "Tingley",
    "Villisca",
    "Akron",
    "Alta",
    "Alton",
    "Anthon",
    "Aurelia",
    "Battle Creek",
    "Bronson",
    "Brunsville",
    "Calumet",
    "Castana",
    "Chatsworth",
    "Cherokee",
    "Cleghorn",
    "Climbing Hill",
    "Correctionville",
    "Correctionvle",
    "Cushing",
    "Danbury",
    "Galva",
    "Granville",
    "Hawarden",
    "Hinton",
    "Holstein",
    "Hornick",
    "Ireton",
    "Kingsley",
    "Larrabee",
    "Lawton",
    "Le Mars",
    "Struble",
    "Linn Grove",
    "Mapleton",
    "Marcus",
    "Maurice",
    "Meriden",
    "Merrill",
    "Moville",
    "Onawa",
    "Turin",
    "Orange City",
    "Oto",
    "Oyens",
    "Paullina",
    "Peterson",
    "Pierson",
    "Quimby",
    "Remsen",
    "Rodney",
    "Salix",
    "Schaller",
    "Sergeant Bluff",
    "Sergeant Blf",
    "Sloan",
    "Smithland",
    "Sutherland",
    "Ute",
    "Washta",
    "Westfield",
    "Whiting",
    "Sioux City",
    "Sheldon",
    "Alvord",
    "Archer",
    "Ashton",
    "Boyden",
    "Doon",
    "George",
    "Hospers",
    "Hull",
    "Inwood",
    "Larchwood",
    "Lester",
    "Little Rock",
    "Matlock",
    "Primghar",
    "Rock Rapids",
    "Rock Valley",
    "Sanborn",
    "Sibley",
    "Sioux Center",
    "Spencer",
    "Arnolds Park",
    "Dickens",
    "Estherville",
    "Gruver",
    "Everly",
    "Fostoria",
    "Gillett Grove",
    "Graettinger",
    "Greenville",
    "Harris",
    "Hartley",
    "Lake Park",
    "Melvin",
    "Milford",
    "Ocheyedan",
    "Allendorf",
    "May City",
    "Okoboji",
    "Royal",
    "Rossie",
    "Ruthven",
    "Spirit Lake",
    "Orleans",
    "Superior",
    "Terril",
    "Wallingford",
    "Webb",
    "Carroll",
    "Arcadia",
    "Arthur",
    "Aspinwall",
    "Auburn",
    "Yetter",
    "Breda",
    "Charter Oak",
    "Dedham",
    "Deloit",
    "Denison",
    "Glidden",
    "Halbur",
    "Ida Grove",
    "Irwin",
    "Kirkman",
    "Kiron",
    "Lake City",
    "Lake View",
    "Carnarvon",
    "Lanesboro",
    "Lidderdale",
    "Lohrville",
    "Manilla",
    "Manning",
    "Odebolt",
    "Ralston",
    "Ricketts",
    "Schleswig",
    "Scranton",
    "Templeton",
    "Vail",
    "Wall Lake",
    "Westside",
    "Council Bluffs",
    "Council Blfs",
    "Manawa",
    "Carter Lake",
    "Arion",
    "Avoca",
    "Blencoe",
    "Carson",
    "Crescent",
    "Defiance",
    "Dow City",
    "Dunlap",
    "Earling",
    "Elk Horn",
    "Elliott",
    "Emerson",
    "Glenwood",
    "Griswold",
    "Hancock",
    "Harlan",
    "Tennant",
    "Hastings",
    "Henderson",
    "Honey Creek",
    "Kimballton",
    "Lewis",
    "Little Sioux",
    "Logan",
    "McClelland",
    "Macedonia",
    "Magnolia",
    "Malvern",
    "Marne",
    "Minden",
    "Mineola",
    "Missouri Valley",
    "Missouri Vly",
    "Mo Valley",
    "Modale",
    "Mondamin",
    "Moorhead",
    "Neola",
    "Oakland",
    "Pacific Junction",
    "Pacific Jct",
    "Panama",
    "Persia",
    "Pisgah",
    "Portsmouth",
    "Red Oak",
    "Shelby",
    "Silver City",
    "Soldier",
    "Stanton",
    "Treynor",
    "Underwood",
    "Walnut",
    "Westphalia",
    "Woodbine",
    "Shenandoah",
    "Blanchard",
    "Braddyville",
    "Clarinda",
    "Coin",
    "College Springs",
    "College Sprgs",
    "Essex",
    "Farragut",
    "Hamburg",
    "Imogene",
    "New Market",
    "Northboro",
    "Percival",
    "Randolph",
    "Riverton",
    "Shambaugh",
    "Sidney",
    "Tabor",
    "Thurman",
    "Bartlett",
    "Yorktown",
    "Dubuque",
    "Asbury",
    "Andrew",
    "Bellevue",
    "Bernard",
    "Cascade",
    "Colesburg",
    "Delaware",
    "Delmar",
    "Dundee",
    "Durango",
    "Dyersville",
    "Earlville",
    "Edgewood",
    "Littleport",
    "Elkader",
    "Elkport",
    "Epworth",
    "Farley",
    "Farmersburg",
    "Garber",
    "Garnavillo",
    "Clayton",
    "Greeley",
    "Guttenberg",
    "Holy Cross",
    "La Motte",
    "Luxemburg",
    "Manchester",
    "Maquoketa",
    "Miles",
    "Green Island",
    "New Vienna",
    "North Buena Vista",
    "N Buena Vista",
    "Peosta",
    "Preston",
    "Sabula",
    "Saint Donatus",
    "Saint Olaf",
    "Sherrill",
    "Spragueville",
    "Springbrook",
    "Strawberry Point",
    "Strawberry Pt",
    "Volga",
    "Worthington",
    "Zwingle",
    "Decorah",
    "Burr Oak",
    "Calmar",
    "Castalia",
    "Chester",
    "Clermont",
    "Cresco",
    "Dorchester",
    "Elgin",
    "Fayette",
    "Fort Atkinson",
    "Festina",
    "Harpers Ferry",
    "Hawkeye",
    "Lansing",
    "Lawler",
    "Lime Springs",
    "Saratoga",
    "Luana",
    "McGregor",
    "Marquette",
    "Monona",
    "New Albin",
    "Ossian",
    "Postville",
    "Protivin",
    "Randalia",
    "Ridgeway",
    "Saint Lucas",
    "Spillville",
    "Wadena",
    "Waterville",
    "Waucoma",
    "Alpha",
    "Jackson Jct",
    "Jackson Junction",
    "Waukon",
    "West Union",
    "Auburn Douglas",
    "Douglas",
    "Eldorado",
    "Ainsworth",
    "Alburnett",
    "Amana",
    "West Amana",
    "Anamosa",
    "Atkins",
    "Baldwin",
    "Belle Plaine",
    "Blairstown",
    "Brandon",
    "Brooklyn",
    "Center Junction",
    "Center Jct",
    "Center Point",
    "Central City",
    "Chelsea",
    "Clarence",
    "Clutier",
    "Coggon",
    "Prairieburg",
    "Conroy",
    "Guernsey",
    "Deep River",
    "Delhi",
    "Dysart",
    "Elberon",
    "Ely",
    "Fairfax",
    "Garrison",
    "Harper",
    "Hartwick",
    "Hiawatha",
    "Hills",
    "Homestead",
    "Hopkinton",
    "Iowa City",
    "Coralville",
    "Oakdale",
    "Kalona",
    "Keota",
    "Keystone",
    "Ladora",
    "Langworthy",
    "Lisbon",
    "Lost Nation",
    "Elwood",
    "Lowden",
    "Luzerne",
    "Marengo",
    "Marion",
    "Martelle",
    "Mechanicsville",
    "Mechanicsvlle",
    "Middle Amana",
    "Middle",
    "Millersburg",
    "Monmouth",
    "Monticello",
    "Scotch Grove",
    "Morley",
    "Mount Auburn",
    "Mount Vernon",
    "Newhall",
    "North English",
    "North Liberty",
    "Norway",
    "Olin",
    "Onslow",
    "Oxford",
    "Oxford Junction",
    "Oxford Jct",
    "Palo",
    "Parnell",
    "Quasqueton",
    "Riverside",
    "Robins",
    "Rowley",
    "Ryan",
    "Shellsburg",
    "Solon",
    "South Amana",
    "South English",
    "Kinross",
    "Springville",
    "Viola",
    "Whittier",
    "Stanwood",
    "Swisher",
    "Shueyville",
    "Tama",
    "Tiffin",
    "Toddville",
    "Toledo",
    "Troy Mills",
    "Urbana",
    "Van Horne",
    "Victor",
    "Vining",
    "Vinton",
    "Walford",
    "Walker",
    "Washington",
    "Watkins",
    "Webster",
    "Wellman",
    "West Branch",
    "West Chester",
    "Williamsburg",
    "Wyoming",
    "Hale",
    "Cedar Rapids",
    "Bertram",
    "Ottumwa",
    "Agency",
    "Albia",
    "Hiteman",
    "Batavia",
    "Beacon",
    "Birmingham",
    "Blakesburg",
    "Bloomfield",
    "West Grove",
    "Brighton",
    "Cantril",
    "Cedar",
    "Centerville",
    "Numa",
    "Rathbun",
    "Chillicothe",
    "Cincinnati",
    "Delta",
    "Douds",
    "Drakesville",
    "Eddyville",
    "Eldon",
    "Exline",
    "Fairfield",
    "Maharishi Vedic City",
    "Vedic City",
    "Floris",
    "Fremont",
    "Hayesville",
    "Hedrick",
    "Keosauqua",
    "Kirkville",
    "Libertyville",
    "Martinsburg",
    "Melrose",
    "Milton",
    "Moravia",
    "Moulton",
    "Mount Sterling",
    "Mt Sterling",
    "Mystic",
    "Ollie",
    "Oskaloosa",
    "Keomah Village",
    "Keomah Vlg",
    "Packwood",
    "Plano",
    "Promise City",
    "Pulaski",
    "Richland",
    "Rubio",
    "Rose Hill",
    "Selma",
    "Seymour",
    "Sigourney",
    "Udell",
    "Unionville",
    "University Park",
    "University Pk",
    "Burlington",
    "Argyle",
    "Bonaparte",
    "Crawfordsville",
    "Crawfordsvlle",
    "Danville",
    "Denmark",
    "Donnellson",
    "Farmington",
    "Fort Madison",
    "Hillsboro",
    "Houghton",
    "Keokuk",
    "Lockridge",
    "Mediapolis",
    "Middletown",
    "Montrose",
    "Morning Sun",
    "Mount Pleasant",
    "Mt Pleasant",
    "Mount Union",
    "Mt Union",
    "New London",
    "Lowell",
    "Oakville",
    "Olds",
    "Salem",
    "Sperry",
    "Stockport",
    "Swedesburg",
    "Wapello",
    "Wayland",
    "West Burlington",
    "W Burlington",
    "West Point",
    "Saint Paul",
    "Wever",
    "Winfield",
    "Yarmouth",
    "Andover",
    "Atalissa",
    "Bennett",
    "Bettendorf",
    "Riverdale",
    "Blue Grass",
    "Bryant",
    "Buffalo",
    "Calamus",
    "Camanche",
    "Charlotte",
    "Clinton",
    "Columbus City",
    "Columbus Junction",
    "Columbus Jct",
    "Conesville",
    "De Witt",
    "Dixon",
    "Big Rock",
    "Donahue",
    "Durant",
    "Eldridge",
    "Fruitland",
    "Goose Lake",
    "Grand Mound",
    "Grandview",
    "Le Claire",
    "Leclaire",
    "Letts",
    "Lone Tree",
    "Long Grove",
    "Low Moor",
    "McCausland",
    "Montpelier",
    "Moscow",
    "Muscatine",
    "New Liberty",
    "Nichols",
    "Pleasant Valley",
    "Pleasant Vly",
    "Princeton",
    "Stockton",
    "Teeds Grove",
    "Tipton",
    "Walcott",
    "Maysville",
    "Welton",
    "West Liberty",
    "Wheatland",
    "Toronto",
    "Wilton",
    "Davenport",
  ],
  ID: [
    "Pocatello",
    "Chubbuck",
    "Fort Hall",
    "Aberdeen",
    "Sterling",
    "American Falls",
    "Am Falls",
    "American Fls",
    "Arbon",
    "Arco",
    "Butte City",
    "Arimo",
    "Atomic City",
    "Bancroft",
    "Basalt",
    "Bern",
    "Blackfoot",
    "Bloomington",
    "Challis",
    "Clayton",
    "Clifton",
    "Oxford",
    "Dayton",
    "Dingle",
    "Downey",
    "Ellis",
    "Firth",
    "Franklin",
    "Geneva",
    "Georgetown",
    "Grace",
    "Holbrook",
    "Howe",
    "Inkom",
    "Lava Hot Springs",
    "Lava Hot Spgs",
    "Mccammon",
    "Mackay",
    "Malad City",
    "Stone",
    "May",
    "Patterson",
    "Montpelier",
    "Bennington",
    "Ovid",
    "Moore",
    "Darlington",
    "Lost River",
    "Paris",
    "Pingree",
    "Preston",
    "Rockland",
    "Saint Charles",
    "Shelley",
    "Soda Springs",
    "Springfield",
    "Stanley",
    "Swanlake",
    "Thatcher",
    "Wayan",
    "Weston",
    "Fish Haven",
    "Twin Falls",
    "Hollister",
    "Rogerson",
    "Albion",
    "Almo",
    "Bellevue",
    "East Magic",
    "Gannett",
    "Bliss",
    "Buhl",
    "Burley",
    "Carey",
    "Castleford",
    "Corral",
    "Fairfield",
    "Declo",
    "Dietrich",
    "Shoshone",
    "Eden",
    "Filer",
    "Gooding",
    "Hagerman",
    "Hailey",
    "Triumph",
    "Hansen",
    "Hazelton",
    "Heyburn",
    "Hill City",
    "Jerome",
    "Ketchum",
    "Sawtooth City",
    "Kimberly",
    "Malta",
    "Elba",
    "Murtaugh",
    "Oakley",
    "Paul",
    "Picabo",
    "Richfield",
    "Rupert",
    "Acequia",
    "Jackson",
    "Minidoka",
    "Lone Star",
    "West Magic",
    "Sun Valley",
    "Elk Horn",
    "Wendell",
    "Idaho Falls",
    "Ammon",
    "Ashton",
    "Chester",
    "Driggs",
    "Dubois",
    "Felt",
    "Tetonia",
    "Hamer",
    "Iona",
    "Irwin",
    "Palisades",
    "Island Park",
    "Lewisville",
    "Macks Inn",
    "Menan",
    "Monteview",
    "Newdale",
    "Parker",
    "Rexburg",
    "Rigby",
    "Ririe",
    "Roberts",
    "Saint Anthony",
    "Spencer",
    "Sugar City",
    "Swan Valley",
    "Terreton",
    "Teton",
    "Ucon",
    "Victor",
    "Carmen",
    "Gibbonsville",
    "Leadore",
    "Lemhi",
    "North Fork",
    "Salmon",
    "Tendoy",
    "Shoup",
    "Lewiston",
    "Ahsahka",
    "Cottonwood",
    "Keuterville",
    "Craigmont",
    "Culdesac",
    "Elk City",
    "Dixie",
    "Ferdinand",
    "Grangeville",
    "Greencreek",
    "Juliaetta",
    "Kamiah",
    "Kendrick",
    "Kooskia",
    "Lapwai",
    "Spalding",
    "Lenore",
    "Lucile",
    "Nezperce",
    "Orofino",
    "Peck",
    "Pierce",
    "Headquarters",
    "Pollock",
    "Reubens",
    "Riggins",
    "Stites",
    "Clearwater",
    "Harpster",
    "Weippe",
    "White Bird",
    "Winchester",
    "Banks",
    "Bruneau",
    "Grasmere",
    "Riddle",
    "Caldwell",
    "Cambridge",
    "Cascade",
    "Council",
    "Fruitvale",
    "Donnelly",
    "Tamarack",
    "Eagle",
    "Emmett",
    "Montour",
    "Fruitland",
    "Garden Valley",
    "Glenns Ferry",
    "Grand View",
    "Greenleaf",
    "Hammett",
    "Homedale",
    "Horseshoe Bend",
    "Horseshoe Bnd",
    "Idaho City",
    "Centerville",
    "New Centerville",
    "Pioneerville",
    "Star Ranch",
    "Steirman",
    "Indian Valley",
    "King Hill",
    "Kuna",
    "Letha",
    "Lowman",
    "Mccall",
    "Marsing",
    "Melba",
    "Meridian",
    "Mesa",
    "Middleton",
    "Midvale",
    "Nampa",
    "Mountain Home",
    "Anderson Dam",
    "Featherville",
    "Mt Home",
    "Mtn Home",
    "Oasis",
    "Paradise Hot",
    "Paradise Hot Springs",
    "Pine",
    "Prairie",
    "Rocky Bar",
    "Tipanuk",
    "Mountain Home Afb",
    "Mtn Home AFB",
    "Murphy",
    "Oreana",
    "New Meadows",
    "New Plymouth",
    "Notus",
    "Ola",
    "Parma",
    "Payette",
    "Placerville",
    "Star",
    "Sweet",
    "Weiser",
    "Wilder",
    "Yellow Pine",
    "Boise",
    "Garden City",
    "Hidden Spgs",
    "Hidden Springs",
    "Atlanta",
    "Athol",
    "Avery",
    "Bayview",
    "Blanchard",
    "Bonners Ferry",
    "Bovill",
    "Calder",
    "Careywood",
    "Cataldo",
    "Clark Fork",
    "Clarkia",
    "Cocolalla",
    "Coeur D Alene",
    "Fernan Lake Village",
    "Fernan Lk Vlg",
    "Dalton Gardens",
    "Dalton Gdns",
    "Huetter",
    "Coolin",
    "Oldtown",
    "Deary",
    "Desmet",
    "Dover",
    "Eastport",
    "Elk River",
    "Fernwood",
    "Genesee",
    "Harrison",
    "Harvard",
    "Hayden",
    "Hayden Lake",
    "Hope",
    "Kellogg",
    "Wardner",
    "Kingston",
    "Kootenai",
    "Laclede",
    "Medimont",
    "Moscow",
    "Moyie Springs",
    "Mullan",
    "Naples",
    "Nordman",
    "Osburn",
    "Pinehurst",
    "Plummer",
    "Ponderay",
    "Post Falls",
    "Hauser",
    "Potlatch",
    "Onaway",
    "Priest River",
    "Priest Lake",
    "Princeton",
    "Rathdrum",
    "Twin Lakes",
    "Sagle",
    "Saint Maries",
    "St Maries",
    "Sandpoint",
    "Santa",
    "Silverton",
    "Smelterville",
    "Spirit Lake",
    "Tensed",
    "Troy",
    "Viola",
    "Wallace",
    "Prichard",
    "Murray",
    "Worley",
  ],
  IL: [
    "Antioch",
    "Old Mill Creek",
    "Old Mill Crk",
    "Arlington Heights",
    "Arlington Hts",
    "Elk Grove Village",
    "Elk Grove Vlg",
    "Rolling Meadows",
    "Rolling Mdws",
    "Barrington",
    "Deer Park",
    "Fox River Valley Gardens",
    "Fox Rv Vly Gn",
    "Hoffman Est",
    "Hoffman Estates",
    "Inverness",
    "Kildeer",
    "Lake Barrington",
    "Lk Barrington",
    "N Barrington",
    "North Barrington",
    "Port Barrington",
    "Pt Barrington",
    "S Barrington",
    "South Barrington",
    "Tower Lakes",
    "Crystal Lake",
    "Bull Valley",
    "Prairie Grove",
    "Cary",
    "Oakwood Hills",
    "Trout Valley",
    "Village Of Lakewood",
    "Vlg Of Lakewd",
    "Deerfield",
    "Bannockburn",
    "Riverwoods",
    "Des Plaines",
    "Rosemont",
    "Fox Lake",
    "Volo",
    "Fox River Grove",
    "Fox River Grv",
    "Glencoe",
    "Glenview",
    "Golf",
    "Grayslake",
    "Gages Lake",
    "Hainesville",
    "Third Lake",
    "Gurnee",
    "Harvard",
    "Hebron",
    "Highland Park",
    "Highwood",
    "Ingleside",
    "Island Lake",
    "Kenilworth",
    "Lake Bluff",
    "Lake Forest",
    "Mettawa",
    "Lake Villa",
    "Lindenhurst",
    "Lake Zurich",
    "Hawthorn Wds",
    "Hawthorn Woods",
    "Long Grove",
    "Libertyville",
    "Mchenry",
    "Holiday Hills",
    "Johnsburg",
    "Lakemoor",
    "Mccullom Lake",
    "Morton Grove",
    "Mount Prospect",
    "Mt Prospect",
    "Mundelein",
    "Vernon Hills",
    "Indian Creek",
    "Northbrook",
    "North Chicago",
    "Abbott Park",
    "Downey",
    "Palatine",
    "Park Ridge",
    "Lincolnshire",
    "Prairie View",
    "Prairieview",
    "Prospect Heights",
    "Prospect Hts",
    "Richmond",
    "Solon Mills",
    "Ringwood",
    "Round Lake",
    "Round Lake Beach",
    "Round Lake Heights",
    "Round Lake Park",
    "Round Lake Pk",
    "Round Lk Bch",
    "Round Lk Hts",
    "Round Lk Park",
    "Russell",
    "Skokie",
    "Spring Grove",
    "Wadsworth",
    "Beach Park",
    "Wauconda",
    "Waukegan",
    "Park City",
    "Great Lakes",
    "Buffalo Grove",
    "Wheeling",
    "Wilmette",
    "Winnetka",
    "Northfield",
    "Winthrop Harbor",
    "Winthrop Hbr",
    "Wonder Lake",
    "Woodstock",
    "Zion",
    "Addison",
    "Algonquin",
    "Lake In The Hills",
    "Lk In The Hls",
    "Bartlett",
    "Ontarioville",
    "Bellwood",
    "Bensenville",
    "Streamwood",
    "Bloomingdale",
    "Glendale Heights",
    "Glendale Hts",
    "Burlington",
    "Carpentersville",
    "Carpentersvle",
    "Clare",
    "Cortland",
    "Creston",
    "Dekalb",
    "Dundee",
    "East Dundee",
    "Sleepy Hollow",
    "West Dundee",
    "Elburn",
    "Campton Hills",
    "Elgin",
    "Plato Center",
    "South Elgin",
    "Elmhurst",
    "Esmond",
    "Forest Park",
    "Franklin Park",
    "Schiller Park",
    "Hanover Park",
    "Geneva",
    "Genoa",
    "Gilberts",
    "Glen Ellyn",
    "Hampshire",
    "Pingree Grove",
    "Hines",
    "Huntley",
    "Itasca",
    "Kaneville",
    "Kingston",
    "Kirkland",
    "Fairdale",
    "Lombard",
    "Malta",
    "Maple Park",
    "Virgil",
    "Marengo",
    "Maywood",
    "Broadview",
    "Westchester",
    "Medinah",
    "Melrose Park",
    "Hillside",
    "Berkeley",
    "Northlake",
    "Stone Park",
    "River Grove",
    "Roselle",
    "Schaumburg",
    "Saint Charles",
    "St Charles",
    "Sycamore",
    "Union",
    "Villa Park",
    "Oakbrook Ter",
    "Oakbrook Terrace",
    "Wasco",
    "Wayne",
    "West Chicago",
    "Northwoods",
    "Wheaton",
    "Carol Stream",
    "Winfield",
    "Wood Dale",
    "Evanston",
    "Oak Park",
    "River Forest",
    "Beecher",
    "Berwyn",
    "Forest View",
    "Stickney",
    "Crest Hill",
    "Joliet",
    "Shorewood",
    "Blue Island",
    "Braceville",
    "Godley",
    "Braidwood",
    "Calumet City",
    "Channahon",
    "Chicago Heights",
    "Chicago Hts",
    "Ford Heights",
    "Lynwood",
    "S Chicago Hei",
    "S Chicago Heights",
    "S Chicago Hts",
    "Sauk Village",
    "South Chicago Heights",
    "Chicago Ridge",
    "Coal City",
    "Carbon Hill",
    "Diamond",
    "Crete",
    "Crestwood",
    "Dolton",
    "Dwight",
    "Elwood",
    "Flossmoor",
    "Homewood",
    "Frankfort",
    "Gardner",
    "Glenwood",
    "Harvey",
    "Dixmoor",
    "Markham",
    "Phoenix",
    "Hazel Crest",
    "E Hazel Crest",
    "East Hazel Crest",
    "Rockdale",
    "Kinsman",
    "Lansing",
    "Lemont",
    "Bolingbrook",
    "Lockport",
    "Homer Glen",
    "Manhattan",
    "Wilton Center",
    "Matteson",
    "Mazon",
    "Midlothian",
    "Romeoville",
    "Minooka",
    "Mokena",
    "Monee",
    "Morris",
    "New Lenox",
    "Oak Forest",
    "Oak Lawn",
    "Bridgeview",
    "Bedford Park",
    "Hometown",
    "Hickory Hills",
    "Justice",
    "Burbank",
    "Odell",
    "Olympia Fields",
    "Olympia Flds",
    "Orland Park",
    "Palos Heights",
    "Palos Park",
    "Palos Hills",
    "Park Forest",
    "University Park",
    "University Pk",
    "Peotone",
    "Posen",
    "Ransom",
    "Richton Park",
    "Robbins",
    "South Holland",
    "South Wilmington",
    "S Wilmington",
    "Steger",
    "Thornton",
    "Tinley Park",
    "Orland Hills",
    "Country Club Hills",
    "Cntry Clb Hls",
    "Ctry Clb Hls",
    "Verona",
    "Willow Springs",
    "Willow Spgs",
    "Wilmington",
    "Custer Park",
    "Worth",
    "Summit Argo",
    "Argo",
    "Summit",
    "Aurora",
    "Batavia",
    "Big Rock",
    "Bristol",
    "Brookfield",
    "Clarendon Hills",
    "Clarendon Hls",
    "Downers Grove",
    "Woodridge",
    "Earlville",
    "Eola",
    "Hinckley",
    "Hinsdale",
    "Oak Brk Mall",
    "Oak Brook",
    "Oak Brook Mall",
    "La Grange",
    "Countryside",
    "Hodgkins",
    "Ind Head Park",
    "Ind Head Pk",
    "Indian Head Park",
    "Indian Head Pk",
    "Indianhead Pk",
    "La Grange Highlands",
    "Lagrange Hlds",
    "Mc Cook",
    "La Grange Park",
    "La Grange Pk",
    "Willowbrook",
    "Burr Ridge",
    "Lee",
    "Leland",
    "Lisle",
    "Lyons",
    "Millbrook",
    "Millington",
    "Montgomery",
    "Montgmry",
    "Mooseheart",
    "Naperville",
    "Newark",
    "North Aurora",
    "Oswego",
    "Plainfield",
    "Plano",
    "Riverside",
    "N Riverside",
    "North Riverside",
    "Sandwich",
    "Serena",
    "Shabbona",
    "Sheridan",
    "Somonauk",
    "Steward",
    "Sugar Grove",
    "Warrenville",
    "Waterman",
    "Wedron",
    "Western Springs",
    "Western Sprgs",
    "Westmont",
    "Yorkville",
    "Darien",
    "Chicago",
    "Jefferson Park",
    "Jefferson Pk",
    "Burnham",
    "Calumet Park",
    "Lincolnwood",
    "Merrionett Pk",
    "Merrionette Park",
    "Harwood Heights",
    "Harwood Hts",
    "Norridge",
    "Elmwood Park",
    "Niles",
    "Alsip",
    "Cicero",
    "Evergreen Park",
    "Evergreen Pk",
    "Riverdale",
    "Kankakee",
    "Irwin",
    "Aroma Park",
    "Ashkum",
    "Beaverville",
    "Bonfield",
    "Bourbonnais",
    "Bradley",
    "Buckingham",
    "Buckley",
    "Cabery",
    "Campus",
    "Chatsworth",
    "Chebanse",
    "Sammons Point",
    "Cissna Park",
    "Claytonville",
    "Clifton",
    "Crescent City",
    "Cullom",
    "Danforth",
    "Donovan",
    "East Lynn",
    "Elliott",
    "Emington",
    "Essex",
    "Gibson City",
    "Gilman",
    "Goodwine",
    "Grant Park",
    "Herscher",
    "Hoopeston",
    "Iroquois",
    "Kempton",
    "Loda",
    "Ludlow",
    "Manteno",
    "Martinton",
    "Melvin",
    "Milford",
    "Momence",
    "Onarga",
    "Papineau",
    "Paxton",
    "Pembroke Township",
    "Pembroke Twp",
    "Piper City",
    "Rankin",
    "Clarence",
    "Reddick",
    "Roberts",
    "Rossville",
    "Saint Anne",
    "Sun River Ter",
    "Sun River Terrace",
    "Sheldon",
    "Stockland",
    "Thawville",
    "Union Hill",
    "Watseka",
    "Wellington",
    "Woodland",
    "Apple River",
    "Ashton",
    "Baileyville",
    "Belvidere",
    "Byron",
    "Caledonia",
    "Machesney Park",
    "Machesney Pk",
    "Capron",
    "Cedarville",
    "Chadwick",
    "Chana",
    "Cherry Valley",
    "Dakota",
    "Davis",
    "Davis Junction",
    "Davis Jct",
    "Dixon",
    "Nelson",
    "Durand",
    "East Dubuque",
    "Eleroy",
    "Elizabeth",
    "Forreston",
    "Franklin Grove",
    "Franklin Grv",
    "Freeport",
    "Scioto Mills",
    "Galena",
    "Galt",
    "Garden Prairie",
    "Garden Pr",
    "German Valley",
    "Hanover",
    "Harmon",
    "Holcomb",
    "Kent",
    "Lanark",
    "Leaf River",
    "Egan",
    "Lena",
    "Lindenwood",
    "McConnell",
    "Milledgeville",
    "Monroe Center",
    "Mount Carroll",
    "Mount Morris",
    "Nachusa",
    "Nora",
    "Orangeville",
    "Oregon",
    "Pearl City",
    "Pecatonica",
    "Polo",
    "Poplar Grove",
    "Ridott",
    "Rochelle",
    "Kings",
    "Rock City",
    "Rock Falls",
    "Rockton",
    "Roscoe",
    "Savanna",
    "Scales Mound",
    "Seward",
    "Shannon",
    "Shirland",
    "South Beloit",
    "Sterling",
    "Coleta",
    "Stillman Valley",
    "Stillman Vly",
    "Stockton",
    "Warren",
    "Winnebago",
    "Winslow",
    "Woosung",
    "Rockford",
    "Loves Park",
    "Rock Island",
    "Albany",
    "Aledo",
    "Andalusia",
    "Andover",
    "Annawan",
    "Atkinson",
    "Barstow",
    "Buffalo Prairie",
    "Buffalo Pr",
    "Cambridge",
    "Carbon Cliff",
    "Coal Valley",
    "Colona",
    "Cleveland",
    "Green Rock",
    "Cordova",
    "Deer Grove",
    "East Moline",
    "Erie",
    "Fenton",
    "Fulton",
    "Geneseo",
    "Hampton",
    "Hillsdale",
    "Hooppole",
    "Illinois City",
    "Joy",
    "Lyndon",
    "Lynn Center",
    "Matherville",
    "Milan",
    "Oak Grove",
    "Moline",
    "Morrison",
    "New Boston",
    "Orion",
    "Osco",
    "Port Byron",
    "Preemption",
    "Prophetstown",
    "Rapids City",
    "Reynolds",
    "Sherrard",
    "Silvis",
    "Tampico",
    "Taylor Ridge",
    "Thomson",
    "La Salle",
    "Amboy",
    "Ancona",
    "Streator",
    "Arlington",
    "Blackstone",
    "Buda",
    "Bureau",
    "Cedar Point",
    "Cherry",
    "Compton",
    "Cornell",
    "Manville",
    "Dalzell",
    "Dana",
    "Depue",
    "Dover",
    "Eldena",
    "Grand Ridge",
    "Granville",
    "Hennepin",
    "Kasbeer",
    "Ladd",
    "La Moille",
    "Lee Center",
    "Leonore",
    "Long Point",
    "Lostant",
    "McNabb",
    "Magnolia",
    "Malden",
    "Manlius",
    "Mark",
    "Marseilles",
    "Mendota",
    "Mineral",
    "Neponset",
    "New Bedford",
    "Oglesby",
    "Ohio",
    "Ottawa",
    "Paw Paw",
    "Peru",
    "Princeton",
    "Hollowayville",
    "Rutland",
    "Seatonville",
    "Seneca",
    "Sheffield",
    "Spring Valley",
    "Standard",
    "Sublette",
    "Tiskilwa",
    "Toluca",
    "Tonica",
    "Triumph",
    "Troy Grove",
    "Utica",
    "Van Orin",
    "Varna",
    "Walnut",
    "Normandy",
    "Wenona",
    "West Brooklyn",
    "Wyanet",
    "Galesburg",
    "Abingdon",
    "Adair",
    "Alexis",
    "Alpha",
    "Altona",
    "Avon",
    "Bardolph",
    "Berwick",
    "Biggsville",
    "Bishop Hill",
    "Blandinsville",
    "Bradford",
    "Bushnell",
    "Cameron",
    "Camp Grove",
    "Carman",
    "Castleton",
    "Cuba",
    "Dahinda",
    "East Galesburg",
    "E Galesburg",
    "Ellisville",
    "Fairview",
    "Fiatt",
    "Galva",
    "Gerlaw",
    "Gilson",
    "Delong",
    "Gladstone",
    "Good Hope",
    "Henderson",
    "Industry",
    "Ipava",
    "Keithsburg",
    "Kewanee",
    "Kirkwood",
    "Knoxville",
    "La Fayette",
    "La Harpe",
    "Laura",
    "Littleton",
    "Little York",
    "Lomax",
    "Macomb",
    "Maquon",
    "Marietta",
    "Media",
    "Monmouth",
    "New Windsor",
    "North Henderson",
    "N Henderson",
    "Oneida",
    "Ophiem",
    "Oquawka",
    "Prairie City",
    "Raritan",
    "Rio",
    "Roseville",
    "Saint Augustine",
    "St Augustine",
    "Sciota",
    "Seaton",
    "Smithfield",
    "Smithshire",
    "Speer",
    "Stronghurst",
    "Table Grove",
    "Toulon",
    "Vermont",
    "Victoria",
    "Viola",
    "Wataga",
    "Williamsfield",
    "Woodhull",
    "Wyoming",
    "Astoria",
    "Benson",
    "Brimfield",
    "Bryant",
    "Canton",
    "Banner",
    "Chillicothe",
    "Dunfermline",
    "Dunlap",
    "Edelstein",
    "Edwards",
    "Elmwood",
    "Eureka",
    "Farmington",
    "Middlegrove",
    "Forest City",
    "Glasford",
    "Green Valley",
    "Groveland",
    "Hanna City",
    "Henry",
    "Kingston Mines",
    "Kingston Mine",
    "Lacon",
    "La Rose",
    "Lewistown",
    "Liverpool",
    "London Mills",
    "Lowpoint",
    "Cazenovia",
    "Manito",
    "Mapleton",
    "Metamora",
    "Germantown Hills",
    "Germantwn Hls",
    "Morton",
    "Mossville",
    "Norris",
    "Pekin",
    "Marquette Heights",
    "Marquette Hts",
    "North Pekin",
    "Princeville",
    "Putnam",
    "Roanoke",
    "Rome",
    "Saint David",
    "South Pekin",
    "Sparland",
    "Hopewell",
    "Topeka",
    "Tremont",
    "Trivoli",
    "Washburn",
    "Washington",
    "Yates City",
    "Peoria",
    "Bellevue",
    "West Peoria",
    "Bartonville",
    "Creve Coeur",
    "East Peoria",
    "Bayview Gardens",
    "Bayview Gdns",
    "Spring Bay",
    "Peoria Heights",
    "Peoria Hts",
    "Bloomington",
    "Anchor",
    "Armington",
    "Arrowsmith",
    "Atlanta",
    "Bellflower",
    "Carlock",
    "Chenoa",
    "Clinton",
    "Colfax",
    "Congerville",
    "Cooksville",
    "Cropsey",
    "Danvers",
    "Deer Creek",
    "Delavan",
    "Dewitt",
    "De Witt",
    "Downs",
    "Holder",
    "Ellsworth",
    "El Paso",
    "Kappa",
    "Panola",
    "Fairbury",
    "Flanagan",
    "Forrest",
    "Goodfield",
    "Graymont",
    "Gridley",
    "Heyworth",
    "Hopedale",
    "Hudson",
    "Kenney",
    "Lane",
    "Lawndale",
    "Le Roy",
    "Lexington",
    "McLean",
    "Mackinaw",
    "Maroa",
    "Minier",
    "Minonk",
    "Normal",
    "Merna",
    "Pontiac",
    "Saunemin",
    "Saybrook",
    "Secor",
    "Shirley",
    "Sibley",
    "Stanford",
    "Strawn",
    "Towanda",
    "Wapella",
    "Waynesville",
    "Urbana",
    "Allerton",
    "Alvin",
    "Armstrong",
    "Bement",
    "Bismarck",
    "Bondville",
    "Broadlands",
    "Catlin",
    "Cerro Gordo",
    "Champaign",
    "Cisco",
    "Collison",
    "Danville",
    "Tilton",
    "De Land",
    "Dewey",
    "Fairmount",
    "Farmer City",
    "Fisher",
    "Fithian",
    "Foosland",
    "Georgetown",
    "Gifford",
    "Henning",
    "Homer",
    "Indianola",
    "Ivesdale",
    "Longview",
    "Mahomet",
    "Mansfield",
    "Milmine",
    "Monticello",
    "Lodge",
    "Muncie",
    "Oakwood",
    "Ogden",
    "Penfield",
    "Pesotum",
    "Philo",
    "Potomac",
    "Rantoul",
    "Ridge Farm",
    "Royal",
    "Sadorus",
    "Saint Joseph",
    "Savoy",
    "Seymour",
    "Sidell",
    "Sidney",
    "Thomasboro",
    "Tolono",
    "Weldon",
    "Westville",
    "White Heath",
    "Arcola",
    "Arthur",
    "Cadwell",
    "Ashmore",
    "Atwood",
    "Bethany",
    "Brocton",
    "Camargo",
    "Charleston",
    "Chrisman",
    "Dalton City",
    "Gays",
    "Hammond",
    "Pierson Sta",
    "Pierson Station",
    "Hindsboro",
    "Humboldt",
    "Hume",
    "Kansas",
    "La Place",
    "Lovington",
    "Lake City",
    "Mattoon",
    "Metcalf",
    "Murdock",
    "Newman",
    "Oakland",
    "Paris",
    "Redmon",
    "Sullivan",
    "Allenville",
    "Kirksville",
    "Tuscola",
    "Vermilion",
    "Villa Grove",
    "Windsor",
    "Alhambra",
    "Alton",
    "Batchtown",
    "Benld",
    "Bethalto",
    "Bingham",
    "Brighton",
    "Brussels",
    "Meppen",
    "Bunker Hill",
    "Butler",
    "Carrollton",
    "Coffeen",
    "Cottage Hills",
    "Donnellson",
    "Dorsey",
    "Dow",
    "Eagarville",
    "East Alton",
    "Edwardsville",
    "Eldred",
    "Elsah",
    "Fidelity",
    "Fieldon",
    "Fillmore",
    "Gillespie",
    "Dorchester",
    "Glen Carbon",
    "Godfrey",
    "Golden Eagle",
    "Grafton",
    "Granite City",
    "Mitchell",
    "Pontoon Beach",
    "Greenfield",
    "Hamburg",
    "Hamel",
    "Hardin",
    "Hartford",
    "Hillsboro",
    "Hillview",
    "Irving",
    "Jerseyville",
    "Otterville",
    "Kampsville",
    "Kane",
    "Litchfield",
    "Livingston",
    "Lovejoy",
    "Brooklyn",
    "Madison",
    "Marine",
    "Maryville",
    "Medora",
    "Moro",
    "Mount Olive",
    "New Douglas",
    "Nokomis",
    "Ohlman",
    "Panama",
    "Patterson",
    "Piasa",
    "Ramsey",
    "Rockbridge",
    "Roodhouse",
    "Rosamond",
    "Roxana",
    "Sawyerville",
    "Sorento",
    "South Roxana",
    "Staunton",
    "Taylor Springs",
    "Taylor Spgs",
    "Venice",
    "Walshville",
    "White Hall",
    "Wilsonville",
    "Witt",
    "Wood River",
    "Worden",
    "Wrights",
    "East Saint Louis",
    "E Saint Louis",
    "Fairmont City",
    "Sauget",
    "Cahokia Heights",
    "Cahokia Hgts",
    "Centreville",
    "Washington Pk",
    "Cahokia",
    "Alorton",
    "Fairview Heights",
    "Fairview Hts",
    "Addieville",
    "Venedy",
    "Albers",
    "Damiansville",
    "Aviston",
    "Baldwin",
    "Bartelso",
    "Beckemeyer",
    "Belleville",
    "Swansea",
    "Shiloh",
    "Scott Air Force Base",
    "Scott AFB",
    "Breese",
    "Saint Rose",
    "Carlyle",
    "Boulder",
    "Ferrin",
    "Posey",
    "Shattuc",
    "Caseyville",
    "Chester",
    "Collinsville",
    "Columbia",
    "Coulterville",
    "Swanwick",
    "Cutler",
    "Dupo",
    "East Carondelet",
    "E Carondelet",
    "Ellis Grove",
    "Evansville",
    "Freeburg",
    "Fults",
    "Germantown",
    "Greenville",
    "Hecker",
    "Highland",
    "Hoffman",
    "Keyesport",
    "Lebanon",
    "Lenzburg",
    "Maeystown",
    "Marissa",
    "Mascoutah",
    "Fayetteville",
    "Millstadt",
    "Modoc",
    "Pr Du Rocher",
    "Prairie Du Rocher",
    "Mulberry Grove",
    "Mulberry Grv",
    "Nashville",
    "New Athens",
    "New Baden",
    "New Memphis",
    "Oakdale",
    "O'Fallon",
    "Okawville",
    "Percy",
    "Pierron",
    "Pinckneyville",
    "Pocahontas",
    "Jamestown",
    "Red Bud",
    "Redbud",
    "Ruma",
    "Renault",
    "Rockwood",
    "Saint Jacob",
    "Saint Libory",
    "Smithboro",
    "Smithton",
    "Sparta",
    "Steeleville",
    "Summerfield",
    "Tilden",
    "Trenton",
    "Troy",
    "Valmeyer",
    "Walsh",
    "Waterloo",
    "Quincy",
    "Augusta",
    "Barry",
    "Basco",
    "Baylis",
    "Bowen",
    "Camden",
    "Camp Point",
    "Columbus",
    "Carthage",
    "Chambersburg",
    "Clayton",
    "Coatsburg",
    "Colchester",
    "Dallas City",
    "Adrian",
    "Burnside",
    "Pontoosuc",
    "Elvaston",
    "Ferris",
    "Fowler",
    "Golden",
    "Griggsville",
    "Hamilton",
    "Hull",
    "Huntsville",
    "Kinderhook",
    "La Prairie",
    "Liberty",
    "Lima",
    "Loraine",
    "Mendon",
    "Milton",
    "Mount Sterling",
    "Mt Sterling",
    "Ripley",
    "Nauvoo",
    "Nebo",
    "New Canton",
    "New Salem",
    "Niota",
    "Paloma",
    "Payson",
    "Pearl",
    "Perry",
    "Pittsfield",
    "Detroit",
    "Summer Hill",
    "Plainville",
    "Pleasant Hill",
    "Plymouth",
    "Colmar",
    "Rockport",
    "Sutter",
    "Tennessee",
    "Timewell",
    "Mound Station",
    "Ursa",
    "Versailles",
    "Warsaw",
    "West Point",
    "Effingham",
    "Allendale",
    "Altamont",
    "Annapolis",
    "Beecher City",
    "Bridgeport",
    "Brownstown",
    "Calhoun",
    "Casey",
    "Claremont",
    "Cowden",
    "Dennison",
    "Dieterich",
    "Dundas",
    "Edgewood",
    "Laclede",
    "Flat Rock",
    "Birds",
    "Greenup",
    "Hazel Dell",
    "Herrick",
    "Hidalgo",
    "Hutsonville",
    "Ingraham",
    "Jewett",
    "Lakewood",
    "Lawrenceville",
    "Lerna",
    "Janesville",
    "Marshall",
    "Martinsville",
    "Mason",
    "Mode",
    "Montrose",
    "Mount Erie",
    "Neoga",
    "Newton",
    "Oblong",
    "Olney",
    "Palestine",
    "Parkersburg",
    "Robinson",
    "Saint Elmo",
    "Sainte Marie",
    "Saint Francisville",
    "St Francisvle",
    "Shumway",
    "Sigel",
    "Stewardson",
    "Stoy",
    "Strasburg",
    "Sumner",
    "Teutopolis",
    "Toledo",
    "Trilla",
    "Vandalia",
    "Hagarstown",
    "Watson",
    "Westfield",
    "West Liberty",
    "West Salem",
    "West Union",
    "West York",
    "Wheeler",
    "Willow Hill",
    "Yale",
    "Argenta",
    "Newburg",
    "Oakley",
    "Assumption",
    "Beason",
    "Blue Mound",
    "Boody",
    "Buffalo",
    "Buffalo Hart",
    "Lanesville",
    "Bulpitt",
    "Chestnut",
    "Cornland",
    "Dawson",
    "Decatur",
    "Long Creek",
    "Bearsdale",
    "Divernon",
    "Cimic",
    "Edinburg",
    "Edenburg",
    "Elwin",
    "Farmersville",
    "Findlay",
    "Yantisville",
    "Forsyth",
    "Glenarm",
    "Harristown",
    "Harvel",
    "Illiopolis",
    "Kincaid",
    "Lake Fork",
    "Latham",
    "Macon",
    "Mechanicsburg",
    "Bolivia",
    "Roby",
    "Morrisonville",
    "Mount Auburn",
    "Mount Pulaski",
    "Mt Zion",
    "Hervey City",
    "Mount Zion",
    "Moweaqua",
    "Radford",
    "Niantic",
    "Oconee",
    "Oreana",
    "Owaneco",
    "Palmer",
    "Clarksdale",
    "Pana",
    "Dunkel",
    "Millersville",
    "Pawnee",
    "Sicily",
    "Raymond",
    "Riverton",
    "Spaulding",
    "Rochester",
    "Berry",
    "Breckenridge",
    "New City",
    "Shelbyville",
    "Clarksburg",
    "Duvall",
    "Henton",
    "Middlesworth",
    "Westervelt",
    "Stonington",
    "Taylorville",
    "Hewittsville",
    "Jeiseyville",
    "Langleyville",
    "Sharpsburg",
    "Willeys",
    "Tovey",
    "Tower Hill",
    "Dollville",
    "Hinton",
    "Waggoner",
    "Atwater",
    "Warrensburg",
    "Heman",
    "Alexander",
    "Alsey",
    "Arenzville",
    "Ashland",
    "Newmansville",
    "Prentice",
    "Yatesville",
    "Athens",
    "Fancy Prairie",
    "Auburn",
    "Bath",
    "Lynchburg",
    "Snicarte",
    "Beardstown",
    "Bluffs",
    "Exeter",
    "Bluff Springs",
    "Browning",
    "Bader",
    "Bluff City",
    "Cantrall",
    "Carlinville",
    "Comer",
    "Enos",
    "Womac",
    "Chandlerville",
    "Panther Creek",
    "Chapin",
    "Chatham",
    "Chesterfield",
    "Hagaman",
    "Concord",
    "Easton",
    "Biggs",
    "Poplar City",
    "Elkhart",
    "Broadwell",
    "Emden",
    "Franklin",
    "Clements",
    "Rees",
    "Frederick",
    "Girard",
    "Mcvey",
    "Standard City",
    "Greenview",
    "Hubly",
    "Sweetwater",
    "Hartsburg",
    "Havana",
    "Eckard",
    "Enion",
    "Hettick",
    "Jacksonville",
    "Arcadia",
    "Arnold",
    "Literberry",
    "Lynnville",
    "Merritt",
    "Pisgah",
    "S Jacksonvle",
    "Sinclair",
    "South Jacksonville",
    "Kilbourne",
    "Lincoln",
    "Loami",
    "Manchester",
    "Mason City",
    "Luther",
    "Teheran",
    "Meredosia",
    "Naples",
    "Middletown",
    "Modesto",
    "Scottville",
    "Murrayville",
    "Nortonville",
    "New Berlin",
    "Bates",
    "Berlin",
    "Curran",
    "Old Berlin",
    "New Holland",
    "Nilwood",
    "Oakford",
    "Palmyra",
    "Barr",
    "Petersburg",
    "Atterberry",
    "Tice",
    "Pleasant Plains",
    "Farmingdale",
    "Pleasant Plns",
    "Richland",
    "Salisbury",
    "Rushville",
    "San Jose",
    "Sherman",
    "Barclay",
    "Shipman",
    "Plainview",
    "Royal Lakes",
    "Tallula",
    "Thayer",
    "Virden",
    "Virginia",
    "Little Indian",
    "Waverly",
    "Williamsville",
    "Winchester",
    "Glasgow",
    "Riggston",
    "Woodson",
    "Springfield",
    "Grandview",
    "Southern View",
    "Jerome",
    "Leland Grove",
    "Andrew",
    "Archer",
    "Bissell",
    "Bradfordton",
    "Clear Lake",
    "Riddle Hill",
    "Centralia",
    "Hoyleton",
    "Albion",
    "Alma",
    "Ashley",
    "Barnhill",
    "Belle Rive",
    "Bellmont",
    "Benton",
    "Bluford",
    "Bone Gap",
    "Bonnie",
    "Nason",
    "Broughton",
    "Dale",
    "Browns",
    "Buckner",
    "Burnt Prairie",
    "Carmi",
    "Christopher",
    "Cisne",
    "Clay City",
    "Sailor Spgs",
    "Sailor Springs",
    "Coello",
    "North City",
    "Crossville",
    "Dahlgren",
    "Dix",
    "Du Bois",
    "Du Quoin",
    "Ellery",
    "Enfield",
    "Ewing",
    "Fairfield",
    "Farina",
    "Iola",
    "Loogootee",
    "Flora",
    "Freeman Spur",
    "Geff",
    "Golden Gate",
    "Grayville",
    "Ina",
    "Irvington",
    "Iuka",
    "Johnsonville",
    "Keenes",
    "Keensburg",
    "Kell",
    "Kinmundy",
    "Logan",
    "Louisville",
    "Bible Grove",
    "McLeansboro",
    "Macedonia",
    "Maunie",
    "Mill Shoals",
    "Mount Carmel",
    "Mount Vernon",
    "Mulkeytown",
    "New Haven",
    "Noble",
    "Norris City",
    "Herald",
    "Odin",
    "Omaha",
    "Opdyke",
    "Orient",
    "Patoka",
    "Radom",
    "Richview",
    "Rinard",
    "Saint Peter",
    "Salem",
    "Sandoval",
    "Scheller",
    "Sesser",
    "Shobonier",
    "Sims",
    "Springerton",
    "Tamaroa",
    "Texico",
    "Thompsonville",
    "Akin",
    "Valier",
    "Vernon",
    "Walnut Hill",
    "Waltonville",
    "Wayne City",
    "West Frankfort",
    "W Frankfort",
    "Whittington",
    "Woodlawn",
    "Xenia",
    "Carbondale",
    "Alto Pass",
    "Anna",
    "Ava",
    "Belknap",
    "Brookport",
    "Hamletsburg",
    "New Liberty",
    "Buncombe",
    "Cairo",
    "Cache",
    "Cambria",
    "Campbell Hill",
    "Carrier Mills",
    "Carterville",
    "Cave In Rock",
    "Cobden",
    "Colp",
    "Creal Springs",
    "Cypress",
    "De Soto",
    "Dongola",
    "Dowell",
    "Eddyville",
    "Eldorado",
    "Elizabethtown",
    "Karbers Ridge",
    "Elkville",
    "Energy",
    "Equality",
    "Galatia",
    "Harco",
    "Golconda",
    "Brownfield",
    "Temple Hill",
    "Goreville",
    "Gorham",
    "Grand Chain",
    "Grand Tower",
    "Grantsburg",
    "Harrisburg",
    "Herod",
    "Herrin",
    "Hurst",
    "Jacob",
    "Johnston City",
    "Jonesboro",
    "Joppa",
    "Junction",
    "Karnak",
    "McClure",
    "Makanda",
    "Marion",
    "Whiteash",
    "Metropolis",
    "Millcreek",
    "Miller City",
    "Mound City",
    "Mounds",
    "Muddy",
    "Murphysboro",
    "New Burnside",
    "Olive Branch",
    "Olmsted",
    "Ozark",
    "Tunnel Hill",
    "Pittsburg",
    "Pomona",
    "Pulaski",
    "Raleigh",
    "Ridgway",
    "Rosiclare",
    "Royalton",
    "Shawneetown",
    "Simpson",
    "Robbs",
    "Stonefort",
    "Tamms",
    "Elco",
    "Thebes",
    "Gale",
    "Ullin",
    "Vergennes",
    "Oraville",
    "Vienna",
    "Villa Ridge",
    "Willisville",
    "Wolf Lake",
    "Zeigler",
  ],
  IN: [
    "Alexandria",
    "Anderson",
    "Country Club Heights",
    "Ctry Clb Hgts",
    "River Forest",
    "Woodlawn Heights",
    "Woodlawn Hgts",
    "Chesterfield",
    "Arcadia",
    "Atlanta",
    "Carmel",
    "Cicero",
    "Westfield",
    "Colfax",
    "Elwood",
    "Fishers",
    "Forest",
    "Fortville",
    "Frankfort",
    "Hillisburg",
    "Frankton",
    "Goldsmith",
    "Hobbs",
    "Ingalls",
    "Kempton",
    "Kirklin",
    "Lapel",
    "Lebanon",
    "Ulen",
    "Mccordsville",
    "Markleville",
    "Michigantown",
    "Mulberry",
    "Noblesville",
    "Orestes",
    "Pendleton",
    "Rossville",
    "Sharpsville",
    "Sheridan",
    "Summitville",
    "Thorntown",
    "Tipton",
    "Whitestown",
    "Windfall",
    "Zionsville",
    "Advance",
    "Amo",
    "Arlington",
    "Bainbridge",
    "Bargersville",
    "Beech Grove",
    "Boggstown",
    "Brooklyn",
    "Brownsburg",
    "Camby",
    "Carthage",
    "Charlottesville",
    "Charlottesvle",
    "Clayton",
    "Cloverdale",
    "Coatesville",
    "Danville",
    "Avon",
    "Edinburgh",
    "Atterbury",
    "Camp Atterbry",
    "Camp Atterbury",
    "Camp Attrbry",
    "Eminence",
    "Fairland",
    "Falmouth",
    "Fillmore",
    "Fountaintown",
    "Franklin",
    "Glenwood",
    "Greencastle",
    "Greenfield",
    "Spring Lake",
    "Greenwood",
    "Gwynneville",
    "Homer",
    "Jamestown",
    "Knightstown",
    "Lizton",
    "Manilla",
    "Martinsville",
    "Bethany",
    "Centerton",
    "Maxwell",
    "Mays",
    "Milroy",
    "Monrovia",
    "Mooresville",
    "Morgantown",
    "Morristown",
    "Needham",
    "New Palestine",
    "Nineveh",
    "Princes Lakes",
    "North Salem",
    "Paragon",
    "Pittsboro",
    "Plainfield",
    "Cartersburg",
    "Putnamville",
    "Reelsville",
    "Roachdale",
    "Rushville",
    "Russellville",
    "Shelbyville",
    "Stilesville",
    "Trafalgar",
    "Waldron",
    "West Newton",
    "Whiteland",
    "New Whiteland",
    "Wilkinson",
    "Willow Branch",
    "Indianapolis",
    "Rocky Ripple",
    "Eagle Creek",
    "Southport",
    "Warren Park",
    "Speedway",
    "Lawrence",
    "Homecroft",
    "Crows Nest",
    "N Crows Nest",
    "North Crows Nest",
    "Spring Hills",
    "Wynnedale",
    "Cumberland",
    "Clermont",
    "Oaklandon",
    "Wanamaker",
    "Nora",
    "Williams Creek",
    "Williams Crk",
    "Castleton",
    "Acton",
    "Meridian Hills",
    "Meridian Hls",
    "New Augusta",
    "Beverly Shores",
    "Beverly Shrs",
    "Boone Grove",
    "Cedar Lake",
    "Chesterton",
    "Burns Harbor",
    "Dune Acres",
    "Porter",
    "Crown Point",
    "Winfield",
    "Demotte",
    "Dyer",
    "East Chicago",
    "Griffith",
    "Hammond",
    "Munster",
    "Highland",
    "Hanna",
    "Hebron",
    "Hobart",
    "New Chicago",
    "Kingsbury",
    "Kingsford Heights",
    "Kingsford Hts",
    "Kouts",
    "La Crosse",
    "Lake Village",
    "La Porte",
    "Laporte",
    "Lowell",
    "Michigan City",
    "Long Beach",
    "Michiana Shores",
    "Michiana Shrs",
    "Pines",
    "Potawatami Pk",
    "Pottawattamie Park",
    "Town Of Pines",
    "Trail Creek",
    "Mill Creek",
    "North Judson",
    "Portage",
    "Ogden Dunes",
    "Rolling Prairie",
    "Rolling Pr",
    "Saint John",
    "San Pierre",
    "Schererville",
    "Schneider",
    "Shelby",
    "Sumava Resorts",
    "Sumava Rsts",
    "Thayer",
    "Union Mills",
    "Valparaiso",
    "Valpo",
    "Wanatah",
    "Westville",
    "Otis",
    "Wheatfield",
    "Wheeler",
    "Whiting",
    "Gary",
    "Lake Station",
    "Merrillville",
    "Argos",
    "Atwood",
    "Bourbon",
    "Bremen",
    "Bristol",
    "Burket",
    "Claypool",
    "Culver",
    "Burr Oak",
    "Donaldson",
    "Elkhart",
    "Etna Green",
    "Goshen",
    "Foraker",
    "Granger",
    "Grovertown",
    "Hamlet",
    "Knox",
    "Ober",
    "Lakeville",
    "Lapaz",
    "La Paz",
    "Leesburg",
    "Mentone",
    "Middlebury",
    "Milford",
    "Millersburg",
    "Mishawaka",
    "Nappanee",
    "New Carlisle",
    "New Paris",
    "North Liberty",
    "North Webster",
    "Notre Dame",
    "Osceola",
    "Pierceton",
    "Sidney",
    "Plymouth",
    "Inwood",
    "Shipshewana",
    "Syracuse",
    "Tippecanoe",
    "Topeka",
    "Tyner",
    "Wakarusa",
    "Walkerton",
    "Warsaw",
    "Winona Lake",
    "Wyatt",
    "South Bend",
    "Roseland",
    "Albion",
    "Andrews",
    "Angola",
    "Arcola",
    "Ashley",
    "Auburn",
    "Avilla",
    "Berne",
    "Linn Grove",
    "Bluffton",
    "Butler",
    "Churubusco",
    "Columbia City",
    "Corunna",
    "Craigville",
    "Cromwell",
    "Decatur",
    "Fremont",
    "Garrett",
    "Geneva",
    "Grabill",
    "Hamilton",
    "Harlan",
    "Hoagland",
    "Howe",
    "Hudson",
    "Helmer",
    "Huntertown",
    "Huntington",
    "Kendallville",
    "Keystone",
    "Kimmell",
    "Lagrange",
    "Laotto",
    "Larwill",
    "Leo",
    "Leo Cedarville",
    "Leo Cedarvle",
    "Liberty Center",
    "Liberty Ctr",
    "Ligonier",
    "Markle",
    "Mongo",
    "Monroe",
    "Monroeville",
    "Monroevl",
    "New Haven",
    "Orland",
    "Ossian",
    "Petroleum",
    "Pleasant Lake",
    "Poneto",
    "Roanoke",
    "Rome City",
    "Saint Joe",
    "South Milford",
    "South Whitley",
    "Spencerville",
    "Stroh",
    "Uniondale",
    "Warren",
    "Waterloo",
    "Wawaka",
    "Brimfield",
    "Wolcottville",
    "Wolflake",
    "Woodburn",
    "Yoder",
    "Zanesville",
    "Fort Wayne",
    "Kokomo",
    "Akron",
    "Amboy",
    "Bringhurst",
    "Bunker Hill",
    "Burlington",
    "Camden",
    "Converse",
    "Cutler",
    "Delong",
    "Delphi",
    "Denver",
    "Chili",
    "Fairmount",
    "Flora",
    "Fowlerton",
    "Fulton",
    "Galveston",
    "Gas City",
    "Greentown",
    "Hemlock",
    "Jonesboro",
    "Kewanna",
    "La Fontaine",
    "Lagro",
    "Laketon",
    "Leiters Ford",
    "Liberty Mills",
    "Logansport",
    "Lucerne",
    "Macy",
    "Marion",
    "Matthews",
    "Mexico",
    "Miami",
    "Monterey",
    "New Waverly",
    "North Manchester",
    "N Manchester",
    "Oakford",
    "Onward",
    "Ora",
    "Peru",
    "Grissom Arb",
    "Grissom Air Reserve Base",
    "Roann",
    "Rochester",
    "Royal Center",
    "Russiaville",
    "Servia",
    "Silver Lake",
    "Somerset",
    "Star City",
    "Swayzee",
    "Sims",
    "Sweetser",
    "Twelve Mile",
    "Upland",
    "Urbana",
    "Van Buren",
    "Wabash",
    "Walton",
    "Winamac",
    "Denham",
    "Young America",
    "Aurora",
    "West College Corner",
    "W College Cnr",
    "Batesville",
    "Bath",
    "Bennington",
    "Brookville",
    "Saint Leon",
    "Cedar Grove",
    "Cross Plains",
    "Dillsboro",
    "Florence",
    "Friendship",
    "Guilford",
    "Holton",
    "Laurel",
    "Lawrenceburg",
    "Greendale",
    "Metamora",
    "Milan",
    "Moores Hill",
    "Morris",
    "Napoleon",
    "New Trenton",
    "Oldenburg",
    "Osgood",
    "Patriot",
    "Rising Sun",
    "Sunman",
    "Versailles",
    "Vevay",
    "West Harrison",
    "Austin",
    "Bethlehem",
    "Borden",
    "Starlight",
    "Campbellsburg",
    "Livonia",
    "Central",
    "New Amsterdam",
    "Charlestown",
    "Corydon",
    "Crandall",
    "Depauw",
    "Eckerty",
    "Elizabeth",
    "Rosewood",
    "English",
    "Sulphur",
    "Floyds Knobs",
    "Galena",
    "Navilleton",
    "Fredericksburg",
    "Fredericksbrg",
    "Georgetown",
    "Grantsburg",
    "Greenville",
    "Hardinsburg",
    "Rego",
    "Valeene",
    "Henryville",
    "Clarksville",
    "Jeffersonville",
    "Jeffersonvlle",
    "Jeff",
    "Utica",
    "Watson",
    "Laconia",
    "Lanesville",
    "Leavenworth",
    "Alton",
    "Carefree",
    "Fredonia",
    "Lexington",
    "Blocher",
    "Marengo",
    "Hogtown",
    "Marysville",
    "Mauckport",
    "Memphis",
    "Milltown",
    "Nabb",
    "New Albany",
    "New Middletown",
    "New Middletwn",
    "New Salisbury",
    "New Washington",
    "New Washingtn",
    "Otisco",
    "Palmyra",
    "Pekin",
    "Ramsey",
    "Salem",
    "Scottsburg",
    "Little York",
    "Sellersburg",
    "Speed",
    "Taswell",
    "Underwood",
    "Columbus",
    "Brownstown",
    "Butlerville",
    "Muscatatuck",
    "Nebraska",
    "Canaan",
    "Clarksburg",
    "Clifford",
    "Commiskey",
    "Crothersville",
    "Deputy",
    "Dupont",
    "Elizabethtown",
    "Flat Rock",
    "Freetown",
    "Grammer",
    "Greensburg",
    "Burney",
    "Hanover",
    "Hartsville",
    "Hope",
    "Jonesville",
    "Madison",
    "Brooksburg",
    "Medora",
    "New Point",
    "Norman",
    "North Vernon",
    "Paris Crossing",
    "Paris Xing",
    "Saint Paul",
    "Scipio",
    "Seymour",
    "Taylorsville",
    "Vallonia",
    "Vernon",
    "Westport",
    "Muncie",
    "Albany",
    "Boston",
    "Brownsville",
    "Bryant",
    "Cambridge City",
    "Cambridge Cty",
    "Centerville",
    "Connersville",
    "Daleville",
    "Dublin",
    "Dunkirk",
    "Dunreith",
    "Eaton",
    "Economy",
    "Farmland",
    "Fountain City",
    "Gaston",
    "Greensboro",
    "Greens Fork",
    "Hagerstown",
    "Hartford City",
    "Kennard",
    "Lewisville",
    "Liberty",
    "Losantville",
    "Lynn",
    "Middletown",
    "Milton",
    "Modoc",
    "Montpelier",
    "Mooreland",
    "Mount Summit",
    "New Castle",
    "New Lisbon",
    "Oakville",
    "Parker City",
    "Parker",
    "Pennville",
    "Pershing",
    "E Germantown",
    "East Germantown",
    "Portland",
    "Redkey",
    "Richmond",
    "Ridgeville",
    "Salamonia",
    "Saratoga",
    "Selma",
    "Shirley",
    "Spiceland",
    "Springport",
    "Straughn",
    "Sulphur Springs",
    "Sulphur Spgs",
    "Union City",
    "Webster",
    "Williamsburg",
    "Winchester",
    "Yorktown",
    "Bloomington",
    "Woodbridge",
    "Avoca",
    "Bedford",
    "Fort Ritner",
    "Bloomfield",
    "Coal City",
    "Ellettsville",
    "Freedom",
    "French Lick",
    "Gosport",
    "Harrodsburg",
    "Helmsburg",
    "Heltonville",
    "Huron",
    "Jasonville",
    "Linton",
    "Lyons",
    "Midland",
    "Mitchell",
    "Nashville",
    "Newberry",
    "Oolitic",
    "Orleans",
    "Owensburg",
    "Paoli",
    "Patricksburg",
    "Quincy",
    "Scotland",
    "Smithville",
    "Solsberry",
    "Spencer",
    "Springville",
    "Stinesville",
    "Switz City",
    "Tunnelton",
    "Unionville",
    "West Baden Springs",
    "W Baden Sprgs",
    "Williams",
    "Worthington",
    "Washington",
    "Bicknell",
    "Birdseye",
    "Branchville",
    "Bristow",
    "Siberia",
    "Bruceville",
    "Cannelburg",
    "Cannelton",
    "Magnet",
    "Mount Pleasant",
    "Mt Pleasant",
    "Tobinsport",
    "Celestine",
    "Crane",
    "Crane Nav Dpt",
    "Crane Naval Depot",
    "Dale",
    "Decker",
    "Derby",
    "Dubois",
    "Edwardsport",
    "Elnora",
    "Evanston",
    "Ferdinand",
    "Freelandville",
    "Gentryville",
    "Holland",
    "Huntingburg",
    "Jasper",
    "Lamar",
    "Buffaloville",
    "Leopold",
    "Lincoln City",
    "Loogootee",
    "Monroe City",
    "Montgomery",
    "Oaktown",
    "Emison",
    "Odon",
    "Otwell",
    "Petersburg",
    "Plainville",
    "Ragsdale",
    "Rome",
    "Saint Anthony",
    "Kyana",
    "Saint Croix",
    "Saint Meinrad",
    "Sandborn",
    "Santa Claus",
    "Christmas Lake Village",
    "Christmas Lk",
    "Xmas Lk Vlg",
    "Schnellville",
    "Shoals",
    "Spurgeon",
    "Stendal",
    "Tell City",
    "Troy",
    "Velpen",
    "Vincennes",
    "Westphalia",
    "Wheatland",
    "Winslow",
    "Boonville",
    "Chandler",
    "Chrisney",
    "Cynthiana",
    "Elberfeld",
    "Grandview",
    "Griffin",
    "Lynnville",
    "Mount Vernon",
    "Newburgh",
    "New Harmony",
    "Poseyville",
    "Richland",
    "Rockport",
    "Tennyson",
    "Folsomville",
    "Wadesville",
    "Haubstadt",
    "Hazleton",
    "Fort Branch",
    "Francisco",
    "Mackey",
    "Oakland City",
    "Owensville",
    "Patoka",
    "Princeton",
    "Somerville",
    "Evansville",
    "Darmstadt",
    "Terre Haute",
    "N Terre Haute",
    "North Terre Haute",
    "Blanford",
    "Bloomingdale",
    "Bowling Green",
    "Brazil",
    "Bridgeton",
    "Carbon",
    "Carlisle",
    "Centerpoint",
    "Center Point",
    "Clay City",
    "Clinton",
    "Coalmont",
    "Cory",
    "Dana",
    "Dugger",
    "Fairbanks",
    "Farmersburg",
    "Fontanet",
    "Harmony",
    "Hillsdale",
    "Hymera",
    "Knightsville",
    "Lewis",
    "Marshall",
    "Mecca",
    "Merom",
    "Montezuma",
    "New Goshen",
    "Paxton",
    "Pimento",
    "Poland",
    "Prairie Creek",
    "Prairieton",
    "Riley",
    "Rockville",
    "Judson",
    "Rosedale",
    "Saint Bernice",
    "Saint Mary Of The Woods",
    "St Mary Of Wd",
    "Shelburn",
    "Shepardsville",
    "Staunton",
    "Sullivan",
    "New Lebanon",
    "Universal",
    "West Terre Haute",
    "Sandford",
    "W Terre Haute",
    "Lafayette",
    "La Fayette",
    "Colburn",
    "West Lafayette",
    "W Lafayette",
    "Shadeland",
    "Alamo",
    "Ambia",
    "Attica",
    "Battle Ground",
    "Boswell",
    "Brook",
    "Brookston",
    "Buck Creek",
    "Buffalo",
    "Burnettsville",
    "Cayuga",
    "Chalmers",
    "Clarks Hill",
    "Covington",
    "Crawfordsville",
    "Crawfordsvlle",
    "Darlington",
    "Dayton",
    "Earl Park",
    "Fair Oaks",
    "Fowler",
    "Francesville",
    "Goodland",
    "Hillsboro",
    "Idaville",
    "Kentland",
    "Kingman",
    "Cates",
    "Tangier",
    "Ladoga",
    "Linden",
    "Medaryville",
    "Mellott",
    "Monon",
    "Monticello",
    "Morocco",
    "Mount Ayr",
    "New Market",
    "Newport",
    "New Richmond",
    "New Ross",
    "Newtown",
    "Otterbein",
    "Oxford",
    "Perrysville",
    "Pine Village",
    "Remington",
    "Rensselaer",
    "Collegeville",
    "Reynolds",
    "Romney",
    "State Line",
    "Stockwell",
    "Templeton",
    "Veedersburg",
    "Waveland",
    "Waynetown",
    "West Lebanon",
    "Westpoint",
    "Williamsport",
    "Marshfield",
    "Pence",
    "Wingate",
    "Wolcott",
    "Yeoman",
  ],
  KS: [
    "Atchison",
    "Potter",
    "Baldwin City",
    "Basehor",
    "Bendena",
    "Blue Mound",
    "Bonner Springs",
    "Bonner Spgs",
    "Lake Of The Forest",
    "Lk Of The Fst",
    "Bucyrus",
    "Overland Park",
    "Stilwell",
    "Centerville",
    "Colony",
    "Cummings",
    "Denton",
    "De Soto",
    "Easton",
    "Edgerton",
    "Effingham",
    "Elwood",
    "Eudora",
    "Fontana",
    "Fort Leavenworth",
    "Ft Leavnwrth",
    "Gardner",
    "New Century",
    "Garnett",
    "Greeley",
    "Highland",
    "Kincaid",
    "La Cygne",
    "Lacygne",
    "Linn Valley",
    "Lancaster",
    "Huron",
    "Lane",
    "Lansing",
    "Leavenworth",
    "Lawrence",
    "Lecompton",
    "Linwood",
    "Louisburg",
    "McLouth",
    "Mound City",
    "Muscotah",
    "Nortonville",
    "Olathe",
    "Lenexa",
    "Osawatomie",
    "Oskaloosa",
    "Ottawa",
    "Centropolis",
    "Ozawkie",
    "Paola",
    "Parker",
    "Perry",
    "Pleasanton",
    "Pomona",
    "Princeton",
    "Rantoul",
    "Richmond",
    "Spring Hill",
    "Tonganoxie",
    "Troy",
    "Severance",
    "Valley Falls",
    "Wathena",
    "Welda",
    "Wellsville",
    "Westphalia",
    "White Cloud",
    "Williamsburg",
    "Winchester",
    "Kansas City",
    "Rosedale",
    "Edwardsville",
    "Mission",
    "Countryside",
    "Merriam",
    "Prairie Vlg",
    "Roeland Park",
    "Shawnee Mission",
    "Shawnee Msn",
    "Shawnee",
    "Fairway",
    "Mission Woods",
    "Westwood",
    "Westwood Hills",
    "Westwood Hls",
    "Leawood",
    "Prairie Village",
    "Mission Hills",
    "Lake Quivira",
    "Stanley",
    "Alma",
    "Auburn",
    "Axtell",
    "Baileyville",
    "Beattie",
    "Belvue",
    "Bern",
    "Berryton",
    "Blue Rapids",
    "Bremen",
    "Burlingame",
    "Carbondale",
    "Centralia",
    "Circleville",
    "Corning",
    "Delia",
    "Denison",
    "Emmett",
    "Eskridge",
    "Everest",
    "Fairview",
    "Frankfort",
    "Goff",
    "Grantville",
    "Harveyville",
    "Havensville",
    "Hiawatha",
    "Reserve",
    "Willis",
    "Holton",
    "Home",
    "Horton",
    "Hoyt",
    "Junction City",
    "Fort Riley",
    "Ft Riley",
    "Leonardville",
    "Lyndon",
    "McFarland",
    "Manhattan",
    "Maple Hill",
    "Marysville",
    "Herkimer",
    "Mayetta",
    "Melvern",
    "Meriden",
    "Milford",
    "Morrill",
    "Netawaka",
    "Ogden",
    "Oketo",
    "Olsburg",
    "Onaga",
    "Duluth",
    "Wheaton",
    "Oneida",
    "Osage City",
    "Overbrook",
    "Paxico",
    "Powhattan",
    "Quenemo",
    "Riley",
    "Robinson",
    "Leona",
    "Rossville",
    "Sabetha",
    "Saint George",
    "Saint Marys",
    "Scranton",
    "Seneca",
    "Kelly",
    "St Benedict",
    "Silver Lake",
    "Soldier",
    "Summerfield",
    "Tecumseh",
    "Vassar",
    "Vermillion",
    "Vliets",
    "Wakarusa",
    "Wamego",
    "Louisville",
    "Waterville",
    "Westmoreland",
    "Blaine",
    "Wetmore",
    "Whiting",
    "Randolph",
    "Topeka",
    "Fort Scott",
    "Hiattville",
    "Altoona",
    "Arcadia",
    "Arma",
    "Baxter Springs",
    "Baxter Spgs",
    "Benedict",
    "Bronson",
    "Buffalo",
    "Chanute",
    "Petrolia",
    "Cherokee",
    "Columbus",
    "Hallowell",
    "Elsmore",
    "Erie",
    "Farlington",
    "Franklin",
    "Fredonia",
    "Coyville",
    "Lafontaine",
    "New Albany",
    "Fulton",
    "Galena",
    "Galesburg",
    "Garland",
    "Gas",
    "Girard",
    "Hepler",
    "Humboldt",
    "Iola",
    "Carlyle",
    "La Harpe",
    "McCune",
    "Mapleton",
    "Moran",
    "Mulberry",
    "Neodesha",
    "Neosho Falls",
    "Opolis",
    "Piqua",
    "Pittsburg",
    "Radley",
    "Frontenac",
    "Prescott",
    "Redfield",
    "Riverton",
    "Saint Paul",
    "Savonburg",
    "Scammon",
    "Carona",
    "Stark",
    "Thayer",
    "Toronto",
    "Treece",
    "Uniontown",
    "Walnut",
    "Weir",
    "Lawton",
    "West Mineral",
    "Yates Center",
    "Emporia",
    "Admire",
    "Allen",
    "Bushong",
    "Alta Vista",
    "Americus",
    "Burdick",
    "Burlington",
    "New Strawn",
    "Burns",
    "Cassoday",
    "Cedar Point",
    "Clements",
    "Cottonwood Falls",
    "Cottonwd Fls",
    "Council Grove",
    "Dunlap",
    "Dwight",
    "Elmdale",
    "Florence",
    "Gridley",
    "Hamilton",
    "Hartford",
    "Lebo",
    "Olivet",
    "Le Roy",
    "Lincolnville",
    "Antelope",
    "Lost Springs",
    "Madison",
    "Marion",
    "Matfield Green",
    "Matfield Grn",
    "Neal",
    "Neosho Rapids",
    "Olpe",
    "Peabody",
    "Reading",
    "Strong City",
    "Virgil",
    "Waverly",
    "White City",
    "Wilsey",
    "Concordia",
    "Ames",
    "Rice",
    "Agenda",
    "Athol",
    "Barnes",
    "Belleville",
    "Burr Oak",
    "Clifton",
    "Clyde",
    "Courtland",
    "Cuba",
    "Esbon",
    "Formoso",
    "Greenleaf",
    "Haddam",
    "Hanover",
    "Hollenberg",
    "Jamestown",
    "Jewell",
    "Ionia",
    "Kensington",
    "Lebanon",
    "Bellaire",
    "Linn",
    "Mahaska",
    "Mankato",
    "Morrowville",
    "Munden",
    "Narka",
    "Norway",
    "Palmer",
    "Randall",
    "Republic",
    "Scandia",
    "Smith Center",
    "Harlan",
    "Washington",
    "Webber",
    "Andale",
    "Andover",
    "Anthony",
    "Argonia",
    "Arkansas City",
    "Parkerfield",
    "Atlanta",
    "Attica",
    "Augusta",
    "Beaumont",
    "Belle Plaine",
    "Bentley",
    "Benton",
    "Bluff City",
    "Burden",
    "Burrton",
    "Byers",
    "Caldwell",
    "Cambridge",
    "Cedar Vale",
    "Cheney",
    "Clearwater",
    "Coats",
    "Belvidere",
    "Coldwater",
    "Colwich",
    "Conway Springs",
    "Conway Spgs",
    "Cunningham",
    "Penalosa",
    "Danville",
    "Derby",
    "Dexter",
    "Douglass",
    "Elbing",
    "El Dorado",
    "Eureka",
    "Fall River",
    "Freeport",
    "Garden Plain",
    "Geuda Springs",
    "Goddard",
    "Goessel",
    "Greensburg",
    "Greenwich",
    "Halstead",
    "Hardtner",
    "Harper",
    "Haviland",
    "Haysville",
    "Hazelton",
    "Hesston",
    "Hillsboro",
    "Isabel",
    "Iuka",
    "Kechi",
    "Kingman",
    "Belmont",
    "Kiowa",
    "Lake City",
    "Latham",
    "Lehigh",
    "Leon",
    "Maize",
    "Maple City",
    "Mayfield",
    "Medicine Lodge",
    "Medicine Ldg",
    "Milan",
    "Milton",
    "Moundridge",
    "Mount Hope",
    "Mullinville",
    "Mulvane",
    "Murdock",
    "Nashville",
    "Newton",
    "North Newton",
    "Norwich",
    "Oxford",
    "Peck",
    "Piedmont",
    "Potwin",
    "Pratt",
    "Cullison",
    "Protection",
    "Rock",
    "Rosalia",
    "Rose Hill",
    "Sawyer",
    "Sedgwick",
    "Severy",
    "Climax",
    "Sharon",
    "South Haven",
    "Hunnewell",
    "Spivey",
    "Rago",
    "Sun City",
    "Towanda",
    "Udall",
    "Valley Center",
    "Park City",
    "Viola",
    "Waldron",
    "Walton",
    "Wellington",
    "Whitewater",
    "Wilmore",
    "Winfield",
    "Zenda",
    "Wichita",
    "Eastborough",
    "Bel Aire",
    "Mcconnell Afb",
    "Independence",
    "Altamont",
    "Bartlett",
    "Caney",
    "Chautauqua",
    "Cherryvale",
    "Chetopa",
    "Coffeyville",
    "Dearing",
    "Dennis",
    "Edna",
    "Elk City",
    "Elk Falls",
    "Grenola",
    "Havana",
    "Howard",
    "Liberty",
    "Longton",
    "Moline",
    "Mound Valley",
    "Niotaze",
    "Oswego",
    "Parsons",
    "Peru",
    "Sedan",
    "Sycamore",
    "Tyro",
    "Salina",
    "Bavaria",
    "Abilene",
    "Industry",
    "Manchester",
    "Assaria",
    "Mentor",
    "Aurora",
    "Barnard",
    "Beloit",
    "Scottsville",
    "Bennington",
    "Beverly",
    "Brookville",
    "Bushton",
    "Canton",
    "Cawker City",
    "Chapman",
    "Clay Center",
    "Oakhill",
    "Delphos",
    "Downs",
    "Durham",
    "Ellsworth",
    "Enterprise",
    "Falun",
    "Galva",
    "Geneseo",
    "Glasco",
    "Glen Elder",
    "Green",
    "Gypsum",
    "Carlton",
    "Herington",
    "Delavan",
    "Latimer",
    "Holyrood",
    "Hope",
    "Navarre",
    "Hunter",
    "Kanopolis",
    "Lincoln",
    "Westfall",
    "Lindsborg",
    "Smolan",
    "Little River",
    "Longford",
    "Lorraine",
    "Mcpherson",
    "Conway",
    "Mc Pherson",
    "Marquette",
    "Miltonvale",
    "Minneapolis",
    "Ada",
    "Wells",
    "Morganville",
    "New Cambria",
    "Osborne",
    "Portis",
    "Ramona",
    "Roxbury",
    "Simpson",
    "Solomon",
    "Sylvan Grove",
    "Talmage",
    "Tampa",
    "Tescott",
    "Culver",
    "Tipton",
    "Wakefield",
    "Wilson",
    "Windom",
    "Woodbine",
    "Hutchinson",
    "Willowbrook",
    "Medora",
    "South Hutchinson",
    "S Hutchinson",
    "Abbyville",
    "Albert",
    "Alden",
    "Alexander",
    "Arlington",
    "Arnold",
    "Bazine",
    "Beeler",
    "Belpre",
    "Bison",
    "Brownell",
    "Buhler",
    "Burdett",
    "Chase",
    "Claflin",
    "Beaver",
    "Odin",
    "Ellinwood",
    "Garfield",
    "Great Bend",
    "Dundee",
    "Heizer",
    "Haven",
    "Hoisington",
    "Susank",
    "Hudson",
    "Inman",
    "Kinsley",
    "La Crosse",
    "Larned",
    "Radium",
    "Lewis",
    "Liebenthal",
    "Lyons",
    "McCracken",
    "Macksville",
    "Nekoma",
    "Ness City",
    "Nickerson",
    "Offerle",
    "Olmitz",
    "Otis",
    "Galatia",
    "Partridge",
    "Pawnee Rock",
    "Plevna",
    "Pretty Prairie",
    "Pretty Pr",
    "Pretty Praire",
    "Ransom",
    "Raymond",
    "Rozel",
    "Rush Center",
    "Timken",
    "St John",
    "Saint John",
    "Seward",
    "Stafford",
    "Sterling",
    "Sylvia",
    "Turon",
    "Langdon",
    "Preston",
    "Utica",
    "Hays",
    "Antonino",
    "Agra",
    "Almena",
    "Alton",
    "Bogue",
    "Bunker Hill",
    "Catharine",
    "Cedar",
    "Clayton",
    "Collyer",
    "Damar",
    "Dorrance",
    "Dresden",
    "Ellis",
    "Gaylord",
    "Glade",
    "Gorham",
    "Hill City",
    "Jennings",
    "Kirwin",
    "Lenora",
    "Densmore",
    "Edmond",
    "New Almelo",
    "Logan",
    "Long Island",
    "Lucas",
    "Luray",
    "Morland",
    "Natoma",
    "Norcatur",
    "Norton",
    "Ogallah",
    "Palco",
    "Paradise",
    "Penokee",
    "Pfeifer",
    "Phillipsburg",
    "Stuttgart",
    "Plainville",
    "Codell",
    "Zurich",
    "Prairie View",
    "Russell",
    "Schoenchen",
    "Stockton",
    "Victoria",
    "Wakeeney",
    "Wa Keeney",
    "Waldo",
    "Walker",
    "Woodston",
    "Colby",
    "Atwood",
    "Bird City",
    "Brewster",
    "Edson",
    "Gem",
    "Goodland",
    "Gove",
    "Grainfield",
    "Grinnell",
    "Herndon",
    "Hoxie",
    "Studley",
    "Kanorado",
    "Levant",
    "Ludell",
    "McDonald",
    "Monument",
    "Winona",
    "Oakley",
    "Oberlin",
    "Park",
    "Quinter",
    "Rexford",
    "Menlo",
    "Saint Francis",
    "Wheeler",
    "Selden",
    "Sharon Springs",
    "Sharon Spgs",
    "Wallace",
    "Weskan",
    "Russell Spg",
    "Russell Springs",
    "Dodge City",
    "Fort Dodge",
    "Ashland",
    "Bucklin",
    "Cimarron",
    "Kalvesta",
    "Coolidge",
    "Copeland",
    "Deerfield",
    "Dighton",
    "Shields",
    "Englewood",
    "Ensign",
    "Ford",
    "Kingsdown",
    "Fowler",
    "Garden City",
    "Hanston",
    "Healy",
    "Holcomb",
    "Ingalls",
    "Jetmore",
    "Johnson",
    "Kendall",
    "Kismet",
    "Lakin",
    "Leoti",
    "Manter",
    "Marienthal",
    "Modoc",
    "Meade",
    "Minneola",
    "Bloom",
    "Montezuma",
    "Pierceville",
    "Plains",
    "Satanta",
    "Scott City",
    "Friend",
    "Spearville",
    "Sublette",
    "Syracuse",
    "Tribune",
    "Ulysses",
    "Wright",
    "Liberal",
    "Elkhart",
    "Hugoton",
    "Moscow",
    "Richfield",
    "Rolla",
  ],
  KY: [
    "Bagdad",
    "Bardstown",
    "Bedford",
    "Bethlehem",
    "Bloomfield",
    "Bradfordsville",
    "Bradfordsvlle",
    "Buckner",
    "Campbellsburg",
    "Chaplin",
    "Coxs Creek",
    "Deatsville",
    "Highgrove",
    "Lenore",
    "Samuels",
    "Crestwood",
    "Ballardsville",
    "Orchard Grass",
    "Orchard Grass Hills",
    "Eminence",
    "Fairfield",
    "Finchville",
    "Fisherville",
    "Wilsonville",
    "Glenview",
    "Goshen",
    "La Grange",
    "Lagrange",
    "Lebanon",
    "Calvary",
    "Lockport",
    "Loretto",
    "Mackville",
    "Masonic Home",
    "Milton",
    "Locust",
    "Mount Eden",
    "Mount Washington",
    "Mt Washington",
    "Nerinx",
    "New Castle",
    "New Haven",
    "Howardstown",
    "Trappist",
    "New Hope",
    "Pendleton",
    "Sulphur",
    "Pewee Valley",
    "Pleasureville",
    "Cropper",
    "Defoe",
    "Franklinton",
    "Port Royal",
    "Prospect",
    "River Bluff",
    "Raywick",
    "Saint Catharine",
    "St Catharine",
    "Saint Francis",
    "Saint Mary",
    "St Mary",
    "Shelbyville",
    "Simpsonville",
    "Smithfield",
    "Springfield",
    "Maud",
    "Taylorsville",
    "Turners Station",
    "Turners Sta",
    "Waddy",
    "Westport",
    "Willisburg",
    "Battletown",
    "Boston",
    "Brandenburg",
    "Brooks",
    "Clermont",
    "Cloverport",
    "Custer",
    "Garfield",
    "Ekron",
    "Fairdale",
    "Hollyvilla",
    "Falls Of Rough",
    "Falls Rough",
    "Glen Dean",
    "Vanzant",
    "Fort Knox",
    "Constantine",
    "Guston",
    "Hardinsburg",
    "Mooleyville",
    "Sample",
    "Harned",
    "Locust Hill",
    "Se Ree",
    "Hudson",
    "Irvington",
    "Lodiburg",
    "Lebanon Junction",
    "Lebanon Jct",
    "McDaniels",
    "Muldraugh",
    "Payneville",
    "Radcliff",
    "Rhodelia",
    "Rineyville",
    "Shepherdsville",
    "Fox Chase",
    "Hebron Estates",
    "Hebron Ests",
    "Hunters Hlw",
    "Hunters Hollow",
    "Pioneer Village",
    "Pioneer Vlg",
    "Shepherdsvlle",
    "Stephensport",
    "Union Star",
    "Vine Grove",
    "Big Spring",
    "Flaherty",
    "Webster",
    "Raymond",
    "West Point",
    "Westview",
    "Louisville",
    "Kingsley",
    "Seneca Gardens",
    "Seneca Gdns",
    "Strathmoor Manor",
    "Strathmoor Village",
    "Strathmr Mnr",
    "Strathmr Vlg",
    "Bellewood",
    "Brownsboro Village",
    "Brwnsboro Vlg",
    "Druid Hills",
    "Indian Hills",
    "Maryhill Estates",
    "Maryhill Ests",
    "Mockingbird Valley",
    "Mockngbrd Vly",
    "Norbourne Est",
    "Norbourne Estates",
    "Richlawn",
    "Riverwood",
    "Rolling Field",
    "Rolling Fields",
    "Saint Matthews",
    "St Matthews",
    "Windy Hills",
    "Woodlawn Park",
    "Audubon Park",
    "Lynnview",
    "Poplar Hills",
    "Shively",
    "Parkway Village",
    "Parkway Vlg",
    "Buechel",
    "Watterson Park",
    "Watterson Pk",
    "Heritage Creek",
    "Heritage Crk",
    "Okolona",
    "South Park View",
    "South Park Vw",
    "Cambridge",
    "Houston Acres",
    "Hurstbourne Acres",
    "Hurstbrne Acr",
    "Lincolnshire",
    "Meadowview Estates",
    "Meadowvw Ests",
    "Saint Regis Park",
    "St Regis Park",
    "Bancroft",
    "Bellemeade",
    "Crossgate",
    "Glenview Hills",
    "Glenview Hls",
    "Glenview Manor",
    "Glenview Mnr",
    "Graymoor Devondale",
    "Grymr Devndle",
    "Hurstbourne",
    "Lyndon",
    "Northfield",
    "Norwood",
    "Thornhill",
    "Anchorage",
    "Blue Rdg Mnr",
    "Blue Ridge Manor",
    "Meadowbrk Frm",
    "Meadowbrook Farm",
    "Moorland",
    "Sycamore",
    "Wildwood",
    "Hollow Creek",
    "Spring Mill",
    "Barbourmeade",
    "Broeck Pointe",
    "Brownsboro Farm",
    "Brwnsboro Frm",
    "Creekside",
    "Fincastle",
    "Goose Creek",
    "Green Spring",
    "Hickory Hill",
    "Hills And Dales",
    "Hills Dales",
    "Manor Creek",
    "Spring Valley",
    "Ten Broeck",
    "Briarwood",
    "Langdon Place",
    "Meadow Vale",
    "Murray Hill",
    "Old Brownsboro Place",
    "Old Brownsbro",
    "Plantation",
    "Rolling Hills",
    "Douglass Hills",
    "Douglass Hls",
    "Middletown",
    "Woodland Hills",
    "Woodland Hls",
    "Coldstream",
    "Worthington Hills",
    "Worthngtn Hls",
    "Pleasure Rdge",
    "Pleasure Ridge Park",
    "Valley Sta",
    "Valley Station",
    "Fern Creek",
    "Jeffersontown",
    "Burgin",
    "Carlisle",
    "Clay City",
    "Westbend",
    "Clearfield",
    "Denniston",
    "Frenchburg",
    "Mariba",
    "Scranton",
    "Georgetown",
    "Gravel Switch",
    "Harrodsburg",
    "Cornishville",
    "Hope",
    "Irvine",
    "Cobhill",
    "Crystal",
    "Jinks",
    "Pryse",
    "West Irvine",
    "Winston",
    "Jeffersonville",
    "Jeffersonvlle",
    "Keene",
    "Lawrenceburg",
    "Means",
    "Midway",
    "Millersburg",
    "Moorefield",
    "Morehead",
    "Haldeman",
    "Lakeview Heights",
    "Lakeview Hgts",
    "Mount Sterling",
    "Camargo",
    "Mt Sterling",
    "New Liberty",
    "Nicholasville",
    "North Middletown",
    "N Middletown",
    "Olympia",
    "Owenton",
    "Gratz",
    "Wheatley",
    "Owingsville",
    "Paris",
    "Perry Park",
    "Sadieville",
    "Salt Lick",
    "Sudith",
    "Salvisa",
    "Bondville",
    "Sharpsburg",
    "Bethel",
    "Slade",
    "Stamping Ground",
    "Stamping Grd",
    "Stanton",
    "Bowen",
    "Patsey",
    "Rosslyn",
    "Versailles",
    "Waco",
    "Bybee",
    "College Hill",
    "Dreyfus",
    "Wellington",
    "Pomeroyton",
    "Wilmore",
    "Winchester",
    "Ford",
    "Annville",
    "Bond",
    "Dabolt",
    "Moores Creek",
    "Berea",
    "Brodhead",
    "Crab Orchard",
    "Danville",
    "Gray Hawk",
    "Hustonville",
    "Junction City",
    "Kings Mountain",
    "Kings Mtn",
    "Lancaster",
    "Livingston",
    "McKee",
    "Clover Bottom",
    "Eberle",
    "Foxtown",
    "Hisle",
    "Kerby Knob",
    "Mckee",
    "Morrill",
    "New Zion",
    "Parrot",
    "Peoples",
    "Wind Cave",
    "McKinney",
    "Mount Vernon",
    "Climax",
    "Conway",
    "Disputanta",
    "Orlando",
    "Johnetta",
    "Paint Lick",
    "Parksville",
    "Perryville",
    "Ravenna",
    "Richmond",
    "Sandgap",
    "Stanford",
    "Tyner",
    "Elias",
    "Herd",
    "Maulden",
    "Waynesburg",
    "Lexington",
    "Frankfort",
    "Hatton",
    "Corbin",
    "Keavy",
    "Woodbine",
    "East Bernstadt",
    "E Bernstadt",
    "Symbol",
    "Victory",
    "Gray",
    "Lily",
    "London",
    "Marydell",
    "Sasser",
    "Tuttle",
    "Rockholds",
    "Meadow Creek",
    "Siler",
    "Williamsburg",
    "Cumberland College",
    "Cumberlnd Clg",
    "Nevisdale",
    "Ages Brookside",
    "Ages Brooksde",
    "Asher",
    "Baxter",
    "Keith",
    "Benham",
    "Big Laurel",
    "Bledsoe",
    "Pine Mountain",
    "Calvin",
    "Cawood",
    "Crummies",
    "Three Point",
    "Chappell",
    "Coalgood",
    "Coldiron",
    "Molus",
    "Cranks",
    "Cumberland",
    "Chad",
    "Hiram",
    "Oven Fork",
    "Dayhoit",
    "Eolia",
    "Essie",
    "Evarts",
    "Bailey Creek",
    "Dizney",
    "Louellen",
    "Redbud",
    "Woods",
    "Yocum Creek",
    "Grays Knob",
    "Gulston",
    "Harlan",
    "Chevrolet",
    "Smith",
    "Helton",
    "Holmes Mill",
    "Hoskinston",
    "Hulen",
    "Kenvir",
    "Lejunior",
    "Loyall",
    "Lynch",
    "Miracle",
    "Mozelle",
    "Partridge",
    "Pathfork",
    "Alva",
    "Putney",
    "Stinnett",
    "Totz",
    "Wallins Creek",
    "Warbranch",
    "Arjay",
    "Artemus",
    "Barbourville",
    "Bailey Switch",
    "Baughman",
    "Crane Nest",
    "Gausdale",
    "Himyar",
    "Jarvis",
    "Kayjay",
    "Swanpond",
    "Tedders",
    "Woollum",
    "Beverly",
    "Red Bird",
    "Big Creek",
    "Peabody",
    "Bimble",
    "Bryants Store",
    "Cannon",
    "Closplint",
    "Flat Lick",
    "Mills",
    "Salt Gum",
    "Fourmile",
    "Elys",
    "Ivy Grove",
    "Frakes",
    "Fonde",
    "Laurel Fork",
    "Garrard",
    "Girdler",
    "Green Road",
    "Heidrick",
    "Hinkle",
    "Kettle Island",
    "Manchester",
    "Bluehole",
    "Bright Shade",
    "Chestnutburg",
    "Eriline",
    "Fogertown",
    "Grace",
    "Marcum",
    "Ogle",
    "Plank",
    "Tanksley",
    "Urban",
    "Wildcat",
    "Mary Alice",
    "Middlesboro",
    "Oneida",
    "Pineville",
    "Balkan",
    "Callaway",
    "Cary",
    "Chenoa",
    "Clear Creek",
    "Clear Creek Springs",
    "Clear Crk Spg",
    "Davisburg",
    "Dorton Branch",
    "E Pineville",
    "East Pineville",
    "Field",
    "Jenson",
    "Log Mountain",
    "Tinsley",
    "Wallsend",
    "Roark",
    "Saul",
    "Scalf",
    "Sextons Creek",
    "Stoney Fork",
    "Trosper",
    "Walker",
    "Alexandria",
    "Augusta",
    "Berry",
    "Brooksville",
    "Milford",
    "Burlington",
    "Rabbit Hash",
    "Butler",
    "California",
    "Mentor",
    "Carrollton",
    "Corinth",
    "Blanchet",
    "Covington",
    "Ft Mitchell",
    "Ft Wright",
    "Park Hills",
    "Latonia",
    "Latonia Lakes",
    "Ryland Heights",
    "Ryland Hght",
    "Ryland Hgts",
    "Taylor Mill",
    "Bromley",
    "Ludlow",
    "Crescent Park",
    "Crescent Spg",
    "Crescent Spgs",
    "Crescent Springs",
    "Crestview Hills",
    "Crestview Hls",
    "Edgewood",
    "Erlanger",
    "Fort Mitchell",
    "Lakeside Park",
    "S Ft Mitchell",
    "South Fort Mitchell",
    "Villa Hills",
    "Elsmere",
    "Crittenden",
    "Cynthiana",
    "De Mossville",
    "Demossville",
    "Dover",
    "Dry Ridge",
    "Ewing",
    "Falmouth",
    "Pendletn Cnty",
    "Flemingsburg",
    "Florence",
    "Foster",
    "Germantown",
    "Ghent",
    "Glencoe",
    "Hebron",
    "Hillsboro",
    "Independence",
    "Jonesville",
    "Mayslick",
    "Maysville",
    "Sardis",
    "Melbourne",
    "Morning View",
    "Mount Olivet",
    "Newport",
    "Fort Thomas",
    "Southgate",
    "Wilder",
    "Bellevue",
    "Dayton",
    "Kenton Vale",
    "Cold Sprgs Hi",
    "Cold Sprgs Highland Hts",
    "Cold Spring",
    "Highland Heights",
    "Highland Hgts",
    "Petersburg",
    "Sanders",
    "Silver Grove",
    "Sparta",
    "Union",
    "Verona",
    "Wallingford",
    "Muses Mills",
    "Walton",
    "Warsaw",
    "Napoleon",
    "Williamstown",
    "Worthville",
    "Ashland",
    "Summitt",
    "Westwood",
    "Argillite",
    "Blaine",
    "Catlettsburg",
    "Denton",
    "Emerson",
    "Head Of Grass",
    "Head Of Grassy",
    "Flatwoods",
    "Russell",
    "Garrison",
    "Grahn",
    "Grayson",
    "Fultz",
    "Johns Run",
    "Greenup",
    "Lloyd",
    "Load",
    "Oldtown",
    "Wurtland",
    "Hitchins",
    "Isonville",
    "Martha",
    "Olive Hill",
    "Lawton",
    "Stark",
    "Upper Tygart",
    "Wolf",
    "Quincy",
    "Saint Paul",
    "Rush",
    "Raceland",
    "Sandy Hook",
    "Bruin",
    "Burke",
    "Culver",
    "Little Sandy",
    "Lytten",
    "Newfoundland",
    "Stephens",
    "South Portsmouth",
    "Firebrick",
    "S Portsmouth",
    "South Shore",
    "Vanceburg",
    "Camp Dix",
    "Concord",
    "Trinity",
    "Webbville",
    "Willard",
    "Worthington",
    "Tollesboro",
    "Adams",
    "Louisa",
    "Beauty",
    "Boons Camp",
    "Debord",
    "Davella",
    "East Point",
    "Flatgap",
    "Elna",
    "Fuget",
    "Redbush",
    "Volga",
    "Hagerhill",
    "Denver",
    "Leander",
    "Inez",
    "Job",
    "Threeforks",
    "Keaton",
    "Clifford",
    "Fallsburg",
    "Richardson",
    "Lovely",
    "Lowmansville",
    "Meally",
    "Oil Springs",
    "Manila",
    "Paintsville",
    "Nippa",
    "Offutt",
    "Swamp Branch",
    "Thealka",
    "Whitehouse",
    "Pilgrim",
    "Laura",
    "River",
    "Sitka",
    "Staffordsville",
    "Barnetts Creek",
    "Barnetts Crk",
    "Staffordsvlle",
    "Stambaugh",
    "Thelma",
    "Tomahawk",
    "Davisport",
    "Milo",
    "Tutor Key",
    "Ulysses",
    "Van Lear",
    "Warfield",
    "Hode",
    "West Van Lear",
    "Williamsport",
    "Wittensville",
    "Campton",
    "Bethany",
    "Burkhart",
    "Flat",
    "Gillmore",
    "Lee City",
    "Leeco",
    "Mary",
    "Maytown",
    "Valeria",
    "Zachariah",
    "Bays",
    "Beattyville",
    "Fillmore",
    "Old Landing",
    "Primrose",
    "Tallega",
    "Vada",
    "Widecreek",
    "Yellow Rock",
    "Booneville",
    "Green Hall",
    "Island City",
    "Morris Fork",
    "Pebworth",
    "Sebastians Br",
    "Sebastians Branch",
    "Turkey",
    "Clayhole",
    "Hazel Green",
    "Buskirk",
    "Helechawa",
    "Insko",
    "Jackson",
    "Altro",
    "Athol",
    "Canoe",
    "Decoy",
    "Elkatawa",
    "Frozen Creek",
    "Guage",
    "Guerrant",
    "Haddix",
    "Lambric",
    "Noctor",
    "Quicksand",
    "Saldee",
    "Talbert",
    "Wolf Coal",
    "Wolverine",
    "Lost Creek",
    "Hardshell",
    "Ned",
    "Mistletoe",
    "Mize",
    "Grassy Creek",
    "Pine Ridge",
    "Ricetown",
    "Rogers",
    "Rousseau",
    "Rowdy",
    "Vancleve",
    "Vincent",
    "Whick",
    "Zoe",
    "Cannel City",
    "Elkfork",
    "Ezel",
    "Royalton",
    "Gypsy",
    "Salyersville",
    "Bethanna",
    "Burning Fork",
    "Carver",
    "Cisco",
    "Conley",
    "Cutuno",
    "Cyrus",
    "Duco",
    "Edna",
    "Elsie",
    "Ever",
    "Flat Fork",
    "Foraker",
    "Fredville",
    "Fritz",
    "Gapville",
    "Gifford",
    "Hager",
    "Harper",
    "Hendricks",
    "Ivyton",
    "Lickburg",
    "Logville",
    "Maggard",
    "Marshallville",
    "Mashfork",
    "Seitz",
    "Stella",
    "Sublett",
    "Swampton",
    "Wonnie",
    "West Liberty",
    "Blairs Mill",
    "Blaze",
    "Caney",
    "Cottle",
    "Dingus",
    "Elamton",
    "Index",
    "Lenox",
    "Matthew",
    "Mima",
    "Moon",
    "Ophir",
    "Relief",
    "Silverhill",
    "Stacy Fork",
    "White Oak",
    "Yocum",
    "Pikeville",
    "Broad Bottom",
    "Gulnare",
    "Mccombs",
    "Meta",
    "Nelse",
    "Piso",
    "South Williamson",
    "S Williamson",
    "Ashcamp",
    "Belcher",
    "Belfry",
    "Aflex",
    "Burnwell",
    "Goody",
    "Hatfield",
    "Toler",
    "Turkey Creek",
    "Burdine",
    "Canada",
    "Elkhorn City",
    "Draffin",
    "Senterville",
    "Fedscreek",
    "Biggs",
    "Fords Branch",
    "Forest Hills",
    "Freeburn",
    "Hardy",
    "Hellier",
    "Huddy",
    "Jenkins",
    "Payne Gap",
    "Jonancy",
    "Kimper",
    "Lick Creek",
    "McAndrews",
    "McCarr",
    "Majestic",
    "Mouthcard",
    "Phelps",
    "Jamboree",
    "Paw Paw",
    "Phyllis",
    "Pinsonfork",
    "Mcveigh",
    "Raccoon",
    "Fishtrap",
    "Jonican",
    "Ransom",
    "Regina",
    "Robinson Creek",
    "Robinson Crk",
    "Shelbiana",
    "Shelby Gap",
    "Sidney",
    "Steele",
    "Stone",
    "Stopover",
    "Argo",
    "Woodman",
    "Varney",
    "Virgie",
    "Etty",
    "Speight",
    "Allen",
    "Auxier",
    "Banner",
    "Honaker",
    "Beaver",
    "Ligon",
    "Betsy Layne",
    "Bevinsville",
    "Halo",
    "Blue River",
    "Bypro",
    "Dana",
    "David",
    "Drift",
    "Dwale",
    "Eastern",
    "Garrett",
    "Grethel",
    "Gunlock",
    "Waldo",
    "Harold",
    "Craynor",
    "Galveston",
    "Hi Hat",
    "Buckingham",
    "Price",
    "Hueysville",
    "Elmrock",
    "Ivel",
    "Lackey",
    "Langley",
    "McDowell",
    "E Mc Dowell",
    "East Mc Dowell",
    "Orkney",
    "Martin",
    "Hite",
    "Risner",
    "Melvin",
    "Minnie",
    "Prestonsburg",
    "Emma",
    "Endicott",
    "Hippo",
    "Printer",
    "Hunter",
    "Stanville",
    "Teaberry",
    "Tram",
    "Wayland",
    "Estill",
    "Weeksbury",
    "Wheelwright",
    "Hazard",
    "Browns Fork",
    "Typo",
    "Walkertown",
    "Ary",
    "Avawam",
    "Bear Branch",
    "Bonnyman",
    "Blue Diamond",
    "Butterfly",
    "Buckhorn",
    "Bulan",
    "Hardburly",
    "Talcum",
    "Tribbey",
    "Busy",
    "Carrie",
    "Chavies",
    "Combs",
    "Cornettsville",
    "Daisy",
    "Leatherwood",
    "Ulvah",
    "Delphia",
    "Dwarf",
    "Emmalena",
    "Bearville",
    "Tina",
    "Gays Creek",
    "Happy",
    "Hyden",
    "Confluence",
    "Dryhill",
    "Kaliopi",
    "Jeff",
    "Krypton",
    "Napfor",
    "Sassafras",
    "Anco",
    "Scuddy",
    "Sizerock",
    "Slemp",
    "Smilax",
    "Thousandsticks",
    "Thsandsticks",
    "Vest",
    "Vicco",
    "Allock",
    "Amburgey",
    "Viper",
    "Farler",
    "Wendover",
    "Wooton",
    "Cinda",
    "Cutshin",
    "Frew",
    "Yeaddiss",
    "Big Rock",
    "Yerkes",
    "Blackey",
    "Carcassonne",
    "Cromona",
    "Deane",
    "Ermine",
    "Garner",
    "Larkslane",
    "Gordon",
    "Gilly",
    "Hallie",
    "Skyline",
    "Hindman",
    "Brinkley",
    "Isom",
    "Jackhorn",
    "Jeremiah",
    "Kite",
    "Leburn",
    "Soft Shell",
    "Letcher",
    "Linefork",
    "Littcarr",
    "McRoberts",
    "Mallie",
    "Mayking",
    "Millstone",
    "Mousie",
    "Neon",
    "Fleming",
    "Fleming Neon",
    "Hall",
    "Pine Top",
    "Pippa Passes",
    "Hollybush",
    "Premium",
    "Redfox",
    "Roxana",
    "Seco",
    "Thornton",
    "Whitesburg",
    "Crown",
    "Democrat",
    "Dongola",
    "Kona",
    "Oscaloosa",
    "Van",
    "Dema",
    "Raven",
    "Topmost",
    "Dry Creek",
    "Paducah",
    "Almo",
    "Arlington",
    "Bandana",
    "Bardwell",
    "Barlow",
    "Benton",
    "Boaz",
    "Burna",
    "Calvert City",
    "Clinton",
    "Columbus",
    "Cunningham",
    "Dexter",
    "Dycusburg",
    "Eddyville",
    "Fancy Farm",
    "Farmington",
    "Fulton",
    "Crutchfield",
    "Gilbertsville",
    "Grand Rivers",
    "Iuka",
    "Hampton",
    "Hardin",
    "Hazel",
    "Hickman",
    "Hickory",
    "Kevil",
    "Kirksey",
    "Kuttawa",
    "La Center",
    "Ledbetter",
    "Lovelaceville",
    "Lowes",
    "Marion",
    "Mayfield",
    "Melber",
    "Murray",
    "New Concord",
    "Hamlin",
    "Salem",
    "Lola",
    "Sedalia",
    "Smithland",
    "Carrsville",
    "Symsonia",
    "Tiline",
    "Water Valley",
    "West Paducah",
    "Wickliffe",
    "Blandville",
    "Wingo",
    "Bowling Green",
    "Hadley",
    "Plum Springs",
    "Richardsville",
    "Adolphus",
    "Alvaton",
    "Austin",
    "Beaumont",
    "Cave City",
    "Edmonton",
    "Subtle",
    "Sulphur Well",
    "Eighty Eight",
    "Etoile",
    "Fountain Run",
    "Franklin",
    "Gamaliel",
    "Glasgow",
    "Lamb",
    "Hestand",
    "Holland",
    "Knob Lick",
    "Lucas",
    "Mount Hermon",
    "Oakland",
    "Park City",
    "Rocky Hill",
    "Scottsville",
    "Halfway",
    "Summer Shade",
    "Willow Shade",
    "Tompkinsville",
    "T Ville",
    "Woodburn",
    "Smiths Grove",
    "Adairville",
    "Allensville",
    "Auburn",
    "South Union",
    "Bee Spring",
    "Brownsville",
    "Huff",
    "Lindseyville",
    "Sunfish",
    "Cadiz",
    "Canton",
    "Golden Pond",
    "Center",
    "Cerulean",
    "Crofton",
    "Elkton",
    "Allegre",
    "Fort Campbell",
    "Gracey",
    "Guthrie",
    "Tiny Town",
    "Herndon",
    "Hopkinsville",
    "Jetson",
    "La Fayette",
    "Lewisburg",
    "Quality",
    "Mammoth Cave",
    "Mammoth Cave National Park",
    "Ollie",
    "Morgantown",
    "Brooklyn",
    "Huntsville",
    "Logansport",
    "Provo",
    "Welchs Creek",
    "Oak Grove",
    "Olmstead",
    "Pembroke",
    "Rochester",
    "Rockfield",
    "Browning",
    "Roundhill",
    "Russellville",
    "Oakville",
    "Sharon Grove",
    "Sweeden",
    "Kyrock",
    "Trenton",
    "Owensboro",
    "Saint Joseph",
    "St Joseph",
    "Stanley",
    "Beaver Dam",
    "Beech Creek",
    "Beech Grove",
    "Beechmont",
    "Belton",
    "Bremen",
    "Browder",
    "Calhoun",
    "W Louisville",
    "West Louisville",
    "Centertown",
    "Central City",
    "Central Cty",
    "Cleaton",
    "Cromwell",
    "Drakesboro",
    "Dundee",
    "Dunmor",
    "Penrod",
    "Fordsville",
    "Graham",
    "Greenville",
    "Hartford",
    "Narrows",
    "Hawesville",
    "Horse Branch",
    "Island",
    "Lewisport",
    "Livermore",
    "McHenry",
    "Maceo",
    "Maple Mount",
    "Olaton",
    "Philpot",
    "Knottsville",
    "Powderly",
    "Reynolds Station",
    "Reynolds Sta",
    "Rockport",
    "Rosine",
    "Rumsey",
    "Sacramento",
    "South Carrollton",
    "S Carrollton",
    "Utica",
    "Whitesville",
    "Clay",
    "Blackford",
    "Corydon",
    "Dawson Springs",
    "Dawson Spgs",
    "Dixon",
    "Earlington",
    "Fredonia",
    "Hanson",
    "Henderson",
    "Madisonville",
    "Manitou",
    "Morganfield",
    "Henshaw",
    "Mortons Gap",
    "Nebo",
    "Nortonville",
    "Poole",
    "Princeton",
    "Providence",
    "Reed",
    "Robards",
    "Saint Charles",
    "Sebree",
    "Slaughters",
    "Spottsville",
    "Sturgis",
    "Uniontown",
    "Waverly",
    "Wheatcroft",
    "White Plains",
    "Somerset",
    "Acorn",
    "Alcalde",
    "Elihu",
    "Poplarville",
    "Public",
    "Ruth",
    "Stab",
    "Walnut Grove",
    "Bethelridge",
    "Bronston",
    "Burnside",
    "Sloans Valley",
    "Dunnville",
    "Ferguson",
    "Liberty",
    "Clementsville",
    "Middleburg",
    "Nancy",
    "Cains Store",
    "Faubush",
    "Ingle",
    "Jabez",
    "Naomi",
    "Pointer",
    "Trimble",
    "Science Hill",
    "Windsor",
    "Yosemite",
    "Eubank",
    "Pulaski",
    "Albany",
    "Aaron",
    "Browns Crossroads",
    "Browns Xroads",
    "Highway",
    "Seminary",
    "Seventy Six",
    "Snow",
    "Static",
    "Alpha",
    "Jamestown",
    "Bryan",
    "Creelsboro",
    "Rowena",
    "Sewellton",
    "Marshes Siding",
    "Marshes Sdng",
    "Monticello",
    "Barrier",
    "Bethesda",
    "Betsey",
    "Coopersville",
    "Delta",
    "Frazer",
    "Frisby",
    "Gregory",
    "Mill Springs",
    "Mount Pisgah",
    "Number One",
    "Oil Valley",
    "Parnell",
    "Powersburg",
    "Pueblo",
    "Ritner",
    "Rockybranch",
    "Slat",
    "Steubenville",
    "Stop",
    "Sunnybrook",
    "Susie",
    "Touristville",
    "Windy",
    "Parkers Lake",
    "Greenwood",
    "Honeybee",
    "Sawyer",
    "Pine Knot",
    "Revelo",
    "Russell Springs",
    "Russell Spgs",
    "Webbs Cross Roads",
    "Webbs Xrds",
    "Stearns",
    "Strunk",
    "Whitley City",
    "Elizabethtown",
    "E Town",
    "Big Clifty",
    "Bonnieville",
    "Breeding",
    "Buffalo",
    "Burkesville",
    "Bakerton",
    "Bow",
    "Dubre",
    "Kettle",
    "Peytonsburg",
    "Waterview",
    "Campbellsville",
    "Campbellsvlle",
    "Finley",
    "Caneyville",
    "Neafus",
    "Spring Lick",
    "Canmer",
    "Cecilia",
    "Stephensburg",
    "Vertrees",
    "Clarkson",
    "Millerstown",
    "Peonia",
    "Rock Creek",
    "Wax",
    "Columbia",
    "Casey Creek",
    "Cundiff",
    "Fairplay",
    "Milltown",
    "Montpelier",
    "Cub Run",
    "Eastview",
    "Meeting Creek",
    "Summit",
    "Elk Horn",
    "Glendale",
    "Glens Fork",
    "Gradyville",
    "Greensburg",
    "Hardyville",
    "Hodgenville",
    "White City",
    "Horse Cave",
    "Park",
    "Knifley",
    "Leitchfield",
    "Magnolia",
    "Mannsville",
    "Marrowbone",
    "Millwood",
    "Mount Sherman",
    "Munfordville",
    "Rowletts",
    "Sonora",
    "Summersville",
    "Upton",
    "White Mills",
  ],
  LA: [
    "Metairie",
    "Des Allemands",
    "Ama",
    "Arabi",
    "Barataria",
    "Belle Chasse",
    "Boothville",
    "Boutte",
    "Braithwaite",
    "Carlisle",
    "Buras",
    "Chalmette",
    "Destrehan",
    "Edgard",
    "Empire",
    "Garyville",
    "Gramercy",
    "Gretna",
    "Terrytown",
    "Hahnville",
    "Killona",
    "Harvey",
    "Kenner",
    "Lafitte",
    "Jean Lafitte",
    "La Place",
    "Montz",
    "Luling",
    "Lutcher",
    "Marrero",
    "Meraux",
    "Mount Airy",
    "Norco",
    "Paradis",
    "Pointe A La Hache",
    "Davant",
    "Pt A La Hache",
    "Port Sulphur",
    "Reserve",
    "Saint Bernard",
    "Saint James",
    "Saint Rose",
    "Vacherie",
    "Venice",
    "Violet",
    "Westwego",
    "Avondale",
    "Bridge City",
    "Fairfield",
    "Nine Mile Point",
    "Nine Mile Pt",
    "New Orleans",
    "Jefferson",
    "Elmwood",
    "Harahan",
    "River Ridge",
    "English Turn",
    "Thibodaux",
    "Pierre Part",
    "Amelia",
    "Belle Rose",
    "Berwick",
    "Bourg",
    "Chauvin",
    "Cut Off",
    "Donaldsonville",
    "Donaldsonvlle",
    "Modeste",
    "Donner",
    "Dulac",
    "Galliano",
    "Gheens",
    "Gibson",
    "Golden Meadow",
    "Grand Isle",
    "Gray",
    "Houma",
    "Labadieville",
    "Larose",
    "Lockport",
    "Mathews",
    "Montegut",
    "Morgan City",
    "Napoleonville",
    "Paincourtville",
    "Paincourtvlle",
    "Patterson",
    "Plattenville",
    "Raceland",
    "Schriever",
    "Theriot",
    "Hammond",
    "Abita Springs",
    "Amite",
    "Hillsdale",
    "Montpelier",
    "Angie",
    "Bogalusa",
    "Bush",
    "Covington",
    "Fluker",
    "Folsom",
    "Franklinton",
    "Sheridan",
    "Greensburg",
    "Husser",
    "Independence",
    "Kentwood",
    "New Zion",
    "Lacombe",
    "Loranger",
    "Madisonville",
    "Mandeville",
    "Maurepas",
    "Mount Hermon",
    "Natalbany",
    "Pearl River",
    "Pine Grove",
    "Ponchatoula",
    "Robert",
    "Roseland",
    "Saint Benedict",
    "St Benedict",
    "Slidell",
    "Springfield",
    "Sun",
    "Talisheek",
    "Tangipahoa",
    "Tickfaw",
    "Lafayette",
    "Abbeville",
    "Cow Island",
    "Meaux",
    "Arnaudville",
    "Avery Island",
    "Baldwin",
    "Basile",
    "Branch",
    "Breaux Bridge",
    "Butte Larose",
    "Henderson",
    "Broussard",
    "Cade",
    "Carencro",
    "Centerville",
    "Charenton",
    "Chataignier",
    "Church Point",
    "Crowley",
    "Delcambre",
    "Duson",
    "Egan",
    "Elton",
    "Erath",
    "Estherwood",
    "Eunice",
    "Evangeline",
    "Franklin",
    "Cypremort Point",
    "Cypremort Pt",
    "Grand Coteau",
    "Gueydan",
    "Iota",
    "Jeanerette",
    "Jennings",
    "Kaplan",
    "Lake Arthur",
    "Lawtell",
    "Leonville",
    "Loreauville",
    "Mamou",
    "Maurice",
    "Mermentau",
    "Milton",
    "Morse",
    "Midland",
    "New Iberia",
    "Opelousas",
    "Perry",
    "Pine Prairie",
    "Port Barre",
    "Rayne",
    "Reddell",
    "Roanoke",
    "Saint Martinville",
    "Parks",
    "St Martinvlle",
    "Scott",
    "Sunset",
    "Cankton",
    "Turkey Creek",
    "Ville Platte",
    "Washington",
    "Welsh",
    "Youngsville",
    "Lake Charles",
    "Moss Bluff",
    "Bell City",
    "Cameron",
    "Creole",
    "Dequincy",
    "Deridder",
    "Dry Creek",
    "Elizabeth",
    "Evans",
    "Fenton",
    "Grand Chenier",
    "Grant",
    "Hackberry",
    "Hayes",
    "Iowa",
    "Kinder",
    "Lacassine",
    "Leblanc",
    "Longville",
    "Merryville",
    "Fields",
    "Mittie",
    "Oberlin",
    "Pitkin",
    "Fullerton",
    "Ragley",
    "Reeves",
    "Rosepine",
    "Singer",
    "Starks",
    "Sugartown",
    "Sulphur",
    "Vinton",
    "Westlake",
    "Denham Springs",
    "Denham Spgs",
    "Addis",
    "Albany",
    "Angola",
    "Baker",
    "Batchelor",
    "Brusly",
    "Carville",
    "Clinton",
    "Convent",
    "Darrow",
    "Dennis Mills",
    "Port Vincent",
    "Erwinville",
    "Bueche",
    "Ethel",
    "Fordoche",
    "French Settlement",
    "Fr Settlement",
    "Geismar",
    "Glynn",
    "Gonzales",
    "Greenwell Springs",
    "Greenwel Spgs",
    "Grosse Tete",
    "Hester",
    "Holden",
    "Innis",
    "Jackson",
    "The Bluffs",
    "Jarreau",
    "Krotz Springs",
    "Lakeland",
    "Lettsworth",
    "Livingston",
    "Livonia",
    "Lottie",
    "Blanks",
    "Maringouin",
    "Ramah",
    "Morganza",
    "Labarre",
    "New Roads",
    "Norwood",
    "Oscar",
    "Torbert",
    "Paulina",
    "Plaquemine",
    "Port Allen",
    "Prairieville",
    "Galvez",
    "Pride",
    "Rosedale",
    "Rougon",
    "Saint Amant",
    "Saint Francisville",
    "Bains",
    "Hardwood",
    "St Francisvle",
    "Starhill",
    "Saint Gabriel",
    "Iberville",
    "Slaughter",
    "Sorrento",
    "Sunshine",
    "Tunica",
    "Ventress",
    "Walker",
    "Watson",
    "Weyanoke",
    "White Castle",
    "Bayou Goula",
    "Wilson",
    "Zachary",
    "Baton Rouge",
    "Scotlandville",
    "Arcadia",
    "Ashland",
    "Athens",
    "Belcher",
    "Benton",
    "Bethany",
    "Bienville",
    "Bryceland",
    "Blanchard",
    "Castor",
    "Cotton Valley",
    "Coushatta",
    "Cullen",
    "Doyline",
    "Dubberly",
    "Frierson",
    "Gibsland",
    "Gilliam",
    "Gloster",
    "Goldonna",
    "Grand Cane",
    "Greenwood",
    "Hall Summit",
    "Haughton",
    "Haynesville",
    "Heflin",
    "Homer",
    "Hosston",
    "Ida",
    "Mira",
    "Jamestown",
    "Keatchie",
    "Keithville",
    "Lisbon",
    "Logansport",
    "Stanley",
    "Elm Grove",
    "Mansfield",
    "S Mansfield",
    "South Mansfield",
    "Minden",
    "Dixie Inn",
    "Mooringsport",
    "Oil City",
    "Pelican",
    "Plain Dealing",
    "Pleasant Hill",
    "Powhatan",
    "Princeton",
    "Ringgold",
    "Rodessa",
    "Saline",
    "Chestnut",
    "Creston",
    "Sarepta",
    "Shongaloo",
    "Sibley",
    "Springhill",
    "Stonewall",
    "Summerfield",
    "Vivian",
    "Trees",
    "Shreveport",
    "Forbing",
    "Dixie",
    "Barksdale Afb",
    "Bossier City",
    "Caspiana",
    "Monroe",
    "Richwood",
    "Archibald",
    "Baskin",
    "Bastrop",
    "Bernice",
    "Bonita",
    "Calhoun",
    "Chatham",
    "Choudrant",
    "Collinston",
    "Crowville",
    "Delhi",
    "Warden",
    "Waverly",
    "Delta",
    "Downsville",
    "Dubach",
    "Epps",
    "Eros",
    "Farmerville",
    "Forest",
    "Fort Necessity",
    "Extension",
    "Ft Necessity",
    "Grambling",
    "Hodge",
    "Jones",
    "Jonesboro",
    "Kilbourne",
    "Lake Providence",
    "Lk Providence",
    "Lillie",
    "Junction City",
    "Mangham",
    "Marion",
    "Linville",
    "Mer Rouge",
    "Oak Grove",
    "Terry",
    "Oak Ridge",
    "Pioneer",
    "Quitman",
    "Rayville",
    "Alto",
    "Girard",
    "Holly Ridge",
    "Ruston",
    "Simsboro",
    "Sondheimer",
    "Spearsville",
    "Start",
    "Sterlington",
    "Spencer",
    "Tallulah",
    "Mound",
    "Richmond",
    "Transylvania",
    "West Monroe",
    "Winnsboro",
    "Alexandria",
    "Acme",
    "Bordelonville",
    "Bunkie",
    "Eola",
    "Whitehall",
    "Center Point",
    "Cheneyville",
    "Clayton",
    "Cottonport",
    "Deville",
    "Buckeye",
    "Echo",
    "Effie",
    "Vick",
    "Evergreen",
    "Goudeau",
    "Ferriday",
    "Frogmore",
    "Ridgecrest",
    "Gilbert",
    "Hamburg",
    "Harrisonburg",
    "Hessmer",
    "Jena",
    "Jonesville",
    "Larto",
    "Lebeau",
    "Rosa",
    "Lecompte",
    "Mansura",
    "Marksville",
    "Melville",
    "Monterey",
    "Moreauville",
    "Morrow",
    "Le Moyen",
    "Newellton",
    "Palmetto",
    "Pineville",
    "Camp Beauregard",
    "Cp Beauregard",
    "Kolin",
    "Plaucheville",
    "Saint Joseph",
    "Saint Landry",
    "Sicily Island",
    "Simmesport",
    "Trout",
    "Vidalia",
    "Waterproof",
    "Wisner",
    "Aimwell",
    "Anacoco",
    "Atlanta",
    "Ball",
    "Pollock",
    "Belmont",
    "Bentley",
    "Boyce",
    "Gardner",
    "Calvin",
    "Campti",
    "Clarence",
    "Clarks",
    "Cloutierville",
    "Derry",
    "Colfax",
    "Columbia",
    "Converse",
    "Mitchell",
    "Dodson",
    "Dry Prong",
    "Creola",
    "Elmer",
    "Enterprise",
    "Fisher",
    "Flatwoods",
    "Flora",
    "Florien",
    "Forest Hill",
    "Georgetown",
    "Glenmora",
    "Melder",
    "Gorum",
    "Grayson",
    "Hineston",
    "Lacamp",
    "Leander",
    "Hornbeck",
    "Kelly",
    "Leesville",
    "Hicks",
    "Lena",
    "Chopin",
    "Clifton",
    "Many",
    "Marthaville",
    "Melrose",
    "Montgomery",
    "Verda",
    "Mora",
    "Natchez",
    "Natchitoches",
    "Cypress",
    "Fort Johnson",
    "New Llano",
    "Noble",
    "Oakdale",
    "Olla",
    "Otis",
    "Provencal",
    "Robeline",
    "Sieper",
    "Sikes",
    "Simpson",
    "Temple",
    "Slagle",
    "Tullos",
    "Urania",
    "Winnfield",
    "Woodworth",
    "Zwolle",
  ],
  MA: [
    "Agawam",
    "Amherst",
    "Cushman",
    "Pelham",
    "Barre",
    "Belchertown",
    "Blandford",
    "Bondsville",
    "Brimfield",
    "Chester",
    "Chesterfield",
    "Chicopee",
    "Willimansett",
    "Westover AFB",
    "Cummington",
    "Easthampton",
    "E Hampton",
    "Mount Tom",
    "Westhampton",
    "East Longmeadow",
    "E Longmeadow",
    "East Otis",
    "Feeding Hills",
    "Gilbertville",
    "Goshen",
    "Granby",
    "Granville",
    "Tolland",
    "Hadley",
    "Hampden",
    "Hardwick",
    "Hatfield",
    "Haydenville",
    "West Whately",
    "Holyoke",
    "Huntington",
    "Montgomery",
    "Leeds",
    "Leverett",
    "Ludlow",
    "Monson",
    "Northampton",
    "Florence",
    "Bay State Village",
    "Bay State Vlg",
    "North Hatfield",
    "N Hatfield",
    "Oakham",
    "Palmer",
    "Plainfield",
    "Russell",
    "Shutesbury",
    "Southampton",
    "South Barre",
    "South Hadley",
    "Southwick",
    "Thorndike",
    "Three Rivers",
    "Wales",
    "Ware",
    "Warren",
    "West Chesterfield",
    "W Chesterfld",
    "Westfield",
    "West Hatfield",
    "W Hatfield",
    "West Springfield",
    "W Springfield",
    "West Warren",
    "Whately",
    "Wheelwright",
    "Wilbraham",
    "Williamsburg",
    "Woronoco",
    "Worthington",
    "Springfield",
    "Longmeadow",
    "Indian Orchard",
    "Indian Orch",
    "Pittsfield",
    "Adams",
    "Ashley Falls",
    "Becket",
    "Washington",
    "Berkshire",
    "Lanesborough",
    "Cheshire",
    "Dalton",
    "Glendale",
    "Great Barrington",
    "Egremont",
    "Gt Barrington",
    "N Egremont",
    "New Marlboro",
    "New Marlborou",
    "New Marlborough",
    "North Egremont",
    "Simons Rock",
    "Hinsdale",
    "Peru",
    "Housatonic",
    "Hancock",
    "New Ashford",
    "Lee",
    "Lenox",
    "Lenox Dale",
    "Middlefield",
    "Mill River",
    "Monterey",
    "West Otis",
    "North Adams",
    "Clarksburg",
    "Florida",
    "Otis",
    "Richmond",
    "Sandisfield",
    "Savoy",
    "Sheffield",
    "South Egremont",
    "Mount Washington",
    "Mt Washington",
    "S Egremont",
    "Southfield",
    "South Lee",
    "Stockbridge",
    "Tyringham",
    "West Stockbridge",
    "Alford",
    "W Stockbridge",
    "Williamstown",
    "Windsor",
    "Greenfield",
    "Leyden",
    "Ashfield",
    "Athol",
    "Phillipston",
    "Bernardston",
    "Buckland",
    "Charlemont",
    "Hawley",
    "Colrain",
    "Shattuckville",
    "Conway",
    "Deerfield",
    "Drury",
    "Erving",
    "Heath",
    "Lake Pleasant",
    "Millers Falls",
    "Monroe Bridge",
    "Monroe",
    "Montague",
    "Gill",
    "Mount Hermon",
    "Mt Hermon",
    "Northfield Mount Hermon",
    "Northfield Mt Hermon",
    "New Salem",
    "Northfield",
    "Orange",
    "Warwick",
    "Petersham",
    "Rowe",
    "Royalston",
    "S Royalston",
    "Shelburne Falls",
    "Shelburne Fls",
    "South Deerfield",
    "S Deerfield",
    "Sunderland",
    "Turners Falls",
    "Wendell",
    "Wendell Depot",
    "Fitchburg",
    "Ashburnham",
    "Ashby",
    "Ayer",
    "Devens",
    "Baldwinville",
    "East Templeton",
    "E Templeton",
    "Gardner",
    "Groton",
    "Harvard",
    "Hubbardston",
    "Leominster",
    "Littleton",
    "Lunenburg",
    "Pepperell",
    "Shirley",
    "Shirley Center",
    "Shirley Ctr",
    "Templeton",
    "Townsend",
    "Westminster",
    "West Townsend",
    "W Townsend",
    "Winchendon",
    "Auburn",
    "Berlin",
    "Blackstone",
    "Boylston",
    "Brookfield",
    "Charlton",
    "Clinton",
    "East Brookfield",
    "E Brookfield",
    "Douglas",
    "East Douglas",
    "Fiskdale",
    "Sturbridge",
    "Grafton",
    "Holden",
    "Holland",
    "Jefferson",
    "Lancaster",
    "Leicester",
    "Linwood",
    "Millbury",
    "Millville",
    "New Braintree",
    "Northborough",
    "Northbridge",
    "North Brookfield",
    "N Brookfield",
    "North Grafton",
    "North Oxford",
    "Oxford",
    "Princeton",
    "Rochdale",
    "Rutland",
    "Shrewsbury",
    "Southbridge",
    "South Grafton",
    "South Lancaster",
    "S Lancaster",
    "Spencer",
    "Sterling",
    "Upton",
    "Uxbridge",
    "Webster",
    "Dudley Hill",
    "Dudley",
    "Westborough",
    "West Boylston",
    "West Brookfield",
    "W Brookfield",
    "Whitinsville",
    "Sutton",
    "Wilkinsonvile",
    "Wilkinsonville",
    "Worcester",
    "Cherry Valley",
    "Paxton",
    "Framingham",
    "Acton",
    "Boxborough",
    "Boxboro",
    "Ashland",
    "Bedford",
    "Hanscom Afb",
    "Bolton",
    "Carlisle",
    "Concord",
    "Fayville",
    "Southborough",
    "Holliston",
    "Hopedale",
    "Hopkinton",
    "Hudson",
    "Marlborough",
    "Maynard",
    "Mendon",
    "Milford",
    "Natick",
    "Sherborn",
    "Lincoln",
    "Stow",
    "Sudbury",
    "Wayland",
    "Woburn",
    "Burlington",
    "Andover",
    "Billerica",
    "Chelmsford",
    "Kates Corner",
    "S Chelmsford",
    "Dracut",
    "Dunstable",
    "Haverhill",
    "Georgetown",
    "Groveland",
    "Bradford",
    "Ward Hill",
    "Lawrence",
    "Methuen",
    "North Andover",
    "Lowell",
    "Merrimac",
    "North Billerica",
    "N Billerica",
    "North Chelmsford",
    "N Chelmsford",
    "North Reading",
    "Reading",
    "Tewksbury",
    "Tyngsboro",
    "Wakefield",
    "Westford",
    "Wilmington",
    "Winchester",
    "Lynn",
    "East Lynn",
    "West Lynn",
    "Saugus",
    "Swampscott",
    "Nahant",
    "Amesbury",
    "Beverly",
    "Boxford",
    "Byfield",
    "Newbury",
    "Danvers",
    "Essex",
    "Gloucester",
    "Hathorne",
    "Ipswich",
    "Lynnfield",
    "Manchester",
    "Manchester By The Sea",
    "Marblehead",
    "Middleton",
    "Newburyport",
    "Salisbury",
    "Salisbury Bch",
    "Salisbury Beach",
    "Peabody",
    "Prides Crossing",
    "Prides Xing",
    "Rockport",
    "Rowley",
    "Salem",
    "South Hamilton",
    "S Hamilton",
    "Topsfield",
    "Wenham",
    "West Newbury",
    "Bellingham",
    "Canton",
    "Cohasset",
    "Dedham",
    "Dover",
    "East Walpole",
    "Foxboro",
    "Foxborough",
    "Franklin",
    "Hingham",
    "Hull",
    "Humarock",
    "Mansfield",
    "Marshfield",
    "Medfield",
    "Medway",
    "Millis",
    "Norfolk",
    "Norwell",
    "Norwood",
    "Scituate",
    "Sharon",
    "South Walpole",
    "Stoughton",
    "Walpole",
    "Westwood",
    "Wrentham",
    "Boston",
    "Roxbury",
    "Roxbury Crossing",
    "Mission Hill",
    "Roxbury Xing",
    "Dorchester",
    "Grove Hall",
    "Dorchester Center",
    "Dorchestr Ctr",
    "Uphams Corner",
    "Mattapan",
    "South Boston",
    "East Boston",
    "Charlestown",
    "Jamaica Plain",
    "Roslindale",
    "West Roxbury",
    "Allston",
    "Brighton",
    "Hyde Park",
    "Readville",
    "Cambridge",
    "N Cambridge",
    "North Cambridge",
    "E Cambridge",
    "East Cambridge",
    "Somerville",
    "W Somerville",
    "West Somerville",
    "Winter Hill",
    "Malden",
    "Everett",
    "Chelsea",
    "Revere",
    "Winthrop",
    "Medford",
    "Quincy",
    "Wollaston",
    "North Quincy",
    "Squantum",
    "Melrose",
    "Stoneham",
    "Braintree",
    "Milton",
    "Weymouth",
    "East Weymouth",
    "South Weymouth",
    "S Weymouth",
    "North Weymouth",
    "N Weymouth",
    "Brockton",
    "Avon",
    "Bridgewater",
    "Carver",
    "Duxbury",
    "East Bridgewater",
    "E Bridgewater",
    "E Bridgewtr",
    "Halifax",
    "Hanover",
    "Hanson",
    "Holbrook",
    "Middleboro",
    "Lakeville",
    "Monponsett",
    "Abington",
    "North Easton",
    "Stonehill Clg",
    "Pembroke",
    "Plymouth",
    "Kingston",
    "South Carver",
    "Plympton",
    "Randolph",
    "Rockland",
    "South Easton",
    "West Bridgewater",
    "W Bridgewater",
    "Whitman",
    "Lexington",
    "Brookline",
    "Waltham",
    "North Waltham",
    "South Waltham",
    "Babson Park",
    "Newton",
    "Newtonville",
    "Newton Center",
    "Newton Centre",
    "Newton Highlands",
    "Newton Hlds",
    "Newton Lower Falls",
    "Newton L F",
    "Newton Upper Falls",
    "Newton U F",
    "West Newton",
    "Auburndale",
    "Chestnut Hill",
    "Boston Clg",
    "Boston College",
    "Waban",
    "Watertown",
    "E Watertown",
    "East Watertown",
    "Arlington",
    "E Arlington",
    "East Arlington",
    "Belmont",
    "Wellesley Hills",
    "Wellesley",
    "Wellesley Hls",
    "Needham",
    "Weston",
    "Needham Heights",
    "Needham Hgts",
    "Buzzards Bay",
    "Bourne",
    "Cataumet",
    "Chilmark",
    "Aquinnah",
    "Gay Head",
    "East Falmouth",
    "E Falmouth",
    "Ea Falmouth",
    "Hatchville",
    "Teaticket",
    "Waquoit",
    "East Sandwich",
    "E Sandwich",
    "East Wareham",
    "E Wareham",
    "Edgartown",
    "Falmouth",
    "Otis Angb",
    "Woods Hole",
    "Monument Beach",
    "Monument Bch",
    "Nantucket",
    "North Falmouth",
    "N Falmouth",
    "Oak Bluffs",
    "Onset",
    "Pocasset",
    "Sagamore",
    "Sagamore Beach",
    "Sagamore Bch",
    "Sandwich",
    "Siasconset",
    "Vineyard Haven",
    "Vineyard Hvn",
    "Wareham",
    "West Tisbury",
    "West Wareham",
    "Hyannis",
    "Barnstable",
    "Brewster",
    "Centerville",
    "Chatham",
    "Cotuit",
    "Cummaquid",
    "Dennis",
    "Dennis Port",
    "Dennisport",
    "East Dennis",
    "Eastham",
    "East Orleans",
    "Forestdale",
    "Harwich",
    "E Harwich",
    "East Harwich",
    "Harwich Port",
    "Hyannis Port",
    "Marstons Mills",
    "Marstons Mls",
    "Mashpee",
    "North Chatham",
    "North Truro",
    "Orleans",
    "Osterville",
    "Provincetown",
    "South Chatham",
    "South Dennis",
    "South Wellfleet",
    "S Wellfleet",
    "South Yarmouth",
    "Bass River",
    "S Yarmouth",
    "Truro",
    "Wellfleet",
    "West Barnstable",
    "W Barnstable",
    "West Dennis",
    "West Harwich",
    "West Hyannisport",
    "W Hyannisport",
    "West Yarmouth",
    "W Yarmouth",
    "Yarmouth Port",
    "Assonet",
    "Attleboro",
    "S Attleboro",
    "South Attleboro",
    "Cuttyhunk",
    "Dighton",
    "East Freetown",
    "East Taunton",
    "Fairhaven",
    "Fall River",
    "Somerset",
    "Marion",
    "Mattapoisett",
    "New Bedford",
    "Acushnet",
    "North Dartmouth",
    "Dartmouth",
    "N Dartmouth",
    "South Dartmouth",
    "Nonquitt",
    "S Dartmouth",
    "North Attleboro",
    "N Attleboro",
    "Plainville",
    "Attleboro Falls",
    "Attleboro Fls",
    "North Dighton",
    "N Dighton",
    "Norton",
    "Raynham",
    "Rehoboth",
    "Rochester",
    "Seekonk",
    "Swansea",
    "Berkley",
    "Taunton",
    "Westport",
    "Westport Point",
    "Westport Pt",
  ],
  MD: [
    "Waldorf",
    "Saint Charles",
    "Abell",
    "Accokeek",
    "Aquasco",
    "Eagle Harbor",
    "Avenue",
    "Bel Alton",
    "Benedict",
    "Brandywine",
    "Broomes Island",
    "Broomes Is",
    "Bryans Road",
    "Bryantown",
    "Bushwood",
    "California",
    "Callaway",
    "Chaptico",
    "Maddox",
    "Charlotte Hall",
    "Charlott Hall",
    "Cheltenham",
    "Clements",
    "Cobb Island",
    "Coltons Point",
    "Dameron",
    "Dowell",
    "Drayden",
    "Faulkner",
    "Great Mills",
    "Hollywood",
    "Hughesville",
    "Huntingtown",
    "Indian Head",
    "Pisgah",
    "Issue",
    "Swan Point",
    "La Plata",
    "Dentsville",
    "Leonardtown",
    "Lexington Park",
    "Lexington Pk",
    "Loveville",
    "Lusby",
    "Marbury",
    "Rison",
    "Mechanicsville",
    "Mechanicsvlle",
    "Morganza",
    "Mount Victoria",
    "Mt Victoria",
    "Nanjemoy",
    "Newburg",
    "Park Hall",
    "Patuxent River",
    "Patuxent Rvr",
    "Piney Point",
    "Pomfret",
    "Port Republic",
    "Port Tobacco",
    "Prince Frederick",
    "Dares Beach",
    "Prnc Frederck",
    "Ridge",
    "Saint Inigoes",
    "Saint Leonard",
    "Saint Marys City",
    "Saint Marys",
    "St Marys City",
    "Scotland",
    "Solomons",
    "Sunderland",
    "Tall Timbers",
    "Valley Lee",
    "Welcome",
    "White Plains",
    "Annapolis Junction",
    "Annapolis Jct",
    "Beltsville",
    "Calverton",
    "Lanham",
    "Glenarden",
    "Lanham Seabrook",
    "Seabrook",
    "Laurel",
    "Montpelier",
    "Bladensburg",
    "Lothian",
    "Mount Rainier",
    "North Beach",
    "Holland Point",
    "Rose Haven",
    "Bowie",
    "Mitchellville",
    "Brentwood",
    "Colmar Manor",
    "Cottage City",
    "N Brentwood",
    "North Brentwood",
    "Scaggsville",
    "Maryland City",
    "Md City",
    "Russett",
    "Chesapeake Beach",
    "Chesapeak Bch",
    "Churchton",
    "Clinton",
    "Owings",
    "Riverdale",
    "Riverdale Park",
    "Riverdale Pk",
    "College Park",
    "Berwyn Heights",
    "Berwyn Hts",
    "Capitol Heights",
    "Capitol Hgts",
    "Fairmount Heights",
    "Fairmount Hgt",
    "Seat Pleasant",
    "Fort Washington",
    "Ft Washington",
    "Oxon Hill",
    "Forest Heights",
    "Forest Hts",
    "Suitland",
    "Camp Springs",
    "Hillcrest Hgts",
    "Hillcrest Hts",
    "Morningside",
    "District Heights",
    "District Hts",
    "Forestville",
    "Temple Hills",
    "Hillcrest Heights",
    "Marlow Heights",
    "Marlow Hgts",
    "Deale",
    "Dunkirk",
    "Fort George G Meade",
    "Fort Meade",
    "Friendship",
    "Fulton",
    "Andrews Air Force Base",
    "Andrews AFB",
    "Jb Andrews",
    "Savage",
    "Shady Side",
    "Galesville",
    "Glenn Dale",
    "Greenbelt",
    "Upper Marlboro",
    "Uppr Marlboro",
    "Kettering",
    "Largo",
    "Springdale",
    "Upr Marlboro",
    "Harwood",
    "Highland",
    "West River",
    "Tracys Landing",
    "Tracys Lndg",
    "Hyattsville",
    "Chillum",
    "University Pa",
    "University Park",
    "W Hyattsville",
    "West Hyattsville",
    "Adelphi",
    "Cheverly",
    "Landover Hills",
    "Landover Hls",
    "New Carrolltn",
    "New Carrollton",
    "Landover",
    "N Englewood",
    "North Englewood",
    "Jessup",
    "Glen Echo",
    "Bethesda",
    "Chevy Chase",
    "Chevy Chase Village",
    "Chevy Chs Vlg",
    "Martins Add",
    "Martins Additions",
    "N Chevy Chase",
    "North Chevy Chase",
    "Westlake",
    "Cabin John",
    "Olney",
    "Brookeville",
    "Poolesville",
    "Barnesville",
    "Beallsville",
    "Boyds",
    "Dickerson",
    "Rockville",
    "Potomac",
    "N Bethesda",
    "North Bethesda",
    "Derwood",
    "Sandy Spring",
    "Ashton",
    "Brinklow",
    "Burtonsville",
    "Spencerville",
    "Clarksburg",
    "Hyattstown",
    "Damascus",
    "Germantown",
    "Darnestown",
    "Gaithersburg",
    "Montgomery Village",
    "Montgomry Vlg",
    "N Potomac",
    "No Potomac",
    "North Potomac",
    "Washington Grove",
    "Washingtn Grv",
    "Laytonsville",
    "Kensington",
    "Garrett Park",
    "Silver Spring",
    "Takoma Park",
    "Wheaton",
    "Colesville",
    "Aspen Hill",
    "Aberdeen",
    "Aberdeen Proving Ground",
    "Aber Prov Grd",
    "Abingdon",
    "Gunpowder",
    "Arnold",
    "Baldwin",
    "Bel Air",
    "Belcamp",
    "Butler",
    "Churchville",
    "Clarksville",
    "Cockeysville",
    "Cockysvil",
    "Hunt Valley",
    "Crownsville",
    "Darlington",
    "Davidsonville",
    "Dayton",
    "Edgewater",
    "Edgewood",
    "Ellicott City",
    "Daniels",
    "Ilchester",
    "Oella",
    "Columbia",
    "Fallston",
    "Finksburg",
    "Patapsco",
    "Forest Hill",
    "Fork",
    "Fort Howard",
    "Freeland",
    "Gambrills",
    "Gibson Island",
    "Glen Arm",
    "Glen Burnie",
    "Glyndon",
    "Hampstead",
    "Greenmount",
    "Elkridge",
    "Hanover",
    "Harmans",
    "Havre De Grace",
    "Hvre De Grace",
    "Hydes",
    "Jarrettsville",
    "Joppa",
    "Kingsville",
    "Bradshaw",
    "Linthicum Heights",
    "Linthicum",
    "Linthicum Hts",
    "Lutherville Timonium",
    "Lutherville",
    "Luthvle Timon",
    "Timonium",
    "Manchester",
    "Lineboro",
    "Millers",
    "Marriottsville",
    "Henryton",
    "Marriottsvl",
    "Woodstock",
    "Maryland Line",
    "Millersville",
    "Monkton",
    "Hereford",
    "Odenton",
    "Crofton",
    "Owings Mills",
    "Garrison",
    "Parkton",
    "Bentley Spgs",
    "Bentley Springs",
    "Pasadena",
    "Lake Shore",
    "Riviera Beach",
    "Perry Hall",
    "Perryman",
    "Phoenix",
    "Jacksonville",
    "Pylesville",
    "Randallstown",
    "Mcdonogh Run",
    "Reisterstown",
    "Riva",
    "Severn",
    "Severna Park",
    "Sparks Glencoe",
    "Glencoe",
    "Sparks",
    "Sparks Glenco",
    "Stevenson",
    "Street",
    "Upperco",
    "Fowbelsburg",
    "Upper Falls",
    "Westminster",
    "Whiteford",
    "Cardiff",
    "White Hall",
    "White Marsh",
    "Granite",
    "Baltimore",
    "East Case",
    "Towson",
    "Eudowood",
    "Loch Raven",
    "Ruxton",
    "Raspeburg",
    "Gwynn Oak",
    "Pikesville",
    "Woodlawn",
    "Mount Washington",
    "Mt Washington",
    "Roland Park",
    "Govans",
    "Clifton",
    "Arlington",
    "Druid",
    "Sparrows Point",
    "Edgemere",
    "Sparrows Pt",
    "Middle River",
    "Essex",
    "Dundalk",
    "Franklin",
    "Highlandtown",
    "Brooklyn",
    "Brooklyn Park",
    "Curtis Bay",
    "Carvel Beach",
    "Chestnut Hill Cove",
    "Chstnt Hl Cv",
    "Clearwater Beach",
    "Clearwatr Bch",
    "Greenland Bch",
    "Greenland Beach",
    "Orchard Beach",
    "Stoney Beach",
    "Halethorpe",
    "Arbutus",
    "Lansdowne",
    "Catonsville",
    "Carroll",
    "Parkville",
    "Nottingham",
    "Rosedale",
    "Idlewylde",
    "Loch Hill",
    "Northwood",
    "Windsor Mill",
    "Annapolis",
    "Cape Saint Claire",
    "Cpe St Claire",
    "N Severn Vlg",
    "Naval Academy",
    "North Severn Village",
    "Highland Bch",
    "Sherwood Forest",
    "Sherwood Frst",
    "Cumberland",
    "Cresaptown",
    "Lavale",
    "Accident",
    "Barton",
    "Bloomington",
    "Corriganville",
    "Ellerslie",
    "Flintstone",
    "Friendsville",
    "Frostburg",
    "Grantsville",
    "Jennings",
    "Kitzmiller",
    "Shallmar",
    "Lonaconing",
    "Luke",
    "Westernport",
    "McHenry",
    "Sang Run",
    "Midland",
    "Midlothian",
    "Mount Savage",
    "Oakland",
    "Crellin",
    "Deer Park",
    "Hutton",
    "Loch Lyn Hght",
    "Loch Lynn Heights",
    "Mnt Lake Park",
    "Mountain Lake Park",
    "Mt Lake Park",
    "Mtn Lk Park",
    "Oldtown",
    "Rawlings",
    "Spring Gap",
    "Swanton",
    "Mccoole",
    "Easton",
    "Barclay",
    "Betterton",
    "Bozman",
    "Cambridge",
    "Centreville",
    "Chester",
    "Chestertown",
    "Church Creek",
    "Church Hill",
    "Claiborne",
    "Cordova",
    "Crapo",
    "Crocheron",
    "Crumpton",
    "Denton",
    "East New Market",
    "E New Market",
    "Federalsburg",
    "Fishing Creek",
    "Galena",
    "Golts",
    "Goldsboro",
    "Grasonville",
    "Greensboro",
    "Henderson",
    "Hillsboro",
    "Hurlock",
    "Ingleside",
    "Kennedyville",
    "Mcdaniel",
    "Madison",
    "Marydel",
    "Massey",
    "Millington",
    "Neavitt",
    "Newcomb",
    "Oxford",
    "Preston",
    "Queen Anne",
    "Queenstown",
    "Rhodesdale",
    "Brookview",
    "Eldorado",
    "Galestown",
    "Ridgely",
    "Rock Hall",
    "Royal Oak",
    "Saint Michaels",
    "St Michaels",
    "Secretary",
    "Sherwood",
    "Stevensville",
    "Still Pond",
    "Sudlersville",
    "Taylors Island",
    "Taylors Is",
    "Tilghman",
    "Toddville",
    "Trappe",
    "Wingate",
    "Wittman",
    "Woolford",
    "Worton",
    "Lynch",
    "Wye Mills",
    "Frederick",
    "Lewistown",
    "Fort Detrick",
    "Urbana",
    "Adamstown",
    "Doubs",
    "Big Pool",
    "Boonsboro",
    "Braddock Heights",
    "Braddock Hts",
    "Brownsville",
    "Brunswick",
    "Buckeystown",
    "Burkittsville",
    "Cascade",
    "Fort Ritchie",
    "Highfield",
    "Clear Spring",
    "Big Spring",
    "Cooksville",
    "Emmitsburg",
    "Fairplay",
    "St James",
    "Funkstown",
    "Glenelg",
    "Glenwood",
    "Hagerstown",
    "Hancock",
    "Ijamsville",
    "Jefferson",
    "Keedysville",
    "Keymar",
    "Detour",
    "Middleburg",
    "Knoxville",
    "Libertytown",
    "Little Orleans",
    "Ltl Orleans",
    "Maugansville",
    "Middletown",
    "Monrovia",
    "Mount Airy",
    "Myersville",
    "New Market",
    "New Windsor",
    "Point Of Rocks",
    "Pt Of Rocks",
    "Rocky Ridge",
    "Rohrersville",
    "Gapland",
    "Sabillasville",
    "Saint James",
    "Sharpsburg",
    "Smithsburg",
    "Sykesville",
    "Eldersburg",
    "Gaither",
    "Taneytown",
    "Thurmont",
    "Graceham",
    "Tuscarora",
    "Union Bridge",
    "Linwood",
    "Walkersville",
    "West Friendship",
    "W Friendship",
    "Williamsport",
    "Woodbine",
    "Woodsboro",
    "Salisbury",
    "Allen",
    "Berlin",
    "Ocean Pines",
    "Ocean Pnes",
    "Bishopville",
    "Bivalve",
    "Crisfield",
    "Deal Island",
    "Chance",
    "Dames Quarter",
    "Wenona",
    "Eden",
    "Ewell",
    "Fruitland",
    "Girdletree",
    "Hebron",
    "Linkwood",
    "Mardela Springs",
    "Mardela",
    "Mardela Spgs",
    "Marion Station",
    "Marion",
    "Marion Sta",
    "Nanticoke",
    "Newark",
    "Ocean City",
    "Parsonsburg",
    "Pittsville",
    "Pocomoke City",
    "Princess Anne",
    "Quantico",
    "Sharptown",
    "Showell",
    "Snow Hill",
    "Stockton",
    "Tyaskin",
    "Tylerton",
    "Upper Fairmount",
    "Fairmount",
    "Upper Fairmt",
    "Upper Hill",
    "Vienna",
    "Westover",
    "Whaleyville",
    "Willards",
    "Delmar",
    "North East",
    "Perry Point",
    "Perryville",
    "Port Deposit",
    "Bainbridge",
    "Rising Sun",
    "Warwick",
    "Cecilton",
    "Charlestown",
    "Chesapeake City",
    "Chesapeake Cy",
    "Colora",
    "Conowingo",
    "Earleville",
    "Elk Mills",
    "Elkton",
    "Georgetown",
  ],
  ME: [
    "Berwick",
    "Cape Neddick",
    "Eliot",
    "Kittery",
    "Kittery Point",
    "North Berwick",
    "Ogunquit",
    "South Berwick",
    "York",
    "York Beach",
    "York Harbor",
    "Acton",
    "Alfred",
    "Lyman",
    "Bailey Island",
    "Biddeford",
    "Dayton",
    "Biddeford Pool",
    "Biddeford Pl",
    "Bowdoinham",
    "Bridgton",
    "Brownfield",
    "Brunswick",
    "Birch Island",
    "Cundys Harbor",
    "Mere Point",
    "Casco",
    "Chebeague Island",
    "Chebeague Is",
    "Cliff Island",
    "Cornish",
    "Cumberland Center",
    "Cumberland",
    "Cumberlnd Ctr",
    "Denmark",
    "East Baldwin",
    "Lebanon",
    "Sebago",
    "East Waterboro",
    "E Waterboro",
    "Freeport",
    "Fryeburg",
    "N Fryeburg",
    "North Fryeburg",
    "Stow",
    "Gorham",
    "Gray",
    "Harrison",
    "Sweden",
    "Hiram",
    "Hollis Center",
    "Kennebunk",
    "Kennebunkport",
    "Arundel",
    "Parsonsfield",
    "Kezar Falls",
    "Limerick",
    "Limington",
    "Long Island",
    "Lovell",
    "Naples",
    "Newfield",
    "North Bridgton",
    "N Bridgton",
    "North Waterboro",
    "N Waterboro",
    "Windham",
    "N Windham",
    "No Windham",
    "North Windham",
    "Ocean Park",
    "Old Orchard Beach",
    "Old Orchd Bch",
    "Orrs Island",
    "Porter",
    "Pownal",
    "Raymond",
    "Frye Island",
    "Saco",
    "Sanford",
    "Scarborough",
    "Pine Point",
    "Shapleigh",
    "N Shapleigh",
    "North Shapleigh",
    "Harpswell",
    "S Harpswell",
    "South Harpswell",
    "Springvale",
    "Standish",
    "Sebago Lake",
    "Steep Falls",
    "Topsham",
    "Pejepscot",
    "Waterboro",
    "Waterford",
    "Wells",
    "Wells Beach",
    "West Baldwin",
    "Westbrook",
    "Buxton",
    "West Newfield",
    "Yarmouth",
    "North Yarmouth",
    "N Yarmouth",
    "Portland",
    "Falmouth",
    "South Portland",
    "S Portland",
    "Cape Elizabeth",
    "Cape Eliz",
    "Pond Cove",
    "Peaks Island",
    "Cushing Is",
    "Cushing Island",
    "Diamond Cove",
    "Diamond Is",
    "Diamond Island",
    "Great Diamond Island",
    "Grt Dia Is",
    "Little Diamond Island",
    "Ltle Dia Is",
    "Cumberland Foreside",
    "Cumb Foreside",
    "Auburn",
    "Andover",
    "Bethel",
    "Albany Twp",
    "Gilead",
    "Mason Twp",
    "Bryant Pond",
    "Milton Twp",
    "Buckfield",
    "Hartford",
    "Canton",
    "Durham",
    "Dixfield",
    "Carthage",
    "East Andover",
    "East Dixfield",
    "Stoneham",
    "E Stoneham",
    "East Wilton",
    "Greene",
    "Hanover",
    "Hebron",
    "Jay",
    "Lewiston",
    "Lisbon",
    "Lisbon Falls",
    "Livermore",
    "Livermore Falls",
    "Livermore Fls",
    "Greenwood",
    "Mechanic Falls",
    "Mechanic Fls",
    "Mexico",
    "Minot",
    "Monmouth",
    "New Gloucester",
    "New Gloucestr",
    "Newry",
    "Upton",
    "Leeds",
    "North Monmouth",
    "N Monmouth",
    "North Waterford",
    "N Waterford",
    "Norway",
    "Oxford",
    "Otisfield",
    "Paris",
    "Poland",
    "Poland Spring",
    "Roxbury",
    "Byron",
    "Rumford",
    "Rumford Center",
    "Rumford Ctr",
    "Rumford Point",
    "Sabattus",
    "Wales",
    "South Paris",
    "Turner",
    "Wayne",
    "Weld",
    "West Bethel",
    "Bowdoin",
    "W Bowdoin",
    "West Paris",
    "Peru",
    "Sumner",
    "Wilton",
    "Perkins Twp",
    "Augusta",
    "Chelsea",
    "Sidney",
    "Coopers Mills",
    "Dresden",
    "Farmingdale",
    "Gardiner",
    "Pittston",
    "West Gardiner",
    "Randolph",
    "Hallowell",
    "Jefferson",
    "Somerville",
    "Kents Hill",
    "Fayette",
    "Litchfield",
    "Manchester",
    "Mount Vernon",
    "Whitefield",
    "Palermo",
    "Readfield",
    "Richmond",
    "South China",
    "China",
    "Weeks Mills",
    "South Gardiner",
    "S Gardiner",
    "Vienna",
    "Windsor",
    "Winthrop",
    "Bangor",
    "Glenburn",
    "Hermon",
    "Veazie",
    "Abbot",
    "Blanchard Twp",
    "Aurora",
    "Great Pond",
    "Bradford",
    "Bradley",
    "Brewer",
    "Brookton",
    "Forest City Twp",
    "Forest Twp",
    "Frst City Twp",
    "Brownville",
    "Barnard Twp",
    "Ebeemee Twp",
    "Wiliamsbg Twp",
    "Williamsburg Twp",
    "Brownville Junction",
    "Brownvlle Jct",
    "Bucksport",
    "Verona Island",
    "Burlington",
    "Greenbush",
    "Cardville",
    "Costigan",
    "Greenfield Twp",
    "Greenfld Twp",
    "Olamon",
    "Carmel",
    "Castine",
    "Charleston",
    "Danforth",
    "Weston",
    "Dover Foxcroft",
    "Atkinson",
    "Bowerbank",
    "Dovr Foxcroft",
    "Dvr Foxcroft",
    "Sebec",
    "Corinth",
    "Eddington",
    "Clifton",
    "Holden",
    "Dedham",
    "East Holden",
    "East Millinocket",
    "E Millinocket",
    "East Orland",
    "Etna",
    "Exeter",
    "Frankfort",
    "Greenville",
    "Beaver Cove",
    "Frenchtown Twp",
    "Frenchtwn Twp",
    "Lily Bay Twp",
    "Shirley",
    "Greenville Junction",
    "Greenvlle Jct",
    "Guilford",
    "Eliotsvle Twp",
    "Elliottsville Twp",
    "Parkman",
    "Willimantic",
    "Hampden",
    "Newburgh",
    "Howland",
    "Edinburg",
    "Seboeis Plt",
    "Hudson",
    "Kenduskeag",
    "Kingman",
    "Kingman Twp",
    "Macwahoc Plt",
    "Lagrange",
    "Maxfield",
    "Lambert Lake",
    "Lee",
    "Levant",
    "Lincoln",
    "Chester",
    "Lincoln Center",
    "Lincoln Ctr",
    "Mattamisc Twp",
    "Mattamiscontis Twp",
    "Woodville",
    "Mattawamkeag",
    "Molunkus Twp",
    "Medway",
    "Grindstone",
    "Grindstone Twp",
    "Soldiertown",
    "Soldiertown Twp",
    "Milford",
    "Millinocket",
    "Cedar Lake",
    "Cedar Lake Twp",
    "Indian Purch",
    "Indian Purchase Twp",
    "Long A Twp",
    "Milo",
    "Derby",
    "Lake View Plt",
    "Medford",
    "Orneville Twp",
    "Monson",
    "Old Town",
    "Alton",
    "Argyle Twp",
    "Indian Island",
    "Orono",
    "Orient",
    "Amity",
    "Cary Plt",
    "Orland",
    "Orrington",
    "Passadumkeag",
    "Penobscot",
    "Rockwood",
    "Little W Twp",
    "Pittstn Acdmy",
    "Pittston Academy Grant Twp",
    "Plymouth Twp",
    "Seboomook Twp",
    "Tomhegan Twp",
    "Sangerville",
    "Shirley Mills",
    "Springfield",
    "Carroll Plt",
    "Lakeville",
    "Prentiss Twp",
    "Webster Plt",
    "Stetson",
    "Stillwater",
    "Topsfield",
    "Codyville Plt",
    "Waite",
    "Vanceboro",
    "Talmadge",
    "West Enfield",
    "Enfield",
    "Lowell",
    "Winn",
    "Winterport",
    "Wytopitlock",
    "Bancroft",
    "Drew Plt",
    "Glenwood Plt",
    "Haynesville",
    "Reed Plt",
    "Bath",
    "Arrowsic",
    "West Bath",
    "Alna",
    "Boothbay",
    "Boothbay Harbor",
    "Boothbay Hbr",
    "Capitol Is",
    "Capitol Island",
    "Bristol",
    "Chamberlain",
    "Damariscotta",
    "East Boothbay",
    "Friendship",
    "Georgetown",
    "Mac Mahan",
    "Bremen",
    "Medomak",
    "Newcastle",
    "New Harbor",
    "Nobleboro",
    "Edgecomb",
    "Pemaquid",
    "Phippsburg",
    "Cushing",
    "Round Pond",
    "South Bristol",
    "Squirrel Island",
    "Squirrel Is",
    "Trevett",
    "Waldoboro",
    "Walpole",
    "Washington",
    "West Boothbay Harbor",
    "W Boothbay Ha",
    "W Boothbay Harbor",
    "W Boothby Hbr",
    "Southport",
    "Newagen",
    "Wiscasset",
    "Westport Is",
    "Westport Island",
    "Woolwich",
    "Ellsworth",
    "Amherst",
    "Fletchers Landing Twp",
    "Fletchers Ldg",
    "Lamoine",
    "Mariaville",
    "Osborn",
    "Otis",
    "Trenton",
    "Waltham",
    "Addison",
    "Gouldsboro",
    "S Gouldsboro",
    "South Gouldsboro",
    "Bar Harbor",
    "Beals",
    "Bernard",
    "West Tremont",
    "Birch Harbor",
    "Blue Hill",
    "Brooklin",
    "Brooksville",
    "Calais",
    "Cherryfield",
    "Beddington",
    "Deblois",
    "Columbia Falls",
    "Centerville",
    "Columbia",
    "Columbia Fls",
    "Corea",
    "Cranberry Isles",
    "Cranberry Is",
    "Cutler",
    "Deer Isle",
    "Dennysville",
    "Edmunds Twp",
    "Marion Twp",
    "East Machias",
    "Eastport",
    "Franklin",
    "Eastbrook",
    "Frenchboro",
    "Hancock",
    "Harborside",
    "Harrington",
    "Isle Au Haut",
    "Stonington",
    "Islesford",
    "Jonesboro",
    "Jonesport",
    "Little Deer Isle",
    "Ltl Deer Is",
    "Lubec",
    "Trescott Twp",
    "Bass Harbor",
    "Machias",
    "Day Block Twp",
    "Marshfield",
    "Northfield",
    "Roque Bluffs",
    "Whitneyville",
    "Machiasport",
    "Bucks Harbor",
    "Meddybemps",
    "Cathance Twp",
    "Cooper",
    "Milbridge",
    "Mount Desert",
    "Otter Creek",
    "Northeast Harbor",
    "Ne Harbor",
    "Sullivan",
    "N Sullivan",
    "North Sullivan",
    "Pembroke",
    "Charlotte",
    "Perry",
    "Pleasant Point",
    "Pleasant Pt",
    "Princeton",
    "Big Lake Twp",
    "Grand Lake Stream",
    "Grand Lk Strm",
    "Greenlaw Chop",
    "Greenlaw Chopping Twp",
    "Indian Twp",
    "Prospect Harbor",
    "Prospect Hbr",
    "Robbinston",
    "Sargentville",
    "Seal Cove",
    "Seal Harbor",
    "Sedgwick",
    "Sorrento",
    "Southwest Harbor",
    "Southwest Hbr",
    "Steuben",
    "Sunset",
    "Surry",
    "Swans Island",
    "Minturn",
    "Wesley",
    "Whiting",
    "Winter Harbor",
    "Baileyville",
    "Alexander",
    "Baring Plt",
    "Crawford",
    "Woodland Washington County",
    "Houlton",
    "Hammond",
    "Hodgdon",
    "Linneus",
    "Littleton",
    "Ludlow",
    "Ashland",
    "Garfield Plt",
    "Masardis",
    "Nashville Plt",
    "Sheridan",
    "Benedicta",
    "Blaine",
    "Bridgewater",
    "Caribou",
    "Connor Twp",
    "Woodland",
    "Clayton Lake",
    "Eagle Lake",
    "Quimby",
    "Winterville Plt",
    "Wntervlle Plt",
    "Easton",
    "Fort Fairfield",
    "Ft Fairfield",
    "Fort Kent",
    "New Canada",
    "St John Plt",
    "Frenchville",
    "Upper Frenchville",
    "Upper Frnchvl",
    "Grand Isle",
    "Lille",
    "Island Falls",
    "Crystal",
    "Dyer Brook",
    "Limestone",
    "Caswell",
    "Loring Cm Ctr",
    "Madawaska",
    "Mapleton",
    "Castle Hill",
    "Chapman",
    "Mars Hill",
    "Monticello",
    "New Limerick",
    "New Sweden",
    "Oakfield",
    "Oxbow",
    "Patten",
    "Mount Chase",
    "Perham",
    "Portage",
    "Portage Lake",
    "Presque Isle",
    "Saint Agatha",
    "Saint David",
    "Saint Francis",
    "Allagash",
    "Sherman",
    "Sherman Mills",
    "Silver Ridge",
    "Silver Ridge Twp",
    "Stacyville",
    "Herseytown Twp",
    "Hrsytown Twp",
    "Sherman Sta",
    "Sherman Station",
    "Sinclair",
    "Cross Lake Twp",
    "Cross Lke Twp",
    "Smyrna Mills",
    "Hersey",
    "Merrill",
    "Moro Plt",
    "Wallagrass",
    "Stockholm",
    "Westmanland",
    "Van Buren",
    "Cyr Plt",
    "Hamlin",
    "Washburn",
    "Wade",
    "Westfield",
    "Rockland",
    "Camden",
    "Hope",
    "Islesboro",
    "Lincolnville",
    "Northport",
    "Matinicus",
    "Monhegan",
    "North Haven",
    "Owls Head",
    "Port Clyde",
    "Rockport",
    "South Thomaston",
    "S Thomaston",
    "Spruce Head",
    "Tenants Harbor",
    "Tenants Hbr",
    "Saint George",
    "Thomaston",
    "Union",
    "Appleton",
    "Vinalhaven",
    "Warren",
    "Waterville",
    "Benton",
    "Winslow",
    "Albion",
    "Anson",
    "Starks",
    "Athens",
    "Brighton Plt",
    "Belfast",
    "Swanville",
    "Waldo",
    "Belgrade",
    "Belgrade Lakes",
    "Belgrade Lks",
    "Bingham",
    "Concord Twp",
    "Moscow",
    "Pleasant Ridge Plt",
    "Plsnt Rdg Plt",
    "Brooks",
    "Jackson",
    "Burnham",
    "Cambridge",
    "Canaan",
    "Caratunk",
    "China Village",
    "China Vlg",
    "Clinton",
    "Corinna",
    "Detroit",
    "Dexter",
    "Ripley",
    "Dixmont",
    "Eustis",
    "Chain Of Pnds",
    "Chain Of Ponds Twp",
    "Coburn Gore",
    "Jim Pond Twp",
    "Fairfield",
    "Farmington",
    "Chesterville",
    "Industry",
    "Garland",
    "Farmington Falls",
    "Farmingtn Fls",
    "Freedom",
    "Montville",
    "Harmony",
    "Kingsbury Plt",
    "Mayfield Twp",
    "Wellington",
    "Hartland",
    "Hinckley",
    "Jackman",
    "Dennistown",
    "Jhnsn Mtn Twp",
    "Johnson Mountain Twp",
    "Long Pond Twp",
    "Moose River",
    "Parlin Pd Twp",
    "Parlin Pond Twp",
    "Sandy Bay Twp",
    "Kingfield",
    "Carabaset Vly",
    "Carrabassett Valley",
    "Liberty",
    "Madison",
    "Monroe",
    "Morrill",
    "Belmont",
    "Newport",
    "New Sharon",
    "New Vineyard",
    "Norridgewock",
    "Mercer",
    "North Anson",
    "Embden",
    "New Portland",
    "Carrying Place Town Twp",
    "Caryng Pl Twp",
    "Dead River Twp",
    "Dead Rvr Twp",
    "Highland Plt",
    "Lexington Twp",
    "N New Portland",
    "N New Portlnd",
    "North New Portland",
    "Pierce Pond",
    "Pierce Pond Twp",
    "Oakland",
    "Rome",
    "Oquossoc",
    "Adamstown Twp",
    "Palmyra",
    "Phillips",
    "Avon",
    "Madrid Twp",
    "Pittsfield",
    "Plymouth",
    "Rangeley",
    "Coplin Plt",
    "Dallas Plt",
    "Lang Twp",
    "Sandy River Plt",
    "Sandy Rvr Plt",
    "Saint Albans",
    "Searsmont",
    "Searsport",
    "Shawmut",
    "Skowhegan",
    "Cornville",
    "Smithfield",
    "Solon",
    "Stockton Springs",
    "Prospect",
    "Stockton Spgs",
    "Stratton",
    "Strong",
    "Freeman Twp",
    "Salem Twp",
    "Temple",
    "West Forks",
    "E Moxie Twp",
    "East Moxie Twp",
    "Indian Stream",
    "Indian Stream Twp",
    "Moxie Gore",
    "Moxie Gore Twp",
    "The Forks Plt",
    "Thorndike",
    "Knox",
    "Troy",
    "Unity",
    "Vassalboro",
    "West Farmington",
    "W Farmington",
  ],
  MI: [
    "Algonac",
    "Clay",
    "Pearl Beach",
    "Russell Is",
    "Russell Island",
    "Allenton",
    "Berlin",
    "Berville",
    "Almont",
    "Armada",
    "Avoca",
    "Fargo",
    "Greenwood",
    "Kenockee",
    "Birmingham",
    "Capac",
    "Mussey",
    "Center Line",
    "Clawson",
    "Eastpointe",
    "East Detroit",
    "Emmett",
    "Fair Haven",
    "Ira",
    "Franklin",
    "Beverly Hills",
    "Bingham Farms",
    "Fraser",
    "Goodells",
    "Wales",
    "Harsens Island",
    "Harsens Is",
    "Hazel Park",
    "Jeddo",
    "Grant Township",
    "Grant Twp",
    "Southfield",
    "Clinton Township",
    "Clinton Twp",
    "Marine City",
    "Cottrellville",
    "Marysville",
    "Memphis",
    "Riley",
    "Macomb",
    "Mount Clemens",
    "Harrison Township",
    "Harrison Twp",
    "Selfridge",
    "Selfridge Angb",
    "New Baltimore",
    "Chesterfield",
    "New Haven",
    "Lenox",
    "North Street",
    "Clyde",
    "Ruby",
    "East China",
    "China",
    "Fort Gratiot",
    "Burtchville",
    "Lakeport",
    "N Lakeport",
    "North Lakeport",
    "Port Huron",
    "Richmond",
    "Columbus",
    "Casco",
    "Romeo",
    "Bruce",
    "Bruce Township",
    "Bruce Twp",
    "Roseville",
    "Royal Oak",
    "Pleasant Ridge",
    "Pleasant Rdg",
    "Huntington Woods",
    "Huntingtn Wds",
    "Madison Heights",
    "Madison Hts",
    "Berkley",
    "Smiths Creek",
    "Kimball",
    "Lathrup Village",
    "Lathrup Vlg",
    "Saint Clair",
    "Saint Clair Shores",
    "St Clair Shrs",
    "St Clr Shores",
    "Troy",
    "Warren",
    "Washington",
    "Washingtn Twp",
    "Washington Township",
    "Washington Twp",
    "Ray",
    "Ray Twp",
    "Yale",
    "Brockway",
    "Lynn",
    "Allen Park",
    "Ann Arbor",
    "Belleville",
    "Sumpter Twp",
    "Van Buren Twp",
    "Brighton",
    "Carleton",
    "Chelsea",
    "Dearborn",
    "Melvindale",
    "Dearborn Heights",
    "Dearborn Hts",
    "Dexter",
    "Dundee",
    "Erie",
    "Flat Rock",
    "Brownstown",
    "Brownstown Township",
    "Brownstown Twp",
    "Brownstwn Twp",
    "Garden City",
    "Gregory",
    "Grosse Ile",
    "Hamburg",
    "Ida",
    "Inkster",
    "Lakeland",
    "Lambertville",
    "La Salle",
    "Lincoln Park",
    "Livonia",
    "Luna Pier",
    "Manchester",
    "Maybee",
    "Milan",
    "Monroe",
    "Frenchtown",
    "Raisinville Twp",
    "Raisinvl Twp",
    "New Boston",
    "New Hudson",
    "Newport",
    "Northville",
    "Northville Township",
    "Northvl Twp",
    "Pinckney",
    "Plymouth",
    "Rockwood",
    "Gibraltar",
    "Romulus",
    "Saline",
    "Samaria",
    "South Lyon",
    "South Rockwood",
    "S Rockwood",
    "Taylor",
    "Temperance",
    "Trenton",
    "Woodhaven",
    "Wayne",
    "Westland",
    "Canton",
    "Whitmore Lake",
    "Hamburg Twp",
    "Whittaker",
    "Willis",
    "Wyandotte",
    "Riverview",
    "Southgate",
    "Ypsilanti",
    "Superior Township",
    "Superior Twp",
    "Detroit",
    "Highland Park",
    "Hamtramck",
    "Grosse Pointe",
    "Grosse Pointe Park",
    "Grosse Pt Pk",
    "River Rouge",
    "Ferndale",
    "Harper Woods",
    "Ecorse",
    "Grosse Pointe Farms",
    "Grosse Pointe Shores",
    "Grosse Pointe Woods",
    "Grosse Pt Frm",
    "Grosse Pt Shr",
    "Grosse Pt Wds",
    "Oak Park",
    "Redford",
    "Bloomfield Hills",
    "Bloomfield",
    "Bloomfield Township",
    "Bloomfield Village",
    "Bloomfld Hls",
    "Bloomfld Twp",
    "Rochester",
    "Goodison",
    "Oakland",
    "Oakland Township",
    "Oakland Twp",
    "Rochester Hills",
    "Rochester Hls",
    "Sterling Heights",
    "Sterling Hts",
    "Utica",
    "Shelby Township",
    "Shelby Twp",
    "Keego Harbor",
    "Sylvan Lake",
    "West Bloomfield",
    "W Bloomfield",
    "Orchard Lake",
    "Auburn Hills",
    "Lake Angelus",
    "Waterford",
    "W Bloomfld Tw",
    "Waterford Township",
    "Waterford Twp",
    "Farmington",
    "Farmingtn Hls",
    "Farmington Hills",
    "Farmington Hls",
    "Pontiac",
    "Mi Metro",
    "Clarkston",
    "Independence",
    "Davisburg",
    "Springfield Township",
    "Springfld Twp",
    "Hartland",
    "Highland",
    "Lake Orion",
    "Orion",
    "Leonard",
    "Addison Township",
    "Addison Twp",
    "Lakeville",
    "Oxford",
    "Novi",
    "Milford",
    "Commerce Township",
    "Commerce Twp",
    "White Lake",
    "Walled Lake",
    "Wolverine Lake",
    "Wolverine Lk",
    "Wixom",
    "Applegate",
    "Argyle",
    "Atlas",
    "Attica",
    "Lum",
    "Bad Axe",
    "Bancroft",
    "Birch Run",
    "Brown City",
    "Burt",
    "Byron",
    "Carsonville",
    "Clio",
    "Columbiaville",
    "Croswell",
    "Davison",
    "Decker",
    "Deckerville",
    "Dryden",
    "Durand",
    "Vernon City",
    "Fenton",
    "Filion",
    "Flushing",
    "Forestville",
    "Fostoria",
    "Gaines",
    "Genesee",
    "Goodrich",
    "Grand Blanc",
    "Hadley",
    "Harbor Beach",
    "Holly",
    "Imlay City",
    "Kinde",
    "Lapeer",
    "Lennon",
    "Lexington",
    "Linden",
    "Marlette",
    "Melvin",
    "Metamora",
    "Minden City",
    "Montrose",
    "Mount Morris",
    "New Lothrop",
    "North Branch",
    "Ortonville",
    "Otisville",
    "Otter Lake",
    "Palms",
    "Peck",
    "Port Austin",
    "Port Hope",
    "Port Sanilac",
    "Ruth",
    "Sandusky",
    "Snover",
    "Swartz Creek",
    "Ubly",
    "Vernon",
    "Flint",
    "Burton",
    "Saginaw",
    "Zilwaukee",
    "Alger",
    "Auburn",
    "Beaverton",
    "Bentley",
    "Brant",
    "Breckenridge",
    "Chesaning",
    "Clare",
    "Coleman",
    "Comins",
    "Edenville",
    "Fairview",
    "Farwell",
    "Freeland",
    "Gladwin",
    "Harrison",
    "Hemlock",
    "Higgins Lake",
    "Hope",
    "Houghton Lake",
    "Houghton Lake Heights",
    "Hghtn Lk Hts",
    "Htn Lk Hghts",
    "Kawkawlin",
    "Lake",
    "Lake Station",
    "Lake George",
    "Linwood",
    "Lupton",
    "Luzerne",
    "Merrill",
    "Midland",
    "Mio",
    "Oakley",
    "Pinconning",
    "Prudenville",
    "Rhodes",
    "Roscommon",
    "Rose City",
    "Saint Charles",
    "Saint Helen",
    "Sanford",
    "Standish",
    "Sterling",
    "West Branch",
    "Wheeler",
    "Akron",
    "Au Gres",
    "Barton City",
    "Bay City",
    "University Center",
    "Univ Ctr",
    "Bay Port",
    "Black River",
    "Bridgeport",
    "Caro",
    "Carrollton",
    "Caseville",
    "Port Elizabeth",
    "Pt Elizabeth",
    "Cass City",
    "Clifford",
    "Curran",
    "Deford",
    "East Tawas",
    "Elkton",
    "Essexville",
    "Fairgrove",
    "Frankenmuth",
    "Gagetown",
    "Glennie",
    "Greenbush",
    "Hale",
    "Harrisville",
    "Kingston",
    "Lincoln",
    "Long Lake",
    "Mayville",
    "Mikado",
    "Millington",
    "Munger",
    "National City",
    "Omer",
    "Oscoda",
    "Au Sable",
    "Owendale",
    "Pigeon",
    "Sand Point",
    "Prescott",
    "Roos",
    "Reese",
    "Sebewaing",
    "Silverwood",
    "South Branch",
    "Spruce",
    "Tawas City",
    "Alabaster",
    "Turner",
    "Twining",
    "Unionville",
    "Vassar",
    "Tuscola",
    "Whittemore",
    "Alma",
    "Ashley",
    "Bannister",
    "Bath",
    "Belding",
    "Carson City",
    "Charlotte",
    "Clarksville",
    "Cohoctah",
    "Corunna",
    "Crystal",
    "Dansville",
    "Dewitt",
    "De Witt",
    "Dimondale",
    "Eagle",
    "East Lansing",
    "Eaton Rapids",
    "Edmore",
    "Elsie",
    "Carland",
    "Elwell",
    "Fenwick",
    "Fowler",
    "Fowlerville",
    "Grand Ledge",
    "Greenville",
    "Haslett",
    "Henderson",
    "Owosso",
    "Holt",
    "Howell",
    "Hubbardston",
    "Ionia",
    "Ithaca",
    "North Star",
    "Laingsburg",
    "Lake Odessa",
    "Lakeview",
    "Lyons",
    "Mcbrides",
    "Mcbride",
    "Maple Rapids",
    "Mason",
    "Middleton",
    "Morrice",
    "Mount Pleasant",
    "Mt Pleasant",
    "Muir",
    "Mulliken",
    "Okemos",
    "Orleans",
    "Ovid",
    "Palo",
    "Perrinton",
    "Perry",
    "Pewamo",
    "Pompeii",
    "Portland",
    "Potterville",
    "Riverdale",
    "Rosebush",
    "Saint Johns",
    "Saint Louis",
    "Saranac",
    "Shepherd",
    "Sheridan",
    "Sidney",
    "Six Lakes",
    "Stanton",
    "Sumner",
    "Sunfield",
    "Vestaburg",
    "Webberville",
    "Weidman",
    "Lake Isabella",
    "Westphalia",
    "Williamston",
    "Winn",
    "Woodland",
    "Lansing",
    "Kalamazoo",
    "Portage",
    "Parchment",
    "Allegan",
    "Athens",
    "Augusta",
    "Bangor",
    "Battle Creek",
    "Springfield",
    "Bellevue",
    "Benton Harbor",
    "Bloomingdale",
    "Breedsville",
    "Bronson",
    "Burlington",
    "Burr Oak",
    "Cassopolis",
    "Centreville",
    "Ceresco",
    "Climax",
    "Coldwater",
    "Coloma",
    "Colon",
    "Constantine",
    "Covert",
    "Decatur",
    "Delton",
    "Dowagiac",
    "Dowling",
    "East Leroy",
    "Fulton",
    "Galesburg",
    "Gobles",
    "Grand Junction",
    "Grand Jct",
    "Hartford",
    "Hastings",
    "Hickory Corners",
    "Hickory Crnrs",
    "Jones",
    "Lacota",
    "Lawrence",
    "Lawton",
    "Leonidas",
    "Marcellus",
    "Marshall",
    "Martin",
    "Mattawan",
    "Mendon",
    "Nashville",
    "Nazareth",
    "Nottawa",
    "Olivet",
    "Otsego",
    "Paw Paw",
    "Plainwell",
    "Quincy",
    "Richland",
    "Riverside",
    "Saint Joseph",
    "Shoreham",
    "Schoolcraft",
    "Scotts",
    "Sherwood",
    "South Haven",
    "Sturgis",
    "Tekonsha",
    "Three Rivers",
    "Union City",
    "Vandalia",
    "Vermontville",
    "Vicksburg",
    "Watervliet",
    "White Pigeon",
    "Mottville",
    "Baroda",
    "Berrien Center",
    "Berrien Ctr",
    "Berrien Springs",
    "Berrien Sprgs",
    "Bridgman",
    "Buchanan",
    "Glendora",
    "Eau Claire",
    "Edwardsburg",
    "Galien",
    "Harbert",
    "Lakeside",
    "New Buffalo",
    "Grand Beach",
    "Michiana",
    "New Troy",
    "Niles",
    "Sawyer",
    "Sodus",
    "Stevensville",
    "Three Oaks",
    "Union Pier",
    "Union",
    "Jackson",
    "Addison",
    "Adrian",
    "Cadmus",
    "Albion",
    "Allen",
    "Blissfield",
    "Britton",
    "Ridgeway",
    "Brooklyn",
    "Camden",
    "Cement City",
    "Clarklake",
    "Clayton",
    "Clayton Twp",
    "Clinton",
    "Concord",
    "Deerfield",
    "Grass Lake",
    "Hanover",
    "Hillsdale",
    "Homer",
    "Horton",
    "Hudson",
    "Rollin",
    "Jasper",
    "Jerome",
    "Jonesville",
    "Leslie",
    "Litchfield",
    "Manitou Beach",
    "Michigan Center",
    "Michigan Ctr",
    "Montgomery",
    "Morenci",
    "Seneca",
    "Mosherville",
    "Munith",
    "Napoleon",
    "North Adams",
    "Norvell",
    "Onondaga",
    "Onsted",
    "Osseo",
    "Ottawa Lake",
    "Palmyra",
    "Parma",
    "Petersburg",
    "Pittsford",
    "Prattville",
    "Pleasant Lake",
    "Reading",
    "Riga",
    "Rives Junction",
    "Rives Jct",
    "Sand Creek",
    "Somerset Center",
    "Somerset Ctr",
    "Spring Arbor",
    "Springport",
    "Stockbridge",
    "Tecumseh",
    "Tipton",
    "Waldron",
    "Weston",
    "Ada",
    "Alto",
    "Bailey",
    "Baldwin",
    "Barryton",
    "Belmont",
    "Big Rapids",
    "Bitely",
    "Blanchard",
    "Millbrook",
    "Brohman",
    "Byron Center",
    "Caledonia",
    "Dutton",
    "Casnovia",
    "Cedar Springs",
    "Chippewa Lake",
    "Comstock Park",
    "Coral",
    "Dorr",
    "Freeport",
    "Gowen",
    "Grant",
    "Hopkins",
    "Howard City",
    "Kent City",
    "Lowell",
    "Mecosta",
    "Middleville",
    "Moline",
    "Morley",
    "Newaygo",
    "Paris",
    "Pierson",
    "Remus",
    "Rockford",
    "Rodney",
    "Sand Lake",
    "Shelbyville",
    "Sparta",
    "Stanwood",
    "Canadian Lake",
    "Canadian Lakes",
    "Trufant",
    "Wayland",
    "White Cloud",
    "Allendale",
    "Branch",
    "Conklin",
    "Coopersville",
    "Custer",
    "Douglas",
    "Fennville",
    "Ferrysburg",
    "Fountain",
    "Free Soil",
    "Fremont",
    "Fruitport",
    "Grand Haven",
    "Grandville",
    "Wyoming",
    "Hamilton",
    "Hart",
    "Hesperia",
    "Holland",
    "Holton",
    "Brunswick",
    "Hudsonville",
    "Jenison",
    "Georgetown Township",
    "Georgetown Tp",
    "Lamont",
    "Ludington",
    "Macatawa",
    "Marne",
    "Mears",
    "Silver Lake",
    "Montague",
    "Muskegon",
    "Norton Shores",
    "Muskegon Heights",
    "Muskegon Hts",
    "N Muskegon",
    "North Muskegon",
    "New Era",
    "Nunica",
    "Pentwater",
    "Pullman",
    "Ravenna",
    "Rothbury",
    "Saugatuck",
    "Scottville",
    "Shelby",
    "Spring Lake",
    "Twin Lake",
    "Walhalla",
    "Walkerville",
    "West Olive",
    "Whitehall",
    "Zeeland",
    "Grand Rapids",
    "E Grand Rapid",
    "East Grand Ra",
    "East Grand Rapids",
    "Kentwood",
    "Walker",
    "Cadillac",
    "Hoxeyville",
    "Alba",
    "Alden",
    "Arcadia",
    "Bear Lake",
    "Pierport",
    "Bellaire",
    "Benzonia",
    "Beulah",
    "Boon",
    "Brethren",
    "Buckley",
    "Cedar",
    "Central Lake",
    "Chase",
    "Copemish",
    "Eastlake",
    "Eastport",
    "Elberta",
    "Elk Rapids",
    "Empire",
    "Evart",
    "Falmouth",
    "Fife Lake",
    "Filer City",
    "Frankfort",
    "Glen Arbor",
    "Grawn",
    "Harrietta",
    "Hersey",
    "Honor",
    "Idlewild",
    "Interlochen",
    "Karlin",
    "Irons",
    "Kaleva",
    "Kalkaska",
    "Kewadin",
    "Kingsley",
    "Lake Ann",
    "Lake City",
    "Moorestown",
    "Lake Leelanau",
    "Leland",
    "Leroy",
    "Luther",
    "McBain",
    "Mancelona",
    "Manistee",
    "Stronach",
    "Manton",
    "Maple City",
    "Marion",
    "Merritt",
    "Mesick",
    "Northport",
    "Omena",
    "Onekama",
    "Rapid City",
    "Reed City",
    "Sears",
    "South Boardman",
    "S Boardman",
    "Suttons Bay",
    "Peshawbestown",
    "Thompsonville",
    "Traverse City",
    "Tustin",
    "Wellston",
    "Williamsburg",
    "Mackinaw City",
    "Afton",
    "Alanson",
    "Alpena",
    "Atlanta",
    "Barbeau",
    "Boyne City",
    "Boyne Falls",
    "Brimley",
    "Raco",
    "Brutus",
    "Burt Lake",
    "Carp Lake",
    "Cedarville",
    "Charlevoix",
    "Cheboygan",
    "Conway",
    "Dafter",
    "De Tour Village",
    "De Tour Vlg",
    "Drummond Island",
    "Drummond Is",
    "East Jordan",
    "Eckerman",
    "Strongs",
    "Ellsworth",
    "Elmira",
    "Frederic",
    "Gaylord",
    "Treetops Village",
    "Treetops Vlg",
    "Goetzville",
    "Stalwart",
    "Grayling",
    "Harbor Springs",
    "Harbor Point",
    "Harbor Spgs",
    "Wequetonsing",
    "Hawks",
    "Herron",
    "Hessel",
    "Hillman",
    "Hubbard Lake",
    "Hulbert",
    "Indian River",
    "Johannesburg",
    "Kinross",
    "Lachine",
    "Levering",
    "Lewiston",
    "Mackinac Island",
    "Mackinac Is",
    "Millersburg",
    "Ocqueoc",
    "Moran",
    "Naubinway",
    "Oden",
    "Onaway",
    "Ossineke",
    "Paradise",
    "Pellston",
    "Petoskey",
    "Bay Harbor",
    "Bay View",
    "Pickford",
    "Pointe Aux Pins",
    "Bois Blanc Is",
    "Bois Blanc Island",
    "Point Aux Pin",
    "Posen",
    "Presque Isle",
    "Rogers City",
    "Rudyard",
    "Fibre",
    "Saint Ignace",
    "Beaver Island",
    "Sault Sainte Marie",
    "Sault S Marie",
    "Kincheloe",
    "Topinabee",
    "Trout Lake",
    "Vanderbilt",
    "Walloon Lake",
    "Wolverine",
    "Iron Mountain",
    "Kingsford",
    "Allouez",
    "Au Train",
    "Bark River",
    "Hardwood",
    "Schaffer",
    "Big Bay",
    "Carney",
    "Champion",
    "Channing",
    "Chatham",
    "Limestone",
    "Cooks",
    "Cornell",
    "Curtis",
    "Daggett",
    "Deerton",
    "Eben Junction",
    "Rumely",
    "Engadine",
    "Escanaba",
    "Felch",
    "Little Lake",
    "Foster City",
    "Garden",
    "Germfask",
    "Gladstone",
    "Brampton",
    "Gould City",
    "Grand Marais",
    "Gulliver",
    "Gwinn",
    "Princeton",
    "Hermansville",
    "Ingalls",
    "Ishpeming",
    "Loretto",
    "Vulcan",
    "McMillan",
    "Manistique",
    "Thompson",
    "Marquette",
    "Harvey",
    "Menominee",
    "Michigamme",
    "Munising",
    "Christmas",
    "Nadeau",
    "Nahma",
    "Negaunee",
    "Newberry",
    "Norway",
    "Palmer",
    "Perkins",
    "Perronville",
    "Powers",
    "Quinnesec",
    "Ralph",
    "Rapid River",
    "Republic",
    "Rock",
    "Sagola",
    "Seney",
    "Shingleton",
    "Skandia",
    "Spalding",
    "Stephenson",
    "Cedar River",
    "Trenary",
    "Traunik",
    "Wallace",
    "Wells",
    "Wetmore",
    "Wilson",
    "Ahmeek",
    "Alpha",
    "Amasa",
    "Atlantic Mine",
    "Baraga",
    "Keweenaw Bay",
    "Bergland",
    "Bessemer",
    "Bruce Crossing",
    "Bruce Xing",
    "Calumet",
    "Laurium",
    "Caspian",
    "Chassell",
    "Copper City",
    "Copper Harbor",
    "Covington",
    "Crystal Falls",
    "Dodgeville",
    "Houghton",
    "Dollar Bay",
    "Ewen",
    "Gaastra",
    "Greenland",
    "Hancock",
    "Hubbell",
    "Iron River",
    "Beechwood",
    "Ironwood",
    "Kearsarge",
    "Lake Linden",
    "Gay",
    "Lanse",
    "Marenisco",
    "Merriweather",
    "Mass City",
    "Mohawk",
    "Eagle Harbor",
    "Eagle River",
    "Nisula",
    "Ontonagon",
    "Painesdale",
    "Pelkie",
    "Ramsay",
    "Rockland",
    "Sidnaw",
    "Skanee",
    "South Range",
    "Toivola",
    "Trout Creek",
    "Kenton",
    "Wakefield",
    "Watersmeet",
    "Watton",
    "White Pine",
  ],
  MN: [
    "Afton",
    "Bayport",
    "Bethel",
    "East Bethel",
    "Braham",
    "Brook Park",
    "Cambridge",
    "Cannon Falls",
    "Cedar",
    "Cedar E Bethl",
    "Cedar East Bethel",
    "Oak Grove",
    "Center City",
    "Chisago City",
    "Circle Pines",
    "Lino Lakes",
    "Cottage Grove",
    "Dalbo",
    "Dennison",
    "Stanton",
    "Dundas",
    "Elko New Market",
    "Elko",
    "Elko New Mrkt",
    "Faribault",
    "Farmington",
    "Forest Lake",
    "Columbus",
    "Frontenac",
    "Goodhue",
    "Bellechester",
    "Grandy",
    "Grasston",
    "Hampton",
    "New Trier",
    "Harris",
    "Hastings",
    "Henriette",
    "Hinckley",
    "Hugo",
    "Centerville",
    "Isanti",
    "Lake City",
    "Lake Elmo",
    "Lakeland",
    "Lake Saint Croix Beach",
    "Lakeland Shores",
    "Lakeland Shrs",
    "Saint Marys Point",
    "St Croix Bch",
    "St Croix Beach",
    "St Marys Point",
    "St Marys Pt",
    "Lakeville",
    "Lindstrom",
    "Lonsdale",
    "Veseli",
    "Marine On Saint Croix",
    "Marine St Crx",
    "Medford",
    "Owatonna",
    "Mora",
    "Morristown",
    "Nerstrand",
    "New Market",
    "Newport",
    "North Branch",
    "Northfield",
    "Pine City",
    "Beroun",
    "Randolph",
    "Red Wing",
    "Rosemount",
    "Rush City",
    "Saint Francis",
    "Saint Paul Park",
    "St Paul Park",
    "Sandstone",
    "Markville",
    "Scandia",
    "Shafer",
    "South Saint Paul",
    "South St Paul",
    "Inver Grove Heights",
    "Inver Grove",
    "Sunfish Lake",
    "Stacy",
    "Stanchfield",
    "Stillwater",
    "Oak Park Heights",
    "Oak Park Hgts",
    "Oak Park Hts",
    "W Lakeland",
    "West Lakeland",
    "Taylors Falls",
    "Vermillion",
    "Warsaw",
    "Webster",
    "Welch",
    "Willernie",
    "Wyoming",
    "Saint Paul",
    "W Saint Paul",
    "West Saint Paul",
    "Falcon Heights",
    "Falcon Hgts",
    "Lauderdale",
    "Little Canada",
    "Maplewood",
    "N Saint Paul",
    "North Saint Paul",
    "North St Paul",
    "Dellwood",
    "Vadnais Heights",
    "Vadnais Hts",
    "White Bear Lake",
    "White Bear Lk",
    "White Bear Township",
    "White Bear Tp",
    "Fort Snelling",
    "Arden Hills",
    "Mounds View",
    "New Brighton",
    "Roseville",
    "Mahtomedi",
    "Pine Springs",
    "Lilydale",
    "Mendota Heights",
    "Mendota Hts",
    "W St Paul",
    "West St Paul",
    "Eagan",
    "Apple Valley",
    "Woodbury",
    "No Oaks",
    "Shoreview",
    "North Oaks",
    "White Bear Lake Township",
    "Landfall Village",
    "Landfall Vlg",
    "Oakdale",
    "Mendota",
    "Albertville",
    "Otsego",
    "Annandale",
    "Anoka",
    "Andover",
    "Nowthen",
    "Ramsey",
    "Ham Lake",
    "Hopkins",
    "Minnetonka",
    "Burnsville",
    "Arlington",
    "Becker",
    "Big Lake",
    "Bird Island",
    "Maple Grove",
    "Osseo",
    "Brownton",
    "Buffalo",
    "Hanover",
    "Buffalo Lake",
    "Carver",
    "Champlin",
    "Chanhassen",
    "Chaska",
    "Victoria",
    "Clear Lake",
    "Clearwater",
    "Saint Augusta",
    "Cokato",
    "Cologne",
    "Darwin",
    "Dassel",
    "Kingston",
    "Dayton",
    "Delano",
    "Eden Valley",
    "Elk River",
    "Burns Township",
    "Burns Twp",
    "Excelsior",
    "Greenwood",
    "Minnetrista",
    "Shorewood",
    "Fairfax",
    "Franklin",
    "Gaylord",
    "Gibbon",
    "Glencoe",
    "Biscay",
    "Green Isle",
    "Hamburg",
    "Hamel",
    "Corcoran",
    "Medina",
    "Saint Michael",
    "Hector",
    "Eden Prairie",
    "Minetonka Mls",
    "Minnetnka Mls",
    "Minnetonka Mills",
    "Howard Lake",
    "Hutchinson",
    "Jordan",
    "Kimball",
    "Rockville",
    "Lester Prairie",
    "Lester Pr",
    "Litchfield",
    "Long Lake",
    "Orono",
    "Loretto",
    "Independence",
    "Maple Lake",
    "Silver Creek",
    "Maple Plain",
    "Mayer",
    "Monticello",
    "Montrose",
    "Mound",
    "New Auburn",
    "New Germany",
    "Norwood Young America",
    "Norwood",
    "Nya",
    "Plato",
    "Princeton",
    "Baldwin",
    "Prior Lake",
    "Shakopee",
    "Rockford",
    "Rogers",
    "Saint Bonifacius",
    "Crown College",
    "St Bonifacius",
    "Savage",
    "Silver Lake",
    "South Haven",
    "Spring Park",
    "Stewart",
    "Waconia",
    "Watertown",
    "Watkins",
    "Waverly",
    "Wayzata",
    "Winsted",
    "Winthrop",
    "Young America",
    "Zimmerman",
    "Minneapolis",
    "Edina",
    "Golden Valley",
    "Saint Louis Park",
    "St Louis Park",
    "Saint Anthony",
    "St Anthny Vlg",
    "St Anthony",
    "St Anthony Village",
    "Bloomington",
    "Columbia Heights",
    "Columbia Hts",
    "Fridley",
    "Hilltop",
    "Crystal",
    "Robbinsdale",
    "Richfield",
    "New Hope",
    "Brooklyn Center",
    "Brooklyn Ctr",
    "Brooklyn Park",
    "Spring Lake Park",
    "Spring Lk Pk",
    "Coon Rapids",
    "Blaine",
    "Medicine Lake",
    "Plymouth",
    "Beaver Bay",
    "Brimson",
    "Finland",
    "Grand Marais",
    "Grand Portage",
    "Hovland",
    "Isabella",
    "Knife River",
    "Lutsen",
    "Schroeder",
    "Silver Bay",
    "Little Marais",
    "Tofte",
    "Two Harbors",
    "Alborn",
    "Angora",
    "Askov",
    "Aurora",
    "Biwabik",
    "Babbitt",
    "Barnum",
    "Mahtowa",
    "Bovey",
    "Britt",
    "Brookston",
    "Bruno",
    "Buhl",
    "Calumet",
    "Canyon",
    "Carlton",
    "Chisholm",
    "Cloquet",
    "Cohasset",
    "Coleraine",
    "Cook",
    "Togo",
    "Cotton",
    "Kelsey",
    "Crane Lake",
    "Cromwell",
    "Ely",
    "Embarrass",
    "Esko",
    "Eveleth",
    "Finlayson",
    "Floodwood",
    "Wawina",
    "Forbes",
    "Zim",
    "Gilbert",
    "Mckinley",
    "Goodland",
    "Grand Rapids",
    "Hibbing",
    "Kelly Lake",
    "Hill City",
    "Holyoke",
    "Wrenshall",
    "Hoyt Lakes",
    "Iron",
    "Iron Junction",
    "Jacobson",
    "Keewatin",
    "Kerrick",
    "Duquette",
    "Kettle River",
    "Kinney",
    "Mcgregor",
    "Makinen",
    "Marble",
    "Meadowlands",
    "Toivola",
    "Moose Lake",
    "Mountain Iron",
    "Parkville",
    "Nashwauk",
    "Orr",
    "Buyck",
    "Gheen",
    "Nett Lake",
    "Pengilly",
    "Saginaw",
    "Culver",
    "Sawyer",
    "Side Lake",
    "Soudan",
    "Sturgeon Lake",
    "Swan River",
    "Swatara",
    "Taconite",
    "Tamarack",
    "Tower",
    "Virginia",
    "Warba",
    "Willow River",
    "Rutledge",
    "Winton",
    "Wright",
    "Duluth",
    "Rice Lake",
    "Hermantown",
    "Proctor",
    "Dlth Fed Pris",
    "Duluth Federal Prison",
    "Rochester",
    "Adams",
    "Altura",
    "Minneiska",
    "Austin",
    "Mapleview",
    "Nicolville",
    "Blooming Prairie",
    "Blmng Prairie",
    "Brownsdale",
    "Brownsville",
    "Byron",
    "Caledonia",
    "Canton",
    "Chatfield",
    "Claremont",
    "Dakota",
    "Dexter",
    "Dodge Center",
    "Dover",
    "Eitzen",
    "Elgin",
    "Elkton",
    "Eyota",
    "Viola",
    "Fountain",
    "Grand Meadow",
    "Harmony",
    "Granger",
    "Hayfield",
    "Hokah",
    "Houston",
    "Kasson",
    "Kellogg",
    "Theilman",
    "Kenyon",
    "La Crescent",
    "Lanesboro",
    "Whalan",
    "Lansing",
    "Le Roy",
    "Lewiston",
    "Lyle",
    "Mabel",
    "Mantorville",
    "Mazeppa",
    "Millville",
    "Minnesota City",
    "Minn City",
    "Oronoco",
    "Ostrander",
    "Peterson",
    "Rushford Village",
    "Rushford Vlg",
    "Pine Island",
    "Plainview",
    "Preston",
    "Racine",
    "Reads Landing",
    "Rollingstone",
    "Rose Creek",
    "Rushford",
    "Saint Charles",
    "Sargeant",
    "Spring Grove",
    "Spring Valley",
    "Stewartville",
    "Taopi",
    "Utica",
    "Wabasha",
    "Waltham",
    "Wanamingo",
    "West Concord",
    "Winona",
    "Goodview",
    "Stockton",
    "Wykoff",
    "Zumbro Falls",
    "Hammond",
    "Zumbrota",
    "Mankato",
    "Skyline",
    "North Mankato",
    "Albert Lea",
    "Manchester",
    "Oakland",
    "Alden",
    "Amboy",
    "Belle Plaine",
    "Blue Earth",
    "Bricelyn",
    "Clarks Grove",
    "Cleveland",
    "Comfrey",
    "Conger",
    "Courtland",
    "Darfur",
    "Delavan",
    "Eagle Lake",
    "Easton",
    "Ellendale",
    "Elmore",
    "Elysian",
    "Emmons",
    "Essig",
    "Fairmont",
    "Freeborn",
    "Frost",
    "Garden City",
    "Geneva",
    "Glenville",
    "London",
    "Myrtle",
    "Good Thunder",
    "Granada",
    "Hanska",
    "Hartland",
    "Hayward",
    "Henderson",
    "Hollandale",
    "Hope",
    "Janesville",
    "Kasota",
    "Kiester",
    "Kilkenny",
    "Lafayette",
    "Lake Crystal",
    "La Salle",
    "Le Center",
    "Le Sueur",
    "Lewisville",
    "Madelia",
    "Madison Lake",
    "Mapleton",
    "Minnesota Lake",
    "Minnesota Lk",
    "Montgomery",
    "New Prague",
    "Heidelberg",
    "New Richland",
    "New Ulm",
    "Klossner",
    "Searles",
    "Nicollet",
    "Northrop",
    "Pemberton",
    "Saint Clair",
    "Saint James",
    "Saint Peter",
    "Sanborn",
    "Sleepy Eye",
    "Cobden",
    "Evan",
    "Springfield",
    "Truman",
    "Twin Lakes",
    "Vernon Center",
    "Waldorf",
    "Waseca",
    "Meriden",
    "Otisco",
    "Waterville",
    "Wells",
    "Walters",
    "Winnebago",
    "Windom",
    "Wilder",
    "Adrian",
    "Alpha",
    "Arco",
    "Avoca",
    "Balaton",
    "Beaver Creek",
    "Bigelow",
    "Bingham Lake",
    "Brewster",
    "Butterfield",
    "Ceylon",
    "Chandler",
    "Currie",
    "Dovray",
    "Dunnell",
    "Edgerton",
    "Ellsworth",
    "Fulda",
    "Dundee",
    "Kinbrae",
    "Garvin",
    "Hardwick",
    "Hendricks",
    "Heron Lake",
    "Hills",
    "Holland",
    "Ihlen",
    "Iona",
    "Ivanhoe",
    "Jackson",
    "Jasper",
    "Trosky",
    "Jeffers",
    "Kanaranzi",
    "Kenneth",
    "Lake Benton",
    "Lakefield",
    "Lake Wilson",
    "Hadley",
    "Slayton",
    "Lamberton",
    "Leota",
    "Lismore",
    "Luverne",
    "Lynd",
    "Magnolia",
    "Mountain Lake",
    "Odin",
    "Okabena",
    "Ormsby",
    "Pipestone",
    "Hatfield",
    "Verdi",
    "Reading",
    "Revere",
    "Round Lake",
    "Rushmore",
    "Russell",
    "Ruthton",
    "Florence",
    "Sherburn",
    "Steen",
    "Storden",
    "Tracy",
    "Amiret",
    "Trimont",
    "Tyler",
    "Walnut Grove",
    "Welcome",
    "Westbrook",
    "Wilmont",
    "Woodstock",
    "Worthington",
    "Willmar",
    "Alberta",
    "Appleton",
    "Atwater",
    "Barry",
    "Beardsley",
    "Bellingham",
    "Belview",
    "Benson",
    "Blomkest",
    "Svea",
    "Boyd",
    "Browns Valley",
    "Canby",
    "Chokio",
    "Clara City",
    "Clarkfield",
    "Clements",
    "Clinton",
    "Clontarf",
    "Correll",
    "Cosmos",
    "Cottonwood",
    "Danube",
    "Danvers",
    "Dawson",
    "Donnelly",
    "Dumont",
    "Johnson",
    "Echo",
    "Ghent",
    "Graceville",
    "Granite Falls",
    "Hazel Run",
    "Grove City",
    "Hancock",
    "Hanley Falls",
    "Herman",
    "Holloway",
    "Kandiyohi",
    "Kerkhoven",
    "Lake Lillian",
    "Lucan",
    "Madison",
    "Louisburg",
    "Marietta",
    "Nassau",
    "Marshall",
    "Maynard",
    "Milan",
    "Milroy",
    "Minneota",
    "Saint Leo",
    "Montevideo",
    "Morgan",
    "Morris",
    "Morton",
    "Murdock",
    "De Graff",
    "New London",
    "Hawick",
    "Norcross",
    "Odessa",
    "Olivia",
    "Ortonville",
    "Pennock",
    "Porter",
    "Prinsburg",
    "Raymond",
    "Redwood Falls",
    "Delhi",
    "North Redwood",
    "Renville",
    "Sacred Heart",
    "Seaforth",
    "Spicer",
    "Sunburg",
    "Taunton",
    "Vesta",
    "Wabasso",
    "Wanda",
    "Watson",
    "Wheaton",
    "Wood Lake",
    "Saint Cloud",
    "Sartell",
    "Albany",
    "Alexandria",
    "Forada",
    "Ashby",
    "Avon",
    "Barrett",
    "Belgrade",
    "Regal",
    "Bock",
    "Bowlus",
    "Elmdale",
    "Brandon",
    "Millerville",
    "Brooten",
    "Burtrum",
    "Carlos",
    "Cold Spring",
    "Collegeville",
    "Cyrus",
    "Dalton",
    "Elrosa",
    "Evansville",
    "Farwell",
    "Flensburg",
    "Foley",
    "Oak Park",
    "Foreston",
    "Freeport",
    "Saint Rosa",
    "Garfield",
    "Glenwood",
    "Long Beach",
    "Sedan",
    "Greenwald",
    "Grey Eagle",
    "Hillman",
    "Hoffman",
    "Holdingford",
    "Isle",
    "Kensington",
    "Little Falls",
    "Sobieski",
    "Long Prairie",
    "Little Sauk",
    "Lowry",
    "McGrath",
    "Melrose",
    "Meire Grove",
    "Spring Hill",
    "Milaca",
    "Miltona",
    "Nelson",
    "New Munich",
    "Ronneby",
    "Ogilvie",
    "Onamia",
    "Osakis",
    "Parkers Prairie",
    "Parkers Pr",
    "Paynesville",
    "Lake Henry",
    "Pease",
    "Pierz",
    "Harding",
    "Rice",
    "Richmond",
    "Roscoe",
    "Royalton",
    "Saint Joseph",
    "Saint Stephen",
    "Saint Martin",
    "Sauk Centre",
    "Sauk Rapids",
    "Starbuck",
    "Swanville",
    "Upsala",
    "Villard",
    "Westport",
    "Wahkon",
    "Waite Park",
    "West Union",
    "Brainerd",
    "Baxter",
    "E Gull Lake",
    "East Gull Lake",
    "Aitkin",
    "Akeley",
    "Aldrich",
    "Backus",
    "Bertha",
    "Browerville",
    "Clarissa",
    "Crosby",
    "Crosslake",
    "Manhattan Bch",
    "Manhattan Beach",
    "Cushing",
    "Deerwood",
    "Eagle Bend",
    "Emily",
    "Fifty Lakes",
    "Fort Ripley",
    "Garrison",
    "Hackensack",
    "Hewitt",
    "Ironton",
    "Riverton",
    "Lake George",
    "Laporte",
    "Menahga",
    "Merrifield",
    "Nisswa",
    "Motley",
    "Nevis",
    "Lake Hubert",
    "Lake Shore",
    "Palisade",
    "Park Rapids",
    "Lake Itasca",
    "Pequot Lakes",
    "Breezy Point",
    "Jenkins",
    "Pillager",
    "Pine River",
    "Randall",
    "Sebeka",
    "Staples",
    "Verndale",
    "Wadena",
    "Walker",
    "Whipholt",
    "Detroit Lakes",
    "Ada",
    "Audubon",
    "Barnesville",
    "Downer",
    "Battle Lake",
    "Bejou",
    "Beltrami",
    "Bluffton",
    "Borup",
    "Breckenridge",
    "Callaway",
    "Campbell",
    "Doran",
    "Climax",
    "Eldred",
    "Clitherall",
    "Comstock",
    "Deer Creek",
    "Dent",
    "Dilworth",
    "Elbow Lake",
    "Elizabeth",
    "Erhard",
    "Erskine",
    "Felton",
    "Fergus Falls",
    "Carlisle",
    "Fertile",
    "Flom",
    "Fosston",
    "Foxhome",
    "Frazee",
    "Gary",
    "Georgetown",
    "Glyndon",
    "Moorhead",
    "Halstad",
    "Hawley",
    "Rollag",
    "Hendrum",
    "Henning",
    "Hitterdal",
    "Kent",
    "Lake Park",
    "Mcintosh",
    "Mahnomen",
    "Nashua",
    "Naytahwaush",
    "New York Mills",
    "New York Mls",
    "Nielsville",
    "Ogema",
    "Osage",
    "Ottertail",
    "Pelican Rapids",
    "Pel Rapids",
    "Perham",
    "Perley",
    "Ponsford",
    "Richville",
    "Rochert",
    "Rothsay",
    "Sabin",
    "Baker",
    "Shelly",
    "Tintah",
    "Tenney",
    "Twin Valley",
    "Ulen",
    "Underwood",
    "Vergas",
    "Vining",
    "Waubun",
    "Wendell",
    "White Earth",
    "Winger",
    "Wolverton",
    "Bemidji",
    "Turtle River",
    "Wilton",
    "Bagley",
    "Baudette",
    "Pitt",
    "Bena",
    "Big Falls",
    "Bigfork",
    "Birchdale",
    "Blackduck",
    "Cass Lake",
    "Clearbrook",
    "Deer River",
    "Talmoon",
    "Effie",
    "Federal Dam",
    "Gonvick",
    "Gully",
    "Hines",
    "International Falls",
    "Intl Falls",
    "Ranier",
    "Kelliher",
    "Saum",
    "Lengby",
    "Leonard",
    "Littlefork",
    "Loman",
    "Longville",
    "Marcell",
    "Margie",
    "Max",
    "Mizpah",
    "Northome",
    "Outing",
    "Pennington",
    "Ponemah",
    "Puposky",
    "Kabetogama",
    "Ray",
    "Redby",
    "Redlake",
    "Remer",
    "Boy River",
    "Roosevelt",
    "Shevlin",
    "Pinewood",
    "Solway",
    "Becida",
    "Spring Lake",
    "Squaw Lake",
    "Tenstrike",
    "Trail",
    "Waskish",
    "Williams",
    "Wirt",
    "Thief River Falls",
    "Thief Rvr Fls",
    "Alvarado",
    "Angle Inlet",
    "Argyle",
    "Badger",
    "Brooks",
    "Crookston",
    "Donaldson",
    "East Grand Forks",
    "E Grand Forks",
    "Euclid",
    "Fisher",
    "Gatzke",
    "Goodridge",
    "Greenbush",
    "Grygla",
    "Hallock",
    "Halma",
    "Humboldt",
    "Karlstad",
    "Kennedy",
    "Lake Bronson",
    "Lancaster",
    "Orleans",
    "Mentor",
    "Middle River",
    "Newfolden",
    "Holt",
    "Oklee",
    "Oslo",
    "Plummer",
    "Red Lake Falls",
    "Rl Falls",
    "Roseau",
    "Pencer",
    "Ross",
    "Saint Hilaire",
    "Saint Vincent",
    "Salol",
    "Stephen",
    "Strandquist",
    "Strathcona",
    "Viking",
    "Wannaska",
    "Warren",
    "Angus",
    "Radium",
    "Warroad",
  ],
  MO: [
    "Chesterfield",
    "Wildwood",
    "Arnold",
    "Ballwin",
    "Ellisville",
    "Manchester",
    "Barnhart",
    "Beaufort",
    "Berger",
    "Catawissa",
    "Cedar Hill",
    "Cedar Hill Lakes",
    "Cedar Hl Lks",
    "Town And Country",
    "Twn And Cntry",
    "Crystal City",
    "De Soto",
    "Dittmer",
    "Eureka",
    "Allenton",
    "Byrnes Mill",
    "Crescent",
    "Fenton",
    "Festus",
    "Fletcher",
    "Florissant",
    "Black Jack",
    "French Village",
    "French Vlg",
    "Gerald",
    "Glencoe",
    "Gray Summit",
    "Grover",
    "Grubville",
    "Hazelwood",
    "Maryland Heights",
    "Champ",
    "Maryland Hts",
    "Bridgeton",
    "Earth City",
    "Hematite",
    "Herculaneum",
    "High Ridge",
    "Parkdale",
    "Hillsboro",
    "House Springs",
    "Imperial",
    "Antonia",
    "Otto",
    "Sulphur Spg",
    "Sulphur Springs",
    "Kimmswick",
    "Labadie",
    "Leslie",
    "Lonedell",
    "Luebbering",
    "New Haven",
    "Pacific",
    "La Barque Creek",
    "La Barque Crk",
    "Pevely",
    "Richwoods",
    "Robertsville",
    "Saint Albans",
    "Saint Ann",
    "Northwest Plaza",
    "Nw Plaza",
    "Saint Clair",
    "Stanton",
    "Sullivan",
    "Union",
    "Valles Mines",
    "Valley Park",
    "Twin Oaks",
    "Villa Ridge",
    "Washington",
    "Rosebud",
    "Saint Louis",
    "Clayton",
    "Breckenridge Hills",
    "Brecknrdg Hls",
    "Overland",
    "Sycamore Hills",
    "Sycamore Hls",
    "Vinita Ter",
    "Vinita Terrace",
    "Richmond Heights",
    "Richmond Hts",
    "Webster Groves",
    "Webster Grvs",
    "Cool Valley",
    "Glen Echo Pk",
    "Hillsdale",
    "Normandy",
    "Norwood Court",
    "Uplands Park",
    "Velda City",
    "Kirkwood",
    "Affton",
    "Grantwood Village",
    "Grantwood Vlg",
    "Lakeshire",
    "Mackenzie",
    "Marlborough",
    "Saint George",
    "Lemay",
    "Sappington",
    "Oakville",
    "University City",
    "University Cy",
    "Des Peres",
    "Frontenac",
    "Olivette",
    "Berkeley",
    "Ferguson",
    "Jennings",
    "North County",
    "Kinloch",
    "Creve Coeur",
    "Maplewood",
    "Brentwood",
    "Saint Charles",
    "Saint Peters",
    "Cottleville",
    "Weldon Spring",
    "Annada",
    "Augusta",
    "Bellflower",
    "Bowling Green",
    "Clarksville",
    "Paynesville",
    "Curryville",
    "Defiance",
    "Elsberry",
    "Eolia",
    "Farber",
    "Foley",
    "Foristell",
    "Hawk Point",
    "High Hill",
    "Jonesburg",
    "Laddonia",
    "Louisiana",
    "Marthasville",
    "Lake Sherwood",
    "Middletown",
    "New Hartford",
    "Montgomery City",
    "Buell",
    "Danville",
    "Mineola",
    "Montgomery Cy",
    "Moscow Mills",
    "New Florence",
    "New Melle",
    "O'Fallon",
    "Dardenne Pr",
    "Dardenne Prairie",
    "Saint Paul",
    "Lake Saint Louis",
    "Lake St Louis",
    "O Fallon",
    "Old Monroe",
    "Portage Des Sioux",
    "Prtg De Sioux",
    "Prtg De Souix",
    "Silex",
    "Olney",
    "Troy",
    "Cave",
    "Truesdale",
    "Warrenton",
    "Truxton",
    "Vandalia",
    "Wellsville",
    "Wentzville",
    "West Alton",
    "Whiteside",
    "Williamsburg",
    "Winfield",
    "Wright City",
    "Innsbrook",
    "Hannibal",
    "Alexandria",
    "Anabel",
    "Arbela",
    "Ashburn",
    "Bethel",
    "Canton",
    "Center",
    "Clarence",
    "Durham",
    "Emden",
    "Ewing",
    "Frankford",
    "Hunnewell",
    "Kahoka",
    "Knox City",
    "La Belle",
    "Steffenville",
    "La Grange",
    "Lentner",
    "Leonard",
    "Lewistown",
    "Luray",
    "Maywood",
    "Monroe City",
    "Monticello",
    "Newark",
    "New London",
    "Novelty",
    "Palmyra",
    "Perry",
    "Philadelphia",
    "Revere",
    "Saint Patrick",
    "Saverton",
    "Shelbina",
    "Shelbyville",
    "Plevna",
    "Taylor",
    "Wayland",
    "Williamstown",
    "Wyaconda",
    "Kirksville",
    "Atlanta",
    "Baring",
    "Bevier",
    "Brashear",
    "Callao",
    "Coatsville",
    "Downing",
    "Edina",
    "Elmer",
    "Ethel",
    "Gibbs",
    "Glenwood",
    "Gorin",
    "South Gorin",
    "Green Castle",
    "Green City",
    "Greentop",
    "Hurdland",
    "Lancaster",
    "La Plata",
    "Livonia",
    "Macon",
    "Memphis",
    "Milan",
    "New Boston",
    "New Cambria",
    "Novinger",
    "Pollock",
    "Queen City",
    "Worthington",
    "Rutledge",
    "Unionville",
    "Winigan",
    "Park Hills",
    "Desloge",
    "Elvins",
    "Flat River",
    "Frankclay",
    "Leadington",
    "Leadwood",
    "Rivermines",
    "Annapolis",
    "Glover",
    "Arcadia",
    "Belgrade",
    "Belleview",
    "Bismarck",
    "Black",
    "Blackwell",
    "Bloomsdale",
    "Bonne Terre",
    "Bunker",
    "Cadet",
    "Caledonia",
    "Centerville",
    "Des Arc",
    "Doe Run",
    "Ellington",
    "Farmington",
    "Fredericktown",
    "Millcreek",
    "Mine La Motte",
    "Irondale",
    "Ironton",
    "Lesterville",
    "Marquand",
    "Middle Brook",
    "Mineral Point",
    "Patton",
    "Pilot Knob",
    "Potosi",
    "Redford",
    "Sainte Genevieve",
    "New Offenburg",
    "Ste Genevieve",
    "Saint Mary",
    "Tiff",
    "Vulcan",
    "Cape Girardeau",
    "Cpe Girardeau",
    "Advance",
    "Altenburg",
    "New Wells",
    "Bell City",
    "Benton",
    "Brownwood",
    "Burfordville",
    "Chaffee",
    "Commerce",
    "Daisy",
    "Delta",
    "Dutchtown",
    "Farrar",
    "Friedheim",
    "Perryville",
    "Frohna",
    "Wittenberg",
    "Gipsy",
    "Glenallen",
    "Grassy",
    "Jackson",
    "Kelso",
    "Leopold",
    "McGee",
    "Marble Hill",
    "Lutesville",
    "Scopus",
    "Millersville",
    "Morley",
    "Oak Ridge",
    "Old Appleton",
    "Oran",
    "Painton",
    "Perkins",
    "Scott City",
    "Sedgewickville",
    "Sedgewickvlle",
    "Sturdivant",
    "Uniontown",
    "Vanduser",
    "Whitewater",
    "Zalma",
    "Arab",
    "Sikeston",
    "Miner",
    "Anniston",
    "Arbyrd",
    "Bernie",
    "Bertrand",
    "Blodgett",
    "Bloomfield",
    "Braggadocio",
    "Bragg City",
    "Canalou",
    "Cardwell",
    "Caruthersville",
    "Caruthersvlle",
    "Catron",
    "Charleston",
    "Clarkton",
    "Cooter",
    "Deering",
    "Dexter",
    "East Prairie",
    "Essex",
    "Gibson",
    "Gideon",
    "Gobler",
    "Grayridge",
    "Hayti",
    "Hayti Heights",
    "Pascola",
    "Holcomb",
    "Holland",
    "Hornersville",
    "Kennett",
    "Kewanee",
    "Lilbourn",
    "Malden",
    "Marston",
    "Matthews",
    "Morehouse",
    "New Madrid",
    "Parma",
    "Portageville",
    "Conran",
    "Risco",
    "Senath",
    "Steele",
    "Tallapoosa",
    "Wardell",
    "Homestown",
    "Whiteoak",
    "Wyatt",
    "Poplar Bluff",
    "Rombauer",
    "Broseley",
    "Campbell",
    "Clubb",
    "Silva",
    "Doniphan",
    "Poynor",
    "Dudley",
    "Ellsinore",
    "Fairdealing",
    "Fisk",
    "Fremont",
    "Gatewood",
    "Grandin",
    "Greenville",
    "Hiram",
    "Harviell",
    "Lodi",
    "Lowndes",
    "Mill Spring",
    "Naylor",
    "Neelyville",
    "Oxly",
    "Patterson",
    "Piedmont",
    "Puxico",
    "Qulin",
    "Van Buren",
    "Wappapello",
    "Williamsville",
    "Alma",
    "Bates City",
    "Belton",
    "Village Of Loch Lloyd",
    "Vlg Loch Loyd",
    "Blue Springs",
    "Lake Tapawingo",
    "Lake Tapwingo",
    "Buckner",
    "Camden",
    "Camden Point",
    "Centerview",
    "Concordia",
    "Corder",
    "Dover",
    "Excelsior Springs",
    "Crystal Lakes",
    "Excelsior Spg",
    "Exclsor Sprgs",
    "Homestead Vlg",
    "Mosby",
    "Wood Heights",
    "Farley",
    "Grain Valley",
    "Grandview",
    "Greenwood",
    "Lake Winnebago",
    "Lk Winnebago",
    "Hardin",
    "Henrietta",
    "Higginsville",
    "Holden",
    "Holt",
    "Independence",
    "Sugar Creek",
    "Kearney",
    "Kingsville",
    "Lawson",
    "Elmira",
    "Excelsior Est",
    "Excelsior Estates",
    "Lees Summit",
    "Unity Village",
    "Levasy",
    "Lexington",
    "Liberty",
    "Pleasant Valley",
    "Pleasant Vly",
    "Lone Jack",
    "Mayview",
    "Missouri City",
    "Napoleon",
    "Oak Grove",
    "Odessa",
    "Orrick",
    "Peculiar",
    "Platte City",
    "Pleasant Hill",
    "Raymore",
    "Rayville",
    "Richmond",
    "Lake Lotawana",
    "Sibley",
    "Smithville",
    "Strasburg",
    "Waldron",
    "Warrensburg",
    "Waverly",
    "Wellington",
    "Weston",
    "Kansas City",
    "N Kansas City",
    "North Kansas City",
    "Avondale",
    "Randolph",
    "Gladstone",
    "Claycomo",
    "Raytown",
    "Martin City",
    "Riverside",
    "Northmoor",
    "Houston Lake",
    "Lake Waukomis",
    "Platte Woods",
    "Parkville",
    "Weatherby Lake",
    "Wthrby Lake",
    "Birmingham",
    "Ferrelview",
    "Agency",
    "Albany",
    "Allendale",
    "Amazonia",
    "Amity",
    "Barnard",
    "Bethany",
    "Blythedale",
    "Bolckow",
    "Burlington Junction",
    "Brlngton Jct",
    "Cameron",
    "Clarksdale",
    "Clearmont",
    "Clyde",
    "Conception",
    "Conception Junction",
    "Cncpton Jct",
    "Cosby",
    "Craig",
    "Bigelow",
    "Corning",
    "Fortescue",
    "Darlington",
    "Dearborn",
    "De Kalb",
    "Denver",
    "Eagleville",
    "Easton",
    "Edgerton",
    "Elmo",
    "Fairfax",
    "Faucett",
    "Fillmore",
    "Forest City",
    "Gentry",
    "Gower",
    "Graham",
    "Grant City",
    "Guilford",
    "Hatfield",
    "Helena",
    "Hopkins",
    "King City",
    "Lathrop",
    "Maitland",
    "Martinsville",
    "Maryville",
    "Maysville",
    "Fairport",
    "Mound City",
    "New Hampton",
    "Oregon",
    "New Point",
    "Nw Point",
    "Osborn",
    "Parnell",
    "Pickering",
    "Plattsburg",
    "Ravenwood",
    "Rea",
    "Ridgeway",
    "Mount Moriah",
    "Rock Port",
    "Rosendale",
    "Rushville",
    "Savannah",
    "Sheridan",
    "Skidmore",
    "Quitman",
    "Stanberry",
    "Stewartsville",
    "Hemple",
    "Tarkio",
    "Trimble",
    "Turney",
    "Union Star",
    "Watson",
    "Weatherby",
    "Westboro",
    "Worth",
    "Saint Joseph",
    "Country Club",
    "Chillicothe",
    "Avalon",
    "Altamont",
    "Bogard",
    "Bosworth",
    "Braymer",
    "Breckenridge",
    "Brookfield",
    "Saint Catharine",
    "St Catharine",
    "Browning",
    "Bucklin",
    "Cainsville",
    "Carrollton",
    "Chula",
    "Coffey",
    "Cowgill",
    "Dawn",
    "De Witt",
    "Gallatin",
    "Galt",
    "Gilman City",
    "Brimson",
    "Hale",
    "Hamilton",
    "Harris",
    "Humphreys",
    "Jameson",
    "Jamesport",
    "Kidder",
    "Kingston",
    "Laclede",
    "Laredo",
    "Linneus",
    "Lock Springs",
    "Lucerne",
    "Ludlow",
    "McFall",
    "Marceline",
    "Meadville",
    "Mendon",
    "Mercer",
    "Mooresville",
    "Newtown",
    "Norborne",
    "Pattonsburg",
    "Polo",
    "Powersville",
    "Princeton",
    "Purdin",
    "Rothville",
    "Spickard",
    "Sumner",
    "Tina",
    "Trenton",
    "Utica",
    "Wheeling",
    "Winston",
    "Harrisonville",
    "Adrian",
    "Amoret",
    "Amsterdam",
    "Appleton City",
    "Archie",
    "Austin",
    "Blairstown",
    "Bronaugh",
    "Butler",
    "Passaic",
    "Chilhowee",
    "Cleveland",
    "West Line",
    "Clinton",
    "Collins",
    "Creighton",
    "Deepwater",
    "Deerfield",
    "Drexel",
    "East Lynne",
    "El Dorado Springs",
    "El Dorado Spg",
    "Foster",
    "Freeman",
    "Lake Annette",
    "Garden City",
    "Latour",
    "Golden City",
    "Harwood",
    "Hume",
    "Stotesbury",
    "Jasper",
    "Jerico Springs",
    "Jerico Sprgs",
    "Lamar",
    "Iantha",
    "Irwin",
    "Leeton",
    "Liberal",
    "Lowry City",
    "Metz",
    "Milo",
    "Mindenmines",
    "Montrose",
    "Moundville",
    "Nevada",
    "Osceola",
    "Vista",
    "Richards",
    "Horton",
    "Rich Hill",
    "Rockville",
    "Roscoe",
    "Schell City",
    "Sheldon",
    "Urich",
    "Walker",
    "Joplin",
    "Loma Linda",
    "Alba",
    "Anderson",
    "Asbury",
    "Waco",
    "Avilla",
    "Carl Junction",
    "Carterville",
    "Carthage",
    "Diamond",
    "Duenweg",
    "Fairview",
    "Goodman",
    "Granby",
    "Lanagan",
    "La Russell",
    "Neck City",
    "Neosho",
    "Noel",
    "Oronogo",
    "Pineville",
    "Jane",
    "Purcell",
    "Racine",
    "Reeds",
    "Rocky Comfort",
    "Sarcoxie",
    "South West City",
    "South West Cy",
    "Seneca",
    "Stark City",
    "Stella",
    "Tiff City",
    "Webb City",
    "Wentworth",
    "Wheaton",
    "Argyle",
    "Ashland",
    "Barnett",
    "Belle",
    "Bland",
    "Bonnots Mill",
    "Brumley",
    "California",
    "Camdenton",
    "Centertown",
    "Chamois",
    "Clarksburg",
    "Eldon",
    "Etterville",
    "Rocky Mount",
    "Eugene",
    "Fortuna",
    "Freeburg",
    "Gravois Mills",
    "Hartsburg",
    "Henley",
    "Hermann",
    "Mckittrick",
    "Holts Summit",
    "Lake Mykee",
    "Jamestown",
    "Kaiser",
    "Koeltztown",
    "Lake Ozark",
    "Four Seasons",
    "Village Of Four Seasons",
    "Vlg Of 4 Ssns",
    "Latham",
    "Linn",
    "Linn Creek",
    "Lohman",
    "Loose Creek",
    "Meta",
    "Mokane",
    "Morrison",
    "Gasconade",
    "Mount Sterling",
    "Mt Sterling",
    "New Bloomfield",
    "New Bloomfld",
    "Olean",
    "Osage Beach",
    "Owensville",
    "Portland",
    "Prairie Home",
    "Rhineland",
    "Russellville",
    "Saint Elizabeth",
    "St Elizabeth",
    "Saint Thomas",
    "Steedman",
    "Stover",
    "Sunrise Beach",
    "Tebbetts",
    "Tipton",
    "Tuscumbia",
    "Ulman",
    "Versailles",
    "Westphalia",
    "Jefferson City",
    "Cedar City",
    "Jefferson Cty",
    "Wardsville",
    "Saint Martins",
    "Columbia",
    "Armstrong",
    "Auxvasse",
    "Benton City",
    "Boonville",
    "Brunswick",
    "Bunceton",
    "Cairo",
    "Centralia",
    "Clark",
    "Clifton Hill",
    "Dalton",
    "Excello",
    "Fayette",
    "Franklin",
    "Fulton",
    "Glasgow",
    "Hallsville",
    "Harrisburg",
    "Higbee",
    "Holliday",
    "Huntsville",
    "Jacksonville",
    "Keytesville",
    "Kingdom City",
    "Madison",
    "Martinsburg",
    "Mexico",
    "Moberly",
    "New Franklin",
    "Paris",
    "Pilot Grove",
    "Renick",
    "Rocheport",
    "Rush Hill",
    "Salisbury",
    "Santa Fe",
    "Stoutsville",
    "Florida",
    "Sturgeon",
    "Thompson",
    "Triplett",
    "Wooldridge",
    "Sedalia",
    "Whiteman Air Force Base",
    "Whiteman AFB",
    "Arrow Rock",
    "Blackburn",
    "Blackwater",
    "Calhoun",
    "Climax Springs",
    "Climax Sprgs",
    "Cole Camp",
    "Edwards",
    "Emma",
    "Florence",
    "Gilliam",
    "Green Ridge",
    "Houstonia",
    "Hughesville",
    "Ionia",
    "Knob Noster",
    "La Monte",
    "Lincoln",
    "Malta Bend",
    "Grand Pass",
    "Mount Leonard",
    "Marshall",
    "Napton",
    "Miami",
    "Mora",
    "Nelson",
    "Otterville",
    "Slater",
    "Smithton",
    "Sweet Springs",
    "Syracuse",
    "Warsaw",
    "Windsor",
    "Rolla",
    "Doolittle",
    "Lecoma",
    "Beulah",
    "Birch Tree",
    "Teresita",
    "Bixby",
    "Boss",
    "Bourbon",
    "Brinktown",
    "Bucyrus",
    "Bendavis",
    "Cherryville",
    "Cook Sta",
    "Crocker",
    "Cuba",
    "Davisville",
    "Devils Elbow",
    "Dixon",
    "Duke",
    "Edgar Springs",
    "Eldridge",
    "Elk Creek",
    "Eminence",
    "Eunice",
    "Falcon",
    "Fort Leonard Wood",
    "Ft Leonard Wd",
    "Hartshorn",
    "Houston",
    "Huggins",
    "Iberia",
    "Jadwin",
    "Jerome",
    "Laquey",
    "Leasburg",
    "Lebanon",
    "Lenox",
    "Licking",
    "Lynchburg",
    "Mountain View",
    "Newburg",
    "Plato",
    "Raymondville",
    "Richland",
    "Swedeborg",
    "Roby",
    "Saint James",
    "Salem",
    "Solo",
    "Steelville",
    "Berryman",
    "Courtois",
    "Viburnum",
    "Stoutland",
    "Success",
    "Summersville",
    "Vichy",
    "Vienna",
    "Waynesville",
    "Saint Robert",
    "Wesco",
    "Winona",
    "Yukon",
    "Long Lane",
    "Montreal",
    "Aldrich",
    "Arcola",
    "Ash Grove",
    "Aurora",
    "Jenkins",
    "Alton",
    "Ava",
    "Bakersfield",
    "Billings",
    "Blue Eye",
    "Bois D Arc",
    "Bolivar",
    "Cherkee Hmstd",
    "Cherokee Homestead Village",
    "Bradleyville",
    "Branson",
    "Brighton",
    "Brixey",
    "Brookline",
    "Battlefield",
    "Brookline Sta",
    "Bruner",
    "Buffalo",
    "Butterfield",
    "Cassville",
    "Cape Fair",
    "Galena",
    "Caulfield",
    "Cedarcreek",
    "Chadwick",
    "Chestnutridge",
    "Saddlebrooke",
    "Clever",
    "Conway",
    "Crane",
    "Cross Timbers",
    "Dadeville",
    "Dora",
    "Drury",
    "Dunnegan",
    "Eagle Rock",
    "Elkland",
    "Everton",
    "Exeter",
    "Fair Grove",
    "Fair Play",
    "Flemington",
    "Fordland",
    "Forsyth",
    "Freistatt",
    "Gainesville",
    "Garrison",
    "Golden",
    "Graff",
    "Greenfield",
    "Grovespring",
    "Half Way",
    "Goodson",
    "Halltown",
    "Hardenville",
    "Hartville",
    "Hermitage",
    "Highlandville",
    "Hollister",
    "Humansville",
    "Hurley",
    "Isabella",
    "Kirbyville",
    "Kissee Mills",
    "Lampe",
    "Lockwood",
    "Louisburg",
    "Kimberling City",
    "Kimberling Cy",
    "Brandsville",
    "Cabool",
    "Couch",
    "Koshkonong",
    "Macomb",
    "Mansfield",
    "Marionville",
    "Marshfield",
    "Miller",
    "Monett",
    "Morrisville",
    "Eudora",
    "Mountain Grove",
    "Mountain Grv",
    "Mount Vernon",
    "Niangua",
    "Nixa",
    "Noble",
    "Norwood",
    "Oldfield",
    "Ozark",
    "Phillipsburg",
    "Pierce City",
    "Pittsburg",
    "Pleasant Hope",
    "Point Lookout",
    "Polk",
    "Ponce De Leon",
    "Pontiac",
    "Powell",
    "Powersite",
    "Preston",
    "Protem",
    "Purdy",
    "Quincy",
    "Reeds Spring",
    "Branson West",
    "Republic",
    "Ridgedale",
    "Rockaway Beach",
    "Merriam Vlg",
    "Merriam Woods Village",
    "Rockaway Bch",
    "Rockbridge",
    "Rogersville",
    "Rueter",
    "Seligman",
    "Seymour",
    "Shell Knob",
    "South Greenfield",
    "S Greenfield",
    "Sparta",
    "Spokane",
    "Squires",
    "Stotts City",
    "Strafford",
    "Taneyville",
    "Tecumseh",
    "Sycamore",
    "Theodosia",
    "Dugginsville",
    "Thornfield",
    "Nottinghill",
    "Tunas",
    "Udall",
    "Urbana",
    "Vanzant",
    "Verona",
    "Walnut Grove",
    "Walnut Shade",
    "Washburn",
    "Wasola",
    "Souder",
    "Weaubleau",
    "West Plains",
    "Moody",
    "Myrtle",
    "Wheatland",
    "Willard",
    "Windyville",
    "Zanoni",
    "Stockton",
    "Macks Creek",
    "Roach",
    "Peace Valley",
    "Pomona",
    "Pottersville",
    "Thayer",
    "Willow Springs",
    "Willow Spgs",
    "Springfield",
  ],
  MP: ["Saipan", "Rota", "Tinian"],
  MS: [
    "Abbeville",
    "Ashland",
    "Canaan",
    "Snow Lake Shores",
    "Snow Lake Shr",
    "Batesville",
    "Blue Mountain",
    "Byhalia",
    "Clarksdale",
    "Mattson",
    "Stovall",
    "Coahoma",
    "Rich",
    "Coldwater",
    "Como",
    "Courtland",
    "Crenshaw",
    "Askew",
    "Crowder",
    "Darling",
    "Dumas",
    "Dundee",
    "Etta",
    "Falkner",
    "Friars Point",
    "Hernando",
    "Hickory Flat",
    "Holly Springs",
    "Mount Pleasant",
    "Mt Pleasant",
    "Horn Lake",
    "Jonestown",
    "Lake Cormorant",
    "Lk Cormorant",
    "Lamar",
    "Lambert",
    "Lula",
    "Lyon",
    "Marks",
    "Michigan City",
    "Myrtle",
    "Nesbit",
    "New Albany",
    "Olive Branch",
    "Mineral Wells",
    "Oxford",
    "Lafayette",
    "Pope",
    "Potts Camp",
    "Red Banks",
    "Ripley",
    "Robinsonville",
    "Sarah",
    "Savage",
    "Sardis",
    "Senatobia",
    "Sledge",
    "Southaven",
    "Taylor",
    "Tiplersville",
    "Tunica",
    "University",
    "Walls",
    "Walnut",
    "Waterford",
    "Greenville",
    "Lamont",
    "Alligator",
    "Anguilla",
    "Nitta Yuma",
    "Arcola",
    "Avon",
    "Benoit",
    "Beulah",
    "Boyle",
    "Skene",
    "Chatham",
    "Cleveland",
    "Doddsville",
    "Drew",
    "Parchman",
    "Duncan",
    "Glen Allan",
    "Grace",
    "Gunnison",
    "Hollandale",
    "Indianola",
    "Baird",
    "Inverness",
    "Isola",
    "Leland",
    "Elizabeth",
    "Merigold",
    "Metcalfe",
    "Moorhead",
    "Mound Bayou",
    "Pace",
    "Panther Burn",
    "Rena Lara",
    "Rome",
    "Rosedale",
    "Ruleville",
    "Scott",
    "Shaw",
    "Shelby",
    "Stoneville",
    "Sunflower",
    "Winstonville",
    "Tupelo",
    "Amory",
    "Hatley",
    "Baldwyn",
    "Belden",
    "Belmont",
    "Blue Springs",
    "Sherman",
    "Booneville",
    "Jumpertown",
    "Burnsville",
    "Corinth",
    "Farmington",
    "Kossuth",
    "Dennis",
    "Derma",
    "Ecru",
    "Fulton",
    "Gattman",
    "Glen",
    "Golden",
    "Greenwood Springs",
    "Greenwood Spg",
    "Greenwood Spr",
    "Guntown",
    "Houlka",
    "Houston",
    "Iuka",
    "Mantachie",
    "Marietta",
    "Mooreville",
    "Nettleton",
    "New Site",
    "Okolona",
    "Egypt",
    "Plantersville",
    "Pontotoc",
    "Randolph",
    "Sarepta",
    "Rienzi",
    "Saltillo",
    "Shannon",
    "Smithville",
    "Thaxton",
    "Tishomingo",
    "Paden",
    "Tremont",
    "Vardaman",
    "Verona",
    "Grenada",
    "Banner",
    "Big Creek",
    "Bruce",
    "Calhoun City",
    "Slate Spring",
    "Carrollton",
    "Cascilla",
    "Charleston",
    "Coffeeville",
    "Coila",
    "Cruger",
    "Duck Hill",
    "Enid",
    "Glendora",
    "Gore Springs",
    "Greenwood",
    "Avalon",
    "Holcomb",
    "Itta Bena",
    "McCarley",
    "Minter City",
    "Morgan City",
    "North Carrollton",
    "N Carrollton",
    "Oakland",
    "Paris",
    "Philipp",
    "Pittsboro",
    "Schlater",
    "Scobey",
    "Sidon",
    "Sumner",
    "Tillatoba",
    "Tippo",
    "Tutwiler",
    "Vance",
    "Water Valley",
    "Webb",
    "Winona",
    "Belzoni",
    "Benton",
    "Bentonia",
    "Bolton",
    "Brandon",
    "Braxton",
    "Camden",
    "Canton",
    "Carthage",
    "Cary",
    "Clinton",
    "Conehatta",
    "Crystal Springs",
    "Crystal Spgs",
    "Delta City",
    "D Lo",
    "Durant",
    "Edwards",
    "Ethel",
    "Fayette",
    "Flora",
    "Florence",
    "Forest",
    "Georgetown",
    "Goodman",
    "Harrisville",
    "Hazlehurst",
    "Hermanville",
    "Holly Bluff",
    "Kosciusko",
    "Lake",
    "Lena",
    "Lexington",
    "Lorman",
    "Louise",
    "McCool",
    "Madison",
    "Magee",
    "Sanatorium",
    "Mayersville",
    "Mendenhall",
    "Midnight",
    "Mize",
    "Morton",
    "Mount Olive",
    "Natchez",
    "Church Hill",
    "Newhebron",
    "Pattison",
    "Pelahatchie",
    "Pickens",
    "Piney Woods",
    "Pinola",
    "Port Gibson",
    "Pulaski",
    "Raleigh",
    "Sylvarena",
    "Raymond",
    "Learned",
    "Redwood",
    "Ridgeland",
    "Rolling Fork",
    "Fitler",
    "Sallis",
    "Satartia",
    "Silver City",
    "Star",
    "Taylorsville",
    "Tchula",
    "Thornton",
    "Terry",
    "Byram",
    "Tinsley",
    "Tougaloo",
    "Utica",
    "Vaiden",
    "Valley Park",
    "Vaughan",
    "Vicksburg",
    "Walnut Grove",
    "Wesson",
    "Beauregard",
    "West",
    "Whitfield",
    "Yazoo City",
    "Eden",
    "Jackson",
    "Pearl",
    "Richland",
    "Flowood",
    "Meridian",
    "Nas Meridian",
    "Naval Air Sta Meridian",
    "Bailey",
    "Buckatunna",
    "Chunky",
    "Clara",
    "Collinsville",
    "Daleville",
    "Decatur",
    "De Kalb",
    "Enterprise",
    "Hickory",
    "Lauderdale",
    "Lawrence",
    "Little Rock",
    "Louin",
    "Montrose",
    "Louisville",
    "Macon",
    "Prairie Point",
    "Marion",
    "Newton",
    "Noxapater",
    "Pachuta",
    "Paulding",
    "Philadelphia",
    "Choctaw",
    "Porterville",
    "Preston",
    "Quitman",
    "Rose Hill",
    "Scooba",
    "Sebastopol",
    "Shubuta",
    "Shuqualak",
    "State Line",
    "Stonewall",
    "Toomsuba",
    "Union",
    "Vossburg",
    "Waynesboro",
    "Hattiesburg",
    "Bassfield",
    "Bay Springs",
    "Beaumont",
    "Brooklyn",
    "Carriere",
    "Carson",
    "Collins",
    "Columbia",
    "Ellisville",
    "Heidelberg",
    "Laurel",
    "Leakesville",
    "Lucedale",
    "Agricola",
    "Lumberton",
    "McLain",
    "Benndale",
    "Leaf",
    "Moselle",
    "Neely",
    "New Augusta",
    "Ovett",
    "Petal",
    "Picayune",
    "Poplarville",
    "Prentiss",
    "Purvis",
    "Richton",
    "Sandersville",
    "Sandy Hook",
    "Seminary",
    "Soso",
    "Stringer",
    "Sumrall",
    "Foxworth",
    "Morgantown",
    "Gulfport",
    "Bay Saint Louis",
    "Bay St Louis",
    "Stennis Ctr",
    "Stennis Space Center",
    "Waveland",
    "Diamondhead",
    "Stennis Sp Ct",
    "Biloxi",
    "Keesler AFB",
    "Diberville",
    "Gautier",
    "Kiln",
    "Long Beach",
    "McHenry",
    "Moss Point",
    "Kreole",
    "Pascagoula",
    "Ocean Springs",
    "Vancleave",
    "Pass Christian",
    "Pass Chris",
    "Pass Christin",
    "Pearlington",
    "Perkinston",
    "Saucier",
    "Wiggins",
    "Brookhaven",
    "Bogue Chitto",
    "Bude",
    "Centreville",
    "Crosby",
    "Fernwood",
    "Gloster",
    "Jayess",
    "Kokomo",
    "Liberty",
    "McCall Creek",
    "Mccomb",
    "Magnolia",
    "Meadville",
    "Monticello",
    "Oak Vale",
    "Osyka",
    "Roxie",
    "Ruth",
    "Silver Creek",
    "Smithdale",
    "Sontag",
    "Summit",
    "Tylertown",
    "Union Church",
    "Woodville",
    "Columbus",
    "Columbus AFB",
    "Aberdeen",
    "Ackerman",
    "Reform",
    "Artesia",
    "Bellefontaine",
    "Brooksville",
    "Bigbee Valley",
    "Caledonia",
    "Cedarbluff",
    "Crawford",
    "Eupora",
    "Tomnolen",
    "French Camp",
    "Hamilton",
    "Kilmichael",
    "Maben",
    "Mantee",
    "Mathiston",
    "Mayhew",
    "Pheba",
    "Prairie",
    "Starkville",
    "Mississippi State",
    "Ms State",
    "Steens",
    "Stewart",
    "Sturgis",
    "Walthall",
    "Weir",
    "West Point",
    "Woodland",
  ],
  MT: [
    "Absarokee",
    "Acton",
    "Molt",
    "Ashland",
    "Ballantine",
    "Bearcreek",
    "Washoe",
    "Belfry",
    "Bighorn",
    "Big Timber",
    "Birney",
    "Boyd",
    "Bridger",
    "Broadview",
    "Busby",
    "Clyde Park",
    "Columbus",
    "Cooke City",
    "Crow Agency",
    "Custer",
    "Decker",
    "Edgar",
    "Emigrant",
    "Fishtail",
    "Fromberg",
    "Gardiner",
    "Garryowen",
    "Grass Range",
    "Greycliff",
    "Hardin",
    "Fort Smith",
    "Yellowtail",
    "Harlowton",
    "Huntley",
    "Hysham",
    "Sanders",
    "Ingomar",
    "Joliet",
    "Silesia",
    "Lame Deer",
    "Laurel",
    "Lavina",
    "Livingston",
    "Lodge Grass",
    "McLeod",
    "Martinsdale",
    "Melstone",
    "Melville",
    "Mosby",
    "Musselshell",
    "Nye",
    "Otter",
    "Park City",
    "Pompeys Pillar",
    "Pompey Pillar",
    "Pray",
    "Pryor",
    "Rapelje",
    "Red Lodge",
    "Luther",
    "Reed Point",
    "Roberts",
    "Fox",
    "Roscoe",
    "Roundup",
    "Ryegate",
    "Saint Xavier",
    "Sand Springs",
    "Shawmut",
    "Shepherd",
    "Silver Gate",
    "Springdale",
    "Sumatra",
    "Two Dot",
    "Wilsall",
    "Winnett",
    "Cat Creek",
    "Worden",
    "Wyola",
    "Billings",
    "Wolf Point",
    "Oswego",
    "Antelope",
    "Bainville",
    "Brockton",
    "Brockway",
    "Circle",
    "Crane",
    "Culbertson",
    "Mccabe",
    "Dagmar",
    "Fairview",
    "Flaxville",
    "Fort Peck",
    "Frazer",
    "Lustre",
    "Froid",
    "Glasgow",
    "Saint Marie",
    "Glentana",
    "Hinsdale",
    "Homestead",
    "Lambert",
    "Larslan",
    "Medicine Lake",
    "Nashua",
    "Opheim",
    "Outlook",
    "Peerless",
    "Plentywood",
    "Poplar",
    "Raymond",
    "Redstone",
    "Reserve",
    "Richey",
    "Richland",
    "Saco",
    "Savage",
    "Scobey",
    "Four Buttes",
    "Sidney",
    "Vandalia",
    "Vida",
    "Westby",
    "Whitetail",
    "Miles City",
    "Alzada",
    "Angela",
    "Baker",
    "Biddle",
    "Bloomfield",
    "Boyes",
    "Broadus",
    "Brusett",
    "Capitol",
    "Cohagen",
    "Colstrip",
    "Ekalaka",
    "Mill Iron",
    "Fallon",
    "Forsyth",
    "Glendive",
    "Hammond",
    "Hathaway",
    "Ismay",
    "Jordan",
    "Kinsey",
    "Lindsay",
    "Olive",
    "Plevna",
    "Powderville",
    "Rosebud",
    "Terry",
    "Volborg",
    "Wibaux",
    "Willard",
    "Great Falls",
    "Augusta",
    "Babb",
    "Belt",
    "Black Eagle",
    "Brady",
    "Browning",
    "Saint Mary",
    "Buffalo",
    "Bynum",
    "Carter",
    "Cascade",
    "Choteau",
    "Coffee Creek",
    "Conrad",
    "Cut Bank",
    "Santa Rita",
    "Denton",
    "Dupuyer",
    "Dutton",
    "East Glacier Park",
    "E Glacier Par",
    "E Glacier Park",
    "E Glacier Pk",
    "Ethridge",
    "Fairfield",
    "Floweree",
    "Forest Grove",
    "Fort Benton",
    "Fort Shaw",
    "Galata",
    "Geraldine",
    "Square Butte",
    "Geyser",
    "Heart Butte",
    "Highwood",
    "Shonkin",
    "Hilger",
    "Hobson",
    "Judith Gap",
    "Garneill",
    "Kevin",
    "Ledger",
    "Lewistown",
    "Loma",
    "Lothair",
    "Moccasin",
    "Monarch",
    "Moore",
    "Neihart",
    "Oilmont",
    "Ferdig",
    "Pendroy",
    "Power",
    "Raynesford",
    "Roy",
    "Sand Coulee",
    "Tracy",
    "Shelby",
    "Simms",
    "Stanford",
    "Stockett",
    "Sunburst",
    "Sun River",
    "Sweet Grass",
    "Ulm",
    "Valier",
    "Vaughn",
    "Winifred",
    "Havre",
    "Big Sandy",
    "Box Elder",
    "Chester",
    "Chinook",
    "Dodson",
    "Gildford",
    "Harlem",
    "Hays",
    "Hingham",
    "Hogeland",
    "Inverness",
    "Joplin",
    "Kremlin",
    "Lloyd",
    "Loring",
    "Malta",
    "Rudyard",
    "Turner",
    "Whitewater",
    "Whitlash",
    "Zortman",
    "Zurich",
    "Helena",
    "Basin",
    "Boulder",
    "Canyon Creek",
    "Clancy",
    "Montana City",
    "East Helena",
    "Fort Harrison",
    "Jefferson City",
    "Jefferson Cty",
    "Lincoln",
    "Marysville",
    "Ringling",
    "Toston",
    "Townsend",
    "White Sulphur Springs",
    "Wht Sphr Spgs",
    "Winston",
    "Wolf Creek",
    "Craig",
    "Butte",
    "Walkerville",
    "Alder",
    "Anaconda",
    "Avon",
    "Belgrade",
    "Bozeman",
    "Big Sky",
    "Cameron",
    "Cardwell",
    "Deer Lodge",
    "Dell",
    "Dillon",
    "Divide",
    "Elliston",
    "Ennis",
    "Gallatin Gateway",
    "Gallatin Gtwy",
    "Garrison",
    "Glen",
    "Gold Creek",
    "Harrison",
    "Jackson",
    "Lima",
    "McAllister",
    "Manhattan",
    "Melrose",
    "Norris",
    "Polaris",
    "Pony",
    "Ramsay",
    "Sheridan",
    "Silver Star",
    "Three Forks",
    "Twin Bridges",
    "Virginia City",
    "Warm Springs",
    "West Yellowstone",
    "W Yellowstone",
    "Whitehall",
    "Willow Creek",
    "Wisdom",
    "Wise River",
    "Missoula",
    "Alberton",
    "Arlee",
    "Bonner",
    "Greenough",
    "Potomac",
    "Charlo",
    "Moiese",
    "Clinton",
    "Condon",
    "Conner",
    "Corvallis",
    "Darby",
    "De Borgia",
    "Dixon",
    "Drummond",
    "Florence",
    "Frenchtown",
    "Hall",
    "Hamilton",
    "Pinesdale",
    "Haugan",
    "Helmville",
    "Heron",
    "Hot Springs",
    "Niarada",
    "Huson",
    "Lolo",
    "Lonepine",
    "Milltown",
    "Noxon",
    "Ovando",
    "Pablo",
    "Paradise",
    "Philipsburg",
    "Plains",
    "Polson",
    "Ravalli",
    "Ronan",
    "Saint Ignatius",
    "St Ignatius",
    "Saint Regis",
    "Saltese",
    "Seeley Lake",
    "Stevensville",
    "Sula",
    "Superior",
    "Thompson Falls",
    "Thompson Fls",
    "Trout Creek",
    "Victor",
    "Kalispell",
    "Creston",
    "Evergreen",
    "Big Arm",
    "Bigfork",
    "Swan Lake",
    "Columbia Falls",
    "Columbia Fls",
    "Coram",
    "Dayton",
    "Elmo",
    "Essex",
    "Eureka",
    "Fortine",
    "Hungry Horse",
    "Kila",
    "Lakeside",
    "Libby",
    "Marion",
    "Martin City",
    "Olney",
    "Polebridge",
    "Proctor",
    "Rexford",
    "Rollins",
    "Somers",
    "Stryker",
    "Trego",
    "Troy",
    "West Glacier",
    "Whitefish",
  ],
  NC: [
    "Advance",
    "Bermuda Run",
    "Ararat",
    "Belews Creek",
    "Boonville",
    "Clemmons",
    "Cleveland",
    "Barber",
    "Cooleemee",
    "Danbury",
    "Dobson",
    "East Bend",
    "Germanton",
    "Hamptonville",
    "King",
    "Lawsonville",
    "Lewisville",
    "Lowgap",
    "Madison",
    "Mayodan",
    "Mocksville",
    "Mount Airy",
    "Pfafftown",
    "Pilot Mountain",
    "Pilot Mtn",
    "Pine Hall",
    "Pinnacle",
    "Rural Hall",
    "Sandy Ridge",
    "Siloam",
    "Stoneville",
    "Tobaccoville",
    "Walkertown",
    "Walnut Cove",
    "Westfield",
    "Woodleaf",
    "Yadkinville",
    "Winston Salem",
    "Alamance",
    "Altamahaw",
    "Asheboro",
    "Bear Creek",
    "Bennett",
    "Biscoe",
    "Blanch",
    "Bonlee",
    "Browns Summit",
    "Burlington",
    "Glen Raven",
    "Green Level",
    "Candor",
    "Cedar Grove",
    "Climax",
    "Colfax",
    "Denton",
    "Eagle Springs",
    "Efland",
    "Elon",
    "Elon College",
    "Ether",
    "Franklinville",
    "Gibsonville",
    "Goldston",
    "Graham",
    "Gulf",
    "Haw River",
    "Highfalls",
    "High Point",
    "Archdale",
    "Hillsborough",
    "Jackson Springs",
    "Foxfire Village",
    "Foxfire Vlg",
    "Jackson Spgs",
    "Jamestown",
    "Julian",
    "Kernersville",
    "Eden",
    "Leasburg",
    "Lexington",
    "Liberty",
    "Linwood",
    "McLeansville",
    "Mebane",
    "Milton",
    "Mount Gilead",
    "Oak Ridge",
    "Pelham",
    "Pittsboro",
    "Fearrington",
    "Fearrington Village",
    "Pleasant Garden",
    "Pleasant Gdn",
    "Prospect Hill",
    "Providence",
    "Ramseur",
    "Coleridge",
    "Randleman",
    "Reidsville",
    "Robbins",
    "Glendon",
    "Ruffin",
    "Sanford",
    "Buffalo Lake",
    "Colon",
    "Saxapahaw",
    "Seagrove",
    "Sedalia",
    "Semora",
    "Siler City",
    "Snow Camp",
    "Sophia",
    "Southmont",
    "Staley",
    "Star",
    "Stokesdale",
    "Summerfield",
    "Thomasville",
    "Trinity",
    "Troy",
    "Welcome",
    "West End",
    "Seven Lakes",
    "Whitsett",
    "Yanceyville",
    "Greensboro",
    "Angier",
    "Apex",
    "Bahama",
    "Benson",
    "Broadway",
    "Buies Creek",
    "Bullock",
    "Bunn",
    "Butner",
    "Carrboro",
    "Cary",
    "Chapel Hill",
    "Clayton",
    "Coats",
    "Creedmoor",
    "Four Oaks",
    "Franklinton",
    "Fuquay Varina",
    "Archer Lodge",
    "Garner",
    "Goldsboro",
    "Seymour Johnson A F B",
    "Seymour Johnson AFB",
    "Sjafb",
    "Henderson",
    "Holly Springs",
    "Hurdle Mills",
    "Kenly",
    "Kittrell",
    "Knightdale",
    "Lillington",
    "Louisburg",
    "Centerville",
    "Macon",
    "Manson",
    "Micro",
    "Middleburg",
    "Middlesex",
    "Moncure",
    "Morrisville",
    "New Hill",
    "Norlina",
    "Oxford",
    "Pine Level",
    "Princeton",
    "Ridgeway",
    "Rolesville",
    "Rougemont",
    "Roxboro",
    "Selma",
    "Smithfield",
    "Stem",
    "Stovall",
    "Timberlake",
    "Townsville",
    "Wake Forest",
    "Warrenton",
    "Wendell",
    "Eagle Rock",
    "Willow Spring",
    "Wilsons Mills",
    "Wise",
    "Youngsville",
    "Zebulon",
    "Raleigh",
    "Brentwood",
    "Durham",
    "Shannon Plaza",
    "Research Triangle Park",
    "Rtp",
    "Eno Valley",
    "Rocky Mount",
    "Wesleyan Col",
    "Wesleyan College",
    "Aulander",
    "Aurora",
    "Bailey",
    "Bath",
    "Battleboro",
    "Belhaven",
    "Bethel",
    "Black Creek",
    "Blounts Creek",
    "Castalia",
    "Chocowinity",
    "Como",
    "Conetoe",
    "Conway",
    "Milwaukee",
    "Edward",
    "Elm City",
    "Enfield",
    "Engelhard",
    "Everetts",
    "Fairfield",
    "Falkland",
    "Farmville",
    "Fountain",
    "Fremont",
    "Eureka",
    "Garysburg",
    "Gumberry",
    "Gaston",
    "Greenville",
    "Grimesland",
    "Halifax",
    "Hamilton",
    "Hassell",
    "Henrico",
    "Hobgood",
    "Hollister",
    "Jackson",
    "Lasker",
    "Jamesville",
    "Kelford",
    "Lewiston Woodville",
    "Lewiston",
    "Littleton",
    "Lucama",
    "Macclesfield",
    "Margarettsville",
    "Margarettsvl",
    "Murfreesboro",
    "Nashville",
    "Momeyer",
    "Oak City",
    "Pantego",
    "Parmele",
    "Pendleton",
    "Pikeville",
    "Pinetops",
    "Pinetown",
    "Pleasant Hill",
    "Rich Square",
    "Roanoke Rapids",
    "Roanoke Rapid",
    "Roanoke Rapids Air Force Sta",
    "Ronok Rpd Afs",
    "Robersonville",
    "Roxobel",
    "Saratoga",
    "Scotland Neck",
    "Scranton",
    "Seaboard",
    "Severn",
    "Sharpsburg",
    "Simpson",
    "Sims",
    "Speed",
    "Spring Hope",
    "Stantonsburg",
    "Stokes",
    "Swanquarter",
    "Tarboro",
    "Leggett",
    "Princeville",
    "Walstonburg",
    "Washington",
    "Weldon",
    "Whitakers",
    "Williamston",
    "Bear Grass",
    "Beargrass",
    "Wilson",
    "Woodland",
    "George",
    "Elizabeth City",
    "Elizabeth Cty",
    "Ahoskie",
    "Avon",
    "Aydlett",
    "Barco",
    "Belvidere",
    "Buxton",
    "Camden",
    "Cofield",
    "Coinjock",
    "Colerain",
    "Columbia",
    "Corapeake",
    "Corolla",
    "Creswell",
    "Currituck",
    "Edenton",
    "Eure",
    "Frisco",
    "Gates",
    "Gatesville",
    "Grandy",
    "Harbinger",
    "Harrellsville",
    "Hatteras",
    "Hertford",
    "Hobbsville",
    "Jarvisburg",
    "Kill Devil Hills",
    "Kill Devil Hl",
    "Kitty Hawk",
    "Duck",
    "Southern Shores",
    "Southrn Shore",
    "Knotts Island",
    "Manns Harbor",
    "East Lake",
    "Manteo",
    "Maple",
    "Merry Hill",
    "Moyock",
    "Nags Head",
    "Ocracoke",
    "Plymouth",
    "Point Harbor",
    "Poplar Branch",
    "Powells Point",
    "Powellsville",
    "Rodanthe",
    "Roduco",
    "Roper",
    "Salvo",
    "Shawboro",
    "Shiloh",
    "South Mills",
    "Stumpy Point",
    "Sunbury",
    "Tyner",
    "Wanchese",
    "Waves",
    "Windsor",
    "Askewville",
    "Winfall",
    "Winton",
    "Albemarle",
    "Alexis",
    "Ansonville",
    "Badin",
    "Belmont",
    "Bessemer City",
    "Boiling Springs",
    "Boiling Spgs",
    "Bostic",
    "Golden Valley",
    "Caroleen",
    "Casar",
    "Cherryville",
    "China Grove",
    "Kannapolis",
    "Cliffside",
    "Concord",
    "Cornelius",
    "Cramerton",
    "Crouse",
    "Dallas",
    "Davidson",
    "Denver",
    "East Spencer",
    "Ellenboro",
    "Faith",
    "Fallston",
    "Forest City",
    "Alexander Mills",
    "Alexander Mls",
    "Gastonia",
    "Gold Hill",
    "Granite Quarry",
    "Granite Qry",
    "Grover",
    "Harris",
    "Harrisburg",
    "Henrietta",
    "High Shoals",
    "Huntersville",
    "Indian Trail",
    "Lake Park",
    "Iron Station",
    "Kings Mountain",
    "Kings Mtn",
    "Landis",
    "Lattimore",
    "Lawndale",
    "Lilesville",
    "Lincolnton",
    "Boger City",
    "Locust",
    "Lowell",
    "McAdenville",
    "McFarlan",
    "Marshville",
    "Matthews",
    "Stallings",
    "Weddington",
    "Wesley Chapel",
    "Midland",
    "Mineral Springs",
    "Mineral Spgs",
    "Misenheimer",
    "Monroe",
    "Unionville",
    "Mooresboro",
    "Mooresville",
    "Morven",
    "Mount Holly",
    "Mt Holly",
    "Mount Pleasant",
    "Mt Pleasant",
    "Mount Ulla",
    "New London",
    "Badin Lake",
    "Norwood",
    "Oakboro",
    "Red Cross",
    "Peachland",
    "Pineville",
    "Polkton",
    "Polkville",
    "Shelby",
    "Richfield",
    "Rockwell",
    "Rutherfordton",
    "Salisbury",
    "Kingstown",
    "Spencer",
    "Spindale",
    "Stanfield",
    "Stanley",
    "Troutman",
    "Union Mills",
    "Vale",
    "Waco",
    "Wadesboro",
    "Waxhaw",
    "Marvin",
    "Wingate",
    "Charlotte",
    "Mint Hill",
    "Fayetteville",
    "E Fayetteville",
    "E Fayettevlle",
    "East Fayetteville",
    "Fort Liberty",
    "Pope Army Airfield",
    "Pope Army Af",
    "Eastover",
    "Aberdeen",
    "Autryville",
    "Bladenboro",
    "Butters",
    "Bunnlevel",
    "Calypso",
    "Cameron",
    "Carthage",
    "Whisper Pnes",
    "Whispering Pines",
    "Clinton",
    "Cordova",
    "Cumberland",
    "Dublin",
    "Dudley",
    "Dunn",
    "Elizabethtown",
    "Ellerbe",
    "Erwin",
    "Fairmont",
    "Faison",
    "Falcon",
    "Gibson",
    "Godwin",
    "Hamlet",
    "Hoffman",
    "Hope Mills",
    "Kenansville",
    "Lakeview",
    "Laurel Hill",
    "Laurinburg",
    "Lemon Springs",
    "Linden",
    "Lumber Bridge",
    "Lumberton",
    "Marietta",
    "Marston",
    "Maxton",
    "Mount Olive",
    "Newton Grove",
    "Norman",
    "Olivia",
    "Orrum",
    "Parkton",
    "Pembroke",
    "Pinebluff",
    "Pinehurst",
    "Proctorville",
    "Raeford",
    "Red Springs",
    "Rex",
    "Rockingham",
    "Roseboro",
    "Rowland",
    "Raynham",
    "Saint Pauls",
    "Salemburg",
    "Shannon",
    "Rennert",
    "Southern Pines",
    "Southern Pnes",
    "Spring Lake",
    "Stedman",
    "Tar Heel",
    "Turkey",
    "Vass",
    "Wade",
    "Wagram",
    "Warsaw",
    "Bowdens",
    "White Oak",
    "Wilmington",
    "Cape Fear",
    "Ash",
    "Atkinson",
    "Bolivia",
    "Bolton",
    "Brunswick",
    "Burgaw",
    "Saint Helena",
    "Carolina Beach",
    "Carolina Bch",
    "Castle Hayne",
    "Cerro Gordo",
    "Chadbourn",
    "Clarendon",
    "Clarkton",
    "Council",
    "Currie",
    "Delco",
    "Evergreen",
    "Boardman",
    "Fair Bluff",
    "Garland",
    "Ingold",
    "Hallsboro",
    "Hampstead",
    "Harrells",
    "Holly Ridge",
    "Surf City",
    "Topsail Beach",
    "Ivanhoe",
    "Kelly",
    "Kure Beach",
    "Lake Waccamaw",
    "Leland",
    "Belville",
    "Navassa",
    "Northwest",
    "Longwood",
    "Magnolia",
    "Maple Hill",
    "Nakina",
    "Riegelwood",
    "East Arcadia",
    "Sandyfield",
    "Rocky Point",
    "Rose Hill",
    "Greenevers",
    "Sneads Ferry",
    "N Topsail Bch",
    "N Topsail Beach",
    "Southport",
    "Bald Head Isl",
    "Bald Head Island",
    "Blng Spg Lks",
    "Boiling Spring Lakes",
    "Oak Island",
    "Saint James",
    "Supply",
    "Holden Beach",
    "Tabor City",
    "Teachey",
    "Caswell Beach",
    "Wallace",
    "Calabash",
    "Carolina Shor",
    "Carolina Shores",
    "Ocean Isl Bch",
    "Ocean Isle Beach",
    "Sunset Beach",
    "Shallotte",
    "S Brunswick",
    "South Brunswick",
    "Whiteville",
    "Willard",
    "Watha",
    "Winnabow",
    "Wrightsville Beach",
    "Writsvlle Bch",
    "Kinston",
    "Albertson",
    "Alliance",
    "Arapahoe",
    "Minnesott Bch",
    "Minnesott Beach",
    "Atlantic",
    "Atlantic Beach",
    "Atlantic Bch",
    "Indian Beach",
    "Pine Knoll Shores",
    "Pks",
    "Salter Path",
    "Ayden",
    "Bayboro",
    "Mesic",
    "Beaufort",
    "Beulaville",
    "Bridgeton",
    "Cedar Island",
    "Chinquapin",
    "Cove City",
    "Davis",
    "Deep Run",
    "Dover",
    "Ernul",
    "Gloucester",
    "Grantsboro",
    "Grifton",
    "Harkers Island",
    "Harkers Is",
    "Havelock",
    "Cherry Point",
    "Hobucken",
    "Hookerton",
    "Hubert",
    "Jacksonville",
    "Camp Lejeune",
    "Tarawa Terrace",
    "Tarawa Ter",
    "Midway Park",
    "La Grange",
    "Lowland",
    "Marshallberg",
    "Maury",
    "Maysville",
    "Merritt",
    "Morehead City",
    "New Bern",
    "Trent Woods",
    "Newport",
    "Bogue",
    "Oriental",
    "Pink Hill",
    "Pollocksville",
    "Richlands",
    "Sealevel",
    "Seven Springs",
    "Smyrna",
    "Williston",
    "Snow Hill",
    "Stacy",
    "Stella",
    "Swansboro",
    "Cape Carteret",
    "Cedar Point",
    "Peletier",
    "Trenton",
    "Vanceboro",
    "Vandemere",
    "Winterville",
    "Emerald Isle",
    "Hickory",
    "Banner Elk",
    "Beech Mountain",
    "Beech Mtn",
    "Seven Devils",
    "Sugar Mountain",
    "Sugar Mtn",
    "Blowing Rock",
    "Boomer",
    "Boone",
    "Catawba",
    "Longisland",
    "Claremont",
    "Collettsville",
    "Connelly Springs",
    "Connelly Spg",
    "Conover",
    "Creston",
    "Crossnore",
    "Crumpler",
    "Deep Gap",
    "Triplett",
    "Drexel",
    "Elkin",
    "Elk Park",
    "Ennice",
    "Ferguson",
    "Statesville",
    "Fleetwood",
    "Glade Valley",
    "Glen Alpine",
    "Glendale Springs",
    "Glendale Spgs",
    "Granite Falls",
    "Sawmills",
    "Grassy Creek",
    "Harmony",
    "Hays",
    "Hiddenite",
    "Hildebran",
    "Hudson",
    "Jefferson",
    "Jonas Ridge",
    "Jonesville",
    "Lansing",
    "Husk",
    "Laurel Springs",
    "Laurel Spgs",
    "Lenoir",
    "Cajahs Mountain",
    "Cajahs Mtn",
    "Cedar Rock",
    "Linville",
    "McGrady",
    "Maiden",
    "Millers Creek",
    "Wilbar",
    "Minneapolis",
    "Montezuma",
    "Moravian Falls",
    "Moravian Fls",
    "Morganton",
    "Newland",
    "Newton",
    "North Wilkesboro",
    "N Wilkesboro",
    "Olin",
    "Pineola",
    "Piney Creek",
    "Plumtree",
    "Purlear",
    "Icard",
    "Rhodhiss",
    "Roaring Gap",
    "Roaring River",
    "Ronda",
    "Rutherford College",
    "Rutherfrd Clg",
    "Rutherfrd Col",
    "Scottville",
    "Sherrills Ford",
    "Sherrills Frd",
    "Sparta",
    "Whitehead",
    "State Road",
    "Stony Point",
    "Sugar Grove",
    "Taylorsville",
    "Terrell",
    "Thurmond",
    "Todd",
    "Traphill",
    "Union Grove",
    "Valdese",
    "Vilas",
    "Warrensville",
    "West Jefferson",
    "W Jefferson",
    "Wilkesboro",
    "Zionville",
    "Alexander",
    "Almond",
    "Arden",
    "Bakersville",
    "Balsam",
    "Balsam Grove",
    "Barnardsville",
    "Bat Cave",
    "Black Mountain",
    "Black Mtn",
    "Brevard",
    "Bryson City",
    "Burnsville",
    "Candler",
    "Biltmore Lake",
    "Canton",
    "Cashiers",
    "Cedar Mountain",
    "Cedar Mtn",
    "Cherokee",
    "Chimney Rock",
    "Clyde",
    "Columbus",
    "Cullowhee",
    "Dillsboro",
    "East Flat Rock",
    "E Flat Rock",
    "Etowah",
    "Fairview",
    "Flat Rock",
    "Fletcher",
    "Mills River",
    "Fontana Dam",
    "Franklin",
    "Gerton",
    "Glenville",
    "Hendersonville",
    "Hendersonvlle",
    "Laurel Park",
    "Green Mountain",
    "Green Mtn",
    "Highlands",
    "Horse Shoe",
    "Hot Springs",
    "Lake Junaluska",
    "Lk Junaluska",
    "Lake Lure",
    "Lake Toxaway",
    "Leicester",
    "Little Switzerland",
    "Ltl Switzrlnd",
    "Maggie Valley",
    "Marion",
    "Marshall",
    "Mars Hill",
    "Micaville",
    "Mill Spring",
    "Montreat",
    "Mountain Home",
    "Nebo",
    "Old Fort",
    "Otto",
    "Penrose",
    "Pisgah Forest",
    "Ridgecrest",
    "Robbinsville",
    "Lake Santeetlah",
    "Lk Santeetlah",
    "Tapoco",
    "Rosman",
    "Saluda",
    "Sapphire",
    "Scaly Mountain",
    "Scaly Mtn",
    "Spruce Pine",
    "Swannanoa",
    "Sylva",
    "Topton",
    "Aquone",
    "Tryon",
    "Tuckasegee",
    "Waynesville",
    "Hazelwood",
    "Weaverville",
    "Webster",
    "Whittier",
    "Zirconia",
    "Asheville",
    "Biltmore Forest",
    "Biltmore Frst",
    "Woodfin",
    "Andrews",
    "Brasstown",
    "Hayesville",
    "Marble",
    "Murphy",
    "Warne",
  ],
  ND: [
    "Abercrombie",
    "Absaraka",
    "Amenia",
    "Argusville",
    "Arthur",
    "Ayr",
    "Barney",
    "Blanchard",
    "Buffalo",
    "Casselton",
    "Cayuga",
    "Christine",
    "Clifford",
    "Cogswell",
    "Brampton",
    "Straubville",
    "Colfax",
    "Davenport",
    "Enderlin",
    "Erie",
    "Fairmount",
    "Fingal",
    "Alice",
    "Forman",
    "Fort Ransom",
    "Englevale",
    "Galesburg",
    "Gardner",
    "Harwood",
    "Grandin",
    "Gwinner",
    "Crete",
    "Hankinson",
    "Prosper",
    "Havana",
    "Hillsboro",
    "Kelso",
    "Hope",
    "Colgate",
    "Horace",
    "Hickson",
    "Oxbow",
    "Wild Rice",
    "Hunter",
    "Kathryn",
    "Hastings",
    "Kindred",
    "Leonard",
    "Lidgerwood",
    "Geneseo",
    "Lisbon",
    "Elliott",
    "Luverne",
    "Mcleod",
    "Mantador",
    "Mapleton",
    "Durbin",
    "Milnor",
    "Delamere",
    "Mooreton",
    "Nome",
    "Oriska",
    "Page",
    "Pillsbury",
    "Rutland",
    "Sheldon",
    "Stirum",
    "Tower City",
    "Valley City",
    "Wahpeton",
    "Dwight",
    "Galchutt",
    "Great Bend",
    "Walcott",
    "West Fargo",
    "Riverside",
    "Wheatland",
    "Chaffee",
    "Embden",
    "Wyndmere",
    "Fargo",
    "North River",
    "Reiles Acres",
    "Briarwood",
    "Frontier",
    "Prairie Rose",
    "Grand Forks",
    "Grand Forks Afb",
    "Gfafb",
    "Adams",
    "Aneta",
    "Arvilla",
    "Bathgate",
    "Buxton",
    "Caledonia",
    "Cavalier",
    "Backoo",
    "Cavalier Afs",
    "Concrete",
    "Crystal",
    "Cummings",
    "Dahlen",
    "Drayton",
    "Bowesmont",
    "Edinburg",
    "Gardar",
    "Emerado",
    "Fairdale",
    "Finley",
    "Fordville",
    "Forest River",
    "Inkster",
    "Gilby",
    "Honeyford",
    "Johnstown",
    "Glasston",
    "Grafton",
    "Nash",
    "Hamilton",
    "Hannah",
    "Hatton",
    "Hensel",
    "Hoople",
    "Orr",
    "Langdon",
    "Lankin",
    "Larimore",
    "Mccanna",
    "Mcville",
    "Kloten",
    "Maida",
    "Manvel",
    "Mayville",
    "Mekinock",
    "Michigan",
    "Whitman",
    "Milton",
    "Union",
    "Minto",
    "Ardoch",
    "Voss",
    "Mountain",
    "Neche",
    "Niagara",
    "Northwood",
    "Kempton",
    "Osnabrock",
    "Park River",
    "Pembina",
    "Joliette",
    "Petersburg",
    "Pisek",
    "Portland",
    "Reynolds",
    "Saint Thomas",
    "Sharon",
    "Thompson",
    "Wales",
    "Walhalla",
    "Leroy",
    "Devils Lake",
    "Agate",
    "Alsen",
    "Loma",
    "Balta",
    "Belcourt",
    "Bisbee",
    "Bottineau",
    "Brocket",
    "Calvin",
    "Cando",
    "Maza",
    "Churchs Ferry",
    "Crary",
    "Doyon",
    "Southam",
    "Dunseith",
    "San Haven",
    "Edmore",
    "Egeland",
    "Esmond",
    "Fillmore",
    "Fort Totten",
    "Hampden",
    "Hansboro",
    "Harvey",
    "Hamberg",
    "Heimdal",
    "Manfred",
    "Selz",
    "Knox",
    "Lakota",
    "Mapes",
    "Lawton",
    "Leeds",
    "Harlow",
    "Maddock",
    "Flora",
    "Minnewaukan",
    "Brinsmade",
    "Munich",
    "Calio",
    "Clyde",
    "Mylo",
    "Nekoma",
    "New Rockford",
    "Brantford",
    "Bremen",
    "Oberon",
    "Pekin",
    "Penn",
    "Perth",
    "Rocklake",
    "Rolette",
    "Nanson",
    "Rolla",
    "Rugby",
    "Orrin",
    "Pleasant Lake",
    "Silva",
    "Saint John",
    "Saint Michael",
    "Sarles",
    "Sheyenne",
    "Starkweather",
    "Tokio",
    "Tolna",
    "Hamar",
    "Warwick",
    "Webster",
    "Willow City",
    "Barton",
    "Overly",
    "Wolford",
    "York",
    "Baker",
    "Jamestown",
    "Eldridge",
    "Sydney",
    "Ashley",
    "Venturia",
    "Berlin",
    "Lamoure",
    "Binford",
    "Bowdon",
    "Heaton",
    "Buchanan",
    "Carrington",
    "Bordulac",
    "Melville",
    "Cathay",
    "Emrick",
    "Chaseley",
    "Cleveland",
    "Windsor",
    "Cooperstown",
    "Courtenay",
    "Dawson",
    "Dazey",
    "Sibley",
    "Denhoff",
    "Dickey",
    "Edgeley",
    "Merricourt",
    "Ellendale",
    "Monango",
    "Fessenden",
    "Forbes",
    "Fredonia",
    "Fullerton",
    "Gackle",
    "Glenfield",
    "Juanita",
    "Goodrich",
    "Grace City",
    "Hannaford",
    "Walum",
    "Hurdsfield",
    "Jessie",
    "Jud",
    "Alfred",
    "Nortonville",
    "Kensal",
    "Kulm",
    "Grand Rapids",
    "Lehr",
    "Litchville",
    "Mcclusky",
    "Mchenry",
    "Marion",
    "Medina",
    "Crystal Spgs",
    "Crystal Springs",
    "Montpelier",
    "Adrian",
    "Millarton",
    "Oakes",
    "Guelph",
    "Ludden",
    "Pettibone",
    "Pingree",
    "Edmunds",
    "Regan",
    "Robinson",
    "Lake Williams",
    "Rogers",
    "Leal",
    "Sanborn",
    "Spiritwood",
    "Eckelson",
    "Steele",
    "Streeter",
    "Sutton",
    "Sykeston",
    "Tappen",
    "Tuttle",
    "Verona",
    "Wimbledon",
    "Wing",
    "Arena",
    "Wishek",
    "Burnstad",
    "Woodworth",
    "Ypsilanti",
    "Bismarck",
    "Lincoln",
    "Almont",
    "Baldwin",
    "Beulah",
    "Braddock",
    "Cannon Ball",
    "Carson",
    "Leith",
    "Center",
    "Fort Clark",
    "Hensler",
    "Coleharbor",
    "Driscoll",
    "Elgin",
    "Heil",
    "Flasher",
    "Lark",
    "Fort Yates",
    "Garrison",
    "Emmet",
    "White Shield",
    "Golden Valley",
    "Hague",
    "Westfield",
    "Hazelton",
    "Hazen",
    "Pick City",
    "Kintyre",
    "Linton",
    "Temvik",
    "Mandan",
    "Fort Rice",
    "Huff",
    "Saint Anthony",
    "Menoken",
    "Mercer",
    "Moffit",
    "Napoleon",
    "New Leipzig",
    "Bentley",
    "New Salem",
    "Hannover",
    "Judson",
    "Raleigh",
    "Riverdale",
    "Selfridge",
    "Shields",
    "Solen",
    "Breien",
    "Stanton",
    "Sterling",
    "Mckenzie",
    "Strasburg",
    "Turtle Lake",
    "Underwood",
    "Washburn",
    "Wilton",
    "Zap",
    "Zeeland",
    "Dickinson",
    "New Hradec",
    "Amidon",
    "Beach",
    "Trotters",
    "Belfield",
    "Fryburg",
    "Bowman",
    "Buffalo Spg",
    "Buffalo Springs",
    "Dodge",
    "Dunn Center",
    "Fairfield",
    "Gorham",
    "Gladstone",
    "Glen Ullin",
    "Golva",
    "Grassy Butte",
    "Halliday",
    "Werner",
    "Hebron",
    "Hettinger",
    "Bucyrus",
    "Haynes",
    "Killdeer",
    "Lefor",
    "Manning",
    "Marmarth",
    "Marshall",
    "Medora",
    "Mott",
    "Burt",
    "New England",
    "Reeder",
    "Regent",
    "Rhame",
    "Richardton",
    "Scranton",
    "Gascoyne",
    "Sentinel Butte",
    "Sentinl Butte",
    "South Heart",
    "Taylor",
    "Minot",
    "Minot Afb",
    "Anamoose",
    "Antler",
    "Balfour",
    "Bantry",
    "Benedict",
    "Berthold",
    "Blaisdell",
    "Foxholm",
    "Tagus",
    "Bowbells",
    "Coteau",
    "Burlington",
    "Butte",
    "Kief",
    "Carpio",
    "Columbus",
    "Larson",
    "Crosby",
    "Deering",
    "Des Lacs",
    "Donnybrook",
    "Coulee",
    "Douglas",
    "Drake",
    "Flaxton",
    "Northgate",
    "Glenburn",
    "Wolseth",
    "Granville",
    "Karlsruhe",
    "Kenmare",
    "Norma",
    "Kramer",
    "Lansford",
    "Lignite",
    "Mcgregor",
    "Makoti",
    "Mandaree",
    "Martin",
    "Max",
    "Maxbass",
    "Mohall",
    "Loraine",
    "Newburg",
    "New Town",
    "Charlson",
    "Sanish",
    "Noonan",
    "Norwich",
    "Palermo",
    "Parshall",
    "Plaza",
    "Portal",
    "Powers Lake",
    "Battleview",
    "Roseglen",
    "Ross",
    "Ruso",
    "Ryder",
    "Raub",
    "Sawyer",
    "Sherwood",
    "Souris",
    "Carbury",
    "Landa",
    "Roth",
    "Stanley",
    "Belden",
    "Lostwood",
    "Surrey",
    "Tolley",
    "Towner",
    "Berwick",
    "Denbigh",
    "Upham",
    "Velva",
    "Voltaire",
    "Bergen",
    "Westhope",
    "White Earth",
    "Wildrose",
    "Hamlet",
    "Williston",
    "Bonetraill",
    "Buford",
    "Alamo",
    "Appam",
    "Corinth",
    "Alexander",
    "Rawson",
    "Ambrose",
    "Arnegard",
    "Cartwright",
    "Epping",
    "Spring Brook",
    "Fortuna",
    "Colgan",
    "Grenora",
    "Alkabo",
    "Keene",
    "Ray",
    "Wheelock",
    "Tioga",
    "Temple",
    "Trenton",
    "Watford City",
    "Zahl",
  ],
  NE: [
    "Abie",
    "Arlington",
    "Ashland",
    "Bancroft",
    "Bellevue",
    "Bennington",
    "Blair",
    "Boys Town",
    "Boystown",
    "Bruno",
    "Cedar Bluffs",
    "Cedar Creek",
    "Ceresco",
    "Colon",
    "Craig",
    "Decatur",
    "Elkhorn",
    "Fort Calhoun",
    "Fremont",
    "Inglewood",
    "Gretna",
    "Herman",
    "Homer",
    "Hooper",
    "Ithaca",
    "Kennard",
    "Linwood",
    "Louisville",
    "Lyons",
    "Macy",
    "Malmo",
    "Mead",
    "Memphis",
    "Nickerson",
    "Fontanelle",
    "Oakland",
    "Papillion",
    "Pender",
    "Plattsmouth",
    "Prague",
    "Rosalie",
    "St Columbans",
    "Scribner",
    "South Bend",
    "Springfield",
    "Richfield",
    "Tekamah",
    "Thurston",
    "Uehling",
    "Valley",
    "Leshara",
    "Valparaiso",
    "Wahoo",
    "Walthill",
    "Washington",
    "Waterloo",
    "Weston",
    "Winnebago",
    "Winslow",
    "Yutan",
    "Omaha",
    "Offutt Afb",
    "Ralston",
    "La Vista",
    "Lavista",
    "Millard",
    "Adams",
    "Alexandria",
    "Alvo",
    "Auburn",
    "Avoca",
    "Barneston",
    "Beatrice",
    "Holmesville",
    "Beaver Crossing",
    "Beaver Xing",
    "Bee",
    "Belvidere",
    "Benedict",
    "Bennet",
    "Blue Springs",
    "Bradshaw",
    "Brock",
    "Brownville",
    "Bruning",
    "Burchard",
    "Burr",
    "Byron",
    "Carleton",
    "Chester",
    "Clatonia",
    "Cook",
    "Cordova",
    "Cortland",
    "Crab Orchard",
    "Crete",
    "Davenport",
    "Davey",
    "Dawson",
    "Daykin",
    "Denton",
    "Deshler",
    "De Witt",
    "Diller",
    "Dorchester",
    "Douglas",
    "Du Bois",
    "Dunbar",
    "Lorton",
    "Eagle",
    "Elk Creek",
    "Elmwood",
    "Endicott",
    "Exeter",
    "Fairbury",
    "Gladstone",
    "Fairmont",
    "Falls City",
    "Filley",
    "Firth",
    "Friend",
    "Garland",
    "Geneva",
    "Gilead",
    "Goehner",
    "Grafton",
    "Greenwood",
    "Gresham",
    "Hallam",
    "Hebron",
    "Henderson",
    "Hickman",
    "Holland",
    "Hubbell",
    "Humboldt",
    "Jansen",
    "Johnson",
    "Julian",
    "Lewiston",
    "Liberty",
    "McCool Junction",
    "Mc Cool Jct",
    "Malcolm",
    "Manley",
    "Martell",
    "Milford",
    "Milligan",
    "Murdock",
    "Murray",
    "Nebraska City",
    "Nehawka",
    "Nemaha",
    "Odell",
    "Ohiowa",
    "Otoe",
    "Palmyra",
    "Panama",
    "Pawnee City",
    "Peru",
    "Pickrell",
    "Pleasant Dale",
    "Plymouth",
    "Raymond",
    "Agnew",
    "Reynolds",
    "Roca",
    "Rulo",
    "Salem",
    "Seward",
    "Shickley",
    "Shubert",
    "Sprague",
    "Staplehurst",
    "Steele City",
    "Steinauer",
    "Stella",
    "Sterling",
    "Saint Mary",
    "Strang",
    "Swanton",
    "Syracuse",
    "Table Rock",
    "Talmage",
    "Tecumseh",
    "Ong",
    "Tobias",
    "Unadilla",
    "Union",
    "Utica",
    "Verdon",
    "Virginia",
    "Waco",
    "Walton",
    "Waverly",
    "Weeping Water",
    "Western",
    "Wilber",
    "Wymore",
    "York",
    "Lincoln",
    "Columbus",
    "Richland",
    "Albion",
    "Boone",
    "Ames",
    "Bartlett",
    "Belgrade",
    "Bellwood",
    "Brainard",
    "Cedar Rapids",
    "Clarks",
    "Clarkson",
    "Creston",
    "David City",
    "Garrison",
    "Octavia",
    "Dodge",
    "Duncan",
    "Dwight",
    "Elgin",
    "Ericson",
    "Fullerton",
    "Genoa",
    "Howells",
    "Humphrey",
    "Cornlea",
    "Tarnov",
    "Leigh",
    "Lindsay",
    "Monroe",
    "Morse Bluff",
    "North Bend",
    "Osceola",
    "Petersburg",
    "Platte Center",
    "Polk",
    "Primrose",
    "Rising City",
    "Rogers",
    "Saint Edward",
    "Schuyler",
    "Shelby",
    "Silver Creek",
    "Snyder",
    "Spalding",
    "Stromsburg",
    "Surprise",
    "Ulysses",
    "Norfolk",
    "Hadar",
    "Allen",
    "Amelia",
    "Atkinson",
    "Bassett",
    "Rose",
    "Battle Creek",
    "Beemer",
    "Belden",
    "Bloomfield",
    "Bristow",
    "Brunswick",
    "Butte",
    "Anoka",
    "Carroll",
    "Center",
    "Chambers",
    "Clearwater",
    "Coleridge",
    "Concord",
    "Creighton",
    "Bazile Mills",
    "Crofton",
    "Dakota City",
    "Dixon",
    "Emerson",
    "Emmet",
    "Ewing",
    "Fordyce",
    "Hartington",
    "Hoskins",
    "Hubbard",
    "Inman",
    "Jackson",
    "Laurel",
    "Lynch",
    "Monowi",
    "Mclean",
    "Madison",
    "Magnet",
    "Maskell",
    "Meadow Grove",
    "Mills",
    "Naper",
    "Neligh",
    "Newcastle",
    "Obert",
    "Newman Grove",
    "Newport",
    "Niobrara",
    "Verdel",
    "Oakdale",
    "Oneill",
    "O Neill",
    "Orchard",
    "Osmond",
    "Foster",
    "Page",
    "Pierce",
    "Pilger",
    "Plainview",
    "Ponca",
    "Randolph",
    "Sholes",
    "Royal",
    "Saint Helena",
    "South Sioux City",
    "S Sioux City",
    "Spencer",
    "Springview",
    "Stanton",
    "Stuart",
    "Tilden",
    "Verdigre",
    "Wakefield",
    "Waterbury",
    "Wausa",
    "Wayne",
    "West Point",
    "Winnetoon",
    "Winside",
    "Wisner",
    "Wynot",
    "Grand Island",
    "Alda",
    "Amherst",
    "Anselmo",
    "Milburn",
    "Ansley",
    "Berwyn",
    "Weissert",
    "Arcadia",
    "Archer",
    "Ashton",
    "Aurora",
    "Boelus",
    "Brewster",
    "Broken Bow",
    "Burwell",
    "Cairo",
    "Callaway",
    "Central City",
    "Chapman",
    "Comstock",
    "Dannebrog",
    "Doniphan",
    "Dunning",
    "Eddyville",
    "Elba",
    "Cotesfield",
    "Elm Creek",
    "Elyria",
    "Farwell",
    "Gibbon",
    "Giltner",
    "Greeley",
    "Hampton",
    "Hazard",
    "Kearney",
    "Hordville",
    "Lexington",
    "Litchfield",
    "Loup City",
    "Marquette",
    "Mason City",
    "Merna",
    "Miller",
    "North Loup",
    "Oconto",
    "Odessa",
    "Ord",
    "Overton",
    "Palmer",
    "Phillips",
    "Pleasanton",
    "Ravenna",
    "Riverdale",
    "Rockville",
    "Saint Libory",
    "Saint Paul",
    "Sargent",
    "Scotia",
    "Shelton",
    "Sumner",
    "Taylor",
    "Almeria",
    "Westerville",
    "Wolbach",
    "Wood River",
    "Prosser",
    "Hastings",
    "Alma",
    "Arapahoe",
    "Atlanta",
    "Axtell",
    "Ayr",
    "Beaver City",
    "Bertrand",
    "Bladen",
    "Bloomington",
    "Blue Hill",
    "Cowles",
    "Rosemont",
    "Campbell",
    "Clay Center",
    "Deweese",
    "Edgar",
    "Edison",
    "Elwood",
    "Johnson Lake",
    "Fairfield",
    "Franklin",
    "Funk",
    "Glenvil",
    "Guide Rock",
    "Hardy",
    "Harvard",
    "Heartwell",
    "Hendley",
    "Hildreth",
    "Holbrook",
    "Holdrege",
    "Holstein",
    "Inavale",
    "Inland",
    "Juniata",
    "Kenesaw",
    "Lawrence",
    "Loomis",
    "Minden",
    "Norman",
    "Naponee",
    "Nelson",
    "Nora",
    "Oak",
    "Orleans",
    "Oxford",
    "Red Cloud",
    "Republican City",
    "Huntley",
    "Repub City",
    "Riverton",
    "Roseland",
    "Ruskin",
    "Saronville",
    "Smithfield",
    "Stamford",
    "Superior",
    "Sutton",
    "Trumbull",
    "Upland",
    "Wilcox",
    "McCook",
    "Mccook",
    "Bartley",
    "Benkelman",
    "Cambridge",
    "Champion",
    "Lamar",
    "Culbertson",
    "Curtis",
    "Danbury",
    "Enders",
    "Eustis",
    "Farnam",
    "Haigler",
    "Hayes Center",
    "Imperial",
    "Indianola",
    "Lebanon",
    "Max",
    "Maywood",
    "Moorefield",
    "Palisade",
    "Hamlet",
    "Parks",
    "Stockville",
    "Stratton",
    "Trenton",
    "Wauneta",
    "Wilsonville",
    "North Platte",
    "Arnold",
    "Arthur",
    "Big Springs",
    "Brady",
    "Broadwater",
    "Brule",
    "Bushnell",
    "Chappell",
    "Cozad",
    "Dalton",
    "Dickens",
    "Dix",
    "Elsie",
    "Elsmere",
    "Gothenburg",
    "Grant",
    "Gurley",
    "Halsey",
    "Hershey",
    "Keystone",
    "Kimball",
    "Lemoyne",
    "Lewellen",
    "Lisco",
    "Lodgepole",
    "Madrid",
    "Maxwell",
    "Mullen",
    "Ogallala",
    "Oshkosh",
    "Paxton",
    "Potter",
    "Purdum",
    "Seneca",
    "Sidney",
    "Stapleton",
    "Sutherland",
    "Thedford",
    "Brownlee",
    "Tryon",
    "Venango",
    "Wallace",
    "Wellfleet",
    "Willow Island",
    "Valentine",
    "Ainsworth",
    "Cody",
    "Crookston",
    "Johnstown",
    "Kilgore",
    "Long Pine",
    "Merriman",
    "Nenzel",
    "Sparks",
    "Wood Lake",
    "Alliance",
    "Angora",
    "Ashby",
    "Bayard",
    "Bingham",
    "Bridgeport",
    "Chadron",
    "Crawford",
    "Ellsworth",
    "Gering",
    "Gordon",
    "Harrisburg",
    "Harrison",
    "Hay Springs",
    "Hemingford",
    "Hyannis",
    "Lakeside",
    "Lyman",
    "Mcgrew",
    "Marsland",
    "Melbeta",
    "Minatare",
    "Mitchell",
    "Morrill",
    "Henry",
    "Rushville",
    "Scottsbluff",
    "Whiteclay",
    "Whitman",
    "Whitney",
  ],
  NH: [
    "Amherst",
    "Auburn",
    "Brookline",
    "Candia",
    "Chester",
    "Deerfield",
    "Derry",
    "Londonderry",
    "Epping",
    "Francestown",
    "Fremont",
    "Goffstown",
    "Dunbarton",
    "Greenfield",
    "Greenville",
    "Mason",
    "Hollis",
    "Hudson",
    "Litchfield",
    "Merrimack",
    "Milford",
    "Mont Vernon",
    "Nashua",
    "New Boston",
    "New Ipswich",
    "Pelham",
    "Raymond",
    "Salem",
    "Lyndeborough",
    "Temple",
    "Wilton",
    "Windham",
    "Manchester",
    "Hooksett",
    "Bedford",
    "Waterville Valley",
    "Watervl Vly",
    "Andover",
    "Ashland",
    "Barnstead",
    "Belmont",
    "Bradford",
    "Bristol",
    "Alexandria",
    "Campton",
    "Ellsworth",
    "Thornton",
    "Canterbury",
    "Center Barnstead",
    "Ctr Barnstead",
    "Center Harbor",
    "Center Sandwich",
    "Ctr Sandwich",
    "Sandwich",
    "Contoocook",
    "Hopkinton",
    "Danbury",
    "East Andover",
    "Elkins",
    "Epsom",
    "Franklin",
    "Gilmanton",
    "Glencliff",
    "Grafton",
    "Hebron",
    "East Hebron",
    "Henniker",
    "Hill",
    "Hillsborough",
    "Deering",
    "Hillsboro",
    "Windsor",
    "Holderness",
    "Laconia",
    "Gilford",
    "Lincoln",
    "Meredith",
    "Moultonborough",
    "Moultonboro",
    "Newbury",
    "Mount Sunapee",
    "New Hampton",
    "New London",
    "Chichester",
    "North Sandwich",
    "N Sandwich",
    "North Sutton",
    "Northwood",
    "North Woodstock",
    "N Woodstock",
    "Pittsfield",
    "Plymouth",
    "Rumney",
    "Dorchester",
    "Salisbury",
    "Sanbornton",
    "South Sutton",
    "Suncook",
    "Allenstown",
    "Pembroke",
    "Tilton",
    "Northfield",
    "Warner",
    "Warren",
    "Washington",
    "Weare",
    "Wentworth",
    "Springfield",
    "Wilmot",
    "Nottingham",
    "West Nottingham",
    "W Nottingham",
    "Woodstock",
    "Concord",
    "Boscawen",
    "Penacook",
    "Webster",
    "Bow",
    "Loudon",
    "Keene",
    "North Swanzey",
    "Roxbury",
    "Surry",
    "Antrim",
    "Ashuelot",
    "Bennington",
    "Chesterfield",
    "Dublin",
    "Sullivan",
    "Swanzey",
    "Fitzwilliam",
    "Gilsum",
    "Hancock",
    "Harrisville",
    "Hinsdale",
    "Jaffrey",
    "Marlborough",
    "Marlow",
    "Nelson",
    "Munsonville",
    "Peterborough",
    "Sharon",
    "Rindge",
    "Spofford",
    "Stoddard",
    "Troy",
    "West Chesterfield",
    "W Chesterfld",
    "Westmoreland",
    "Winchester",
    "Richmond",
    "Littleton",
    "Berlin",
    "Bethlehem",
    "Bretton Woods",
    "Colebrook",
    "Dixville",
    "Stewartstown",
    "Errol",
    "Wentworths Location",
    "Wntwrths Lctn",
    "Franconia",
    "Easton",
    "Gorham",
    "Shelburne",
    "Groveton",
    "Northumberland",
    "Northumberlnd",
    "Stark",
    "Jefferson",
    "Lancaster",
    "Lisbon",
    "Landaff",
    "Lyman",
    "Sugar Hill",
    "Milan",
    "Dummer",
    "North Stratford",
    "N Stratford",
    "Stratford",
    "Pittsburg",
    "Clarksville",
    "Randolph",
    "Twin Mountain",
    "West Stewartstown",
    "W Stewartstwn",
    "Whitefield",
    "Carroll",
    "Dalton",
    "Acworth",
    "Alstead",
    "Langdon",
    "Charlestown",
    "Drewsville",
    "Lempster",
    "East Lempster",
    "South Acworth",
    "Walpole",
    "North Walpole",
    "Bath",
    "Canaan",
    "Orange",
    "Claremont",
    "Cornish",
    "Enfield",
    "Etna",
    "Georges Mills",
    "Goshen",
    "Grantham",
    "Hanover",
    "Haverhill",
    "Lebanon",
    "Lyme",
    "Meriden",
    "Monroe",
    "Newport",
    "Croydon",
    "North Haverhill",
    "N Haverhill",
    "Orford",
    "Piermont",
    "Pike",
    "Plainfield",
    "Sunapee",
    "West Lebanon",
    "Woodsville",
    "Benton",
    "Portsmouth",
    "Newington",
    "Alton",
    "Alton Bay",
    "Atkinson",
    "Bartlett",
    "Harts Lctn",
    "Harts Location",
    "Center Conway",
    "Chatham",
    "Center Ossipee",
    "Ctr Ossipee",
    "Center Tuftonboro",
    "Ctr Tuftnboro",
    "Chocorua",
    "Conway",
    "Albany",
    "Danville",
    "Dover",
    "Madbury",
    "Durham",
    "Lee",
    "Barrington",
    "East Hampstead",
    "E Hampstead",
    "East Kingston",
    "South Hampton",
    "East Wakefield",
    "E Wakefield",
    "Eaton Center",
    "Exeter",
    "Brentwood",
    "Kensington",
    "Farmington",
    "Freedom",
    "Gilmanton Iron Works",
    "Gilmanton Iw",
    "Glen",
    "Rochester",
    "Greenland",
    "Hampstead",
    "Hampton",
    "Hampton Falls",
    "Intervale",
    "Jackson",
    "Kearsarge",
    "Kingston",
    "Madison",
    "Melvin Village",
    "Melvin Vlg",
    "Milton",
    "Milton Mills",
    "Mirror Lake",
    "New Castle",
    "New Durham",
    "Newfields",
    "Newmarket",
    "Newton",
    "North Conway",
    "Hales Lctn",
    "Hales Location",
    "North Hampton",
    "Ossipee",
    "Plaistow",
    "Rollinsford",
    "Rye",
    "Rye Beach",
    "Sanbornville",
    "Brookfield",
    "Sandown",
    "Seabrook",
    "Silver Lake",
    "Somersworth",
    "Effingham",
    "South Tamworth",
    "S Tamworth",
    "Strafford",
    "Stratham",
    "Tamworth",
    "Union",
    "Middleton",
    "West Ossipee",
    "Wolfeboro",
    "Wonalancet",
  ],
  NJ: [
    "Avenel",
    "Bayonne",
    "Bloomfield",
    "Fairfield",
    "Boonton",
    "Boonton Township",
    "Boonton Twp",
    "Caldwell",
    "N Caldwell",
    "North Caldwell",
    "W Caldwell",
    "West Caldwell",
    "Carteret",
    "Cedar Grove",
    "Cliffside Park",
    "Cliffside Pk",
    "Clifton",
    "Cranford",
    "East Orange",
    "Edgewater",
    "Essex Fells",
    "Fairview",
    "Fanwood",
    "Fort Lee",
    "Garfield",
    "Garwood",
    "Glen Ridge",
    "Harrison",
    "East Newark",
    "Hoboken",
    "North Arlington",
    "N Arlington",
    "Kearny",
    "Kenilworth",
    "Lake Hiawatha",
    "Lincoln Park",
    "Linden",
    "Winfield Park",
    "Livingston",
    "Maplewood",
    "Millburn",
    "Montclair",
    "Upper Montclair",
    "Upr Montclair",
    "Verona",
    "Montville",
    "Mountain Lakes",
    "Mountain Lks",
    "North Bergen",
    "Orange",
    "West Orange",
    "Parsippany",
    "Passaic",
    "Wallington",
    "Pine Brook",
    "Warren",
    "Plainfield",
    "N Plainfield",
    "North Plainfield",
    "Port Reading",
    "Rahway",
    "Clark",
    "Colonia",
    "Roseland",
    "Watchung",
    "Rutherford",
    "Lyndhurst",
    "Carlstadt",
    "East Rutherford",
    "E Rutherford",
    "Moonachie",
    "Wood Ridge",
    "Scotch Plains",
    "Sewaren",
    "Short Hills",
    "South Orange",
    "South Plainfield",
    "S Plainfield",
    "Springfield",
    "Towaco",
    "Union",
    "Weehawken",
    "Union City",
    "Vauxhall",
    "Westfield",
    "Mountainside",
    "West New York",
    "Guttenberg",
    "Secaucus",
    "Woodbridge",
    "Newark",
    "Belleville",
    "Nutley",
    "Irvington",
    "Elizabeth",
    "Roselle",
    "Roselle Park",
    "Hillside",
    "Ind Hillside",
    "Industrial Hillside",
    "Elizabethport",
    "Jersey City",
    "Allendale",
    "Bloomingdale",
    "Butler",
    "Kinnelon",
    "Elmwood Park",
    "Fair Lawn",
    "Franklin",
    "Franklin Lakes",
    "Franklin Lks",
    "Glenwood",
    "Hamburg",
    "Haskell",
    "Hewitt",
    "Highland Lakes",
    "Highland Lks",
    "Ho Ho Kus",
    "Little Falls",
    "West Paterson",
    "Woodland Park",
    "Mahwah",
    "Midland Park",
    "Newfoundland",
    "Oakland",
    "Oak Ridge",
    "Ogdensburg",
    "Pequannock",
    "Pompton Lakes",
    "Pompton Plains",
    "Pompton Plns",
    "Ramsey",
    "Ridgewood",
    "Glen Rock",
    "Ringwood",
    "Riverdale",
    "Saddle River",
    "U Saddle Riv",
    "Upper Saddle River",
    "Stockholm",
    "Hardyston",
    "Sussex",
    "Wantage",
    "Vernon",
    "Waldwick",
    "Wanaque",
    "Wayne",
    "West Milford",
    "Wyckoff",
    "Paterson",
    "Totowa",
    "Hawthorne",
    "Haledon",
    "North Haledon",
    "Prospect Park",
    "Hackensack",
    "Bogota",
    "Hasbrouck Heights",
    "Hasbrouck Hts",
    "Leonia",
    "South Hackensack",
    "S Hackensack",
    "Maywood",
    "Teterboro",
    "Alpine",
    "Bergenfield",
    "Closter",
    "Cresskill",
    "Demarest",
    "Dumont",
    "Emerson",
    "Englewood",
    "Englewood Cliffs",
    "Englewd Clfs",
    "Harrington Park",
    "Harrington Pk",
    "Haworth",
    "Hillsdale",
    "Little Ferry",
    "Lodi",
    "Montvale",
    "New Milford",
    "Northvale",
    "Rockleigh",
    "Norwood",
    "Oradell",
    "Palisades Park",
    "Palisades Pk",
    "Paramus",
    "Park Ridge",
    "Ridgefield",
    "Ridgefield Park",
    "Ridgefield Pk",
    "River Edge",
    "Rochelle Park",
    "Saddle Brook",
    "Teaneck",
    "Tenafly",
    "Westwood",
    "Old Tappan",
    "River Vale",
    "Rivervale",
    "Township Of Washington",
    "Twp Washingtn",
    "Twp Washinton",
    "Washington Twps",
    "Woodcliff Lake",
    "Woodcliff Lk",
    "Red Bank",
    "Tinton Falls",
    "Shrewsbury",
    "Fort Monmouth",
    "Fair Haven",
    "Allenhurst",
    "Loch Arbour",
    "W Allenhurst",
    "West Allenhurst",
    "Asbury Park",
    "Interlaken",
    "Ocean",
    "Atlantic Highlands",
    "Atlantic Hlds",
    "Avon By The Sea",
    "Avon By Sea",
    "Belford",
    "Belmar",
    "Lake Como",
    "Wall",
    "Wall Township",
    "Bradley Beach",
    "Cliffwood",
    "Colts Neck",
    "Deal",
    "Ocean Townshp",
    "Ocean Twp",
    "Eatontown",
    "Englishtown",
    "Manalapan",
    "Farmingdale",
    "Freehold",
    "Hazlet",
    "Howell",
    "Highlands",
    "Sandy Hook",
    "Holmdel",
    "Keansburg",
    "Hazlet Township",
    "Hazlet Twp",
    "Keyport",
    "Union Beach",
    "Leonardo",
    "Lincroft",
    "Little Silver",
    "Long Branch",
    "Elberon",
    "Marlboro",
    "Matawan",
    "Aberdeen",
    "Middletown",
    "N Middletown",
    "New Monmouth",
    "North Middletown",
    "Monmouth Beach",
    "Monmouth Bch",
    "Morganville",
    "Neptune",
    "Neptune City",
    "Oakhurst",
    "Ocean Grove",
    "Oceanport",
    "Port Monmouth",
    "Rumson",
    "Locust",
    "Sea Bright",
    "Spring Lake",
    "West Long Branch",
    "W Long Branch",
    "Dover",
    "Mine Hill",
    "Allamuchy",
    "Andover",
    "Byram Township",
    "Byram Twp",
    "Green Township",
    "Green Twp",
    "Augusta",
    "Belvidere",
    "Blairstown",
    "Hardwick",
    "Johnsonburg",
    "Branchville",
    "Sandyston",
    "Montague",
    "Budd Lake",
    "Califon",
    "Tewksbury Township",
    "Tewksbury Twp",
    "Changewater",
    "Columbia",
    "Delaware",
    "Denville",
    "Flanders",
    "Roxbury Township",
    "Roxbury Twp",
    "Great Meadows",
    "Hackettstown",
    "Hibernia",
    "Hopatcong",
    "Hope",
    "Kenvil",
    "Lafayette",
    "Lake Hopatcong",
    "Lk Hopatcong",
    "Landing",
    "Layton",
    "Ledgewood",
    "Long Valley",
    "Mount Arlington",
    "Mt Arlington",
    "Netcong",
    "Newton",
    "Fredon",
    "Fredon Township",
    "Fredon Twp",
    "Oxford",
    "Port Murray",
    "Rockaway",
    "Rockaway Boro",
    "Rockaway Borough",
    "Randolph",
    "Chester Twp",
    "Schooleys Mountain",
    "Schooleys Mtn",
    "Sparta",
    "Stanhope",
    "Succasunna",
    "Mount Tabor",
    "Vienna",
    "Wallpack Center",
    "Wallpack Ctr",
    "Washington",
    "Wharton",
    "Summit",
    "Basking Ridge",
    "Bedminster",
    "Berkeley Heights",
    "Berkeley Hts",
    "Bernardsville",
    "Brookside",
    "Cedar Knolls",
    "Chatham",
    "Chatham Twp",
    "Chester",
    "Far Hills",
    "Florham Park",
    "Gillette",
    "Gladstone",
    "Green Village",
    "East Hanover",
    "Lyons",
    "Madison",
    "Mendham",
    "Mendham Township",
    "Mendham Twp",
    "Millington",
    "Morris Plains",
    "Greystone Park",
    "Greystone Pk",
    "Morristown",
    "Convent Station",
    "Convent Sta",
    "Mount Freedom",
    "New Providence",
    "New Providnce",
    "New Vernon",
    "Peapack",
    "Pottersville",
    "Stirling",
    "Whippany",
    "Alloway",
    "Cherry Hill",
    "Atco",
    "Barnegat",
    "Barnegat Light",
    "Barnegat Lgt",
    "Barrington",
    "Beach Haven",
    "Harvey Cedars",
    "Long Bch Twp",
    "Long Beach",
    "Long Beach Township",
    "Ship Bottom",
    "Surf City",
    "Berlin",
    "Berlin Boro",
    "Beverly",
    "Edgewater Park",
    "Edgewater Prk",
    "Birmingham",
    "Blackwood",
    "Turnersville",
    "Bridgeport",
    "Browns Mills",
    "Burlington",
    "Burlington City",
    "Burlington Township",
    "Burlngtn City",
    "Burlngtn Twp",
    "Chatsworth",
    "Clarksboro",
    "Clementon",
    "Laurel Spgs",
    "Laurel Springs",
    "Lindenwold",
    "Pine Hill",
    "Pine Valley",
    "Columbus",
    "Deepwater",
    "Gibbsboro",
    "Gibbstown",
    "Glassboro",
    "Glendora",
    "Gloucester City",
    "Brooklawn",
    "Gloucester Cy",
    "Gloucstr City",
    "Bellmawr",
    "Grenloch",
    "Haddonfield",
    "Haddon Heights",
    "Haddon Hgts",
    "Haddon Hts",
    "Hainesport",
    "Hainesport Township",
    "Hainesprt Twp",
    "Hammonton",
    "Batsto",
    "Blue Anchor",
    "Mullica",
    "Hancocks Bridge",
    "Hancocks Brg",
    "Harrisonville",
    "Jobstown",
    "Juliustown",
    "Voorhees",
    "Kirkwd Vrhes",
    "Kirkwood",
    "Lawnside",
    "Willingboro",
    "Lumberton",
    "Lumberton Township",
    "Lumberton Twp",
    "Magnolia",
    "Manahawkin",
    "Stafford Township",
    "Stafford Twp",
    "Mantua",
    "West Deptford",
    "Maple Shade",
    "Marlton",
    "Evesham",
    "Mount Laurel",
    "Medford",
    "Medford Lakes",
    "Mickleton",
    "Moorestown",
    "Mount Ephraim",
    "W Colls Hgts",
    "West Collingswood Heights",
    "Mount Holly",
    "Eastamptn Twp",
    "Eastampton",
    "Eastampton Township",
    "Westampton",
    "Mount Royal",
    "Mullica Hill",
    "S Harrisn Twp",
    "South Harrison Township",
    "National Park",
    "New Lisbon",
    "Palmyra",
    "Paulsboro",
    "Pedricktown",
    "Pemberton",
    "Penns Grove",
    "Carneys Point",
    "Pennsville",
    "Pitman",
    "Quinton",
    "Rancocas",
    "Richwood",
    "Riverside",
    "Delanco",
    "Delran",
    "Riverton",
    "Cinnaminson",
    "Runnemede",
    "Salem",
    "Mannington",
    "Sewell",
    "Sicklerville",
    "Erial",
    "Somerdale",
    "Hi Nella",
    "Stratford",
    "Swedesboro",
    "Logan Township",
    "Logan Twp",
    "Woolwich Township",
    "Woolwich Twp",
    "Thorofare",
    "Tuckerton",
    "Little Egg Harbor",
    "Little Egg Harbor Twp",
    "Ltl Egg Hbr",
    "Mystic Islands",
    "Mystic Islnds",
    "Vincentown",
    "Shamong",
    "Southampton",
    "Tabernacle",
    "Waterford Works",
    "Chesilhurst",
    "Waterford Wks",
    "Wenonah",
    "West Berlin",
    "Berlin Township",
    "Berlin Twp",
    "West Creek",
    "Westville",
    "Williamstown",
    "Winslow",
    "Woodbury",
    "Blackwood Ter",
    "Blackwood Terrace",
    "Deptford",
    "Woodbury Heights",
    "Woodbury Hts",
    "Woodstown",
    "Pilesgrove",
    "Pilesgrove Township",
    "Pilesgrv Twp",
    "Camden",
    "Haddon Township",
    "Haddon Twp",
    "Audubon",
    "Oaklyn",
    "Collingswood",
    "W Colls",
    "West Collingswood",
    "Woodlynne",
    "Westmont",
    "Merchantville",
    "Pennsauken",
    "Delair",
    "Absecon",
    "Avalon",
    "Brigantine",
    "Cape May",
    "N Cape May",
    "North Cape May",
    "West Cape May",
    "Galloway",
    "Smithville",
    "Cape May Court House",
    "Cape May Ch",
    "Cape May Point",
    "Cape May Pt",
    "Egg Harbor City",
    "Egg Harbor Cy",
    "Egg Hbr City",
    "Elwood",
    "Linwood",
    "Marmora",
    "New Gretna",
    "Northfield",
    "Ocean City",
    "Ocean View",
    "Upper Twp",
    "Pleasantville",
    "Mckee City",
    "Egg Harbor Township",
    "Egg Harbor Twp",
    "Egg Hbr Twp",
    "Pomona",
    "Port Republic",
    "Rio Grande",
    "Sea Isle City",
    "Townsend Inlt",
    "Townsends Inlet",
    "Somers Point",
    "South Dennis",
    "South Seaville",
    "S Seaville",
    "Stone Harbor",
    "Strathmere",
    "Villas",
    "Del Haven",
    "Wildwood",
    "N Wildwood",
    "North Wildwood",
    "West Wildwood",
    "Wildwood Crest",
    "Wildwood Crst",
    "Woodbine",
    "Corbin City",
    "Dennis Twp",
    "Bridgeton",
    "Deerfield Twp",
    "Buena",
    "Cedarville",
    "Clayton",
    "Delmont",
    "Dorchester",
    "Dorothy",
    "Elmer",
    "Pittsgrove",
    "Estell Manor",
    "Fairton",
    "Fortescue",
    "Franklinville",
    "Greenwich",
    "Heislerville",
    "Landisville",
    "Leesburg",
    "Malaga",
    "Mauricetown",
    "Mays Landing",
    "Millville",
    "Milmay",
    "Minotola",
    "Monroeville",
    "Newfield",
    "Newport",
    "Newtonville",
    "Port Elizabeth",
    "Prt Elizabeth",
    "Port Norris",
    "Richland",
    "Rosenhayn",
    "Shiloh",
    "Vineland",
    "S Vineland",
    "South Vineland",
    "Atlantic City",
    "Margate City",
    "Longport",
    "Ventnor City",
    "Allentown",
    "Belle Mead",
    "Bordentown",
    "Fieldsboro",
    "Millstone Township",
    "Clarksburg",
    "Millstone Twp",
    "Cookstown",
    "Cranbury",
    "East Windsor",
    "Cream Ridge",
    "Chesterfield",
    "Crosswicks",
    "Florence",
    "Hightstown",
    "Hopewell",
    "Jackson",
    "Kingston",
    "Lambertville",
    "New Egypt",
    "Pennington",
    "Perrineville",
    "Plainsboro",
    "Princeton",
    "Princeton Junction",
    "Princeton Jct",
    "West Windsor",
    "Ringoes",
    "Rocky Hill",
    "Roebling",
    "Roosevelt",
    "Skillman",
    "Stockton",
    "Titusville",
    "Ewing",
    "Windsor",
    "Wrightstown",
    "Trenton",
    "Hamilton",
    "Mercerville",
    "West Trenton",
    "Joint Base Mdl",
    "Fort Dix",
    "Jb Mdl",
    "Mc Guire AFB",
    "Lawrence Township",
    "Lawrence",
    "Lawrence Twp",
    "Lawrenceville",
    "Hamilton Sq",
    "Hamilton Square",
    "Robbinsville",
    "Lakewood",
    "Allenwood",
    "Bayville",
    "Beachwood",
    "Brick",
    "Osbornville",
    "Brielle",
    "Forked River",
    "Island Heights",
    "Island Hgts",
    "Lakehurst",
    "Lakehurst Nae",
    "Lakehurst Naec",
    "Lanoka Harbor",
    "Lavallette",
    "Manasquan",
    "Mantoloking",
    "Ocean Gate",
    "Pine Beach",
    "Point Pleasant Beach",
    "Bay Head",
    "Point Pleasant Boro",
    "Pt Pleas Bch",
    "Pt Pleasant",
    "Pt Pleasant Beach",
    "Sea Girt",
    "Seaside Heights",
    "Seaside Hgts",
    "Seaside Park",
    "Toms River",
    "Berkeley",
    "Manchester",
    "Waretown",
    "Manchester Township",
    "Manchester Tw",
    "Whiting",
    "Annandale",
    "Asbury",
    "Bloomsbury",
    "Bound Brook",
    "Bridgewater",
    "Clinton",
    "Dayton",
    "Dunellen",
    "Green Brook",
    "East Brunswick",
    "E Brunswick",
    "Edison",
    "Flagtown",
    "Flemington",
    "Franklin Park",
    "Kendall Park",
    "Frenchtown",
    "Glen Gardner",
    "Hampton",
    "Helmetta",
    "High Bridge",
    "Iselin",
    "Monroe Township",
    "Jamesburg",
    "Monroe",
    "Monroe Twp",
    "Keasbey",
    "Lebanon",
    "Manville",
    "Martinsville",
    "Metuchen",
    "Hillsborough",
    "Middlesex",
    "Milford",
    "Milltown",
    "Monmouth Junction",
    "Monmouth Jct",
    "Neshanic Station",
    "Branchburg",
    "Neshanic Sta",
    "Piscataway",
    "Old Bridge",
    "Oldwick",
    "Parlin",
    "Perth Amboy",
    "Hopelawn",
    "Fords",
    "Phillipsburg",
    "Alpha",
    "Pittstown",
    "Raritan",
    "Sayreville",
    "Somerset",
    "Somerville",
    "North Branch",
    "South Amboy",
    "Laurence Harbor",
    "Laurence Hbr",
    "South Bound Brook",
    "S Bound Brook",
    "South River",
    "Spotswood",
    "Stewartsville",
    "Three Bridges",
    "Whitehouse Station",
    "White Hse Sta",
    "Zarephath",
    "New Brunswick",
    "North Brunswick",
    "N Brunswick",
    "Highland Park",
  ],
  NM: [
    "Algodones",
    "Budaghers",
    "San Felipe Pb",
    "Belen",
    "Rio Comm",
    "Rio Communities",
    "Bernalillo",
    "Sandia Pueblo",
    "Santa Ana Pue",
    "Santa Ana Pueblo",
    "Tamaya",
    "Bluewater",
    "Bosque",
    "Casa Blanca",
    "Paraje",
    "Seama",
    "Cedar Crest",
    "Cerrillos",
    "Madrid",
    "Claunch",
    "Coyote",
    "Cuba",
    "Ojo Encino",
    "Cubero",
    "Seboyeta",
    "Edgewood",
    "Estancia",
    "Tajique",
    "Gallina",
    "Counselor",
    "Grants",
    "San Mateo",
    "Milan",
    "Isleta",
    "Jarales",
    "Jemez Pueblo",
    "Jemez Springs",
    "Laguna",
    "Canoncito",
    "Mesita",
    "Old Laguna",
    "Tohajiilee",
    "La Jara",
    "Llaves",
    "La Joya",
    "Lindrith",
    "Los Lunas",
    "Mcintosh",
    "Pueblo Of Acoma",
    "Acoma",
    "Pblo Of Acoma",
    "Moriarty",
    "Mountainair",
    "Nageezi",
    "New Laguna",
    "Encinal",
    "Paguate",
    "Pena Blanca",
    "Peralta",
    "Bosque Farms",
    "Placitas",
    "Ponderosa",
    "Prewitt",
    "Regina",
    "Sandia Park",
    "Golden",
    "San Antonito",
    "Corrales",
    "San Fidel",
    "San Rafael",
    "Santo Domingo Pueblo",
    "Kewa",
    "St Dmng Pblo",
    "San Ysidro",
    "Zia Pueblo",
    "Stanley",
    "Tijeras",
    "Tome",
    "Torreon",
    "Veguita",
    "Willard",
    "Youngsville",
    "Clines Corners",
    "Clines Cors",
    "Cochiti Pueblo",
    "Cochiti Publo",
    "Cochiti Lake",
    "Albuquerque",
    "Unm",
    "Los Ranchos",
    "Los Ranchos De Abq",
    "Los Ranchos De Albuquerque",
    "Los Rnchs Abq",
    "Village Of Los Ranchos",
    "Alameda",
    "Kirtland Afb",
    "Rio Rancho",
    "Gallup",
    "Black Hat",
    "Manuelito",
    "Tse Bonito",
    "Brimhall",
    "Church Rock",
    "Continental Divide",
    "Contnental Dv",
    "Crownpoint",
    "Fence Lake",
    "Fort Wingate",
    "Gamerco",
    "Mentmore",
    "Mexican Springs",
    "Mexican Spgs",
    "Ramah",
    "Rehoboth",
    "Thoreau",
    "Tohatchi",
    "Vanderwagen",
    "Zuni",
    "Navajo",
    "Jamestown",
    "Pinehill",
    "Sheep Springs",
    "Smith Lake",
    "Yatahey",
    "Farmington",
    "Aztec",
    "Blanco",
    "Bloomfield",
    "Flora Vista",
    "Fruitland",
    "Kirtland",
    "La Plata",
    "Navajo Dam",
    "Shiprock",
    "Waterflow",
    "Newcomb",
    "Sanostee",
    "Santa Fe",
    "Pojoaque",
    "Jaconita",
    "Nambe Pueblo",
    "San Ildefonso",
    "San Ildefonso Pueblo",
    "Tesuque Puebl",
    "Tesuque Pueblo",
    "Abiquiu",
    "Alcalde",
    "Amalia",
    "Arroyo Hondo",
    "Arroyo Seco",
    "Canjilon",
    "Canones",
    "Carson",
    "Cebolla",
    "Cerro",
    "Chama",
    "Chamisal",
    "Ojo Sarco",
    "Chimayo",
    "Cundiyo",
    "Cordova",
    "Costilla",
    "Taos Ski Valley",
    "Taos Ski Vly",
    "Dixon",
    "Dulce",
    "Lumberton",
    "El Prado",
    "El Rito",
    "Embudo",
    "Pilar",
    "Espanola",
    "Glorieta",
    "Hernandez",
    "Ilfeld",
    "La Madera",
    "Lamy",
    "Galisteo",
    "Llano",
    "Los Alamos",
    "White Rock",
    "Medanales",
    "Ojo Caliente",
    "Los Ojos",
    "Rutheron",
    "Pecos",
    "Penasco",
    "Petaca",
    "Questa",
    "Ranchos De Taos",
    "Rnch De Taos",
    "Red River",
    "Ribera",
    "Gonzales Ranch",
    "Gonzales Rnch",
    "Sena",
    "Rowe",
    "San Cristobal",
    "San Jose",
    "Ohkay Owingeh",
    "San Juan Pblo",
    "San Juan Pueblo",
    "Santa Cruz",
    "Serafina",
    "Taos",
    "Tererro",
    "Tierra Amarilla",
    "Tira Amarilla",
    "Tres Piedras",
    "Truchas",
    "Vadito",
    "Valdez",
    "Vallecitos",
    "Las Tablas",
    "Velarde",
    "Villanueva",
    "Las Vegas",
    "Angel Fire",
    "Eagle Nest",
    "Anton Chico",
    "Buena Vista",
    "Chacon",
    "Cimarron",
    "Cleveland",
    "Guadalupita",
    "Holman",
    "La Loma",
    "Maxwell",
    "Miami",
    "Springer",
    "Mills",
    "Montezuma",
    "Mora",
    "Ledoux",
    "Mosquero",
    "Albert",
    "Ocate",
    "Ojo Feliz",
    "Wagon Mound",
    "Rainsville",
    "Raton",
    "Rociada",
    "Roy",
    "Sapello",
    "Solano",
    "Ute Park",
    "Valmora",
    "Watrous",
    "Socorro",
    "Aragon",
    "Datil",
    "Lemitar",
    "Luna",
    "Magdalena",
    "Alamo",
    "Pie Town",
    "Polvadera",
    "Quemado",
    "Reserve",
    "San Acacia",
    "San Antonio",
    "Bingham",
    "Truth Or Consequences",
    "Cuchillo",
    "T OR C",
    "Truth Consq",
    "Arrey",
    "Caballo",
    "Derry",
    "Elephant Butte",
    "Elephant Btte",
    "Garfield",
    "Hatch",
    "Monticello",
    "Rincon",
    "Salem",
    "Williamsburg",
    "Winston",
    "Las Cruces",
    "White Sands Missile Range",
    "White Sands",
    "Santa Teresa",
    "Sunland Park",
    "Playas",
    "Lordsburg",
    "Animas",
    "Anthony",
    "Chaparral",
    "Arenas Valley",
    "Silver City",
    "Bayard",
    "Vanadium",
    "Berino",
    "Buckhorn",
    "Santa Clara",
    "Central",
    "Chamberino",
    "Cliff",
    "Columbus",
    "Deming",
    "Faywood",
    "Gila",
    "Glenwood",
    "Hachita",
    "Hanover",
    "San Lorenzo",
    "Hillsboro",
    "Hurley",
    "La Mesa",
    "Road Forks",
    "Separ",
    "Steins",
    "Virden",
    "Mesilla",
    "Mesilla Park",
    "Mesquite",
    "Mimbres",
    "Mule Creek",
    "Organ",
    "Pinos Altos",
    "Redrock",
    "Rodeo",
    "Tyrone",
    "Vado",
    "Clovis",
    "Cannon AFB",
    "Cannon Afb",
    "Broadview",
    "Bellview",
    "Causey",
    "Crossroads",
    "Dora",
    "Elida",
    "Floyd",
    "Fort Sumner",
    "Lake Sumner",
    "Grady",
    "House",
    "Melrose",
    "Milnesand",
    "Pep",
    "Portales",
    "Rogers",
    "Taiban",
    "Texico",
    "Yeso",
    "Lon",
    "Roswell",
    "Border Hill",
    "Pine Lodge",
    "Artesia",
    "Carlsbad",
    "Dexter",
    "Eunice",
    "Hagerman",
    "Hobbs",
    "Oil Center",
    "Hope",
    "Jal",
    "Lake Arthur",
    "Lakewood",
    "Loco Hills",
    "Loving",
    "Lovington",
    "Mcdonald",
    "Malaga",
    "Maljamar",
    "Monument",
    "Tatum",
    "Whites City",
    "Carrizozo",
    "Ancho",
    "Duran",
    "Oscuro",
    "White Oaks",
    "Alamogordo",
    "Alto",
    "Bent",
    "Capitan",
    "Angus",
    "Cloudcroft",
    "Corona",
    "Encino",
    "Fort Stanton",
    "Glencoe",
    "High Rolls Mountain Park",
    "Hi Rls Mtn Pk",
    "Holloman Air Force Base",
    "Holloman AFB",
    "Hondo",
    "La Luz",
    "Lincoln",
    "Mayhill",
    "Flying H",
    "Mescalero",
    "Nogal",
    "Orogrande",
    "Picacho",
    "Pinon",
    "Ruidoso",
    "Ruidoso Downs",
    "Sacramento",
    "San Patricio",
    "Sunspot",
    "Timberon",
    "Tinnie",
    "Arabela",
    "Tularosa",
    "Vaughn",
    "Weed",
    "Tucumcari",
    "Amistad",
    "Bard",
    "San Jon",
    "Capulin",
    "Clayton",
    "Bueyeros",
    "Seneca",
    "Stead",
    "Conchas Dam",
    "Cuervo",
    "Des Moines",
    "Folsom",
    "Garita",
    "Gladstone",
    "Grenville",
    "Mount Dora",
    "Logan",
    "Mcalister",
    "Nara Visa",
    "Newkirk",
    "Bell Ranch",
    "Glenrio",
    "Santa Rosa",
    "Pastura",
    "Puerta D Luna",
    "Puerta De Luna",
    "Sedan",
    "Trementina",
  ],
  NV: [
    "Alamo",
    "Henderson",
    "Beatty",
    "Blue Diamond",
    "Boulder City",
    "Bunkerville",
    "Caliente",
    "Dyer",
    "Goldfield",
    "Hiko",
    "Indian Springs",
    "Indian Spgs",
    "Jean",
    "Goodsprings",
    "Primm",
    "Sandy Valley",
    "Amargosa Valley",
    "Amargosa Vly",
    "Logandale",
    "Manhattan",
    "Moapa",
    "Mesquite",
    "Laughlin",
    "North Las Vegas",
    "N Las Vegas",
    "Cal Nev Ari",
    "Palm Gardens",
    "Searchlight",
    "Overton",
    "Panaca",
    "Pioche",
    "Las Vegas",
    "Round Mountain",
    "Round Mtn",
    "Cottonwood Cv",
    "Silverpeak",
    "Pahrump",
    "Tonopah",
    "Sloan",
    "Crystal",
    "Calico Basin",
    "Callville Bay",
    "Cold Creek",
    "Corn Creek",
    "Enterprise",
    "Mount Charleston",
    "Mountain Sprg",
    "Mountain Springs",
    "Mt Charleston",
    "City Center",
    "Nellis Afb",
    "Indian Springs Air Force Aux",
    "Isafa",
    "Ely",
    "Austin",
    "Kingston",
    "Baker",
    "Duckwater",
    "Eureka",
    "Lund",
    "McGill",
    "Ruth",
    "Crystal Bay",
    "Dayton",
    "Denio",
    "Empire",
    "Fallon",
    "Fernley",
    "Gabbs",
    "Gardnerville",
    "Genoa",
    "Gerlach",
    "Glenbrook",
    "Golconda",
    "Midas",
    "Hawthorne",
    "Walker Lake",
    "Imlay",
    "Mill City",
    "Unionville",
    "Lovelock",
    "Luning",
    "McDermitt",
    "Fort Mcdermitt",
    "Ft Mcdermitt",
    "Mina",
    "Minden",
    "Nixon",
    "Orovada",
    "Paradise Valley",
    "Paradise Vly",
    "Schurz",
    "Silver City",
    "Silver Springs",
    "Silver Spgs",
    "Stagecoach",
    "Smith",
    "Sparks",
    "Sun Valley",
    "Lockwood",
    "Spanish Spgs",
    "Spanish Springs",
    "Valmy",
    "Verdi",
    "Virginia City",
    "Wadsworth",
    "Wellington",
    "Winnemucca",
    "Yerington",
    "Zephyr Cove",
    "Stateline",
    "Incline Village",
    "Incline Vlg",
    "Reno",
    "Vc Highlands",
    "Carson City",
    "Washoe Valley",
    "Mound House",
    "Elko",
    "Halleck",
    "Lee",
    "Spring Creek",
    "Jiggs",
    "Battle Mountain",
    "Battle Mtn",
    "Crescent Valley",
    "Beowawe",
    "Crescent Vly",
    "Emigrant Pass",
    "Carlin",
    "Deeth",
    "Jackpot",
    "Jarbidge",
    "Lamoille",
    "Montello",
    "Mountain City",
    "Owyhee",
    "Ruby Valley",
    "Tuscarora",
    "Wells",
    "Oasis",
    "West Wendover",
    "W Wendover",
    "Wendover",
  ],
  NY: [
    "Fishers Island",
    "Fishers Isle",
    "New York",
    "Knickerbocker",
    "Bowling Green",
    "Wall Street",
    "Trinity",
    "Prince",
    "Canal Street",
    "Chinatown",
    "Peck Slip",
    "Roosevelt Isl",
    "Roosevelt Island",
    "Staten Island",
    "Bronx",
    "Amawalk",
    "Ardsley",
    "Ardsley On Hudson",
    "Ardsley Hdsn",
    "Armonk",
    "North Castle",
    "Baldwin Place",
    "Bedford",
    "Bedford Hills",
    "Brewster",
    "Briarcliff Manor",
    "Briarcliff",
    "Scarborough",
    "Buchanan",
    "Carmel",
    "Kent Cliffs",
    "Kent Lakes",
    "Chappaqua",
    "Cold Spring",
    "Nelsonville",
    "Crompond",
    "Cross River",
    "Croton Falls",
    "Croton On Hudson",
    "Croton Hdsn",
    "Dobbs Ferry",
    "Elmsford",
    "Garrison",
    "Goldens Bridge",
    "Goldens Brg",
    "Granite Springs",
    "Granite Spgs",
    "Harrison",
    "Hartsdale",
    "Scarsdale",
    "Hawthorne",
    "Irvington",
    "Jefferson Valley",
    "Jefferson Vly",
    "Katonah",
    "Lake Peekskill",
    "Lk Peekskill",
    "Larchmont",
    "Lincolndale",
    "Mahopac",
    "Lake Lincolnd",
    "Lake Lincolndale",
    "Mahopac Falls",
    "Mamaroneck",
    "Maryknoll",
    "Millwood",
    "Mohegan Lake",
    "Montrose",
    "Mount Kisco",
    "Bedford Corners",
    "Bedford Cors",
    "Mount Vernon",
    "Fleetwood",
    "North Salem",
    "Ossining",
    "Peekskill",
    "Cortlandt Manor",
    "Cortlandt Mnr",
    "Pleasantville",
    "Port Chester",
    "Rye Brook",
    "Pound Ridge",
    "Purchase",
    "Purdys",
    "Putnam Valley",
    "Rye",
    "Heathcote",
    "Shrub Oak",
    "Somers",
    "South Salem",
    "Tarrytown",
    "N Tarrytown",
    "North Tarrytown",
    "Sleepy Hollow",
    "Thornwood",
    "Valhalla",
    "Verplanck",
    "Waccabuc",
    "Yorktown Heights",
    "Yorktown Hts",
    "White Plains",
    "N White Plains",
    "N White Plns",
    "West Harrison",
    "W Harrison",
    "Yonkers",
    "Hastings On Hudson",
    "Hastings Hdsn",
    "Tuckahoe",
    "Eastchester",
    "Bronxville",
    "New Rochelle",
    "Pelham",
    "Wykagyl",
    "Suffern",
    "Airmont",
    "Montebello",
    "Arden",
    "Bear Mountain",
    "Blauvelt",
    "Blooming Grove",
    "Blooming Grv",
    "S Bloomng Grv",
    "Bullville",
    "Campbell Hall",
    "Central Valley",
    "Central Vly",
    "Chester",
    "Mediacom Park",
    "Circleville",
    "Congers",
    "Florida",
    "Fort Montgomery",
    "Ft Montgomery",
    "Garnerville",
    "Goshen",
    "Greenwood Lake",
    "Greenwood Lk",
    "Harriman",
    "Haverstraw",
    "Highland Falls",
    "Highland Fls",
    "Highland Mills",
    "Highland Mls",
    "Hillburn",
    "Howells",
    "Johnson",
    "Middletown",
    "Scotchtown",
    "Monroe",
    "Kiryas Joel",
    "Palm Tree",
    "Twn Palm Tree",
    "Monsey",
    "Kaser",
    "Mountainville",
    "Nanuet",
    "Bardonia",
    "New City",
    "New Hampton",
    "Nyack",
    "Grandview On Hudson",
    "Grnd Vw Hudsn",
    "Orangeburg",
    "Otisville",
    "Palisades",
    "Pearl River",
    "Piermont",
    "Pine Island",
    "Pomona",
    "Slate Hill",
    "Sloatsburg",
    "Southfields",
    "Sparkill",
    "Spring Valley",
    "Chestnut Rdg",
    "Chestnut Ridge",
    "New Square",
    "Sterling Forest",
    "Sterling Frst",
    "Stony Point",
    "Tappan",
    "Thiells",
    "Thompson Ridge",
    "Thompson Rdg",
    "Tomkins Cove",
    "Tuxedo Park",
    "Unionville",
    "Valley Cottage",
    "Vly Cottage",
    "Warwick",
    "Washingtonville",
    "Washingtonvle",
    "West Haverstraw",
    "W Haverstraw",
    "West Nyack",
    "West Point",
    "Westtown",
    "Floral Park",
    "Bellerose Village",
    "Bellerose Vlg",
    "S Floral Park",
    "South Floral Park",
    "Elmont",
    "Alden Manor",
    "Glen Oaks",
    "Franklin Square",
    "Franklin Sq",
    "Great Neck",
    "Lake Success",
    "Great Nck Plz",
    "Great Neck Plaza",
    "Kings Point",
    "Manhasset",
    "Plandome",
    "New Hyde Park",
    "Garden City Park",
    "Garden Cty Pk",
    "Hillside Manor",
    "Hillside Mnr",
    "Manhasset Hills",
    "Manhasset Hl",
    "N New Hyde Pk",
    "North Hills",
    "North New Hyde Park",
    "Port Washington",
    "Prt Washingtn",
    "Sands Point",
    "Inwood",
    "Far Rockaway",
    "Long Island City",
    "Astoria",
    "Long Is City",
    "Sunnyside",
    "Brooklyn",
    "Brooklyn Heights",
    "Brooklyn Hgts",
    "Flushing",
    "College Point",
    "Whitestone",
    "Beechhurst",
    "Malba",
    "Auburndale",
    "Bayside",
    "Little Neck",
    "Douglaston",
    "Oakland Gardens",
    "Bayside Hills",
    "Hollis Hills",
    "Oakland Gdns",
    "Fresh Meadows",
    "Kew Garden Hl",
    "Kew Gardens Hills",
    "Corona",
    "East Elmhurst",
    "La Guardia Airport",
    "La Gurda Arpt",
    "Jackson Heights",
    "Jackson Hts",
    "Elmhurst",
    "Rego Park",
    "Forest Hills",
    "Woodside",
    "Maspeth",
    "Middle Village",
    "Middle Vlg",
    "Ridgewood",
    "Glendale",
    "Cambria Heights",
    "Cambria Hts",
    "Jamaica",
    "Saint Albans",
    "Springfield Gardens",
    "Laurelton",
    "Rosedale",
    "Sprngfld Gdns",
    "Howard Beach",
    "Kew Gardens",
    "Ozone Park",
    "Richmond Hill",
    "South Richmond Hill",
    "S Richmond Hl",
    "South Ozone Park",
    "S Ozone Park",
    "Woodhaven",
    "Hollis",
    "Bellerose",
    "Queens Village",
    "Bellerose Manor",
    "Bellrs Manor",
    "Queens Vlg",
    "Jf Kennedy Ap",
    "Jfk Airport",
    "John F Kennedy Airport",
    "Addisleigh Park",
    "Addisleigh Pk",
    "Rochdale Village",
    "Rochdale Vlg",
    "Briarwood",
    "Mineola",
    "Albertson",
    "Atlantic Beach",
    "Atlantic Bch",
    "Baldwin",
    "N Baldwin",
    "North Baldwin",
    "Carle Place",
    "Cedarhurst",
    "East Rockaway",
    "Freeport",
    "Garden City",
    "Garden City S",
    "Garden City South",
    "Stewart Manor",
    "Village Of Garden City",
    "Vlg Gdn City",
    "Glen Cove",
    "Glen Head",
    "Glenwood Landing",
    "Glenwood Lndg",
    "Greenvale",
    "Hempstead",
    "S Hempstead",
    "South Hempstead",
    "West Hempstead",
    "W Hempstead",
    "Uniondale",
    "East Meadow",
    "Hewlett",
    "Island Park",
    "Lawrence",
    "Locust Valley",
    "Long Beach",
    "E Atlantc Bch",
    "E Atlantic Beach",
    "East Atlantic Beach",
    "Lido Beach",
    "Lynbrook",
    "Malverne",
    "Merrick",
    "N Merrick",
    "North Merrick",
    "Old Westbury",
    "Westbury",
    "Point Lookout",
    "Rockville Centre",
    "Rockville Ctr",
    "Oceanside",
    "Roosevelt",
    "Roslyn",
    "Roslyn Heights",
    "Roslyn Hts",
    "Sea Cliff",
    "Valley Stream",
    "Williston Park",
    "E Williston",
    "East Williston",
    "Williston Pk",
    "Woodmere",
    "Arverne",
    "Broad Channel",
    "Rockaway Bch",
    "Rockaway Beach",
    "Rockaway Park",
    "Belle Harbor",
    "Neponsit",
    "Breezy Point",
    "Rockaway Point",
    "Rockaway Pt",
    "Amityville",
    "Amity Harbor",
    "Babylon",
    "Captree Is",
    "Captree Island",
    "Gilgo Beach",
    "Oak Beach",
    "Oak Island",
    "W Gilgo Beach",
    "West Gilgo Beach",
    "North Babylon",
    "West Babylon",
    "Bayport",
    "Bay Shore",
    "Fair Harbor",
    "Kismet",
    "Point O Woods",
    "Saltaire",
    "Bayville",
    "Bellmore",
    "N Bellmore",
    "North Bellmore",
    "Bellport",
    "Bethpage",
    "Blue Point",
    "Bohemia",
    "Brentwood",
    "Edgewood",
    "W Brentwood",
    "West Brentwood",
    "Brightwaters",
    "Brookhaven",
    "Centereach",
    "S Setauket",
    "South Setauket",
    "Centerport",
    "Central Islip",
    "Cold Spring Harbor",
    "Cold Spg Hbr",
    "Commack",
    "Copiague",
    "Coram",
    "Deer Park",
    "East Islip",
    "East Northport",
    "E Northport",
    "Elwood",
    "East Norwich",
    "East Setauket",
    "Setauket",
    "Farmingdale",
    "S Farmingdale",
    "South Farmingdale",
    "Farmingville",
    "Great River",
    "Greenlawn",
    "Holbrook",
    "Holtsville",
    "Huntington",
    "Halesite",
    "Lloyd Harbor",
    "Huntington Station",
    "Dix Hills",
    "Huntingtn Sta",
    "S Huntington",
    "South Huntington",
    "Melville",
    "Islandia",
    "Hauppauge",
    "Ronkonkoma",
    "Islip",
    "Islip Terrace",
    "Jericho",
    "Kings Park",
    "Lake Grove",
    "Levittown",
    "Lindenhurst",
    "Massapequa",
    "N Massapequa",
    "North Massapequa",
    "Massapequa Park",
    "Massapequa Pk",
    "Medford",
    "Miller Place",
    "Mill Neck",
    "Mount Sinai",
    "Nesconset",
    "Northport",
    "Fort Salonga",
    "Oakdale",
    "Ocean Beach",
    "Oyster Bay",
    "Patchogue",
    "Davis Park",
    "E Patchogue",
    "East Patchogue",
    "Port Jefferson Station",
    "Port Jeff Sta",
    "Port Jefferson",
    "Prt Jefferson",
    "Rocky Point",
    "Lake Ronkonkoma",
    "Lk Ronkonkoma",
    "Saint James",
    "Sayville",
    "Cherry Grove",
    "Fire Is Pines",
    "Fire Island Pines",
    "Seaford",
    "Selden",
    "Shoreham",
    "Smithtown",
    "Sound Beach",
    "Stony Brook",
    "Syosset",
    "Wading River",
    "Wantagh",
    "West Islip",
    "West Sayville",
    "Woodbury",
    "Wyandanch",
    "Wheatley Heights",
    "Wheatley Hts",
    "Hicksville",
    "Plainview",
    "Old Bethpage",
    "Riverhead",
    "Flanders",
    "Amagansett",
    "Aquebogue",
    "Bridgehampton",
    "Calverton",
    "Baiting Hollow",
    "Baiting Holw",
    "Center Moriches",
    "Ctr Moriches",
    "Cutchogue",
    "East Hampton",
    "East Marion",
    "East Moriches",
    "Eastport",
    "East Quogue",
    "Greenport",
    "Hampton Bays",
    "Jamesport",
    "Laurel",
    "Manorville",
    "Mastic",
    "Mastic Beach",
    "Mattituck",
    "Middle Island",
    "Montauk",
    "Moriches",
    "New Suffolk",
    "Orient",
    "Peconic",
    "Quogue",
    "Remsenburg",
    "Ridge",
    "Sagaponack",
    "Sag Harbor",
    "Shelter Island",
    "Shelter Is",
    "Shelter Island Heights",
    "Shelter Is Ht",
    "Shirley",
    "E Yaphank",
    "East Yaphank",
    "Smith Point",
    "Southampton",
    "South Jamesport",
    "S Jamesport",
    "Southold",
    "Speonk",
    "Upton",
    "Wainscott",
    "Water Mill",
    "Westhampton",
    "Westhampton Beach",
    "W Hampton Bch",
    "Yaphank",
    "Alcove",
    "Alplaus",
    "Altamont",
    "Amsterdam",
    "West Charlton",
    "Athens",
    "Austerlitz",
    "Averill Park",
    "Ballston Lake",
    "Burnt Hills",
    "Charlton",
    "Ballston Spa",
    "Malta",
    "Berlin",
    "Berne",
    "Brainard",
    "Broadalbin",
    "Buskirk",
    "Canaan",
    "Carlisle",
    "Caroga Lake",
    "Castleton On Hudson",
    "Brookview",
    "Castleton",
    "S Schodack",
    "South Schodack",
    "Central Bridge",
    "Central Brg",
    "Charlotteville",
    "Charlottevle",
    "Chatham",
    "Cherry Plain",
    "Clarksville",
    "Climax",
    "Cobleskill",
    "Lawyersville",
    "Coeymans",
    "Coeymans Hollow",
    "Coeymans Holw",
    "Cohoes",
    "Coxsackie",
    "Cropseyville",
    "Delanson",
    "Delmar",
    "Duanesburg",
    "Eagle Bridge",
    "White Creek",
    "Earlton",
    "East Berne",
    "East Chatham",
    "East Greenbush",
    "E Greenbush",
    "East Nassau",
    "East Schodack",
    "East Worcester",
    "E Worcester",
    "Clifton Park",
    "Halfmoon",
    "Esperance",
    "Feura Bush",
    "Fonda",
    "Fort Hunter",
    "Fort Johnson",
    "Fultonham",
    "Fultonville",
    "Galway",
    "Ghent",
    "Gilboa",
    "Glenmont",
    "Gloversville",
    "Grafton",
    "Greenville",
    "Norton Hill",
    "S Westerlo",
    "South Westerlo",
    "Guilderland",
    "Guilderland Center",
    "Guildrlnd Ctr",
    "Hagaman",
    "Hannacroix",
    "Hoosick Falls",
    "Howes Cave",
    "Jefferson",
    "Johnsonville",
    "Johnstown",
    "Kinderhook",
    "Lake Pleasant",
    "Latham",
    "Newtonville",
    "Malden Bridge",
    "Maryland",
    "Mayfield",
    "Mechanicville",
    "Medusa",
    "Melrose",
    "Middleburgh",
    "Nassau",
    "New Baltimore",
    "New Lebanon",
    "Lebanon Spg",
    "Lebanon Springs",
    "Niverville",
    "North Blenheim",
    "N Blenheim",
    "North Chatham",
    "Northville",
    "Old Chatham",
    "Pattersonville",
    "Pattersonvle",
    "Petersburg",
    "Petersburgh",
    "Taconic Lake",
    "Piseco",
    "Poestenkill",
    "Ravena",
    "Rensselaer",
    "Rensselaerville",
    "Rensselaervle",
    "Rexford",
    "Richmondville",
    "Rotterdam Junction",
    "Rotterdam Jct",
    "Round Lake",
    "Sand Lake",
    "Schaghticoke",
    "Schenevus",
    "Schodack Landing",
    "Schodack Lndg",
    "Schoharie",
    "Selkirk",
    "Slingerlands",
    "Sloansville",
    "South Bethlehem",
    "S Bethlehem",
    "Speculator",
    "Spencertown",
    "Sprakers",
    "Stamford",
    "Stephentown",
    "Stillwater",
    "Stottville",
    "Stuyvesant",
    "Stuyvesant Falls",
    "Stuyvesant Fl",
    "Summit",
    "Surprise",
    "Tribes Hill",
    "Troy",
    "Green Island",
    "Valatie",
    "Valley Falls",
    "Voorheesville",
    "Warnerville",
    "Waterford",
    "Watervliet",
    "Wells",
    "West Coxsackie",
    "W Coxsackie",
    "Westerlo",
    "West Fulton",
    "West Lebanon",
    "West Sand Lake",
    "W Sand Lake",
    "Worcester",
    "Wynantskill",
    "Albany",
    "Colonie",
    "Stuyvesant Plaza",
    "Stuyvsnt Plz",
    "Menands",
    "Roessleville",
    "Loudonville",
    "Siena",
    "Schenectady",
    "Glenville",
    "Scotia",
    "Rotterdam",
    "Niskayuna",
    "Kingston",
    "Eddyville",
    "Saint Remy",
    "Accord",
    "Acra",
    "Arkville",
    "Ashland",
    "Bearsville",
    "Shady",
    "Big Indian",
    "Oliverea",
    "Bloomington",
    "Boiceville",
    "Cairo",
    "Catskill",
    "Cementon",
    "Chichester",
    "Connelly",
    "Cornwallville",
    "Cottekill",
    "Cragsmoor",
    "Denver",
    "Durham",
    "East Durham",
    "East Jewett",
    "Tannersville",
    "Elka Park",
    "Ellenville",
    "Esopus",
    "Fleischmanns",
    "Halcott Center",
    "Halcott Ctr",
    "Freehold",
    "Glasco",
    "Glenford",
    "Grand Gorge",
    "Greenfield Park",
    "Greenfld Park",
    "Haines Falls",
    "Halcottsville",
    "Hensonville",
    "East Windham",
    "High Falls",
    "Highmount",
    "Hunter",
    "Hurley",
    "Jewett",
    "Kerhonkson",
    "Lake Hill",
    "Lake Katrine",
    "Lanesville",
    "Leeds",
    "Lexington",
    "Malden On Hudson",
    "Malden Hudson",
    "Maplecrest",
    "Margaretville",
    "Mount Marion",
    "Mount Tremper",
    "Napanoch",
    "New Kingston",
    "Oak Hill",
    "Olivebridge",
    "Krumville",
    "Palenville",
    "Phoenicia",
    "Pine Hill",
    "Port Ewen",
    "Prattsville",
    "Preston Hollow",
    "Preston Holw",
    "Purling",
    "Rifton",
    "Rosendale",
    "Round Top",
    "Roxbury",
    "Ruby",
    "Saugerties",
    "Shandaken",
    "Shokan",
    "South Cairo",
    "Spring Glen",
    "Stone Ridge",
    "Tillson",
    "Ulster Park",
    "Wawarsing",
    "West Camp",
    "West Hurley",
    "West Kill",
    "West Park",
    "West Shokan",
    "Willow",
    "Windham",
    "Woodstock",
    "Amenia",
    "Ancram",
    "Ancramdale",
    "Annandale On Hudson",
    "Annandale",
    "Red Hook",
    "Barrytown",
    "Beacon",
    "Chelsea",
    "Claverack",
    "Clinton Corners",
    "Clinton Cors",
    "Clintondale",
    "Copake",
    "Copake Falls",
    "Cornwall",
    "Cornwall On Hudson",
    "Cornwall Hdsn",
    "Craryville",
    "Taghkanic",
    "Dover Plains",
    "Elizaville",
    "Fishkill",
    "Gardiner",
    "Germantown",
    "Glenham",
    "Highland",
    "Hillsdale",
    "Hollowville",
    "Holmes",
    "Hopewell Junction",
    "East Fishkill",
    "Hopewell",
    "Hopewell Jct",
    "Wiccopee",
    "Hudson",
    "Hyde Park",
    "Lagrangeville",
    "Marlboro",
    "Maybrook",
    "Mellenville",
    "Millbrook",
    "Millerton",
    "Milton",
    "Modena",
    "Montgomery",
    "Newburgh",
    "New Windsor",
    "New Paltz",
    "Patterson",
    "Pawling",
    "Philmont",
    "Pine Bush",
    "Pine Plains",
    "Pleasant Valley",
    "Pleasant Vly",
    "Poughquag",
    "Milan",
    "Rhinebeck",
    "Rhinecliff",
    "Rock Tavern",
    "Salisbury Mills",
    "Salisbury Mls",
    "Salt Point",
    "Staatsburg",
    "Stanfordville",
    "Stormville",
    "Tivoli",
    "Verbank",
    "Walden",
    "Wallkill",
    "Wappingers Falls",
    "New Hamburg",
    "Wappingers Fl",
    "West Fishkill",
    "Wassaic",
    "Wingdale",
    "Poughkeepsie",
    "Arlington",
    "Monticello",
    "Barryville",
    "Bethel",
    "Bloomingburg",
    "Burlingham",
    "Callicoon",
    "Callicoon Center",
    "Callicoon Ctr",
    "Claryville",
    "Cochecton",
    "Cuddebackville",
    "Cuddebackvlle",
    "Godeffroy",
    "Eldred",
    "Fallsburg",
    "Ferndale",
    "Fremont Center",
    "Fremont Ctr",
    "Glen Spey",
    "Glen Wild",
    "Grahamsville",
    "Sundown",
    "Hankins",
    "Harris",
    "Highland Lake",
    "Hortonville",
    "Huguenot",
    "Hurleyville",
    "Jeffersonville",
    "Jeffersonvlle",
    "Kauneonga Lake",
    "Kauneonga Lk",
    "Kenoza Lake",
    "Kiamesha Lake",
    "Lake Huntington",
    "Lk Huntington",
    "Liberty",
    "Livingston Manor",
    "Lew Beach",
    "Livingstn Mnr",
    "Loch Sheldrake",
    "Loch Sheldrke",
    "Long Eddy",
    "Mongaup Valley",
    "Mongaup Vly",
    "Mountain Dale",
    "Narrowsburg",
    "Neversink",
    "North Branch",
    "Obernburg",
    "Parksville",
    "Phillipsport",
    "Pond Eddy",
    "Port Jervis",
    "Rock Hill",
    "Roscoe",
    "Forestburgh",
    "Smallwood",
    "South Fallsburg",
    "S Fallsburg",
    "Sparrow Bush",
    "Sparrowbush",
    "Summitville",
    "Swan Lake",
    "Thompsonville",
    "Westbrookville",
    "Westbrookvlle",
    "White Lake",
    "White Sulphur Springs",
    "Wht Sphr Spgs",
    "Woodbourne",
    "Woodridge",
    "Wurtsboro",
    "Youngsville",
    "Yulan",
    "Glens Falls",
    "Queensbury",
    "South Glens Falls",
    "S Glens Falls",
    "Adirondack",
    "Argyle",
    "Athol",
    "Bakers Mills",
    "Blue Mountain Lake",
    "Blue Mtn Lake",
    "Bolton Landing",
    "Bolton Lndg",
    "Brant Lake",
    "Cambridge",
    "Chestertown",
    "Clemons",
    "Cleverdale",
    "Comstock",
    "Corinth",
    "Cossayuna",
    "Diamond Point",
    "Fort Ann",
    "Fort Edward",
    "Gansevoort",
    "Wilton",
    "Granville",
    "Greenfield Center",
    "Greenfld Ctr",
    "Greenwich",
    "Thomson",
    "Hadley",
    "Hague",
    "Hampton",
    "Hartford",
    "Hudson Falls",
    "Huletts Landing",
    "Huletts Lndg",
    "Indian Lake",
    "Johnsburg",
    "Kattskill Bay",
    "Pilot Knob",
    "Lake George",
    "Lake Luzerne",
    "Long Lake",
    "Middle Granville",
    "Mdl Granville",
    "Middle Grove",
    "Minerva",
    "Newcomb",
    "North Creek",
    "North Granville",
    "N Granville",
    "North Hudson",
    "North River",
    "Olmstedville",
    "Paradox",
    "Ticonderoga",
    "Porter Corners",
    "Porter Cors",
    "Pottersville",
    "Putnam Station",
    "Putnam Sta",
    "Riparius",
    "Rock City Falls",
    "Rock City Fls",
    "Sabael",
    "Salem",
    "E Greenwich",
    "East Greenwich",
    "Saratoga Springs",
    "Saratoga Spgs",
    "Schroon Lake",
    "Schuylerville",
    "Severance",
    "Shushan",
    "Silver Bay",
    "Stony Creek",
    "Victory Mills",
    "Warrensburg",
    "Thurman",
    "Wevertown",
    "Whitehall",
    "Plattsburgh",
    "Altona",
    "Keeseville",
    "Au Sable Chasm",
    "Ausable Chasm",
    "Au Sable Forks",
    "Au Sable Frks",
    "Bloomingdale",
    "Bombay",
    "Brainardsville",
    "Brainardsvle",
    "Brushton",
    "Burke",
    "Cadyville",
    "Champlain",
    "Chateaugay",
    "Chazy",
    "Childwold",
    "Churubusco",
    "Clintonville",
    "Constable",
    "Cranberry Lake",
    "Cranberry Lk",
    "Crown Point",
    "Dannemora",
    "Dickinson Center",
    "Dickinson Ctr",
    "Elizabethtown",
    "Ellenburg",
    "Ellenburg Center",
    "Ellenburg Ctr",
    "Ellenburg Depot",
    "Ellenburg Dep",
    "Essex",
    "Whallonsburg",
    "Fort Covington",
    "Ft Covington",
    "Gabriels",
    "Jay",
    "Keene",
    "Keene Valley",
    "Saint Huberts",
    "Lake Clear",
    "Upper Saint Regis",
    "Upper St Reg",
    "Lake Placid",
    "Lewis",
    "Lyon Mountain",
    "Malone",
    "Merrill",
    "Mineville",
    "Moira",
    "Mooers",
    "Mooers Forks",
    "Moriah",
    "Moriah Center",
    "Morrisonville",
    "New Russia",
    "Nicholville",
    "Fort Jackson",
    "Hopkinton",
    "North Bangor",
    "Bangor",
    "West Bangor",
    "North Lawrence",
    "N Lawrence",
    "Owls Head",
    "Paul Smiths",
    "Peru",
    "Piercefield",
    "Port Henry",
    "Port Kent",
    "Rainbow Lake",
    "Ray Brook",
    "Redford",
    "Rouses Point",
    "Saint Regis Falls",
    "St Regis Fls",
    "Saranac",
    "Saranac Lake",
    "Schuyler Falls",
    "Schuyler Fls",
    "Tupper Lake",
    "Massawepie",
    "Upper Jay",
    "Vermontville",
    "Loon Lake",
    "Onchiota",
    "West Chazy",
    "Westport",
    "Wadhams",
    "Willsboro",
    "Wilmington",
    "Whiteface Mountain",
    "Whiteface Mtn",
    "Witherbee",
    "Apulia Station",
    "Apulia Sta",
    "Auburn",
    "Owasco",
    "Sennett",
    "Aurora",
    "Baldwinsville",
    "Lysander",
    "Bernhards Bay",
    "Brewerton",
    "Bridgeport",
    "Camillus",
    "Canastota",
    "Perryville",
    "Cato",
    "Cayuga",
    "Cazenovia",
    "Central Square",
    "Central Sq",
    "Chittenango",
    "Cicero",
    "Clay",
    "Cincinnatus",
    "East Freetown",
    "Cleveland",
    "Constantia",
    "Cortland",
    "Delphi Falls",
    "De Ruyter",
    "Dryden",
    "Durhamville",
    "East Syracuse",
    "Elbridge",
    "Erieville",
    "Etna",
    "Fabius",
    "Fayette",
    "Fayetteville",
    "Freeville",
    "Fulton",
    "Genoa",
    "Georgetown",
    "Groton",
    "Hannibal",
    "Hastings",
    "Homer",
    "Jamesville",
    "Jordan",
    "King Ferry",
    "Kirkville",
    "Lacona",
    "La Fayette",
    "Little York",
    "Liverpool",
    "Bayberry",
    "Locke",
    "McGraw",
    "McLean",
    "Mallory",
    "Manlius",
    "Marcellus",
    "Marietta",
    "Martville",
    "Memphis",
    "Meridian",
    "Mexico",
    "Minetto",
    "Minoa",
    "Montezuma",
    "Moravia",
    "Mottville",
    "Nedrow",
    "New Haven",
    "New Woodstock",
    "North Bay",
    "North Pitcher",
    "Oswego",
    "Parish",
    "Pennellville",
    "Peterboro",
    "Phoenix",
    "Pitcher",
    "Pompey",
    "Port Byron",
    "Preble",
    "Pulaski",
    "Red Creek",
    "Richland",
    "Sandy Creek",
    "Savannah",
    "Scipio Center",
    "Venice Center",
    "Seneca Falls",
    "Skaneateles",
    "Skaneateles Falls",
    "Skan Falls",
    "South Butler",
    "South Otselic",
    "Sterling",
    "Sylvan Beach",
    "Truxton",
    "Cuyler",
    "East Homer",
    "Tully",
    "Union Springs",
    "Verona Beach",
    "Wampsville",
    "Warners",
    "Waterloo",
    "Weedsport",
    "West Monroe",
    "Syracuse",
    "Solvay",
    "Mattydale",
    "N Syracuse",
    "North Syracuse",
    "De Witt",
    "Alder Creek",
    "Altmar",
    "Ava",
    "Barneveld",
    "Beaver Falls",
    "Beaver Fls",
    "Blossvale",
    "Boonville",
    "Bouckville",
    "Brantingham",
    "Glenfield",
    "Bridgewater",
    "Brookfield",
    "Burlington Flats",
    "Burlngtn Flt",
    "Camden",
    "Canajoharie",
    "Ames",
    "Cassville",
    "Chadwicks",
    "Cherry Valley",
    "Clark Mills",
    "Clayville",
    "Clinton",
    "Cold Brook",
    "Ohio",
    "Constableville",
    "Constablevle",
    "Cooperstown",
    "Hartwick Seminary",
    "Hrtwk Seminry",
    "Croghan",
    "Deansboro",
    "Dolgeville",
    "Eagle Bay",
    "Earlville",
    "Lebanon",
    "Poolville",
    "East Springfield",
    "E Springfield",
    "Eaton",
    "Edmeston",
    "Fly Creek",
    "Forestport",
    "Fort Plain",
    "Frankfort",
    "Schuyler",
    "Garrattsville",
    "Greig",
    "Hamilton",
    "Hartwick",
    "Herkimer",
    "Hinckley",
    "Hoffmeister",
    "Holland Patent",
    "Holland Patnt",
    "Hubbardsville",
    "Ilion",
    "Inlet",
    "Jordanville",
    "Lee Center",
    "Leonardsville",
    "Little Falls",
    "Lowville",
    "Beaver River",
    "Lyons Falls",
    "Madison",
    "Marcy",
    "Martinsburg",
    "Middleville",
    "Mohawk",
    "Morrisville",
    "Munnsville",
    "Pratts Hollow",
    "Nelliston",
    "New Berlin",
    "S Edmeston",
    "South Edmeston",
    "New Hartford",
    "New Lisbon",
    "Newport",
    "New York Mills",
    "New York Mls",
    "North Brookfield",
    "N Brookfield",
    "Old Forge",
    "Oneida",
    "Oriskany",
    "Oriskany Falls",
    "Oriskany Fls",
    "Palatine Bridge",
    "Palatine Brg",
    "Poland",
    "Port Leyden",
    "Prospect",
    "Raquette Lake",
    "Redfield",
    "Remsen",
    "Richfield Springs",
    "Richfld Spgs",
    "Rome",
    "Roseboom",
    "Saint Johnsville",
    "St Johnsville",
    "Salisbury Center",
    "Salisbury Ctr",
    "Sangerfield",
    "Sauquoit",
    "Paris",
    "Schuyler Lake",
    "Sharon Springs",
    "Sharon Spgs",
    "Sherburne",
    "Sherrill",
    "Smyrna",
    "Springfield Center",
    "Springfld Ctr",
    "Stittville",
    "Stratford",
    "Taberg",
    "Thendara",
    "Turin",
    "Van Hornesville",
    "Van Hornesvle",
    "Vernon",
    "Vernon Center",
    "Verona",
    "Waterville",
    "West Burlington",
    "W Burlington",
    "Westdale",
    "West Eaton",
    "West Edmeston",
    "Westernville",
    "Westford",
    "West Leyden",
    "Westmoreland",
    "West Winfield",
    "West Exeter",
    "Whitesboro",
    "Williamstown",
    "Woodgate",
    "Yorkville",
    "Utica",
    "Deerfield",
    "Watertown",
    "Glen Park",
    "Fort Drum",
    "Adams",
    "Smithville",
    "Adams Center",
    "Alexandria Bay",
    "Alex Bay",
    "Point Vivian",
    "Antwerp",
    "Belleville",
    "Black River",
    "Brasher Falls",
    "Brier Hill",
    "Brownville",
    "Calcium",
    "Canton",
    "Cape Vincent",
    "Carthage",
    "Castorland",
    "Chase Mills",
    "Chaumont",
    "Chippewa Bay",
    "Clayton",
    "Frontenac",
    "Grenell",
    "Murray Isle",
    "Colton",
    "Copenhagen",
    "Barnes Corners",
    "Barnes Cors",
    "South Rutland",
    "Deferiet",
    "De Kalb Junction",
    "De Kalb Jct",
    "Depauville",
    "De Peyster",
    "Dexter",
    "Edwards",
    "Ellisburg",
    "Evans Mills",
    "Felts Mills",
    "Fine",
    "Wellesley Island",
    "Fineview",
    "Wellesley Is",
    "Fishers Landing",
    "Fishers Lndg",
    "Gouverneur",
    "Balmat",
    "Great Bend",
    "Hailesboro",
    "Hammond",
    "Hannawa Falls",
    "Harrisville",
    "Helena",
    "Henderson",
    "Woodville",
    "Henderson Harbor",
    "Henderson Hbr",
    "Hermon",
    "Heuvelton",
    "Hogansburg",
    "Akwesasne",
    "La Fargeville",
    "Lisbon",
    "Lorraine",
    "Madrid",
    "Mannsville",
    "Massena",
    "Morristown",
    "Natural Bridge",
    "Natural Brg",
    "Newton Falls",
    "Norfolk",
    "Norwood",
    "Ogdensburg",
    "Oswegatchie",
    "Parishville",
    "Philadelphia",
    "Pierrepont Manor",
    "Pierrepnt Mnr",
    "Plessis",
    "Potsdam",
    "Raymondville",
    "Redwood",
    "Rensselaer Falls",
    "Rensslaer Fls",
    "Richville",
    "Rodman",
    "Rooseveltown",
    "Russell",
    "Degrasse",
    "Sackets Harbor",
    "Sackets Hbr",
    "South Colton",
    "Star Lake",
    "Theresa",
    "Thousand Island Park",
    "Thous Is Pk",
    "Thousnd Is Pk",
    "Three Mile Bay",
    "Three Mle Bay",
    "Waddington",
    "Wanakena",
    "West Stockholm",
    "W Stockholm",
    "Winthrop",
    "Afton",
    "Andes",
    "Apalachin",
    "Bainbridge",
    "Barton",
    "Berkshire",
    "Blodgett Mills",
    "Blodgett Mls",
    "Bloomville",
    "Bovina Center",
    "Candor",
    "Castle Creek",
    "Chenango Forks",
    "Chenango Fks",
    "Colliersville",
    "Conklin",
    "Davenport",
    "Davenport Center",
    "Davenport Ctr",
    "Delancey",
    "Delhi",
    "Meredith",
    "Deposit",
    "Downsville",
    "Shinhopple",
    "East Branch",
    "East Meredith",
    "Endicott",
    "Endwell",
    "Fishs Eddy",
    "Franklin",
    "Gilbertsville",
    "Glen Aubrey",
    "Greene",
    "Guilford",
    "Hamden",
    "Hancock",
    "Cadosia",
    "Harford",
    "Harpersfield",
    "Harpursville",
    "Hobart",
    "Johnson City",
    "Kirkwood",
    "Laurens",
    "Lisle",
    "McDonough",
    "Maine",
    "Marathon",
    "Masonville",
    "Meridale",
    "Milford",
    "Morris",
    "Mount Upton",
    "Mount Vision",
    "Newark Valley",
    "Nichols",
    "Nineveh",
    "North Norwich",
    "Norwich",
    "Oneonta",
    "Otego",
    "Ouaquaga",
    "Owego",
    "Oxford",
    "Brisben",
    "Plymouth",
    "Port Crane",
    "Sanitaria Spg",
    "Sanitaria Springs",
    "Portlandville",
    "Richford",
    "Harford Mills",
    "Sidney",
    "Sidney Center",
    "Smithville Flats",
    "Smithvle Flts",
    "South Kortright",
    "S Kortright",
    "South New Berlin",
    "S New Berlin",
    "South Plymouth",
    "So Plymouth",
    "Treadwell",
    "Trout Creek",
    "Unadilla",
    "Vestal",
    "Walton",
    "Wells Bridge",
    "West Davenport",
    "W Davenport",
    "West Oneonta",
    "Whitney Point",
    "Willet",
    "Willseyville",
    "Windsor",
    "W Windsor",
    "West Windsor",
    "Binghamton",
    "Akron",
    "Alden",
    "Alexander",
    "Angola",
    "Appleton",
    "Arcade",
    "Attica",
    "Barker",
    "Basom",
    "Alabama",
    "Batavia",
    "Bliss",
    "Boston",
    "Bowmansville",
    "Brant",
    "Burt",
    "Centerville",
    "Chaffee",
    "Clarence",
    "Clarence Center",
    "Clarence Ctr",
    "Colden",
    "Collins",
    "Collins Center",
    "Collins Ctr",
    "Corfu",
    "Cowlesville",
    "Dale",
    "Darien Center",
    "Dayton",
    "Delevan",
    "Depew",
    "Derby",
    "Dunkirk",
    "Van Buren Bay",
    "East Amherst",
    "Swormville",
    "East Aurora",
    "East Bethany",
    "East Concord",
    "Concord",
    "East Pembroke",
    "Eden",
    "Elba",
    "Elma",
    "Farmersville Station",
    "Farmersvl Sta",
    "Farnham",
    "Forestville",
    "Fredonia",
    "Freedom",
    "Sandusky",
    "Gainesville",
    "Gasport",
    "Getzville",
    "Amherst",
    "Glenwood",
    "Gowanda",
    "Grand Island",
    "Hamburg",
    "Holland",
    "Irving",
    "Java Center",
    "Java Village",
    "Lake View",
    "Lancaster",
    "Lawtons",
    "Lewiston",
    "Stela Niagara",
    "Stella Niagara",
    "Lockport",
    "Lyndonville",
    "Machias",
    "Marilla",
    "Medina",
    "Middleport",
    "Newfane",
    "Niagara University",
    "Niagara Univ",
    "North Collins",
    "North Evans",
    "North Java",
    "North Tonawanda",
    "N Tonawanda",
    "Oakfield",
    "Olcott",
    "Orchard Park",
    "Perrysburg",
    "Pike",
    "Ransomville",
    "Sanborn",
    "Sardinia",
    "Sheridan",
    "Silver Creek",
    "South Dayton",
    "South Wales",
    "Springville",
    "Stafford",
    "Strykersville",
    "Tonawanda",
    "Van Buren Point",
    "Van Buren Pt",
    "Varysburg",
    "Versailles",
    "Wales Center",
    "West Falls",
    "West Valley",
    "Wilson",
    "Yorkshire",
    "Youngstown",
    "Buffalo",
    "Cheektowaga",
    "West Seneca",
    "Sloan",
    "Snyder",
    "Kenmore",
    "Tn Of Tona",
    "Town Of Tonawanda",
    "Lackawanna",
    "Blasdell",
    "Williamsville",
    "Eggertsville",
    "S Cheek",
    "South Cheektowaga",
    "W Amherst",
    "West Amherst",
    "Niagara Falls",
    "Albion",
    "Eagle Harbor",
    "Alton",
    "Avon",
    "Bellona",
    "Bergen",
    "Branchport",
    "Brockport",
    "Byron",
    "Caledonia",
    "Canandaigua",
    "Farmington",
    "Castile",
    "Churchville",
    "Clifton",
    "Clifton Springs",
    "Clifton Spgs",
    "Clyde",
    "Conesus",
    "Dansville",
    "Dresden",
    "East Rochester",
    "E Rochester",
    "Fairport",
    "Fishers",
    "Geneseo",
    "Geneva",
    "Groveland",
    "Hall",
    "Hamlin",
    "Hemlock",
    "Henrietta",
    "Hilton",
    "Bloomfield",
    "Holley",
    "Hulberton",
    "Honeoye",
    "Honeoye Falls",
    "Ionia",
    "Kendall",
    "Kent",
    "Keuka Park",
    "Bluff Point",
    "Knowlesville",
    "Lakeville",
    "Leicester",
    "Le Roy",
    "Lima",
    "Linwood",
    "Livonia",
    "Lyons",
    "Macedon",
    "Manchester",
    "Marion",
    "Mendon",
    "Middlesex",
    "Mount Morris",
    "Tuscarora",
    "Mumford",
    "Naples",
    "Newark",
    "East Palmyra",
    "North Chili",
    "North Greece",
    "North Rose",
    "Nunda",
    "Ontario",
    "Ovid",
    "Hayt Corners",
    "Palmyra",
    "Pavilion",
    "Penfield",
    "Penn Yan",
    "Perkinsville",
    "Perry",
    "Phelps",
    "Piffard",
    "Wadsworth",
    "Pittsford",
    "Portageville",
    "Rossburg",
    "Port Gibson",
    "Retsof",
    "Romulus",
    "Mac Dougall",
    "Rose",
    "Rush",
    "Industry",
    "West Rush",
    "Rushville",
    "Scottsburg",
    "Scottsville",
    "Shortsville",
    "Silver Lake",
    "Silver Springs",
    "Rock Glen",
    "Silver Spgs",
    "Sodus",
    "Sodus Center",
    "Sodus Point",
    "Sonyea",
    "South Byron",
    "Spencerport",
    "Springwater",
    "Webster Crossing",
    "Webster Xing",
    "Stanley",
    "Victor",
    "Walworth",
    "Warsaw",
    "Waterport",
    "Wayland",
    "Webster",
    "West Bloomfield",
    "W Bloomfield",
    "West Henrietta",
    "W Henrietta",
    "Willard",
    "Williamson",
    "Wolcott",
    "Wyoming",
    "York",
    "Rochester",
    "Gates",
    "Irondequoit",
    "Brighton",
    "Greece",
    "Loehmanns Plaza",
    "Loehmanns Plz",
    "Westgate",
    "Panorama",
    "Ridgemont",
    "Jamestown",
    "Fluvanna",
    "West Ellicott",
    "Allegany",
    "Allentown",
    "Alma",
    "Angelica",
    "Ashville",
    "Belfast",
    "Bemus Point",
    "Black Creek",
    "Bolivar",
    "Brocton",
    "Caneadea",
    "Cassadaga",
    "Cattaraugus",
    "Celoron",
    "Ceres",
    "Chautauqua",
    "Cherry Creek",
    "Clymer",
    "Conewango Valley",
    "Conewango Vly",
    "Cuba",
    "Dewittville",
    "East Otto",
    "Ellicottville",
    "Ellington",
    "Falconer",
    "Fillmore",
    "Findley Lake",
    "Franklinville",
    "Frewsburg",
    "Friendship",
    "Gerry",
    "Great Valley",
    "Greenhurst",
    "Hinsdale",
    "Ischua",
    "Houghton",
    "Kennedy",
    "Kill Buck",
    "Lakewood",
    "Lily Dale",
    "Limestone",
    "Little Genesee",
    "Little Genese",
    "Little Valley",
    "Maple Springs",
    "Mayville",
    "Olean",
    "Knapp Creek",
    "Panama",
    "Portland",
    "Portville",
    "Randolph",
    "Richburg",
    "Ripley",
    "Rushford",
    "Saint Bonaventure",
    "St Bonas",
    "Salamanca",
    "Sherman",
    "Sinclairville",
    "Steamburg",
    "Stockton",
    "Stow",
    "Westfield",
    "Westons Mills",
    "Addison",
    "Alfred",
    "Alfred Station",
    "Alfred Sta",
    "Almond",
    "Alpine",
    "Andover",
    "Arkport",
    "Atlanta",
    "N Cohocton",
    "North Cohocton",
    "Avoca",
    "Wallace",
    "Bath",
    "Veterans Administration",
    "Veterans Admn",
    "Beaver Dams",
    "Belmont",
    "Big Flats",
    "Bradford",
    "Breesport",
    "Brooktondale",
    "Burdett",
    "Cameron",
    "Cameron Mills",
    "Campbell",
    "Canaseraga",
    "Canisteo",
    "Cayuta",
    "Chemung",
    "Cohocton",
    "Coopers Plains",
    "Coopers Plns",
    "Corning",
    "South Corning",
    "Dalton",
    "Dundee",
    "Erin",
    "Greenwood",
    "Hammondsport",
    "Hector",
    "Valois",
    "Himrod",
    "Hornell",
    "North Hornell",
    "Horseheads",
    "Hunt",
    "Interlaken",
    "Ithaca",
    "Jacksonville",
    "Jasper",
    "Kanona",
    "Lindley",
    "Lockwood",
    "Lodi",
    "Lowman",
    "Millport",
    "Montour Falls",
    "Newfield",
    "Odessa",
    "Painted Post",
    "Pine City",
    "Pine Valley",
    "Prattsburgh",
    "Pulteney",
    "Rexville",
    "Rock Stream",
    "Savona",
    "Scio",
    "Slaterville Springs",
    "Slatervle Spg",
    "Lansing",
    "Spencer",
    "West Danby",
    "Swain",
    "Troupsburg",
    "Trumansburg",
    "Van Etten",
    "Watkins Glen",
    "Waverly",
    "Wayne",
    "Wellsburg",
    "Wellsville",
    "Whitesville",
    "Woodhull",
    "Elmira",
    "Elmira Heights",
    "Elmira Hgts",
    "Elmira Hts",
  ],
  OH: [
    "Alexandria",
    "Amlin",
    "Ashley",
    "Blacklick",
    "Bladensburg",
    "Brinkhaven",
    "Broadway",
    "Buckeye Lake",
    "Cable",
    "Catawba",
    "Centerburg",
    "Croton",
    "Danville",
    "Delaware",
    "Dublin",
    "Etna",
    "Fredericktown",
    "Galena",
    "Gambier",
    "Granville",
    "Hebron",
    "Hilliard",
    "Homer",
    "Howard",
    "Irwin",
    "Jacksontown",
    "Johnstown",
    "Kilbourne",
    "Kirkersville",
    "Lewis Center",
    "Magnetic Springs",
    "Magnetic Spgs",
    "Martinsburg",
    "Marysville",
    "Mechanicsburg",
    "Milford Center",
    "Milford Ctr",
    "Millersport",
    "Mingo",
    "Mount Vernon",
    "New Albany",
    "Newark",
    "Hanover",
    "Heath",
    "North Lewisburg",
    "N Lewisburg",
    "Ostrander",
    "Pataskala",
    "Plain City",
    "Powell",
    "Shawnee Hills",
    "Radnor",
    "Raymond",
    "Reynoldsburg",
    "Rosewood",
    "Saint Louisville",
    "Saint Louisvl",
    "St Louisville",
    "Saint Paris",
    "Sunbury",
    "Thornville",
    "Unionville Center",
    "Unionvlle Ctr",
    "Urbana",
    "Utica",
    "Westerville",
    "Columbus",
    "Harlem Township",
    "Harlem Twp",
    "Woodstock",
    "Worthington",
    "Adelphi",
    "Amanda",
    "Ashville",
    "S Bloomfield",
    "South Bloomfield",
    "Baltimore",
    "Bloomingburg",
    "Bremen",
    "Hideaway Hls",
    "Brice",
    "Canal Winchester",
    "Canal Whchstr",
    "Canal Wnchstr",
    "Carbon Hill",
    "Carroll",
    "Circleville",
    "Clarksburg",
    "Commercial Point",
    "Commercial Pt",
    "Derby",
    "Galloway",
    "Grove City",
    "Darbydale",
    "Urbancrest",
    "Groveport",
    "Harrisburg",
    "Haydenville",
    "Jeffersonville",
    "Jeffersonvlle",
    "Lancaster",
    "Laurelville",
    "Lithopolis",
    "Lockbourne",
    "Logan",
    "London",
    "Summerford",
    "Milledgeville",
    "Mount Sterling",
    "Mt Sterling",
    "Murray City",
    "New Holland",
    "Orient",
    "Darbyville",
    "Pleasant Corners",
    "Pleasant Cors",
    "Pickerington",
    "Pleasantville",
    "Rockbridge",
    "Rushville",
    "W Rushville",
    "West Rushville",
    "Sedalia",
    "South Bloomingville",
    "S Bloomingvil",
    "S Bloomingville",
    "South Solon",
    "Stoutsville",
    "Sugar Grove",
    "Tarlton",
    "Thurston",
    "Union Furnace",
    "Washington Court House",
    "Wshngtn Ct Hs",
    "West Jefferson",
    "W Jefferson",
    "Williamsport",
    "Obetz",
    "Bexley",
    "Grandview",
    "Grandview Heights",
    "Marble Cliff",
    "Upper Arlington",
    "Upper Arlngtn",
    "Whitehall",
    "New Rome",
    "Gahanna",
    "Marion",
    "Belle Center",
    "Bellefontaine",
    "Caledonia",
    "Cardington",
    "Carey",
    "Adrian",
    "Chesterville",
    "De Graff",
    "East Liberty",
    "Edison",
    "Fulton",
    "Green Camp",
    "Harpster",
    "Huntsville",
    "Iberia",
    "Kenton",
    "Kirby",
    "Lakeview",
    "La Rue",
    "Lewistown",
    "Marengo",
    "Middleburg",
    "Morral",
    "Mount Gilead",
    "Mount Victory",
    "New Bloomington",
    "New Bloomngtn",
    "Prospect",
    "Quincy",
    "Richwood",
    "Ridgeway",
    "Roundhead",
    "Rushsylvania",
    "Russells Point",
    "Russells Pt",
    "Sparta",
    "Upper Sandusky",
    "Upper Sandsky",
    "Waldo",
    "West Liberty",
    "West Mansfield",
    "W Mansfield",
    "Wharton",
    "Zanesfield",
    "Bowling Green",
    "Bradner",
    "Burgoon",
    "Clay Center",
    "Clyde",
    "Curtice",
    "Cygnet",
    "Dunbridge",
    "Elmore",
    "Fremont",
    "Genoa",
    "Gibsonburg",
    "Graytown",
    "Elliston",
    "Gypsum",
    "Harbor View",
    "Helena",
    "Millersville",
    "Isle Saint George",
    "Is St George",
    "Jerry City",
    "Kelleys Island",
    "Kelleys Is",
    "Lacarne",
    "Lakeside Marblehead",
    "Lakeside",
    "Lksid Marblhd",
    "Marblehead",
    "Lindsey",
    "Luckey",
    "Martin",
    "Bono",
    "Middle Bass",
    "Millbury",
    "Oak Harbor",
    "Pemberville",
    "Portage",
    "Port Clinton",
    "Put In Bay",
    "Risingsun",
    "Rocky Ridge",
    "Rossford",
    "Rudolph",
    "Stony Ridge",
    "Vickery",
    "Walbridge",
    "Wayne",
    "West Millgrove",
    "W Millgrove",
    "Williston",
    "Woodville",
    "Alvordton",
    "Archbold",
    "Berkey",
    "Blakeslee",
    "Bryan",
    "Colton",
    "Custar",
    "Defiance",
    "Delta",
    "Deshler",
    "Edgerton",
    "Edon",
    "Evansport",
    "Stryker",
    "Farmer",
    "Fayette",
    "Grand Rapids",
    "Grelton",
    "Mc Clure",
    "Hamler",
    "Haskins",
    "Hicksville",
    "Holgate",
    "Holland",
    "Hoytville",
    "Jewell",
    "Kunkle",
    "Liberty Center",
    "Liberty Ctr",
    "Lyons",
    "McClure",
    "Malinta",
    "Mark Center",
    "Maumee",
    "Metamora",
    "Milton Center",
    "Monclova",
    "Montpelier",
    "Holiday City",
    "Napoleon",
    "Florida",
    "Okolona",
    "Neapolis",
    "New Bavaria",
    "Ney",
    "Perrysburg",
    "Pettisville",
    "Pioneer",
    "Ridgeville Corners",
    "Rdgville Cors",
    "Sherwood",
    "Swanton",
    "Sylvania",
    "Tontogany",
    "Waterville",
    "Wauseon",
    "Weston",
    "West Unity",
    "Whitehouse",
    "Toledo",
    "Northwood",
    "Oregon",
    "Ottawa Hills",
    "Sylvania Township",
    "Sylvania Twp",
    "Zanesville",
    "S Zanesville",
    "Sonora",
    "South Zanesville",
    "Ava",
    "Barnesville",
    "Somerton",
    "Beallsville",
    "Belle Valley",
    "Belmont",
    "Bethesda",
    "Blue Rock",
    "Brownsville",
    "Buffalo",
    "Byesville",
    "Caldwell",
    "Cambridge",
    "Claysville",
    "Chandlersville",
    "Chandlersvlle",
    "Chesterhill",
    "Corning",
    "Hemlock",
    "Rendville",
    "Crooksville",
    "Cumberland",
    "Derwent",
    "Duncan Falls",
    "East Fultonham",
    "E Fultonham",
    "Fairview",
    "Quaker City",
    "Fultonham",
    "Glenford",
    "Gratiot",
    "Hopewell",
    "Jerusalem",
    "Junction City",
    "Kimbolton",
    "Guernsey",
    "Kipling",
    "Lewisville",
    "Sycamore Valley",
    "Sycamore Vly",
    "Lore City",
    "Mcconnelsville",
    "Mcconnelsvle",
    "Malta",
    "Morristown",
    "Mount Perry",
    "Moxahala",
    "New Concord",
    "New Lexington",
    "New Straitsville",
    "New Straitsvl",
    "Norwich",
    "Old Washington",
    "Old Washingtn",
    "Philo",
    "Pleasant City",
    "Roseville",
    "Salesville",
    "Sarahsville",
    "Senecaville",
    "Shawnee",
    "Somerset",
    "Stafford",
    "Stockport",
    "Pennsville",
    "Summerfield",
    "White Cottage",
    "Woodsfield",
    "Antioch",
    "Adamsville",
    "Baltic",
    "Bucks",
    "Farmerstown",
    "Mechanic",
    "Blissfield",
    "Conesville",
    "Coshocton",
    "Dresden",
    "Adams Mills",
    "Frazeysburg",
    "Fresno",
    "New Bedford",
    "Nashport",
    "Newcomerstown",
    "Plainfield",
    "Port Washington",
    "Prt Washingtn",
    "Stone Creek",
    "Trinway",
    "Walhonding",
    "Warsaw",
    "West Lafayette",
    "W Lafayette",
    "Adena",
    "Alledonia",
    "Amsterdam",
    "Barton",
    "Bellaire",
    "Cadiz",
    "Bergholz",
    "Blaine",
    "Bloomingdale",
    "Unionport",
    "Bridgeport",
    "Brilliant",
    "Cameron",
    "Clarington",
    "Dillonvale",
    "East Liverpool",
    "Calcutta",
    "E Liverpool",
    "East Springfield",
    "E Springfield",
    "Empire",
    "Glencoe",
    "Hammondsville",
    "Hannibal",
    "Irondale",
    "Jacobsburg",
    "Armstrong Mills",
    "Armstrong Mls",
    "Stewartsville",
    "Lansing",
    "Martins Ferry",
    "Mingo Junction",
    "Mingo Jct",
    "Mount Pleasant",
    "Mt Pleasant",
    "Neffs",
    "Powhatan Point",
    "Powhatan Pt",
    "Rayland",
    "Richmond",
    "Salineville",
    "Sardis",
    "Shadyside",
    "Smithfield",
    "Saint Clairsville",
    "St Clairsvle",
    "Lafferty",
    "Steubenville",
    "Wintersville",
    "Stratton",
    "Summitville",
    "Tiltonsville",
    "Toronto",
    "Warnock",
    "Wellsville",
    "Yorkville",
    "Bannock",
    "Freeport",
    "Harrisville",
    "Hopedale",
    "Flushing",
    "New Athens",
    "Piedmont",
    "Holloway",
    "Jewett",
    "Scio",
    "Amherst",
    "South Amherst",
    "Vermilion",
    "Andover",
    "Ashtabula",
    "Austinburg",
    "Avon",
    "Avon Lake",
    "Berea",
    "Burton",
    "Chagrin Falls",
    "Bentleyville",
    "Moreland Hills",
    "Moreland Hls",
    "Auburn Township",
    "Auburn Twp",
    "Chardon",
    "Concord Township",
    "Concord Twp",
    "Chesterland",
    "Columbia Station",
    "Columbia Sta",
    "Conneaut",
    "Dorset",
    "Elyria",
    "N Ridgeville",
    "North Ridgeville",
    "Sheffield Village",
    "Sheffield Vlg",
    "Gates Mills",
    "Geneva",
    "Grafton",
    "Grand River",
    "Huntsburg",
    "Jefferson",
    "New Lyme",
    "Kingsville",
    "Kipton",
    "Lagrange",
    "Lorain",
    "Sheffield Lake",
    "Sheffield Lk",
    "Macedonia",
    "Northfield",
    "Madison",
    "Mentor",
    "Mentor On Lk",
    "Mentor On The Lake",
    "Middlefield",
    "Montville",
    "Newbury",
    "Sagamore Hills",
    "Sagamore Hls",
    "North Kingsville",
    "N Kingsville",
    "North Olmsted",
    "Novelty",
    "Russell",
    "Oberlin",
    "Orwell",
    "East Orwell",
    "Painesville",
    "Fairport Harbor",
    "Fairport Hbr",
    "Parkman",
    "Perry",
    "Pierpont",
    "Rock Creek",
    "Roaming Shores",
    "Roaming Shrs",
    "Rome",
    "Thompson",
    "Twinsburg",
    "Wellington",
    "Rochester",
    "Wickliffe",
    "Willoughby Hills",
    "Wiloughby Hls",
    "Williamsfield",
    "Willoughby",
    "Kirtland",
    "Waite Hill",
    "Eastlake",
    "Lakeline",
    "Timberlake",
    "Willowick",
    "Windsor",
    "Cleveland",
    "Garfield Heights",
    "Garfield Hts",
    "Newburgh Heights",
    "Newburgh Hts",
    "Cleveland Heights",
    "Cleveland Hts",
    "Lakewood",
    "Edgewater",
    "Bratenahl",
    "E Cleveland",
    "East Cleveland",
    "Rocky River",
    "Euclid",
    "Shaker Heights",
    "Shaker Hts",
    "South Euclid",
    "University Heights",
    "University Ht",
    "University Hts",
    "Beachwood",
    "Highland Hills",
    "Highland Hls",
    "Warrensville Heights",
    "Warrensvl Hts",
    "Woodmere",
    "Lyndhurst",
    "Mayfield Heights",
    "Mayfield Hts",
    "Pepper Pike",
    "Valley View",
    "Fairview Park",
    "Cuyahoga Heights",
    "Cuyahoga Hts",
    "Bedford Heights",
    "Bedford Hts",
    "North Randall",
    "Parma",
    "Middlebrg Hts",
    "Middleburg Heights",
    "Parma Heights",
    "Independence",
    "Brooklyn Heights",
    "Brooklyn Hts",
    "Seven Hills",
    "North Royalton",
    "N Royalton",
    "Strongsville",
    "Maple Heights",
    "Olmsted Falls",
    "Olmsted Twp",
    "Solon",
    "Bay Village",
    "Brecksville",
    "Brookpark",
    "Brook Park",
    "Highland Heights",
    "Highland Hgts",
    "Highland Hts",
    "Mayfield",
    "Mayfield Village",
    "Mayfield Vlg",
    "Richmond Heights",
    "Richmond Hts",
    "Brooklyn",
    "Westlake",
    "Bedford",
    "Oakwood Village",
    "Oakwood Vlg",
    "Walton Hills",
    "Broadview Heights",
    "Broadview Hts",
    "Atwater",
    "Aurora",
    "Reminderville",
    "Barberton",
    "Coventry Township",
    "Coventry Twp",
    "New Franklin",
    "Norton",
    "Brunswick",
    "Burbank",
    "Chippewa Lake",
    "Medina",
    "Clinton",
    "Creston",
    "Cuyahoga Falls",
    "Cuyahoga Fls",
    "Stow",
    "Hudson",
    "Silver Lake",
    "Doylestown",
    "Garrettsville",
    "Green",
    "Hinckley",
    "Hiram",
    "Homerville",
    "Boston Heights",
    "Boston Hts",
    "Kent",
    "Streetsboro",
    "Lakemore",
    "Westfield Center",
    "Westfield Ctr",
    "Litchfield",
    "Lodi",
    "Mantua",
    "Mogadore",
    "Munroe Falls",
    "Peninsula",
    "Ravenna",
    "Rittman",
    "Rootstown",
    "Seville",
    "Sharon Center",
    "Spencer",
    "Sterling",
    "Tallmadge",
    "Valley City",
    "Wadsworth",
    "Wayland",
    "Richfield",
    "West Salem",
    "Congress",
    "Windham",
    "Akron",
    "Copley",
    "Fairlawn",
    "Berlin Center",
    "Bristolville",
    "Brookfield",
    "Burghill",
    "Campbell",
    "Canfield",
    "Columbiana",
    "Cortland",
    "Deerfield",
    "Diamond",
    "East Palestine",
    "E Palestine",
    "Elkton",
    "Farmdale",
    "Fowler",
    "Girard",
    "Hanoverton",
    "Hartford",
    "Hubbard",
    "Kensington",
    "Kinsman",
    "Lake Milton",
    "Leavittsburg",
    "Leetonia",
    "Lisbon",
    "Lowellville",
    "McDonald",
    "Masury",
    "Mesopotamia",
    "Mineral Ridge",
    "Negley",
    "New Middletown",
    "New Middletwn",
    "New Springfield",
    "New Springfld",
    "Newton Falls",
    "New Waterford",
    "Niles",
    "North Benton",
    "North Bloomfield",
    "N Bloomfield",
    "North Jackson",
    "North Lima",
    "Petersburg",
    "Rogers",
    "Salem",
    "Southington",
    "Struthers",
    "Vienna",
    "Warren",
    "Washingtonville",
    "Washingtonvle",
    "West Farmington",
    "W Farmington",
    "Winona",
    "Youngstown",
    "Boardman",
    "Poland",
    "Austintown",
    "Alliance",
    "Apple Creek",
    "Augusta",
    "Beach City",
    "Beloit",
    "Berlin",
    "Big Prairie",
    "Bolivar",
    "Brewster",
    "Canal Fulton",
    "Carrollton",
    "Harlem Spgs",
    "Harlem Springs",
    "Dalton",
    "Damascus",
    "Dellroy",
    "Dennison",
    "Dover",
    "Dundee",
    "East Rochester",
    "E Rochester",
    "East Sparta",
    "Fredericksburg",
    "Fredericksbrg",
    "Glenmont",
    "Gnadenhutten",
    "Greentown",
    "Hartville",
    "Holmesville",
    "Homeworth",
    "Killbuck",
    "Lakeville",
    "Leesville",
    "Limaville",
    "Louisville",
    "Magnolia",
    "Malvern",
    "Marshallville",
    "Massillon",
    "Mechanicstown",
    "Middlebranch",
    "Midvale",
    "Millersburg",
    "Mineral City",
    "Zoarville",
    "Minerva",
    "Mount Eaton",
    "Mount Hope",
    "Nashville",
    "Navarre",
    "New Philadelphia",
    "New Phila",
    "North Georgetown",
    "N Georgetown",
    "North Lawrence",
    "N Lawrence",
    "Orrville",
    "Paris",
    "Robertsville",
    "Sandyville",
    "Sebring",
    "Sherrodsville",
    "Shreve",
    "Smithville",
    "Somerdale",
    "Strasburg",
    "Sugarcreek",
    "Tuscarawas",
    "Uhrichsville",
    "Uniontown",
    "Walnut Creek",
    "Waynesburg",
    "Wilmot",
    "Winesburg",
    "Wooster",
    "Deersville",
    "Bowerston",
    "Zoar",
    "Tippecanoe",
    "Canton",
    "N Industry",
    "North Industry",
    "North Canton",
    "Jacksn Belden",
    "Jackson Belden",
    "N Canton",
    "East Canton",
    "Alvada",
    "Arcadia",
    "Ashland",
    "Attica",
    "Carrothers",
    "Bascom",
    "Bellevue",
    "Bellville",
    "Berlin Heights",
    "Berlin Hts",
    "Bettsville",
    "Bloomdale",
    "Bloomville",
    "Bucyrus",
    "Butler",
    "Castalia",
    "Chatfield",
    "Collins",
    "Crestline",
    "N Robinson",
    "North Robinson",
    "Flat Rock",
    "Fostoria",
    "Amsden",
    "Galion",
    "Green Springs",
    "Greenwich",
    "Hayesville",
    "Huron",
    "Shinrock",
    "Jeromesville",
    "Kansas",
    "Loudonville",
    "Lucas",
    "McCutchenville",
    "Mc Cutchenvle",
    "Milan",
    "Monroeville",
    "Nevada",
    "New Haven",
    "New London",
    "New Riegel",
    "New Washington",
    "New Washingtn",
    "North Fairfield",
    "N Fairfield",
    "Norwalk",
    "Nova",
    "Old Fort",
    "Perrysville",
    "Plymouth",
    "Polk",
    "Republic",
    "Sandusky",
    "Savannah",
    "Shelby",
    "Shiloh",
    "Sullivan",
    "Sulphur Springs",
    "Sulphur Spgs",
    "Sycamore",
    "Tiffin",
    "Fort Seneca",
    "Tiro",
    "Wakeman",
    "Willard",
    "Mansfield",
    "Ontario",
    "Lexington",
    "Addyston",
    "Cleves",
    "College Corner",
    "College Cor",
    "Franklin",
    "Carlisle",
    "Middletown",
    "Hamilton",
    "Fairfield",
    "Fairfield Township",
    "Fairfield Twp",
    "Indian Spgs",
    "Liberty Twp",
    "Village Of Indian Springs",
    "West Chester",
    "Rossville",
    "Lindenwald",
    "Harrison",
    "Harveysburg",
    "Hooven",
    "Kings Mills",
    "Kings Island",
    "Lebanon",
    "Mason",
    "Maineville",
    "Hamilton Township",
    "Hamilton Twp",
    "Miamitown",
    "Liberty Township",
    "Monroe",
    "Mount Saint Joseph",
    "Mt St Joseph",
    "North Bend",
    "Okeana",
    "Oregonia",
    "Overpeck",
    "Oxford",
    "Seven Mile",
    "Somerville",
    "South Lebanon",
    "Springboro",
    "Trenton",
    "Waynesville",
    "Liberty Townshp",
    "West Elkton",
    "Aberdeen",
    "Amelia",
    "Batavia",
    "Bentonville",
    "Bethel",
    "Blanchester",
    "Camp Dennison",
    "Loveland",
    "Chilo",
    "Clarksville",
    "Decatur",
    "Fayetteville",
    "Marathon",
    "Feesburg",
    "Felicity",
    "Georgetown",
    "Brown County",
    "Clermont Cnty",
    "Clermont County",
    "Goshen",
    "Greenfield",
    "Ross County",
    "Hamersville",
    "Poetown",
    "Higginsport",
    "Highland",
    "Hillsboro",
    "Leesburg",
    "Fayette Cnty",
    "Fayette County",
    "Hglnd County",
    "Highland County",
    "Montgomery",
    "Symmes Twp",
    "Lynchburg",
    "Manchester",
    "Adams County",
    "Martinsville",
    "Miamiville",
    "Midland",
    "Milford",
    "Day Heights",
    "Morrow",
    "Moscow",
    "Point Pleasant",
    "Pt Pleasant",
    "Mount Orab",
    "Mowrystown",
    "Neville",
    "New Richmond",
    "Newtonsville",
    "New Vienna",
    "Owensville",
    "Pleasant Plain",
    "Pleasant Pln",
    "Port William",
    "Reesville",
    "Ripley",
    "Russellville",
    "Sabina",
    "Clinton Cnty",
    "Clinton County",
    "Lees Creek",
    "Sardinia",
    "Buford",
    "Lake Waynoka",
    "Sinking Spring",
    "Sinking Spg",
    "Terrace Park",
    "Williamsburg",
    "Wilmington",
    "Cuba",
    "Cincinnati",
    "Queen City",
    "Walnut Hills",
    "Cheviot",
    "Norwood",
    "Taft",
    "Arlington Heights",
    "Arlington Hts",
    "Lockland",
    "Reading",
    "Wyoming",
    "Elmwood Pl",
    "Elmwood Place",
    "Saint Bernard",
    "Parkdale",
    "College Hl",
    "N College Hl",
    "Madeira",
    "Avondale",
    "Anderson Township",
    "Anderson Twp",
    "Mount Washington",
    "Mt Washington",
    "Mount Healthy",
    "Sayler Park",
    "Blue Ash",
    "Deer Park",
    "Silverton",
    "Amberley",
    "Colerain Township",
    "Colerain Twp",
    "Groesbeck",
    "North College Hill",
    "Sharonville",
    "Columbia Township",
    "Columbia Twp",
    "Anderson",
    "Newtown",
    "Glendale",
    "Springdale",
    "Westwood",
    "Symmes",
    "Alpha",
    "Anna",
    "Ansonia",
    "Arcanum",
    "Castine",
    "Gordon",
    "Ithaca",
    "Bellbrook",
    "Beavercreek",
    "Beavercreek Township",
    "Beavercrk Twp",
    "Sugarcreek Township",
    "Sugarcrk Twp",
    "Botkins",
    "Bowersville",
    "Bradford",
    "Brookville",
    "Burkettsville",
    "Camden",
    "Casstown",
    "Cedarville",
    "Clayton",
    "Englewood",
    "Clifton",
    "Conover",
    "Covington",
    "Donnelsville",
    "Eaton",
    "Eldorado",
    "Union",
    "Enon",
    "Fairborn",
    "Farmersville",
    "Germantown",
    "Fletcher",
    "Gettysburg",
    "Gratis",
    "Greenville",
    "Hollansburg",
    "Houston",
    "Jackson Center",
    "Jackson Ctr",
    "Jamestown",
    "Kettlersville",
    "Laura",
    "Potsdm",
    "Lewisburg",
    "Ludlow Falls",
    "Maplewood",
    "Medway",
    "Miamisburg",
    "New Carlisle",
    "New Lebanon",
    "New Madison",
    "New Paris",
    "New Weston",
    "Rossburg",
    "North Hampton",
    "North Star",
    "Osgood",
    "Palestine",
    "Pemberton",
    "Phillipsburg",
    "Piqua",
    "Pitsburg",
    "Pleasant Hill",
    "Port Jefferson",
    "Prt Jefferson",
    "Potsdam",
    "Russia",
    "Sidney",
    "South Charleston",
    "S Charleston",
    "South Vienna",
    "Spring Valley",
    "Tipp City",
    "Phoneton",
    "Tremont City",
    "Troy",
    "Vandalia",
    "Verona",
    "Versailles",
    "West Alexandria",
    "W Alexandria",
    "West Manchester",
    "W Manchester",
    "West Milton",
    "Wilberforce",
    "Xenia",
    "Yellow Springs",
    "Yellow Spgs",
    "Yorkshire",
    "Christiansburg",
    "Christiansbrg",
    "Union City",
    "Dayton",
    "Riverside",
    "Trotwood",
    "Kettering",
    "Moraine",
    "Oakwood",
    "Huber Heights",
    "Centerville",
    "Wp Air Base",
    "Wpafb",
    "Wright Pat",
    "Wright Patterson AFB",
    "W Carrollton",
    "West Carrollton",
    "West Carrollton City",
    "Washingtn Twp",
    "Washington Township",
    "Springfield",
    "Chillicothe",
    "Bainbridge",
    "Beaver",
    "Stockdale",
    "Bidwell",
    "Blue Creek",
    "Bourneville",
    "Cherry Fork",
    "Chesapeake",
    "Cheshire",
    "Coalton",
    "Creola",
    "Crown City",
    "Cynthiana",
    "Frankfort",
    "Franklin Furnace",
    "Frankln Frnce",
    "Friendship",
    "Gallipolis",
    "Hamden",
    "Haverhill",
    "Ironton",
    "Coal Grove",
    "Hanging Rock",
    "Jackson",
    "Jasper",
    "Kingston",
    "Kitts Hill",
    "Rock Camp",
    "Latham",
    "Londonderry",
    "Lucasville",
    "Lynx",
    "McArthur",
    "Allensville",
    "McDermott",
    "Minford",
    "New Plymouth",
    "Oak Hill",
    "Otway",
    "Patriot",
    "Pedro",
    "Peebles",
    "Piketon",
    "Idaho",
    "Portsmouth",
    "New Boston",
    "Sciotoville",
    "West Portsmouth",
    "W Portsmouth",
    "Proctorville",
    "Athalia",
    "Rarden",
    "Ray",
    "Richmond Dale",
    "Rio Grande",
    "Scioto Furnace",
    "Scioto Furnce",
    "Scottown",
    "Seaman",
    "South Point",
    "South Salem",
    "South Webster",
    "Stout",
    "Thurman",
    "Vinton",
    "Waterloo",
    "Waverly",
    "Wellston",
    "West Union",
    "Wheelersburg",
    "Wilkesville",
    "Radcliff",
    "Willow Wood",
    "Winchester",
    "Zaleski",
    "Athens",
    "Albany",
    "Amesville",
    "Belpre",
    "Beverly",
    "Buchtel",
    "Chauncey",
    "Chester",
    "Coal Run",
    "Coolville",
    "Cutler",
    "Dexter City",
    "Fleming",
    "Glouster",
    "Graysville",
    "Rinard Mills",
    "Guysville",
    "Hockingport",
    "Jacksonville",
    "Langsville",
    "Dexter",
    "Little Hocking",
    "Little Hockng",
    "Long Bottom",
    "Lowell",
    "Lower Salem",
    "Warner",
    "Macksburg",
    "Elba",
    "Marietta",
    "Middleport",
    "Millfield",
    "Nelsonville",
    "New Marshfield",
    "New Marshfld",
    "New Matamoras",
    "Fly",
    "Matamoras",
    "Newport",
    "Pomeroy",
    "Portland",
    "Racine",
    "Reedsville",
    "Reno",
    "Rutland",
    "Shade",
    "Stewart",
    "Syracuse",
    "The Plains",
    "Trimble",
    "Tuppers Plains",
    "Tuppers Plns",
    "Vincent",
    "Waterford",
    "Whipple",
    "Wingett Run",
    "Lima",
    "Cridersville",
    "Fort Shawnee",
    "Elida",
    "Beaverdam",
    "Gomer",
    "Ada",
    "Alger",
    "Antwerp",
    "Arlington",
    "Belmore",
    "Leipsic",
    "Benton Ridge",
    "Bluffton",
    "Buckland",
    "Cairo",
    "Cecil",
    "Celina",
    "Carthagena",
    "Chickasaw",
    "Cloverdale",
    "Coldwater",
    "Columbus Grove",
    "Columbus Grv",
    "Continental",
    "Convoy",
    "Delphos",
    "Dola",
    "Dunkirk",
    "Elgin",
    "Findlay",
    "Jenera",
    "Forest",
    "Fort Jennings",
    "Fort Loramie",
    "Fort Recovery",
    "Glandorf",
    "Grover Hill",
    "Harrod",
    "Haviland",
    "Kalida",
    "Lafayette",
    "Latty",
    "McComb",
    "McGuffey",
    "Maria Stein",
    "Melrose",
    "Mendon",
    "Middle Point",
    "Miller City",
    "Minster",
    "Montezuma",
    "Mount Blanchard",
    "Mt Blanchard",
    "Mount Cory",
    "New Bremen",
    "New Hampshire",
    "New Knoxville",
    "North Baltimore",
    "Bairdstown",
    "N Baltimore",
    "Ohio City",
    "Ottawa",
    "Gilboa",
    "Ottoville",
    "Pandora",
    "Paulding",
    "Broughton",
    "Payne",
    "Rawson",
    "Rockford",
    "Saint Henry",
    "Saint Johns",
    "Saint Marys",
    "Scott",
    "Spencerville",
    "Uniopolis",
    "Van Buren",
    "Vanlue",
    "Van Wert",
    "Vaughnsville",
    "Venedocia",
    "Wapakoneta",
    "Waynesfield",
    "Williamstown",
    "Willshire",
    "Wren",
  ],
  OK: [
    "Albert",
    "Alex",
    "Edmond",
    "Amber",
    "Anadarko",
    "Washita",
    "Apache",
    "Arcadia",
    "Bethany",
    "Woodlawn Park",
    "Binger",
    "Blanchard",
    "Cole",
    "Bradley",
    "Calumet",
    "Carnegie",
    "Cashion",
    "Cement",
    "Chickasha",
    "Norge",
    "Norman",
    "Choctaw",
    "Colony",
    "Concho",
    "Corn",
    "Coyle",
    "Crescent",
    "Cimarron City",
    "Cyril",
    "Davis",
    "Dibble",
    "Dougherty",
    "Eakly",
    "El Reno",
    "Fort Cobb",
    "Geary",
    "Gotebo",
    "Gracemont",
    "Greenfield",
    "Guthrie",
    "Harrah",
    "Hinton",
    "Bridgeport",
    "Hydro",
    "Jones",
    "Langston",
    "Lexington",
    "Slaughterville",
    "Slaughtervl",
    "Lindsay",
    "Erin Springs",
    "Lookeba",
    "Luther",
    "Marlow",
    "Bray",
    "Central High",
    "Marshall",
    "Maysville",
    "Meridian",
    "Minco",
    "Morrison",
    "Mountain View",
    "Mulhall",
    "Mustang",
    "Newcastle",
    "Nicoma Park",
    "Ninnekah",
    "Noble",
    "Etowah",
    "Orlando",
    "Paoli",
    "Pauls Valley",
    "Perry",
    "Piedmont",
    "Pocasset",
    "Purcell",
    "Rush Springs",
    "Spencer",
    "Sulphur",
    "Tuttle",
    "Union City",
    "Verden",
    "Washington",
    "Goldsby",
    "Wayne",
    "Weatherford",
    "Wheatland",
    "Wynnewood",
    "Yukon",
    "Oklahoma City",
    "Midwest City",
    "Warr Acres",
    "Del City",
    "Smith Village",
    "Nichols Hills",
    "The Village",
    "Village",
    "Forest Park",
    "Lake Aluma",
    "Tinker AFB",
    "Moore",
    "Ardmore",
    "Milo",
    "Pooleville",
    "Countyline",
    "Burneyville",
    "Coleman",
    "Elmore City",
    "Pernell",
    "Foster",
    "Fox",
    "Gene Autry",
    "Graham",
    "Healdton",
    "Kingston",
    "Lebanon",
    "Leon",
    "Loco",
    "Lone Grove",
    "Hennepin",
    "Madill",
    "Mc Millan",
    "Oakland",
    "Mannsville",
    "Marietta",
    "Mead",
    "Milburn",
    "Overbrook",
    "Ravia",
    "Ringling",
    "Cornish",
    "Springer",
    "Thackerville",
    "Tishomingo",
    "Wapanucka",
    "Wilson",
    "Rubottom",
    "Ratliff City",
    "Tatums",
    "Tussy",
    "Velma",
    "Lawton",
    "Fort Sill",
    "Addington",
    "Altus",
    "Altus Afb",
    "Blair",
    "Cache",
    "Chattanooga",
    "Comanche",
    "Davidson",
    "Devol",
    "Duke",
    "Duncan",
    "Empire City",
    "Eldorado",
    "Elgin",
    "Elmer",
    "Faxon",
    "Fletcher",
    "Frederick",
    "Geronimo",
    "Gould",
    "Grandfield",
    "Granite",
    "Hastings",
    "Headrick",
    "Hollis",
    "Hollister",
    "Indiahoma",
    "Loveland",
    "Mangum",
    "Reed",
    "Manitou",
    "Martha",
    "Medicine Park",
    "Mountain Park",
    "Olustee",
    "Randlett",
    "Roosevelt",
    "Cooperton",
    "Ryan",
    "Snyder",
    "Sterling",
    "Temple",
    "Terral",
    "Grady",
    "Tipton",
    "Vinson",
    "Walters",
    "Waurika",
    "Sugden",
    "Clinton",
    "Arapaho",
    "Bessie",
    "Burns Flat",
    "Butler",
    "Canute",
    "Carter",
    "Cheyenne",
    "Strong City",
    "Cordell",
    "Crawford",
    "Custer City",
    "Dill City",
    "Durham",
    "Elk City",
    "Erick",
    "Fay",
    "Foss",
    "Hammon",
    "Hobart",
    "Leedey",
    "Lone Wolf",
    "Oakwood",
    "Eagle City",
    "Putnam",
    "Reydon",
    "Rocky",
    "Sayre",
    "Seiling",
    "Sentinel",
    "Sweetwater",
    "Taloga",
    "Texola",
    "Thomas",
    "Willow",
    "Enid",
    "North Enid",
    "Aline",
    "Alva",
    "Avard",
    "Capron",
    "Ames",
    "Amorita",
    "Bison",
    "Burlington",
    "Byron",
    "Canton",
    "Carmen",
    "Carrier",
    "Cherokee",
    "Lambert",
    "Cleo Springs",
    "Covington",
    "Dacoma",
    "Douglas",
    "Dover",
    "Drummond",
    "Fairmont",
    "Fairview",
    "Orienta",
    "Garber",
    "Goltry",
    "Helena",
    "Hennessey",
    "Hillsdale",
    "Hitchcock",
    "Hopeton",
    "Isabella",
    "Jet",
    "Kingfisher",
    "Kremlin",
    "Lahoma",
    "Longdale",
    "Loyal",
    "Lucien",
    "Manchester",
    "Medford",
    "Jefferson",
    "Renfrow",
    "Meno",
    "Nash",
    "Okarche",
    "Okeene",
    "Omega",
    "Pond Creek",
    "Ringwood",
    "Southard",
    "Wakita",
    "Watonga",
    "Waukomis",
    "Woodward",
    "Arnett",
    "Harmon",
    "Buffalo",
    "Selman",
    "Camargo",
    "Chester",
    "Fargo",
    "Fort Supply",
    "Freedom",
    "Gage",
    "Gate",
    "Knowles",
    "Laverne",
    "Logan",
    "May",
    "Mooreland",
    "Mutual",
    "Rosston",
    "Sharon",
    "Shattuck",
    "Vici",
    "Waynoka",
    "Adams",
    "Balko",
    "Beaver",
    "Elmwood",
    "Boise City",
    "Felt",
    "Forgan",
    "Goodwell",
    "Guymon",
    "Hardesty",
    "Hooker",
    "Optima",
    "Kenton",
    "Keyes",
    "Texhoma",
    "Turpin",
    "Baker",
    "Tyrone",
    "Avant",
    "Barnsdall",
    "Bartlesville",
    "Bixby",
    "Bristow",
    "Broken Arrow",
    "Catoosa",
    "Fair Oaks",
    "Chelsea",
    "Claremore",
    "Valley Park",
    "Cleveland",
    "Shady Grove",
    "Collinsville",
    "Copan",
    "Cushing",
    "Davenport",
    "Delaware",
    "Depew",
    "Dewey",
    "Drumright",
    "Glencoe",
    "Glenpool",
    "Hallett",
    "Hominy",
    "Inola",
    "Jenks",
    "Jennings",
    "Kellyville",
    "Kiefer",
    "Lenapah",
    "Mannford",
    "Lawrence Creek",
    "Lawrence Crk",
    "Maramec",
    "Milfay",
    "Mounds",
    "Nowata",
    "Oakhurst",
    "Ochelata",
    "Oilton",
    "Oologah",
    "Osage",
    "Owasso",
    "Pawhuska",
    "Bowring",
    "Pawnee",
    "Blackburn",
    "Skedee",
    "Perkins",
    "Prue",
    "Ramona",
    "Ripley",
    "Sand Springs",
    "Sapulpa",
    "Shamrock",
    "Skiatook",
    "Slick",
    "S Coffeyville",
    "Sperry",
    "Stillwater",
    "Stroud",
    "Kendrick",
    "Talala",
    "Terlton",
    "Vera",
    "Wann",
    "Wynona",
    "Yale",
    "Tulsa",
    "Vinita",
    "Centralia",
    "Pensacola",
    "White Oak",
    "Adair",
    "Afton",
    "Bernice",
    "Cleora",
    "Monkey Island",
    "Big Cabin",
    "Bluejacket",
    "Chouteau",
    "Mazie",
    "Colcord",
    "W Siloam Spgs",
    "West Siloam Springs",
    "Commerce",
    "Disney",
    "Eucha",
    "Fairland",
    "Grove",
    "Jay",
    "Kansas",
    "Ketchum",
    "Grand Lake Towne",
    "Grnd Lke Town",
    "Langley",
    "Locust Grove",
    "Miami",
    "North Miami",
    "Oaks",
    "Picher",
    "Pryor",
    "Sportsmen Acres",
    "Sprtsmn Acres",
    "Quapaw",
    "Peoria",
    "Rose",
    "Salina",
    "Spavinaw",
    "Strang",
    "Twin Oaks",
    "Welch",
    "Wyandotte",
    "Muskogee",
    "Summit",
    "Beggs",
    "Winchester",
    "Boynton",
    "Braggs",
    "Canadian",
    "Checotah",
    "Cookson",
    "Council Hill",
    "Coweta",
    "Crowder",
    "Dewar",
    "Eufaula",
    "Carlton Landing",
    "Carlton Lndg",
    "Fort Gibson",
    "Gore",
    "Paradise Hill",
    "Haskell",
    "Henryetta",
    "Hoffman",
    "Hitchita",
    "Hulbert",
    "Indianola",
    "Morris",
    "Okay",
    "Okmulgee",
    "Oktaha",
    "Park Hill",
    "Peggs",
    "Porter",
    "Tullahassee",
    "Porum",
    "Preston",
    "Proctor",
    "Redbird",
    "Rentiesville",
    "Schulter",
    "Stigler",
    "Taft",
    "Tahlequah",
    "Wagoner",
    "Wainwright",
    "Warner",
    "Webbers Falls",
    "Welling",
    "Whitefield",
    "Hoyt",
    "Mcalester",
    "Bache",
    "Haywood",
    "Albion",
    "Alderson",
    "Antlers",
    "Atoka",
    "Farris",
    "Blanco",
    "Bromide",
    "Calvin",
    "Gerty",
    "Caney",
    "Centrahoma",
    "Clarita",
    "Clayton",
    "Coalgate",
    "Daisy",
    "Finley",
    "Haileyville",
    "Hartshorne",
    "Honobia",
    "Kiamichi",
    "Kinta",
    "Kiowa",
    "Krebs",
    "Lane",
    "Lehigh",
    "Moyers",
    "Nashoba",
    "Pittsburg",
    "Quinton",
    "Rattan",
    "Red Oak",
    "Savanna",
    "Snow",
    "Stringtown",
    "Stuart",
    "Ashland",
    "Talihina",
    "Tupelo",
    "Tuskahoma",
    "Wardville",
    "Whitesboro",
    "Wilburton",
    "Ponca City",
    "Billings",
    "Blackwell",
    "Braman",
    "Burbank",
    "Deer Creek",
    "Fairfax",
    "Hunter",
    "Kaw City",
    "Kaw",
    "Lamont",
    "Marland",
    "Nardin",
    "Newkirk",
    "Peckham",
    "Ralston",
    "Red Rock",
    "Shidler",
    "Foraker",
    "Webb City",
    "Tonkawa",
    "Durant",
    "Silo",
    "Achille",
    "Albany",
    "Battiest",
    "Bennington",
    "Wade",
    "Bethel",
    "Bokchito",
    "Armstrong",
    "Boswell",
    "Broken Bow",
    "Caddo",
    "Calera",
    "Cartwright",
    "Colbert",
    "Eagletown",
    "Fort Towson",
    "Ft Towson",
    "Garvin",
    "Golden",
    "Grant",
    "Haworth",
    "Tom",
    "Hendrix",
    "Yarnaby",
    "Hugo",
    "Idabel",
    "Kemp",
    "Kenefic",
    "Millerton",
    "Platter",
    "Ringold",
    "Rufe",
    "Sawyer",
    "Soper",
    "Spencerville",
    "Swink",
    "Valliant",
    "Wright City",
    "Shawnee",
    "Bethel Acres",
    "Johnson",
    "Ada",
    "Bing",
    "Byng",
    "Pontotoc",
    "Agra",
    "Allen",
    "Asher",
    "Atwood",
    "Boley",
    "Bowlegs",
    "Byars",
    "Rosedale",
    "Carney",
    "Castle",
    "Welty",
    "Chandler",
    "Connerville",
    "Cromwell",
    "Dustin",
    "Earlsboro",
    "Fittstown",
    "Fitzhugh",
    "Francis",
    "Hanna",
    "Vernon",
    "Holdenville",
    "Horntown",
    "Spaulding",
    "Yeager",
    "Konawa",
    "Lamar",
    "Mcloud",
    "Dale",
    "Macomb",
    "Maud",
    "Meeker",
    "Mill Creek",
    "Newalla",
    "Okemah",
    "Bearden",
    "Mason",
    "Paden",
    "Prague",
    "Roff",
    "Hickory",
    "Saint Louis",
    "Sasakwa",
    "Seminole",
    "Sparks",
    "Stonewall",
    "Harden City",
    "Stratford",
    "Tecumseh",
    "Tryon",
    "Wanette",
    "Tribbey",
    "Weleetka",
    "Clearview",
    "Pharoah",
    "Wellston",
    "Fallis",
    "Warwick",
    "Wetumka",
    "Wewoka",
    "Lima",
    "New Lima",
    "Arkoma",
    "Pocola",
    "Bokoshe",
    "Bunch",
    "Cameron",
    "Fanshawe",
    "Gans",
    "Heavener",
    "Hodgen",
    "Howe",
    "Keota",
    "Cowlington",
    "Leflore",
    "Lequire",
    "Mccurtain",
    "Marble City",
    "Moffett",
    "Monroe",
    "Muldrow",
    "Muse",
    "Panama",
    "Poteau",
    "Roland",
    "Sallisaw",
    "Shady Point",
    "Smithville",
    "Octavia",
    "Spiro",
    "Fort Coffee",
    "Stilwell",
    "Vian",
    "Watson",
    "Watts",
    "Westville",
    "Wister",
  ],
  OR: [
    "Antelope",
    "Aurora",
    "Beaverton",
    "Aloha",
    "Hillsboro",
    "Beavercreek",
    "Boring",
    "Damascus",
    "Brightwood",
    "Canby",
    "Cascade Locks",
    "Clackamas",
    "Happy Valley",
    "Clatskanie",
    "Birkenfeld",
    "Westport",
    "Colton",
    "Columbia City",
    "Corbett",
    "Donald",
    "Dufur",
    "Friend",
    "Eagle Creek",
    "Estacada",
    "Fairview",
    "Gervais",
    "Gladstone",
    "Government Camp",
    "Government Cp",
    "Timberline Lodge",
    "Timbrline Ldg",
    "Grass Valley",
    "Gresham",
    "Hood River",
    "Hubbard",
    "Kent",
    "Lake Oswego",
    "Lake Grove",
    "Maupin",
    "Molalla",
    "Moro",
    "Mosier",
    "Mount Hood Parkdale",
    "Mt Hood Prkdl",
    "Mulino",
    "Oregon City",
    "Rainier",
    "Prescott",
    "Rhododendron",
    "Zigzag",
    "Rufus",
    "Saint Helens",
    "Warren",
    "Deer Island",
    "Sandy",
    "Scappoose",
    "Shaniko",
    "The Dalles",
    "Troutdale",
    "Wood Village",
    "Tualatin",
    "Tygh Valley",
    "Wamic",
    "Vernonia",
    "Wasco",
    "Welches",
    "West Linn",
    "Wilsonville",
    "Woodburn",
    "Portland",
    "Amity",
    "Arch Cape",
    "Astoria",
    "Banks",
    "Bay City",
    "Beaver",
    "Buxton",
    "Cannon Beach",
    "Carlton",
    "Cloverdale",
    "Cornelius",
    "Dayton",
    "Dundee",
    "Forest Grove",
    "Glenwood",
    "Gales Creek",
    "Garibaldi",
    "Gaston",
    "Hammond",
    "Hebo",
    "Manning",
    "Lafayette",
    "Mcminnville",
    "Manzanita",
    "Nehalem",
    "Newberg",
    "North Plains",
    "Oceanside",
    "Pacific City",
    "Rockaway Beach",
    "Rockaway",
    "Rockaway Bch",
    "Saint Paul",
    "Seaside",
    "Gearhart",
    "Sherwood",
    "Tillamook",
    "Timber",
    "Tolovana Park",
    "Warrenton",
    "Wheeler",
    "Yamhill",
    "Neskowin",
    "Milwaukie",
    "Oak Grove",
    "Tigard",
    "King City",
    "Salem",
    "Keizer",
    "Brooks",
    "Albany",
    "Millersburg",
    "Alsea",
    "Aumsville",
    "West Stayton",
    "Blodgett",
    "Brownsville",
    "Cascadia",
    "Corvallis",
    "Adair Village",
    "Crabtree",
    "Crawfordsville",
    "Crawfordsvlle",
    "Dallas",
    "Depoe Bay",
    "Detroit",
    "Eddyville",
    "Falls City",
    "Foster",
    "Gates",
    "Grand Ronde",
    "Halsey",
    "Idanha",
    "Independence",
    "Jefferson",
    "Lebanon",
    "Logsden",
    "Lyons",
    "Mill City",
    "Monmouth",
    "Mount Angel",
    "Neotsu",
    "Newport",
    "South Beach",
    "Lincoln City",
    "Rose Lodge",
    "Otis",
    "Otter Rock",
    "Philomath",
    "Rickreall",
    "Saint Benedict",
    "St Benedict",
    "Scio",
    "Scotts Mills",
    "Seal Rock",
    "Shedd",
    "Sheridan",
    "Siletz",
    "Silverton",
    "Stayton",
    "Mehama",
    "Sublimity",
    "Sweet Home",
    "Gleneden Beach",
    "Gleneden Bch",
    "Tangent",
    "Tidewater",
    "Toledo",
    "Turner",
    "Marion",
    "Waldport",
    "Willamina",
    "Eugene",
    "Agness",
    "Coburg",
    "Azalea",
    "Bandon",
    "Blachly",
    "Blue River",
    "Ckenzie Bridge",
    "Mc Kenzie Brg",
    "Mckenzie Bridge",
    "Broadbent",
    "Brookings",
    "Harbor",
    "Camas Valley",
    "Canyonville",
    "Cheshire",
    "Coos Bay",
    "Charleston",
    "Coquille",
    "Cottage Grove",
    "Curtin",
    "Saginaw",
    "Creswell",
    "Days Creek",
    "Deadwood",
    "Greenleaf",
    "Dexter",
    "Dillard",
    "Dorena",
    "Culp Creek",
    "Drain",
    "Elkton",
    "Elmira",
    "Fall Creek",
    "Jasper",
    "Florence",
    "Dunes City",
    "Gardiner",
    "Glendale",
    "Glide",
    "Gold Beach",
    "Harrisburg",
    "Idleyld Park",
    "Junction City",
    "Lakeside",
    "Langlois",
    "Lorane",
    "Lowell",
    "Mapleton",
    "Marcola",
    "Pleasant Hill",
    "Monroe",
    "Myrtle Creek",
    "Myrtle Point",
    "Norway",
    "Remote",
    "North Bend",
    "Noti",
    "Oakland",
    "Oakridge",
    "Port Orford",
    "Powers",
    "Reedsport",
    "Win Bay",
    "Winchester Bay",
    "Winchestr Bay",
    "Riddle",
    "Roseburg",
    "Scottsburg",
    "Sixes",
    "Springfield",
    "Sutherlin",
    "Swisshome",
    "Tenmile",
    "Tiller",
    "Umpqua",
    "Veneta",
    "Vida",
    "Walterville",
    "Leaburg",
    "Walton",
    "Westfir",
    "Westlake",
    "Wilbur",
    "Winchester",
    "Winston",
    "Wolf Creek",
    "Yachats",
    "Yoncalla",
    "Medford",
    "Central Point",
    "White City",
    "Ashland",
    "Butte Falls",
    "Cave Junction",
    "Eagle Point",
    "Gold Hill",
    "Grants Pass",
    "Jacksonville",
    "Applegate",
    "Kerby",
    "Merlin",
    "O'Brien",
    "Phoenix",
    "Prospect",
    "Rogue River",
    "Selma",
    "Shady Cove",
    "Talent",
    "Trail",
    "Wilderville",
    "Williams",
    "Klamath Falls",
    "Oretech",
    "Crater Lake",
    "Adel",
    "Beatty",
    "Bly",
    "Bonanza",
    "Chiloquin",
    "Dairy",
    "Fort Klamath",
    "Keno",
    "Lakeview",
    "Malin",
    "Merrill",
    "Midland",
    "New Pine Creek",
    "New Pine Crk",
    "Paisley",
    "Plush",
    "Silver Lake",
    "Sprague River",
    "Summer Lake",
    "Christmas Valley",
    "Christmas Vly",
    "Bend",
    "Sunriver",
    "Fields",
    "Ashwood",
    "Brothers",
    "Burns",
    "Lawen",
    "Princeton",
    "Diamond",
    "Camp Sherman",
    "Chemult",
    "Diamond Lake",
    "Crane",
    "Crescent",
    "Crescent Lake",
    "Culver",
    "Fort Rock",
    "Frenchglen",
    "Gilchrist",
    "Hines",
    "La Pine",
    "Madras",
    "Metolius",
    "Mitchell",
    "Paulina",
    "Post",
    "Powell Butte",
    "Prineville",
    "Redmond",
    "Riley",
    "Sisters",
    "Terrebonne",
    "Crkd Rvr Rnch",
    "Crooked River",
    "Crooked River Ranch",
    "Warm Springs",
    "Pendleton",
    "Cayuse",
    "Adams",
    "Arlington",
    "Athena",
    "Baker City",
    "Medical Spgs",
    "Medical Springs",
    "Bates",
    "Boardman",
    "Bridgeport",
    "Canyon City",
    "Condon",
    "Lonerock",
    "Cove",
    "Dayville",
    "Echo",
    "Elgin",
    "Enterprise",
    "Fossil",
    "Kinzua",
    "Mayville",
    "Haines",
    "Halfway",
    "Helix",
    "Heppner",
    "Hereford",
    "Hermiston",
    "Lexington",
    "Oxbow",
    "Imbler",
    "Imnaha",
    "Ione",
    "Irrigon",
    "John Day",
    "Joseph",
    "Kimberly",
    "La Grande",
    "Island City",
    "Long Creek",
    "Fox",
    "Ritter",
    "Lostine",
    "Meacham",
    "Milton Freewater",
    "Milton Frwtr",
    "Monument",
    "Mount Vernon",
    "North Powder",
    "Pilot Rock",
    "Prairie City",
    "Richland",
    "Seneca",
    "Spray",
    "Stanfield",
    "Summerville",
    "Sumpter",
    "Granite",
    "Greenhorn",
    "Ukiah",
    "Dale",
    "Umatilla",
    "Mcnary",
    "Union",
    "Unity",
    "Wallowa",
    "Weston",
    "Adrian",
    "Arock",
    "Brogan",
    "Drewsey",
    "Durkee",
    "Harper",
    "Huntington",
    "Ironside",
    "Jamieson",
    "Jordan Valley",
    "South Mountain",
    "South Mtn",
    "Juntura",
    "Nyssa",
    "Ontario",
    "Riverside",
    "Vale",
    "Westfall",
  ],
  PA: [
    "Aliquippa",
    "Macarthur",
    "W Aliquippa",
    "West Aliquippa",
    "Ambridge",
    "Fair Oaks",
    "Atlasburg",
    "Baden",
    "Bairdford",
    "Bakerstown",
    "Beaver",
    "Vanport",
    "W Bridgewater",
    "West Bridgewater",
    "Beaver Falls",
    "Patterson Heights",
    "Patterson Hts",
    "Racine",
    "Belle Vernon",
    "Belle Vrn Br",
    "N Bell Vernon",
    "N Belle Vernon",
    "N Belle Vrn",
    "North Belle Vernon",
    "Rostraver Township",
    "Rostraver Twp",
    "Brackenridge",
    "Bradfordwoods",
    "Bridgeville",
    "Buena Vista",
    "Bulger",
    "Bunola",
    "Burgettstown",
    "Eldersville",
    "Paris",
    "Charleroi",
    "N Charleroi",
    "North Charleroi",
    "Cheswick",
    "Clairton",
    "Floreffe",
    "Jefferson Hills",
    "Jefferson Hls",
    "Large",
    "Clinton",
    "Conway",
    "Coulters",
    "Creighton",
    "Cuddy",
    "Donora",
    "Dravosburg",
    "East McKeesport",
    "E Mckeesport",
    "Elizabeth",
    "Elrama",
    "Freedom",
    "Georgetown",
    "Gibsonia",
    "Glassport",
    "Crescent",
    "Glenwillard",
    "Greenock",
    "Harwick",
    "Hookstown",
    "Indianola",
    "Industry",
    "Joffre",
    "Langeloth",
    "Lawrence",
    "Leetsdale",
    "McDonald",
    "Midland",
    "Midway",
    "Monaca",
    "Monessen",
    "Monongahela",
    "Morgan",
    "Natrona Heights",
    "Natrona Hts",
    "New Brighton",
    "New Eagle",
    "New Kensington",
    "Arnold",
    "Barking",
    "Lower Burrell",
    "New Kensingtn",
    "Parnassus",
    "Oakdale",
    "Noblestown",
    "Pricedale",
    "Rochester",
    "Rural Ridge",
    "Russellton",
    "Shippingport",
    "Slovan",
    "South Heights",
    "Sturgeon",
    "Sutersville",
    "Tarentum",
    "Trafford",
    "Warrendale",
    "Webster",
    "West Elizabeth",
    "W Elizabeth",
    "West Newton",
    "Wexford",
    "Allison Park",
    "Bethel Park",
    "Braddock",
    "Rankin",
    "Carnegie",
    "Heidelberg",
    "Coraopolis",
    "Moon Township",
    "Moon Twp",
    "Duquesne",
    "East Pittsburgh",
    "E Pittsburgh",
    "Glenshaw",
    "Homestead",
    "Munhall",
    "W Homestead",
    "West Homestead",
    "West Mifflin",
    "Pittsburgh",
    "Imperial",
    "South Park",
    "Library",
    "Mckeesport",
    "White Oak",
    "Boston",
    "McKees Rocks",
    "North Versailles",
    "N Versailles",
    "Oakmont",
    "Pitcairn",
    "Monroeville",
    "Presto",
    "Sewickley",
    "Edgeworth",
    "Springdale",
    "Turtle Creek",
    "Verona",
    "Wilmerding",
    "Wall",
    "Arsenal",
    "Avalon",
    "Bellevue",
    "Bellvue",
    "Ben Avon",
    "Emsworth",
    "Carson",
    "Corliss",
    "Crafton",
    "East Liberty",
    "Hazelwood",
    "Homewood",
    "Millvale",
    "Mount Oliver",
    "Mt Oliver",
    "Mount Washington",
    "Mt Washington",
    "Allegheny",
    "Oakland",
    "Observatory",
    "Aspinwall",
    "Sharpsburg",
    "South Hills",
    "Squirrel Hill",
    "Swissvale",
    "Wabash",
    "Wilkinsburg",
    "Etna",
    "Bloomfield",
    "Brookline",
    "Brentwood",
    "Mt Lebanon",
    "West View",
    "Shadyside",
    "Kilbuck",
    "Castle Shann",
    "Castle Shannon",
    "Penn Hills",
    "Pleasant Hills",
    "Pleasant Hls",
    "Mc Knight",
    "Mcknight",
    "Blawnox",
    "Plum",
    "Upper Saint Clair",
    "Upper St Clair",
    "Uppr St Clair",
    "Cedarhurst",
    "Washington",
    "Aleppo",
    "Amity",
    "Avella",
    "Rea",
    "Beallsville",
    "Bentleyville",
    "Bobtown",
    "Brave",
    "Canonsburg",
    "Mc Murray",
    "Mcmurray",
    "Carmichaels",
    "Cecil",
    "Clarksville",
    "Claysville",
    "Cokeburg",
    "Crucible",
    "Dilliner",
    "Prosperity",
    "Eighty Four",
    "Ellsworth",
    "Finleyville",
    "Fredericktown",
    "Garards Fort",
    "Graysville",
    "Greensboro",
    "Hickory",
    "Holbrook",
    "Houston",
    "Jefferson",
    "Marianna",
    "Mather",
    "Meadow Lands",
    "Millsboro",
    "Mount Morris",
    "Davistown",
    "Mt Morris",
    "Muse",
    "Nemacolin",
    "New Freeport",
    "Pine Bank",
    "Nineveh",
    "Rices Landing",
    "Richeyville",
    "Rogersville",
    "Scenery Hill",
    "Southview",
    "Spraggs",
    "Strabane",
    "Sycamore",
    "Taylorstown",
    "Van Voorhis",
    "Venetia",
    "Vestaburg",
    "Waynesburg",
    "West Alexander",
    "W Alexander",
    "West Finley",
    "Westland",
    "West Middletown",
    "W Middletown",
    "Wind Ridge",
    "Uniontown",
    "Adah",
    "Addison",
    "Allenport",
    "Allison",
    "Brownfield",
    "Brownsville",
    "California",
    "Cardale",
    "Chalk Hill",
    "Chestnut Ridge",
    "Chestnut Rdg",
    "Coal Center",
    "Confluence",
    "Listonburg",
    "Ursina",
    "Connellsville",
    "S Connellsvl",
    "Daisytown",
    "Dawson",
    "Denbo",
    "Dickerson Run",
    "Dunbar",
    "Dunlevy",
    "East Millsboro",
    "E Millsboro",
    "Elco",
    "Fairbank",
    "Fairchance",
    "Farmington",
    "Fayette City",
    "Gibbon Glade",
    "Grindstone",
    "Hibbs",
    "Hiller",
    "Hopwood",
    "Indian Head",
    "Isabella",
    "Jacobs Creek",
    "Keisterville",
    "La Belle",
    "Lake Lynn",
    "Leckrone",
    "Leisenring",
    "Lemont Furnace",
    "Lemont Frnc",
    "Lemont Frnce",
    "McClellandtown",
    "Lamberton",
    "Mcclellandtwn",
    "Markleysburg",
    "Martin",
    "Masontown",
    "Melcroft",
    "Merrittstown",
    "Mill Run",
    "Mount Braddock",
    "Mt Braddock",
    "Newell",
    "New Geneva",
    "New Salem",
    "Normalville",
    "Ohiopyle",
    "Oliver",
    "Perryopolis",
    "Layton",
    "Whitsett",
    "Point Marion",
    "Republic",
    "Ronco",
    "Roscoe",
    "Smithfield",
    "Smithton",
    "Van Meter",
    "Smock",
    "Star Junction",
    "Stockdale",
    "Uledi",
    "Vanderbilt",
    "Waltersburg",
    "West Leisenring",
    "W Leisenring",
    "White",
    "Wickhaven",
    "Somerset",
    "Hidden Valley",
    "Acosta",
    "Alum Bank",
    "Bedford",
    "Berlin",
    "Boswell",
    "Boynton",
    "Breezewood",
    "Buffalo Mills",
    "Clearville",
    "Crystal Spring",
    "Crystal Spg",
    "Everett",
    "Fairhope",
    "Glencoe",
    "Fishertown",
    "Fort Hill",
    "Friedens",
    "Garrett",
    "Gray",
    "Hyndman",
    "Jenners",
    "Jennerstown",
    "Manns Choice",
    "Markleton",
    "Meyersdale",
    "New Paris",
    "Quecreek",
    "Rockwood",
    "Salisbury",
    "Schellsburg",
    "Shanksville",
    "Sipesville",
    "Springs",
    "Stoystown",
    "Wellersburg",
    "West Salisbury",
    "W Salisbury",
    "Greensburg",
    "Acme",
    "Adamsburg",
    "Alverton",
    "Apollo",
    "Ardara",
    "Armbrust",
    "Arona",
    "Avonmore",
    "Edmon",
    "Bovard",
    "Bradenville",
    "Champion",
    "Claridge",
    "Crabtree",
    "Darragh",
    "Delmont",
    "Derry",
    "Donegal",
    "East Vandergrift",
    "E Vandergrift",
    "Everson",
    "Export",
    "Murrysville",
    "Forbes Road",
    "Grapeville",
    "Hannastown",
    "Harrison City",
    "Herminie",
    "Hostetter",
    "Hunker",
    "Hutchinson",
    "Hyde Park",
    "Irwin",
    "N Huntingdon",
    "No Huntingdon",
    "North Huntingdon",
    "North Irwin",
    "Jeannette",
    "Jones Mills",
    "Larimer",
    "Latrobe",
    "Laughlintown",
    "Leechburg",
    "N Leechburg",
    "North Leechburg",
    "W Leechburg",
    "West Leechburg",
    "Ligonier",
    "Wilpen",
    "Lowber",
    "Loyalhanna",
    "Luxor",
    "Madison",
    "Manor",
    "Mount Pleasant",
    "Mt Pleasant",
    "New Alexandria",
    "New Alexandri",
    "New Derry",
    "New Stanton",
    "North Apollo",
    "Norvelt",
    "Penn",
    "Pleasant Unity",
    "Pleasant Unty",
    "Rector",
    "Rillton",
    "Ruffs Dale",
    "Salina",
    "Saltsburg",
    "Schenley",
    "Scottdale",
    "Slickville",
    "Spring Church",
    "Stahlstown",
    "Tarrs",
    "United",
    "Vandergrift",
    "Park",
    "Wendel",
    "Westmoreland City",
    "Westmrlnd Cty",
    "Whitney",
    "Wyano",
    "Youngstown",
    "Youngwood",
    "Yukon",
    "Indiana",
    "Alverda",
    "Anita",
    "Arcadia",
    "Aultman",
    "Northern Cambria",
    "Barnesboro",
    "N Cambria",
    "Big Run",
    "Black Lick",
    "Blairsville",
    "Brush Valley",
    "Burnside",
    "Carrolltown",
    "Chambersville",
    "Cherry Tree",
    "Clarksburg",
    "Clune",
    "Clymer",
    "Commodore",
    "Coolspring",
    "Coral",
    "Creekside",
    "De Lancey",
    "Dixonville",
    "Elderton",
    "Elmora",
    "Emeigh",
    "Ernest",
    "Gipsy",
    "Glen Campbell",
    "Hamilton",
    "Heilwood",
    "Hillsdale",
    "Home",
    "Homer City",
    "Graceton",
    "Waterman",
    "Josephine",
    "Kent",
    "La Jose",
    "Lucernemines",
    "McIntyre",
    "Mahaffey",
    "Mcgees Mills",
    "Marion Center",
    "Marsteller",
    "Mentcle",
    "Nicktown",
    "Northpoint",
    "Oliveburg",
    "Penn Run",
    "Punxsutawney",
    "Frostburg",
    "Juneau",
    "Ringgold",
    "Rochester Mills",
    "Rochester Mls",
    "Rossiter",
    "Saint Benedict",
    "St Benedict",
    "Shelocta",
    "Spangler",
    "Sprankle Mills",
    "Sprankle Mls",
    "Starford",
    "Timblin",
    "Torrance",
    "Valier",
    "Walston",
    "West Lebanon",
    "Worthville",
    "Du Bois",
    "Dubois",
    "Benezett",
    "Benezette",
    "Brockport",
    "Brockway",
    "Brookville",
    "Hazen",
    "Byrnedale",
    "Clarington",
    "Corsica",
    "Dagus Mines",
    "Driftwood",
    "Emporium",
    "Falls Creek",
    "Force",
    "Johnsonburg",
    "Kersey",
    "Knox Dale",
    "Luthersburg",
    "Penfield",
    "Reynoldsville",
    "Ridgway",
    "Portland Mills",
    "Portland Mls",
    "Rockton",
    "Saint Marys",
    "Sigel",
    "Hallton",
    "Sinnamahoning",
    "Stump Creek",
    "Summerville",
    "Sykesville",
    "Troutville",
    "Weedville",
    "Wilcox",
    "Johnstown",
    "Conemaugh",
    "Armagh",
    "Beaverdale",
    "Belsano",
    "Bolivar",
    "Cairnbrook",
    "Cassandra",
    "Central City",
    "Colver",
    "Davidsville",
    "Dilltown",
    "Dunlo",
    "Ebensburg",
    "Elton",
    "Hollsopple",
    "Hooversville",
    "Jerome",
    "Lilly",
    "Loretto",
    "Mineral Point",
    "Nanty Glo",
    "New Florence",
    "Parkhill",
    "Portage",
    "Puritan",
    "Revloc",
    "Robinson",
    "Saint Michael",
    "Salix",
    "Seanor",
    "Seward",
    "Sidman",
    "South Fork",
    "Strongstown",
    "Summerhill",
    "Twin Rocks",
    "Vintondale",
    "Wilmore",
    "Windber",
    "Butler",
    "Meridian",
    "Boyers",
    "Annandale",
    "Bruin",
    "Cabot",
    "Marwood",
    "Callery",
    "Chicora",
    "Connoquenessing",
    "Connoqunsg",
    "East Brady",
    "East Butler",
    "Eau Claire",
    "Evans City",
    "Fenelton",
    "Forestville",
    "Foxburg",
    "Harmony",
    "Harrisville",
    "Hilliards",
    "Karns City",
    "Lyndora",
    "Mars",
    "Seven Fields",
    "North Washington",
    "N Washington",
    "Parker",
    "Petrolia",
    "Portersville",
    "Prospect",
    "Renfrew",
    "Saint Petersburg",
    "St Petersburg",
    "Sarver",
    "Saxonburg",
    "Slippery Rock",
    "Valencia",
    "West Sunbury",
    "Zelienople",
    "Cranberry Township",
    "Cranberry Twp",
    "New Castle",
    "Neshannock",
    "Adamsville",
    "Atlantic",
    "Bessemer",
    "Clark",
    "Clarks Mills",
    "Darlington",
    "Edinburg",
    "Ellwood City",
    "Ellport",
    "Enon Valley",
    "Farrell",
    "Fombell",
    "Fredonia",
    "Greenville",
    "Shenango",
    "Grove City",
    "Hadley",
    "Hartstown",
    "Hillsville",
    "Jackson Center",
    "Jackson Ctr",
    "Jamestown",
    "Westford",
    "Koppel",
    "Mercer",
    "New Bedford",
    "New Galilee",
    "New Wilmington",
    "New Wilmngtn",
    "Pulaski",
    "Sandy Lake",
    "Sharon",
    "Hermitage",
    "Sharpsville",
    "Sheakleyville",
    "Stoneboro",
    "Transfer",
    "Villa Maria",
    "Volant",
    "Wampum",
    "West Middlesex",
    "W Middlesex",
    "West Pittsburg",
    "W Pittsburg",
    "Wheatland",
    "Kittanning",
    "Adrian",
    "Beyer",
    "Cadogan",
    "Callensburg",
    "Clarion",
    "Cooksburg",
    "Cowansville",
    "Crown",
    "Dayton",
    "Distant",
    "Fairmount City",
    "Fairmount Cty",
    "Ford City",
    "Ford Cliff",
    "Freeport",
    "Hawthorn",
    "Knox",
    "Leeper",
    "Lucinda",
    "McGrann",
    "Manorville",
    "Marienville",
    "Mayport",
    "New Bethlehem",
    "Climax",
    "Nu Mine",
    "Oak Ridge",
    "Plumville",
    "Rimersburg",
    "Huey",
    "Rural Valley",
    "Sagamore",
    "Seminole",
    "Shippenville",
    "Sligo",
    "Smicksburg",
    "Strattanville",
    "Templeton",
    "Vowinckel",
    "Worthington",
    "Craigsville",
    "Yatesboro",
    "Oil City",
    "Carlton",
    "Chandlers Valley",
    "Chandlrs Vly",
    "Clarendon",
    "Cochranton",
    "Conneaut Lake",
    "Cooperstown",
    "Cranberry",
    "East Hickory",
    "Endeavor",
    "Franklin",
    "Fryburg",
    "Guys Mills",
    "Hydetown",
    "Irvine",
    "Kossuth",
    "Lickingville",
    "Ludlow",
    "Marble",
    "Meadville",
    "Pittsfield",
    "Pleasantville",
    "Polk",
    "Reno",
    "Rouseville",
    "Russell",
    "Seneca",
    "Sheffield",
    "Sugar Grove",
    "Tidioute",
    "Tiona",
    "Tionesta",
    "Titusville",
    "Townville",
    "Tylersburg",
    "Utica",
    "Venus",
    "Warren",
    "North Warren",
    "West Hickory",
    "Youngsville",
    "Clintonville",
    "Emlenton",
    "Kennerdell",
    "Albion",
    "Lundys Lane",
    "Bear Lake",
    "Cambridge Springs",
    "Cambridg Spgs",
    "Centerville",
    "Columbus",
    "Conneautville",
    "Corry",
    "Cranesville",
    "East Springfield",
    "E Springfield",
    "Edinboro",
    "Crossingville",
    "Fairview",
    "Garland",
    "Girard",
    "Grand Valley",
    "Harborcreek",
    "Harmonsburg",
    "Lake City",
    "Linesville",
    "Espyville",
    "McKean",
    "Mckean",
    "Mill Village",
    "North East",
    "North Springfield",
    "N Springfield",
    "Saegertown",
    "Spartansburg",
    "Springboro",
    "Spring Creek",
    "Union City",
    "Venango",
    "Waterford",
    "Wattsburg",
    "West Springfield",
    "W Springfield",
    "Erie",
    "Altoona",
    "Alexandria",
    "Barree",
    "Ashville",
    "Beccaria",
    "Bellwood",
    "Blandburg",
    "Brisbin",
    "Broad Top",
    "Calvin",
    "Cassville",
    "Chest Springs",
    "Claysburg",
    "Coalport",
    "Cresson",
    "Curryville",
    "Defiance",
    "Dudley",
    "Duncansville",
    "Dysart",
    "East Freedom",
    "Entriken",
    "Fallentimber",
    "Flinton",
    "Gallitzin",
    "Glen Hope",
    "Hastings",
    "Hesston",
    "Hollidaysburg",
    "Hopewell",
    "Houtzdale",
    "Ginter",
    "Huntingdon",
    "Imler",
    "Irvona",
    "James Creek",
    "Loysburg",
    "Madera",
    "Martinsburg",
    "New Enterprise",
    "New Entrprise",
    "Newry",
    "Osceola Mills",
    "Osterburg",
    "Saint Clairsv",
    "Saint Clairsville",
    "St Clairsville",
    "St Clrsville",
    "Patton",
    "Petersburg",
    "Queen",
    "Ramey",
    "Riddlesburg",
    "Roaring Spring",
    "Bakers Summit",
    "Roaring Spg",
    "Robertsdale",
    "Saint Boniface",
    "St Boniface",
    "Sandy Ridge",
    "Saxton",
    "Six Mile Run",
    "Smithmill",
    "Sproul",
    "Spruce Creek",
    "Tipton",
    "Todd",
    "Tyrone",
    "Birmingham",
    "Waterfall",
    "Wells Tannery",
    "Westover",
    "Williamsburg",
    "Ganister",
    "Wood",
    "Woodbury",
    "Bradford",
    "Austin",
    "Crosby",
    "Custer City",
    "Cyclone",
    "Ormsby",
    "Derrick City",
    "Duke Center",
    "East Smethport",
    "E Smethport",
    "Eldred",
    "Gifford",
    "Hazel Hurst",
    "James City",
    "Kane",
    "Lewis Run",
    "Mount Jewett",
    "Westline",
    "Port Allegany",
    "Rew",
    "Rixford",
    "Roulette",
    "Shinglehouse",
    "Smethport",
    "Turtlepoint",
    "State College",
    "University Park",
    "Penn St Univ",
    "Penn State University",
    "University Pk",
    "Aaronsburg",
    "Allport",
    "Beech Creek",
    "Bellefonte",
    "Hublersburg",
    "Pleasant Gap",
    "Wingate",
    "Bigler",
    "Blanchard",
    "Boalsburg",
    "Centre Hall",
    "Clarence",
    "Clearfield",
    "Coburn",
    "Curwensville",
    "Drifting",
    "Fleming",
    "Frenchville",
    "Glen Richey",
    "Grampian",
    "Grassflat",
    "Hawk Run",
    "Howard",
    "Hyde",
    "Julian",
    "Karthaus",
    "Kylertown",
    "Lamar",
    "Lanse",
    "Lemont",
    "Madisonburg",
    "Milesburg",
    "Millheim",
    "Mineral Springs",
    "Mineral Spgs",
    "Mingoville",
    "Morrisdale",
    "Moshannon",
    "Munson",
    "New Millport",
    "Olanta",
    "Orviston",
    "Pennsylvania Furnace",
    "Pa Furnace",
    "Philipsburg",
    "Pine Grove Mills",
    "Pine Grv Mls",
    "Port Matilda",
    "Pottersdale",
    "Rebersburg",
    "Snow Shoe",
    "Spring Mills",
    "Wallaceton",
    "Warriors Mark",
    "West Decatur",
    "Winburne",
    "Woodland",
    "Woodward",
    "Wellsboro",
    "Alba",
    "Snydertown",
    "Arnot",
    "Blossburg",
    "Columbia Cross Roads",
    "Columbia X Rd",
    "Coudersport",
    "Oswayo",
    "Covington",
    "Elkland",
    "Gaines",
    "Galeton",
    "Genesee",
    "North Bingham",
    "Gillett",
    "Granville Summit",
    "Granville Smt",
    "Harrison Valley",
    "Harrison Twp",
    "Harrison Vly",
    "Westfield",
    "Knoxville",
    "Lawrenceville",
    "Liberty",
    "Mainesburg",
    "Mansfield",
    "Middlebury Center",
    "Middlebry Ctr",
    "Millerton",
    "Mills",
    "Morris",
    "Morris Run",
    "Nelson",
    "Osceola",
    "Sabinsville",
    "Tioga",
    "Troy",
    "W Burlington",
    "West Burlington Township",
    "Ulysses",
    "Cowanesque",
    "Little Marsh",
    "Allensville",
    "Annville",
    "Belleville",
    "Berrysburg",
    "Blain",
    "Boiling Springs",
    "Boiling Spgs",
    "Burnham",
    "Campbelltown",
    "Camp Hill",
    "Shiremanstown",
    "Carlisle",
    "Carlisle Barracks",
    "Carlisle Brks",
    "Cocolamus",
    "W Pennsboro",
    "West Pennsboro",
    "Cornwall",
    "Dalmatia",
    "Dauphin",
    "Dillsburg",
    "Duncannon",
    "East Waterford",
    "E Waterford",
    "Elizabethtown",
    "Elizabethville",
    "Elizabethvle",
    "Elliottsburg",
    "Green Park",
    "Enola",
    "E Pennsboro",
    "East Pennsboro",
    "Fredericksburg",
    "Fredericksbrg",
    "Grantham",
    "Messiah Coll",
    "Messiah College",
    "Grantville",
    "Granville",
    "Gratz",
    "Halifax",
    "Hershey",
    "Highspire",
    "Honey Grove",
    "Hummelstown",
    "Ickesburg",
    "Jonestown",
    "Kleinfeltersville",
    "Kleinfeltersv",
    "Landisburg",
    "Lawn",
    "Lebanon",
    "Cleona",
    "Colebrook",
    "Cornwall Boro",
    "Cornwall Borough",
    "Lemoyne",
    "Wormleysburg",
    "Lewistown",
    "Liverpool",
    "Swatara Township",
    "Swatara Twp",
    "Loysville",
    "Lykens",
    "McAlisterville",
    "Mc Alistervle",
    "Mechanicsburg",
    "Hampden Township",
    "Hampden Twp",
    "Silver Spg Tp",
    "Silver Spring Township",
    "McVeytown",
    "Mapleton Depot",
    "Mapleton Dep",
    "Marysville",
    "Mattawana",
    "Bowmansdale",
    "Mexico",
    "Middletown",
    "Mifflin",
    "Mifflintown",
    "Mill Creek",
    "Millersburg",
    "Millerstown",
    "Milroy",
    "Mount Gretna",
    "Mount Holly Springs",
    "Mt Holly Spgs",
    "Mount Union",
    "Myerstown",
    "New Bloomfield",
    "New Bloomfld",
    "New Buffalo",
    "New Cumberland",
    "New Cumberlnd",
    "New Germantown",
    "New Germanton",
    "Newmanstown",
    "Newport",
    "Newton Hamilton",
    "Newton Hamltn",
    "Oakland Mills",
    "Ono",
    "Palmyra",
    "Pillow",
    "Plainfield",
    "Port Royal",
    "Reedsville",
    "Richfield",
    "Richland",
    "Schaefferstown",
    "Schaefferstwn",
    "Shermans Dale",
    "Summerdale",
    "Thompsontown",
    "Wiconisco",
    "Williamstown",
    "Yeagertown",
    "Harrisburg",
    "Penbrook",
    "Lower Paxton",
    "Paxtang",
    "Swatara",
    "Linglestown",
    "Paxtonia",
    "West Hanover",
    "Bressler",
    "Oberlin",
    "Steelton",
    "Chambersburg",
    "Guilford Township",
    "Guilford Twp",
    "Amberson",
    "Artemas",
    "Big Cove Tannery",
    "Big Cove Tann",
    "Blairs Mills",
    "Blue Ridge Summit",
    "Blue Ridge Sm",
    "Burnt Cabins",
    "Concord",
    "Doylesburg",
    "Dry Run",
    "Fannettsburg",
    "Fayetteville",
    "Fort Littleton",
    "Fort Littletn",
    "Fort Loudon",
    "Greencastle",
    "Harrisonville",
    "Hustontown",
    "Lurgan",
    "McConnellsburg",
    "Mc Connellsbg",
    "Marion",
    "Mercersburg",
    "Mont Alto",
    "Needmore",
    "Neelyton",
    "Newburg",
    "Newville",
    "Orbisonia",
    "Orrstown",
    "Pleasant Hall",
    "Quincy",
    "Rockhill Furnace",
    "Rockhill Furn",
    "Rouzerville",
    "Roxbury",
    "Saint Thomas",
    "Saltillo",
    "Scotland",
    "Shade Gap",
    "Shippensburg",
    "Shirleysburg",
    "South Mountain",
    "S Mountain",
    "Spring Run",
    "State Line",
    "Three Springs",
    "Upperstrasburg",
    "Upperstrasbrg",
    "Walnut Bottom",
    "Warfordsburg",
    "Waynesboro",
    "Willow Hill",
    "Abbottstown",
    "Airville",
    "Arendtsville",
    "Aspers",
    "Bendersville",
    "Biglerville",
    "Brogue",
    "Codorus",
    "Dallastown",
    "Yoe",
    "Delta",
    "Dover",
    "York",
    "East Berlin",
    "East Prospect",
    "Emigsville",
    "Etters",
    "Fairfield",
    "Greenstone",
    "Fawn Grove",
    "Felton",
    "Franklintown",
    "Gardners",
    "Gettysburg",
    "Glen Rock",
    "Glenville",
    "Brodbecks",
    "Hanover",
    "Lewisberry",
    "Littlestown",
    "Loganville",
    "McKnightstown",
    "Mcknightstown",
    "McSherrystown",
    "Mcsherrystown",
    "Manchester",
    "Mount Wolf",
    "New Freedom",
    "New Oxford",
    "New Park",
    "Orrtanna",
    "Railroad",
    "Red Lion",
    "Seven Valleys",
    "Shrewsbury",
    "Spring Grove",
    "Menges Mills",
    "Stewartstown",
    "Thomasville",
    "Wellsville",
    "Windsor",
    "Wrightsville",
    "York Haven",
    "York New Salem",
    "York Nw Salem",
    "York Springs",
    "East York",
    "Springettsbury Township",
    "Sprngtsbry Tp",
    "West York",
    "Hallam",
    "Hellam",
    "Yorkana",
    "Jacobus",
    "New Salem Borough",
    "New Salem Bro",
    "W Manchester",
    "West Manchester Twp",
    "Akron",
    "Bainbridge",
    "Bausman",
    "Bird In Hand",
    "Blue Ball",
    "Bowmansville",
    "Brownstown",
    "Christiana",
    "Ninepoints",
    "Columbia",
    "Conestoga",
    "Denver",
    "Drumore",
    "East Earl",
    "East Petersburg",
    "E Petersburg",
    "Ephrata",
    "Gap",
    "Gordonville",
    "Holtwood",
    "Intercourse",
    "Kinzers",
    "Kirkwood",
    "Landisville",
    "Salunga",
    "Leola",
    "Lititz",
    "Manheim",
    "Marietta",
    "Maytown",
    "Millersville",
    "Mount Joy",
    "Florin",
    "Mountville",
    "Narvon",
    "New Holland",
    "New Providence",
    "New Providnce",
    "Paradise",
    "Peach Bottom",
    "Pequea",
    "Quarryville",
    "Refton",
    "Reinholds",
    "Rheems",
    "Ronks",
    "Soudersburg",
    "Smoketown",
    "Stevens",
    "Strasburg",
    "Terre Hill",
    "Washington Boro",
    "Wash Boro",
    "Willow Street",
    "Lancaster",
    "Neffsville",
    "Rohrerstown",
    "Williamsport",
    "Armstrong",
    "Bastress",
    "Collomsville",
    "Duboistown",
    "Nisbet",
    "S Williamspor",
    "S Williamsport",
    "S Williamsprt",
    "South Williamsport",
    "Sylvan Dell",
    "Antes Fort",
    "Avis",
    "Cammal",
    "Jersey Shore",
    "Canton",
    "Leroy",
    "Cedar Run",
    "Cogan Station",
    "Cross Fork",
    "Dewart",
    "Eagles Mere",
    "Hughesville",
    "Jersey Mills",
    "Salladasburg",
    "Lairdsville",
    "Linden",
    "Lock Haven",
    "Farrandsville",
    "Flemington",
    "Loganton",
    "Tylersville",
    "McElhattan",
    "McEwensville",
    "Mackeyville",
    "Mill Hall",
    "Montgomery",
    "Montoursville",
    "Muncy",
    "Pennsdale",
    "Muncy Valley",
    "Sonestown",
    "North Bend",
    "Picture Rocks",
    "Ralston",
    "Renovo",
    "Roaring Branch",
    "Roaring Brnch",
    "Shunk",
    "Slate Run",
    "Trout Run",
    "Turbotville",
    "Unityville",
    "Waterville",
    "Watsontown",
    "Westport",
    "Woolrich",
    "Sunbury",
    "Allenwood",
    "Beaver Springs",
    "Beaver Sprgs",
    "Middle Creek",
    "Beavertown",
    "Benton",
    "Bloomsburg",
    "Catawissa",
    "Danville",
    "Dornsife",
    "Elysburg",
    "Freeburg",
    "Hartleton",
    "Herndon",
    "Marion Heights",
    "Marion Height",
    "Kulpmont",
    "Laurelton",
    "Leck Kill",
    "Lewisburg",
    "Locust Gap",
    "McClure",
    "Middleburg",
    "Mifflinburg",
    "Millmont",
    "Millville",
    "Milton",
    "Montandon",
    "Mount Carmel",
    "Mount Pleasant Mills",
    "Mt Pleasant M",
    "Mt Pleasant Mills",
    "New Berlin",
    "New Columbia",
    "Northumberland",
    "Northumberlnd",
    "Numidia",
    "Orangeville",
    "Paxinos",
    "Paxtonville",
    "Penns Creek",
    "Port Trevorton",
    "Port Trevortn",
    "Potts Grove",
    "Coal Township",
    "Excelsior",
    "Ranshaw",
    "Rebuck",
    "Riverside",
    "Selinsgrove",
    "Monroe Township",
    "Monroe Twp",
    "Shamokin",
    "Gowen City",
    "Shamokin Dam",
    "Stillwater",
    "Swengel",
    "Trevorton",
    "Washingtonville",
    "Washingtonvle",
    "Weikert",
    "West Milton",
    "White Deer",
    "Wilburton",
    "Winfield",
    "Pottsville",
    "Aristes",
    "Ashland",
    "Centralia",
    "Helfenstein",
    "Auburn",
    "Branchdale",
    "Brockton",
    "Cressona",
    "Cumbola",
    "Frackville",
    "Friedensburg",
    "Gilberton",
    "Girardville",
    "Gordon",
    "Hegins",
    "Klingerstown",
    "Lavelle",
    "Llewellyn",
    "Locustdale",
    "Lost Creek",
    "Mahanoy City",
    "Morea",
    "New Boston",
    "Mahanoy Plane",
    "Mar Lin",
    "Mary D",
    "Middleport",
    "Minersville",
    "Muir",
    "New Philadelphia",
    "Kaska",
    "New Phila",
    "New Ringgold",
    "Orwigsburg",
    "Pine Grove",
    "Pitman",
    "Port Carbon",
    "Ringtown",
    "Sacramento",
    "Saint Clair",
    "Schuylkill Haven",
    "Landingville",
    "Schuykl Havn",
    "Seltzer",
    "Shenandoah",
    "Lower Shaft",
    "Spring Glen",
    "Summit Station",
    "Summit Sta",
    "Tower City",
    "Tremont",
    "Donaldson",
    "Good Spring",
    "Joliett",
    "Zerbe",
    "Tuscarora",
    "Valley View",
    "Zion Grove",
    "Alburtis",
    "Aquashicola",
    "Bangor",
    "East Bangor",
    "Roseto",
    "Bath",
    "Bethlehem",
    "Fountain Hill",
    "Butztown",
    "Freemansburg",
    "Bowmanstown",
    "Breinigsville",
    "Catasauqua",
    "Center Valley",
    "Cherryville",
    "Coopersburg",
    "Coplay",
    "Danielsville",
    "Easton",
    "Forks Township",
    "Forks Twp",
    "Stockertown Township",
    "Stockrtwn Twp",
    "East Greenville",
    "E Greenville",
    "College Hill",
    "Glendon",
    "West Easton",
    "Williams Township",
    "Williams Twp",
    "Palmer",
    "Palmer Township",
    "Palmer Twp",
    "Tatamy Boro",
    "Tatamy Borough",
    "East Texas",
    "Emmaus",
    "Fogelsville",
    "Whitehall",
    "Hokendauqua",
    "Germansville",
    "Green Lane",
    "Hellertown",
    "Hereford",
    "Kunkletown",
    "Laurys Station",
    "Laurys Sta",
    "Macungie",
    "Martins Creek",
    "Nazareth",
    "Neffs",
    "New Tripoli",
    "Northampton",
    "Orefield",
    "Palm",
    "Palmerton",
    "Pen Argyl",
    "Pennsburg",
    "Red Hill",
    "Perkiomenville",
    "Perkiomenvlle",
    "Riegelsville",
    "Schnecksville",
    "Slatedale",
    "Slatington",
    "Emerald",
    "Springtown",
    "Stockertown",
    "Tatamy",
    "Treichlers",
    "Trexlertown",
    "Walnutport",
    "Wind Gap",
    "Zionsville",
    "Allentown",
    "Wescosville",
    "Hazleton",
    "Hazle Township",
    "Hazle Townshp",
    "Pardeesville",
    "W Hazleton",
    "West Hazleton",
    "Albrightsville",
    "Albrightsvlle",
    "Andreas",
    "Ashfield",
    "Barnesville",
    "Beaver Meadows",
    "Beaver Mdws",
    "Coaldale",
    "Conyngham",
    "Delano",
    "Drifton",
    "Drums",
    "Ebervale",
    "Freeland",
    "Harleigh",
    "Jim Thorpe",
    "Junedale",
    "Kelayres",
    "Lansford",
    "Lattimer Mines",
    "Lattimer Mnes",
    "Lehighton",
    "Lehightn Boro",
    "Lehighton Borough",
    "Weissport",
    "Mcadoo",
    "Kline Township",
    "Kline Twp",
    "Milnesville",
    "Nesquehoning",
    "Nuremberg",
    "Fern Glen",
    "Oneida",
    "Parryville",
    "Quakake",
    "Rock Glen",
    "Sheppton",
    "Sugarloaf",
    "Summit Hill",
    "Tamaqua",
    "Tresckow",
    "Weatherly",
    "Weston",
    "East Stroudsburg",
    "E Stroudsburg",
    "Lehman",
    "Bartonsville",
    "Brodheadsville",
    "Brodheadsvlle",
    "Buck Hill Falls",
    "Buck Hill Fls",
    "Bushkill",
    "Canadensis",
    "Cresco",
    "Paradise Valley",
    "Paradise Vly",
    "Delaware Water Gap",
    "De Water Gap",
    "Dingmans Ferry",
    "Dingmans Fry",
    "Lakeview Township",
    "Lakeview Twp",
    "Effort",
    "Gilbert",
    "Henryville",
    "Kresgeville",
    "Long Pond",
    "Marshalls Creek",
    "Marshalls Crk",
    "Matamoras",
    "Milford",
    "Millrift",
    "Mountainhome",
    "Mount Bethel",
    "Mount Pocono",
    "Pocono Summit",
    "Pocono Lake",
    "Pocono Manor",
    "Pocono Pines",
    "Portland",
    "Saylorsburg",
    "Sciota",
    "Scotrun",
    "Shawnee On Delaware",
    "Shawnee",
    "Shawnee On De",
    "Skytop",
    "Stroudsburg",
    "Swiftwater",
    "Tamiment",
    "Tannersville",
    "Archbald",
    "Eynon",
    "Beach Lake",
    "Carbondale",
    "Childs",
    "Clifford Township",
    "Clifford Twp",
    "Fell Township",
    "Fell Twp",
    "Greenfield Township",
    "Greenfild Twp",
    "Simpson",
    "Clarks Summit",
    "Clarks Green",
    "Ransom Township",
    "Ransom Twp",
    "S Abingtn Twp",
    "Scott Township",
    "Scott Twp",
    "South Abington Township",
    "Waverly Township",
    "Waverly Twp",
    "Clifford",
    "Dalton",
    "N Abingtn Twp",
    "North Abington Township",
    "W Abingtn Twp",
    "West Abington Township",
    "Damascus",
    "Galilee",
    "Equinunk",
    "Factoryville",
    "Fleetville",
    "Forest City",
    "Browndale",
    "Richmondale",
    "Vandling",
    "Gouldsboro",
    "Clifton",
    "Clifton Township",
    "Clifton Twp",
    "Covington Township",
    "Covington Twp",
    "Thornhurst",
    "Greeley",
    "Greentown",
    "Hawley",
    "Blooming Grove",
    "Blooming Grv",
    "Lords Valley",
    "Herrick Center",
    "Herrick Ctr",
    "Honesdale",
    "Bethany",
    "Jermyn",
    "Mayfield",
    "Jessup",
    "Lackawaxen",
    "Lake Ariel",
    "Cobbs Lake Preserve",
    "Cobbs Lk Pres",
    "Jefferson Township",
    "Jefferson Twp",
    "Mount Cobb",
    "Roaring Bk Tp",
    "Roaring Brook Twp",
    "Lake Como",
    "Lakeville",
    "Lakewood",
    "La Plume",
    "Lenoxville",
    "Nicholson",
    "Milanville",
    "Moscow",
    "Elmhurst Township",
    "Elmhurst Twp",
    "Madison Township",
    "Madison Twp",
    "Spring Brook Township",
    "Sprng Brk Twp",
    "Newfoundland",
    "S Sterling",
    "South Sterling",
    "Olyphant",
    "Blakely",
    "Dickson Cty",
    "Paupack",
    "Peckville",
    "Pleasant Mount",
    "Pleasant Mt",
    "Poyntelle",
    "Preston Park",
    "Prompton",
    "Rowland",
    "Shohola",
    "Starlight",
    "Starrucca",
    "Sterling",
    "Tafton",
    "Thompson",
    "Tobyhanna",
    "Coolbaugh Township",
    "Coolbaugh Twp",
    "Tyler Hill",
    "Union Dale",
    "Waverly",
    "Waymart",
    "White Mills",
    "Scranton",
    "Moosic",
    "N Scranton",
    "North Scranton",
    "Dunmore",
    "Throop",
    "Taylor",
    "Old Forge",
    "Dickson City",
    "Bear Creek",
    "Berwick",
    "Blakeslee",
    "Dallas",
    "Dushore",
    "Forkston Township",
    "Forkston Twp",
    "Wilmot Township",
    "Wilmot Twp",
    "Falls",
    "Forksville",
    "Glen Lyon",
    "Harveys Lake",
    "Hillsgrove",
    "Hunlock Creek",
    "Hunlock Township",
    "Hunlock Twp",
    "Huntington Mills",
    "Huntington Ml",
    "Laceyville",
    "Lake Harmony",
    "Lake Winola",
    "Laporte",
    "Lopez",
    "Mehoopany",
    "Meshoppen",
    "Mifflinville",
    "Mildred",
    "Nanticoke",
    "Nescopeck",
    "Noxen",
    "Pittston",
    "Hughestown",
    "Inkerman",
    "Jenkins Township",
    "Jenkins Twp",
    "Pittston Township",
    "Pittston Twp",
    "Port Griffith",
    "Yatesville",
    "Avoca",
    "Dupont",
    "Duryea",
    "Exeter",
    "Harding",
    "West Pittston",
    "Wyoming",
    "West Wyoming",
    "Plymouth",
    "Larksville",
    "Shickshinny",
    "Mocanaqua",
    "Sweet Valley",
    "Tunkhannock",
    "Mehoopany Twp",
    "Wapwallopen",
    "White Haven",
    "Wilkes Barre",
    "Bear Creek Township",
    "Bear Crk Twp",
    "City Of Wb",
    "City Of Wilkes Barre",
    "Hilldale",
    "Hudson",
    "Korn Krest",
    "Plains",
    "Plains Township",
    "Plains Twp",
    "Wilkes Barre Township",
    "Wlks Barr Twp",
    "Kingston",
    "Courtdale",
    "Edwardsville",
    "Forty Fort",
    "Pringle",
    "Swoyersville",
    "Miners Mill",
    "Parsons",
    "Ashley",
    "Hanover Township",
    "Hanover Twp",
    "Laurel Run",
    "Sugar Notch",
    "Warrior Run",
    "Mountain Top",
    "Nuangola",
    "Shavertown",
    "Jackson Township",
    "Jackson Twp",
    "Trucksville",
    "Luzerne",
    "Montrose",
    "Athens",
    "Brackney",
    "Burlington",
    "Dimock",
    "East Smithfield",
    "E Smithfield",
    "Friendsville",
    "Gibson",
    "Great Bend",
    "Hallstead",
    "Harford",
    "Hop Bottom",
    "Jackson",
    "Kingsley",
    "Lawton",
    "Rushville",
    "Le Raysville",
    "Little Meadows",
    "Little Mdws",
    "Milan",
    "Monroeton",
    "New Albany",
    "New Milford",
    "Rome",
    "Sayre",
    "South Waverly",
    "South Gibson",
    "South Montrose",
    "S Montrose",
    "Springville",
    "Stevensville",
    "Sugar Run",
    "Susquehanna",
    "Towanda",
    "Burlingtn Twp",
    "Burlington Township",
    "Ulster",
    "Warren Center",
    "Wyalusing",
    "Wysox",
    "Doylestown",
    "New Britain",
    "Buckingham",
    "Carversville",
    "Chalfont",
    "Colmar",
    "Dublin",
    "Erwinna",
    "Ferndale",
    "Fountainville",
    "Furlong",
    "Hilltown",
    "Jamison",
    "Kintnersville",
    "Line Lexington",
    "Line Lxngtn",
    "Lumberville",
    "Milford Square",
    "Milford Sq",
    "Montgomeryville",
    "Montgomeryvle",
    "New Hope",
    "Newtown",
    "George School",
    "Upper Makefield",
    "Upr Makefield",
    "Ottsville",
    "Perkasie",
    "Pineville",
    "Pipersville",
    "Point Pleasant",
    "Pt Pleasant",
    "Quakertown",
    "Richboro",
    "Southampton",
    "Richlandtown",
    "Sellersville",
    "Silverdale",
    "Souderton",
    "Telford",
    "Churchville",
    "Holland",
    "Indian Valley",
    "Trumbauersville",
    "Trumbaursvlle",
    "Upper Black Eddy",
    "Uppr Blck Edy",
    "Warminster",
    "Hartsville",
    "Ivyland",
    "Warwick",
    "Warrington",
    "Washington Crossing",
    "Washington Xing",
    "Wshngtn Xing",
    "Wycombe",
    "Abington",
    "Ogontz Campus",
    "Roslyn",
    "Ambler",
    "Lower Gwynedd",
    "Maple Glen",
    "Ardmore",
    "Bala Cynwyd",
    "Belmont Hills",
    "Huntingdon Valley",
    "Huntingdon Vy",
    "Bristol",
    "Edgely",
    "Tullytown",
    "West Bristol",
    "Broomall",
    "Radnor",
    "Bryn Athyn",
    "Bryn Mawr",
    "Cheltenham",
    "Chester",
    "Chester Township",
    "Chester Twp",
    "Eddystone",
    "Upper Chichester",
    "Uppr Chichstr",
    "Aston",
    "Brookhaven",
    "Upland",
    "Chester Heights",
    "Chester Hts",
    "Clifton Heights",
    "Aldan",
    "Clifton Hts",
    "Primos",
    "Primos Secane",
    "Secane",
    "Bensalem",
    "Andalusia",
    "Cornwells Heights",
    "Cornwells Hts",
    "Eddington",
    "Croydon",
    "Crum Lynne",
    "Darby",
    "Collingdale",
    "Dresher",
    "Drexel Hill",
    "Pilgrim Gardens",
    "Pilgrim Gdns",
    "Elkins Park",
    "Lamott",
    "Melrose",
    "Melrose Park",
    "Essington",
    "Lester",
    "Fairless Hills",
    "Fairless Hls",
    "Flourtown",
    "Folcroft",
    "Folsom",
    "Milmont Park",
    "Fort Washington",
    "Ft Washington",
    "Gladwyne",
    "Glenolden",
    "Glenside",
    "Erdenheim",
    "Laverock",
    "Wyndmoor",
    "Hatboro",
    "Uppr Moreland",
    "Haverford",
    "Holmes",
    "Horsham",
    "Jenkintown",
    "Foxcroft Sq",
    "Foxcroft Square",
    "Hollywood",
    "Meadowbrook",
    "Rockledge",
    "Rydal",
    "Langhorne",
    "Hulmeville",
    "Penndel",
    "Upper Holland",
    "Lansdowne",
    "E Lansdowne",
    "East Lansdowne",
    "Yeadon",
    "Lenni",
    "Feasterville Trevose",
    "Fstrvl Trvose",
    "Oakford",
    "Trevose",
    "Levittown",
    "Fallsington",
    "Newportville",
    "Garnet Valley",
    "Boothwyn",
    "Marcus Hook",
    "Linwood",
    "Ogden",
    "Trainer",
    "Media",
    "Elwyn",
    "Garden City",
    "Glen Riddle",
    "Rose Valley",
    "Springfield",
    "Merion Station",
    "Merion Sta",
    "Morrisville",
    "Yardley",
    "Morton",
    "Ridley",
    "Rutledge",
    "Narberth",
    "Penn Valley",
    "Newtown Square",
    "Newtown Sq",
    "Norwood",
    "Oreland",
    "Prospect Park",
    "Ridley Park",
    "Sharon Hill",
    "Swarthmore",
    "Upper Darby",
    "Bywood",
    "Highland Park",
    "Kirklyn",
    "Millbourne",
    "Havertown",
    "Lower Merion",
    "Villanova",
    "Wallingford",
    "Wayne",
    "Chesterbrook",
    "Saint Davids",
    "St Davids",
    "Strafford",
    "Willow Grove",
    "Woodlyn",
    "Wyncote",
    "Wynnewood",
    "Carroll Park",
    "Penn Wynne",
    "Philadelphia",
    "Mid City East",
    "Middle City East",
    "Phila",
    "Mid City West",
    "Middle City West",
    "William Penn Annex East",
    "Wm Penn Anx E",
    "William Penn Annex West",
    "Wm Penn Anx W",
    "Manayunk",
    "Overbrook Hills",
    "Overbrook Hls",
    "Paoli",
    "Atglen",
    "Steelville",
    "Avondale",
    "Berwyn",
    "Tredyffrin",
    "Brandamore",
    "Chadds Ford",
    "Cheyney",
    "Coatesville",
    "E Fallowfield",
    "East Fallowfield Township",
    "Romansville",
    "Valley Township",
    "Valley Twp",
    "W Brandywine",
    "West Bradford",
    "West Brandywine",
    "Cochranville",
    "Devon",
    "Downingtown",
    "Exton",
    "Franklin Center",
    "Franklin Ctr",
    "Glen Mills",
    "Glenmoore",
    "Honey Brook",
    "Immaculata",
    "Kennett Square",
    "Kennett Sq",
    "Landenberg",
    "Lincoln University",
    "Lincoln Univ",
    "New Londn Twp",
    "New London Township",
    "Newlondon Twp",
    "Malvern",
    "Frazer",
    "Modena",
    "Nottingham",
    "Oxford",
    "Parkesburg",
    "Pomeroy",
    "Sadsburyville",
    "Thorndale",
    "Thornton",
    "Toughkenamon",
    "Unionville",
    "West Chester",
    "West Grove",
    "Chatham",
    "Norristown",
    "Black Horse",
    "East Norriton",
    "Audubon",
    "Eagleville",
    "Jeffersonville",
    "Jeffersonvlle",
    "Trooper",
    "Bridgeport",
    "King Of Prussia",
    "Kng Of Prussa",
    "Blue Bell",
    "Center Square",
    "Penllyn",
    "Chester Springs",
    "Chester Sprgs",
    "Collegeville",
    "Trappe",
    "Conshohocken",
    "Gulph Mills",
    "W Cnshohocken",
    "Frederick",
    "Gwynedd",
    "North Wales",
    "Spring House",
    "Gwynedd Valley",
    "Gwynedd Vly",
    "Harleysville",
    "Lower Salford",
    "Hatfield",
    "North Penn",
    "Kimberton",
    "Lafayette Hill",
    "Lafayette Hl",
    "Miquon",
    "Lansdale",
    "Upper Gwynedd",
    "Mont Clare",
    "Phoenixville",
    "Oaks",
    "Parker Ford",
    "Plymouth Meeting",
    "Plymouth Mtng",
    "Pottstown",
    "Sanatoga",
    "Stowe",
    "Royersford",
    "Limerick",
    "Linfield",
    "Sassamansville",
    "Sassamansvlle",
    "Schwenksville",
    "Delphi",
    "Fruitville",
    "Neiffer",
    "Skippack",
    "Spring City",
    "Worcester",
    "Zieglerville",
    "Zieglersville",
    "Adamstown",
    "Bally",
    "Barto",
    "Bechtelsville",
    "Bernville",
    "Bethel",
    "Birdsboro",
    "Blandon",
    "Bowers",
    "Boyertown",
    "Centerport",
    "Douglassville",
    "Earlville",
    "Elverson",
    "Fleetwood",
    "Evansville",
    "Ruscmbmnr Twp",
    "Ruscombmanor Twp",
    "Geigertown",
    "Gilbertsville",
    "Hamburg",
    "Kempton",
    "Stony Run",
    "Kutztown",
    "Leesport",
    "Dauberville",
    "Lenhartsville",
    "Limekiln",
    "Lyon Station",
    "Maxatawny",
    "Mertztown",
    "Mohnton",
    "Mohrsville",
    "Morgantown",
    "Mount Aetna",
    "New Berlinville",
    "New Berlinvle",
    "Oley",
    "Port Clinton",
    "Rehrersburg",
    "Robesonia",
    "Shartlesville",
    "Shoemakersville",
    "Shoemakersvle",
    "Strausstown",
    "Temple",
    "Topton",
    "Virginville",
    "Wernersville",
    "Womelsdorf",
    "Stouchsburg",
    "Reading",
    "Laureldale",
    "Muhlenberg",
    "Muhlenberg Township",
    "Ontelaunee",
    "Mount Penn",
    "Reading Sta",
    "Reading Station",
    "Shillington",
    "S Heidelberg",
    "Sinking Spg",
    "Sinking Spring",
    "South Heidelberg Twp",
    "West Lawn",
    "Wyomissing",
    "West Reading",
  ],
  PR: [
    "Adjuntas",
    "Aguada",
    "Aguadilla",
    "Ramey",
    "Maricao",
    "Anasco",
    "Angeles",
    "Arecibo",
    "Bajadero",
    "Barceloneta",
    "Boqueron",
    "Cabo Rojo",
    "Penuelas",
    "Camuy",
    "Castaner",
    "Rosario",
    "Sabana Grande",
    "Ciales",
    "Utuado",
    "Dorado",
    "Ensenada",
    "Florida",
    "Garrochales",
    "Guanica",
    "Guayanilla",
    "Hatillo",
    "Hormigueros",
    "Isabela",
    "Jayuya",
    "Lajas",
    "Lares",
    "Las Marias",
    "Manati",
    "Moca",
    "Rincon",
    "Quebradillas",
    "Mayaguez",
    "San German",
    "San Sebastian",
    "Morovis",
    "Sabana Hoyos",
    "San Antonio",
    "Vega Alta",
    "Vega Baja",
    "Yauco",
    "Aguas Buenas",
    "Aguirre",
    "Aibonito",
    "Maunabo",
    "Arroyo",
    "Mercedita",
    "Ponce",
    "Naguabo",
    "Naranjito",
    "Orocovis",
    "Patillas",
    "Caguas",
    "Canovanas",
    "Ceiba",
    "Roosevelt Rds",
    "Roosevelt Roads",
    "Cayey",
    "Fajardo",
    "Cidra",
    "Puerto Real",
    "Punta Santiago",
    "Punta Stgo",
    "Rio Grande",
    "Salinas",
    "San Lorenzo",
    "Santa Isabel",
    "Vieques",
    "Villalba",
    "Yabucoa",
    "Coamo",
    "Las Piedras",
    "Loiza",
    "Luquillo",
    "Culebra",
    "Juncos",
    "Gurabo",
    "Coto Laurel",
    "Comerio",
    "Corozal",
    "Guayama",
    "La Plata",
    "Humacao",
    "Barranquitas",
    "Juana Diaz",
    "San Juan",
    "Old San Juan",
    "Viejo San Juan",
    "Viejo Sn Juan",
    "Pta De Tierra",
    "Puerta De Tierra",
    "Condado",
    "Miramar",
    "Santurce",
    "Fdez Juncos",
    "Fernandez Juncos",
    "Minillas",
    "Isla Verde",
    "Barrio Obrero",
    "Bo Obrero",
    "Hato Rey",
    "Caparra",
    "Caparra Hills",
    "Caparra Ter",
    "Caparra Terrace",
    "Pto Nuevo",
    "Puerto Nuevo",
    "College Park",
    "Rio Piedras",
    "Cupey",
    "Fort Buchanan",
    "Toa Baja",
    "Levittown",
    "Sabana Seca",
    "Toa Alta",
    "Bayamon",
    "Catano",
    "Guaynabo",
    "Trujillo Alto",
    "Trujillo",
    "Carolina",
  ],
  RI: [
    "Albion",
    "Ashaway",
    "Barrington",
    "Block Island",
    "New Shoreham",
    "Bradford",
    "Bristol",
    "Carolina",
    "Richmond",
    "Charlestown",
    "Chepachet",
    "Clayville",
    "Coventry",
    "West Greenwich",
    "W Greenwich",
    "East Greenwich",
    "E Greenwich",
    "Exeter",
    "Escoheag",
    "Fiskeville",
    "Forestdale",
    "Foster",
    "Glendale",
    "Greene",
    "Greenville",
    "Harmony",
    "Harrisville",
    "Burrillville",
    "Hope",
    "Hope Valley",
    "Hopkinton",
    "Jamestown",
    "Kenyon",
    "Little Compton",
    "L Compton",
    "Manville",
    "Mapleville",
    "Newport",
    "Middletown",
    "North Kingstown",
    "N Kingstown",
    "North Scituate",
    "N Scituate",
    "Scituate",
    "Oakland",
    "Pascoag",
    "Pawtucket",
    "Central Falls",
    "Cumberland",
    "Lincoln",
    "Portsmouth",
    "Prudence Island",
    "Prudence Isl",
    "Rockville",
    "Saunderstown",
    "Shannock",
    "Slatersville",
    "Tiverton",
    "Wakefield",
    "Narragansett",
    "Peace Dale",
    "S Kingstown",
    "South Kingstown",
    "Kingston",
    "Point Judith",
    "Warren",
    "Warwick",
    "Westerly",
    "West Kingston",
    "West Warwick",
    "Wood River Junction",
    "Wood River Jt",
    "Woonsocket",
    "North Smithfield",
    "N Smithfield",
    "Wyoming",
    "Providence",
    "N Providence",
    "North Providence",
    "Cranston",
    "East Providence",
    "E Providence",
    "Riverside",
    "Rumford",
    "Smithfield",
    "Johnston",
  ],
  SC: [
    "Alcolu",
    "Bamberg",
    "Batesburg",
    "Batesburg Leesville",
    "Batsbrg Levil",
    "Bethune",
    "Bishopville",
    "Wisacky",
    "Blackstock",
    "Blair",
    "Blythewood",
    "Bowman",
    "Camden",
    "Cameron",
    "Lone Star",
    "Carlisle",
    "Cassatt",
    "Cayce",
    "West Columbia",
    "Chapin",
    "Chappells",
    "Cope",
    "Cordova",
    "Dalzell",
    "Denmark",
    "Eastover",
    "Mcentire Jngb",
    "Elgin",
    "Elliott",
    "Elloree",
    "Eutawville",
    "Gable",
    "Gadsden",
    "Gaston",
    "Gilbert",
    "Great Falls",
    "Greeleyville",
    "Heath Springs",
    "Holly Hill",
    "Hopkins",
    "Horatio",
    "Irmo",
    "Jenkinsville",
    "Monticello",
    "Kershaw",
    "Lamar",
    "Leesville",
    "Lexington",
    "Liberty Hill",
    "Little Mountain",
    "Little Mtn",
    "Lugoff",
    "Lydia",
    "Lynchburg",
    "Ehrhardt",
    "Lodge",
    "McBee",
    "Manning",
    "Paxville",
    "Mayesville",
    "Saint Charles",
    "Monetta",
    "Neeses",
    "Livingston",
    "Newberry",
    "New Zion",
    "North",
    "Norway",
    "Olanta",
    "Orangeburg",
    "Peak",
    "Pelion",
    "Pinewood",
    "Rimini",
    "Pomaria",
    "Prosperity",
    "Rembert",
    "Borden",
    "Ridge Spring",
    "Ridgeway",
    "Rowesville",
    "Saint Matthews",
    "Fort Motte",
    "St Matthews",
    "Salley",
    "Perry",
    "Saluda",
    "Santee",
    "Silverstreet",
    "Springfield",
    "Summerton",
    "Sumter",
    "Oswego",
    "Shaw Afb",
    "Swansea",
    "Timmonsville",
    "Turbeville",
    "Vance",
    "Wagener",
    "Ward",
    "Wedgefield",
    "Westville",
    "White Rock",
    "Whitmire",
    "Winnsboro",
    "White Oak",
    "Columbia",
    "Spartanburg",
    "Boiling Springs",
    "Boiling Spgs",
    "Arcadia",
    "Buffalo",
    "Campobello",
    "Chesnee",
    "Clifton",
    "Clinton",
    "Converse",
    "Cowpens",
    "Cross Anchor",
    "Cross Hill",
    "Drayton",
    "Duncan",
    "Enoree",
    "Fingerville",
    "Gaffney",
    "Glendale",
    "Inman",
    "Joanna",
    "Jonesville",
    "Kinards",
    "Landrum",
    "Laurens",
    "Lockhart",
    "Lyman",
    "Mayo",
    "Moore",
    "Mountville",
    "Pacolet",
    "Pacolet Mills",
    "Pauline",
    "Glenn Springs",
    "Reidville",
    "Roebuck",
    "Startex",
    "Una",
    "Union",
    "Waterloo",
    "Wellford",
    "Woodruff",
    "Charleston",
    "Charleston Afb",
    "Chas AFB",
    "Joint Base Charleston",
    "Jt Base Chas",
    "North Charleston",
    "N Charleston",
    "Hanahan",
    "Adams Run",
    "Jericho",
    "Awendaw",
    "Mount Pleasant",
    "Mt Pleasant",
    "Bonneau",
    "Branchville",
    "Cordesville",
    "Cottageville",
    "Cross",
    "Dorchester",
    "Edisto Island",
    "Edisto",
    "Folly Beach",
    "Georgetown",
    "Goose Creek",
    "Green Pond",
    "Greenpond",
    "Harleyville",
    "Hollywood",
    "Meggett",
    "Yonges Island",
    "Huger",
    "Isle Of Palms",
    "Dewees Island",
    "Jacksonboro",
    "Jamestown",
    "Shulerville",
    "Johns Island",
    "Kiawah Island",
    "Seabrook Isl",
    "Seabrook Island",
    "Ladson",
    "McClellanville",
    "Mcclellanvle",
    "Moncks Corner",
    "Pineville",
    "Pinopolis",
    "Ravenel",
    "Reevesville",
    "Ridgeville",
    "Round O",
    "Ruffin",
    "Saint George",
    "Saint Stephen",
    "Alvin",
    "Smoaks",
    "Sullivans Island",
    "Sullivans Is",
    "Summerville",
    "Knightsville",
    "Lincolnville",
    "Wadmalaw Island",
    "Wadmalaw Is",
    "Walterboro",
    "Ritter",
    "Cainhoy",
    "Daniel Island",
    "Wando",
    "Williams",
    "Florence",
    "Quinby",
    "Andrews",
    "Aynor",
    "Bennettsville",
    "Blenheim",
    "Cades",
    "Centenary",
    "Cheraw",
    "Clio",
    "Conway",
    "Bucksport",
    "Coward",
    "Darlington",
    "Dillon",
    "Floyd Dale",
    "Effingham",
    "Fork",
    "Galivants Ferry",
    "Galivants Fry",
    "Green Sea",
    "Gresham",
    "Brittons Neck",
    "Hamer",
    "S Of Border",
    "South Of The Border",
    "Hartsville",
    "Hemingway",
    "Johnsonville",
    "Poston",
    "Kingstree",
    "Lake City",
    "Lake View",
    "Lane",
    "Latta",
    "Little River",
    "Little Rock",
    "Longs",
    "Loris",
    "McColl",
    "Marion",
    "Myrtle Beach",
    "Mullins",
    "Surfside Bch",
    "Surfside Beach",
    "Murrells Inlet",
    "Murrells Inlt",
    "Nesmith",
    "Nichols",
    "North Myrtle Beach",
    "Atlantic Bch",
    "Atlantic Beach",
    "Cherry Grove",
    "Cherry Grove Beach",
    "N Myrtle Bch",
    "Ocean Drive",
    "Pamplico",
    "Patrick",
    "Pawleys Island",
    "Litchfield",
    "N Litchfield",
    "Pawleys Isl",
    "Rains",
    "Salters",
    "Trio",
    "Scranton",
    "Sellers",
    "Society Hill",
    "Tatum",
    "Wallace",
    "Greenville",
    "Powdersville",
    "Abbeville",
    "Anderson",
    "Belton",
    "Calhoun Falls",
    "Central",
    "Clemson",
    "Cleveland",
    "Donalds",
    "Shoals Jct",
    "Shoals Junction",
    "Due West",
    "Easley",
    "Fair Play",
    "Fountain Inn",
    "Gray Court",
    "Greenwood",
    "Greer",
    "Hodges",
    "Honea Path",
    "Iva",
    "Liberty",
    "Long Creek",
    "Lowndesville",
    "Marietta",
    "Mauldin",
    "Mountain Rest",
    "Newry",
    "Ninety Six",
    "Norris",
    "Cateechee",
    "Pelzer",
    "Pendleton",
    "Pickens",
    "Seneca",
    "Piedmont",
    "Salem",
    "Simpsonville",
    "Six Mile",
    "Slater",
    "Starr",
    "Sunset",
    "Tamassee",
    "Taylors",
    "Townville",
    "Travelers Rest",
    "Travelers Rst",
    "Walhalla",
    "Ware Shoals",
    "Westminster",
    "Madison",
    "West Union",
    "Williamston",
    "Blacksburg",
    "Cherokee Falls",
    "Cherokee Fls",
    "Kings Creek",
    "Catawba",
    "Chester",
    "Fort Mill",
    "Indian Land",
    "Tega Cay",
    "Chesterfield",
    "Clover",
    "Lake Wylie",
    "River Hills",
    "Edgemoor",
    "Fort Lawn",
    "Hickory Grove",
    "Jefferson",
    "Lancaster",
    "Lando",
    "McConnells",
    "Mount Croghan",
    "Pageland",
    "Richburg",
    "Rock Hill",
    "Ruby",
    "Sharon",
    "Smyrna",
    "York",
    "Aiken",
    "Vaucluse",
    "New Ellenton",
    "Allendale",
    "Barnwell",
    "Kline",
    "Bath",
    "Blackville",
    "Bradley",
    "Clarks Hill",
    "Edgefield",
    "Elko",
    "Fairfax",
    "Gloverville",
    "Graniteville",
    "Jackson",
    "Johnston",
    "Langley",
    "McCormick",
    "Martin",
    "Modoc",
    "Mount Carmel",
    "North Augusta",
    "Beech Island",
    "Belvedere",
    "Clearwater",
    "Olar",
    "Parksville",
    "Plum Branch",
    "Trenton",
    "Troy",
    "Ulmer",
    "Warrenville",
    "Williston",
    "Windsor",
    "Beaufort",
    "Parris Island",
    "Ladys Island",
    "Okatie",
    "Bluffton",
    "Brunson",
    "Coosawhatchie",
    "Daufuskie Island",
    "Daufuskie Is",
    "Early Branch",
    "Estill",
    "Saint Helena Island",
    "Fripp Island",
    "St Helena Is",
    "Furman",
    "Garnett",
    "Gifford",
    "Hampton",
    "Hilton Head Island",
    "Hilton Head",
    "Hardeeville",
    "Islandton",
    "Luray",
    "Pineland",
    "Port Royal",
    "Ridgeland",
    "Scotia",
    "Seabrook",
    "Sheldon",
    "Tillman",
    "Varnville",
    "Yemassee",
  ],
  SD: [
    "Alcester",
    "Aurora",
    "Baltic",
    "Beresford",
    "Brandon",
    "Corson",
    "Rowena",
    "Brookings",
    "Burbank",
    "Canistota",
    "Canton",
    "Centerville",
    "Chancellor",
    "Chester",
    "Brant Lake",
    "Colman",
    "Colton",
    "Crooks",
    "Renner",
    "Davis",
    "Dell Rapids",
    "Egan",
    "Elk Point",
    "Elkton",
    "Ward",
    "Fairview",
    "Flandreau",
    "Freeman",
    "Garretson",
    "Sherman",
    "Gayville",
    "Harrisburg",
    "Hartford",
    "Hudson",
    "Humboldt",
    "Hurley",
    "Irene",
    "Jefferson",
    "Lennox",
    "Lesterville",
    "Lyons",
    "Madison",
    "Marion",
    "Menno",
    "Mission Hill",
    "Monroe",
    "Montrose",
    "North Sioux City",
    "Dakota Dunes",
    "Mccook Lake",
    "N Sioux City",
    "Nunda",
    "Oldham",
    "Olivet",
    "Parker",
    "Ramona",
    "Rutland",
    "Salem",
    "Scotland",
    "Sinai",
    "Springfield",
    "Running Water",
    "Tabor",
    "Tea",
    "Trent",
    "Tyndall",
    "Utica",
    "Valley Springs",
    "Valley Spgs",
    "Vermillion",
    "Meckling",
    "Viborg",
    "Volga",
    "Volin",
    "Wakonda",
    "Wentworth",
    "Winfred",
    "Worthing",
    "Yankton",
    "Sioux Falls",
    "Buffalo Ridge",
    "Watertown",
    "Waverly",
    "Arlington",
    "Hetland",
    "Astoria",
    "Badger",
    "Big Stone City",
    "Big Stone Cty",
    "Bradley",
    "Crocker",
    "Brandt",
    "Bristol",
    "Butler",
    "Bruce",
    "Bryant",
    "Castlewood",
    "Claire City",
    "Clark",
    "Clear Lake",
    "Altamont",
    "Corona",
    "De Smet",
    "Eden",
    "Erwin",
    "Estelline",
    "Dempster",
    "Florence",
    "Garden City",
    "Gary",
    "Goodwin",
    "Bemis",
    "Grenville",
    "Hayti",
    "Hazel",
    "Henry",
    "Kranzburg",
    "Labolt",
    "Lake City",
    "Lake Norden",
    "Lake Preston",
    "Marvin",
    "Milbank",
    "New Effington",
    "Ortley",
    "Peever",
    "Raymond",
    "Revillo",
    "Albee",
    "Rosholt",
    "Roslyn",
    "Sisseton",
    "Agency Village",
    "Agency Vlg",
    "South Shore",
    "Stockholm",
    "Strandburg",
    "Summit",
    "Toronto",
    "Twin Brooks",
    "Veblen",
    "Vienna",
    "Wallace",
    "Waubay",
    "Webster",
    "Lily",
    "White",
    "Bushnell",
    "Willow Lake",
    "Wilmot",
    "Mitchell",
    "Loomis",
    "Alexandria",
    "Farmer",
    "Alpena",
    "Armour",
    "Artesian",
    "Forestburg",
    "Avon",
    "Bonesteel",
    "Bridgewater",
    "Dolton",
    "Canova",
    "Carpenter",
    "Carthage",
    "Cavour",
    "Chamberlain",
    "Corsica",
    "Dante",
    "Delmont",
    "Dimock",
    "Emery",
    "Ethan",
    "Fairfax",
    "Fedora",
    "Fort Thompson",
    "Fulton",
    "Gann Valley",
    "Geddes",
    "Harrison",
    "Highmore",
    "Stephan",
    "Hitchcock",
    "Howard",
    "Roswell",
    "Huron",
    "Iroquois",
    "Bancroft",
    "Kaylor",
    "Kimball",
    "Lake Andes",
    "Ravinia",
    "Lane",
    "Letcher",
    "Marty",
    "Miller",
    "Mount Vernon",
    "New Holland",
    "Oacoma",
    "Parkston",
    "Pickstown",
    "Plankinton",
    "Platte",
    "Academy",
    "Pukwana",
    "Ree Heights",
    "Saint Lawrence",
    "St Lawrence",
    "Spencer",
    "Stickney",
    "Tripp",
    "Virgil",
    "Wagner",
    "Wessington",
    "Wessington Springs",
    "Wessingtn Spg",
    "White Lake",
    "Wolsey",
    "Woonsocket",
    "Yale",
    "Aberdeen",
    "Akaska",
    "Amherst",
    "Andover",
    "Ashton",
    "Athol",
    "Barnard",
    "Bath",
    "Bowdle",
    "Brentford",
    "Britton",
    "Claremont",
    "Columbia",
    "Conde",
    "Verdon",
    "Cresbard",
    "Doland",
    "Eureka",
    "Artas",
    "Faulkton",
    "Miranda",
    "Norbeck",
    "Wecota",
    "Ferney",
    "Frankfort",
    "Frederick",
    "Gettysburg",
    "Groton",
    "Hecla",
    "Hosmer",
    "Houghton",
    "Hoven",
    "Ipswich",
    "Mina",
    "Java",
    "Langford",
    "Lebanon",
    "Leola",
    "Long Lake",
    "Mansfield",
    "Mellette",
    "Northville",
    "Chelsea",
    "Onaka",
    "Orient",
    "Pierpont",
    "Redfield",
    "Zell",
    "Rockham",
    "Roscoe",
    "Selby",
    "Lowry",
    "Seneca",
    "Stratford",
    "Tolstoy",
    "Tulare",
    "Turton",
    "Warner",
    "Westport",
    "Wetonka",
    "Pierre",
    "Agar",
    "Belvidere",
    "Blunt",
    "Burke",
    "Lucas",
    "Colome",
    "Dallas",
    "Dixon",
    "Draper",
    "Fort Pierre",
    "Mission Ridge",
    "Gregory",
    "Iona",
    "Hamill",
    "Harrold",
    "Hayes",
    "Herrick",
    "Holabird",
    "Ideal",
    "Kadoka",
    "Kennebec",
    "Long Valley",
    "Lower Brule",
    "Martin",
    "Vetal",
    "Midland",
    "Ottumwa",
    "Milesville",
    "Mission",
    "Murdo",
    "Norris",
    "Okaton",
    "Okreek",
    "Onida",
    "Parmelee",
    "Philip",
    "Presho",
    "Reliance",
    "Rosebud",
    "Saint Charles",
    "St Charles",
    "Saint Francis",
    "Tuthill",
    "Vivian",
    "Wanblee",
    "White River",
    "Cedarbutte",
    "Winner",
    "Carter",
    "Clearfield",
    "Keyapaha",
    "Millboro",
    "Wewela",
    "Witten",
    "Wood",
    "Mobridge",
    "Bison",
    "Bullhead",
    "Cherry Creek",
    "Dupree",
    "Eagle Butte",
    "Parade",
    "Faith",
    "Glencross",
    "Glenham",
    "Herreid",
    "Isabel",
    "Firesteel",
    "Keldron",
    "Lantry",
    "Lemmon",
    "Shadehill",
    "Thunder Hawk",
    "Little Eagle",
    "Lodgepole",
    "McIntosh",
    "McLaughlin",
    "Kenel",
    "Meadow",
    "Glad Valley",
    "Morristown",
    "Mound City",
    "Pollock",
    "Prairie City",
    "Ralph",
    "Reva",
    "Ridgeview",
    "La Plant",
    "Timber Lake",
    "Trail City",
    "Wakpala",
    "Walker",
    "Watauga",
    "Whitehorse",
    "Rapid City",
    "Rockerville",
    "Silver City",
    "Ellsworth Afb",
    "Allen",
    "Batesland",
    "Denby",
    "Belle Fourche",
    "Fruitdale",
    "Black Hawk",
    "Summerset",
    "Box Elder",
    "Buffalo",
    "Buffalo Gap",
    "Camp Crook",
    "Caputa",
    "Custer",
    "Crazy Horse",
    "Deadwood",
    "Edgemont",
    "Ardmore",
    "Burdock",
    "Dewey",
    "Provo",
    "Enning",
    "Fairburn",
    "Fort Meade",
    "Hermosa",
    "Red Shirt",
    "Hill City",
    "Rochford",
    "Hot Springs",
    "Howes",
    "Plainview",
    "Interior",
    "Keystone",
    "Kyle",
    "Lead",
    "Central City",
    "Ludlow",
    "Manderson",
    "Mud Butte",
    "Opal",
    "Zeona",
    "Nemo",
    "Newell",
    "New Underwood",
    "Nisland",
    "Oelrichs",
    "Oglala",
    "Oral",
    "Owanka",
    "Piedmont",
    "Bethlehem",
    "Pine Ridge",
    "Porcupine",
    "Pringle",
    "Quinn",
    "Cottonwood",
    "Redig",
    "Saint Onge",
    "Scenic",
    "Smithwick",
    "Spearfish",
    "Sturgis",
    "Hereford",
    "Marcus",
    "Union Center",
    "Red Owl",
    "Stoneville",
    "Vale",
    "Wall",
    "Creighton",
    "Wasta",
    "Elm Springs",
    "White Owl",
    "Whitewood",
    "Wounded Knee",
  ],
  TN: [
    "Adams",
    "Alexandria",
    "Antioch",
    "Cane Ridge",
    "Arrington",
    "Ashland City",
    "Auburntown",
    "Beechgrove",
    "Belfast",
    "Bell Buckle",
    "Bethpage",
    "Rock Bridge",
    "Big Rock",
    "Bon Aqua",
    "Bradyville",
    "Brentwood",
    "Bumpus Mills",
    "Burns",
    "Carthage",
    "Defeated",
    "S Carthage",
    "So Carthage",
    "South Carthage",
    "Castalian Springs",
    "Castalin Spgs",
    "Cedar Hill",
    "Centerville",
    "Pleasantville",
    "Chapel Hill",
    "Chapmansboro",
    "Charlotte",
    "Christiana",
    "Clarksville",
    "College Grove",
    "Cornersville",
    "Cottontown",
    "Walnut Grove",
    "Cross Plains",
    "Cumberland City",
    "Cumberlnd Cty",
    "Cumberland Furnace",
    "Cmbrlnd Frnce",
    "Slayden",
    "Cunningham",
    "Dickson",
    "Dixon Springs",
    "Dover",
    "Dowelltown",
    "Eagleville",
    "Erin",
    "Fairview",
    "Franklin",
    "Gallatin",
    "Goodlettsville",
    "Goodlettsvlle",
    "Greenbrier",
    "Hartsville",
    "Hendersonville",
    "Hendersonvlle",
    "Hermitage",
    "Hurricane Mills",
    "Hurricne Mlls",
    "Indian Mound",
    "Joelton",
    "Kingston Springs",
    "Kingston Spgs",
    "Lafayette",
    "Lascassas",
    "La Vergne",
    "Lebanon",
    "Lewisburg",
    "Liberty",
    "Gassaway",
    "Linden",
    "Flatwoods",
    "Lobelville",
    "Lyles",
    "Wrigley",
    "McEwen",
    "Mcminnville",
    "Centertown",
    "Mc Minnville",
    "Madison",
    "Milton",
    "Mount Juliet",
    "Mt Juliet",
    "Murfreesboro",
    "New Johnsonville",
    "Denver",
    "New Johsonvle",
    "Nolensville",
    "Nunnelly",
    "Old Hickory",
    "Lakewood",
    "Only",
    "Orlinda",
    "Palmyra",
    "Pegram",
    "Petersburg",
    "Pleasant Shade",
    "Pleasant Shde",
    "Pleasant View",
    "Portland",
    "Readyville",
    "Red Boiling Springs",
    "Red Blng Spgs",
    "Riddleton",
    "Rockvale",
    "Shelbyville",
    "Royal",
    "Smithville",
    "Smyrna",
    "Southside",
    "Springfield",
    "Coopertown",
    "Spring Hill",
    "Stewart",
    "Tennessee Ridge",
    "Tennessee Rdg",
    "Thompsons Station",
    "Thompsons Stn",
    "Unionville",
    "Vanleer",
    "Wartrace",
    "Watertown",
    "Waverly",
    "Westmoreland",
    "White Bluff",
    "White House",
    "Whites Creek",
    "Woodbury",
    "Woodlawn",
    "Nashville",
    "Berry Hill",
    "Melrose",
    "Belle Meade",
    "Forest Hills",
    "Oak Hill",
    "Bellevue",
    "Altamont",
    "Apison",
    "Athens",
    "Beersheba Springs",
    "Beershba Spgs",
    "Belvidere",
    "Benton",
    "Birchwood",
    "Calhoun",
    "Charleston",
    "Cleveland",
    "Coalmont",
    "Collegedale",
    "Conasauga",
    "Copperhill",
    "Postelle",
    "Cowan",
    "Dayton",
    "Decatur",
    "Decherd",
    "Delano",
    "Ducktown",
    "Dunlap",
    "Elora",
    "Englewood",
    "Estill Springs",
    "Estill Spgs",
    "Etowah",
    "Evensville",
    "Farner",
    "Fayetteville",
    "Flintville",
    "Georgetown",
    "Grandview",
    "Graysville",
    "Gruetli Laager",
    "Gruetli Laagr",
    "Guild",
    "Harrison",
    "Hillsboro",
    "Hixson",
    "Huntland",
    "Jasper",
    "Kimball",
    "Kelso",
    "Lookout Mountain",
    "Lookout Mtn",
    "Lupton City",
    "Lynchburg",
    "McDonald",
    "Madisonville",
    "Manchester",
    "Monteagle",
    "Morrison",
    "Mulberry",
    "Normandy",
    "Ocoee",
    "Old Fort",
    "Ooltewah",
    "College Dale",
    "Palmer",
    "Pelham",
    "Pikeville",
    "Reliance",
    "Riceville",
    "Sale Creek",
    "Bakewell",
    "Sequatchie",
    "Sewanee",
    "Saint Andrews",
    "Sherwood",
    "Signal Mountain",
    "Signal Mtn",
    "Walden",
    "Soddy Daisy",
    "Lakesite",
    "South Pittsburg",
    "New Hope",
    "Orme",
    "S Pittsburg",
    "Spring City",
    "Watts Bar Dam",
    "Tellico Plains",
    "Tellico Plns",
    "Tracy City",
    "Tullahoma",
    "Dickel",
    "Turtletown",
    "Viola",
    "Whiteside",
    "Whitwell",
    "Powells Crossroads",
    "Powells Xroad",
    "Winchester",
    "Chattanooga",
    "Ridgeside",
    "East Ridge",
    "Red Bank",
    "Johnson City",
    "Gray",
    "Afton",
    "Blountville",
    "Bluff City",
    "Bristol",
    "Butler",
    "Chuckey",
    "Church Hill",
    "Elizabethton",
    "Mount Carmel",
    "Mt Carmel",
    "Erwin",
    "Fall Branch",
    "Flag Pond",
    "Hampton",
    "Jonesborough",
    "Kingsport",
    "Colonial Heights",
    "Colonial Hgts",
    "Laurel Bloomery",
    "Laurel Blmry",
    "Limestone",
    "Milligan College",
    "Milligan",
    "Milligan Coll",
    "Mountain City",
    "Piney Flats",
    "Roan Mountain",
    "Shady Valley",
    "Telford",
    "Trade",
    "Unicoi",
    "Watauga",
    "Alcoa",
    "Andersonville",
    "Bean Station",
    "Blaine",
    "Briceville",
    "Devonia",
    "Bulls Gap",
    "Bybee",
    "Caryville",
    "Clairfield",
    "Clinton",
    "Coalfield",
    "Corryton",
    "Cosby",
    "Crab Orchard",
    "Cumberland Gap",
    "Cumb Gap",
    "Cumberland Gp",
    "Dandridge",
    "Deer Lodge",
    "Del Rio",
    "Duff",
    "La Follette",
    "Eagan",
    "Eidson",
    "Elgin",
    "Rugby",
    "Friendsville",
    "Gatlinburg",
    "Greenback",
    "Greeneville",
    "Tusculum Coll",
    "Tusculum",
    "Harriman",
    "Harrogate",
    "Hartford",
    "Heiskell",
    "Helenwood",
    "Huntsville",
    "Winona",
    "Jacksboro",
    "Jefferson City",
    "Jefferson Cty",
    "Jellico",
    "Kingston",
    "Kodak",
    "Kyles Ford",
    "Morley",
    "Rocky Top",
    "Lake City",
    "Lancing",
    "Lenoir City",
    "Loudon",
    "Louisville",
    "Luttrell",
    "Plainview",
    "Maryville",
    "Mascot",
    "Maynardville",
    "Midway",
    "Mohawk",
    "Mooresburg",
    "Morristown",
    "Mosheim",
    "Newcomb",
    "New Market",
    "Newport",
    "Mt Sterling",
    "New Tazewell",
    "Niota",
    "Norris",
    "Oakdale",
    "Oak Ridge",
    "Oliver Springs",
    "Oliver Spgs",
    "Oneida",
    "Parrottsville",
    "Petros",
    "Philadelphia",
    "Pioneer",
    "Powder Springs",
    "Powder Spgs",
    "Powell",
    "Pruden",
    "Robbins",
    "Rockford",
    "Rockwood",
    "Ozone",
    "Rogersville",
    "Russellville",
    "Rutledge",
    "Sevierville",
    "Pigeon Forge",
    "Seymour",
    "Sharps Chapel",
    "Sneedville",
    "Speedwell",
    "Strawberry Plains",
    "Straw Plains",
    "Sunbright",
    "Surgoinsville",
    "Sweetwater",
    "Pittman Center",
    "Pittman Ctr",
    "Talbott",
    "Tallassee",
    "Tazewell",
    "Ten Mile",
    "Thorn Hill",
    "Treadway",
    "Townsend",
    "Vonore",
    "Walland",
    "Wartburg",
    "Washburn",
    "White Pine",
    "Baneberry",
    "Whitesburg",
    "Winfield",
    "Knoxville",
    "Kimberlin Heights",
    "Kimberlin Hgt",
    "Concord",
    "Concord Farr",
    "Concord Farragut",
    "Farragut",
    "Alamo",
    "Arlington",
    "Bartlett",
    "Lakeland",
    "Atoka",
    "Bells",
    "Bogota",
    "Bolivar",
    "Brighton",
    "Brownsville",
    "Burlison",
    "Gilt Edge",
    "Cordova",
    "Collierville",
    "Fisherville",
    "Piperton",
    "Covington",
    "Garland",
    "Crockett Mills",
    "Crockett Mls",
    "Drummonds",
    "Dyersburg",
    "Eads",
    "Ellendale",
    "Finley",
    "Friendship",
    "Gallaway",
    "Gates",
    "Grand Junction",
    "Grand Jct",
    "Halls",
    "Henning",
    "Fort Pillow",
    "Hickory Valley",
    "Hickory Vly",
    "Hornsby",
    "La Grange",
    "Lenox",
    "Mason",
    "Maury City",
    "Middleton",
    "Millington",
    "Moscow",
    "Munford",
    "Newbern",
    "Oakland",
    "Somerville",
    "Pocahontas",
    "Ripley",
    "Rossville",
    "Saulsbury",
    "Stanton",
    "Tigrett",
    "Whiteville",
    "Williston",
    "Wynnburg",
    "Tiptonville",
    "Ridgely",
    "Miston",
    "Memphis",
    "Hickory Hill",
    "Germantown",
    "McKenzie",
    "Atwood",
    "Big Sandy",
    "Buchanan",
    "Cottage Grove",
    "Dresden",
    "Dukedom",
    "Gleason",
    "Greenfield",
    "Henry",
    "Hornbeak",
    "Kenton",
    "McLemoresville",
    "Mc Lemoresvle",
    "Mansfield",
    "Martin",
    "Obion",
    "Palmersville",
    "Paris",
    "Puryear",
    "Rives",
    "Samburg",
    "Sharon",
    "Springville",
    "South Fulton",
    "Trezevant",
    "Trimble",
    "Troy",
    "Union City",
    "Jackson",
    "Adamsville",
    "Bath Springs",
    "Beech Bluff",
    "Bethel Springs",
    "Bethel Spgs",
    "Bradford",
    "Bruceton",
    "Buena Vista",
    "Camden",
    "Cedar Grove",
    "Counce",
    "Crump",
    "Darden",
    "Decaturville",
    "Dyer",
    "Enville",
    "Eva",
    "Finger",
    "Gadsden",
    "Gibson",
    "Guys",
    "Henderson",
    "Holladay",
    "Hollow Rock",
    "Humboldt",
    "Three Way",
    "Huntingdon",
    "Huron",
    "Jacks Creek",
    "Lavinia",
    "Lexington",
    "Luray",
    "Medina",
    "Medon",
    "Michie",
    "Milan",
    "Milledgeville",
    "Morris Chapel",
    "Oakfield",
    "Parsons",
    "Pickwick Dam",
    "Pinson",
    "Ramer",
    "Eastview",
    "Reagan",
    "Rutherford",
    "Saltillo",
    "Sardis",
    "Savannah",
    "Scotts Hill",
    "Selmer",
    "Shiloh",
    "Stantonville",
    "Sugar Tree",
    "Toone",
    "Trenton",
    "Westport",
    "Wildersville",
    "Parker Crossroads",
    "Parker Xroads",
    "Yorkville",
    "Yuma",
    "Denmark",
    "Mercer",
    "Columbia",
    "Clifton",
    "Ardmore",
    "Collinwood",
    "Culleoka",
    "Cypress Inn",
    "Dellrose",
    "Duck River",
    "Elkton",
    "Ethridge",
    "Five Points",
    "Frankewing",
    "Goodspring",
    "Hampshire",
    "Hohenwald",
    "Kimmins",
    "Iron City",
    "Lawrenceburg",
    "Leoma",
    "Loretto",
    "Lutts",
    "Lynnville",
    "Minor Hill",
    "Mount Pleasant",
    "Mt Pleasant",
    "Olivehill",
    "Primm Springs",
    "Prospect",
    "Pulaski",
    "Saint Joseph",
    "Santa Fe",
    "Summertown",
    "Waynesboro",
    "Westpoint",
    "Williamsport",
    "Taft",
    "Cookeville",
    "Algood",
    "Allardt",
    "Allons",
    "Allred",
    "Alpine",
    "Baxter",
    "Bloomington Springs",
    "Blmngton Spgs",
    "Brush Creek",
    "Buffalo Valley",
    "Buffalo Vly",
    "Byrdstown",
    "Campaign",
    "Celina",
    "Chestnut Mound",
    "Chestnut Mnd",
    "Clarkrange",
    "Crawford",
    "Crossville",
    "Fairfield Glade",
    "Fairfld Glde",
    "Jamestown",
    "Doyle",
    "Elmwood",
    "Gainesboro",
    "Gordonsville",
    "Granville",
    "Grimsley",
    "Hickman",
    "Hilham",
    "Lancaster",
    "Livingston",
    "Monroe",
    "Monterey",
    "Moss",
    "Pall Mall",
    "Pleasant Hill",
    "Quebeck",
    "Rickman",
    "Rock Island",
    "Bone Cave",
    "Silver Point",
    "Sparta",
    "Ravenscroft",
    "Spencer",
    "Walling",
    "Whitleyville",
    "Wilder",
  ],
  TX: [
    "Texhoma",
    "Addison",
    "Allen",
    "Lucas",
    "Parker",
    "Carrollton",
    "Celina",
    "Coppell",
    "Denison",
    "Flower Mound",
    "Flowermound",
    "Lewisville",
    "Plano",
    "Rockwall",
    "Fate",
    "Heath",
    "Frisco",
    "Irving",
    "Garland",
    "Sachse",
    "Grand Prairie",
    "The Colony",
    "Gunter",
    "Lake Dallas",
    "Hickory Creek",
    "Little Elm",
    "Lakewood Village",
    "Lakewood Vlg",
    "Oak Point",
    "Mckinney",
    "Fairview",
    "Mc Kinney",
    "Pottsboro",
    "Copper Canyon",
    "Double Oak",
    "Highland Village",
    "Highland Vlg",
    "Prosper",
    "Richardson",
    "Rowlett",
    "Sherman",
    "Tom Bean",
    "Knollwood",
    "Murphy",
    "Wylie",
    "St Paul",
    "Bardwell",
    "Barry",
    "Canton",
    "Cedar Hill",
    "Chatfield",
    "Corsicana",
    "Crandall",
    "Desoto",
    "Duncanville",
    "Edgewood",
    "Ennis",
    "Eustace",
    "Ferris",
    "Forney",
    "Heartland",
    "Heathridge",
    "Fruitvale",
    "Lancaster",
    "Caddo Mills",
    "Josephine",
    "Grand Saline",
    "Hutchins",
    "Kaufman",
    "Kemp",
    "Seven Points",
    "Tool",
    "Kerens",
    "Mabank",
    "Gun Barrel City",
    "Gun Barrel Cy",
    "Malakoff",
    "Log Cabin",
    "Mesquite",
    "Palmer",
    "Powell",
    "Red Oak",
    "Glenn Heights",
    "Oak Leaf",
    "Ovilla",
    "Rice",
    "Enchanted Oak",
    "Enchanted Oaks",
    "Rosser",
    "Scurry",
    "Seagoville",
    "Combine",
    "Terrell",
    "Trinidad",
    "Waxahachie",
    "Lavon",
    "Wills Point",
    "Wilmer",
    "Nevada",
    "Balch Springs",
    "Sunnyvale",
    "Royse City",
    "Dallas",
    "Farmers Branch",
    "Farmers Brnch",
    "North Branch",
    "Dfw",
    "Dfw Airport",
    "Greenville",
    "Princeton",
    "Anna",
    "Alba",
    "Arthur City",
    "Bagwell",
    "Bailey",
    "Bells",
    "Ben Franklin",
    "Blossom",
    "Bogata",
    "Bonham",
    "Brashear",
    "Brookston",
    "Campbell",
    "Celeste",
    "Blue Ridge",
    "Clarksville",
    "Commerce",
    "Como",
    "Cooper",
    "Cumby",
    "Cunningham",
    "Deport",
    "Detroit",
    "Dike",
    "Dodd City",
    "Ector",
    "Emory",
    "Enloe",
    "Farmersville",
    "Honey Grove",
    "Ivanhoe",
    "Klondike",
    "Ladonia",
    "Lake Creek",
    "Leesburg",
    "Leonard",
    "Lone Oak",
    "Melissa",
    "Mount Pleasant",
    "Mt Pleasant",
    "Mount Vernon",
    "Mt Vernon",
    "Howe",
    "Dorchester",
    "Paris",
    "Reno",
    "Pattonville",
    "Pecan Gap",
    "Petty",
    "Pickton",
    "Point",
    "East Tawakoni",
    "Powderly",
    "Quinlan",
    "West Tawakoni",
    "Randolph",
    "Ravenna",
    "Roxton",
    "Saltillo",
    "Savoy",
    "Scroggins",
    "Sulphur Bluff",
    "Sulphur Springs",
    "Sulphur Spgs",
    "Sumner",
    "Talco",
    "Telephone",
    "Trenton",
    "Whitewright",
    "Windom",
    "Winfield",
    "Winnsboro",
    "Van Alstyne",
    "Wolfe City",
    "Yantis",
    "Texarkana",
    "S Texarkana",
    "South Texarkana",
    "Wake Village",
    "Annona",
    "Atlanta",
    "Avery",
    "Bivins",
    "Bloomburg",
    "Cookville",
    "De Kalb",
    "Douglassville",
    "Hooks",
    "Kildare",
    "Linden",
    "Lodi",
    "McLeod",
    "Marietta",
    "Maud",
    "Naples",
    "Nash",
    "New Boston",
    "Boston",
    "Omaha",
    "Queen City",
    "Redwater",
    "Simms",
    "Longview",
    "Avinger",
    "Beckville",
    "Carthage",
    "Daingerfield",
    "De Berry",
    "Diana",
    "New Diana",
    "Easton",
    "Elysian Fields",
    "Elysian Flds",
    "Gary",
    "Gilmer",
    "Gladewater",
    "Hallsville",
    "Harleton",
    "Henderson",
    "Hughes Springs",
    "Hughes Spgs",
    "Jefferson",
    "Smithland",
    "Joinerville",
    "Jonesville",
    "Karnack",
    "Kilgore",
    "Laneville",
    "Lone Star",
    "Long Branch",
    "Marshall",
    "Minden",
    "Mount Enterprise",
    "Mt Enterprise",
    "New London",
    "Ore City",
    "Overton",
    "Pittsburg",
    "Price",
    "Selman City",
    "Turnertown",
    "Tatum",
    "Waskom",
    "White Oak",
    "Clarksville City",
    "Clarksvle Cty",
    "Woodlawn",
    "Tyler",
    "Lindale",
    "Arp",
    "Athens",
    "Ben Wheeler",
    "Edom",
    "Big Sandy",
    "Holly Lake Ranch",
    "Holly Lk Rnch",
    "Brownsboro",
    "Bullard",
    "Mount Selman",
    "Chandler",
    "Cuney",
    "Cushing",
    "Flint",
    "Frankston",
    "Coffee City",
    "Gallatin",
    "Hawkins",
    "Jacksonville",
    "Larue",
    "Garden Valley",
    "Hide A Way",
    "Hideaway",
    "Mt Sylvan",
    "Mineola",
    "Murchison",
    "Neches",
    "New Summerfield",
    "New Summerfld",
    "Poynor",
    "Quitman",
    "Reklaw",
    "Rusk",
    "Dialville",
    "Sacul",
    "Troup",
    "Van",
    "Whitehouse",
    "Winona",
    "Palestine",
    "Buffalo",
    "Keechi",
    "Centerville",
    "Crockett",
    "Donie",
    "Elkhart",
    "Slocum",
    "Fairfield",
    "Grapeland",
    "Groveton",
    "Jewett",
    "Kennard",
    "Kirvin",
    "Latexo",
    "Leona",
    "Midway",
    "Lovelady",
    "Montalba",
    "Oakwood",
    "Pennington",
    "Ratcliff",
    "Streetman",
    "Teague",
    "Tennessee Colony",
    "Tenn Colony",
    "Trinity",
    "Woodlake",
    "Lufkin",
    "Alto",
    "Forest",
    "Apple Springs",
    "Bon Wier",
    "Broaddus",
    "Bronson",
    "Brookeland",
    "Burkeville",
    "Call",
    "Camden",
    "Center",
    "Chester",
    "Chireno",
    "Colmesneil",
    "Rockland",
    "Corrigan",
    "Barnum",
    "Diboll",
    "Burke",
    "Doucette",
    "Douglass",
    "Etoile",
    "Garrison",
    "Hemphill",
    "Huntington",
    "Jasper",
    "Joaquin",
    "Kirbyville",
    "Bon Ami",
    "Magnolia Spgs",
    "Magnolia Springs",
    "Roganville",
    "Milam",
    "Geneva",
    "Moscow",
    "Nacogdoches",
    "Newton",
    "Pineland",
    "Pollok",
    "San Augustine",
    "Shelbyville",
    "Tenaha",
    "Timpson",
    "Wells",
    "Wiergate",
    "Woodville",
    "Zavalla",
    "Arlington",
    "Aledo",
    "Annetta",
    "Annetta N",
    "Annetta S",
    "Willow Park",
    "Alvarado",
    "Dalworthington Gardens",
    "Dw Gdns",
    "Dwg",
    "Pantego",
    "Azle",
    "Sanctuary",
    "Bedford",
    "Boyd",
    "Burleson",
    "Briaroaks",
    "Cross Timber",
    "Cleburne",
    "Colleyville",
    "Cresson",
    "Crowley",
    "Euless",
    "Forreston",
    "Glen Rose",
    "Godley",
    "Granbury",
    "Brazos Bend",
    "Acton",
    "Decordova",
    "Grandview",
    "Grapevine",
    "Haslet",
    "Hurst",
    "Itasca",
    "Joshua",
    "Keene",
    "Kennedale",
    "Lillian",
    "Mansfield",
    "Maypearl",
    "Midlothian",
    "Millsap",
    "Cool",
    "Mineral Wells",
    "Nemo",
    "Newark",
    "Paradise",
    "Rainbow",
    "Rhome",
    "Aurora",
    "Springtown",
    "Venus",
    "Mansfiel",
    "Weatherford",
    "Brock",
    "Hudson Oaks",
    "Southlake",
    "South Lake",
    "Rio Vista",
    "Fort Worth",
    "Ft Worth",
    "Lakeside",
    "White Settlement",
    "Wht Settlemt",
    "Benbrook",
    "Haltom City",
    "River Oaks",
    "Westworth Village",
    "Westworth Vlg",
    "N Richland Hills",
    "N Richlnd Hls",
    "North Richland Hills",
    "Richland Hills",
    "Richland Hls",
    "Forest Hill",
    "Naval Air Station Jrb",
    "Nas Jrb",
    "Blue Mound",
    "Saginaw",
    "Edgecliff Village",
    "Edgecliff Vlg",
    "Lake Worth",
    "Watauga",
    "Everman",
    "Denton",
    "Corinth",
    "Shady Shores",
    "Alvord",
    "Argyle",
    "Bartonville",
    "Lantana",
    "Northlake",
    "Aubrey",
    "Crossroads",
    "Krugerville",
    "Providence Village",
    "Providnce Vlg",
    "Savannah",
    "Bellevue",
    "Bowie",
    "Collinsville",
    "Decatur",
    "Era",
    "Forestburg",
    "Gainesville",
    "Callisburg",
    "Lake Kiowa",
    "Oak Ridge",
    "Keller",
    "Gordonville",
    "Justin",
    "Krum",
    "Lindsay",
    "Montague",
    "Muenster",
    "Myra",
    "Nocona",
    "Pilot Point",
    "Ponder",
    "Ringgold",
    "Roanoke",
    "Trophy Club",
    "Westlake",
    "Rosston",
    "Sadler",
    "Saint Jo",
    "Sanger",
    "Slidell",
    "Southmayd",
    "Sunset",
    "Tioga",
    "Valley View",
    "Whitesboro",
    "Wichita Falls",
    "Cashion Cmnty",
    "Cashion Community",
    "Dean",
    "Jolly",
    "Pleasant Valley",
    "Pleasant Vly",
    "Sheppard Afb",
    "Archer City",
    "Burkburnett",
    "Byers",
    "Electra",
    "Goree",
    "Harrold",
    "Henrietta",
    "Holliday",
    "Iowa Park",
    "Megargel",
    "Munday",
    "Newcastle",
    "Elbert",
    "Oklaunion",
    "Olney",
    "Petrolia",
    "Scotland",
    "Seymour",
    "Red Springs",
    "Vera",
    "Vernon",
    "Weinert",
    "Windthorst",
    "Stephenville",
    "Breckenridge",
    "Bridgeport",
    "Runaway Bay",
    "Bryson",
    "Caddo",
    "Albany",
    "Chico",
    "Blanket",
    "Bluff Dale",
    "Carbon",
    "Carlton",
    "Cisco",
    "Dennis",
    "Comanche",
    "Hasse",
    "Cross Plains",
    "De Leon",
    "Desdemona",
    "Dublin",
    "Lingleville",
    "Eastland",
    "Graford",
    "Graham",
    "Energy",
    "Gordon",
    "Gorman",
    "Gustine",
    "Hico",
    "Jacksboro",
    "Jermyn",
    "Loving",
    "Lipan",
    "Mingus",
    "Moran",
    "Olden",
    "Putnam",
    "Ranger",
    "Rising Star",
    "Santo",
    "Sidney",
    "Strawn",
    "Tolar",
    "South Bend",
    "Eliasville",
    "Throckmorton",
    "Palo Pinto",
    "Perrin",
    "Poolville",
    "Whitt",
    "Woodson",
    "Temple",
    "Bartlett",
    "Belton",
    "Morgans Point",
    "Morgans Point Resort",
    "Buckholts",
    "Burlington",
    "Ben Arnold",
    "Cameron",
    "Maysfield",
    "Copperas Cove",
    "Davilla",
    "Eddy",
    "Evant",
    "Bee House",
    "Florence",
    "Gatesville",
    "Izoro",
    "Leon Junction",
    "South Mountain",
    "South Mtn",
    "Granger",
    "Hamilton",
    "Holland",
    "Jarrell",
    "Jonesboro",
    "Kempner",
    "Killeen",
    "Fort Cavazos",
    "Harker Heights",
    "Harker Hts",
    "Lampasas",
    "Little River Academy",
    "Ltl Rvr Acad",
    "Milano",
    "Moody",
    "Nolanville",
    "Oglesby",
    "Pottsville",
    "Purmela",
    "Rockdale",
    "Rogers",
    "Rosebud",
    "Salado",
    "Schwertner",
    "Taylor",
    "Thorndale",
    "Thrall",
    "Troy",
    "Abbott",
    "Aquilla",
    "Avalon",
    "Axtell",
    "Blooming Grove",
    "Blooming Grv",
    "Blum",
    "Brandon",
    "Bremond",
    "Bruceville",
    "Bynum",
    "Chilton",
    "China Spring",
    "Clifton",
    "Laguna Park",
    "Coolidge",
    "Covington",
    "Cranfills Gap",
    "Crawford",
    "Dawson",
    "Elm Mott",
    "Frost",
    "Groesbeck",
    "Lake Limestone",
    "Lk Limestone",
    "Hewitt",
    "Hillsboro",
    "Hubbard",
    "Iredell",
    "Irene",
    "Italy",
    "Kopperl",
    "Kosse",
    "Leroy",
    "Lorena",
    "Lott",
    "Mcgregor",
    "Malone",
    "Marlin",
    "Mart",
    "Meridian",
    "Mertens",
    "Mexia",
    "Milford",
    "Morgan",
    "Mount Calm",
    "Birome",
    "Penelope",
    "Prairie Hill",
    "Purdon",
    "Reagan",
    "Richland",
    "Riesel",
    "Otto",
    "Perry",
    "Satin",
    "Tehuacana",
    "Thornton",
    "Valley Mills",
    "Walnut Springs",
    "Walnut Spgs",
    "West",
    "Whitney",
    "Wortham",
    "Waco",
    "Bellmead",
    "Lacy Lakeview",
    "Robinson",
    "Beverly Hills",
    "Woodway",
    "Brownwood",
    "Early",
    "Art",
    "Ballinger",
    "Bangs",
    "Bend",
    "Brady",
    "Fife",
    "Brookesmith",
    "Burkett",
    "Castell",
    "Cherokee",
    "Coleman",
    "Doole",
    "Eden",
    "Fort McKavett",
    "Fort Mckavett",
    "Fredonia",
    "Goldthwaite",
    "Gouldbusk",
    "Hext",
    "Junction",
    "Lohn",
    "Pear Valley",
    "Lometa",
    "London",
    "Mason",
    "May",
    "Melvin",
    "Menard",
    "Miles",
    "Millersview",
    "Mullin",
    "Norton",
    "Paint Rock",
    "Pontotoc",
    "Priddy",
    "Richland Springs",
    "Richland Spgs",
    "Rochelle",
    "Rockwood",
    "Roosevelt",
    "Rowena",
    "San Saba",
    "Santa Anna",
    "Whon",
    "Star",
    "Talpa",
    "Valera",
    "Valley Spring",
    "Voca",
    "Voss",
    "Leaday",
    "Zephyr",
    "San Angelo",
    "Grape Creek",
    "Goodfellow Afb",
    "Goodfelow AFB",
    "Barnhart",
    "Big Lake",
    "Best",
    "Texon",
    "Bronte",
    "Carlsbad",
    "Christoval",
    "Eldorado",
    "Eldorado Afs",
    "Eola",
    "Knickerbocker",
    "Mereta",
    "Mertzon",
    "Ozona",
    "Robert Lee",
    "Silver",
    "Sonora",
    "Sterling City",
    "Tennyson",
    "Vancourt",
    "Wall",
    "Water Valley",
    "Houston",
    "Clutch City",
    "W Univ Pl",
    "West University Place",
    "Hedwig Village",
    "Hedwig Vlg",
    "Piney Point",
    "Piney Point Village",
    "Jacinto City",
    "Va Hospital",
    "Jersey Village",
    "Jersey Vlg",
    "Pearland",
    "Gridiron",
    "Conroe",
    "Grangerland",
    "Woodloch",
    "Cut And Shoot",
    "Panorama Village",
    "Panorama Vlg",
    "Montgomery",
    "Willis",
    "Huntsville",
    "Ace",
    "Cleveland",
    "Coldspring",
    "Dodge",
    "Goodrich",
    "Huffman",
    "Humble",
    "Kingwood",
    "Atascocita",
    "Leggett",
    "Livingston",
    "Segno",
    "Magnolia",
    "Decker Pr",
    "Decker Prairie",
    "The Woodlands",
    "Stagecoach",
    "New Caney",
    "Roman Forest",
    "New Waverly",
    "Oakhurst",
    "Onalaska",
    "Pinehurst",
    "Plantersville",
    "Todd Mission",
    "Pointblank",
    "Porter",
    "Riverside",
    "Romayor",
    "Rye",
    "Shepherd",
    "Splendora",
    "Patton Village",
    "Patton Vlg",
    "Spring",
    "Thicket",
    "Tomball",
    "Votaw",
    "Klein",
    "Shenandoah",
    "Oak Ridge N",
    "Oak Ridge North",
    "Bellaire",
    "Richmond",
    "Fulshear",
    "Altair",
    "Bay City",
    "Clemville",
    "Sargent",
    "Cedar Lane",
    "Beasley",
    "Kendleton",
    "Bellville",
    "Blessing",
    "Boling",
    "Brazoria",
    "Brookshire",
    "Pattison",
    "Chappell Hill",
    "Collegeport",
    "Cypress",
    "Damon",
    "Danciger",
    "Danevang",
    "Eagle Lake",
    "East Bernard",
    "Egypt",
    "El Campo",
    "Elmaton",
    "Weston Lakes",
    "Garwood",
    "Glen Flora",
    "Guy",
    "Hempstead",
    "Pine Island",
    "Prairie View",
    "Hockley",
    "Hungerford",
    "Katy",
    "Park Row",
    "Lane City",
    "Lissie",
    "Louise",
    "Markham",
    "Matagorda",
    "Midfield",
    "Missouri City",
    "Sienna Plant",
    "Sienna Plantation",
    "Nada",
    "Needville",
    "Orchard",
    "Palacios",
    "Pierce",
    "Pledger",
    "Booth",
    "Clodine",
    "Rosenberg",
    "Rock Island",
    "San Felipe",
    "Sealy",
    "Sheridan",
    "Simonton",
    "Stafford",
    "Meadows Place",
    "Sugar Land",
    "Sweeny",
    "Thompsons",
    "Van Vleck",
    "Wadsworth",
    "Waller",
    "Wallis",
    "West Columbia",
    "Wharton",
    "Pasadena",
    "Santa Fe",
    "Alta Loma",
    "Texas City",
    "Alvin",
    "Anahuac",
    "Monroe City",
    "Angleton",
    "Holiday Lakes",
    "Richwood",
    "Arcadia",
    "Bacliff",
    "Batson",
    "Baytown",
    "Beach City",
    "Cove",
    "Mont Belvieu",
    "Old River Winfree",
    "Old Rvr Wnfre",
    "Channelview",
    "Clute",
    "Crosby",
    "Daisetta",
    "Danbury",
    "Dayton",
    "Dayton Lakes",
    "Deer Park",
    "Devers",
    "Dickinson",
    "San Leon",
    "Freeport",
    "Jones Creek",
    "Oyster Creek",
    "Quintana",
    "Surfside Bch",
    "Surfside Beach",
    "Fresno",
    "Friendswood",
    "Galena Park",
    "Galveston",
    "Jamaica Beach",
    "Tiki Island",
    "Hankamer",
    "Hardin",
    "Highlands",
    "Hitchcock",
    "Bayou Vista",
    "Hull",
    "Kemah",
    "Clear Lake Shores",
    "Clear Lk Shrs",
    "Lake Jackson",
    "La Marque",
    "La Porte",
    "Shoreacres",
    "League City",
    "Liberty",
    "Ames",
    "Liverpool",
    "Manvel",
    "Brookside Village",
    "Brookside Vl",
    "Raywood",
    "Rosharon",
    "Arcola",
    "Iowa Colony",
    "Sandy Point",
    "Saratoga",
    "Seabrook",
    "El Lago",
    "Taylor Lake Village",
    "Taylor Lk Vlg",
    "South Houston",
    "Wallisville",
    "Webster",
    "Bridge City",
    "Buna",
    "China",
    "Deweyville",
    "Evadale",
    "Fred",
    "Gilchrist",
    "Groves",
    "Hamshire",
    "High Island",
    "Hillister",
    "Kountze",
    "Nederland",
    "Nome",
    "Orange",
    "West Orange",
    "Port Arthur",
    "Port Acres",
    "Port Bolivar",
    "Crystal Beach",
    "Port Neches",
    "Sabine Pass",
    "Silsbee",
    "Lumberton",
    "Rose Hill Acres",
    "Rose Hl Acres",
    "Sour Lake",
    "Spurger",
    "Stowell",
    "Vidor",
    "Village Mills",
    "Warren",
    "Winnie",
    "Beaumont",
    "Taylor Landing",
    "Taylor Lndg",
    "Bevil Oaks",
    "Bryan",
    "Mumford",
    "Wixon Valley",
    "Anderson",
    "Bedias",
    "Singleton",
    "Brenham",
    "Burton",
    "Caldwell",
    "Calvert",
    "College Station",
    "College Sta",
    "Deanville",
    "Dime Box",
    "Flynn",
    "Franklin",
    "Ridge",
    "Gause",
    "Hearne",
    "Iola",
    "Lyons",
    "Madisonville",
    "Marquez",
    "Millican",
    "Navasota",
    "Normangee",
    "Hilltop Lakes",
    "North Zulch",
    "Richards",
    "Roans Prairie",
    "Shiro",
    "Snook",
    "Somerville",
    "Washington",
    "Wheelock",
    "Victoria",
    "Raisin",
    "Austwell",
    "Bloomington",
    "Cuero",
    "Edna",
    "Fannin",
    "Francitas",
    "Ganado",
    "Goliad",
    "Hallettsville",
    "Speaks",
    "Inez",
    "La Salle",
    "La Ward",
    "Lolita",
    "Mcfaddin",
    "Meyersville",
    "Moulton",
    "Nursery",
    "Placedo",
    "Point Comfort",
    "Port Lavaca",
    "Long Mott",
    "Port O'Connor",
    "Seadrift",
    "Shiner",
    "Sublime",
    "Sweet Home",
    "Telferner",
    "Tivoli",
    "Vanderbilt",
    "Weesatche",
    "Westhoff",
    "Yoakum",
    "Artesia Wells",
    "Atascosa",
    "Bandera",
    "Bergheim",
    "Bigfoot",
    "Boerne",
    "Fair Oaks",
    "Fair Oaks Ranch",
    "Sisterdale",
    "Calliham",
    "Campbellton",
    "Castroville",
    "Center Point",
    "Camp Verde",
    "Charlotte",
    "Christine",
    "Comfort",
    "Cotulla",
    "Devine",
    "Dilley",
    "Encinal",
    "Fowlerton",
    "George West",
    "Helotes",
    "Hunt",
    "Ingram",
    "Jourdanton",
    "Kendalia",
    "Kerrville",
    "La Coste",
    "Laredo",
    "Rio Bravo",
    "El Cenizo",
    "Leming",
    "Lytle",
    "Medina",
    "Mico",
    "Moore",
    "Mountain Home",
    "Natalia",
    "Pearsall",
    "Peggy",
    "Pipe Creek",
    "Lakehills",
    "Pleasanton",
    "Poteet",
    "Rio Medina",
    "San Ygnacio",
    "Somerset",
    "Spring Branch",
    "Bulverde",
    "Three Rivers",
    "Tilden",
    "Von Ormy",
    "Waring",
    "Whitsett",
    "Zapata",
    "Adkins",
    "Beeville",
    "Berclair",
    "Cibolo",
    "Schertz",
    "Converse",
    "Ecleto",
    "Gillett",
    "Elmendorf",
    "Falls City",
    "Mccoy",
    "Floresville",
    "Hobson",
    "Karnes City",
    "Kenedy",
    "La Vernia",
    "Lavernia",
    "Leesville",
    "McQueeney",
    "Mcqueeney",
    "Marion",
    "Santa Clara",
    "Mineral",
    "New Braunfels",
    "Canyon Lake",
    "Nixon",
    "Nordheim",
    "Normanna",
    "Pandora",
    "Panna Maria",
    "Pawnee",
    "Pettus",
    "Poth",
    "Universal City",
    "Universal Cty",
    "Jbsa Randolph",
    "Randolph AFB",
    "Randolph Air",
    "Randolph Air Force Base",
    "Runge",
    "Saint Hedwig",
    "Selma",
    "Seguin",
    "New Berlin",
    "Smiley",
    "Stockdale",
    "Sutherland Springs",
    "Sutherlnd Spg",
    "Tuleta",
    "Yorktown",
    "San Antonio",
    "Balcones Heights",
    "Balcones Hts",
    "Alamo Heights",
    "Terrell Hills",
    "Olmos Park",
    "Castle Hills",
    "Windcrest",
    "Kirby",
    "Shavano Park",
    "Hill Country Village",
    "Hl Cntry Vlg",
    "Hollywood Park",
    "Hollywood Pk",
    "Live Oak",
    "Jbsa Ft Sam Houston",
    "Fort Sam Houston",
    "Ft Sm Houston",
    "Jbsa Fsh",
    "Brooks Cb",
    "Brooks City Base",
    "Jbsa Lackland",
    "Lackland AFB",
    "Security Services",
    "Security Svc",
    "Wilford Hall",
    "Wilford Hall Usaf Hosp",
    "Leon Valley",
    "Wetmore",
    "China Grove",
    "Garden Ridge",
    "Agua Dulce",
    "Alice",
    "Aransas Pass",
    "City By The Sea",
    "Cty By The Se",
    "Armstrong",
    "Banquete",
    "Bayside",
    "Benavides",
    "Ben Bolt",
    "Bishop",
    "Bruni",
    "Chapman Ranch",
    "Concepcion",
    "Driscoll",
    "Edroy",
    "Encino",
    "Falfurrias",
    "Freer",
    "Fulton",
    "Gregory",
    "Guerra",
    "Hebbronville",
    "Ingleside",
    "Kingsville",
    "Kingsville Naval Air Station",
    "Kingsvl Naval",
    "Kingsvlle Nas",
    "Mathis",
    "Lake City",
    "Swinney Switch",
    "Swinney Swtch",
    "Mirando City",
    "Odem",
    "Oilton",
    "Orange Grove",
    "Port Aransas",
    "Portland",
    "Premont",
    "Realitos",
    "Refugio",
    "Riviera",
    "Robstown",
    "Rockport",
    "Sandia",
    "San Diego",
    "Sarita",
    "Sinton",
    "Skidmore",
    "Taft",
    "Tynan",
    "Woodsboro",
    "Corpus Christi",
    "Corp Christi",
    "Mcallen",
    "Alamo",
    "Brownsville",
    "Combes",
    "Delmita",
    "Donna",
    "Edcouch",
    "Monte Alto",
    "Edinburg",
    "Elsa",
    "Falcon Heights",
    "Falcon Hts",
    "Garciasville",
    "Grulla",
    "La Grulla",
    "Hargill",
    "Harlingen",
    "Palm Valley",
    "Hidalgo",
    "La Blanca",
    "La Feria",
    "La Joya",
    "Lasara",
    "La Villa",
    "Linn",
    "Lopeno",
    "Falcon",
    "Los Ebanos",
    "Los Fresnos",
    "Bayview",
    "Indian Lake",
    "Los Indios",
    "Lyford",
    "Mercedes",
    "Mission",
    "Palmhurst",
    "Palmview",
    "Alton",
    "Olmito",
    "Rancho Viejo",
    "Penitas",
    "Pharr",
    "Port Isabel",
    "Laguna Heights",
    "Laguna Hts",
    "Laguna Vista",
    "Progreso",
    "Raymondville",
    "Rio Grande City",
    "Rio Grande Cy",
    "Rio Hondo",
    "Roma",
    "Salineno",
    "San Benito",
    "San Isidro",
    "San Juan",
    "San Perlita",
    "Santa Elena",
    "Santa Maria",
    "Santa Rosa",
    "Sebastian",
    "Sullivan City",
    "Weslaco",
    "Progreso Lakes",
    "Progreso Lks",
    "South Padre Island",
    "S Padre Isle",
    "Port Mansfield",
    "Prt Mansfield",
    "Bastrop",
    "Bertram",
    "Blanco",
    "Bluffton",
    "Briggs",
    "Oakalla",
    "Buchanan Dam",
    "Buda",
    "Creedmoor",
    "Hays",
    "Mountain City",
    "Mustang Ridge",
    "Burnet",
    "Cedar Creek",
    "Lost Pines",
    "Cedar Park",
    "Cost",
    "Bebe",
    "Coupland",
    "Dale",
    "Mcmahan",
    "Del Valle",
    "Doss",
    "Driftwood",
    "Dripping Springs",
    "Dripping Spgs",
    "Elgin",
    "Webberville",
    "Fentress",
    "Fischer",
    "Fredericksburg",
    "Fbg",
    "Fredericksbrg",
    "Georgetown",
    "Andice",
    "Sun City",
    "Gonzales",
    "Harper",
    "Harwood",
    "Hutto",
    "Hye",
    "Johnson City",
    "Kingsbury",
    "Kingsland",
    "Kyle",
    "Niederwald",
    "Uhland",
    "Leander",
    "Volente",
    "Liberty Hill",
    "Llano",
    "Sunrise Beach",
    "Lockhart",
    "Jonestown",
    "Lago Vista",
    "Point Venture",
    "Luling",
    "McDade",
    "Mcdade",
    "Manchaca",
    "Manor",
    "Marble Falls",
    "Granite Shls",
    "Granite Shoals",
    "Highland Haven",
    "Highland Havn",
    "Meadowlakes",
    "Martindale",
    "Maxwell",
    "Horseshoe Bay",
    "Cottonwd Shrs",
    "Cottonwood Shores",
    "Ottine",
    "Paige",
    "Pflugerville",
    "Prairie Lea",
    "Red Rock",
    "Round Mountain",
    "Cypress Mill",
    "Round Mtn",
    "Round Rock",
    "San Marcos",
    "Spicewood",
    "Briarcliff",
    "Double Horn",
    "Staples",
    "Stonewall",
    "Albert",
    "Tow",
    "Weir",
    "Willow City",
    "Wimberley",
    "Woodcreek",
    "Wrightsboro",
    "Austin",
    "Bee Cave",
    "Bee Caves",
    "Lakeway",
    "Sunset Valley",
    "The Hills",
    "Village Of The Hills",
    "Vlg O The Hls",
    "Rollingwood",
    "W Lake Hills",
    "West Lake Hills",
    "West Lake Hls",
    "Uvalde",
    "Asherton",
    "Barksdale",
    "Batesville",
    "Big Wells",
    "Brackettville",
    "Camp Wood",
    "Carrizo Springs",
    "Carrizo Spgs",
    "Catarina",
    "Comstock",
    "Concan",
    "Crystal City",
    "Del Rio",
    "Laughlin AFB",
    "Laughlin Afb",
    "D Hanis",
    "Dryden",
    "Eagle Pass",
    "El Indio",
    "Hondo",
    "Dunlay",
    "Knippa",
    "Langtry",
    "La Pryor",
    "Leakey",
    "Quemado",
    "Spofford",
    "Rio Frio",
    "Rocksprings",
    "Sabinal",
    "Tarpley",
    "Utopia",
    "Vanderpool",
    "Yancey",
    "Bleiblerville",
    "Carmine",
    "Cat Spring",
    "Columbus",
    "Alleyton",
    "Ellinger",
    "Fayetteville",
    "Flatonia",
    "Giddings",
    "Glidden",
    "Industry",
    "La Grange",
    "Winchester",
    "Ledbetter",
    "Lexington",
    "Lincoln",
    "Muldoon",
    "New Ulm",
    "Oakland",
    "Rosanky",
    "Round Top",
    "Schulenburg",
    "Smithville",
    "Waelder",
    "Weimar",
    "West Point",
    "Adrian",
    "Alanreed",
    "Allison",
    "Booker",
    "Borger",
    "Phillips",
    "Bovina",
    "Boys Ranch",
    "Valle De Oro",
    "Briscoe",
    "Bushland",
    "Cactus",
    "Canadian",
    "Glazier",
    "Canyon",
    "Channing",
    "Claude",
    "Cotton Center",
    "Dalhart",
    "Darrouzett",
    "Dawn",
    "Dimmitt",
    "Dumas",
    "Earth",
    "Edmonson",
    "Farnsworth",
    "Follett",
    "Friona",
    "Black",
    "Fritch",
    "Groom",
    "Gruver",
    "Hale Center",
    "Happy",
    "Hart",
    "Hartley",
    "Hereford",
    "Higgins",
    "Kerrick",
    "Kress",
    "Lazbuddie",
    "Lefors",
    "Lipscomb",
    "Mclean",
    "Masterson",
    "Miami",
    "Mobeetie",
    "Morse",
    "Nazareth",
    "Olton",
    "Pampa",
    "Panhandle",
    "Perryton",
    "Plainview",
    "Sanford",
    "Shamrock",
    "Twitty",
    "Skellytown",
    "Spearman",
    "Springlake",
    "Stinnett",
    "Stratford",
    "Summerfield",
    "Sunray",
    "Texline",
    "Tulia",
    "Vigo Park",
    "Umbarger",
    "Vega",
    "Waka",
    "Wayside",
    "Wellington",
    "Wheeler",
    "White Deer",
    "Wildorado",
    "Amarillo",
    "Palisades",
    "Timbercreek Canyon",
    "Timbercrk Cyn",
    "Bishop Hills",
    "Childress",
    "Northfield",
    "Afton",
    "Cee Vee",
    "Chillicothe",
    "Clarendon",
    "Howardwick",
    "Crowell",
    "Truscott",
    "Dickens",
    "Dodson",
    "Dougherty",
    "Estelline",
    "Flomot",
    "Floydada",
    "Guthrie",
    "Hedley",
    "Lakeview",
    "Lelia Lake",
    "Lockney",
    "Mcadoo",
    "Matador",
    "Memphis",
    "Odell",
    "Paducah",
    "Dumont",
    "Petersburg",
    "Quail",
    "Quanah",
    "Quitaque",
    "Roaring Springs",
    "Roaring Spngs",
    "Silverton",
    "South Plains",
    "Tell",
    "Turkey",
    "Abernathy",
    "Amherst",
    "Anton",
    "Bledsoe",
    "Brownfield",
    "Crosbyton",
    "Denver City",
    "Enochs",
    "Farwell",
    "Fieldton",
    "Idalou",
    "Justiceburg",
    "Lamesa",
    "La Mesa",
    "Levelland",
    "Littlefield",
    "Loop",
    "Lorenzo",
    "Maple",
    "Meadow",
    "Morton",
    "Muleshoe",
    "New Deal",
    "Odonnell",
    "Pep",
    "Plains",
    "Post",
    "Ralls",
    "Cone",
    "Ropesville",
    "Seagraves",
    "Seminole",
    "Shallowater",
    "Slaton",
    "Ransom Canyon",
    "Southland",
    "Smyer",
    "Spade",
    "Spur",
    "Sudan",
    "Sundown",
    "Tahoka",
    "Tokio",
    "Welch",
    "Wellman",
    "Whiteface",
    "Whitharral",
    "Wilson",
    "New Home",
    "Wolfforth",
    "Lubbock",
    "Buffalo Spgs",
    "Buffalo Springs",
    "Anson",
    "Aspermont",
    "Avoca",
    "Baird",
    "Benjamin",
    "Blackwell",
    "Buffalo Gap",
    "Clyde",
    "Coahoma",
    "Colorado City",
    "Fluvanna",
    "Girard",
    "Goldsboro",
    "Hamlin",
    "Haskell",
    "Hawley",
    "Hermleigh",
    "Ira",
    "Jayton",
    "Knox City",
    "Lawn",
    "Loraine",
    "Lueders",
    "McCaulley",
    "Maryneal",
    "Merkel",
    "Nolan",
    "Novice",
    "O'Brien",
    "Old Glory",
    "Ovalo",
    "Roby",
    "Rochester",
    "Roscoe",
    "Rotan",
    "Rule",
    "Sagerton",
    "Snyder",
    "Dermott",
    "Stamford",
    "Sweetwater",
    "Sylvester",
    "Trent",
    "Tuscola",
    "Tye",
    "Westbrook",
    "Wingate",
    "Winters",
    "Abilene",
    "Dyess Afb",
    "Midland",
    "Ackerly",
    "Andrews",
    "Balmorhea",
    "Barstow",
    "Big Spring",
    "Vealmoor",
    "Coyanosa",
    "Crane",
    "Forsan",
    "Fort Davis",
    "Mcdonald Obs",
    "Mcdonald Observatory",
    "Fort Stockton",
    "Gail",
    "Garden City",
    "Goldsmith",
    "Grandfalls",
    "Imperial",
    "Iraan",
    "Kermit",
    "Knott",
    "Lenorah",
    "McCamey",
    "Mccamey",
    "Mentone",
    "Midkiff",
    "Monahans",
    "Thorntonville",
    "Gardendale",
    "Notrees",
    "Odessa",
    "Orla",
    "Pecos",
    "Verhalen",
    "Penwell",
    "Pyote",
    "Rankin",
    "Saragosa",
    "Sheffield",
    "Stanton",
    "Tarzan",
    "Toyah",
    "Wickett",
    "Wink",
    "Anthony",
    "Vinton",
    "Alpine",
    "Big Bend National Park",
    "Bg Bnd Ntl Pk",
    "Canutillo",
    "El Paso",
    "Clint",
    "Dell City",
    "Fabens",
    "Fort Hancock",
    "Marathon",
    "Marfa",
    "Shafter",
    "Presidio",
    "Redford",
    "Salt Flat",
    "Sanderson",
    "San Elizario",
    "Sierra Blanca",
    "Terlingua",
    "Lajitas",
    "Tornillo",
    "Valentine",
    "Van Horn",
    "Kent",
    "Fort Bliss",
    "Ysleta Del Sur Pueblo",
    "Ysleta Sur",
    "Biggs Field",
    "Horizon City",
    "Socorro",
    "Desert Haven",
  ],
  UT: [
    "Altamont",
    "Altonah",
    "American Fork",
    "Highland",
    "Alpine",
    "Eagle Mountain",
    "Eagle Mtn",
    "Lehi",
    "Saratoga",
    "Saratoga Spgs",
    "Saratoga Springs",
    "Bingham Canyon",
    "Bingham Cyn",
    "Copperton",
    "Bluebell",
    "Bonanza",
    "South Jordan",
    "Bountiful",
    "N Salt Lake",
    "North Salt Lake",
    "W Bountiful",
    "West Bountiful",
    "Woods Cross",
    "Cedar Valley",
    "Fairfield",
    "Centerville",
    "Clearfield",
    "Clinton",
    "Sunset",
    "West Point",
    "Coalville",
    "Wanship",
    "Croydon",
    "Draper",
    "Duchesne",
    "Bridgeland",
    "Dugway",
    "Terra",
    "Dutch John",
    "Red Canyon",
    "Echo",
    "Farmington",
    "Fort Duchesne",
    "Gusher",
    "Ouray",
    "Fruitland",
    "Garden City",
    "Grantsville",
    "Lakeside",
    "Skull Valley",
    "Hanna",
    "Heber City",
    "Daniel",
    "Mayflower Mnt",
    "Henefer",
    "Ibapah",
    "Callao",
    "Jensen",
    "Kamas",
    "Francis",
    "Hideout",
    "Kaysville",
    "Fruit Heights",
    "Laketown",
    "Lapoint",
    "Layton",
    "Lindon",
    "Magna",
    "Manila",
    "Midvale",
    "Cottonwd Hts",
    "Cottonwood Heights",
    "Midway",
    "Morgan",
    "Mountain Green",
    "Mtn Green",
    "Mountain Home",
    "Myton",
    "Neola",
    "Oakley",
    "Hill Afb",
    "Hill Air Force Base",
    "Orem",
    "Vineyard",
    "Park City",
    "Deer Valley",
    "Peoa",
    "Pleasant Grove",
    "Cedar Hills",
    "Pleasant Grv",
    "Randlett",
    "Randolph",
    "Riverton",
    "Bluffdale",
    "Herriman",
    "Roosevelt",
    "Ballard",
    "Roy",
    "Rush Valley",
    "Sandy",
    "Stockton",
    "Ophir",
    "South Rim",
    "Tabiona",
    "Talmage",
    "Tooele",
    "Erda",
    "Lake Point",
    "Stansbury Park",
    "Stansbury Pk",
    "Syracuse",
    "Tridell",
    "Vernal",
    "Naples",
    "Vernon",
    "West Jordan",
    "W Valley City",
    "West Valley",
    "West Valley City",
    "Wallsburg",
    "Wendover",
    "Greenhaven",
    "Partoun",
    "Trout Creek",
    "Whiterocks",
    "Woodruff",
    "Alta",
    "Snowbird",
    "White City",
    "Snyderville",
    "Salt Lake City",
    "Salt Lake Cty",
    "Slc",
    "Millcreek",
    "S Salt Lake",
    "South Salt Lake",
    "Murray",
    "Emigration Canyon",
    "Emigratn Cyn",
    "Holladay",
    "Holladay Cottonwood",
    "Holladay Ctwd",
    "Kearns",
    "Taylorsville",
    "Brighton",
    "Cottonwood",
    "Cottonwood Heights City",
    "Solitude",
    "Salt Lake",
    "Bear River City",
    "Bear River Cy",
    "Brigham City",
    "Perry",
    "Cache Junction",
    "Cache Jct",
    "Clarkston",
    "Collinston",
    "Beaverdam",
    "Corinne",
    "Cornish",
    "Deweyville",
    "Eden",
    "Liberty",
    "Fielding",
    "Garland",
    "Grouse Creek",
    "Honeyville",
    "Hooper",
    "Kanesville",
    "Howell",
    "Huntsville",
    "Hyde Park",
    "Hyrum",
    "Lewiston",
    "Cove",
    "Logan",
    "Nibley",
    "River Heights",
    "Mantua",
    "Mendon",
    "Millville",
    "Newton",
    "Paradise",
    "Park Valley",
    "Plymouth",
    "Portage",
    "Providence",
    "Richmond",
    "Riverside",
    "Smithfield",
    "Amalga",
    "Benson",
    "Snowville",
    "Tremonton",
    "Elwood",
    "Penrose",
    "Thatcher",
    "Trenton",
    "Wellsville",
    "Willard",
    "North Logan",
    "Ogden",
    "Marriott Slaterville",
    "Marriott Slaterville City",
    "Mriott Sltrvl",
    "Ms City",
    "Msc",
    "Taylor",
    "West Haven",
    "South Ogden",
    "South Weber",
    "Uintah",
    "Farr West",
    "Harrisville",
    "North Ogden",
    "Plain City",
    "Pleasant View",
    "Riverdale",
    "Washington Terrace",
    "Washington Tr",
    "Price",
    "Blanding",
    "White Mesa",
    "Bluff",
    "Castle Dale",
    "Cisco",
    "Clawson",
    "Cleveland",
    "East Carbon",
    "Elmo",
    "Emery",
    "Ferron",
    "Green River",
    "Helper",
    "Scofield",
    "Huntington",
    "Kenilworth",
    "La Sal",
    "Mexican Hat",
    "Moab",
    "Castle Valley",
    "Lake Powell",
    "Bullfrog",
    "Halls Crossing",
    "Halls Xing",
    "Hite",
    "Ticaboo",
    "Montezuma Creek",
    "Montezuma Crk",
    "Monticello",
    "Monument Valley New",
    "Monument Vly",
    "Orangeville",
    "Sunnyside",
    "Thompson",
    "Wellington",
    "Provo",
    "Provo Canyon",
    "Sundance",
    "Aurora",
    "Axtell",
    "Centerfield",
    "Chester",
    "Delta",
    "Deseret",
    "Oasis",
    "Sugarville",
    "Sutherland",
    "Elberta",
    "Ephraim",
    "Eureka",
    "Mammoth",
    "Fairview",
    "Indianola",
    "Mount Pleasant",
    "Mt Pleasant",
    "Thistle",
    "Fayette",
    "Fillmore",
    "Fountain Green",
    "Fountain Grn",
    "Goshen",
    "Gunnison",
    "Hinckley",
    "Abraham",
    "Holden",
    "Kanosh",
    "Leamington",
    "Levan",
    "Lynndyl",
    "Manti",
    "Mayfield",
    "Meadow",
    "Mona",
    "Rocky Ridge",
    "Rocky Ridge Town",
    "Moroni",
    "Nephi",
    "Oak City",
    "Payson",
    "Elk Ridge",
    "Redmond",
    "Salem",
    "Woodland Hills",
    "Woodland Hls",
    "Salina",
    "Santaquin",
    "Genola",
    "Scipio",
    "Sigurd",
    "Spanish Fork",
    "Benjamin",
    "Spring City",
    "Springville",
    "Mapleton",
    "Sterling",
    "Wales",
    "Richfield",
    "Venice",
    "Alton",
    "Annabella",
    "Antimony",
    "Beaver",
    "Beryl",
    "Bicknell",
    "Boulder",
    "Cannonville",
    "Brian Head",
    "Cedar City",
    "Enoch",
    "Pintura",
    "Central",
    "Circleville",
    "Elsinore",
    "Enterprise",
    "Escalante",
    "Garrison",
    "Glendale",
    "Glenwood",
    "Greenville",
    "Adamsville",
    "Greenwich",
    "Gunlock",
    "Hanksville",
    "Hatch",
    "Mammoth Creek",
    "Henrieville",
    "Hurricane",
    "Apple Valley",
    "Ivins",
    "Joseph",
    "Junction",
    "Kanab",
    "Big Water",
    "Canyon Point",
    "Kanarraville",
    "Kingston",
    "Koosharem",
    "Burrville",
    "La Verkin",
    "Leeds",
    "Loa",
    "Fremont",
    "Lyman",
    "Marysvale",
    "Milford",
    "Minersville",
    "Modena",
    "Monroe",
    "Austin",
    "Central Valley",
    "Central Vly",
    "Mount Carmel",
    "Newcastle",
    "New Harmony",
    "Orderville",
    "Panguitch",
    "Paragonah",
    "Parowan",
    "Duck Creek Village",
    "Duck Crk Vlg",
    "Rockville",
    "Bryce",
    "Bryce Canyon",
    "Bryce Canyon City",
    "Bryce Cyn Cty",
    "Santa Clara",
    "Sevier",
    "Springdale",
    "Zion National Park",
    "Zion Ntl Park",
    "Saint George",
    "St George",
    "Summit",
    "Teasdale",
    "Toquerville",
    "Torrey",
    "Tropic",
    "Virgin",
    "Washington",
    "Pine Valley",
    "Veyo",
    "Brookside",
    "Dammeron Valley",
    "Dammeron Vly",
    "Hildale",
  ],
  VA: [
    "Aldie",
    "Stone Ridge",
    "Amissville",
    "Viewtown",
    "Manassas",
    "Sudley Spgs",
    "Sudley Springs",
    "Manassas Park",
    "Marshall",
    "Middleburg",
    "Catlett",
    "Centreville",
    "Sully Station",
    "Clifton",
    "Paeonian Springs",
    "Paeonian Spgs",
    "Paris",
    "Purcellville",
    "Hillsboro",
    "Bluemont",
    "Mount Weather",
    "Bristow",
    "Broad Run",
    "Round Hill",
    "Catharpin",
    "Delaplane",
    "Ashburn",
    "Brambleton",
    "Broadlands",
    "Chantilly",
    "Fairfax",
    "South Riding",
    "Gainesville",
    "Hamilton",
    "Sterling",
    "Potomac Falls",
    "Arcola",
    "Dulles",
    "Haymarket",
    "Herndon",
    "Oak Hill",
    "Leesburg",
    "Lansdowne",
    "Lovettsville",
    "Nokesville",
    "Upperville",
    "Warrenton",
    "New Baltimore",
    "Vint Hill Farms",
    "Vint Hill Frm",
    "Reston",
    "Waterford",
    "The Plains",
    "Annandale",
    "Burke",
    "Springfield",
    "Dumfries",
    "Montclair",
    "Southbridge",
    "Dunn Loring",
    "Vienna",
    "Fairfax Station",
    "Fairfax Sta",
    "Fx Station",
    "Falls Church",
    "Baileys Crossroads",
    "Baileys Xrds",
    "Mosby",
    "Pimmit",
    "Seven Corners",
    "Fort Belvoir",
    "Ft Belvoir",
    "Great Falls",
    "Lorton",
    "Mason Neck",
    "McLean",
    "Mclean",
    "Tysons",
    "Tysons Corner",
    "West Mclean",
    "Oakton",
    "Occoquan",
    "Quantico",
    "N Springfield",
    "North Springfield",
    "W Springfield",
    "West Springfield",
    "Triangle",
    "Woodbridge",
    "Lake Ridge",
    "Prince William",
    "Prince Wm",
    "Dale City",
    "Arlington",
    "Rosslyn",
    "Fort Myer",
    "Ft Myer",
    "Alexandria",
    "Potomac",
    "Jefferson Manor",
    "Jefferson Mnr",
    "Community",
    "Belleview",
    "Fort Hunt",
    "Engleside",
    "Franconia",
    "Lincolnia",
    "Kingstowne",
    "Fredericksburg",
    "Fredericksbrg",
    "Falmouth",
    "Bowling Green",
    "Fort A P Hill",
    "Burgess",
    "Burr Hill",
    "Callao",
    "Caret",
    "Supply",
    "Center Cross",
    "Champlain",
    "Chance",
    "Colonial Beach",
    "Colonial Bch",
    "Oak Grove",
    "Washgtns Brhp",
    "Washingtons Birthplace",
    "Dahlgren",
    "Dunnsville",
    "Howertons",
    "Farnham",
    "Hague",
    "Haynesville",
    "Heathsville",
    "Hustle",
    "Irvington",
    "Kilmarnock",
    "King George",
    "Shiloh",
    "Kinsale",
    "Lancaster",
    "Alfonso",
    "Regina",
    "Laneview",
    "Locust Grove",
    "Lake Of The Woods",
    "Lake Of Woods",
    "Mine Run",
    "Loretto",
    "Lottsburg",
    "Lewisetta",
    "Milford",
    "Montross",
    "Oldhams",
    "Partlow",
    "Port Royal",
    "Rappahannock Academy",
    "Raphanck Acad",
    "Reedville",
    "Rhoadesville",
    "Ruther Glen",
    "Sharps",
    "Spotsylvania",
    "Snell",
    "Stafford",
    "Tappahannock",
    "Unionville",
    "Warsaw",
    "Foneswood",
    "Weems",
    "White Stone",
    "Woodford",
    "Winchester",
    "Hayfield",
    "Bentonville",
    "Browntown",
    "Berryville",
    "Boyce",
    "Chester Gap",
    "Clear Brook",
    "Cross Junction",
    "Cross Jct",
    "Whitacre",
    "Flint Hill",
    "Huntly",
    "Front Royal",
    "Lake Frederick",
    "Lk Frederick",
    "Riverton",
    "Gore",
    "Hume",
    "Strasburg",
    "Lebanon Ch",
    "Lebanon Church",
    "Linden",
    "Markham",
    "Maurertown",
    "Middletown",
    "Millwood",
    "Rileyville",
    "Fort Valley",
    "Saint Davids Church",
    "Seven Fountains",
    "Seven Fountns",
    "St Davids Ch",
    "Star Tannery",
    "Stephens City",
    "Stephenson",
    "Toms Brook",
    "White Post",
    "Woodstock",
    "Culpeper",
    "Raccoon Ford",
    "Winston",
    "Aroda",
    "Banco",
    "Bealeton",
    "Morrisville",
    "Boston",
    "Brandy Station",
    "Brandy Sta",
    "Brightwood",
    "Castleton",
    "Elkwood",
    "Etlan",
    "Madison",
    "Goldvein",
    "Haywood",
    "Hood",
    "Jeffersonton",
    "Leon",
    "Lignum",
    "Graves Mill",
    "Midland",
    "Mitchells",
    "Oakpark",
    "Pratts",
    "Radiant",
    "Rapidan",
    "Remington",
    "Reva",
    "Richardsville",
    "Rixeyville",
    "Rochelle",
    "Uno",
    "Sperryville",
    "Stevensburg",
    "Sumerduck",
    "Syria",
    "Washington",
    "Woodville",
    "Harrisonburg",
    "Rockingham",
    "Basye",
    "Bergton",
    "Bridgewater",
    "Broadway",
    "Criders",
    "Dayton",
    "Montezuma",
    "Edinburg",
    "Elkton",
    "Fulks Run",
    "Hinton",
    "Keezletown",
    "Linville",
    "Luray",
    "McGaheysville",
    "Massanutten",
    "Mcgaheysville",
    "Mount Crawford",
    "Mt Crawford",
    "Mount Jackson",
    "Mount Solon",
    "New Market",
    "Orkney Springs",
    "Orkney Spgs",
    "Penn Laird",
    "Quicksburg",
    "Shenandoah Caverns",
    "Shendoah Cvrn",
    "Shenandoah",
    "Singers Glen",
    "Stanley",
    "Timberville",
    "Charlottesville",
    "Charlottesvle",
    "Monticello",
    "University",
    "Afton",
    "Arrington",
    "Lowesville",
    "Tye River",
    "Barboursville",
    "Burnleys",
    "Eheart",
    "Covesville",
    "Crozet",
    "Yancey Mills",
    "Dyke",
    "Boonesville",
    "Nortonsville",
    "St George",
    "Earlysville",
    "Esmont",
    "Faber",
    "Fishersville",
    "Free Union",
    "Mission Home",
    "Gordonsville",
    "Zion Crossrds",
    "Zion Crossroads",
    "Greenwood",
    "Keene",
    "Keswick",
    "Boyd Tavern",
    "Campbell",
    "Cismont",
    "Cobham",
    "Shadwell",
    "Locust Dale",
    "Lovingston",
    "Lyndhurst",
    "Sherando",
    "Montpelier Station",
    "Mntpelier Sta",
    "Nellysford",
    "North Garden",
    "Orange",
    "Madison Mills",
    "Montford",
    "Nasons",
    "Thornhill",
    "Palmyra",
    "Bybee",
    "Cunningham",
    "Wildwood",
    "Wilmington",
    "Piney River",
    "Roseland",
    "Massies Mill",
    "Wintergreen Resort",
    "Wintergrn Rst",
    "Ruckersville",
    "Advance Mills",
    "Schuyler",
    "Shipman",
    "Rockfish",
    "Somerset",
    "Stanardsville",
    "Troy",
    "Tyro",
    "Waynesboro",
    "Woodberry Forest",
    "Woodberry For",
    "Amelia Court House",
    "Amelia Ct Hse",
    "Arvonia",
    "Ashland",
    "Aylett",
    "Barhamsville",
    "Beaverdam",
    "Bohannon",
    "Bremo Bluff",
    "Bruington",
    "Bumpass",
    "Cardinal",
    "Miles",
    "Cartersville",
    "Tamworth",
    "Charles City",
    "Church View",
    "Cobbs Creek",
    "Blakes",
    "Columbia",
    "Crozier",
    "Cumberland",
    "Deltaville",
    "Diggs",
    "Doswell",
    "Dutton",
    "Fork Union",
    "Foster",
    "Mobjack",
    "Glen Allen",
    "Gloucester",
    "Bellamy",
    "Naxera",
    "Pinero",
    "Zanoni",
    "Gloucester Point",
    "Glou Point",
    "Gloucester Pt",
    "Goochland",
    "Fife",
    "Gum Spring",
    "Gwynn",
    "Hallieford",
    "Hanover",
    "Mangohick",
    "Hardyville",
    "Hartfield",
    "Hayes",
    "Henrico",
    "Highland Spgs",
    "Highland Springs",
    "Hudgins",
    "Redart",
    "Jamaica",
    "Jamestown",
    "Williamsburg",
    "Jetersville",
    "Kents Store",
    "King And Queen Court House",
    "King Queen Ch",
    "King William",
    "Lanexa",
    "Little Plymouth",
    "Little Plymth",
    "Locust Hill",
    "Louisa",
    "Maidens",
    "Dabneys",
    "Manakin Sabot",
    "Manquin",
    "Mascot",
    "Mathews",
    "Beaverlett",
    "Mattaponi",
    "Mechanicsville",
    "Mechanicsvlle",
    "Midlothian",
    "Mineral",
    "Moon",
    "Moseley",
    "New Canton",
    "New Kent",
    "Newtown",
    "North",
    "James Store",
    "Oilville",
    "Onemo",
    "Port Haywood",
    "Bavon",
    "Peary",
    "Powhatan",
    "Macon",
    "Providence Forge",
    "Provdence Frg",
    "Quinton",
    "Rockville",
    "Ruthville",
    "Saint Stephens Church",
    "Cauthornville",
    "Indian Neck",
    "St Stephens Church",
    "St Stephns Ch",
    "Saluda",
    "Sandston",
    "Sandy Hook",
    "Shacklefords",
    "Plain View",
    "State Farm",
    "Stevensville",
    "Susan",
    "Shadow",
    "Toano",
    "Topping",
    "Syringa",
    "Richmond",
    "Urbanna",
    "Warner",
    "Wake",
    "Walkerton",
    "Water View",
    "West Point",
    "Cologne",
    "Montpelier",
    "N Chesterfld",
    "North Chesterfield",
    "Regency",
    "Ridge",
    "Ampthill",
    "Bon Air",
    "Rich Int Ap",
    "Richmond Int Airport",
    "Accomac",
    "Assawoman",
    "Atlantic",
    "Battery Park",
    "Belle Haven",
    "Birdsnest",
    "Bloxom",
    "Cape Charles",
    "Carrollton",
    "Carrsville",
    "Walters",
    "Cheriton",
    "Chesapeake",
    "South Norfolk",
    "Chincoteague Island",
    "Chincoteague",
    "Wallops Island",
    "Wallops Is",
    "Eastville",
    "Exmore",
    "Franktown",
    "Greenbackville",
    "Greenbackvile",
    "Greenbush",
    "Hacksneck",
    "Hacks Neck",
    "Hallwood",
    "Harborton",
    "Horntown",
    "Jamesville",
    "Keller",
    "Machipongo",
    "Mappsville",
    "Marionville",
    "Mears",
    "Melfa",
    "Nassawadox",
    "Weirwood",
    "Nelsonia",
    "New Church",
    "Oak Hall",
    "Onancock",
    "Onley",
    "Painter",
    "Parksley",
    "Lee Mont",
    "Pungoteague",
    "Quinby",
    "Sanford",
    "Saxis",
    "Smithfield",
    "Suffolk",
    "Tangier",
    "Tasley",
    "Temperanceville",
    "Temperancevle",
    "Virginia Beach",
    "Va Bch",
    "Va Beach",
    "Vab",
    "Virginia Bch",
    "Princess Anne",
    "Fort Story",
    "Wachapreague",
    "Willis Wharf",
    "Windsor",
    "Withams",
    "Norfolk",
    "Fleet",
    "Naval Base",
    "Newport News",
    "Fort Eustis",
    "Hampton",
    "Fort Monroe",
    "Poquoson",
    "Langley AFB",
    "Yorktown",
    "Nav Wpns Sta",
    "Naval Weapons Station",
    "Grafton",
    "Tabb",
    "Seaford",
    "Portsmouth",
    "Fort Gregg Adams",
    "Petersburg",
    "N Dinwiddie",
    "North Dinwiddie",
    "S Chesterfld",
    "South Chesterfield",
    "S Prince Geo",
    "South Prince George",
    "Alberta",
    "Blackstone",
    "Boykins",
    "Branchville",
    "Capron",
    "Carson",
    "Chester",
    "Chesterfield",
    "Church Road",
    "Colonial Heights",
    "Colonial Hgts",
    "Courtland",
    "Dendron",
    "Dewitt",
    "Dinwiddie",
    "Disputanta",
    "Dolphin",
    "Drewryville",
    "Ebony",
    "Elberon",
    "Emporia",
    "Ford",
    "Franklin",
    "Freeman",
    "Gasburg",
    "Hopewell",
    "N Prince Geo",
    "North Prince George",
    "Ivor",
    "Jarratt",
    "Lawrenceville",
    "Triplet",
    "McKenney",
    "Newsoms",
    "Prince George",
    "Rawlings",
    "Sedley",
    "Skippers",
    "Spring Grove",
    "Stony Creek",
    "Surry",
    "Sussex",
    "Sutherland",
    "Valentines",
    "Wakefield",
    "Warfield",
    "Waverly",
    "White Plains",
    "Wilsons",
    "Yale",
    "Zuni",
    "Claremont",
    "Farmville",
    "Baskerville",
    "Boydton",
    "Bracey",
    "Brodnax",
    "Buckingham",
    "Burkeville",
    "Charlotte Court House",
    "Charlotte C H",
    "Chase City",
    "Clarksville",
    "Crewe",
    "Cullen",
    "Dillwyn",
    "Sprouses Corn",
    "Sprouses Corner",
    "Drakes Branch",
    "Dundas",
    "Green Bay",
    "Hampden Sydney",
    "Hmpden Sydney",
    "Kenbridge",
    "Keysville",
    "La Crosse",
    "Blackridge",
    "Forksville",
    "South Hill",
    "Lunenburg",
    "Meherrin",
    "Nottoway",
    "Pamplin",
    "Darlingtn Hts",
    "Darlington Heights",
    "Phenix",
    "Prospect",
    "Randolph",
    "Red House",
    "Red Oak",
    "Rice",
    "Saxe",
    "Skipwith",
    "Victoria",
    "Wylliesburg",
    "Roanoke",
    "Cave Spring",
    "Hollins",
    "Hollins Clg",
    "Hollins College",
    "Ararat",
    "Axton",
    "Bassett",
    "Belspring",
    "Bent Mountain",
    "Blacksburg",
    "Blue Ridge",
    "Boones Mill",
    "Buchanan",
    "Lithia",
    "Callaway",
    "Cascade",
    "Catawba",
    "Check",
    "Simpsons",
    "Christiansburg",
    "Christiansbrg",
    "Claudville",
    "Cloverdale",
    "Collinsville",
    "Copper Hill",
    "Critz",
    "Daleville",
    "Dublin",
    "Eagle Rock",
    "Eggleston",
    "Elliston",
    "Ironto",
    "Lafayette",
    "Ferrum",
    "Charity",
    "Fieldale",
    "Fincastle",
    "Floyd",
    "Alum Ridge",
    "Glade Hill",
    "Glen Lyn",
    "Goodview",
    "Hardy",
    "Henry",
    "Huddleston",
    "Indian Valley",
    "Martinsville",
    "Meadows Of Dan",
    "Meadows Dan",
    "Moneta",
    "Montvale",
    "Narrows",
    "New Castle",
    "Newport",
    "New River",
    "Paint Bank",
    "Parrott",
    "Patrick Springs",
    "Patrick Spgs",
    "Pearisburg",
    "Pembroke",
    "Penhook",
    "Pilot",
    "Pittsville",
    "Radford",
    "Fairlawn",
    "Rich Creek",
    "Ridgeway",
    "Riner",
    "Ripplemead",
    "Goldbond",
    "Rocky Mount",
    "Salem",
    "Sandy Level",
    "Shawsville",
    "Spencer",
    "Staffordsville",
    "Staffordsvlle",
    "Stanleytown",
    "Stuart",
    "Thaxton",
    "Troutville",
    "Union Hall",
    "Vinton",
    "Wirtz",
    "Burnt Chimney",
    "Woolwine",
    "Bristol",
    "Abingdon",
    "Appalachia",
    "Exeter",
    "Stonega",
    "Bee",
    "Big Stone Gap",
    "Birchleaf",
    "Blackwater",
    "Castlewood",
    "Cleveland",
    "Clinchco",
    "Clintwood",
    "Coeburn",
    "Damascus",
    "Dante",
    "Trammel",
    "Davenport",
    "Dryden",
    "Duffield",
    "Clinchport",
    "Dungannon",
    "East Stone Gap",
    "E Stone Gap",
    "Ewing",
    "Fort Blackmore",
    "Ft Blackmore",
    "Gate City",
    "Haysi",
    "Hiltons",
    "Honaker",
    "Council",
    "Elk Garden",
    "Venia",
    "Jonesville",
    "Keokee",
    "Lebanon",
    "McClure",
    "Mendota",
    "Nickelsville",
    "Nora",
    "Norton",
    "Pennington Gap",
    "Penningtn Gap",
    "Pound",
    "Rosedale",
    "Rose Hill",
    "Saint Charles",
    "Saint Paul",
    "Weber City",
    "Whitetop",
    "Wise",
    "Pulaski",
    "Atkins",
    "Austinville",
    "Barren Springs",
    "Barren Spgs",
    "Bastian",
    "Bland",
    "Broadford",
    "Cana",
    "Ceres",
    "Chilhowie",
    "Cripple Creek",
    "Crockett",
    "Draper",
    "Dugspur",
    "Elk Creek",
    "Emory",
    "Fancy Gap",
    "Fries",
    "Galax",
    "Glade Spring",
    "Hillsville",
    "Hiwassee",
    "Allisonia",
    "Independence",
    "Ivanhoe",
    "Lambsburg",
    "Laurel Fork",
    "Marion",
    "Seven Mile Fd",
    "Seven Mile Ford",
    "Max Meadows",
    "Fort Chiswell",
    "Foster Falls",
    "Meadowview",
    "Clinchburg",
    "Mouth Of Wilson",
    "Mouth Wilson",
    "Volney",
    "Rocky Gap",
    "Rural Retreat",
    "Saltville",
    "Speedwell",
    "Sugar Grove",
    "Tannersville",
    "Troutdale",
    "Willis",
    "Woodlawn",
    "Wytheville",
    "Staunton",
    "Augusta Springs",
    "Augusta Sprgs",
    "Bacova",
    "Blue Grass",
    "Brownsburg",
    "Buena Vista",
    "Churchville",
    "Clifton Forge",
    "Covington",
    "Alleghany",
    "Jordan Mines",
    "Craigsville",
    "Crimora",
    "Deerfield",
    "Doe Hill",
    "Fairfield",
    "Fort Defiance",
    "Goshen",
    "Greenville",
    "Grottoes",
    "Head Waters",
    "Hot Springs",
    "Iron Gate",
    "Lexington",
    "Low Moor",
    "McDowell",
    "Middlebrook",
    "Millboro",
    "Montebello",
    "Monterey",
    "Hightown",
    "Mustoe",
    "Mount Sidney",
    "New Hope",
    "Port Republic",
    "Raphine",
    "Rockbridge Baths",
    "Rockbdge Bath",
    "Selma",
    "Steeles Tavern",
    "Spottswood",
    "Steeles Tavrn",
    "Stuarts Draft",
    "Swoope",
    "Verona",
    "Vesuvius",
    "Warm Springs",
    "Bolar",
    "West Augusta",
    "Weyers Cave",
    "Williamsville",
    "Burnsville",
    "Lynchburg",
    "Timberlake",
    "Altavista",
    "Alton",
    "Amherst",
    "Appomattox",
    "Bedford",
    "Big Island",
    "Blairs",
    "Brookneal",
    "Buffalo Junction",
    "Buffalo Jct",
    "Callands",
    "Chatham",
    "Clover",
    "Coleman Falls",
    "Concord",
    "Crystal Hill",
    "Danville",
    "Dry Fork",
    "Evington",
    "Forest",
    "Gladstone",
    "Gladys",
    "Glasgow",
    "Goode",
    "Gretna",
    "Halifax",
    "Howardsville",
    "Scottsville",
    "Hurt",
    "Java",
    "Keeling",
    "Long Island",
    "Lowry",
    "Lynch Station",
    "Madison Heights",
    "Madison Hts",
    "Monroe",
    "Nathalie",
    "Lennig",
    "Republican Grove",
    "Republicn Grv",
    "Natural Bridge",
    "Natural Brg",
    "Natural Bridge Station",
    "Naturl Br Sta",
    "Nelson",
    "Norwood",
    "Ringgold",
    "Rustburg",
    "Scottsburg",
    "South Boston",
    "Turbeville",
    "Spout Spring",
    "Sutherlin",
    "Sweet Briar",
    "Vernon Hill",
    "Ingram",
    "Virgilina",
    "Wingina",
    "Amonate",
    "Bandy",
    "Big Rock",
    "Conaway",
    "Bishop",
    "Bluefield",
    "Yards",
    "Boissevain",
    "Breaks",
    "Cedar Bluff",
    "Doran",
    "Falls Mills",
    "Grundy",
    "Hurley",
    "Jewell Ridge",
    "Jewell Valley",
    "North Tazewell",
    "N Tazewell",
    "Tiptop",
    "Oakwood",
    "Patterson",
    "Pilgrims Knob",
    "Pocahontas",
    "Pounding Mill",
    "Raven",
    "Richlands",
    "Rowe",
    "Swords Creek",
    "Tazewell",
    "Vansant",
    "Whitewood",
  ],
  VI: [
    "St Thomas",
    "Charlotte Ama",
    "Charlotte Amalie",
    "Christiansted",
    "St Croix",
    "St John",
    "Cruz Bay",
    "Frederiksted",
    "Kingshill",
  ],
  VT: [
    "White River Junction",
    "White Riv Jct",
    "Ascutney",
    "Barnard",
    "Bethel",
    "Bradford",
    "Bridgewater",
    "Bridgewater Corners",
    "Brdgewtr Cors",
    "Bridgewtr Cor",
    "Brookfield",
    "Brownsville",
    "Chelsea",
    "Corinth",
    "East Corinth",
    "East Randolph",
    "East Ryegate",
    "Ryegate",
    "East Thetford",
    "Fairlee",
    "Groton",
    "Hartland",
    "McIndoe Falls",
    "Mc Indoe Fls",
    "Mcindoe Falls",
    "Newbury",
    "North Hartland",
    "N Hartland",
    "North Pomfret",
    "Pomfret",
    "Norwich",
    "Plymouth",
    "Post Mills",
    "Quechee",
    "Randolph",
    "Braintree",
    "W Brookfield",
    "West Brookfield",
    "Randolph Center",
    "Randolph Ctr",
    "Reading",
    "Sharon",
    "South Pomfret",
    "South Royalton",
    "S Royalton",
    "South Ryegate",
    "South Strafford",
    "S Strafford",
    "South Woodstock",
    "S Woodstock",
    "Strafford",
    "Taftsville",
    "Thetford Center",
    "Thetford Ctr",
    "Topsham",
    "Tunbridge",
    "Vershire",
    "Wells River",
    "West Fairlee",
    "West Hartford",
    "West Topsham",
    "East Orange",
    "Wilder",
    "Windsor",
    "West Windsor",
    "Woodstock",
    "Bellows Falls",
    "Cambridgeport",
    "Cavendish",
    "Chester",
    "Andover",
    "Athens",
    "Baltimore",
    "Grafton",
    "Londonderry",
    "Landgrove",
    "Ludlow",
    "North Springfield",
    "N Springfield",
    "Perkinsville",
    "Peru",
    "Proctorsville",
    "South Reading",
    "Saxtons River",
    "South Londonderry",
    "S Londonderry",
    "Stratton Mnt",
    "Stratton Mountain",
    "Stratton Mtn",
    "Springfield",
    "Westminster",
    "Weston",
    "Bennington",
    "Woodford",
    "Arlington",
    "Sandgate",
    "Sunderland",
    "West Arlingtn",
    "West Arlington",
    "Dorset",
    "East Arlington",
    "E Arlington",
    "East Dorset",
    "Manchester",
    "Manchester Center",
    "Manchestr Ctr",
    "North Bennington",
    "N Bennington",
    "North Pownal",
    "Pownal",
    "Shaftsbury",
    "Brattleboro",
    "Dummerston",
    "Guilford",
    "W Brattleboro",
    "West Brattleboro",
    "Bondville",
    "Winhall",
    "East Dover",
    "Dover",
    "Jacksonville",
    "Jamaica",
    "Marlboro",
    "Newfane",
    "Brookline",
    "Putney",
    "E Dummerston",
    "East Dummerston",
    "Westminster W",
    "Westminster West",
    "Readsboro",
    "South Newfane",
    "Stamford",
    "Townshend",
    "Vernon",
    "Wardsboro",
    "West Dover",
    "Mount Snow",
    "West Halifax",
    "West Townshend",
    "W Townshend",
    "Windham",
    "West Wardsboro",
    "Stratton",
    "W Wardsboro",
    "Whitingham",
    "Williamsville",
    "Wilmington",
    "Searsburg",
    "West Marlboro",
    "Burlington",
    "South Burlington",
    "S Burlington",
    "Winooski",
    "Colchester",
    "Alburgh",
    "Alburg",
    "Bakersfield",
    "Belvidere Center",
    "Belvidere Ctr",
    "Bristol",
    "Lincoln",
    "Cambridge",
    "Charlotte",
    "East Berkshire",
    "E Berkshire",
    "East Fairfield",
    "E Fairfield",
    "Enosburg Falls",
    "Enosburg Fls",
    "Essex Junction",
    "Essex Jct",
    "Fairfax",
    "Fairfield",
    "Sheldon",
    "Ferrisburgh",
    "Franklin",
    "Grand Isle",
    "Highgate Center",
    "Highgate Ctr",
    "Hinesburg",
    "Huntington",
    "Isle La Motte",
    "Jeffersonville",
    "Jeffersonvlle",
    "Jericho",
    "Jericho Center",
    "Jericho Ctr",
    "Milton",
    "Montgomery Center",
    "Montgomry Ctr",
    "New Haven",
    "North Ferrisburgh",
    "N Ferrisburgh",
    "North Hero",
    "Richford",
    "Richmond",
    "Bolton Valley",
    "Saint Albans",
    "Saint Albans Bay",
    "St Albans Bay",
    "Shelburne",
    "Sheldon Springs",
    "Sheldon Spgs",
    "South Hero",
    "Starksboro",
    "Swanton",
    "Underhill",
    "Vergennes",
    "Addison",
    "Panton",
    "Waterville",
    "Westford",
    "Williston",
    "Saint George",
    "St George",
    "Montpelier",
    "Berlin",
    "Middlesex",
    "Middlesex Center",
    "Middlesex Ctr",
    "Adamant",
    "Barre",
    "Orange",
    "Cabot",
    "Calais",
    "East Barre",
    "East Calais",
    "East Montpelier",
    "E Montpelier",
    "Eden",
    "Eden Mills",
    "Graniteville",
    "Hyde Park",
    "Johnson",
    "Marshfield",
    "Moretown",
    "South Duxbury",
    "Morrisville",
    "Elmore",
    "Morristown",
    "Northfield",
    "Riverton",
    "West Berlin",
    "Northfield Falls",
    "Northfield Fl",
    "Northfld Fls",
    "North Montpelier",
    "N Montpelier",
    "Plainfield",
    "Roxbury",
    "W Braintree",
    "West Braintree",
    "South Barre",
    "Stowe",
    "Waitsfield",
    "Warren",
    "Washington",
    "Waterbury",
    "Waterbury Center",
    "Waterbury Ctr",
    "Websterville",
    "Williamstown",
    "Wolcott",
    "Woodbury",
    "Worcester",
    "N Middlesex",
    "North Middlesex",
    "Rutland",
    "Mendon",
    "S Chittenden",
    "South Chittenden",
    "Belmont",
    "Benson",
    "Bomoseen",
    "Brandon",
    "Goshen",
    "Leicester",
    "Sudbury",
    "Bridport",
    "Castleton",
    "Center Rutland",
    "Ctr Rutland",
    "Chittenden",
    "Cuttingsville",
    "Shrewsbury",
    "Danby",
    "Mount Tabor",
    "East Wallingford",
    "E Wallingford",
    "Fair Haven",
    "West Haven",
    "Florence",
    "Gaysville",
    "Granville",
    "Hancock",
    "Killington",
    "Middlebury",
    "Cornwall",
    "Weybridge",
    "Middletown Springs",
    "Middletwn Spg",
    "Mount Holly",
    "North Clarendon",
    "N Clarendon",
    "Orwell",
    "Pawlet",
    "Pittsfield",
    "Pittsford",
    "N Chittenden",
    "North Chittenden",
    "Poultney",
    "Proctor",
    "Ripton",
    "Rochester",
    "Rupert",
    "Salisbury",
    "Shoreham",
    "Stockbridge",
    "Wallingford",
    "Tinmouth",
    "Wells",
    "West Pawlet",
    "West Rupert",
    "West Rutland",
    "Clarendn Spgs",
    "Clarendon Springs",
    "Whiting",
    "West Cornwall",
    "Saint Johnsbury",
    "St Johnsbury",
    "Waterford",
    "Albany",
    "Barnet",
    "Barton",
    "Concord",
    "Coventry",
    "Craftsbury",
    "Craftsbury Common",
    "Craftsbry Cmn",
    "Craftsbury Cm",
    "Danville",
    "Derby",
    "Derby Line",
    "East Burke",
    "East Charleston",
    "E Charleston",
    "East Hardwick",
    "East Haven",
    "Glover",
    "Granby",
    "Greensboro",
    "Greensboro Bend",
    "Greensbro Bnd",
    "Grnsboro Bend",
    "Hardwick",
    "Irasburg",
    "Island Pond",
    "Ferdinand",
    "Lowell",
    "Lyndon Center",
    "Lyndonville",
    "Morgan",
    "Morgan Ctr",
    "Newport",
    "Newport Center",
    "Newport Ctr",
    "North Concord",
    "Victory",
    "North Troy",
    "Jay",
    "Jay Peak",
    "Orleans",
    "Brownington",
    "Peacham",
    "Sheffield",
    "Sutton",
    "Troy",
    "West Burke",
    "West Charleston",
    "W Charleston",
    "West Danville",
    "Westfield",
    "West Glover",
    "Averill",
    "Canaan",
    "Beecher Falls",
    "Lemington",
    "Gilman",
    "Guildhall",
    "Bloomfield",
    "Brunswick",
    "Maidstone",
    "Lunenburg",
    "East Concord",
    "Norton",
  ],
  WA: [
    "Auburn",
    "Algona",
    "Federal Way",
    "Bellevue",
    "Beaux Arts",
    "Clyde Hill",
    "Hunts Point",
    "Yarrow Point",
    "Black Diamond",
    "Bothell",
    "Mill Creek",
    "Carnation",
    "Duvall",
    "Edmonds",
    "Woodway",
    "Enumclaw",
    "Fall City",
    "Hobart",
    "Issaquah",
    "Kenmore",
    "Sammamish",
    "Kent",
    "Kirkland",
    "Redmond",
    "Lynnwood",
    "Brier",
    "Maple Valley",
    "Medina",
    "Mercer Island",
    "Covington",
    "Mountlake Terrace",
    "Mountlake Ter",
    "North Bend",
    "Pacific",
    "Preston",
    "Ravensdale",
    "Renton",
    "Newcastle",
    "Snoqualmie",
    "Snoqualmie Pass",
    "Snoqualmie Ps",
    "Vashon",
    "Woodinville",
    "Seattle",
    "Tukwila",
    "Bainbridge Island",
    "Bainbridge Is",
    "Shoreline",
    "Burien",
    "Des Moines",
    "Normandy Park",
    "Seatac",
    "Lake Forest Park",
    "Lk Forest Pk",
    "Everett",
    "Acme",
    "Anacortes",
    "Decatur Is",
    "Decatur Island",
    "Blakely Island",
    "Blakely Is",
    "Arlington",
    "Baring",
    "Bellingham",
    "Blaine",
    "Bow",
    "Burlington",
    "Clearlake",
    "Clinton",
    "Concrete",
    "Conway",
    "Coupeville",
    "Custer",
    "Darrington",
    "Deer Harbor",
    "Deming",
    "Eastsound",
    "Everson",
    "Ferndale",
    "Freeland",
    "Friday Harbor",
    "Roche Harbor",
    "Gold Bar",
    "Granite Falls",
    "Greenbank",
    "Hamilton",
    "Index",
    "La Conner",
    "Lake Stevens",
    "Langley",
    "Lopez Island",
    "Lummi Island",
    "Lyman",
    "Lynden",
    "Maple Falls",
    "Marblemount",
    "Marysville",
    "Quil Ceda Village",
    "Quil Ceda Vlg",
    "Tulalip",
    "Monroe",
    "Mount Vernon",
    "Mukilteo",
    "Nooksack",
    "Oak Harbor",
    "Nas Whidbey",
    "Whidbey Island Naval Air",
    "Olga",
    "Orcas",
    "Point Roberts",
    "Camano Island",
    "Stanwood",
    "Rockport",
    "Sedro Woolley",
    "Shaw Island",
    "Skykomish",
    "Snohomish",
    "Sultan",
    "Sumas",
    "Waldron",
    "Anderson Island",
    "Anderson Is",
    "Ashford",
    "Beaver",
    "Bremerton",
    "Silverdale",
    "Brinnon",
    "Buckley",
    "Carbonado",
    "Chimacum",
    "Clallam Bay",
    "Dupont",
    "Eatonville",
    "Gig Harbor",
    "Wauna",
    "Elbe",
    "Forks",
    "Fox Island",
    "Glenoma",
    "Gorst",
    "Graham",
    "Port Hadlock",
    "Hansville",
    "Indianola",
    "Keyport",
    "Kingston",
    "Lakebay",
    "Home",
    "La Push",
    "Longbranch",
    "Manchester",
    "Milton",
    "Mineral",
    "Morton",
    "Neah Bay",
    "Nordland",
    "Olalla",
    "Orting",
    "Packwood",
    "Port Angeles",
    "Port Gamble",
    "Port Ludlow",
    "Port Orchard",
    "S Park Vlg",
    "South Park Village",
    "Port Townsend",
    "Poulsbo",
    "Puyallup",
    "Edgewood",
    "South Hill",
    "Quilcene",
    "Randle",
    "Seabeck",
    "Sekiu",
    "Sequim",
    "South Prairie",
    "Spanaway",
    "Bethel",
    "Steilacoom",
    "Sumner",
    "Bonney Lake",
    "Lake Tapps",
    "Suquamish",
    "Vaughn",
    "Wilkeson",
    "Tacoma",
    "Ruston",
    "Lakewood",
    "Fife",
    "Camp Murray",
    "Fort Lewis",
    "Ft Lewis",
    "Joint Base Lewis Mcchord",
    "Lewis Mcchord",
    "Mcchord Afb",
    "Mcchord AFB",
    "Parkland",
    "Fircrest",
    "University Pl",
    "University Place",
    "Olympia",
    "Tumwater",
    "Lacey",
    "Aberdeen",
    "Allyn",
    "Amanda Park",
    "Bay Center",
    "Belfair",
    "Bucoda",
    "Centralia",
    "Chehalis",
    "Napavine",
    "Cinebar",
    "Copalis Beach",
    "Copalis Crossing",
    "Copalis Xing",
    "Cosmopolis",
    "Curtis",
    "Doty",
    "Elma",
    "Ethel",
    "Galvin",
    "Grapeview",
    "Grayland",
    "Hoodsport",
    "Hoquiam",
    "Humptulips",
    "Lilliwaup",
    "Littlerock",
    "Mccleary",
    "Mckenna",
    "Malone",
    "Matlock",
    "Moclips",
    "Montesano",
    "Mossyrock",
    "Neilton",
    "Oakville",
    "Ocean Shores",
    "Ocean City",
    "Onalaska",
    "Pacific Beach",
    "Pe Ell",
    "Quinault",
    "Rainier",
    "Raymond",
    "Rochester",
    "Roy",
    "Ryderwood",
    "Salkum",
    "Satsop",
    "Shelton",
    "Skok",
    "Skokomish Nation",
    "Silver Creek",
    "South Bend",
    "Taholah",
    "Tahuya",
    "Tenino",
    "Tokeland",
    "Toledo",
    "Union",
    "Vader",
    "Westport",
    "Winlock",
    "Yelm",
    "Amboy",
    "Appleton",
    "Ariel",
    "Battle Ground",
    "Bingen",
    "Cook",
    "Brush Prairie",
    "Camas",
    "Carrolls",
    "Carson",
    "Castle Rock",
    "Cathlamet",
    "Centerville",
    "Chinook",
    "Cougar",
    "Dallesport",
    "Glenwood",
    "Goldendale",
    "Grays River",
    "Husum",
    "Ilwaco",
    "Kalama",
    "Kelso",
    "Klickitat",
    "La Center",
    "Long Beach",
    "Longview",
    "Lyle",
    "Naselle",
    "North Bonneville",
    "N Bonneville",
    "Ocean Park",
    "Oysterville",
    "Ridgefield",
    "Rosburg",
    "Seaview",
    "Silverlake",
    "Skamokawa",
    "Stevenson",
    "Toutle",
    "Trout Lake",
    "Underwood",
    "Vancouver",
    "Wahkiacus",
    "Washougal",
    "White Salmon",
    "Wishram",
    "Woodland",
    "Yacolt",
    "Wenatchee",
    "East Wenatchee",
    "E Wenatchee",
    "Ardenvoir",
    "Brewster",
    "Bridgeport",
    "Carlton",
    "Cashmere",
    "Chelan",
    "Chelan Falls",
    "Conconully",
    "Dryden",
    "Entiat",
    "Ephrata",
    "George",
    "Leavenworth",
    "Loomis",
    "Malaga",
    "Malott",
    "Mansfield",
    "Manson",
    "Marlin",
    "Mazama",
    "Methow",
    "Monitor",
    "Moses Lake",
    "Okanogan",
    "Omak",
    "Orondo",
    "Oroville",
    "Palisades",
    "Pateros",
    "Peshastin",
    "Quincy",
    "Riverside",
    "Rock Island",
    "Soap Lake",
    "Stehekin",
    "Stratford",
    "Tonasket",
    "Twisp",
    "Warden",
    "Waterville",
    "Wauconda",
    "Wilson Creek",
    "Winthrop",
    "Yakima",
    "Union Gap",
    "Buena",
    "Cle Elum",
    "Cowiche",
    "Easton",
    "Ellensburg",
    "Kittitas",
    "Grandview",
    "Granger",
    "Harrah",
    "Mabton",
    "Moxee",
    "Naches",
    "Goose Prairie",
    "Outlook",
    "Parker",
    "Ronald",
    "Roslyn",
    "Selah",
    "South Cle Elum",
    "S Cle Elum",
    "Sunnyside",
    "Thorp",
    "Tieton",
    "Toppenish",
    "Vantage",
    "Wapato",
    "White Swan",
    "Zillah",
    "Airway Heights",
    "Airway Hgts",
    "Chattaroy",
    "Cheney",
    "Colbert",
    "Deer Park",
    "Edwall",
    "Elk",
    "Fairchild Air Force Base",
    "Fairchild AFB",
    "Fairfield",
    "Ford",
    "Four Lakes",
    "Greenacres",
    "Liberty Lake",
    "Spokane Valley",
    "Spokane Vly",
    "Lamont",
    "Sprague",
    "Latah",
    "Marshall",
    "Mead",
    "Medical Lake",
    "Espanola",
    "Mica",
    "Valleyford",
    "Newman Lake",
    "Nine Mile Falls",
    "Nine Mile Fls",
    "Otis Orchards",
    "City Of Spokane Valley",
    "Reardan",
    "Rockford",
    "Spangle",
    "Tekoa",
    "Tumtum",
    "Veradale",
    "Waverly",
    "Wellpinit",
    "Addy",
    "Albion",
    "Almira",
    "Benge",
    "Chewelah",
    "Clayton",
    "Colfax",
    "Diamond",
    "Colton",
    "Colville",
    "Coulee City",
    "Coulee Dam",
    "Creston",
    "Curlew",
    "Cusick",
    "Danville",
    "Davenport",
    "Deer Meadows",
    "Seven Bays",
    "Electric City",
    "Elmer City",
    "Endicott",
    "Evans",
    "Kettle Falls",
    "Farmington",
    "Fruitland",
    "Hunters",
    "Garfield",
    "Gifford",
    "Grand Coulee",
    "Harrington",
    "Hartline",
    "Hay",
    "Inchelium",
    "Ione",
    "Keller",
    "Lacrosse",
    "Lamona",
    "Odessa",
    "Laurier",
    "Lincoln",
    "Loon Lake",
    "Malden",
    "Malo",
    "Marcus",
    "Metaline",
    "Metaline Falls",
    "Metaline Fls",
    "Mohler",
    "Nespelem",
    "Newport",
    "Northport",
    "Oakesdale",
    "Orient",
    "Palouse",
    "Pullman",
    "Republic",
    "Rice",
    "Ritzville",
    "Rosalia",
    "Plaza",
    "Saint John",
    "Springdale",
    "Steptoe",
    "Thornton",
    "Uniontown",
    "Usk",
    "Valley",
    "Wilbur",
    "Spokane",
    "Millwood",
    "Pasco",
    "Benton City",
    "Beverly",
    "Bickleton",
    "Burbank",
    "College Place",
    "Connell",
    "Dayton",
    "Dixie",
    "Eltopia",
    "Hooper",
    "Kahlotus",
    "Kennewick",
    "Lind",
    "Mesa",
    "Othello",
    "Hatton",
    "Paterson",
    "Plymouth",
    "Pomeroy",
    "Prescott",
    "Mattawa",
    "Desert Aire",
    "Prosser",
    "Richland",
    "West Richland",
    "Roosevelt",
    "Royal City",
    "Starbuck",
    "Touchet",
    "Lowden",
    "Waitsburg",
    "Walla Walla",
    "Wallula",
    "Washtucna",
    "Anatone",
    "Asotin",
    "Clarkston",
  ],
  WI: [
    "Adell",
    "Allenton",
    "Ashippun",
    "Belgium",
    "Brookfield",
    "Brownsville",
    "Byron",
    "South Byron",
    "Butler",
    "Campbellsport",
    "Cascade",
    "Cedarburg",
    "Cedar Grove",
    "Chilton",
    "Cleveland",
    "Clyman",
    "Colgate",
    "Delafield",
    "Eden",
    "Elkhart Lake",
    "Fredonia",
    "Waubeka",
    "Germantown",
    "Rockfield",
    "Glenbeulah",
    "Grafton",
    "Hartford",
    "Hartland",
    "Hingham",
    "Horicon",
    "Hubertus",
    "Hustisford",
    "Iron Ridge",
    "Ixonia",
    "Jackson",
    "Johnson Creek",
    "Juneau",
    "Kewaskum",
    "Kiel",
    "Kohler",
    "Lannon",
    "Lebanon",
    "Lomira",
    "Knowles",
    "Malone",
    "Mayville",
    "Menomonee Falls",
    "Menomonee Fls",
    "Mount Calvary",
    "Nashotah",
    "Neosho",
    "New Holstein",
    "Newton",
    "Oakfield",
    "Oconomowoc",
    "Summit",
    "Okauchee",
    "Oostburg",
    "Pewaukee",
    "Plymouth",
    "Port Washington",
    "Prt Washingtn",
    "Random Lake",
    "Richfield",
    "Rubicon",
    "Saint Cloud",
    "Saukville",
    "Sheboygan",
    "Haven",
    "Howards Grove",
    "Sheboygan Falls",
    "Sheboygan Fls",
    "Slinger",
    "Stockbridge",
    "Sussex",
    "Lisbon",
    "West Bend",
    "Theresa",
    "Mequon",
    "Thiensville",
    "Waldo",
    "Watertown",
    "Woodland",
    "Big Bend",
    "Bristol",
    "Burlington",
    "Caledonia",
    "Cudahy",
    "Darien",
    "Delavan",
    "Dousman",
    "Eagle",
    "East Troy",
    "Elkhorn",
    "Elm Grove",
    "Fontana",
    "Franksville",
    "Genesee Depot",
    "Genoa City",
    "Greendale",
    "Hales Corners",
    "Franklin",
    "Helenville",
    "Kansasville",
    "Kenosha",
    "New Berlin",
    "Lake Geneva",
    "Mukwonago",
    "Muskego",
    "North Prairie",
    "Oak Creek",
    "Palmyra",
    "Pell Lake",
    "Pleasant Prairie",
    "Pleasant Pr",
    "Rochester",
    "Salem",
    "Silver Lake",
    "South Milwaukee",
    "S Milwaukee",
    "Springfield",
    "Sturtevant",
    "Mount Pleasant",
    "Mt Pleasant",
    "Sullivan",
    "Trevor",
    "Twin Lakes",
    "Union Grove",
    "Wales",
    "Walworth",
    "Waterford",
    "Wind Lake",
    "Waukesha",
    "Vernon",
    "Whitewater",
    "Williams Bay",
    "Wilmot",
    "Zenda",
    "Milwaukee",
    "Bay View",
    "Brown Deer",
    "Glendale",
    "River Hills",
    "Wauwatosa",
    "Shorewood",
    "Whitefish Bay",
    "W Milwaukee",
    "West Allis",
    "West Milwaukee",
    "Bayside",
    "Fox Point",
    "Greenfield",
    "Saint Francis",
    "St Francis",
    "Racine",
    "Wind Point",
    "Elmwood Park",
    "Afton",
    "Albany",
    "Arena",
    "Argyle",
    "Avalon",
    "Avoca",
    "Barneveld",
    "Belleville",
    "Belmont",
    "Beloit",
    "Black Earth",
    "Blanchardville",
    "Blanchardvlle",
    "Blue Mounds",
    "Blue River",
    "Brodhead",
    "Brooklyn",
    "Browntown",
    "Cambridge",
    "Clinton",
    "Cobb",
    "Cottage Grove",
    "Cross Plains",
    "Dane",
    "Darlington",
    "Deerfield",
    "Deforest",
    "Dodgeville",
    "Edgerton",
    "Evansville",
    "Footville",
    "Fort Atkinson",
    "Gotham",
    "Gratiot",
    "Highland",
    "Hollandale",
    "Janesville",
    "Jefferson",
    "Juda",
    "Lake Mills",
    "Linden",
    "Livingston",
    "Lodi",
    "Lone Rock",
    "Lowell",
    "Mcfarland",
    "Marshall",
    "Mazomanie",
    "Merrimac",
    "Middleton",
    "Milton",
    "Mineral Point",
    "Monroe",
    "Montfort",
    "Monticello",
    "Morrisonville",
    "Mount Horeb",
    "Muscoda",
    "New Glarus",
    "Oregon",
    "Fitchburg",
    "Orfordville",
    "Plain",
    "Prairie Du Sac",
    "Pr Du Sac",
    "Reeseville",
    "Rewey",
    "Richland Center",
    "Richland Ctr",
    "Ridgeway",
    "Sauk City",
    "Sextonville",
    "Sharon",
    "Shullsburg",
    "South Wayne",
    "Spring Green",
    "Stoughton",
    "Sun Prairie",
    "Verona",
    "Waterloo",
    "Waunakee",
    "Westport",
    "Windsor",
    "Woodford",
    "Madison",
    "Monona",
    "Bagley",
    "Beetown",
    "Benton",
    "Bloomington",
    "Boscobel",
    "Cassville",
    "Cuba City",
    "Dickeyville",
    "Fennimore",
    "Glen Haven",
    "Hazel Green",
    "Kieler",
    "Lancaster",
    "Mount Hope",
    "Patch Grove",
    "Platteville",
    "Potosi",
    "Prairie Du Chien",
    "Pr Du Chien",
    "Stitzer",
    "Wauzeka",
    "Woodman",
    "Portage",
    "Adams",
    "Arlington",
    "Baraboo",
    "Beaver Dam",
    "Brandon",
    "Briggsville",
    "Burnett",
    "Cambria",
    "Friesland",
    "Cazenovia",
    "Columbus",
    "Dalton",
    "Doylestown",
    "Elroy",
    "Endeavor",
    "Fairwater",
    "Fall River",
    "Fox Lake",
    "Friendship",
    "Grand Marsh",
    "Hillpoint",
    "Kingston",
    "Lake Delton",
    "La Valle",
    "Lime Ridge",
    "Loganville",
    "Lyndon Station",
    "Lyndon Sta",
    "Markesan",
    "Manchester",
    "Marquette",
    "Mauston",
    "Montello",
    "New Lisbon",
    "North Freedom",
    "Oxford",
    "Brooks",
    "Packwaukee",
    "Pardeeville",
    "Poynette",
    "Randolph",
    "Reedsburg",
    "Rio",
    "Rock Springs",
    "Union Center",
    "Waupun",
    "Westfield",
    "Wisconsin Dells",
    "Wisc Dells",
    "Wonewoc",
    "Wyocena",
    "Amery",
    "Deronda",
    "Baldwin",
    "Beldenville",
    "Clayton",
    "Clear Lake",
    "Cushing",
    "Deer Park",
    "Dresser",
    "Ellsworth",
    "Glenwood City",
    "Emerald",
    "Hager City",
    "Hammond",
    "Hudson",
    "New Richmond",
    "Osceola",
    "Prescott",
    "River Falls",
    "Roberts",
    "Saint Croix Falls",
    "St Croix Fls",
    "Somerset",
    "Star Prairie",
    "Wilson",
    "Woodville",
    "Houlton",
    "Abrams",
    "Amberg",
    "Armstrong Creek",
    "Armstrong Crk",
    "Athelstane",
    "Silver Cliff",
    "Black Creek",
    "Bonduel",
    "Navarino",
    "Brillion",
    "Cecil",
    "Coleman",
    "Combined Locks",
    "Combined Lcks",
    "Crivitz",
    "Beaver",
    "Middle Inlet",
    "De Pere",
    "Ashwaubenon",
    "Hobart",
    "Dunbar",
    "Pembine",
    "Fence",
    "Florence",
    "Forest Junction",
    "Forest Jct",
    "Gillett",
    "Pulcifer",
    "Underhill",
    "Goodman",
    "Greenleaf",
    "Green Valley",
    "Gresham",
    "Hilbert",
    "Kaukauna",
    "Freedom",
    "Keshena",
    "Kimberly",
    "Krakow",
    "Lakewood",
    "Lena",
    "Stiles",
    "Little Chute",
    "Little Suamico",
    "Ltl Suamico",
    "Marinette",
    "Mountain",
    "Neopit",
    "Niagara",
    "Nichols",
    "Oconto",
    "Oconto Falls",
    "Oneida",
    "Peshtigo",
    "Porterfield",
    "Potter",
    "Pound",
    "Pulaski",
    "Seymour",
    "Shawano",
    "Sherwood",
    "Shiocton",
    "Sobieski",
    "Suamico",
    "Suring",
    "Townsend",
    "Wausaukee",
    "Wrightstown",
    "Algoma",
    "Rio Creek",
    "Baileys Harbor",
    "Baileys Hbr",
    "Brussels",
    "Casco",
    "Collins",
    "Denmark",
    "Egg Harbor",
    "Ellison Bay",
    "Ephraim",
    "Fish Creek",
    "Forestville",
    "Francis Creek",
    "Kellnersville",
    "Kewaunee",
    "Luxemburg",
    "Manitowoc",
    "Maribel",
    "Mishicot",
    "New Franken",
    "Green Bay",
    "Reedsville",
    "Cato",
    "Saint Nazianz",
    "Sister Bay",
    "Sturgeon Bay",
    "Maplewood",
    "Two Rivers",
    "Valders",
    "Washington Island",
    "Washington Is",
    "Whitelaw",
    "Branch",
    "Allouez",
    "Howard",
    "Bellevue",
    "Wausau",
    "Abbotsford",
    "Amherst",
    "Amherst Junction",
    "Amherst Jct",
    "Aniwa",
    "Antigo",
    "Arpin",
    "Athens",
    "Hamburg",
    "Milan",
    "Auburndale",
    "Babcock",
    "Birnamwood",
    "Bowler",
    "Brokaw",
    "Bryant",
    "Chili",
    "Colby",
    "Curtiss",
    "Custer",
    "Deerbrook",
    "Kempster",
    "Dorchester",
    "Edgar",
    "Fenwood",
    "Eland",
    "Elcho",
    "Elton",
    "Gilman",
    "Gleason",
    "Granton",
    "Greenwood",
    "Hatley",
    "Hewitt",
    "Irma",
    "Junction City",
    "Loyal",
    "Lublin",
    "Marathon",
    "Marshfield",
    "Mattoon",
    "Medford",
    "Chelsea",
    "Merrill",
    "Milladore",
    "Mosinee",
    "Kronenwetter",
    "Neillsville",
    "Nekoosa",
    "Nelsonville",
    "Ogema",
    "Owen",
    "Pearson",
    "Pelican Lake",
    "Phlox",
    "Pickerel",
    "Pittsville",
    "Plover",
    "Port Edwards",
    "Rib Lake",
    "Ringle",
    "Rosholt",
    "Rothschild",
    "Rudolph",
    "Schofield",
    "Weston",
    "Spencer",
    "Stetsonville",
    "Stevens Point",
    "Stratford",
    "Summit Lake",
    "Tigerton",
    "Tomahawk",
    "Unity",
    "Vesper",
    "Westboro",
    "White Lake",
    "Lily",
    "Willard",
    "Wisconsin Rapids",
    "Wisc Rapids",
    "Withee",
    "Wittenberg",
    "Rhinelander",
    "Monico",
    "Argonne",
    "Cavour",
    "Hiles",
    "Newald",
    "Boulder Junction",
    "Boulder Jct",
    "Brantwood",
    "Butternut",
    "Catawba",
    "Clam Lake",
    "Conover",
    "Crandon",
    "Eagle River",
    "Fifield",
    "Gile",
    "Glen Flora",
    "Ingram",
    "Glidden",
    "Harshaw",
    "Hawkins",
    "Hazelhurst",
    "Hurley",
    "Iron Belt",
    "Kennan",
    "Lac Du Flambeau",
    "Lac Du Flambu",
    "Lake Tomahawk",
    "Land O'Lakes",
    "Laona",
    "Long Lake",
    "Alvin",
    "Nelma",
    "Tipler",
    "Manitowish Waters",
    "Manitowsh Wtr",
    "Mellen",
    "Mercer",
    "Minocqua",
    "Montreal",
    "Pence",
    "Park Falls",
    "Phelps",
    "Phillips",
    "Prentice",
    "Presque Isle",
    "Winchester",
    "Saint Germain",
    "Saxon",
    "Gurney",
    "Sayner",
    "Star Lake",
    "Three Lakes",
    "Tony",
    "Tripoli",
    "Upson",
    "Wabeno",
    "Woodruff",
    "Arbor Vitae",
    "La Crosse",
    "Alma",
    "Alma Center",
    "Arcadia",
    "Arkdale",
    "Bangor",
    "Black River Falls",
    "Blk River Fls",
    "Blair",
    "Camp Douglas",
    "Cutler",
    "Cashton",
    "Chaseburg",
    "Cochrane",
    "Buffalo City",
    "Waumandee",
    "Coon Valley",
    "De Soto",
    "Victory",
    "Dodge",
    "Eastman",
    "Lynxville",
    "Ettrick",
    "Ferryville",
    "Fountain City",
    "Galesville",
    "Gays Mills",
    "Genoa",
    "Hillsboro",
    "Bloom City",
    "Yuba",
    "Hixton",
    "Northfield",
    "Holmen",
    "Hustler",
    "Kendall",
    "La Farge",
    "West Lima",
    "Melrose",
    "Millston",
    "Mindoro",
    "Mount Sterling",
    "Mt Sterling",
    "Necedah",
    "Norwalk",
    "Onalaska",
    "Ontario",
    "Readstown",
    "Rockland",
    "Seneca",
    "Soldiers Grove",
    "Soldier Grove",
    "Sparta",
    "Fort Mccoy",
    "Steuben",
    "Stoddard",
    "Taylor",
    "Tomah",
    "Wyeville",
    "Trempealeau",
    "Viola",
    "Viroqua",
    "Warrens",
    "Westby",
    "West Salem",
    "Wilton",
    "Eau Claire",
    "Altoona",
    "Arkansaw",
    "Augusta",
    "Bay City",
    "Bloomer",
    "Boyceville",
    "Boyd",
    "Cadott",
    "Chetek",
    "Chippewa Falls",
    "Chippewa Fls",
    "Lake Hallie",
    "Colfax",
    "Conrath",
    "Cornell",
    "Dallas",
    "Hillsdale",
    "Downing",
    "Durand",
    "Eau Galle",
    "Eleva",
    "Elk Mound",
    "Elmwood",
    "Fairchild",
    "Fall Creek",
    "Holcombe",
    "Humbird",
    "Independence",
    "Jim Falls",
    "Knapp",
    "Maiden Rock",
    "Menomonie",
    "Merrillan",
    "Mondovi",
    "Modena",
    "Rock Falls",
    "Nelson",
    "New Auburn",
    "Osseo",
    "Pepin",
    "Pigeon Falls",
    "Plum City",
    "Prairie Farm",
    "Ridgeland",
    "Sheldon",
    "Spring Valley",
    "Stanley",
    "Stockholm",
    "Strum",
    "Thorp",
    "Wheeler",
    "Whitehall",
    "Spooner",
    "Almena",
    "Ashland",
    "Moquah",
    "Sanborn",
    "Balsam Lake",
    "Barron",
    "Poskin",
    "Barronett",
    "Bayfield",
    "Birchwood",
    "Bruce",
    "Brule",
    "Cable",
    "Cameron",
    "Centuria",
    "Comstock",
    "Cornucopia",
    "Couderay",
    "New Post",
    "Cumberland",
    "Danbury",
    "Dairyland",
    "Webb Lake",
    "Yellow Lake",
    "Drummond",
    "Exeland",
    "Foxboro",
    "Frederic",
    "Clam Falls",
    "Lewis",
    "Gordon",
    "Wascott",
    "Grand View",
    "Grantsburg",
    "Haugen",
    "Hawthorne",
    "Hayward",
    "N Woods Beach",
    "North Woods Beach",
    "Herbster",
    "Hertel",
    "High Bridge",
    "Highbridge",
    "Marengo",
    "Iron River",
    "Ladysmith",
    "Lake Nebagamon",
    "Lk Nebagamon",
    "La Pointe",
    "Luck",
    "Maple",
    "Mason",
    "Delta",
    "Mikana",
    "Milltown",
    "Minong",
    "Odanah",
    "Ojibwa",
    "Poplar",
    "Port Wing",
    "Radisson",
    "Rice Lake",
    "Canton",
    "Sarona",
    "Shell Lake",
    "Siren",
    "Solon Springs",
    "Barnes",
    "Bennett",
    "South Range",
    "Wentworth",
    "Springbrook",
    "Stone Lake",
    "Superior",
    "Oliver",
    "Trego",
    "Turtle Lake",
    "Washburn",
    "Webster",
    "Weyerhaeuser",
    "Winter",
    "Loretta",
    "Oshkosh",
    "Almond",
    "Appleton",
    "Grand Chute",
    "Bancroft",
    "Bear Creek",
    "Berlin",
    "Big Falls",
    "Butte Des Morts",
    "Bte Des Morts",
    "Caroline",
    "Clintonville",
    "Coloma",
    "Dale",
    "Eldorado",
    "Embarrass",
    "Fond Du Lac",
    "N Fond Du Lac",
    "North Fond Du Lac",
    "Taycheedah",
    "Fremont",
    "Green Lake",
    "Greenville",
    "Hancock",
    "Hortonville",
    "Medina",
    "Iola",
    "King",
    "Larsen",
    "Leopolis",
    "Manawa",
    "Marion",
    "Menasha",
    "Neenah",
    "Neshkoro",
    "New London",
    "Royalton",
    "Ogdensburg",
    "Omro",
    "Eureka",
    "Pickett",
    "Pine River",
    "Plainfield",
    "Poy Sippi",
    "Princeton",
    "Redgranite",
    "Ripon",
    "Rosendale",
    "Scandinavia",
    "Tilleda",
    "Van Dyne",
    "Waukau",
    "Waupaca",
    "Wautoma",
    "Weyauwega",
    "Wild Rose",
    "Winnebago",
    "Winneconne",
  ],
  WV: [
    "Bluefield",
    "Bluewell",
    "Green Valley",
    "Athens",
    "Beeson",
    "Bramwell",
    "Bud",
    "Covel",
    "Freeman",
    "Coaldale",
    "Herndon",
    "Hiawatha",
    "Kegley",
    "Lashmeet",
    "Matoaka",
    "Dott",
    "Montcalm",
    "Nemours",
    "Princeton",
    "Oakvale",
    "Elgood",
    "Rock",
    "Duhring",
    "Mc Comas",
    "Welch",
    "Capels",
    "Coalwood",
    "Havaco",
    "Hemphill",
    "Skygusty",
    "Superior",
    "Wolf Pen",
    "Anawalt",
    "Leckie",
    "Avondale",
    "Bartley",
    "Berwind",
    "Canebrake",
    "Vallscreek",
    "Big Sandy",
    "Bradshaw",
    "Brenton",
    "Clear Fork",
    "Coal Mountain",
    "Cucumber",
    "Cyclone",
    "Davy",
    "Asco",
    "Twin Branch",
    "Elbert",
    "Filbert",
    "Elkhorn",
    "Fanrock",
    "Gary",
    "Hanover",
    "Hensley",
    "Iaeger",
    "Ikes Fork",
    "Isaban",
    "Itmann",
    "Jenkinjones",
    "Jesse",
    "Jolo",
    "Justice",
    "Kimball",
    "Vivian",
    "Kopperston",
    "Kyle",
    "Lynco",
    "Matheny",
    "Maybeury",
    "Mohawk",
    "Newhall",
    "New Richmond",
    "Northfork",
    "Algoma",
    "Ashland",
    "Crumpler",
    "Keystone",
    "Mc Dowell",
    "Powhatan",
    "Worth",
    "North Spring",
    "Oceana",
    "Pageton",
    "Panther",
    "Paynesville",
    "Pineville",
    "Premier",
    "Raysal",
    "Rock View",
    "Roderfield",
    "Simon",
    "Squire",
    "Switchback",
    "Thorpe",
    "War",
    "Caretta",
    "English",
    "Yukon",
    "Warriormine",
    "Wilcoe",
    "Wyoming",
    "Lewisburg",
    "Alderson",
    "Dawson",
    "Arbovale",
    "Asbury",
    "Alta",
    "Ballard",
    "Bartow",
    "Buckeye",
    "Caldwell",
    "Cass",
    "Stony Bottom",
    "Crawley",
    "Clintonville",
    "Kieffer",
    "Sam Black",
    "Dunmore",
    "Forest Hill",
    "Indian Mills",
    "Frankford",
    "Anthony",
    "Friars Hill",
    "Gap Mills",
    "Sweet Springs",
    "Grassy Meadows",
    "Grassy Mdws",
    "Green Bank",
    "Greenville",
    "Hillsboro",
    "Droop",
    "Mill Point",
    "Seebert",
    "Lindside",
    "Marlinton",
    "Minehaha Spgs",
    "Minnehaha Springs",
    "Maxwelton",
    "Pence Springs",
    "Peterstown",
    "Bozoo",
    "Renick",
    "Auto",
    "Falling Sprg",
    "Ronceverte",
    "Fort Spring",
    "Organ Cave",
    "Secondcreek",
    "Sinks Grove",
    "Pickaway",
    "Smoot",
    "Meadow Bluff",
    "Talcott",
    "Ballengee",
    "Union",
    "Glace",
    "Sarton",
    "Willow Bend",
    "Waiteville",
    "Wayside",
    "White Sulphur Springs",
    "Neola",
    "Wht Sphr Spgs",
    "Wht Sulphur S",
    "Wht Sulphur Spgs",
    "Williamsburg",
    "Trout",
    "Wolfcreek",
    "Alloy",
    "Alum Creek",
    "Amma",
    "Arnett",
    "Artie",
    "Ashford",
    "Bancroft",
    "Belle",
    "Diamond",
    "Dupont City",
    "Quincy",
    "Shrewsbury",
    "Witcher",
    "Bickmore",
    "Fola",
    "Bim",
    "Blair",
    "Bloomingrose",
    "Blount",
    "Bob White",
    "Bomont",
    "Boomer",
    "Buffalo",
    "Cabin Creek",
    "Cannelton",
    "Cedar Grove",
    "Charlton Heights",
    "Charlton Hgts",
    "Clay",
    "Clear Creek",
    "Clendenin",
    "Clio",
    "Corton",
    "Quick",
    "Clothier",
    "Colcord",
    "Comfort",
    "Costa",
    "Danville",
    "Dawes",
    "Deep Water",
    "Dixie",
    "Dorothy",
    "Ameagle",
    "Drybranch",
    "Dry Creek",
    "Duck",
    "Elmira",
    "Harrison",
    "Strange Creek",
    "Dunbar",
    "East Bank",
    "Crown Hill",
    "Eleanor",
    "Elkview",
    "Frame",
    "Eskdale",
    "Carbon",
    "Decota",
    "Kayford",
    "Leewood",
    "Ohley",
    "Ethel",
    "Foster",
    "Fraziers Bottom",
    "Fraziers Btm",
    "Pliny",
    "Gallagher",
    "Burnwell",
    "Livingston",
    "Mahan",
    "Standard",
    "Whittaker",
    "Gauley Bridge",
    "Brownsville",
    "Glasgow",
    "Glen",
    "Glen Ferris",
    "Gordon",
    "Handley",
    "Hansford",
    "Henderson",
    "Hernshaw",
    "Hewett",
    "Hometown",
    "Hugheston",
    "Indore",
    "Institute",
    "Ivydale",
    "Big Otter",
    "Jeffrey",
    "Ramage",
    "Kanawha Falls",
    "Kimberly",
    "Kincaid",
    "Lake",
    "Leon",
    "Arbuckle",
    "Grimms Landing",
    "Grimms Lndg",
    "Robertsburg",
    "Liberty",
    "Lizemores",
    "Bentree",
    "London",
    "Madison",
    "Mammoth",
    "Maysel",
    "Miami",
    "Montgomery",
    "Mount Carbon",
    "Naoma",
    "Montcoal",
    "Stickney",
    "Sundial",
    "Nebo",
    "Nellis",
    "Nitro",
    "Orgas",
    "Ottawa",
    "Page",
    "Peytona",
    "Pinch",
    "Poca",
    "Lanham",
    "Pond Gap",
    "Powellton",
    "Pratt",
    "Procious",
    "Ovapa",
    "Pigeon",
    "Racine",
    "Red House",
    "Ridgeview",
    "Robson",
    "Beards Fork",
    "Rock Creek",
    "Saint Albans",
    "Jefferson",
    "Saxon",
    "Seth",
    "Prenter",
    "Sharples",
    "Mount Olive",
    "Smithers",
    "Longacre",
    "Southside",
    "Sylvester",
    "Tad",
    "Tornado",
    "Upper Falls",
    "Turtle Creek",
    "Twilight",
    "Bandytown",
    "Uneeda",
    "Van",
    "Wharton",
    "Bald Knob",
    "Barrett",
    "Whitesville",
    "Garrison",
    "Packsville",
    "Pettus",
    "Widen",
    "Winfield",
    "Winifrede",
    "Advent",
    "Arnoldsburg",
    "Sand Ridge",
    "Chloe",
    "Floe",
    "Cottageville",
    "Evans",
    "Gandeeville",
    "Harmony",
    "Gay",
    "Given",
    "Rock Castle",
    "Hartford",
    "Hartford City",
    "Kenna",
    "Kentuck",
    "Romance",
    "Left Hand",
    "Le Roy",
    "Duncan",
    "Liverpool",
    "Letart",
    "Looneyville",
    "Linden",
    "Tariff",
    "Mason",
    "Clifton",
    "Millstone",
    "Millwood",
    "Mount Alto",
    "New Haven",
    "Newton",
    "Uler",
    "Normantown",
    "Letter Gap",
    "Lockney",
    "Stumptown",
    "Orma",
    "Minnora",
    "Reedy",
    "Ripley",
    "Statts Mills",
    "Sandyville",
    "Spencer",
    "Wallback",
    "Valley Fork",
    "Walton",
    "West Columbia",
    "Lakin",
    "Charleston",
    "Big Chimney",
    "South Charleston",
    "S Charleston",
    "Malden",
    "Cross Lanes",
    "Chesapeake",
    "Marmet",
    "Sissonville",
    "Martinsburg",
    "Berkeley Springs",
    "Berkeley Spgs",
    "Hancock",
    "Unger",
    "Bunker Hill",
    "Charles Town",
    "Falling Waters",
    "Falling Wtrs",
    "Gerrardstown",
    "Glengary",
    "Great Cacapon",
    "Harpers Ferry",
    "Bolivar",
    "Hedgesville",
    "Cherry Run",
    "Jones Springs",
    "Inwood",
    "Kearneysville",
    "Middleway",
    "Levels",
    "Millville",
    "Paw Paw",
    "Points",
    "Ranson",
    "Shenandoah Junction",
    "Shendoah Jct",
    "Shepherdstown",
    "Slanesville",
    "Summit Point",
    "Alkol",
    "Apple Grove",
    "Ashton",
    "Barboursville",
    "Big Creek",
    "Branchland",
    "Palermo",
    "Sias",
    "Ceredo",
    "Chapmanville",
    "Shively",
    "Culloden",
    "Dunlow",
    "East Lynn",
    "Fort Gay",
    "Glenhayes",
    "Gallipolis Ferry",
    "Galipolis Fry",
    "Genoa",
    "Radnor",
    "Glenwood",
    "Griffithsville",
    "Griffithsvle",
    "Hamlin",
    "Sweetland",
    "Harts",
    "Ferrellsburg",
    "Leet",
    "Hurricane",
    "Julian",
    "Kenova",
    "Kiahsville",
    "Cove Gap",
    "Lavalette",
    "Lesage",
    "Midkiff",
    "Milton",
    "Myra",
    "Ona",
    "Pecks Mill",
    "Point Pleasant",
    "Pt Pleasant",
    "Prichard",
    "Ranger",
    "Salt Rock",
    "Scott Depot",
    "Sod",
    "Spurlockville",
    "Morrisvale",
    "Sumerco",
    "Wayne",
    "West Hamlin",
    "Yawkey",
    "Logan",
    "Mitchell Hts",
    "Monaville",
    "Rossmore",
    "West Logan",
    "Accoville",
    "Amherstdale",
    "Robinette",
    "Baisden",
    "Bruno",
    "Chauncey",
    "Davin",
    "Gilbert",
    "Hampden",
    "Henlawson",
    "Holden",
    "Kistler",
    "Lorado",
    "Lundale",
    "Lyburn",
    "Earling",
    "Taplin",
    "Mallory",
    "Man",
    "Hunt",
    "Landville",
    "Mount Gay",
    "Omar",
    "Barnabus",
    "Peach Creek",
    "Sarah Ann",
    "Stollings",
    "Mc Connell",
    "Switzer",
    "Verdunville",
    "Verner",
    "Emmett",
    "Wharncliffe",
    "Whitman",
    "Wilkinson",
    "Yolyn",
    "Dehue",
    "Williamson",
    "Nolan",
    "Sprigg",
    "Breeden",
    "Chattaroy",
    "Crum",
    "Delbarton",
    "Myrtle",
    "Stirrat",
    "Dingess",
    "Edgarton",
    "Thacker",
    "Vulcan",
    "Kermit",
    "Lenore",
    "Matewan",
    "Blackberry City",
    "Blckberry Cty",
    "Lobata",
    "Meador",
    "Naugatuck",
    "North Matewan",
    "Ragland",
    "Red Jacket",
    "Varney",
    "Wilsondale",
    "Huntington",
    "Alltizer",
    "Beckley",
    "Allen Junction",
    "Allen Jct",
    "Amigo",
    "Ansted",
    "Beaver",
    "Blue Jay",
    "Glen Morgan",
    "Bolt",
    "Bradley",
    "Camp Creek",
    "Coal City",
    "Jonben",
    "Whitby",
    "Cool Ridge",
    "Corinne",
    "Crab Orchard",
    "Danese",
    "Clifftop",
    "Maplewood",
    "Daniels",
    "Glade Springs",
    "Eccles",
    "Edmond",
    "Fairdale",
    "Fayetteville",
    "Beckwith",
    "Cunard",
    "Wriston",
    "Flat Top",
    "Ghent",
    "Glen Daniel",
    "Glen Fork",
    "Glen Jean",
    "Glen Rogers",
    "Glen White",
    "Harper",
    "Helen",
    "Hico",
    "Hilltop",
    "Josephine",
    "Lansing",
    "Layland",
    "Lawton",
    "Terry",
    "Lester",
    "Lochgelly",
    "Lookout",
    "Maben",
    "Mabscott",
    "MacArthur",
    "McGraws",
    "Saulsville",
    "Mc Graws",
    "Midway",
    "Pemberton",
    "Minden",
    "Mount Hope",
    "Mullens",
    "Oak Hill",
    "Harvey",
    "Redstar",
    "Summerlee",
    "Odd",
    "Pax",
    "Prince",
    "Princewick",
    "Winding Gulf",
    "Prosperity",
    "Raleigh",
    "Ravencliff",
    "Rhodell",
    "East Gulf",
    "Mead",
    "Sabine",
    "Scarbro",
    "Kingston",
    "Shady Spring",
    "Abraham",
    "Slab Fork",
    "Sophia",
    "Mcalpin",
    "Tams",
    "Spanishburg",
    "Stephenson",
    "Surveyor",
    "Thurmond",
    "Victor",
    "Ramsey",
    "Winona",
    "Wyco",
    "Hinton",
    "Brooks",
    "True",
    "Charmco",
    "Bingham",
    "Hines",
    "Orient Hill",
    "Rainelle",
    "Bellwood",
    "Corliss",
    "Hilton Village",
    "Hilton Vlg",
    "Lilly Park",
    "Green Sulphur Springs",
    "Grn Sphr Spgs",
    "Meadow Bridge",
    "Jumping Branch",
    "Jumping Br",
    "Streeter",
    "Lerona",
    "Leslie",
    "Bellburn",
    "Elton",
    "Lockbridge",
    "Meadow Creek",
    "Nimitz",
    "Pipestem",
    "Lovern",
    "Quinwood",
    "Crichton",
    "Marfrance",
    "Rupert",
    "Duo",
    "Kessler",
    "Sandstone",
    "Spring Dale",
    "White Oak",
    "Wheeling",
    "Bethlehem",
    "Elm Grove",
    "Mozart",
    "Overbrook",
    "Warwood",
    "Beech Bottom",
    "Benwood",
    "Bethany",
    "Cameron",
    "Chester",
    "Colliers",
    "Dallas",
    "Follansbee",
    "Glen Dale",
    "Glen Easton",
    "Mcmechen",
    "Moundsville",
    "New Cumberland",
    "New Cumberlnd",
    "Newell",
    "Proctor",
    "New Manchester",
    "New Manchestr",
    "Short Creek",
    "Triadelphia",
    "Valley Grove",
    "Weirton",
    "Wellsburg",
    "West Liberty",
    "Windsor Heights",
    "Windsor Hts",
    "Parkersburg",
    "N Parkersburg",
    "North Hills",
    "North Parkersburg",
    "Vienna",
    "Belleville",
    "Belmont",
    "Eureka",
    "Willow Island",
    "Big Bend",
    "Five Forks",
    "Big Springs",
    "Nobe",
    "Tanner",
    "Brohard",
    "Creston",
    "Annamoriah",
    "Davisville",
    "Elizabeth",
    "Hughes River",
    "Limestone Hill",
    "Limestone Hl",
    "Newark",
    "Spring Valley",
    "Standing Stone",
    "Stndg Stone",
    "Friendly",
    "Bens Run",
    "Grantsville",
    "Macfarlan",
    "Middlebourne",
    "Wick",
    "Mineral Wells",
    "Mount Zion",
    "Munday",
    "New Martinsville",
    "N Martinsvlle",
    "Paden City",
    "Palestine",
    "Blue Goose",
    "Lynncamp",
    "Sanoma",
    "Somervlle Frk",
    "Sommerville Fork",
    "Two Run",
    "Petroleum",
    "Porters Falls",
    "Ravenswood",
    "Murraysville",
    "Sherman",
    "Reader",
    "Rockport",
    "Saint Marys",
    "Sistersville",
    "Smithville",
    "Burnt House",
    "Walker",
    "Freeport",
    "Washington",
    "New England",
    "Waverly",
    "Williamstown",
    "Buckhannon",
    "Century",
    "Tennerton",
    "Fenwick",
    "Erbacon",
    "Craigsville",
    "Cottle",
    "Cowen",
    "Boggs",
    "Camden On Gauley",
    "Camden On Gly",
    "Gauley Mills",
    "Snowshoe",
    "Slatyfork",
    "Adrian",
    "Cleveland",
    "Rock Cave",
    "Diana",
    "French Creek",
    "Alexander",
    "Hacker Valley",
    "Replete",
    "Helvetia",
    "Kanawha Head",
    "Pickens",
    "Selbyville",
    "Tallmansville",
    "Volga",
    "Elkins",
    "Belington",
    "Beverly",
    "Bowden",
    "Wymer",
    "Coalton",
    "Dailey",
    "Davis",
    "Canaan Valley",
    "Richwood",
    "Dryfork",
    "Durbin",
    "Upperglade",
    "Ellamore",
    "Glady",
    "Hambleton",
    "Harman",
    "Hendricks",
    "Huttonsville",
    "Junior",
    "Kerens",
    "Mabie",
    "Mill Creek",
    "Monterville",
    "Montrose",
    "Norton",
    "Parsons",
    "Saint George",
    "Webster Springs",
    "Curtin",
    "Parcoal",
    "Webster Spgs",
    "Red Creek",
    "Thomas",
    "Valley Bend",
    "Valley Head",
    "Mingo",
    "Whitmer",
    "Job",
    "Bergoo",
    "Clarksburg",
    "Country Club",
    "Dawmont",
    "Laurel Park",
    "Laurel Valley",
    "Nutter Fort",
    "Stonewood",
    "Alma",
    "Wilbur",
    "Alum Bridge",
    "Vadis",
    "Anmoore",
    "Auburn",
    "Berea",
    "Bridgeport",
    "Brushy Fork",
    "Lake Ridge",
    "Maple Lake",
    "Burnsville",
    "Gem",
    "Cairo",
    "Camden",
    "Center Point",
    "Coxs Mills",
    "Crawford",
    "Ellenboro",
    "Highland",
    "Flemington",
    "Astor",
    "Brownton",
    "Wendel",
    "Folsom",
    "Galloway",
    "Glenville",
    "Baldwin",
    "Gilmer",
    "Grafton",
    "Belgium",
    "Harmony Grove",
    "Haymond",
    "White Day",
    "Gypsy",
    "Harrisville",
    "Hazelgreen",
    "Mahone",
    "Newberne",
    "Haywood",
    "Hepzibah",
    "Horner",
    "Independence",
    "Ireland",
    "Wildcat",
    "Jacksonburg",
    "Alvy",
    "Lima",
    "Jane Lew",
    "Kincheloe",
    "Linn",
    "Lost Creek",
    "Mcwhorter",
    "Lumberport",
    "Dola",
    "Meadowbrook",
    "Moatsville",
    "Kasson",
    "Mount Clare",
    "Craigmoore",
    "Newburg",
    "New Milton",
    "Orlando",
    "Pennsboro",
    "Greenwood",
    "Mountain",
    "Toll Gate",
    "Philippi",
    "Pine Grove",
    "Hastings",
    "Pullman",
    "Reynoldsville",
    "Rosemont",
    "Rowlesburg",
    "Manheim",
    "Salem",
    "Bristol",
    "Industrial",
    "Wolf Summit",
    "Sand Fork",
    "Stouts Mills",
    "Shinnston",
    "Adamsville",
    "Francis Mine",
    "Owings",
    "Peora",
    "Pine Bluff",
    "Saltwell",
    "Simpson",
    "Smithburg",
    "Smithfield",
    "Spelter",
    "Thornton",
    "Troy",
    "Tunnelton",
    "Walkersville",
    "Roanoke",
    "Wallace",
    "West Milford",
    "Weston",
    "Valley Chapel",
    "West Union",
    "Blandville",
    "Wyatt",
    "Morgantown",
    "Westover",
    "Booth",
    "Everettville",
    "Star City",
    "Little Falls",
    "Albright",
    "Arthurdale",
    "Blacksville",
    "Bretz",
    "Bruceton Mills",
    "Brandonville",
    "Bruceton Mls",
    "Cuzzart",
    "Hazelton",
    "Granville",
    "Kingwood",
    "Maidsville",
    "Core",
    "Masontown",
    "Cascade",
    "Osage",
    "Pentress",
    "Pursglove",
    "Reedsville",
    "Fairmont",
    "Jordan",
    "Monongah",
    "Pleasant Valley",
    "Pleasant Vly",
    "White Hall",
    "Barrackville",
    "Baxter",
    "Burton",
    "Coburn",
    "Carolina",
    "Enterprise",
    "Fairview",
    "Farmington",
    "Four States",
    "Grant Town",
    "Hundred",
    "Idamay",
    "Littleton",
    "Knob Fork",
    "Wileyville",
    "Mannington",
    "Metz",
    "Montana Mines",
    "Rachel",
    "Rivesville",
    "Wana",
    "Wadestown",
    "Worthington",
    "Sutton",
    "Centralia",
    "Herold",
    "Newville",
    "Birch River",
    "Cedarville",
    "Flower",
    "Copen",
    "Dille",
    "Exchange",
    "Riffle",
    "Flatwoods",
    "Corley",
    "Frametown",
    "Clem",
    "Glendon",
    "Wilsie",
    "Gassaway",
    "Chapel",
    "Heaters",
    "Little Birch",
    "Tesla",
    "Napier",
    "Falls Mill",
    "Rosedale",
    "Nicut",
    "Perkins",
    "Shock",
    "Summersville",
    "Belva",
    "Calvin",
    "Canvas",
    "Drennen",
    "Gilboa",
    "Leivasy",
    "Mount Lookout",
    "Mount Nebo",
    "Runa",
    "Nallen",
    "Russelville",
    "Nettie",
    "Pool",
    "Swiss",
    "Jodie",
    "Tioga",
    "Augusta",
    "Aurora",
    "Amboy",
    "Bayard",
    "Wilson",
    "Burlington",
    "Medley",
    "Capon Bridge",
    "Delray",
    "Eglon",
    "Horse Shoe Rn",
    "Horse Shoe Run",
    "Elk Garden",
    "Fort Ashby",
    "Gormania",
    "Green Spring",
    "Keyser",
    "Rocket Center",
    "Scherr",
    "Short Gap",
    "Lahmansville",
    "Mount Storm",
    "New Creek",
    "Piedmont",
    "Ridgeley",
    "Carpendale",
    "Patterson Creek",
    "Patterson Crk",
    "Rio",
    "Kirby",
    "Romney",
    "Three Chrs",
    "Three Churches",
    "Shanks",
    "Springfield",
    "Terra Alta",
    "Corinth",
    "Hopemont",
    "Wiley Ford",
    "Baker",
    "Brandywine",
    "Fort Seybert",
    "Circleville",
    "Franklin",
    "High View",
    "Lost City",
    "Lost River",
    "Mathias",
    "Riverton",
    "Sugar Grove",
    "Moyers",
    "Bloomery",
    "Fisher",
    "Capon Springs",
    "Maysville",
    "Moorefield",
    "Rig",
    "Milam",
    "Old Fields",
    "Petersburg",
    "Arthur",
    "Dorcas",
    "Landes Sta",
    "Landes Station",
    "Wardensville",
    "Purgitsville",
    "Junction",
    "Cabins",
    "Yellow Spring",
    "Lehew",
    "Upper Tract",
    "Seneca Rocks",
    "Onego",
  ],
  WY: [
    "Cheyenne",
    "Fe Warren AFB",
    "Fe Warren Afb",
    "Iron Mountain",
    "Albin",
    "Bosler",
    "Laramie",
    "Buford",
    "Burns",
    "Egbert",
    "Carpenter",
    "Centennial",
    "Garrett",
    "Rock River",
    "Granite Canon",
    "Granite Canyon",
    "Harriman",
    "Hillsdale",
    "Horse Creek",
    "Jelm",
    "Foxpark",
    "Mountain Home",
    "Meriden",
    "Pine Bluffs",
    "Arlington",
    "Mcfadden",
    "Tie Siding",
    "Yellowstone National Park",
    "Mammoth",
    "Mammoth Hot Springs",
    "Yelwstn Nl Pk",
    "Wheatland",
    "Bordeaux",
    "Slater",
    "Uva",
    "Chugwater",
    "Diamond",
    "Fort Laramie",
    "Glendo",
    "Guernsey",
    "Hartville",
    "Sunrise",
    "Hawk Springs",
    "Huntley",
    "Jay Em",
    "Lagrange",
    "Lance Creek",
    "Lingle",
    "Rockeagle",
    "Lost Springs",
    "Lusk",
    "Kirtley",
    "Node",
    "Manville",
    "Keeline",
    "Shawnee",
    "Torrington",
    "Prairie Center",
    "Prairie Ctr",
    "Van Tassell",
    "Veteran",
    "Yoder",
    "Rawlins",
    "Creston",
    "Fort Steele",
    "Muddy Gap",
    "Riner",
    "Jeffrey City",
    "Baggs",
    "Bairoil",
    "Dixon",
    "Elk Mountain",
    "Encampment",
    "Riverside",
    "Hanna",
    "Elmo",
    "Kortes Dam",
    "Leo",
    "Medicine Bow",
    "Saratoga",
    "Ryan Park",
    "Savery",
    "Sinclair",
    "Walcott",
    "Wamsutter",
    "Red Desert",
    "Tipton",
    "Worland",
    "Basin",
    "Burlington",
    "Byron",
    "Cody",
    "Cowley",
    "Deaver",
    "Emblem",
    "Frannie",
    "Greybull",
    "Hyattville",
    "Kirby",
    "Lovell",
    "Manderson",
    "Meeteetse",
    "Otto",
    "Powell",
    "Clark",
    "Garland",
    "Mantua",
    "Willwood",
    "Ralston",
    "Shell",
    "Ten Sleep",
    "Thermopolis",
    "Hamilton Dome",
    "Wapiti",
    "Riverton",
    "Gas Hills",
    "Lucky Maccamp",
    "Midval",
    "Morton",
    "Sand Draw",
    "Arapahoe",
    "Crowheart",
    "Burris",
    "Dubois",
    "Fort Washakie",
    "Hudson",
    "Kinnear",
    "Lander",
    "Atlantic City",
    "Ethete",
    "S Pass City",
    "South Pass City",
    "Sweetwater Station",
    "Sweetwatr Sta",
    "Pavillion",
    "Casper",
    "Bar Nunn",
    "Mills",
    "Moneta",
    "Allendale",
    "Alcova",
    "Arminto",
    "Douglas",
    "Orin",
    "Edgerton",
    "Evansville",
    "Glenrock",
    "Parkerton",
    "Rolling Hills",
    "Hiland",
    "Kaycee",
    "Mayoworth",
    "Sussex",
    "Linch",
    "Lysite",
    "Lost Cabin",
    "Midwest",
    "Natrona",
    "Powder River",
    "Shoshoni",
    "Newcastle",
    "Aladdin",
    "Alva",
    "Beulah",
    "Devils Tower",
    "Gillette",
    "Hulett",
    "New Haven",
    "Moorcroft",
    "Carlile",
    "Oshoto",
    "Pine Haven",
    "Osage",
    "Recluse",
    "Rozet",
    "Sundance",
    "Upton",
    "Weston",
    "Wright",
    "Sheridan",
    "Arvada",
    "Banner",
    "Story",
    "Big Horn",
    "Buffalo",
    "Clearmont",
    "Dayton",
    "Leiter",
    "Parkman",
    "Ranchester",
    "Acme",
    "Wolf",
    "Wyarno",
    "Rock Springs",
    "Bitter Creek",
    "Quealy",
    "Bondurant",
    "Little Jacksn",
    "Little Jackson Hole",
    "Boulder",
    "Cora",
    "Little America",
    "Litl America",
    "Evanston",
    "Bear River",
    "Farson",
    "Eden",
    "Fort Bridger",
    "Piedmont",
    "Granger",
    "Green River",
    "Mc Kinnon",
    "Lonetree",
    "Lyman",
    "Urie",
    "McKinnon",
    "Mountain View",
    "Pinedale",
    "Point Of Rocks",
    "Pt Of Rocks",
    "Reliance",
    "Robertson",
    "Superior",
    "Jackson",
    "Hoback Jct",
    "Hoback Junction",
    "Jackson Hole",
    "Teton Village",
    "Kelly",
    "Moose",
    "Jenny Lake",
    "Moran",
    "Wilson",
    "Kemmerer",
    "Fontenelle",
    "Hamsfork",
    "Afton",
    "Turnerville",
    "Auburn",
    "Bedford",
    "Big Piney",
    "Cokeville",
    "Raymond",
    "Daniel",
    "Diamondville",
    "Etna",
    "Fairview",
    "Freedom",
    "Frontier",
    "Grover",
    "La Barge",
    "Opal",
    "Smoot",
    "Thayne",
    "Star Valley Ranch",
    "Star Vly Rnch",
    "Alpine",
    "Alta",
  ],
};

export const stateCities = UScities;

export const cities = Object.entries(UScities)
  .map(([key, value]) => value.map((x) => ({ state: key, city: x })))
  .reduce((pre, it) => pre.concat(it), []);
